
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});
parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
"use strict";

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
"use strict";

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 7), "big");
    else return $btcbI.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("a9EzX", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});


parcelRegister("7j4cV", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 12), "big");
    else return $btcbI.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("lMBCM", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "little");
    else return $btcbI.split32(this.h, "little");
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});

parcelRegister("kyrHl", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

});

parcelRegister("6y4qQ", function(module, exports) {

$parcel$export(module.exports, "addMessages", () => $4c495b2409d4cb2d$export$e8c6a0d7313851e);
$parcel$export(module.exports, "init", () => $4c495b2409d4cb2d$export$2cd8252107eb640b);
$parcel$export(module.exports, "locale", () => $4c495b2409d4cb2d$export$162ce11d62a1ca51);
$parcel$export(module.exports, "getLocaleFromNavigator", () => $4c495b2409d4cb2d$export$3de58040980076f2);
$parcel$export(module.exports, "_", () => $4c495b2409d4cb2d$export$71511d61b312f219);

var $hLpYp = parcelRequire("hLpYp");

var $bc5yV = parcelRequire("bc5yV");

var $8KDXU = parcelRequire("8KDXU");
function $4c495b2409d4cb2d$var$delve(obj, fullKey) {
    if (fullKey == null) return void 0;
    if (fullKey in obj) return obj[fullKey];
    const keys = fullKey.split(".");
    let result = obj;
    for(let p = 0; p < keys.length; p++)if (typeof result === "object") {
        if (p > 0) {
            const partialKey = keys.slice(p, keys.length).join(".");
            if (partialKey in result) {
                result = result[partialKey];
                break;
            }
        }
        result = result[keys[p]];
    } else result = void 0;
    return result;
}
const $4c495b2409d4cb2d$var$lookupCache = {};
const $4c495b2409d4cb2d$var$addToCache = (path, locale, message)=>{
    if (!message) return message;
    if (!(locale in $4c495b2409d4cb2d$var$lookupCache)) $4c495b2409d4cb2d$var$lookupCache[locale] = {};
    if (!(path in $4c495b2409d4cb2d$var$lookupCache[locale])) $4c495b2409d4cb2d$var$lookupCache[locale][path] = message;
    return message;
};
const $4c495b2409d4cb2d$var$lookup = (path, refLocale)=>{
    if (refLocale == null) return void 0;
    if (refLocale in $4c495b2409d4cb2d$var$lookupCache && path in $4c495b2409d4cb2d$var$lookupCache[refLocale]) return $4c495b2409d4cb2d$var$lookupCache[refLocale][path];
    const locales = $4c495b2409d4cb2d$var$getPossibleLocales(refLocale);
    for(let i = 0; i < locales.length; i++){
        const locale = locales[i];
        const message = $4c495b2409d4cb2d$var$getMessageFromDictionary(locale, path);
        if (message) return $4c495b2409d4cb2d$var$addToCache(path, refLocale, message);
    }
    return void 0;
};
let $4c495b2409d4cb2d$var$dictionary;
const $4c495b2409d4cb2d$export$d3757880ed390b62 = (0, $hLpYp.writable)({});
function $4c495b2409d4cb2d$var$getLocaleDictionary(locale) {
    return $4c495b2409d4cb2d$var$dictionary[locale] || null;
}
function $4c495b2409d4cb2d$var$hasLocaleDictionary(locale) {
    return locale in $4c495b2409d4cb2d$var$dictionary;
}
function $4c495b2409d4cb2d$var$getMessageFromDictionary(locale, id) {
    if (!$4c495b2409d4cb2d$var$hasLocaleDictionary(locale)) return null;
    const localeDictionary = $4c495b2409d4cb2d$var$getLocaleDictionary(locale);
    const match = $4c495b2409d4cb2d$var$delve(localeDictionary, id);
    return match;
}
function $4c495b2409d4cb2d$var$getClosestAvailableLocale(refLocale) {
    if (refLocale == null) return void 0;
    const relatedLocales = $4c495b2409d4cb2d$var$getPossibleLocales(refLocale);
    for(let i = 0; i < relatedLocales.length; i++){
        const locale = relatedLocales[i];
        if ($4c495b2409d4cb2d$var$hasLocaleDictionary(locale)) return locale;
    }
    return void 0;
}
function $4c495b2409d4cb2d$export$e8c6a0d7313851e(locale, ...partials) {
    delete $4c495b2409d4cb2d$var$lookupCache[locale];
    $4c495b2409d4cb2d$export$d3757880ed390b62.update((d)=>{
        d[locale] = (0, (/*@__PURE__*/$parcel$interopDefault($bc5yV))).all([
            d[locale] || {},
            ...partials
        ]);
        return d;
    });
}
const $4c495b2409d4cb2d$export$df1c34db1371eeed = (0, $hLpYp.derived)([
    $4c495b2409d4cb2d$export$d3757880ed390b62
], ([dictionary2])=>Object.keys(dictionary2));
$4c495b2409d4cb2d$export$d3757880ed390b62.subscribe((newDictionary)=>$4c495b2409d4cb2d$var$dictionary = newDictionary);
const $4c495b2409d4cb2d$var$queue = {};
function $4c495b2409d4cb2d$var$createLocaleQueue(locale) {
    $4c495b2409d4cb2d$var$queue[locale] = /* @__PURE__ */ new Set();
}
function $4c495b2409d4cb2d$var$removeLoaderFromQueue(locale, loader) {
    $4c495b2409d4cb2d$var$queue[locale].delete(loader);
    if ($4c495b2409d4cb2d$var$queue[locale].size === 0) delete $4c495b2409d4cb2d$var$queue[locale];
}
function $4c495b2409d4cb2d$var$getLocaleQueue(locale) {
    return $4c495b2409d4cb2d$var$queue[locale];
}
function $4c495b2409d4cb2d$var$getLocalesQueues(locale) {
    return $4c495b2409d4cb2d$var$getPossibleLocales(locale).map((localeItem)=>{
        const localeQueue = $4c495b2409d4cb2d$var$getLocaleQueue(localeItem);
        return [
            localeItem,
            localeQueue ? [
                ...localeQueue
            ] : []
        ];
    }).filter(([, localeQueue])=>localeQueue.length > 0);
}
function $4c495b2409d4cb2d$var$hasLocaleQueue(locale) {
    if (locale == null) return false;
    return $4c495b2409d4cb2d$var$getPossibleLocales(locale).some((localeQueue)=>{
        var _a;
        return (_a = $4c495b2409d4cb2d$var$getLocaleQueue(localeQueue)) == null ? void 0 : _a.size;
    });
}
function $4c495b2409d4cb2d$var$loadLocaleQueue(locale, localeQueue) {
    const allLoadersPromise = Promise.all(localeQueue.map((loader)=>{
        $4c495b2409d4cb2d$var$removeLoaderFromQueue(locale, loader);
        return loader().then((partial)=>partial.default || partial);
    }));
    return allLoadersPromise.then((partials)=>$4c495b2409d4cb2d$export$e8c6a0d7313851e(locale, ...partials));
}
const $4c495b2409d4cb2d$var$activeFlushes = {};
function $4c495b2409d4cb2d$var$flush(locale) {
    if (!$4c495b2409d4cb2d$var$hasLocaleQueue(locale)) {
        if (locale in $4c495b2409d4cb2d$var$activeFlushes) return $4c495b2409d4cb2d$var$activeFlushes[locale];
        return Promise.resolve();
    }
    const queues = $4c495b2409d4cb2d$var$getLocalesQueues(locale);
    $4c495b2409d4cb2d$var$activeFlushes[locale] = Promise.all(queues.map(([localeName, localeQueue])=>$4c495b2409d4cb2d$var$loadLocaleQueue(localeName, localeQueue))).then(()=>{
        if ($4c495b2409d4cb2d$var$hasLocaleQueue(locale)) return $4c495b2409d4cb2d$var$flush(locale);
        delete $4c495b2409d4cb2d$var$activeFlushes[locale];
    });
    return $4c495b2409d4cb2d$var$activeFlushes[locale];
}
function $4c495b2409d4cb2d$export$6503ec6e8aabbaf(locale, loader) {
    if (!$4c495b2409d4cb2d$var$getLocaleQueue(locale)) $4c495b2409d4cb2d$var$createLocaleQueue(locale);
    const localeQueue = $4c495b2409d4cb2d$var$getLocaleQueue(locale);
    if ($4c495b2409d4cb2d$var$getLocaleQueue(locale).has(loader)) return;
    if (!$4c495b2409d4cb2d$var$hasLocaleDictionary(locale)) $4c495b2409d4cb2d$export$d3757880ed390b62.update((d)=>{
        d[locale] = {};
        return d;
    });
    localeQueue.add(loader);
}
var $4c495b2409d4cb2d$var$__getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var $4c495b2409d4cb2d$var$__hasOwnProp$2 = Object.prototype.hasOwnProperty;
var $4c495b2409d4cb2d$var$__propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var $4c495b2409d4cb2d$var$__objRest$1 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4c495b2409d4cb2d$var$__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4c495b2409d4cb2d$var$__getOwnPropSymbols$2) {
        for (var prop of $4c495b2409d4cb2d$var$__getOwnPropSymbols$2(source))if (exclude.indexOf(prop) < 0 && $4c495b2409d4cb2d$var$__propIsEnum$2.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $4c495b2409d4cb2d$var$defaultFormats = {
    number: {
        scientific: {
            notation: "scientific"
        },
        engineering: {
            notation: "engineering"
        },
        compactLong: {
            notation: "compact",
            compactDisplay: "long"
        },
        compactShort: {
            notation: "compact",
            compactDisplay: "short"
        }
    },
    date: {
        short: {
            month: "numeric",
            day: "numeric",
            year: "2-digit"
        },
        medium: {
            month: "short",
            day: "numeric",
            year: "numeric"
        },
        long: {
            month: "long",
            day: "numeric",
            year: "numeric"
        },
        full: {
            weekday: "long",
            month: "long",
            day: "numeric",
            year: "numeric"
        }
    },
    time: {
        short: {
            hour: "numeric",
            minute: "numeric"
        },
        medium: {
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        },
        long: {
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            timeZoneName: "short"
        },
        full: {
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            timeZoneName: "short"
        }
    }
};
function $4c495b2409d4cb2d$var$defaultMissingKeyHandler({ locale: locale, id: id }) {
    console.warn(`[svelte-i18n] The message "${id}" was not found in "${$4c495b2409d4cb2d$var$getPossibleLocales(locale).join('", "')}".${$4c495b2409d4cb2d$var$hasLocaleQueue($4c495b2409d4cb2d$var$getCurrentLocale()) ? `

Note: there are at least one loader still registered to this locale that wasn't executed.` : ""}`);
}
const $4c495b2409d4cb2d$var$defaultOptions = {
    fallbackLocale: null,
    loadingDelay: 200,
    formats: $4c495b2409d4cb2d$var$defaultFormats,
    warnOnMissingMessages: true,
    handleMissingMessage: void 0,
    ignoreTag: true
};
const $4c495b2409d4cb2d$var$options = $4c495b2409d4cb2d$var$defaultOptions;
function $4c495b2409d4cb2d$var$getOptions() {
    return $4c495b2409d4cb2d$var$options;
}
function $4c495b2409d4cb2d$export$2cd8252107eb640b(opts) {
    const _a = opts, { formats: formats } = _a, rest = $4c495b2409d4cb2d$var$__objRest$1(_a, [
        "formats"
    ]);
    let initialLocale = opts.fallbackLocale;
    if (opts.initialLocale) try {
        if ((0, $8KDXU.IntlMessageFormat).resolveLocale(opts.initialLocale)) initialLocale = opts.initialLocale;
    } catch (e) {
        console.warn(`[svelte-i18n] The initial locale "${opts.initialLocale}" is not a valid locale.`);
    }
    if (rest.warnOnMissingMessages) {
        delete rest.warnOnMissingMessages;
        if (rest.handleMissingMessage == null) rest.handleMissingMessage = $4c495b2409d4cb2d$var$defaultMissingKeyHandler;
        else console.warn('[svelte-i18n] The "warnOnMissingMessages" option is deprecated. Please use the "handleMissingMessage" option instead.');
    }
    Object.assign($4c495b2409d4cb2d$var$options, rest, {
        initialLocale: initialLocale
    });
    if (formats) {
        if ("number" in formats) Object.assign($4c495b2409d4cb2d$var$options.formats.number, formats.number);
        if ("date" in formats) Object.assign($4c495b2409d4cb2d$var$options.formats.date, formats.date);
        if ("time" in formats) Object.assign($4c495b2409d4cb2d$var$options.formats.time, formats.time);
    }
    return $4c495b2409d4cb2d$export$162ce11d62a1ca51.set(initialLocale);
}
const $4c495b2409d4cb2d$export$20bb0d907fbbe433 = (0, $hLpYp.writable)(false);
var $4c495b2409d4cb2d$var$__defProp$1 = Object.defineProperty;
var $4c495b2409d4cb2d$var$__defProps = Object.defineProperties;
var $4c495b2409d4cb2d$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4c495b2409d4cb2d$var$__getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var $4c495b2409d4cb2d$var$__hasOwnProp$1 = Object.prototype.hasOwnProperty;
var $4c495b2409d4cb2d$var$__propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var $4c495b2409d4cb2d$var$__defNormalProp$1 = (obj, key, value)=>key in obj ? $4c495b2409d4cb2d$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4c495b2409d4cb2d$var$__spreadValues$1 = (a, b)=>{
    for(var prop in b || (b = {}))if ($4c495b2409d4cb2d$var$__hasOwnProp$1.call(b, prop)) $4c495b2409d4cb2d$var$__defNormalProp$1(a, prop, b[prop]);
    if ($4c495b2409d4cb2d$var$__getOwnPropSymbols$1) {
        for (var prop of $4c495b2409d4cb2d$var$__getOwnPropSymbols$1(b))if ($4c495b2409d4cb2d$var$__propIsEnum$1.call(b, prop)) $4c495b2409d4cb2d$var$__defNormalProp$1(a, prop, b[prop]);
    }
    return a;
};
var $4c495b2409d4cb2d$var$__spreadProps = (a, b)=>$4c495b2409d4cb2d$var$__defProps(a, $4c495b2409d4cb2d$var$__getOwnPropDescs(b));
let $4c495b2409d4cb2d$var$current;
const $4c495b2409d4cb2d$var$internalLocale = (0, $hLpYp.writable)(null);
function $4c495b2409d4cb2d$var$getSubLocales(refLocale) {
    return refLocale.split("-").map((_, i, arr)=>arr.slice(0, i + 1).join("-")).reverse();
}
function $4c495b2409d4cb2d$var$getPossibleLocales(refLocale, fallbackLocale = $4c495b2409d4cb2d$var$getOptions().fallbackLocale) {
    const locales = $4c495b2409d4cb2d$var$getSubLocales(refLocale);
    if (fallbackLocale) return [
        .../* @__PURE__ */ new Set([
            ...locales,
            ...$4c495b2409d4cb2d$var$getSubLocales(fallbackLocale)
        ])
    ];
    return locales;
}
function $4c495b2409d4cb2d$var$getCurrentLocale() {
    return $4c495b2409d4cb2d$var$current != null ? $4c495b2409d4cb2d$var$current : void 0;
}
$4c495b2409d4cb2d$var$internalLocale.subscribe((newLocale)=>{
    $4c495b2409d4cb2d$var$current = newLocale != null ? newLocale : void 0;
    if (typeof window !== "undefined" && newLocale != null) document.documentElement.setAttribute("lang", newLocale);
});
const $4c495b2409d4cb2d$var$set = (newLocale)=>{
    if (newLocale && $4c495b2409d4cb2d$var$getClosestAvailableLocale(newLocale) && $4c495b2409d4cb2d$var$hasLocaleQueue(newLocale)) {
        const { loadingDelay: loadingDelay } = $4c495b2409d4cb2d$var$getOptions();
        let loadingTimer;
        if (typeof window !== "undefined" && $4c495b2409d4cb2d$var$getCurrentLocale() != null && loadingDelay) loadingTimer = window.setTimeout(()=>$4c495b2409d4cb2d$export$20bb0d907fbbe433.set(true), loadingDelay);
        else $4c495b2409d4cb2d$export$20bb0d907fbbe433.set(true);
        return $4c495b2409d4cb2d$var$flush(newLocale).then(()=>{
            $4c495b2409d4cb2d$var$internalLocale.set(newLocale);
        }).finally(()=>{
            clearTimeout(loadingTimer);
            $4c495b2409d4cb2d$export$20bb0d907fbbe433.set(false);
        });
    }
    return $4c495b2409d4cb2d$var$internalLocale.set(newLocale);
};
const $4c495b2409d4cb2d$export$162ce11d62a1ca51 = $4c495b2409d4cb2d$var$__spreadProps($4c495b2409d4cb2d$var$__spreadValues$1({}, $4c495b2409d4cb2d$var$internalLocale), {
    set: $4c495b2409d4cb2d$var$set
});
const $4c495b2409d4cb2d$var$getFromQueryString = (queryString, key)=>{
    const keyVal = queryString.split("&").find((i)=>i.indexOf(`${key}=`) === 0);
    if (keyVal) return keyVal.split("=").pop();
    return null;
};
const $4c495b2409d4cb2d$var$getFirstMatch = (base, pattern)=>{
    const match = pattern.exec(base);
    if (!match) return null;
    return match[1] || null;
};
const $4c495b2409d4cb2d$export$4b645ee0c03e8679 = (hostname)=>{
    if (typeof window === "undefined") return null;
    return $4c495b2409d4cb2d$var$getFirstMatch(window.location.hostname, hostname);
};
const $4c495b2409d4cb2d$export$7d7c6a2d1731fd0c = (pathname)=>{
    if (typeof window === "undefined") return null;
    return $4c495b2409d4cb2d$var$getFirstMatch(window.location.pathname, pathname);
};
const $4c495b2409d4cb2d$export$3de58040980076f2 = ()=>{
    if (typeof window === "undefined") return null;
    return window.navigator.language || window.navigator.languages[0];
};
const $4c495b2409d4cb2d$export$ec45b8ee346340d7 = (search)=>{
    if (typeof window === "undefined") return null;
    return $4c495b2409d4cb2d$var$getFromQueryString(window.location.search.substr(1), search);
};
const $4c495b2409d4cb2d$export$c75599b9cea22398 = (hash)=>{
    if (typeof window === "undefined") return null;
    return $4c495b2409d4cb2d$var$getFromQueryString(window.location.hash.substr(1), hash);
};
const $4c495b2409d4cb2d$var$monadicMemoize = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    const memoizedFn = (arg)=>{
        const cacheKey = JSON.stringify(arg);
        if (cacheKey in cache) return cache[cacheKey];
        return cache[cacheKey] = fn(arg);
    };
    return memoizedFn;
};
var $4c495b2409d4cb2d$var$__defProp = Object.defineProperty;
var $4c495b2409d4cb2d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4c495b2409d4cb2d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4c495b2409d4cb2d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4c495b2409d4cb2d$var$__defNormalProp = (obj, key, value)=>key in obj ? $4c495b2409d4cb2d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4c495b2409d4cb2d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4c495b2409d4cb2d$var$__hasOwnProp.call(b, prop)) $4c495b2409d4cb2d$var$__defNormalProp(a, prop, b[prop]);
    if ($4c495b2409d4cb2d$var$__getOwnPropSymbols) {
        for (var prop of $4c495b2409d4cb2d$var$__getOwnPropSymbols(b))if ($4c495b2409d4cb2d$var$__propIsEnum.call(b, prop)) $4c495b2409d4cb2d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4c495b2409d4cb2d$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4c495b2409d4cb2d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4c495b2409d4cb2d$var$__getOwnPropSymbols) {
        for (var prop of $4c495b2409d4cb2d$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4c495b2409d4cb2d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $4c495b2409d4cb2d$var$getIntlFormatterOptions = (type, name)=>{
    const { formats: formats } = $4c495b2409d4cb2d$var$getOptions();
    if (type in formats && name in formats[type]) return formats[type][name];
    throw new Error(`[svelte-i18n] Unknown "${name}" ${type} format.`);
};
const $4c495b2409d4cb2d$var$createNumberFormatter = $4c495b2409d4cb2d$var$monadicMemoize((_a)=>{
    var _b = _a, { locale: locale, format: format } = _b, options = $4c495b2409d4cb2d$var$__objRest(_b, [
        "locale",
        "format"
    ]);
    if (locale == null) throw new Error('[svelte-i18n] A "locale" must be set to format numbers');
    if (format) options = $4c495b2409d4cb2d$var$getIntlFormatterOptions("number", format);
    return new Intl.NumberFormat(locale, options);
});
const $4c495b2409d4cb2d$var$createDateFormatter = $4c495b2409d4cb2d$var$monadicMemoize((_c)=>{
    var _d = _c, { locale: locale, format: format } = _d, options = $4c495b2409d4cb2d$var$__objRest(_d, [
        "locale",
        "format"
    ]);
    if (locale == null) throw new Error('[svelte-i18n] A "locale" must be set to format dates');
    if (format) options = $4c495b2409d4cb2d$var$getIntlFormatterOptions("date", format);
    else if (Object.keys(options).length === 0) options = $4c495b2409d4cb2d$var$getIntlFormatterOptions("date", "short");
    return new Intl.DateTimeFormat(locale, options);
});
const $4c495b2409d4cb2d$var$createTimeFormatter = $4c495b2409d4cb2d$var$monadicMemoize((_e)=>{
    var _f = _e, { locale: locale, format: format } = _f, options = $4c495b2409d4cb2d$var$__objRest(_f, [
        "locale",
        "format"
    ]);
    if (locale == null) throw new Error('[svelte-i18n] A "locale" must be set to format time values');
    if (format) options = $4c495b2409d4cb2d$var$getIntlFormatterOptions("time", format);
    else if (Object.keys(options).length === 0) options = $4c495b2409d4cb2d$var$getIntlFormatterOptions("time", "short");
    return new Intl.DateTimeFormat(locale, options);
});
const $4c495b2409d4cb2d$export$c2604861dc73a731 = (_g = {})=>{
    var _h = _g, { locale: locale = $4c495b2409d4cb2d$var$getCurrentLocale() } = _h, args = $4c495b2409d4cb2d$var$__objRest(_h, [
        "locale"
    ]);
    return $4c495b2409d4cb2d$var$createNumberFormatter($4c495b2409d4cb2d$var$__spreadValues({
        locale: locale
    }, args));
};
const $4c495b2409d4cb2d$export$dec541045008c8e3 = (_i = {})=>{
    var _j = _i, { locale: locale = $4c495b2409d4cb2d$var$getCurrentLocale() } = _j, args = $4c495b2409d4cb2d$var$__objRest(_j, [
        "locale"
    ]);
    return $4c495b2409d4cb2d$var$createDateFormatter($4c495b2409d4cb2d$var$__spreadValues({
        locale: locale
    }, args));
};
const $4c495b2409d4cb2d$export$55180a88c41165a1 = (_k = {})=>{
    var _l = _k, { locale: locale = $4c495b2409d4cb2d$var$getCurrentLocale() } = _l, args = $4c495b2409d4cb2d$var$__objRest(_l, [
        "locale"
    ]);
    return $4c495b2409d4cb2d$var$createTimeFormatter($4c495b2409d4cb2d$var$__spreadValues({
        locale: locale
    }, args));
};
const $4c495b2409d4cb2d$export$3b8be924e637e17c = $4c495b2409d4cb2d$var$monadicMemoize(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(message, locale = $4c495b2409d4cb2d$var$getCurrentLocale())=>new (0, $8KDXU.IntlMessageFormat)(message, locale, $4c495b2409d4cb2d$var$getOptions().formats, {
        ignoreTag: $4c495b2409d4cb2d$var$getOptions().ignoreTag
    }));
const $4c495b2409d4cb2d$var$formatMessage = (id, options = {})=>{
    var _a, _b, _c, _d;
    let messageObj = options;
    if (typeof id === "object") {
        messageObj = id;
        id = messageObj.id;
    }
    const { values: values, locale: locale = $4c495b2409d4cb2d$var$getCurrentLocale(), default: defaultValue } = messageObj;
    if (locale == null) throw new Error("[svelte-i18n] Cannot format a message without first setting the initial locale.");
    let message = $4c495b2409d4cb2d$var$lookup(id, locale);
    if (!message) message = (_d = (_c = (_b = (_a = $4c495b2409d4cb2d$var$getOptions()).handleMissingMessage) == null ? void 0 : _b.call(_a, {
        locale: locale,
        id: id,
        defaultValue: defaultValue
    })) != null ? _c : defaultValue) != null ? _d : id;
    else if (typeof message !== "string") {
        console.warn(`[svelte-i18n] Message with id "${id}" must be of type "string", found: "${typeof message}". Gettin its value through the "$format" method is deprecated; use the "json" method instead.`);
        return message;
    }
    if (!values) return message;
    let result = message;
    try {
        result = $4c495b2409d4cb2d$export$3b8be924e637e17c(message, locale).format(values);
    } catch (e) {
        if (e instanceof Error) console.warn(`[svelte-i18n] Message "${id}" has syntax error:`, e.message);
    }
    return result;
};
const $4c495b2409d4cb2d$var$formatTime = (t, options)=>{
    return $4c495b2409d4cb2d$export$55180a88c41165a1(options).format(t);
};
const $4c495b2409d4cb2d$var$formatDate = (d, options)=>{
    return $4c495b2409d4cb2d$export$dec541045008c8e3(options).format(d);
};
const $4c495b2409d4cb2d$var$formatNumber = (n, options)=>{
    return $4c495b2409d4cb2d$export$c2604861dc73a731(options).format(n);
};
const $4c495b2409d4cb2d$var$getJSON = (id, locale = $4c495b2409d4cb2d$var$getCurrentLocale())=>{
    return $4c495b2409d4cb2d$var$lookup(id, locale);
};
const $4c495b2409d4cb2d$export$71511d61b312f219 = (0, $hLpYp.derived)([
    $4c495b2409d4cb2d$export$162ce11d62a1ca51,
    $4c495b2409d4cb2d$export$d3757880ed390b62
], ()=>$4c495b2409d4cb2d$var$formatMessage);
const $4c495b2409d4cb2d$export$2da9be4cfdb689b1 = (0, $hLpYp.derived)([
    $4c495b2409d4cb2d$export$162ce11d62a1ca51
], ()=>$4c495b2409d4cb2d$var$formatTime);
const $4c495b2409d4cb2d$export$324d90190a8b822a = (0, $hLpYp.derived)([
    $4c495b2409d4cb2d$export$162ce11d62a1ca51
], ()=>$4c495b2409d4cb2d$var$formatDate);
const $4c495b2409d4cb2d$export$98e628dec113755e = (0, $hLpYp.derived)([
    $4c495b2409d4cb2d$export$162ce11d62a1ca51
], ()=>$4c495b2409d4cb2d$var$formatNumber);
const $4c495b2409d4cb2d$export$7b419323e6ed4f31 = (0, $hLpYp.derived)([
    $4c495b2409d4cb2d$export$162ce11d62a1ca51,
    $4c495b2409d4cb2d$export$d3757880ed390b62
], ()=>$4c495b2409d4cb2d$var$getJSON);
function $4c495b2409d4cb2d$export$aa8691a29e6f19c5(store) {
    let localReference;
    const cancel = store.subscribe((value)=>localReference = value);
    const fn = (...args)=>localReference(...args);
    fn.freeze = cancel;
    return fn;
}
function $4c495b2409d4cb2d$export$1adfeb024f5185b(i) {
    return i;
}
function $4c495b2409d4cb2d$export$9d812b4fe93f6cb6(locale) {
    return $4c495b2409d4cb2d$var$flush(locale || $4c495b2409d4cb2d$var$getCurrentLocale() || $4c495b2409d4cb2d$var$getOptions().initialLocale);
}

});
parcelRegister("hLpYp", function(module, exports) {

$parcel$export(module.exports, "writable", () => $82325611e84d1a46$export$e6d3eada50a007b1);
$parcel$export(module.exports, "derived", () => $82325611e84d1a46$export$90b0b54dab0a340a);
$parcel$export(module.exports, "get", () => (parcelRequire("6ojdr")).get_store_value);

var $6ojdr = parcelRequire("6ojdr");
const $82325611e84d1a46$var$subscriber_queue = [];
/**
 * Creates a `Readable` store that allows reading by subscription.
 * @param value initial value
 * @param {StartStopNotifier} [start]
 */ function $82325611e84d1a46$export$1e3fc3ecfda8b1c3(value, start) {
    return {
        subscribe: $82325611e84d1a46$export$e6d3eada50a007b1(value, start).subscribe
    };
}
/**
 * Create a `Writable` store that allows both updating and reading by subscription.
 * @param {*=}value initial value
 * @param {StartStopNotifier=} start
 */ function $82325611e84d1a46$export$e6d3eada50a007b1(value, start = (0, $6ojdr.noop)) {
    let stop;
    const subscribers = new Set();
    function set(new_value) {
        if ((0, $6ojdr.safe_not_equal)(value, new_value)) {
            value = new_value;
            if (stop) {
                const run_queue = !$82325611e84d1a46$var$subscriber_queue.length;
                for (const subscriber of subscribers){
                    subscriber[1]();
                    $82325611e84d1a46$var$subscriber_queue.push(subscriber, value);
                }
                if (run_queue) {
                    for(let i = 0; i < $82325611e84d1a46$var$subscriber_queue.length; i += 2)$82325611e84d1a46$var$subscriber_queue[i][0]($82325611e84d1a46$var$subscriber_queue[i + 1]);
                    $82325611e84d1a46$var$subscriber_queue.length = 0;
                }
            }
        }
    }
    function update(fn) {
        set(fn(value));
    }
    function subscribe(run, invalidate = (0, $6ojdr.noop)) {
        const subscriber = [
            run,
            invalidate
        ];
        subscribers.add(subscriber);
        if (subscribers.size === 1) stop = start(set) || (0, $6ojdr.noop);
        run(value);
        return ()=>{
            subscribers.delete(subscriber);
            if (subscribers.size === 0 && stop) {
                stop();
                stop = null;
            }
        };
    }
    return {
        set: set,
        update: update,
        subscribe: subscribe
    };
}
function $82325611e84d1a46$export$90b0b54dab0a340a(stores, fn, initial_value) {
    const single = !Array.isArray(stores);
    const stores_array = single ? [
        stores
    ] : stores;
    const auto = fn.length < 2;
    return $82325611e84d1a46$export$1e3fc3ecfda8b1c3(initial_value, (set)=>{
        let started = false;
        const values = [];
        let pending = 0;
        let cleanup = (0, $6ojdr.noop);
        const sync = ()=>{
            if (pending) return;
            cleanup();
            const result = fn(single ? values[0] : values, set);
            if (auto) set(result);
            else cleanup = (0, $6ojdr.is_function)(result) ? result : (0, $6ojdr.noop);
        };
        const unsubscribers = stores_array.map((store, i)=>(0, $6ojdr.subscribe)(store, (value)=>{
                values[i] = value;
                pending &= ~(1 << i);
                if (started) sync();
            }, ()=>{
                pending |= 1 << i;
            }));
        started = true;
        sync();
        return function stop() {
            (0, $6ojdr.run_all)(unsubscribers);
            cleanup();
            // We need to set this to false because callbacks can still happen despite having unsubscribed:
            // Callbacks might already be placed in the queue which doesn't know it should no longer
            // invoke this derived store.
            started = false;
        };
    });
}
/**
 * Takes a store and returns a new one derived from the old one that is readable.
 *
 * @param store - store to make readonly
 */ function $82325611e84d1a46$export$6ec456bd5b7b3c51(store) {
    return {
        subscribe: store.subscribe.bind(store)
    };
}

});
parcelRegister("6ojdr", function(module, exports) {

$parcel$export(module.exports, "noop", () => $26ebed30afc43a11$export$8793edee2d425525);
$parcel$export(module.exports, "run_all", () => $26ebed30afc43a11$export$3f1fcd837f99a9ab);
$parcel$export(module.exports, "is_function", () => $26ebed30afc43a11$export$b451353ebd749597);
$parcel$export(module.exports, "safe_not_equal", () => $26ebed30afc43a11$export$170eaf694b129a16);
$parcel$export(module.exports, "subscribe", () => $26ebed30afc43a11$export$ec068583843480e7);
$parcel$export(module.exports, "get_store_value", () => $26ebed30afc43a11$export$def9168ec19d7707);
function $26ebed30afc43a11$export$8793edee2d425525() {}
const $26ebed30afc43a11$export$f0954fd7d5368655 = (x)=>x;
function $26ebed30afc43a11$export$e6e34fd1f2686227(tar, src) {
    // @ts-ignore
    for(const k in src)tar[k] = src[k];
    return tar;
}
// Adapted from https://github.com/then/is-promise/blob/master/index.js
// Distributed under MIT License https://github.com/then/is-promise/blob/master/LICENSE
function $26ebed30afc43a11$export$7666b03abe8479da(value) {
    return !!value && (typeof value === "object" || typeof value === "function") && typeof value.then === "function";
}
function $26ebed30afc43a11$export$8d162c0ddfac72(element, file, line, column, char) {
    element.__svelte_meta = {
        loc: {
            file: file,
            line: line,
            column: column,
            char: char
        }
    };
}
function $26ebed30afc43a11$export$889ea624f2cb2c57(fn) {
    return fn();
}
function $26ebed30afc43a11$export$31092919e374e43c() {
    return Object.create(null);
}
function $26ebed30afc43a11$export$3f1fcd837f99a9ab(fns) {
    fns.forEach($26ebed30afc43a11$export$889ea624f2cb2c57);
}
function $26ebed30afc43a11$export$b451353ebd749597(thing) {
    return typeof thing === "function";
}
function $26ebed30afc43a11$export$170eaf694b129a16(a, b) {
    return a != a ? b == b : a !== b || a && typeof a === "object" || typeof a === "function";
}
let $26ebed30afc43a11$var$src_url_equal_anchor;
function $26ebed30afc43a11$export$49b3f9828235af7b(element_src, url) {
    if (!$26ebed30afc43a11$var$src_url_equal_anchor) $26ebed30afc43a11$var$src_url_equal_anchor = document.createElement("a");
    $26ebed30afc43a11$var$src_url_equal_anchor.href = url;
    return element_src === $26ebed30afc43a11$var$src_url_equal_anchor.href;
}
function $26ebed30afc43a11$export$22fbbf144bff5d00(a, b) {
    return a != a ? b == b : a !== b;
}
function $26ebed30afc43a11$export$cc2e736493e359e2(obj) {
    return Object.keys(obj).length === 0;
}
function $26ebed30afc43a11$export$e3d0b9f4796b296b(store, name) {
    if (store != null && typeof store.subscribe !== "function") throw new Error(`'${name}' is not a store with a 'subscribe' method`);
}
function $26ebed30afc43a11$export$ec068583843480e7(store, ...callbacks) {
    if (store == null) return $26ebed30afc43a11$export$8793edee2d425525;
    const unsub = store.subscribe(...callbacks);
    return unsub.unsubscribe ? ()=>unsub.unsubscribe() : unsub;
}
function $26ebed30afc43a11$export$def9168ec19d7707(store) {
    let value;
    $26ebed30afc43a11$export$ec068583843480e7(store, (_)=>value = _)();
    return value;
}
function $26ebed30afc43a11$export$e9b69a2eee9b6cbe(component, store, callback) {
    component.$$.on_destroy.push($26ebed30afc43a11$export$ec068583843480e7(store, callback));
}
function $26ebed30afc43a11$export$2d30ef90c9114b44(definition, ctx, $$scope, fn) {
    if (definition) {
        const slot_ctx = $26ebed30afc43a11$var$get_slot_context(definition, ctx, $$scope, fn);
        return definition[0](slot_ctx);
    }
}
function $26ebed30afc43a11$var$get_slot_context(definition, ctx, $$scope, fn) {
    return definition[1] && fn ? $26ebed30afc43a11$export$e6e34fd1f2686227($$scope.ctx.slice(), definition[1](fn(ctx))) : $$scope.ctx;
}
function $26ebed30afc43a11$export$37743db7f61eb37b(definition, $$scope, dirty, fn) {
    if (definition[2] && fn) {
        const lets = definition[2](fn(dirty));
        if ($$scope.dirty === undefined) return lets;
        if (typeof lets === "object") {
            const merged = [];
            const len = Math.max($$scope.dirty.length, lets.length);
            for(let i = 0; i < len; i += 1)merged[i] = $$scope.dirty[i] | lets[i];
            return merged;
        }
        return $$scope.dirty | lets;
    }
    return $$scope.dirty;
}
function $26ebed30afc43a11$export$320f2dc7816567d9(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn) {
    if (slot_changes) {
        const slot_context = $26ebed30afc43a11$var$get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
        slot.p(slot_context, slot_changes);
    }
}
function $26ebed30afc43a11$export$6f5c611fd589b77(slot, slot_definition, ctx, $$scope, dirty, get_slot_changes_fn, get_slot_context_fn) {
    const slot_changes = $26ebed30afc43a11$export$37743db7f61eb37b(slot_definition, $$scope, dirty, get_slot_changes_fn);
    $26ebed30afc43a11$export$320f2dc7816567d9(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn);
}
function $26ebed30afc43a11$export$a15c6a804dce25b7($$scope) {
    if ($$scope.ctx.length > 32) {
        const dirty = [];
        const length = $$scope.ctx.length / 32;
        for(let i = 0; i < length; i++)dirty[i] = -1;
        return dirty;
    }
    return -1;
}
function $26ebed30afc43a11$export$1b59c714eb8e4c9f(props) {
    const result = {};
    for(const k in props)if (k[0] !== "$") result[k] = props[k];
    return result;
}
function $26ebed30afc43a11$export$3086903c15858881(props, keys) {
    const rest = {};
    keys = new Set(keys);
    for(const k in props)if (!keys.has(k) && k[0] !== "$") rest[k] = props[k];
    return rest;
}
function $26ebed30afc43a11$export$3001519f1cb535ea(slots) {
    const result = {};
    for(const key in slots)result[key] = true;
    return result;
}
function $26ebed30afc43a11$export$d2de3aaeafa91619(fn) {
    let ran = false;
    return function(...args) {
        if (ran) return;
        ran = true;
        fn.call(this, ...args);
    };
}
function $26ebed30afc43a11$export$1a9d7733e079fbfa(value) {
    return value == null ? "" : value;
}
function $26ebed30afc43a11$export$ef3da5b70290de1(store, ret, value) {
    store.set(value);
    return ret;
}
const $26ebed30afc43a11$export$90ea246e00657977 = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
function $26ebed30afc43a11$export$44ef7a4ea2170a07(action_result) {
    return action_result && $26ebed30afc43a11$export$b451353ebd749597(action_result.destroy) ? action_result.destroy : $26ebed30afc43a11$export$8793edee2d425525;
}
function $26ebed30afc43a11$export$fde6ca7e0b92f8ff(value) {
    const split = typeof value === "string" && value.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
    return split ? [
        parseFloat(split[1]),
        split[2] || "px"
    ] : [
        value,
        "px"
    ];
}
const $26ebed30afc43a11$export$e3d839ffa95f7481 = [
    "",
    true,
    1,
    "true",
    "contenteditable"
];
const $26ebed30afc43a11$export$63e5d6c42bc01b79 = typeof window !== "undefined";
let $26ebed30afc43a11$export$461939dd4422153 = $26ebed30afc43a11$export$63e5d6c42bc01b79 ? ()=>window.performance.now() : ()=>Date.now();
let $26ebed30afc43a11$export$27f233d61a9e2fa4 = $26ebed30afc43a11$export$63e5d6c42bc01b79 ? (cb)=>requestAnimationFrame(cb) : $26ebed30afc43a11$export$8793edee2d425525;
// used internally for testing
function $26ebed30afc43a11$export$50265a0ed747f6de(fn) {
    $26ebed30afc43a11$export$461939dd4422153 = fn;
}
function $26ebed30afc43a11$export$43be9c1bea1fd56(fn) {
    $26ebed30afc43a11$export$27f233d61a9e2fa4 = fn;
}
const $26ebed30afc43a11$var$tasks = new Set();
function $26ebed30afc43a11$var$run_tasks(now) {
    $26ebed30afc43a11$var$tasks.forEach((task)=>{
        if (!task.c(now)) {
            $26ebed30afc43a11$var$tasks.delete(task);
            task.f();
        }
    });
    if ($26ebed30afc43a11$var$tasks.size !== 0) $26ebed30afc43a11$export$27f233d61a9e2fa4($26ebed30afc43a11$var$run_tasks);
}
/**
 * For testing purposes only!
 */ function $26ebed30afc43a11$export$36ce6b87b73ae3() {
    $26ebed30afc43a11$var$tasks.clear();
}
/**
 * Creates a new task that runs on each raf frame
 * until it returns a falsy value or is aborted
 */ function $26ebed30afc43a11$export$f9ef67375ddc185(callback) {
    let task;
    if ($26ebed30afc43a11$var$tasks.size === 0) $26ebed30afc43a11$export$27f233d61a9e2fa4($26ebed30afc43a11$var$run_tasks);
    return {
        promise: new Promise((fulfill)=>{
            $26ebed30afc43a11$var$tasks.add(task = {
                c: callback,
                f: fulfill
            });
        }),
        abort () {
            $26ebed30afc43a11$var$tasks.delete(task);
        }
    };
}
const $26ebed30afc43a11$export$816be348776d53c1 = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : $parcel$global;
/**
 * Resize observer singleton.
 * One listener per element only!
 * https://groups.google.com/a/chromium.org/g/blink-dev/c/z6ienONUb5A/m/F5-VcUZtBAAJ
 */ class $26ebed30afc43a11$export$cd966d69202271fb {
    constructor(options){
        this.options = options;
        this._listeners = "WeakMap" in $26ebed30afc43a11$export$816be348776d53c1 ? new WeakMap() : undefined;
    }
    observe(element, listener) {
        this._listeners.set(element, listener);
        this._getObserver().observe(element, this.options);
        return ()=>{
            this._listeners.delete(element);
            this._observer.unobserve(element); // this line can probably be removed
        };
    }
    _getObserver() {
        var _a;
        return (_a = this._observer) !== null && _a !== void 0 ? _a : this._observer = new ResizeObserver((entries)=>{
            var _a;
            for (const entry of entries){
                $26ebed30afc43a11$export$cd966d69202271fb.entries.set(entry.target, entry);
                (_a = this._listeners.get(entry.target)) === null || _a === void 0 || _a(entry);
            }
        });
    }
}
// Needs to be written like this to pass the tree-shake-test
$26ebed30afc43a11$export$cd966d69202271fb.entries = "WeakMap" in $26ebed30afc43a11$export$816be348776d53c1 ? new WeakMap() : undefined;
// Track which nodes are claimed during hydration. Unclaimed nodes can then be removed from the DOM
// at the end of hydration without touching the remaining nodes.
let $26ebed30afc43a11$var$is_hydrating = false;
function $26ebed30afc43a11$export$237ef195d41ae60c() {
    $26ebed30afc43a11$var$is_hydrating = true;
}
function $26ebed30afc43a11$export$4b42d81e6a3b0cd2() {
    $26ebed30afc43a11$var$is_hydrating = false;
}
function $26ebed30afc43a11$var$upper_bound(low, high, key, value) {
    // Return first index of value larger than input value in the range [low, high)
    while(low < high){
        const mid = low + (high - low >> 1);
        if (key(mid) <= value) low = mid + 1;
        else high = mid;
    }
    return low;
}
function $26ebed30afc43a11$var$init_hydrate(target) {
    if (target.hydrate_init) return;
    target.hydrate_init = true;
    // We know that all children have claim_order values since the unclaimed have been detached if target is not <head>
    let children = target.childNodes;
    // If target is <head>, there may be children without claim_order
    if (target.nodeName === "HEAD") {
        const myChildren = [];
        for(let i = 0; i < children.length; i++){
            const node = children[i];
            if (node.claim_order !== undefined) myChildren.push(node);
        }
        children = myChildren;
    }
    /*
    * Reorder claimed children optimally.
    * We can reorder claimed children optimally by finding the longest subsequence of
    * nodes that are already claimed in order and only moving the rest. The longest
    * subsequence of nodes that are claimed in order can be found by
    * computing the longest increasing subsequence of .claim_order values.
    *
    * This algorithm is optimal in generating the least amount of reorder operations
    * possible.
    *
    * Proof:
    * We know that, given a set of reordering operations, the nodes that do not move
    * always form an increasing subsequence, since they do not move among each other
    * meaning that they must be already ordered among each other. Thus, the maximal
    * set of nodes that do not move form a longest increasing subsequence.
    */ // Compute longest increasing subsequence
    // m: subsequence length j => index k of smallest value that ends an increasing subsequence of length j
    const m = new Int32Array(children.length + 1);
    // Predecessor indices + 1
    const p = new Int32Array(children.length);
    m[0] = -1;
    let longest = 0;
    for(let i = 0; i < children.length; i++){
        const current = children[i].claim_order;
        // Find the largest subsequence length such that it ends in a value less than our current value
        // upper_bound returns first greater value, so we subtract one
        // with fast path for when we are on the current longest subsequence
        const seqLen = (longest > 0 && children[m[longest]].claim_order <= current ? longest + 1 : $26ebed30afc43a11$var$upper_bound(1, longest, (idx)=>children[m[idx]].claim_order, current)) - 1;
        p[i] = m[seqLen] + 1;
        const newLen = seqLen + 1;
        // We can guarantee that current is the smallest value. Otherwise, we would have generated a longer sequence.
        m[newLen] = i;
        longest = Math.max(newLen, longest);
    }
    // The longest increasing subsequence of nodes (initially reversed)
    const lis = [];
    // The rest of the nodes, nodes that will be moved
    const toMove = [];
    let last = children.length - 1;
    for(let cur = m[longest] + 1; cur != 0; cur = p[cur - 1]){
        lis.push(children[cur - 1]);
        for(; last >= cur; last--)toMove.push(children[last]);
        last--;
    }
    for(; last >= 0; last--)toMove.push(children[last]);
    lis.reverse();
    // We sort the nodes being moved to guarantee that their insertion order matches the claim order
    toMove.sort((a, b)=>a.claim_order - b.claim_order);
    // Finally, we move the nodes
    for(let i = 0, j = 0; i < toMove.length; i++){
        while(j < lis.length && toMove[i].claim_order >= lis[j].claim_order)j++;
        const anchor = j < lis.length ? lis[j] : null;
        target.insertBefore(toMove[i], anchor);
    }
}
function $26ebed30afc43a11$export$10d8903dec122b9d(target, node) {
    target.appendChild(node);
}
function $26ebed30afc43a11$export$79c6991e22869eb0(target, style_sheet_id, styles) {
    const append_styles_to = $26ebed30afc43a11$export$e6f325d87fe70439(target);
    if (!append_styles_to.getElementById(style_sheet_id)) {
        const style = $26ebed30afc43a11$export$8454457683f90105("style");
        style.id = style_sheet_id;
        style.textContent = styles;
        $26ebed30afc43a11$var$append_stylesheet(append_styles_to, style);
    }
}
function $26ebed30afc43a11$export$e6f325d87fe70439(node) {
    if (!node) return document;
    const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
    if (root && root.host) return root;
    return node.ownerDocument;
}
function $26ebed30afc43a11$export$98a01cd5b3256c7(node) {
    const style_element = $26ebed30afc43a11$export$8454457683f90105("style");
    $26ebed30afc43a11$var$append_stylesheet($26ebed30afc43a11$export$e6f325d87fe70439(node), style_element);
    return style_element.sheet;
}
function $26ebed30afc43a11$var$append_stylesheet(node, style) {
    $26ebed30afc43a11$export$10d8903dec122b9d(node.head || node, style);
    return style.sheet;
}
function $26ebed30afc43a11$export$172bc581f7520fb7(target, node) {
    if ($26ebed30afc43a11$var$is_hydrating) {
        $26ebed30afc43a11$var$init_hydrate(target);
        if (target.actual_end_child === undefined || target.actual_end_child !== null && target.actual_end_child.parentNode !== target) target.actual_end_child = target.firstChild;
        // Skip nodes of undefined ordering
        while(target.actual_end_child !== null && target.actual_end_child.claim_order === undefined)target.actual_end_child = target.actual_end_child.nextSibling;
        if (node !== target.actual_end_child) // We only insert if the ordering of this node should be modified or the parent node is not target
        {
            if (node.claim_order !== undefined || node.parentNode !== target) target.insertBefore(node, target.actual_end_child);
        } else target.actual_end_child = node.nextSibling;
    } else if (node.parentNode !== target || node.nextSibling !== null) target.appendChild(node);
}
function $26ebed30afc43a11$export$21a5ca8aa77d35ff(target, node, anchor) {
    target.insertBefore(node, anchor || null);
}
function $26ebed30afc43a11$export$f7a8880e5fbca7f8(target, node, anchor) {
    if ($26ebed30afc43a11$var$is_hydrating && !anchor) $26ebed30afc43a11$export$172bc581f7520fb7(target, node);
    else if (node.parentNode !== target || node.nextSibling != anchor) target.insertBefore(node, anchor || null);
}
function $26ebed30afc43a11$export$3f780019ff766da6(node) {
    if (node.parentNode) node.parentNode.removeChild(node);
}
function $26ebed30afc43a11$export$7ddc7a4fd25b2662(iterations, detaching) {
    for(let i = 0; i < iterations.length; i += 1)if (iterations[i]) iterations[i].d(detaching);
}
function $26ebed30afc43a11$export$8454457683f90105(name) {
    return document.createElement(name);
}
function $26ebed30afc43a11$export$6b474b18510bcd0a(name, is) {
    return document.createElement(name, {
        is: is
    });
}
function $26ebed30afc43a11$export$9fd581e6a5ec01ab(obj, exclude) {
    const target = {};
    for(const k in obj)if ($26ebed30afc43a11$export$90ea246e00657977(obj, k) && exclude.indexOf(k) === -1) // @ts-ignore
    target[k] = obj[k];
    return target;
}
function $26ebed30afc43a11$export$3967a3bb66708d71(name) {
    return document.createElementNS("http://www.w3.org/2000/svg", name);
}
function $26ebed30afc43a11$export$6f093cfa640b7166(data) {
    return document.createTextNode(data);
}
function $26ebed30afc43a11$export$a941ed4b947d12f8() {
    return $26ebed30afc43a11$export$6f093cfa640b7166(" ");
}
function $26ebed30afc43a11$export$6e22c362a0406a2c() {
    return $26ebed30afc43a11$export$6f093cfa640b7166("");
}
function $26ebed30afc43a11$export$4a34f930e789283c(content) {
    return document.createComment(content);
}
function $26ebed30afc43a11$export$63174c828edd6ff8(node, event, handler, options) {
    node.addEventListener(event, handler, options);
    return ()=>node.removeEventListener(event, handler, options);
}
function $26ebed30afc43a11$export$87efb90f285c3ace(fn) {
    return function(event) {
        event.preventDefault();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function $26ebed30afc43a11$export$52770bb39e602159(fn) {
    return function(event) {
        event.stopPropagation();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function $26ebed30afc43a11$export$11e2a029189b1fe4(fn) {
    return function(event) {
        event.stopImmediatePropagation();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function $26ebed30afc43a11$export$82c2e460fb230c2a(fn) {
    return function(event) {
        // @ts-ignore
        if (event.target === this) fn.call(this, event);
    };
}
function $26ebed30afc43a11$export$3db9a96880fcbbea(fn) {
    return function(event) {
        // @ts-ignore
        if (event.isTrusted) fn.call(this, event);
    };
}
function $26ebed30afc43a11$export$7aabe8b3a840d2fd(node, attribute, value) {
    if (value == null) node.removeAttribute(attribute);
    else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}
/**
 * List of attributes that should always be set through the attr method,
 * because updating them through the property setter doesn't work reliably.
 * In the example of `width`/`height`, the problem is that the setter only
 * accepts numeric values, but the attribute can also be set to a string like `50%`.
 * If this list becomes too big, rethink this approach.
 */ const $26ebed30afc43a11$var$always_set_through_set_attribute = [
    "width",
    "height"
];
function $26ebed30afc43a11$export$d7952e694819cff8(node, attributes) {
    // @ts-ignore
    const descriptors = Object.getOwnPropertyDescriptors(node.__proto__);
    for(const key in attributes){
        if (attributes[key] == null) node.removeAttribute(key);
        else if (key === "style") node.style.cssText = attributes[key];
        else if (key === "__value") node.value = node[key] = attributes[key];
        else if (descriptors[key] && descriptors[key].set && $26ebed30afc43a11$var$always_set_through_set_attribute.indexOf(key) === -1) node[key] = attributes[key];
        else $26ebed30afc43a11$export$7aabe8b3a840d2fd(node, key, attributes[key]);
    }
}
function $26ebed30afc43a11$export$368e7860cfb63d61(node, attributes) {
    for(const key in attributes)$26ebed30afc43a11$export$7aabe8b3a840d2fd(node, key, attributes[key]);
}
function $26ebed30afc43a11$export$98353888655e5db6(node, data_map) {
    Object.keys(data_map).forEach((key)=>{
        $26ebed30afc43a11$export$ebd6c566d63faf17(node, key, data_map[key]);
    });
}
function $26ebed30afc43a11$export$ebd6c566d63faf17(node, prop, value) {
    if (prop in node) node[prop] = typeof node[prop] === "boolean" && value === "" ? true : value;
    else $26ebed30afc43a11$export$7aabe8b3a840d2fd(node, prop, value);
}
function $26ebed30afc43a11$export$e796c4bd7c66dc3b(tag) {
    return /-/.test(tag) ? $26ebed30afc43a11$export$98353888655e5db6 : $26ebed30afc43a11$export$d7952e694819cff8;
}
function $26ebed30afc43a11$export$f27475e5487b56e(node, attribute, value) {
    node.setAttributeNS("http://www.w3.org/1999/xlink", attribute, value);
}
function $26ebed30afc43a11$export$e362e436917dc36e(group, __value, checked) {
    const value = new Set();
    for(let i = 0; i < group.length; i += 1)if (group[i].checked) value.add(group[i].__value);
    if (!checked) value.delete(__value);
    return Array.from(value);
}
function $26ebed30afc43a11$export$c9db880d5988ec92(group) {
    let _inputs;
    return {
        /* push */ p (...inputs) {
            _inputs = inputs;
            _inputs.forEach((input)=>group.push(input));
        },
        /* remove */ r () {
            _inputs.forEach((input)=>group.splice(group.indexOf(input), 1));
        }
    };
}
function $26ebed30afc43a11$export$e81314ce0988e002(group, indexes) {
    let _group = get_binding_group(group);
    let _inputs;
    function get_binding_group(group) {
        for(let i = 0; i < indexes.length; i++)group = group[indexes[i]] = group[indexes[i]] || [];
        return group;
    }
    function push() {
        _inputs.forEach((input)=>_group.push(input));
    }
    function remove() {
        _inputs.forEach((input)=>_group.splice(_group.indexOf(input), 1));
    }
    return {
        /* update */ u (new_indexes) {
            indexes = new_indexes;
            const new_group = get_binding_group(group);
            if (new_group !== _group) {
                remove();
                _group = new_group;
                push();
            }
        },
        /* push */ p (...inputs) {
            _inputs = inputs;
            push();
        },
        /* remove */ r: remove
    };
}
function $26ebed30afc43a11$export$5ba91aa2ee2bd813(value) {
    return value === "" ? null : +value;
}
function $26ebed30afc43a11$export$fea0a9609a381cb7(ranges) {
    const array = [];
    for(let i = 0; i < ranges.length; i += 1)array.push({
        start: ranges.start(i),
        end: ranges.end(i)
    });
    return array;
}
function $26ebed30afc43a11$export$bacb5cc5a11aef16(element) {
    return Array.from(element.childNodes);
}
function $26ebed30afc43a11$var$init_claim_info(nodes) {
    if (nodes.claim_info === undefined) nodes.claim_info = {
        last_index: 0,
        total_claimed: 0
    };
}
function $26ebed30afc43a11$var$claim_node(nodes, predicate, processNode, createNode, dontUpdateLastIndex = false) {
    // Try to find nodes in an order such that we lengthen the longest increasing subsequence
    $26ebed30afc43a11$var$init_claim_info(nodes);
    const resultNode = (()=>{
        // We first try to find an element after the previous one
        for(let i = nodes.claim_info.last_index; i < nodes.length; i++){
            const node = nodes[i];
            if (predicate(node)) {
                const replacement = processNode(node);
                if (replacement === undefined) nodes.splice(i, 1);
                else nodes[i] = replacement;
                if (!dontUpdateLastIndex) nodes.claim_info.last_index = i;
                return node;
            }
        }
        // Otherwise, we try to find one before
        // We iterate in reverse so that we don't go too far back
        for(let i = nodes.claim_info.last_index - 1; i >= 0; i--){
            const node = nodes[i];
            if (predicate(node)) {
                const replacement = processNode(node);
                if (replacement === undefined) nodes.splice(i, 1);
                else nodes[i] = replacement;
                if (!dontUpdateLastIndex) nodes.claim_info.last_index = i;
                else if (replacement === undefined) // Since we spliced before the last_index, we decrease it
                nodes.claim_info.last_index--;
                return node;
            }
        }
        // If we can't find any matching node, we create a new one
        return createNode();
    })();
    resultNode.claim_order = nodes.claim_info.total_claimed;
    nodes.claim_info.total_claimed += 1;
    return resultNode;
}
function $26ebed30afc43a11$var$claim_element_base(nodes, name, attributes, create_element) {
    return $26ebed30afc43a11$var$claim_node(nodes, (node)=>node.nodeName === name, (node)=>{
        const remove = [];
        for(let j = 0; j < node.attributes.length; j++){
            const attribute = node.attributes[j];
            if (!attributes[attribute.name]) remove.push(attribute.name);
        }
        remove.forEach((v)=>node.removeAttribute(v));
        return undefined;
    }, ()=>create_element(name));
}
function $26ebed30afc43a11$export$e4d2dfbfb60b531(nodes, name, attributes) {
    return $26ebed30afc43a11$var$claim_element_base(nodes, name, attributes, $26ebed30afc43a11$export$8454457683f90105);
}
function $26ebed30afc43a11$export$565c8233a6bb82a5(nodes, name, attributes) {
    return $26ebed30afc43a11$var$claim_element_base(nodes, name, attributes, $26ebed30afc43a11$export$3967a3bb66708d71);
}
function $26ebed30afc43a11$export$2fada5bb0438cbc3(nodes, data) {
    return $26ebed30afc43a11$var$claim_node(nodes, (node)=>node.nodeType === 3, (node)=>{
        const dataStr = "" + data;
        if (node.data.startsWith(dataStr)) {
            if (node.data.length !== dataStr.length) return node.splitText(dataStr.length);
        } else node.data = dataStr;
    }, ()=>$26ebed30afc43a11$export$6f093cfa640b7166(data), true // Text nodes should not update last index since it is likely not worth it to eliminate an increasing subsequence of actual elements
    );
}
function $26ebed30afc43a11$export$2466e42bcfb45299(nodes) {
    return $26ebed30afc43a11$export$2fada5bb0438cbc3(nodes, " ");
}
function $26ebed30afc43a11$export$193ad9a257f71537(nodes, data) {
    return $26ebed30afc43a11$var$claim_node(nodes, (node)=>node.nodeType === 8, (node)=>{
        node.data = "" + data;
        return undefined;
    }, ()=>$26ebed30afc43a11$export$4a34f930e789283c(data), true);
}
function $26ebed30afc43a11$var$find_comment(nodes, text, start) {
    for(let i = start; i < nodes.length; i += 1){
        const node = nodes[i];
        if (node.nodeType === 8 /* comment node */  && node.textContent.trim() === text) return i;
    }
    return nodes.length;
}
function $26ebed30afc43a11$export$5d5909c037ed7d6(nodes, is_svg) {
    // find html opening tag
    const start_index = $26ebed30afc43a11$var$find_comment(nodes, "HTML_TAG_START", 0);
    const end_index = $26ebed30afc43a11$var$find_comment(nodes, "HTML_TAG_END", start_index);
    if (start_index === end_index) return new $26ebed30afc43a11$export$7cdd9a1105a7b19d(undefined, is_svg);
    $26ebed30afc43a11$var$init_claim_info(nodes);
    const html_tag_nodes = nodes.splice(start_index, end_index - start_index + 1);
    $26ebed30afc43a11$export$3f780019ff766da6(html_tag_nodes[0]);
    $26ebed30afc43a11$export$3f780019ff766da6(html_tag_nodes[html_tag_nodes.length - 1]);
    const claimed_nodes = html_tag_nodes.slice(1, html_tag_nodes.length - 1);
    for (const n of claimed_nodes){
        n.claim_order = nodes.claim_info.total_claimed;
        nodes.claim_info.total_claimed += 1;
    }
    return new $26ebed30afc43a11$export$7cdd9a1105a7b19d(claimed_nodes, is_svg);
}
function $26ebed30afc43a11$export$c31d24e2793e6a58(text, data) {
    data = "" + data;
    if (text.data === data) return;
    text.data = data;
}
function $26ebed30afc43a11$export$3216f7a4c630e86(text, data) {
    data = "" + data;
    if (text.wholeText === data) return;
    text.data = data;
}
function $26ebed30afc43a11$export$81784c858f228282(text, data, attr_value) {
    if (~$26ebed30afc43a11$export$e3d839ffa95f7481.indexOf(attr_value)) $26ebed30afc43a11$export$3216f7a4c630e86(text, data);
    else $26ebed30afc43a11$export$c31d24e2793e6a58(text, data);
}
function $26ebed30afc43a11$export$aee788c6eadfac08(input, value) {
    input.value = value == null ? "" : value;
}
function $26ebed30afc43a11$export$b4858aaf125f1c5a(input, type) {
    try {
        input.type = type;
    } catch (e) {
    // do nothing
    }
}
function $26ebed30afc43a11$export$4bb9c9f436517f16(node, key, value, important) {
    if (value == null) node.style.removeProperty(key);
    else node.style.setProperty(key, value, important ? "important" : "");
}
function $26ebed30afc43a11$export$5bf9f186a0379f12(select, value, mounting) {
    for(let i = 0; i < select.options.length; i += 1){
        const option = select.options[i];
        if (option.__value === value) {
            option.selected = true;
            return;
        }
    }
    if (!mounting || value !== undefined) select.selectedIndex = -1; // no option should be selected
}
function $26ebed30afc43a11$export$336810584d2bdfc9(select, value) {
    for(let i = 0; i < select.options.length; i += 1){
        const option = select.options[i];
        option.selected = ~value.indexOf(option.__value);
    }
}
function $26ebed30afc43a11$export$10e6f38ae1549a20(select) {
    const selected_option = select.querySelector(":checked");
    return selected_option && selected_option.__value;
}
function $26ebed30afc43a11$export$4dde2acae9a7963a(select) {
    return [].map.call(select.querySelectorAll(":checked"), (option)=>option.__value);
}
// unfortunately this can't be a constant as that wouldn't be tree-shakeable
// so we cache the result instead
let $26ebed30afc43a11$var$crossorigin;
function $26ebed30afc43a11$export$1d584e6276e92aaf() {
    if ($26ebed30afc43a11$var$crossorigin === undefined) {
        $26ebed30afc43a11$var$crossorigin = false;
        try {
            if (typeof window !== "undefined" && window.parent) window.parent.document;
        } catch (error) {
            $26ebed30afc43a11$var$crossorigin = true;
        }
    }
    return $26ebed30afc43a11$var$crossorigin;
}
function $26ebed30afc43a11$export$38ac981d7e55f60a(node, fn) {
    const computed_style = getComputedStyle(node);
    if (computed_style.position === "static") node.style.position = "relative";
    const iframe = $26ebed30afc43a11$export$8454457683f90105("iframe");
    iframe.setAttribute("style", "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden; border: 0; opacity: 0; pointer-events: none; z-index: -1;");
    iframe.setAttribute("aria-hidden", "true");
    iframe.tabIndex = -1;
    const crossorigin = $26ebed30afc43a11$export$1d584e6276e92aaf();
    let unsubscribe;
    if (crossorigin) {
        iframe.src = "data:text/html,<script>onresize=function(){parent.postMessage(0,'*')}</script>";
        unsubscribe = $26ebed30afc43a11$export$63174c828edd6ff8(window, "message", (event)=>{
            if (event.source === iframe.contentWindow) fn();
        });
    } else {
        iframe.src = "about:blank";
        iframe.onload = ()=>{
            unsubscribe = $26ebed30afc43a11$export$63174c828edd6ff8(iframe.contentWindow, "resize", fn);
            // make sure an initial resize event is fired _after_ the iframe is loaded (which is asynchronous)
            // see https://github.com/sveltejs/svelte/issues/4233
            fn();
        };
    }
    $26ebed30afc43a11$export$10d8903dec122b9d(node, iframe);
    return ()=>{
        if (crossorigin) unsubscribe();
        else if (unsubscribe && iframe.contentWindow) unsubscribe();
        $26ebed30afc43a11$export$3f780019ff766da6(iframe);
    };
}
const $26ebed30afc43a11$export$75ea48ff5ddc5b1 = /* @__PURE__ */ new $26ebed30afc43a11$export$cd966d69202271fb({
    box: "content-box"
});
const $26ebed30afc43a11$export$cfbcf6582d01e769 = /* @__PURE__ */ new $26ebed30afc43a11$export$cd966d69202271fb({
    box: "border-box"
});
const $26ebed30afc43a11$export$43fc4a2903df8cae = /* @__PURE__ */ new $26ebed30afc43a11$export$cd966d69202271fb({
    box: "device-pixel-content-box"
});
function $26ebed30afc43a11$export$d546e2fde02d30d6(element, name, toggle) {
    element.classList[toggle ? "add" : "remove"](name);
}
function $26ebed30afc43a11$export$da00493480283d6b(type, detail, { bubbles: bubbles = false, cancelable: cancelable = false } = {}) {
    const e = document.createEvent("CustomEvent");
    e.initCustomEvent(type, bubbles, cancelable, detail);
    return e;
}
function $26ebed30afc43a11$export$b06f083696d24824(selector, parent = document.body) {
    return Array.from(parent.querySelectorAll(selector));
}
function $26ebed30afc43a11$export$6a512dd14a7df6a(nodeId, head) {
    const result = [];
    let started = 0;
    for (const node of head.childNodes){
        if (node.nodeType === 8 /* comment node */ ) {
            const comment = node.textContent.trim();
            if (comment === `HEAD_${nodeId}_END`) {
                started -= 1;
                result.push(node);
            } else if (comment === `HEAD_${nodeId}_START`) {
                started += 1;
                result.push(node);
            }
        } else if (started > 0) result.push(node);
    }
    return result;
}
class $26ebed30afc43a11$export$5b2cf11349dd7485 {
    constructor(is_svg = false){
        this.is_svg = false;
        this.is_svg = is_svg;
        this.e = this.n = null;
    }
    c(html) {
        this.h(html);
    }
    m(html, target, anchor = null) {
        if (!this.e) {
            if (this.is_svg) this.e = $26ebed30afc43a11$export$3967a3bb66708d71(target.nodeName);
            else this.e = $26ebed30afc43a11$export$8454457683f90105(target.nodeType === 11 ? "TEMPLATE" : target.nodeName);
            this.t = target.tagName !== "TEMPLATE" ? target : target.content;
            this.c(html);
        }
        this.i(anchor);
    }
    h(html) {
        this.e.innerHTML = html;
        this.n = Array.from(this.e.nodeName === "TEMPLATE" ? this.e.content.childNodes : this.e.childNodes);
    }
    i(anchor) {
        for(let i = 0; i < this.n.length; i += 1)$26ebed30afc43a11$export$21a5ca8aa77d35ff(this.t, this.n[i], anchor);
    }
    p(html) {
        this.d();
        this.h(html);
        this.i(this.a);
    }
    d() {
        this.n.forEach($26ebed30afc43a11$export$3f780019ff766da6);
    }
}
class $26ebed30afc43a11$export$7cdd9a1105a7b19d extends $26ebed30afc43a11$export$5b2cf11349dd7485 {
    constructor(claimed_nodes, is_svg = false){
        super(is_svg);
        this.e = this.n = null;
        this.l = claimed_nodes;
    }
    c(html) {
        if (this.l) this.n = this.l;
        else super.c(html);
    }
    i(anchor) {
        for(let i = 0; i < this.n.length; i += 1)$26ebed30afc43a11$export$f7a8880e5fbca7f8(this.t, this.n[i], anchor);
    }
}
function $26ebed30afc43a11$export$110c642b3fe80ed5(attributes) {
    const result = {};
    for (const attribute of attributes)result[attribute.name] = attribute.value;
    return result;
}
function $26ebed30afc43a11$export$58283a1df1431097(element) {
    const result = {};
    element.childNodes.forEach((node)=>{
        result[node.slot || "default"] = true;
    });
    return result;
}
function $26ebed30afc43a11$export$203be6b617b8723(component, props) {
    return new component(props);
}
// we need to store the information for multiple documents because a Svelte application could also contain iframes
// https://github.com/sveltejs/svelte/issues/3624
const $26ebed30afc43a11$var$managed_styles = new Map();
let $26ebed30afc43a11$var$active = 0;
// https://github.com/darkskyapp/string-hash/blob/master/index.js
function $26ebed30afc43a11$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i--)hash = (hash << 5) - hash ^ str.charCodeAt(i);
    return hash >>> 0;
}
function $26ebed30afc43a11$var$create_style_information(doc, node) {
    const info = {
        stylesheet: $26ebed30afc43a11$export$98a01cd5b3256c7(node),
        rules: {}
    };
    $26ebed30afc43a11$var$managed_styles.set(doc, info);
    return info;
}
function $26ebed30afc43a11$var$create_rule(node, a, b, duration, delay, ease, fn, uid = 0) {
    const step = 16.666 / duration;
    let keyframes = "{\n";
    for(let p = 0; p <= 1; p += step){
        const t = a + (b - a) * ease(p);
        keyframes += p * 100 + `%{${fn(t, 1 - t)}}\n`;
    }
    const rule = keyframes + `100% {${fn(b, 1 - b)}}\n}`;
    const name = `__svelte_${$26ebed30afc43a11$var$hash(rule)}_${uid}`;
    const doc = $26ebed30afc43a11$export$e6f325d87fe70439(node);
    const { stylesheet: stylesheet, rules: rules } = $26ebed30afc43a11$var$managed_styles.get(doc) || $26ebed30afc43a11$var$create_style_information(doc, node);
    if (!rules[name]) {
        rules[name] = true;
        stylesheet.insertRule(`@keyframes ${name} ${rule}`, stylesheet.cssRules.length);
    }
    const animation = node.style.animation || "";
    node.style.animation = `${animation ? `${animation}, ` : ""}${name} ${duration}ms linear ${delay}ms 1 both`;
    $26ebed30afc43a11$var$active += 1;
    return name;
}
function $26ebed30afc43a11$var$delete_rule(node, name) {
    const previous = (node.style.animation || "").split(", ");
    const next = previous.filter(name ? (anim)=>anim.indexOf(name) < 0 // remove specific animation
     : (anim)=>anim.indexOf("__svelte") === -1 // remove all Svelte animations
    );
    const deleted = previous.length - next.length;
    if (deleted) {
        node.style.animation = next.join(", ");
        $26ebed30afc43a11$var$active -= deleted;
        if (!$26ebed30afc43a11$var$active) $26ebed30afc43a11$var$clear_rules();
    }
}
function $26ebed30afc43a11$var$clear_rules() {
    $26ebed30afc43a11$export$27f233d61a9e2fa4(()=>{
        if ($26ebed30afc43a11$var$active) return;
        $26ebed30afc43a11$var$managed_styles.forEach((info)=>{
            const { ownerNode: ownerNode } = info.stylesheet;
            // there is no ownerNode if it runs on jsdom.
            if (ownerNode) $26ebed30afc43a11$export$3f780019ff766da6(ownerNode);
        });
        $26ebed30afc43a11$var$managed_styles.clear();
    });
}
function $26ebed30afc43a11$export$39b5174d4b79e190(node, from, fn, params) {
    if (!from) return $26ebed30afc43a11$export$8793edee2d425525;
    const to = node.getBoundingClientRect();
    if (from.left === to.left && from.right === to.right && from.top === to.top && from.bottom === to.bottom) return $26ebed30afc43a11$export$8793edee2d425525;
    const { delay: delay = 0, duration: duration = 300, easing: easing = $26ebed30afc43a11$export$f0954fd7d5368655, // @ts-ignore todo: should this be separated from destructuring? Or start/end added to public api and documentation?
    start: start_time = $26ebed30afc43a11$export$461939dd4422153() + delay, end: // @ts-ignore todo:
    end = start_time + duration, tick: tick = $26ebed30afc43a11$export$8793edee2d425525, css: css } = fn(node, {
        from: from,
        to: to
    }, params);
    let running = true;
    let started = false;
    let name;
    function start() {
        if (css) name = $26ebed30afc43a11$var$create_rule(node, 0, 1, duration, delay, easing, css);
        if (!delay) started = true;
    }
    function stop() {
        if (css) $26ebed30afc43a11$var$delete_rule(node, name);
        running = false;
    }
    $26ebed30afc43a11$export$f9ef67375ddc185((now)=>{
        if (!started && now >= start_time) started = true;
        if (started && now >= end) {
            tick(1, 0);
            stop();
        }
        if (!running) return false;
        if (started) {
            const p = now - start_time;
            const t = 0 + 1 * easing(p / duration);
            tick(t, 1 - t);
        }
        return true;
    });
    start();
    tick(0, 1);
    return stop;
}
function $26ebed30afc43a11$export$b3559b6401c8ae16(node) {
    const style = getComputedStyle(node);
    if (style.position !== "absolute" && style.position !== "fixed") {
        const { width: width, height: height } = style;
        const a = node.getBoundingClientRect();
        node.style.position = "absolute";
        node.style.width = width;
        node.style.height = height;
        $26ebed30afc43a11$export$e05da6b8aaec7de(node, a);
    }
}
function $26ebed30afc43a11$export$e05da6b8aaec7de(node, a) {
    const b = node.getBoundingClientRect();
    if (a.left !== b.left || a.top !== b.top) {
        const style = getComputedStyle(node);
        const transform = style.transform === "none" ? "" : style.transform;
        node.style.transform = `${transform} translate(${a.left - b.left}px, ${a.top - b.top}px)`;
    }
}
let $26ebed30afc43a11$export$3ec7acbf47bb7c71;
function $26ebed30afc43a11$export$e72a4c53a1d11dfc(component) {
    $26ebed30afc43a11$export$3ec7acbf47bb7c71 = component;
}
function $26ebed30afc43a11$export$d19094f0a5fb37fa() {
    if (!$26ebed30afc43a11$export$3ec7acbf47bb7c71) throw new Error("Function called outside component initialization");
    return $26ebed30afc43a11$export$3ec7acbf47bb7c71;
}
/**
 * Schedules a callback to run immediately before the component is updated after any state change.
 *
 * The first time the callback runs will be before the initial `onMount`
 *
 * https://svelte.dev/docs#run-time-svelte-beforeupdate
 */ function $26ebed30afc43a11$export$4b797776fd97928f(fn) {
    $26ebed30afc43a11$export$d19094f0a5fb37fa().$$.before_update.push(fn);
}
/**
 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
 * it can be called from an external module).
 *
 * `onMount` does not run inside a [server-side component](/docs#run-time-server-side-component-api).
 *
 * https://svelte.dev/docs#run-time-svelte-onmount
 */ function $26ebed30afc43a11$export$1e848a9e87980bd5(fn) {
    $26ebed30afc43a11$export$d19094f0a5fb37fa().$$.on_mount.push(fn);
}
/**
 * Schedules a callback to run immediately after the component has been updated.
 *
 * The first time the callback runs will be after the initial `onMount`
 */ function $26ebed30afc43a11$export$f956f39b9a12cea8(fn) {
    $26ebed30afc43a11$export$d19094f0a5fb37fa().$$.after_update.push(fn);
}
/**
 * Schedules a callback to run immediately before the component is unmounted.
 *
 * Out of `onMount`, `beforeUpdate`, `afterUpdate` and `onDestroy`, this is the
 * only one that runs inside a server-side component.
 *
 * https://svelte.dev/docs#run-time-svelte-ondestroy
 */ function $26ebed30afc43a11$export$f1238fd06ad9b453(fn) {
    $26ebed30afc43a11$export$d19094f0a5fb37fa().$$.on_destroy.push(fn);
}
/**
 * Creates an event dispatcher that can be used to dispatch [component events](/docs#template-syntax-component-directives-on-eventname).
 * Event dispatchers are functions that can take two arguments: `name` and `detail`.
 *
 * Component events created with `createEventDispatcher` create a
 * [CustomEvent](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent).
 * These events do not [bubble](https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Events#Event_bubbling_and_capture).
 * The `detail` argument corresponds to the [CustomEvent.detail](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/detail)
 * property and can contain any type of data.
 *
 * https://svelte.dev/docs#run-time-svelte-createeventdispatcher
 */ function $26ebed30afc43a11$export$2a380c922b2bd2b3() {
    const component = $26ebed30afc43a11$export$d19094f0a5fb37fa();
    return (type, detail, { cancelable: cancelable = false } = {})=>{
        const callbacks = component.$$.callbacks[type];
        if (callbacks) {
            // TODO are there situations where events could be dispatched
            // in a server (non-DOM) environment?
            const event = $26ebed30afc43a11$export$da00493480283d6b(type, detail, {
                cancelable: cancelable
            });
            callbacks.slice().forEach((fn)=>{
                fn.call(component, event);
            });
            return !event.defaultPrevented;
        }
        return true;
    };
}
/**
 * Associates an arbitrary `context` object with the current component and the specified `key`
 * and returns that object. The context is then available to children of the component
 * (including slotted content) with `getContext`.
 *
 * Like lifecycle functions, this must be called during component initialisation.
 *
 * https://svelte.dev/docs#run-time-svelte-setcontext
 */ function $26ebed30afc43a11$export$2f04de43fe27971a(key, context) {
    $26ebed30afc43a11$export$d19094f0a5fb37fa().$$.context.set(key, context);
    return context;
}
/**
 * Retrieves the context that belongs to the closest parent component with the specified `key`.
 * Must be called during component initialisation.
 *
 * https://svelte.dev/docs#run-time-svelte-getcontext
 */ function $26ebed30afc43a11$export$31553aaa555c1514(key) {
    return $26ebed30afc43a11$export$d19094f0a5fb37fa().$$.context.get(key);
}
/**
 * Retrieves the whole context map that belongs to the closest parent component.
 * Must be called during component initialisation. Useful, for example, if you
 * programmatically create a component and want to pass the existing context to it.
 *
 * https://svelte.dev/docs#run-time-svelte-getallcontexts
 */ function $26ebed30afc43a11$export$58bb8454a8b39484() {
    return $26ebed30afc43a11$export$d19094f0a5fb37fa().$$.context;
}
/**
 * Checks whether a given `key` has been set in the context of a parent component.
 * Must be called during component initialisation.
 *
 * https://svelte.dev/docs#run-time-svelte-hascontext
 */ function $26ebed30afc43a11$export$1fda64d8edbe0e8d(key) {
    return $26ebed30afc43a11$export$d19094f0a5fb37fa().$$.context.has(key);
}
// TODO figure out if we still want to support
// shorthand events, or if we want to implement
// a real bubbling mechanism
function $26ebed30afc43a11$export$f5dbf5ce556e97fb(component, event) {
    const callbacks = component.$$.callbacks[event.type];
    if (callbacks) // @ts-ignore
    callbacks.slice().forEach((fn)=>fn.call(this, event));
}
const $26ebed30afc43a11$export$befe60e985bb3cce = [];
const $26ebed30afc43a11$export$eec97e1bbe9a59bc = {
    enabled: false
};
const $26ebed30afc43a11$export$de8cb20e97391842 = [];
let $26ebed30afc43a11$var$render_callbacks = [];
const $26ebed30afc43a11$var$flush_callbacks = [];
const $26ebed30afc43a11$var$resolved_promise = /* @__PURE__ */ Promise.resolve();
let $26ebed30afc43a11$var$update_scheduled = false;
function $26ebed30afc43a11$export$c3d55cc721051d24() {
    if (!$26ebed30afc43a11$var$update_scheduled) {
        $26ebed30afc43a11$var$update_scheduled = true;
        $26ebed30afc43a11$var$resolved_promise.then($26ebed30afc43a11$export$4909b86c8034bf73);
    }
}
function $26ebed30afc43a11$export$55d7f61db91b7b70() {
    $26ebed30afc43a11$export$c3d55cc721051d24();
    return $26ebed30afc43a11$var$resolved_promise;
}
function $26ebed30afc43a11$export$8851747095d022df(fn) {
    $26ebed30afc43a11$var$render_callbacks.push(fn);
}
function $26ebed30afc43a11$export$53b4f9f742189b3b(fn) {
    $26ebed30afc43a11$var$flush_callbacks.push(fn);
}
// flush() calls callbacks in this order:
// 1. All beforeUpdate callbacks, in order: parents before children
// 2. All bind:this callbacks, in reverse order: children before parents.
// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
//    for afterUpdates called during the initial onMount, which are called in
//    reverse order: children before parents.
// Since callbacks might update component values, which could trigger another
// call to flush(), the following steps guard against this:
// 1. During beforeUpdate, any updated components will be added to the
//    dirty_components array and will cause a reentrant call to flush(). Because
//    the flush index is kept outside the function, the reentrant call will pick
//    up where the earlier call left off and go through all dirty components. The
//    current_component value is saved and restored so that the reentrant call will
//    not interfere with the "parent" flush() call.
// 2. bind:this callbacks cannot trigger new flush() calls.
// 3. During afterUpdate, any updated components will NOT have their afterUpdate
//    callback called a second time; the seen_callbacks set, outside the flush()
//    function, guarantees this behavior.
const $26ebed30afc43a11$var$seen_callbacks = new Set();
let $26ebed30afc43a11$var$flushidx = 0; // Do *not* move this inside the flush() function
function $26ebed30afc43a11$export$4909b86c8034bf73() {
    // Do not reenter flush while dirty components are updated, as this can
    // result in an infinite loop. Instead, let the inner flush handle it.
    // Reentrancy is ok afterwards for bindings etc.
    if ($26ebed30afc43a11$var$flushidx !== 0) return;
    const saved_component = $26ebed30afc43a11$export$3ec7acbf47bb7c71;
    do {
        // first, call beforeUpdate functions
        // and update components
        try {
            while($26ebed30afc43a11$var$flushidx < $26ebed30afc43a11$export$befe60e985bb3cce.length){
                const component = $26ebed30afc43a11$export$befe60e985bb3cce[$26ebed30afc43a11$var$flushidx];
                $26ebed30afc43a11$var$flushidx++;
                $26ebed30afc43a11$export$e72a4c53a1d11dfc(component);
                $26ebed30afc43a11$var$update(component.$$);
            }
        } catch (e) {
            // reset dirty state to not end up in a deadlocked state and then rethrow
            $26ebed30afc43a11$export$befe60e985bb3cce.length = 0;
            $26ebed30afc43a11$var$flushidx = 0;
            throw e;
        }
        $26ebed30afc43a11$export$e72a4c53a1d11dfc(null);
        $26ebed30afc43a11$export$befe60e985bb3cce.length = 0;
        $26ebed30afc43a11$var$flushidx = 0;
        while($26ebed30afc43a11$export$de8cb20e97391842.length)$26ebed30afc43a11$export$de8cb20e97391842.pop()();
        // then, once components are updated, call
        // afterUpdate functions. This may cause
        // subsequent updates...
        for(let i = 0; i < $26ebed30afc43a11$var$render_callbacks.length; i += 1){
            const callback = $26ebed30afc43a11$var$render_callbacks[i];
            if (!$26ebed30afc43a11$var$seen_callbacks.has(callback)) {
                // ...so guard against infinite loops
                $26ebed30afc43a11$var$seen_callbacks.add(callback);
                callback();
            }
        }
        $26ebed30afc43a11$var$render_callbacks.length = 0;
    }while ($26ebed30afc43a11$export$befe60e985bb3cce.length);
    while($26ebed30afc43a11$var$flush_callbacks.length)$26ebed30afc43a11$var$flush_callbacks.pop()();
    $26ebed30afc43a11$var$update_scheduled = false;
    $26ebed30afc43a11$var$seen_callbacks.clear();
    $26ebed30afc43a11$export$e72a4c53a1d11dfc(saved_component);
}
function $26ebed30afc43a11$var$update($$) {
    if ($$.fragment !== null) {
        $$.update();
        $26ebed30afc43a11$export$3f1fcd837f99a9ab($$.before_update);
        const dirty = $$.dirty;
        $$.dirty = [
            -1
        ];
        $$.fragment && $$.fragment.p($$.ctx, dirty);
        $$.after_update.forEach($26ebed30afc43a11$export$8851747095d022df);
    }
}
/**
 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
 */ function $26ebed30afc43a11$export$99d0f1b00233da03(fns) {
    const filtered = [];
    const targets = [];
    $26ebed30afc43a11$var$render_callbacks.forEach((c)=>fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
    targets.forEach((c)=>c());
    $26ebed30afc43a11$var$render_callbacks = filtered;
}
let $26ebed30afc43a11$var$promise;
function $26ebed30afc43a11$var$wait() {
    if (!$26ebed30afc43a11$var$promise) {
        $26ebed30afc43a11$var$promise = Promise.resolve();
        $26ebed30afc43a11$var$promise.then(()=>{
            $26ebed30afc43a11$var$promise = null;
        });
    }
    return $26ebed30afc43a11$var$promise;
}
function $26ebed30afc43a11$var$dispatch(node, direction, kind) {
    node.dispatchEvent($26ebed30afc43a11$export$da00493480283d6b(`${direction ? "intro" : "outro"}${kind}`));
}
const $26ebed30afc43a11$var$outroing = new Set();
let $26ebed30afc43a11$var$outros;
function $26ebed30afc43a11$export$b074532eec6b252c() {
    $26ebed30afc43a11$var$outros = {
        r: 0,
        c: [],
        p: $26ebed30afc43a11$var$outros // parent group
    };
}
function $26ebed30afc43a11$export$e7d251cf909c6ab9() {
    if (!$26ebed30afc43a11$var$outros.r) $26ebed30afc43a11$export$3f1fcd837f99a9ab($26ebed30afc43a11$var$outros.c);
    $26ebed30afc43a11$var$outros = $26ebed30afc43a11$var$outros.p;
}
function $26ebed30afc43a11$export$9e951caa2db2b1da(block, local) {
    if (block && block.i) {
        $26ebed30afc43a11$var$outroing.delete(block);
        block.i(local);
    }
}
function $26ebed30afc43a11$export$fdd20dba65b2c00e(block, local, detach, callback) {
    if (block && block.o) {
        if ($26ebed30afc43a11$var$outroing.has(block)) return;
        $26ebed30afc43a11$var$outroing.add(block);
        $26ebed30afc43a11$var$outros.c.push(()=>{
            $26ebed30afc43a11$var$outroing.delete(block);
            if (callback) {
                if (detach) block.d(1);
                callback();
            }
        });
        block.o(local);
    } else if (callback) callback();
}
const $26ebed30afc43a11$var$null_transition = {
    duration: 0
};
function $26ebed30afc43a11$export$60774c4a339e0bce(node, fn, params) {
    const options = {
        direction: "in"
    };
    let config = fn(node, params, options);
    let running = false;
    let animation_name;
    let task;
    let uid = 0;
    function cleanup() {
        if (animation_name) $26ebed30afc43a11$var$delete_rule(node, animation_name);
    }
    function go() {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $26ebed30afc43a11$export$f0954fd7d5368655, tick: tick = $26ebed30afc43a11$export$8793edee2d425525, css: css } = config || $26ebed30afc43a11$var$null_transition;
        if (css) animation_name = $26ebed30afc43a11$var$create_rule(node, 0, 1, duration, delay, easing, css, uid++);
        tick(0, 1);
        const start_time = $26ebed30afc43a11$export$461939dd4422153() + delay;
        const end_time = start_time + duration;
        if (task) task.abort();
        running = true;
        $26ebed30afc43a11$export$8851747095d022df(()=>$26ebed30afc43a11$var$dispatch(node, true, "start"));
        task = $26ebed30afc43a11$export$f9ef67375ddc185((now)=>{
            if (running) {
                if (now >= end_time) {
                    tick(1, 0);
                    $26ebed30afc43a11$var$dispatch(node, true, "end");
                    cleanup();
                    return running = false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(t, 1 - t);
                }
            }
            return running;
        });
    }
    let started = false;
    return {
        start () {
            if (started) return;
            started = true;
            $26ebed30afc43a11$var$delete_rule(node);
            if ($26ebed30afc43a11$export$b451353ebd749597(config)) {
                config = config(options);
                $26ebed30afc43a11$var$wait().then(go);
            } else go();
        },
        invalidate () {
            started = false;
        },
        end () {
            if (running) {
                cleanup();
                running = false;
            }
        }
    };
}
function $26ebed30afc43a11$export$f77bfa1b5f956ef9(node, fn, params) {
    const options = {
        direction: "out"
    };
    let config = fn(node, params, options);
    let running = true;
    let animation_name;
    const group = $26ebed30afc43a11$var$outros;
    group.r += 1;
    function go() {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $26ebed30afc43a11$export$f0954fd7d5368655, tick: tick = $26ebed30afc43a11$export$8793edee2d425525, css: css } = config || $26ebed30afc43a11$var$null_transition;
        if (css) animation_name = $26ebed30afc43a11$var$create_rule(node, 1, 0, duration, delay, easing, css);
        const start_time = $26ebed30afc43a11$export$461939dd4422153() + delay;
        const end_time = start_time + duration;
        $26ebed30afc43a11$export$8851747095d022df(()=>$26ebed30afc43a11$var$dispatch(node, false, "start"));
        $26ebed30afc43a11$export$f9ef67375ddc185((now)=>{
            if (running) {
                if (now >= end_time) {
                    tick(0, 1);
                    $26ebed30afc43a11$var$dispatch(node, false, "end");
                    if (!--group.r) // this will result in `end()` being called,
                    // so we don't need to clean up here
                    $26ebed30afc43a11$export$3f1fcd837f99a9ab(group.c);
                    return false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(1 - t, t);
                }
            }
            return running;
        });
    }
    if ($26ebed30afc43a11$export$b451353ebd749597(config)) $26ebed30afc43a11$var$wait().then(()=>{
        // @ts-ignore
        config = config(options);
        go();
    });
    else go();
    return {
        end (reset) {
            if (reset && config.tick) config.tick(1, 0);
            if (running) {
                if (animation_name) $26ebed30afc43a11$var$delete_rule(node, animation_name);
                running = false;
            }
        }
    };
}
function $26ebed30afc43a11$export$20b54ee3658479fb(node, fn, params, intro) {
    const options = {
        direction: "both"
    };
    let config = fn(node, params, options);
    let t = intro ? 0 : 1;
    let running_program = null;
    let pending_program = null;
    let animation_name = null;
    function clear_animation() {
        if (animation_name) $26ebed30afc43a11$var$delete_rule(node, animation_name);
    }
    function init(program, duration) {
        const d = program.b - t;
        duration *= Math.abs(d);
        return {
            a: t,
            b: program.b,
            d: d,
            duration: duration,
            start: program.start,
            end: program.start + duration,
            group: program.group
        };
    }
    function go(b) {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $26ebed30afc43a11$export$f0954fd7d5368655, tick: tick = $26ebed30afc43a11$export$8793edee2d425525, css: css } = config || $26ebed30afc43a11$var$null_transition;
        const program = {
            start: $26ebed30afc43a11$export$461939dd4422153() + delay,
            b: b
        };
        if (!b) {
            // @ts-ignore todo: improve typings
            program.group = $26ebed30afc43a11$var$outros;
            $26ebed30afc43a11$var$outros.r += 1;
        }
        if (running_program || pending_program) pending_program = program;
        else {
            // if this is an intro, and there's a delay, we need to do
            // an initial tick and/or apply CSS animation immediately
            if (css) {
                clear_animation();
                animation_name = $26ebed30afc43a11$var$create_rule(node, t, b, duration, delay, easing, css);
            }
            if (b) tick(0, 1);
            running_program = init(program, duration);
            $26ebed30afc43a11$export$8851747095d022df(()=>$26ebed30afc43a11$var$dispatch(node, b, "start"));
            $26ebed30afc43a11$export$f9ef67375ddc185((now)=>{
                if (pending_program && now > pending_program.start) {
                    running_program = init(pending_program, duration);
                    pending_program = null;
                    $26ebed30afc43a11$var$dispatch(node, running_program.b, "start");
                    if (css) {
                        clear_animation();
                        animation_name = $26ebed30afc43a11$var$create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
                    }
                }
                if (running_program) {
                    if (now >= running_program.end) {
                        tick(t = running_program.b, 1 - t);
                        $26ebed30afc43a11$var$dispatch(node, running_program.b, "end");
                        if (!pending_program) {
                            // we're done
                            if (running_program.b) // intro — we can tidy up immediately
                            clear_animation();
                            else // outro — needs to be coordinated
                            if (!--running_program.group.r) $26ebed30afc43a11$export$3f1fcd837f99a9ab(running_program.group.c);
                        }
                        running_program = null;
                    } else if (now >= running_program.start) {
                        const p = now - running_program.start;
                        t = running_program.a + running_program.d * easing(p / running_program.duration);
                        tick(t, 1 - t);
                    }
                }
                return !!(running_program || pending_program);
            });
        }
    }
    return {
        run (b) {
            if ($26ebed30afc43a11$export$b451353ebd749597(config)) $26ebed30afc43a11$var$wait().then(()=>{
                // @ts-ignore
                config = config(options);
                go(b);
            });
            else go(b);
        },
        end () {
            clear_animation();
            running_program = pending_program = null;
        }
    };
}
function $26ebed30afc43a11$export$784d33b211c10e0c(promise, info) {
    const token = info.token = {};
    function update(type, index, key, value) {
        if (info.token !== token) return;
        info.resolved = value;
        let child_ctx = info.ctx;
        if (key !== undefined) {
            child_ctx = child_ctx.slice();
            child_ctx[key] = value;
        }
        const block = type && (info.current = type)(child_ctx);
        let needs_flush = false;
        if (info.block) {
            if (info.blocks) info.blocks.forEach((block, i)=>{
                if (i !== index && block) {
                    $26ebed30afc43a11$export$b074532eec6b252c();
                    $26ebed30afc43a11$export$fdd20dba65b2c00e(block, 1, 1, ()=>{
                        if (info.blocks[i] === block) info.blocks[i] = null;
                    });
                    $26ebed30afc43a11$export$e7d251cf909c6ab9();
                }
            });
            else info.block.d(1);
            block.c();
            $26ebed30afc43a11$export$9e951caa2db2b1da(block, 1);
            block.m(info.mount(), info.anchor);
            needs_flush = true;
        }
        info.block = block;
        if (info.blocks) info.blocks[index] = block;
        if (needs_flush) $26ebed30afc43a11$export$4909b86c8034bf73();
    }
    if ($26ebed30afc43a11$export$7666b03abe8479da(promise)) {
        const current_component = $26ebed30afc43a11$export$d19094f0a5fb37fa();
        promise.then((value)=>{
            $26ebed30afc43a11$export$e72a4c53a1d11dfc(current_component);
            update(info.then, 1, info.value, value);
            $26ebed30afc43a11$export$e72a4c53a1d11dfc(null);
        }, (error)=>{
            $26ebed30afc43a11$export$e72a4c53a1d11dfc(current_component);
            update(info.catch, 2, info.error, error);
            $26ebed30afc43a11$export$e72a4c53a1d11dfc(null);
            if (!info.hasCatch) throw error;
        });
        // if we previously had a then/catch block, destroy it
        if (info.current !== info.pending) {
            update(info.pending, 0);
            return true;
        }
    } else {
        if (info.current !== info.then) {
            update(info.then, 1, info.value, promise);
            return true;
        }
        info.resolved = promise;
    }
}
function $26ebed30afc43a11$export$69ebd9d202167ab4(info, ctx, dirty) {
    const child_ctx = ctx.slice();
    const { resolved: resolved } = info;
    if (info.current === info.then) child_ctx[info.value] = resolved;
    if (info.current === info.catch) child_ctx[info.error] = resolved;
    info.block.p(child_ctx, dirty);
}
function $26ebed30afc43a11$export$75442db144d4e64e(block, lookup) {
    block.d(1);
    lookup.delete(block.key);
}
function $26ebed30afc43a11$export$34db5f5dc4992cab(block, lookup) {
    $26ebed30afc43a11$export$fdd20dba65b2c00e(block, 1, 1, ()=>{
        lookup.delete(block.key);
    });
}
function $26ebed30afc43a11$export$ba06fda9300662d1(block, lookup) {
    block.f();
    $26ebed30afc43a11$export$75442db144d4e64e(block, lookup);
}
function $26ebed30afc43a11$export$6fdc494652858fb8(block, lookup) {
    block.f();
    $26ebed30afc43a11$export$34db5f5dc4992cab(block, lookup);
}
function $26ebed30afc43a11$export$1c17fe0cd58c4da7(old_blocks, dirty, get_key, dynamic, ctx, list, lookup, node, destroy, create_each_block, next, get_context) {
    let o = old_blocks.length;
    let n = list.length;
    let i = o;
    const old_indexes = {};
    while(i--)old_indexes[old_blocks[i].key] = i;
    const new_blocks = [];
    const new_lookup = new Map();
    const deltas = new Map();
    const updates = [];
    i = n;
    while(i--){
        const child_ctx = get_context(ctx, list, i);
        const key = get_key(child_ctx);
        let block = lookup.get(key);
        if (!block) {
            block = create_each_block(key, child_ctx);
            block.c();
        } else if (dynamic) // defer updates until all the DOM shuffling is done
        updates.push(()=>block.p(child_ctx, dirty));
        new_lookup.set(key, new_blocks[i] = block);
        if (key in old_indexes) deltas.set(key, Math.abs(i - old_indexes[key]));
    }
    const will_move = new Set();
    const did_move = new Set();
    function insert(block) {
        $26ebed30afc43a11$export$9e951caa2db2b1da(block, 1);
        block.m(node, next);
        lookup.set(block.key, block);
        next = block.first;
        n--;
    }
    while(o && n){
        const new_block = new_blocks[n - 1];
        const old_block = old_blocks[o - 1];
        const new_key = new_block.key;
        const old_key = old_block.key;
        if (new_block === old_block) {
            // do nothing
            next = new_block.first;
            o--;
            n--;
        } else if (!new_lookup.has(old_key)) {
            // remove old block
            destroy(old_block, lookup);
            o--;
        } else if (!lookup.has(new_key) || will_move.has(new_key)) insert(new_block);
        else if (did_move.has(old_key)) o--;
        else if (deltas.get(new_key) > deltas.get(old_key)) {
            did_move.add(new_key);
            insert(new_block);
        } else {
            will_move.add(old_key);
            o--;
        }
    }
    while(o--){
        const old_block = old_blocks[o];
        if (!new_lookup.has(old_block.key)) destroy(old_block, lookup);
    }
    while(n)insert(new_blocks[n - 1]);
    $26ebed30afc43a11$export$3f1fcd837f99a9ab(updates);
    return new_blocks;
}
function $26ebed30afc43a11$export$7a64eb7bd69e8d3f(ctx, list, get_context, get_key) {
    const keys = new Set();
    for(let i = 0; i < list.length; i++){
        const key = get_key(get_context(ctx, list, i));
        if (keys.has(key)) throw new Error("Cannot have duplicate keys in a keyed each");
        keys.add(key);
    }
}
function $26ebed30afc43a11$export$eea1060726e9ab6(levels, updates) {
    const update = {};
    const to_null_out = {};
    const accounted_for = {
        $$scope: 1
    };
    let i = levels.length;
    while(i--){
        const o = levels[i];
        const n = updates[i];
        if (n) {
            for(const key in o)if (!(key in n)) to_null_out[key] = 1;
            for(const key in n)if (!accounted_for[key]) {
                update[key] = n[key];
                accounted_for[key] = 1;
            }
            levels[i] = n;
        } else for(const key in o)accounted_for[key] = 1;
    }
    for(const key in to_null_out)if (!(key in update)) update[key] = undefined;
    return update;
}
function $26ebed30afc43a11$export$19fac21209f8779d(spread_props) {
    return typeof spread_props === "object" && spread_props !== null ? spread_props : {};
}
const $26ebed30afc43a11$var$_boolean_attributes = [
    "allowfullscreen",
    "allowpaymentrequest",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "hidden",
    "inert",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected"
];
/**
 * List of HTML boolean attributes (e.g. `<input disabled>`).
 * Source: https://html.spec.whatwg.org/multipage/indices.html
 */ const $26ebed30afc43a11$var$boolean_attributes = new Set([
    ...$26ebed30afc43a11$var$_boolean_attributes
]);
/** regex of all html void element names */ const $26ebed30afc43a11$var$void_element_names = /^(?:area|base|br|col|command|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)$/;
function $26ebed30afc43a11$export$66cf70365c175aee(name) {
    return $26ebed30afc43a11$var$void_element_names.test(name) || name.toLowerCase() === "!doctype";
}
const $26ebed30afc43a11$export$44426fed7d33cfd0 = /[\s'">/=\u{FDD0}-\u{FDEF}\u{FFFE}\u{FFFF}\u{1FFFE}\u{1FFFF}\u{2FFFE}\u{2FFFF}\u{3FFFE}\u{3FFFF}\u{4FFFE}\u{4FFFF}\u{5FFFE}\u{5FFFF}\u{6FFFE}\u{6FFFF}\u{7FFFE}\u{7FFFF}\u{8FFFE}\u{8FFFF}\u{9FFFE}\u{9FFFF}\u{AFFFE}\u{AFFFF}\u{BFFFE}\u{BFFFF}\u{CFFFE}\u{CFFFF}\u{DFFFE}\u{DFFFF}\u{EFFFE}\u{EFFFF}\u{FFFFE}\u{FFFFF}\u{10FFFE}\u{10FFFF}]/u;
// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
// https://infra.spec.whatwg.org/#noncharacter
function $26ebed30afc43a11$export$3ae0fd4797ed47c8(args, attrs_to_add) {
    const attributes = Object.assign({}, ...args);
    if (attrs_to_add) {
        const classes_to_add = attrs_to_add.classes;
        const styles_to_add = attrs_to_add.styles;
        if (classes_to_add) {
            if (attributes.class == null) attributes.class = classes_to_add;
            else attributes.class += " " + classes_to_add;
        }
        if (styles_to_add) {
            if (attributes.style == null) attributes.style = $26ebed30afc43a11$var$style_object_to_string(styles_to_add);
            else attributes.style = $26ebed30afc43a11$var$style_object_to_string($26ebed30afc43a11$export$59f1d5f66ae7e219(attributes.style, styles_to_add));
        }
    }
    let str = "";
    Object.keys(attributes).forEach((name)=>{
        if ($26ebed30afc43a11$export$44426fed7d33cfd0.test(name)) return;
        const value = attributes[name];
        if (value === true) str += " " + name;
        else if ($26ebed30afc43a11$var$boolean_attributes.has(name.toLowerCase())) {
            if (value) str += " " + name;
        } else if (value != null) str += ` ${name}="${value}"`;
    });
    return str;
}
function $26ebed30afc43a11$export$59f1d5f66ae7e219(style_attribute, style_directive) {
    const style_object = {};
    for (const individual_style of style_attribute.split(";")){
        const colon_index = individual_style.indexOf(":");
        const name = individual_style.slice(0, colon_index).trim();
        const value = individual_style.slice(colon_index + 1).trim();
        if (!name) continue;
        style_object[name] = value;
    }
    for(const name in style_directive){
        const value = style_directive[name];
        if (value) style_object[name] = value;
        else delete style_object[name];
    }
    return style_object;
}
const $26ebed30afc43a11$var$ATTR_REGEX = /[&"]/g;
const $26ebed30afc43a11$var$CONTENT_REGEX = /[&<]/g;
/**
 * Note: this method is performance sensitive and has been optimized
 * https://github.com/sveltejs/svelte/pull/5701
 */ function $26ebed30afc43a11$export$4e7f196112fea3c5(value, is_attr = false) {
    const str = String(value);
    const pattern = is_attr ? $26ebed30afc43a11$var$ATTR_REGEX : $26ebed30afc43a11$var$CONTENT_REGEX;
    pattern.lastIndex = 0;
    let escaped = "";
    let last = 0;
    while(pattern.test(str)){
        const i = pattern.lastIndex - 1;
        const ch = str[i];
        escaped += str.substring(last, i) + (ch === "&" ? "&amp;" : ch === '"' ? "&quot;" : "&lt;");
        last = i + 1;
    }
    return escaped + str.substring(last);
}
function $26ebed30afc43a11$export$7997b567c4bb0bed(value) {
    // keep booleans, null, and undefined for the sake of `spread`
    const should_escape = typeof value === "string" || value && typeof value === "object";
    return should_escape ? $26ebed30afc43a11$export$4e7f196112fea3c5(value, true) : value;
}
function $26ebed30afc43a11$export$9a9efab655aeaa3(obj) {
    const result = {};
    for(const key in obj)result[key] = $26ebed30afc43a11$export$7997b567c4bb0bed(obj[key]);
    return result;
}
function $26ebed30afc43a11$export$79b2f7037acddd43(items, fn) {
    let str = "";
    for(let i = 0; i < items.length; i += 1)str += fn(items[i], i);
    return str;
}
const $26ebed30afc43a11$export$84983a965b218545 = {
    $$render: ()=>""
};
function $26ebed30afc43a11$export$930da2a45a215472(component, name) {
    if (!component || !component.$$render) {
        if (name === "svelte:component") name += " this={...}";
        throw new Error(`<${name}> is not a valid SSR component. You may need to review your build config to ensure that dependencies are compiled, rather than imported as pre-compiled modules. Otherwise you may need to fix a <${name}>.`);
    }
    return component;
}
function $26ebed30afc43a11$export$1c9f709888824e05(file, line, column, values) {
    console.log(`{@debug} ${file ? file + " " : ""}(${line}:${column})`); // eslint-disable-line no-console
    console.log(values); // eslint-disable-line no-console
    return "";
}
let $26ebed30afc43a11$var$on_destroy;
function $26ebed30afc43a11$export$caab6e78cc1ff033(fn) {
    function $$render(result, props, bindings, slots, context) {
        const parent_component = $26ebed30afc43a11$export$3ec7acbf47bb7c71;
        const $$ = {
            on_destroy: $26ebed30afc43a11$var$on_destroy,
            context: new Map(context || (parent_component ? parent_component.$$.context : [])),
            // these will be immediately discarded
            on_mount: [],
            before_update: [],
            after_update: [],
            callbacks: $26ebed30afc43a11$export$31092919e374e43c()
        };
        $26ebed30afc43a11$export$e72a4c53a1d11dfc({
            $$: $$
        });
        const html = fn(result, props, bindings, slots);
        $26ebed30afc43a11$export$e72a4c53a1d11dfc(parent_component);
        return html;
    }
    return {
        render: (props = {}, { $$slots: $$slots = {}, context: context = new Map() } = {})=>{
            $26ebed30afc43a11$var$on_destroy = [];
            const result = {
                title: "",
                head: "",
                css: new Set()
            };
            const html = $$render(result, props, {}, $$slots, context);
            $26ebed30afc43a11$export$3f1fcd837f99a9ab($26ebed30afc43a11$var$on_destroy);
            return {
                html: html,
                css: {
                    code: Array.from(result.css).map((css)=>css.code).join("\n"),
                    map: null // TODO
                },
                head: result.title + result.head
            };
        },
        $$render: $$render
    };
}
function $26ebed30afc43a11$export$b442e23403500748(name, value, boolean) {
    if (value == null || boolean && !value) return "";
    const assignment = boolean && value === true ? "" : `="${$26ebed30afc43a11$export$4e7f196112fea3c5(value, true)}"`;
    return ` ${name}${assignment}`;
}
function $26ebed30afc43a11$export$b377786ff5e86c4c(classes) {
    return classes ? ` class="${classes}"` : "";
}
function $26ebed30afc43a11$var$style_object_to_string(style_object) {
    return Object.keys(style_object).filter((key)=>style_object[key]).map((key)=>`${key}: ${$26ebed30afc43a11$export$7997b567c4bb0bed(style_object[key])};`).join(" ");
}
function $26ebed30afc43a11$export$97f189f545ba14e6(style_object) {
    const styles = $26ebed30afc43a11$var$style_object_to_string(style_object);
    return styles ? ` style="${styles}"` : "";
}
function $26ebed30afc43a11$export$2385a24977818dd0(component, name, callback) {
    const index = component.$$.props[name];
    if (index !== undefined) {
        component.$$.bound[index] = callback;
        callback(component.$$.ctx[index]);
    }
}
function $26ebed30afc43a11$export$3dac9ce53bfc6012(block) {
    block && block.c();
}
function $26ebed30afc43a11$export$a73b5a5296efe9fc(block, parent_nodes) {
    block && block.l(parent_nodes);
}
function $26ebed30afc43a11$export$18b26e9aca35251(component, target, anchor, customElement) {
    const { fragment: fragment, after_update: after_update } = component.$$;
    fragment && fragment.m(target, anchor);
    if (!customElement) // onMount happens before the initial afterUpdate
    $26ebed30afc43a11$export$8851747095d022df(()=>{
        const new_on_destroy = component.$$.on_mount.map($26ebed30afc43a11$export$889ea624f2cb2c57).filter($26ebed30afc43a11$export$b451353ebd749597);
        // if the component was destroyed immediately
        // it will update the `$$.on_destroy` reference to `null`.
        // the destructured on_destroy may still reference to the old array
        if (component.$$.on_destroy) component.$$.on_destroy.push(...new_on_destroy);
        else // Edge case - component was destroyed immediately,
        // most likely as a result of a binding initialising
        $26ebed30afc43a11$export$3f1fcd837f99a9ab(new_on_destroy);
        component.$$.on_mount = [];
    });
    after_update.forEach($26ebed30afc43a11$export$8851747095d022df);
}
function $26ebed30afc43a11$export$ddd2890b29e5aebe(component, detaching) {
    const $$ = component.$$;
    if ($$.fragment !== null) {
        $26ebed30afc43a11$export$99d0f1b00233da03($$.after_update);
        $26ebed30afc43a11$export$3f1fcd837f99a9ab($$.on_destroy);
        $$.fragment && $$.fragment.d(detaching);
        // TODO null out other refs, including component.$$ (but need to
        // preserve final state?)
        $$.on_destroy = $$.fragment = null;
        $$.ctx = [];
    }
}
function $26ebed30afc43a11$var$make_dirty(component, i) {
    if (component.$$.dirty[0] === -1) {
        $26ebed30afc43a11$export$befe60e985bb3cce.push(component);
        $26ebed30afc43a11$export$c3d55cc721051d24();
        component.$$.dirty.fill(0);
    }
    component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}
function $26ebed30afc43a11$export$2cd8252107eb640b(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [
    -1
]) {
    const parent_component = $26ebed30afc43a11$export$3ec7acbf47bb7c71;
    $26ebed30afc43a11$export$e72a4c53a1d11dfc(component);
    const $$ = component.$$ = {
        fragment: null,
        ctx: [],
        props: // state
        props,
        update: $26ebed30afc43a11$export$8793edee2d425525,
        not_equal: not_equal,
        bound: $26ebed30afc43a11$export$31092919e374e43c(),
        // lifecycle
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
        // everything else
        callbacks: $26ebed30afc43a11$export$31092919e374e43c(),
        dirty: dirty,
        skip_bound: false,
        root: options.target || parent_component.$$.root
    };
    append_styles && append_styles($$.root);
    let ready = false;
    $$.ctx = instance ? instance(component, options.props || {}, (i, ret, ...rest)=>{
        const value = rest.length ? rest[0] : ret;
        if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
            if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
            if (ready) $26ebed30afc43a11$var$make_dirty(component, i);
        }
        return ret;
    }) : [];
    $$.update();
    ready = true;
    $26ebed30afc43a11$export$3f1fcd837f99a9ab($$.before_update);
    // `false` as a special case of no DOM component
    $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
    if (options.target) {
        if (options.hydrate) {
            $26ebed30afc43a11$export$237ef195d41ae60c();
            const nodes = $26ebed30afc43a11$export$bacb5cc5a11aef16(options.target);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $$.fragment && $$.fragment.l(nodes);
            nodes.forEach($26ebed30afc43a11$export$3f780019ff766da6);
        } else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $$.fragment && $$.fragment.c();
        if (options.intro) $26ebed30afc43a11$export$9e951caa2db2b1da(component.$$.fragment);
        $26ebed30afc43a11$export$18b26e9aca35251(component, options.target, options.anchor, options.customElement);
        $26ebed30afc43a11$export$4b42d81e6a3b0cd2();
        $26ebed30afc43a11$export$4909b86c8034bf73();
    }
    $26ebed30afc43a11$export$e72a4c53a1d11dfc(parent_component);
}
let $26ebed30afc43a11$export$1add084de80b788;
if (typeof HTMLElement === "function") $26ebed30afc43a11$export$1add084de80b788 = class extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        const { on_mount: on_mount } = this.$$;
        this.$$.on_disconnect = on_mount.map($26ebed30afc43a11$export$889ea624f2cb2c57).filter($26ebed30afc43a11$export$b451353ebd749597);
        // @ts-ignore todo: improve typings
        for(const key in this.$$.slotted)// @ts-ignore todo: improve typings
        this.appendChild(this.$$.slotted[key]);
    }
    attributeChangedCallback(attr, _oldValue, newValue) {
        this[attr] = newValue;
    }
    disconnectedCallback() {
        $26ebed30afc43a11$export$3f1fcd837f99a9ab(this.$$.on_disconnect);
    }
    $destroy() {
        $26ebed30afc43a11$export$ddd2890b29e5aebe(this, 1);
        this.$destroy = $26ebed30afc43a11$export$8793edee2d425525;
    }
    $on(type, callback) {
        // TODO should this delegate to addEventListener?
        if (!$26ebed30afc43a11$export$b451353ebd749597(callback)) return $26ebed30afc43a11$export$8793edee2d425525;
        const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return ()=>{
            const index = callbacks.indexOf(callback);
            if (index !== -1) callbacks.splice(index, 1);
        };
    }
    $set($$props) {
        if (this.$$set && !$26ebed30afc43a11$export$cc2e736493e359e2($$props)) {
            this.$$.skip_bound = true;
            this.$$set($$props);
            this.$$.skip_bound = false;
        }
    }
};
/**
 * Base class for Svelte components. Used when dev=false.
 */ class $26ebed30afc43a11$export$a9dbe146ce5e8823 {
    $destroy() {
        $26ebed30afc43a11$export$ddd2890b29e5aebe(this, 1);
        this.$destroy = $26ebed30afc43a11$export$8793edee2d425525;
    }
    $on(type, callback) {
        if (!$26ebed30afc43a11$export$b451353ebd749597(callback)) return $26ebed30afc43a11$export$8793edee2d425525;
        const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return ()=>{
            const index = callbacks.indexOf(callback);
            if (index !== -1) callbacks.splice(index, 1);
        };
    }
    $set($$props) {
        if (this.$$set && !$26ebed30afc43a11$export$cc2e736493e359e2($$props)) {
            this.$$.skip_bound = true;
            this.$$set($$props);
            this.$$.skip_bound = false;
        }
    }
}
function $26ebed30afc43a11$export$bf18b7db1b422af6(type, detail) {
    document.dispatchEvent($26ebed30afc43a11$export$da00493480283d6b(type, Object.assign({
        version: "3.59.2"
    }, detail), {
        bubbles: true
    }));
}
function $26ebed30afc43a11$export$e914ea5e9eb9f312(target, node) {
    $26ebed30afc43a11$export$bf18b7db1b422af6("SvelteDOMInsert", {
        target: target,
        node: node
    });
    $26ebed30afc43a11$export$10d8903dec122b9d(target, node);
}
function $26ebed30afc43a11$export$3d7d958f073d996a(target, node) {
    $26ebed30afc43a11$export$bf18b7db1b422af6("SvelteDOMInsert", {
        target: target,
        node: node
    });
    $26ebed30afc43a11$export$172bc581f7520fb7(target, node);
}
function $26ebed30afc43a11$export$f6e687e9f4e253bb(target, node, anchor) {
    $26ebed30afc43a11$export$bf18b7db1b422af6("SvelteDOMInsert", {
        target: target,
        node: node,
        anchor: anchor
    });
    $26ebed30afc43a11$export$21a5ca8aa77d35ff(target, node, anchor);
}
function $26ebed30afc43a11$export$b7da215dbd2db801(target, node, anchor) {
    $26ebed30afc43a11$export$bf18b7db1b422af6("SvelteDOMInsert", {
        target: target,
        node: node,
        anchor: anchor
    });
    $26ebed30afc43a11$export$f7a8880e5fbca7f8(target, node, anchor);
}
function $26ebed30afc43a11$export$9e710e34d240cc7b(node) {
    $26ebed30afc43a11$export$bf18b7db1b422af6("SvelteDOMRemove", {
        node: node
    });
    $26ebed30afc43a11$export$3f780019ff766da6(node);
}
function $26ebed30afc43a11$export$a21682f9877e0498(before, after) {
    while(before.nextSibling && before.nextSibling !== after)$26ebed30afc43a11$export$9e710e34d240cc7b(before.nextSibling);
}
function $26ebed30afc43a11$export$75f8da77d42fcb5(after) {
    while(after.previousSibling)$26ebed30afc43a11$export$9e710e34d240cc7b(after.previousSibling);
}
function $26ebed30afc43a11$export$c97ff19765ca3394(before) {
    while(before.nextSibling)$26ebed30afc43a11$export$9e710e34d240cc7b(before.nextSibling);
}
function $26ebed30afc43a11$export$995228cbf38b380f(node, event, handler, options, has_prevent_default, has_stop_propagation, has_stop_immediate_propagation) {
    const modifiers = options === true ? [
        "capture"
    ] : options ? Array.from(Object.keys(options)) : [];
    if (has_prevent_default) modifiers.push("preventDefault");
    if (has_stop_propagation) modifiers.push("stopPropagation");
    if (has_stop_immediate_propagation) modifiers.push("stopImmediatePropagation");
    $26ebed30afc43a11$export$bf18b7db1b422af6("SvelteDOMAddEventListener", {
        node: node,
        event: event,
        handler: handler,
        modifiers: modifiers
    });
    const dispose = $26ebed30afc43a11$export$63174c828edd6ff8(node, event, handler, options);
    return ()=>{
        $26ebed30afc43a11$export$bf18b7db1b422af6("SvelteDOMRemoveEventListener", {
            node: node,
            event: event,
            handler: handler,
            modifiers: modifiers
        });
        dispose();
    };
}
function $26ebed30afc43a11$export$a99ae29e763a6619(node, attribute, value) {
    $26ebed30afc43a11$export$7aabe8b3a840d2fd(node, attribute, value);
    if (value == null) $26ebed30afc43a11$export$bf18b7db1b422af6("SvelteDOMRemoveAttribute", {
        node: node,
        attribute: attribute
    });
    else $26ebed30afc43a11$export$bf18b7db1b422af6("SvelteDOMSetAttribute", {
        node: node,
        attribute: attribute,
        value: value
    });
}
function $26ebed30afc43a11$export$1a8b8000a5a2f955(node, property, value) {
    node[property] = value;
    $26ebed30afc43a11$export$bf18b7db1b422af6("SvelteDOMSetProperty", {
        node: node,
        property: property,
        value: value
    });
}
function $26ebed30afc43a11$export$9bdcf8c0c1039da5(node, property, value) {
    node.dataset[property] = value;
    $26ebed30afc43a11$export$bf18b7db1b422af6("SvelteDOMSetDataset", {
        node: node,
        property: property,
        value: value
    });
}
function $26ebed30afc43a11$export$df702e4649e15993(text, data) {
    data = "" + data;
    if (text.data === data) return;
    $26ebed30afc43a11$export$bf18b7db1b422af6("SvelteDOMSetData", {
        node: text,
        data: data
    });
    text.data = data;
}
function $26ebed30afc43a11$export$3eb5e573cac73e07(text, data) {
    data = "" + data;
    if (text.wholeText === data) return;
    $26ebed30afc43a11$export$bf18b7db1b422af6("SvelteDOMSetData", {
        node: text,
        data: data
    });
    text.data = data;
}
function $26ebed30afc43a11$export$3e6e8a2bfe41f53c(text, data, attr_value) {
    if (~$26ebed30afc43a11$export$e3d839ffa95f7481.indexOf(attr_value)) $26ebed30afc43a11$export$3eb5e573cac73e07(text, data);
    else $26ebed30afc43a11$export$df702e4649e15993(text, data);
}
function $26ebed30afc43a11$export$dc082ae212b9df(arg) {
    if (typeof arg !== "string" && !(arg && typeof arg === "object" && "length" in arg)) {
        let msg = "{#each} only iterates over array-like objects.";
        if (typeof Symbol === "function" && arg && Symbol.iterator in arg) msg += " You can use a spread to convert this iterable into an array.";
        throw new Error(msg);
    }
}
function $26ebed30afc43a11$export$d0e654d7c8c8b385(name, slot, keys) {
    for (const slot_key of Object.keys(slot))if (!~keys.indexOf(slot_key)) console.warn(`<${name}> received an unexpected slot "${slot_key}".`);
}
function $26ebed30afc43a11$export$3bfb1dac7720acdf(tag) {
    const is_string = typeof tag === "string";
    if (tag && !is_string) throw new Error('<svelte:element> expects "this" attribute to be a string.');
}
function $26ebed30afc43a11$export$604f774bac268e5a(tag) {
    if (tag && $26ebed30afc43a11$export$66cf70365c175aee(tag)) console.warn(`<svelte:element this="${tag}"> is self-closing and cannot have content.`);
}
function $26ebed30afc43a11$export$12b4fecd7d9ee1e9(component, props) {
    const error_message = "this={...} of <svelte:component> should specify a Svelte component.";
    try {
        const instance = new component(props);
        if (!instance.$$ || !instance.$set || !instance.$on || !instance.$destroy) throw new Error(error_message);
        return instance;
    } catch (err) {
        const { message: message } = err;
        if (typeof message === "string" && message.indexOf("is not a constructor") !== -1) throw new Error(error_message);
        else throw err;
    }
}
/**
 * Base class for Svelte components with some minor dev-enhancements. Used when dev=true.
 */ class $26ebed30afc43a11$export$5a58a898d1ca0447 extends $26ebed30afc43a11$export$a9dbe146ce5e8823 {
    constructor(options){
        if (!options || !options.target && !options.$$inline) throw new Error("'target' is a required option");
        super();
    }
    $destroy() {
        super.$destroy();
        this.$destroy = ()=>{
            console.warn("Component was already destroyed"); // eslint-disable-line no-console
        };
    }
    $capture_state() {}
    $inject_state() {}
}
/**
 * Base class to create strongly typed Svelte components.
 * This only exists for typing purposes and should be used in `.d.ts` files.
 *
 * ### Example:
 *
 * You have component library on npm called `component-library`, from which
 * you export a component called `MyComponent`. For Svelte+TypeScript users,
 * you want to provide typings. Therefore you create a `index.d.ts`:
 * ```ts
 * import { SvelteComponentTyped } from "svelte";
 * export class MyComponent extends SvelteComponentTyped<{foo: string}> {}
 * ```
 * Typing this makes it possible for IDEs like VS Code with the Svelte extension
 * to provide intellisense and to use the component like this in a Svelte file
 * with TypeScript:
 * ```svelte
 * <script lang="ts">
 * 	import { MyComponent } from "component-library";
 * </script>
 * <MyComponent foo={'bar'} />
 * ```
 *
 * #### Why not make this part of `SvelteComponent(Dev)`?
 * Because
 * ```ts
 * class ASubclassOfSvelteComponent extends SvelteComponent<{foo: string}> {}
 * const component: typeof SvelteComponent = ASubclassOfSvelteComponent;
 * ```
 * will throw a type error, so we need to separate the more strictly typed class.
 */ class $26ebed30afc43a11$export$3364bb23ce325405 extends $26ebed30afc43a11$export$5a58a898d1ca0447 {
    constructor(options){
        super(options);
    }
}
function $26ebed30afc43a11$export$3fad216b09e0538b(timeout) {
    const start = Date.now();
    return ()=>{
        if (Date.now() - start > timeout) throw new Error("Infinite loop detected");
    };
}

});


parcelRegister("bc5yV", function(module, exports) {
"use strict";
var $82652140c2d744c1$var$isMergeableObject = function isMergeableObject(value) {
    return $82652140c2d744c1$var$isNonNullObject(value) && !$82652140c2d744c1$var$isSpecial(value);
};
function $82652140c2d744c1$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $82652140c2d744c1$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $82652140c2d744c1$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $82652140c2d744c1$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $82652140c2d744c1$var$REACT_ELEMENT_TYPE = $82652140c2d744c1$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $82652140c2d744c1$var$isReactElement(value) {
    return value.$$typeof === $82652140c2d744c1$var$REACT_ELEMENT_TYPE;
}
function $82652140c2d744c1$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $82652140c2d744c1$var$deepmerge($82652140c2d744c1$var$emptyTarget(value), value, options) : value;
}
function $82652140c2d744c1$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $82652140c2d744c1$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $82652140c2d744c1$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $82652140c2d744c1$var$deepmerge;
}
function $82652140c2d744c1$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $82652140c2d744c1$var$getKeys(target) {
    return Object.keys(target).concat($82652140c2d744c1$var$getEnumerableOwnPropertySymbols(target));
}
function $82652140c2d744c1$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $82652140c2d744c1$var$propertyIsUnsafe(target, key) {
    return $82652140c2d744c1$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $82652140c2d744c1$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $82652140c2d744c1$var$getKeys(target).forEach(function(key) {
        destination[key] = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $82652140c2d744c1$var$getKeys(source).forEach(function(key) {
        if ($82652140c2d744c1$var$propertyIsUnsafe(target, key)) return;
        if ($82652140c2d744c1$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $82652140c2d744c1$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $82652140c2d744c1$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $82652140c2d744c1$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $82652140c2d744c1$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $82652140c2d744c1$var$mergeObject(target, source, options);
}
$82652140c2d744c1$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $82652140c2d744c1$var$deepmerge(prev, next, options);
    }, {});
};
var $82652140c2d744c1$var$deepmerge_1 = $82652140c2d744c1$var$deepmerge;
module.exports = $82652140c2d744c1$var$deepmerge_1;

});

parcelRegister("8KDXU", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", () => $65f19ee2190344e6$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $7WQrb = parcelRequire("7WQrb");

var $fFbHU = parcelRequire("fFbHU");

var $cimWX = parcelRequire("cimWX");

var $eoUSZ = parcelRequire("eoUSZ");
// -- MessageFormat --------------------------------------------------------
function $65f19ee2190344e6$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $65f19ee2190344e6$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $65f19ee2190344e6$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $7WQrb.__assign)({}, defaultConfig));
}
function $65f19ee2190344e6$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $65f19ee2190344e6$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $cimWX.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $7WQrb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.number),
            strategy: (0, $cimWX.strategies).variadic
        }),
        getDateTimeFormat: (0, $cimWX.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $7WQrb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $cimWX.strategies).variadic
        }),
        getPluralRules: (0, $cimWX.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $7WQrb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $cimWX.strategies).variadic
        })
    };
}
var $65f19ee2190344e6$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $eoUSZ.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $eoUSZ.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $65f19ee2190344e6$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $65f19ee2190344e6$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $fFbHU.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $5c96a02c592fcff1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $5c96a02c592fcff1$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $5c96a02c592fcff1$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $5c96a02c592fcff1$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
$parcel$export(module.exports, "__await", () => $5c96a02c592fcff1$export$10c90e4f7922046c);
$parcel$export(module.exports, "__asyncGenerator", () => $5c96a02c592fcff1$export$e427f37a30a4de9b);
$parcel$export(module.exports, "__asyncValues", () => $5c96a02c592fcff1$export$e3b29a3d6162315f);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};

});

parcelRegister("fFbHU", function(module, exports) {
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("jLdHn")).isLiteralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("jLdHn")).isPoundElement);
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("jLdHn")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("jLdHn")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("jLdHn")).isDateTimeSkeleton);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("jLdHn")).isTimeElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("jLdHn")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("jLdHn")).isNumberSkeleton);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("jLdHn")).isTagElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("jLdHn")).isSelectElement);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("jLdHn")).isPluralElement);

$parcel$export(module.exports, "parse", () => $b673c42291cd7fb6$export$98e6a39c04603d36);

var $7WQrb = parcelRequire("7WQrb");

var $6z8Hv = parcelRequire("6z8Hv");

var $8jO5A = parcelRequire("8jO5A");

var $jLdHn = parcelRequire("jLdHn");
function $b673c42291cd7fb6$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $jLdHn.isSelectElement)(el) || (0, $jLdHn.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $b673c42291cd7fb6$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $jLdHn.isNumberElement)(el) && (0, $jLdHn.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $jLdHn.isDateElement)(el) || (0, $jLdHn.isTimeElement)(el)) && (0, $jLdHn.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $jLdHn.isTagElement)(el)) $b673c42291cd7fb6$var$pruneLocation(el.children);
    });
}
function $b673c42291cd7fb6$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $7WQrb.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $8jO5A.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $6z8Hv.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $b673c42291cd7fb6$var$pruneLocation(result.val);
    return result.val;
}

});
parcelRegister("6z8Hv", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", () => $4c7cc2bf81666647$export$896afd8541959ee5);
var $4c7cc2bf81666647$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($4c7cc2bf81666647$export$896afd8541959ee5 || ($4c7cc2bf81666647$export$896afd8541959ee5 = {}));

});

parcelRegister("8jO5A", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $60e6f3ba709db920$export$7acfa6ed01010e37);

var $7WQrb = parcelRequire("7WQrb");

var $6z8Hv = parcelRequire("6z8Hv");

var $jLdHn = parcelRequire("jLdHn");

var $bTwG4 = parcelRequire("bTwG4");
parcelRequire("1TlWL");
var $JriS2 = parcelRequire("JriS2");
var $8YjFP = parcelRequire("8YjFP");

var $2V8Zg = parcelRequire("2V8Zg");
var $60e6f3ba709db920$var$_a;
var $60e6f3ba709db920$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $bTwG4.SPACE_SEPARATOR_REGEX).source, "*"));
var $60e6f3ba709db920$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $bTwG4.SPACE_SEPARATOR_REGEX).source, "*$"));
function $60e6f3ba709db920$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $60e6f3ba709db920$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $60e6f3ba709db920$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $60e6f3ba709db920$var$hasNativeFromEntries = !!Object.fromEntries;
var $60e6f3ba709db920$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $60e6f3ba709db920$var$hasTrimStart = !!String.prototype.trimStart;
var $60e6f3ba709db920$var$hasTrimEnd = !!String.prototype.trimEnd;
var $60e6f3ba709db920$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $60e6f3ba709db920$var$isSafeInteger = $60e6f3ba709db920$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $60e6f3ba709db920$var$re = $60e6f3ba709db920$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y = (($60e6f3ba709db920$var$_a = $60e6f3ba709db920$var$re.exec("a")) === null || $60e6f3ba709db920$var$_a === void 0 ? void 0 : $60e6f3ba709db920$var$_a[0]) === "a";
} catch (_) {
    $60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $60e6f3ba709db920$var$startsWith = $60e6f3ba709db920$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $60e6f3ba709db920$var$fromCodePoint = $60e6f3ba709db920$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $60e6f3ba709db920$var$fromEntries = // native
$60e6f3ba709db920$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $60e6f3ba709db920$var$codePointAt = $60e6f3ba709db920$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $60e6f3ba709db920$var$trimStart = $60e6f3ba709db920$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($60e6f3ba709db920$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $60e6f3ba709db920$var$trimEnd = $60e6f3ba709db920$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($60e6f3ba709db920$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $60e6f3ba709db920$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $60e6f3ba709db920$var$matchIdentifierAtIndex;
if ($60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $60e6f3ba709db920$var$IDENTIFIER_PREFIX_RE_1 = $60e6f3ba709db920$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $60e6f3ba709db920$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $60e6f3ba709db920$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $60e6f3ba709db920$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$60e6f3ba709db920$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $60e6f3ba709db920$var$codePointAt(s, index);
        if (c === undefined || $60e6f3ba709db920$var$_isWhiteSpace(c) || $60e6f3ba709db920$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $60e6f3ba709db920$var$fromCodePoint.apply(void 0, match);
};
var $60e6f3ba709db920$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $jLdHn.TYPE).pound,
                    location: $60e6f3ba709db920$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $6z8Hv.ErrorKind).UNMATCHED_CLOSING_TAG, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $60e6f3ba709db920$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $jLdHn.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$60e6f3ba709db920$var$_isAlpha(this.char())) return this.error((0, $6z8Hv.ErrorKind).INVALID_TAG, $60e6f3ba709db920$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $6z8Hv.ErrorKind).UNMATCHED_CLOSING_TAG, $60e6f3ba709db920$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $6z8Hv.ErrorKind).INVALID_TAG, $60e6f3ba709db920$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $jLdHn.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $6z8Hv.ErrorKind).UNCLOSED_TAG, $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $6z8Hv.ErrorKind).INVALID_TAG, $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $60e6f3ba709db920$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $60e6f3ba709db920$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $jLdHn.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$60e6f3ba709db920$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $60e6f3ba709db920$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $60e6f3ba709db920$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $6z8Hv.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $6z8Hv.ErrorKind).EMPTY_ARGUMENT, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $6z8Hv.ErrorKind).MALFORMED_ARGUMENT, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $6z8Hv.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $jLdHn.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $6z8Hv.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $6z8Hv.ErrorKind).MALFORMED_ARGUMENT, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $60e6f3ba709db920$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $60e6f3ba709db920$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $6z8Hv.ErrorKind).EXPECT_ARGUMENT_TYPE, $60e6f3ba709db920$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $60e6f3ba709db920$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $6z8Hv.ErrorKind).EXPECT_ARGUMENT_STYLE, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $60e6f3ba709db920$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $60e6f3ba709db920$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $60e6f3ba709db920$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $jLdHn.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $6z8Hv.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $2V8Zg.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $jLdHn.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $JriS2.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $jLdHn.TYPE).date : (0, $jLdHn.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $jLdHn.TYPE).number : argType === "date" ? (0, $jLdHn.TYPE).date : (0, $jLdHn.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $6z8Hv.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $60e6f3ba709db920$var$createLocation(typeEndPosition_1, (0, $7WQrb.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $6z8Hv.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $6z8Hv.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $6z8Hv.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $jLdHn.TYPE).select,
                        value: value,
                        options: $60e6f3ba709db920$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $jLdHn.TYPE).plural,
                        value: value,
                        options: $60e6f3ba709db920$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $6z8Hv.ErrorKind).INVALID_ARGUMENT_TYPE, $60e6f3ba709db920$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $6z8Hv.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $6z8Hv.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $60e6f3ba709db920$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $8YjFP.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $6z8Hv.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $jLdHn.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $8YjFP.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $6z8Hv.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $6z8Hv.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $6z8Hv.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $6z8Hv.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $6z8Hv.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $6z8Hv.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $6z8Hv.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $6z8Hv.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $6z8Hv.ErrorKind).MISSING_OTHER_CLAUSE, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $60e6f3ba709db920$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$60e6f3ba709db920$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $60e6f3ba709db920$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($60e6f3ba709db920$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $60e6f3ba709db920$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $60e6f3ba709db920$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $60e6f3ba709db920$var$_isAlphaOrSlash(codepoint) {
    return $60e6f3ba709db920$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $60e6f3ba709db920$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $60e6f3ba709db920$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $60e6f3ba709db920$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("jLdHn", function(module, exports) {

$parcel$export(module.exports, "TYPE", () => $e62d085b79ea4606$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $e62d085b79ea4606$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $e62d085b79ea4606$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $e62d085b79ea4606$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $e62d085b79ea4606$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $e62d085b79ea4606$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $e62d085b79ea4606$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $e62d085b79ea4606$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $e62d085b79ea4606$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $e62d085b79ea4606$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $e62d085b79ea4606$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $e62d085b79ea4606$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $e62d085b79ea4606$export$7680c41f1a55f4cf);
var $e62d085b79ea4606$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($e62d085b79ea4606$export$b87f371cbc396fcf || ($e62d085b79ea4606$export$b87f371cbc396fcf = {}));
var $e62d085b79ea4606$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($e62d085b79ea4606$export$906452485466fa53 || ($e62d085b79ea4606$export$906452485466fa53 = {}));
function $e62d085b79ea4606$export$cfa10c5697238752(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.literal;
}
function $e62d085b79ea4606$export$4f55724281bdfaf9(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.argument;
}
function $e62d085b79ea4606$export$e11187b219e191e1(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.number;
}
function $e62d085b79ea4606$export$32d811605da75f40(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.date;
}
function $e62d085b79ea4606$export$34ec46f596b1702f(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.time;
}
function $e62d085b79ea4606$export$dcfe1c11d168b5a1(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.select;
}
function $e62d085b79ea4606$export$6c796d116f0a4fbc(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.plural;
}
function $e62d085b79ea4606$export$c0ece297bdd0c082(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.pound;
}
function $e62d085b79ea4606$export$5c83de34745812b(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.tag;
}
function $e62d085b79ea4606$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $e62d085b79ea4606$export$906452485466fa53.number);
}
function $e62d085b79ea4606$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $e62d085b79ea4606$export$906452485466fa53.dateTime);
}
function $e62d085b79ea4606$export$f0ac572c1121c662(value) {
    return {
        type: $e62d085b79ea4606$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $e62d085b79ea4606$export$425e864b0ba114f1(value, style) {
    return {
        type: $e62d085b79ea4606$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("bTwG4", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $8a8e2dd39f8c2b53$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $8a8e2dd39f8c2b53$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $8a8e2dd39f8c2b53$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("1TlWL", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("JriS2")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("8YjFP")).parseNumberSkeletonFromString);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("8YjFP")).parseNumberSkeleton);
parcelRequire("JriS2");
parcelRequire("8YjFP");

});
parcelRegister("JriS2", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", () => $088961f6a5934025$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $088961f6a5934025$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $088961f6a5934025$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($088961f6a5934025$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("8YjFP", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $68833020532266e2$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $68833020532266e2$export$47c6f8480bda3e11);

var $7WQrb = parcelRequire("7WQrb");

var $4SzKr = parcelRequire("4SzKr");
function $68833020532266e2$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $4SzKr.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $68833020532266e2$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $68833020532266e2$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $68833020532266e2$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $68833020532266e2$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $68833020532266e2$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $68833020532266e2$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($68833020532266e2$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $68833020532266e2$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $68833020532266e2$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$68833020532266e2$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $68833020532266e2$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $68833020532266e2$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $68833020532266e2$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $68833020532266e2$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, all), $68833020532266e2$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, all), $68833020532266e2$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($68833020532266e2$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($68833020532266e2$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($68833020532266e2$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($68833020532266e2$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), $68833020532266e2$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($68833020532266e2$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), $68833020532266e2$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $68833020532266e2$var$parseSign(token.stem);
        if (signOpts) result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $68833020532266e2$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("4SzKr", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $38d7ef65502c3cf1$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $38d7ef65502c3cf1$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("2V8Zg", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", () => $2207e049a5272320$export$29c5368be8904d27);

var $dawKT = parcelRequire("dawKT");
function $2207e049a5272320$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $2207e049a5272320$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $2207e049a5272320$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $dawKT.timeData)[regionTag || ""] || (0, $dawKT.timeData)[languageTag || ""] || (0, $dawKT.timeData)["".concat(languageTag, "-001")] || (0, $dawKT.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("dawKT", function(module, exports) {

$parcel$export(module.exports, "timeData", () => $99659e106fc3b209$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $99659e106fc3b209$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

});




parcelRegister("cimWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f38f7d77b1e84b6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "strategies", () => $8f38f7d77b1e84b6$export$c5491a8691a23b9e);
//
// Main
//
function $8f38f7d77b1e84b6$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $8f38f7d77b1e84b6$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $8f38f7d77b1e84b6$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $8f38f7d77b1e84b6$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $8f38f7d77b1e84b6$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $8f38f7d77b1e84b6$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $8f38f7d77b1e84b6$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8f38f7d77b1e84b6$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8f38f7d77b1e84b6$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $8f38f7d77b1e84b6$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $8f38f7d77b1e84b6$var$monadic : $8f38f7d77b1e84b6$var$variadic;
    return $8f38f7d77b1e84b6$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $8f38f7d77b1e84b6$var$strategyVariadic(fn, options) {
    return $8f38f7d77b1e84b6$var$assemble(fn, this, $8f38f7d77b1e84b6$var$variadic, options.cache.create(), options.serializer);
}
function $8f38f7d77b1e84b6$var$strategyMonadic(fn, options) {
    return $8f38f7d77b1e84b6$var$assemble(fn, this, $8f38f7d77b1e84b6$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $8f38f7d77b1e84b6$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $8f38f7d77b1e84b6$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache();
    }
};
var $8f38f7d77b1e84b6$export$c5491a8691a23b9e = {
    variadic: $8f38f7d77b1e84b6$var$strategyVariadic,
    monadic: $8f38f7d77b1e84b6$var$strategyMonadic
};

});

parcelRegister("eoUSZ", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", () => $a7bf6eec6df43b65$export$49694c2877b44c57);
$parcel$export(module.exports, "formatToParts", () => $a7bf6eec6df43b65$export$275d4a3bb5f66fda);
parcelRequire("fFbHU");
var $jLdHn = parcelRequire("jLdHn");

var $fm6Ot = parcelRequire("fm6Ot");
var $a7bf6eec6df43b65$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($a7bf6eec6df43b65$export$49694c2877b44c57 || ($a7bf6eec6df43b65$export$49694c2877b44c57 = {}));
function $a7bf6eec6df43b65$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $a7bf6eec6df43b65$export$49694c2877b44c57.literal || part.type !== $a7bf6eec6df43b65$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $a7bf6eec6df43b65$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $a7bf6eec6df43b65$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $jLdHn.isLiteralElement)(els[0])) return [
        {
            type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $jLdHn.isLiteralElement)(el)) {
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $jLdHn.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $fm6Ot.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $jLdHn.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $a7bf6eec6df43b65$export$49694c2877b44c57.literal : $a7bf6eec6df43b65$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $jLdHn.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $jLdHn.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLdHn.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $jLdHn.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLdHn.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $jLdHn.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLdHn.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$a7bf6eec6df43b65$export$df0c12a2d414a163(formatFn)) throw new (0, $fm6Ot.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $a7bf6eec6df43b65$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $a7bf6eec6df43b65$export$49694c2877b44c57.literal : $a7bf6eec6df43b65$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $jLdHn.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $fm6Ot.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $a7bf6eec6df43b65$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $jLdHn.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $fm6Ot.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $fm6Ot.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $fm6Ot.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $a7bf6eec6df43b65$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $a7bf6eec6df43b65$var$mergeLiteral(result);
}

});
parcelRegister("fm6Ot", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", () => $b2de32051be1701b$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $b2de32051be1701b$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $b2de32051be1701b$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $b2de32051be1701b$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $b2de32051be1701b$export$8bfc137e4d23fdf0);

var $7WQrb = parcelRequire("7WQrb");
var $b2de32051be1701b$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($b2de32051be1701b$export$d4e71bc0b80dc0fb || ($b2de32051be1701b$export$d4e71bc0b80dc0fb = {}));
var $b2de32051be1701b$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $b2de32051be1701b$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $b2de32051be1701b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($b2de32051be1701b$export$7369836851cc1329);
var $b2de32051be1701b$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $b2de32051be1701b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($b2de32051be1701b$export$7369836851cc1329);
var $b2de32051be1701b$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $b2de32051be1701b$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($b2de32051be1701b$export$7369836851cc1329);

});




parcelRegister("kBJxW", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $f00a97eed1786a48$export$ac4959f4f1338dfc);

let $f00a97eed1786a48$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $f00a97eed1786a48$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $f00a97eed1786a48$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$f00a97eed1786a48$export$a5cee9e955a615e5(alphabet, size, $f00a97eed1786a48$export$4385e60b38654f68);
let $f00a97eed1786a48$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");

});

parcelRegister("kmsNQ", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(self, ()=>{
    var e, t;
    return e = {
        7629: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(9474), i = r(1687), o = r(8652), l = r(8160), c = r(3292), u = r(6354), f = r(8901), h = r(9708), m = r(6914), d = r(2294), p = r(6133), g = r(1152), y = r(8863), b = r(2036), v = {
                Base: class {
                    constructor(e){
                        this.type = e, this.$_root = null, this._definition = {}, this._reset();
                    }
                    _reset() {
                        this._ids = new d.Ids, this._preferences = null, this._refs = new p.Manager, this._cache = null, this._valids = null, this._invalids = null, this._flags = {}, this._rules = [], this._singleRules = new Map, this.$_terms = {}, this.$_temp = {
                            ruleset: null,
                            whens: {}
                        };
                    }
                    describe() {
                        return s("function" == typeof h.describe, "Manifest functionality disabled"), h.describe(this);
                    }
                    allow() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        return l.verifyFlat(t, "allow"), this._values(t, "_valids");
                    }
                    alter(e) {
                        s(e && "object" == typeof e && !Array.isArray(e), "Invalid targets argument"), s(!this._inRuleset(), "Cannot set alterations inside a ruleset");
                        const t = this.clone();
                        t.$_terms.alterations = t.$_terms.alterations || [];
                        for(const r in e){
                            const n = e[r];
                            s("function" == typeof n, "Alteration adjuster for", r, "must be a function"), t.$_terms.alterations.push({
                                target: r,
                                adjuster: n
                            });
                        }
                        return t.$_temp.ruleset = !1, t;
                    }
                    artifact(e) {
                        return s(void 0 !== e, "Artifact cannot be undefined"), s(!this._cache, "Cannot set an artifact with a rule cache"), this.$_setFlag("artifact", e);
                    }
                    cast(e) {
                        return s(!1 === e || "string" == typeof e, "Invalid to value"), s(!1 === e || this._definition.cast[e], "Type", this.type, "does not support casting to", e), this.$_setFlag("cast", !1 === e ? void 0 : e);
                    }
                    default(e, t) {
                        return this._default("default", e, t);
                    }
                    description(e) {
                        return s(e && "string" == typeof e, "Description must be a non-empty string"), this.$_setFlag("description", e);
                    }
                    empty(e) {
                        const t = this.clone();
                        return void 0 !== e && (e = t.$_compile(e, {
                            override: !1
                        })), t.$_setFlag("empty", e, {
                            clone: !1
                        });
                    }
                    error(e) {
                        return s(e, "Missing error"), s(e instanceof Error || "function" == typeof e, "Must provide a valid Error object or a function"), this.$_setFlag("error", e);
                    }
                    example(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return s(void 0 !== e, "Missing example"), l.assertOptions(t, [
                            "override"
                        ]), this._inner("examples", e, {
                            single: !0,
                            override: t.override
                        });
                    }
                    external(e, t) {
                        return "object" == typeof e && (s(!t, "Cannot combine options with description"), t = e.description, e = e.method), s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this._inner("externals", {
                            method: e,
                            description: t
                        }, {
                            single: !0
                        });
                    }
                    failover(e, t) {
                        return this._default("failover", e, t);
                    }
                    forbidden() {
                        return this.presence("forbidden");
                    }
                    id(e) {
                        return e ? (s("string" == typeof e, "id must be a non-empty string"), s(/^[^\.]+$/.test(e), "id cannot contain period character"), this.$_setFlag("id", e)) : this.$_setFlag("id", void 0);
                    }
                    invalid() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        return this._values(t, "_invalids");
                    }
                    label(e) {
                        return s(e && "string" == typeof e, "Label name must be a non-empty string"), this.$_setFlag("label", e);
                    }
                    meta(e) {
                        return s(void 0 !== e, "Meta cannot be undefined"), this._inner("metas", e, {
                            single: !0
                        });
                    }
                    note() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        s(t.length, "Missing notes");
                        for (const e of t)s(e && "string" == typeof e, "Notes must be non-empty strings");
                        return this._inner("notes", t);
                    }
                    only() {
                        let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                        return s("boolean" == typeof e, "Invalid mode:", e), this.$_setFlag("only", e);
                    }
                    optional() {
                        return this.presence("optional");
                    }
                    prefs(e) {
                        s(e, "Missing preferences"), s(void 0 === e.context, "Cannot override context"), s(void 0 === e.externals, "Cannot override externals"), s(void 0 === e.warnings, "Cannot override warnings"), s(void 0 === e.debug, "Cannot override debug"), l.checkPreferences(e);
                        const t = this.clone();
                        return t._preferences = l.preferences(t._preferences, e), t;
                    }
                    presence(e) {
                        return s([
                            "optional",
                            "required",
                            "forbidden"
                        ].includes(e), "Unknown presence mode", e), this.$_setFlag("presence", e);
                    }
                    raw() {
                        let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                        return this.$_setFlag("result", e ? "raw" : void 0);
                    }
                    result(e) {
                        return s([
                            "raw",
                            "strip"
                        ].includes(e), "Unknown result mode", e), this.$_setFlag("result", e);
                    }
                    required() {
                        return this.presence("required");
                    }
                    strict(e) {
                        const t = this.clone(), r = void 0 !== e && !e;
                        return t._preferences = l.preferences(t._preferences, {
                            convert: r
                        }), t;
                    }
                    strip() {
                        let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                        return this.$_setFlag("result", e ? "strip" : void 0);
                    }
                    tag() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        s(t.length, "Missing tags");
                        for (const e of t)s(e && "string" == typeof e, "Tags must be non-empty strings");
                        return this._inner("tags", t);
                    }
                    unit(e) {
                        return s(e && "string" == typeof e, "Unit name must be a non-empty string"), this.$_setFlag("unit", e);
                    }
                    valid() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        l.verifyFlat(t, "valid");
                        const s = this.allow(...t);
                        return s.$_setFlag("only", !!s._valids, {
                            clone: !1
                        }), s;
                    }
                    when(e, t) {
                        const r = this.clone();
                        r.$_terms.whens || (r.$_terms.whens = []);
                        const n = c.when(r, e, t);
                        if (![
                            "any",
                            "link"
                        ].includes(r.type)) {
                            const e = n.is ? [
                                n
                            ] : n.switch;
                            for (const t of e)s(!t.then || "any" === t.then.type || t.then.type === r.type, "Cannot combine", r.type, "with", t.then && t.then.type), s(!t.otherwise || "any" === t.otherwise.type || t.otherwise.type === r.type, "Cannot combine", r.type, "with", t.otherwise && t.otherwise.type);
                        }
                        return r.$_terms.whens.push(n), r.$_mutateRebuild();
                    }
                    cache(e) {
                        s(!this._inRuleset(), "Cannot set caching inside a ruleset"), s(!this._cache, "Cannot override schema cache"), s(void 0 === this._flags.artifact, "Cannot cache a rule with an artifact");
                        const t = this.clone();
                        return t._cache = e || o.provider.provision(), t.$_temp.ruleset = !1, t;
                    }
                    clone() {
                        const e = Object.create(Object.getPrototypeOf(this));
                        return this._assign(e);
                    }
                    concat(e) {
                        s(l.isSchema(e), "Invalid schema object"), s("any" === this.type || "any" === e.type || e.type === this.type, "Cannot merge type", this.type, "with another type:", e.type), s(!this._inRuleset(), "Cannot concatenate onto a schema with open ruleset"), s(!e._inRuleset(), "Cannot concatenate a schema with open ruleset");
                        let t = this.clone();
                        if ("any" === this.type && "any" !== e.type) {
                            const r = e.clone();
                            for (const e of Object.keys(t))"type" !== e && (r[e] = t[e]);
                            t = r;
                        }
                        t._ids.concat(e._ids), t._refs.register(e, p.toSibling), t._preferences = t._preferences ? l.preferences(t._preferences, e._preferences) : e._preferences, t._valids = b.merge(t._valids, e._valids, e._invalids), t._invalids = b.merge(t._invalids, e._invalids, e._valids);
                        for (const r of e._singleRules.keys())t._singleRules.has(r) && (t._rules = t._rules.filter((e)=>e.keep || e.name !== r), t._singleRules.delete(r));
                        for (const r of e._rules)e._definition.rules[r.method].multi || t._singleRules.set(r.name, r), t._rules.push(r);
                        if (t._flags.empty && e._flags.empty) {
                            t._flags.empty = t._flags.empty.concat(e._flags.empty);
                            const r = Object.assign({}, e._flags);
                            delete r.empty, i(t._flags, r);
                        } else if (e._flags.empty) {
                            t._flags.empty = e._flags.empty;
                            const r = Object.assign({}, e._flags);
                            delete r.empty, i(t._flags, r);
                        } else i(t._flags, e._flags);
                        for(const r in e.$_terms){
                            const s = e.$_terms[r];
                            s ? t.$_terms[r] ? t.$_terms[r] = t.$_terms[r].concat(s) : t.$_terms[r] = s.slice() : t.$_terms[r] || (t.$_terms[r] = s);
                        }
                        return this.$_root._tracer && this.$_root._tracer._combine(t, [
                            this,
                            e
                        ]), t.$_mutateRebuild();
                    }
                    extend(e) {
                        return s(!e.base, "Cannot extend type with another base"), f.type(this, e);
                    }
                    extract(e) {
                        return e = Array.isArray(e) ? e : e.split("."), this._ids.reach(e);
                    }
                    fork(e, t) {
                        s(!this._inRuleset(), "Cannot fork inside a ruleset");
                        let r = this;
                        for (let s of [].concat(e))s = Array.isArray(s) ? s : s.split("."), r = r._ids.fork(s, t, r);
                        return r.$_temp.ruleset = !1, r;
                    }
                    rule(e) {
                        const t = this._definition;
                        l.assertOptions(e, Object.keys(t.modifiers)), s(!1 !== this.$_temp.ruleset, "Cannot apply rules to empty ruleset or the last rule added does not support rule properties");
                        const r = null === this.$_temp.ruleset ? this._rules.length - 1 : this.$_temp.ruleset;
                        s(r >= 0 && r < this._rules.length, "Cannot apply rules to empty ruleset");
                        const a = this.clone();
                        for(let i = r; i < a._rules.length; ++i){
                            const r = a._rules[i], o = n(r);
                            for(const n in e)t.modifiers[n](o, e[n]), s(o.name === r.name, "Cannot change rule name");
                            a._rules[i] = o, a._singleRules.get(o.name) === r && a._singleRules.set(o.name, o);
                        }
                        return a.$_temp.ruleset = !1, a.$_mutateRebuild();
                    }
                    get ruleset() {
                        s(!this._inRuleset(), "Cannot start a new ruleset without closing the previous one");
                        const e = this.clone();
                        return e.$_temp.ruleset = e._rules.length, e;
                    }
                    get $() {
                        return this.ruleset;
                    }
                    tailor(e) {
                        e = [].concat(e), s(!this._inRuleset(), "Cannot tailor inside a ruleset");
                        let t = this;
                        if (this.$_terms.alterations) for (const { target: r, adjuster: n } of this.$_terms.alterations)e.includes(r) && (t = n(t), s(l.isSchema(t), "Alteration adjuster for", r, "failed to return a schema object"));
                        return t = t.$_modify({
                            each: (t)=>t.tailor(e),
                            ref: !1
                        }), t.$_temp.ruleset = !1, t.$_mutateRebuild();
                    }
                    tracer() {
                        return g.location ? g.location(this) : this;
                    }
                    validate(e, t) {
                        return y.entry(e, this, t);
                    }
                    validateAsync(e, t) {
                        return y.entryAsync(e, this, t);
                    }
                    $_addRule(e) {
                        "string" == typeof e && (e = {
                            name: e
                        }), s(e && "object" == typeof e, "Invalid options"), s(e.name && "string" == typeof e.name, "Invalid rule name");
                        for(const t in e)s("_" !== t[0], "Cannot set private rule properties");
                        const t = Object.assign({}, e);
                        t._resolve = [], t.method = t.method || t.name;
                        const r = this._definition.rules[t.method], n = t.args;
                        s(r, "Unknown rule", t.method);
                        const a = this.clone();
                        if (n) {
                            s(1 === Object.keys(n).length || Object.keys(n).length === this._definition.rules[t.name].args.length, "Invalid rule definition for", this.type, t.name);
                            for(const e in n){
                                let i = n[e];
                                if (r.argsByName) {
                                    const o = r.argsByName.get(e);
                                    if (o.ref && l.isResolvable(i)) t._resolve.push(e), a.$_mutateRegister(i);
                                    else if (o.normalize && (i = o.normalize(i), n[e] = i), o.assert) {
                                        const t = l.validateArg(i, e, o);
                                        s(!t, t, "or reference");
                                    }
                                }
                                void 0 !== i ? n[e] = i : delete n[e];
                            }
                        }
                        return r.multi || (a._ruleRemove(t.name, {
                            clone: !1
                        }), a._singleRules.set(t.name, t)), !1 === a.$_temp.ruleset && (a.$_temp.ruleset = null), r.priority ? a._rules.unshift(t) : a._rules.push(t), a;
                    }
                    $_compile(e, t) {
                        return c.schema(this.$_root, e, t);
                    }
                    $_createError(e, t, r, s, n) {
                        let a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
                        const i = !1 !== a.flags ? this._flags : {}, o = a.messages ? m.merge(this._definition.messages, a.messages) : this._definition.messages;
                        return new u.Report(e, t, r, i, o, s, n);
                    }
                    $_getFlag(e) {
                        return this._flags[e];
                    }
                    $_getRule(e) {
                        return this._singleRules.get(e);
                    }
                    $_mapLabels(e) {
                        return e = Array.isArray(e) ? e : e.split("."), this._ids.labels(e);
                    }
                    $_match(e, t, r, s) {
                        (r = Object.assign({}, r)).abortEarly = !0, r._externals = !1, t.snapshot();
                        const n = !y.validate(e, this, t, r, s).errors;
                        return t.restore(), n;
                    }
                    $_modify(e) {
                        return l.assertOptions(e, [
                            "each",
                            "once",
                            "ref",
                            "schema"
                        ]), d.schema(this, e) || this;
                    }
                    $_mutateRebuild() {
                        return s(!this._inRuleset(), "Cannot add this rule inside a ruleset"), this._refs.reset(), this._ids.reset(), this.$_modify({
                            each: (e, t)=>{
                                let { source: r, name: s, path: n, key: a } = t;
                                const i = this._definition[r][s] && this._definition[r][s].register;
                                !1 !== i && this.$_mutateRegister(e, {
                                    family: i,
                                    key: a
                                });
                            }
                        }), this._definition.rebuild && this._definition.rebuild(this), this.$_temp.ruleset = !1, this;
                    }
                    $_mutateRegister(e) {
                        let { family: t, key: r } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        this._refs.register(e, t), this._ids.register(e, {
                            key: r
                        });
                    }
                    $_property(e) {
                        return this._definition.properties[e];
                    }
                    $_reach(e) {
                        return this._ids.reach(e);
                    }
                    $_rootReferences() {
                        return this._refs.roots();
                    }
                    $_setFlag(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        s("_" === e[0] || !this._inRuleset(), "Cannot set flag inside a ruleset");
                        const n = this._definition.flags[e] || {};
                        if (a(t, n.default) && (t = void 0), a(t, this._flags[e])) return this;
                        const i = !1 !== r.clone ? this.clone() : this;
                        return void 0 !== t ? (i._flags[e] = t, i.$_mutateRegister(t)) : delete i._flags[e], "_" !== e[0] && (i.$_temp.ruleset = !1), i;
                    }
                    $_parent(e) {
                        for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)r[s - 1] = arguments[s];
                        return this[e][l.symbols.parent].call(this, ...r);
                    }
                    $_validate(e, t, r) {
                        return y.validate(e, this, t, r);
                    }
                    _assign(e) {
                        e.type = this.type, e.$_root = this.$_root, e.$_temp = Object.assign({}, this.$_temp), e.$_temp.whens = {}, e._ids = this._ids.clone(), e._preferences = this._preferences, e._valids = this._valids && this._valids.clone(), e._invalids = this._invalids && this._invalids.clone(), e._rules = this._rules.slice(), e._singleRules = n(this._singleRules, {
                            shallow: !0
                        }), e._refs = this._refs.clone(), e._flags = Object.assign({}, this._flags), e._cache = null, e.$_terms = {};
                        for(const t in this.$_terms)e.$_terms[t] = this.$_terms[t] ? this.$_terms[t].slice() : null;
                        e.$_super = {};
                        for(const t in this.$_super)e.$_super[t] = this._super[t].bind(e);
                        return e;
                    }
                    _bare() {
                        const e = this.clone();
                        e._reset();
                        const t = e._definition.terms;
                        for(const r in t){
                            const s = t[r];
                            e.$_terms[r] = s.init;
                        }
                        return e.$_mutateRebuild();
                    }
                    _default(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        return l.assertOptions(r, "literal"), s(void 0 !== t, "Missing", e, "value"), s("function" == typeof t || !r.literal, "Only function value supports literal option"), "function" == typeof t && r.literal && (t = {
                            [l.symbols.literal]: !0,
                            literal: t
                        }), this.$_setFlag(e, t);
                    }
                    _generate(e, t, r) {
                        if (!this.$_terms.whens) return {
                            schema: this
                        };
                        const s = [], n = [];
                        for(let a = 0; a < this.$_terms.whens.length; ++a){
                            const i = this.$_terms.whens[a];
                            if (i.concat) {
                                s.push(i.concat), n.push(`${a}.concat`);
                                continue;
                            }
                            const o = i.ref ? i.ref.resolve(e, t, r) : e, l = i.is ? [
                                i
                            ] : i.switch, c = n.length;
                            for(let c = 0; c < l.length; ++c){
                                const { is: u, then: f, otherwise: h } = l[c], m = `${a}${i.switch ? "." + c : ""}`;
                                if (u.$_match(o, t.nest(u, `${m}.is`), r)) {
                                    if (f) {
                                        const a = t.localize([
                                            ...t.path,
                                            `${m}.then`
                                        ], t.ancestors, t.schemas), { schema: i, id: o } = f._generate(e, a, r);
                                        s.push(i), n.push(`${m}.then${o ? `(${o})` : ""}`);
                                        break;
                                    }
                                } else if (h) {
                                    const a = t.localize([
                                        ...t.path,
                                        `${m}.otherwise`
                                    ], t.ancestors, t.schemas), { schema: i, id: o } = h._generate(e, a, r);
                                    s.push(i), n.push(`${m}.otherwise${o ? `(${o})` : ""}`);
                                    break;
                                }
                            }
                            if (i.break && n.length > c) break;
                        }
                        const a = n.join(", ");
                        if (t.mainstay.tracer.debug(t, "rule", "when", a), !a) return {
                            schema: this
                        };
                        if (!t.mainstay.tracer.active && this.$_temp.whens[a]) return {
                            schema: this.$_temp.whens[a],
                            id: a
                        };
                        let i = this;
                        this._definition.generate && (i = this._definition.generate(this, e, t, r));
                        for (const e of s)i = i.concat(e);
                        return this.$_root._tracer && this.$_root._tracer._combine(i, [
                            this,
                            ...s
                        ]), this.$_temp.whens[a] = i, {
                            schema: i,
                            id: a
                        };
                    }
                    _inner(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        s(!this._inRuleset(), `Cannot set ${e} inside a ruleset`);
                        const n = this.clone();
                        return n.$_terms[e] && !r.override || (n.$_terms[e] = []), r.single ? n.$_terms[e].push(t) : n.$_terms[e].push(...t), n.$_temp.ruleset = !1, n;
                    }
                    _inRuleset() {
                        return null !== this.$_temp.ruleset && !1 !== this.$_temp.ruleset;
                    }
                    _ruleRemove(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        if (!this._singleRules.has(e)) return this;
                        const r = !1 !== t.clone ? this.clone() : this;
                        r._singleRules.delete(e);
                        const s = [];
                        for(let t = 0; t < r._rules.length; ++t){
                            const n = r._rules[t];
                            n.name !== e || n.keep ? s.push(n) : r._inRuleset() && t < r.$_temp.ruleset && --r.$_temp.ruleset;
                        }
                        return r._rules = s, r;
                    }
                    _values(e, t) {
                        l.verifyFlat(e, t.slice(1, -1));
                        const r = this.clone(), n = e[0] === l.symbols.override;
                        if (n && (e = e.slice(1)), !r[t] && e.length ? r[t] = new b : n && (r[t] = e.length ? new b : null, r.$_mutateRebuild()), !r[t]) return r;
                        n && r[t].override();
                        for (const n of e){
                            s(void 0 !== n, "Cannot call allow/valid/invalid with undefined"), s(n !== l.symbols.override, "Override must be the first value");
                            const e = "_invalids" === t ? "_valids" : "_invalids";
                            r[e] && (r[e].remove(n), r[e].length || (s("_valids" === t || !r._flags.only, "Setting invalid value", n, "leaves schema rejecting all values due to previous valid rule"), r[e] = null)), r[t].add(n, r._refs);
                        }
                        return r;
                    }
                }
            };
            v.Base.prototype[l.symbols.any] = {
                version: l.version,
                compile: c.compile,
                root: "$_root"
            }, v.Base.prototype.isImmutable = !0, v.Base.prototype.deny = v.Base.prototype.invalid, v.Base.prototype.disallow = v.Base.prototype.invalid, v.Base.prototype.equal = v.Base.prototype.valid, v.Base.prototype.exist = v.Base.prototype.required, v.Base.prototype.not = v.Base.prototype.invalid, v.Base.prototype.options = v.Base.prototype.prefs, v.Base.prototype.preferences = v.Base.prototype.prefs, e.exports = new v.Base;
        },
        8652: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(8160), i = {
                max: 1e3,
                supported: new Set([
                    "undefined",
                    "boolean",
                    "number",
                    "string"
                ])
            };
            t.provider = {
                provision: (e)=>new i.Cache(e)
            }, i.Cache = class {
                constructor(){
                    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    a.assertOptions(e, [
                        "max"
                    ]), s(void 0 === e.max || e.max && e.max > 0 && isFinite(e.max), "Invalid max cache size"), this._max = e.max || i.max, this._map = new Map, this._list = new i.List;
                }
                get length() {
                    return this._map.size;
                }
                set(e, t) {
                    if (null !== e && !i.supported.has(typeof e)) return;
                    let r = this._map.get(e);
                    if (r) return r.value = t, void this._list.first(r);
                    r = this._list.unshift({
                        key: e,
                        value: t
                    }), this._map.set(e, r), this._compact();
                }
                get(e) {
                    const t = this._map.get(e);
                    if (t) return this._list.first(t), n(t.value);
                }
                _compact() {
                    if (this._map.size > this._max) {
                        const e = this._list.pop();
                        this._map.delete(e.key);
                    }
                }
            }, i.List = class {
                constructor(){
                    this.tail = null, this.head = null;
                }
                unshift(e) {
                    return e.next = null, e.prev = this.head, this.head && (this.head.next = e), this.head = e, this.tail || (this.tail = e), e;
                }
                first(e) {
                    e !== this.head && (this._remove(e), this.unshift(e));
                }
                pop() {
                    return this._remove(this.tail);
                }
                _remove(e) {
                    const { next: t, prev: r } = e;
                    return t.prev = r, r && (r.next = t), e === this.tail && (this.tail = t), e.prev = null, e.next = null, e;
                }
            };
        },
        8160: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(7916), a = r(5934);
            let i, o;
            const l = {
                isoDate: /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/
            };
            t.version = a.version, t.defaults = {
                abortEarly: !0,
                allowUnknown: !1,
                artifacts: !1,
                cache: !0,
                context: null,
                convert: !0,
                dateFormat: "iso",
                errors: {
                    escapeHtml: !1,
                    label: "path",
                    language: null,
                    render: !0,
                    stack: !1,
                    wrap: {
                        label: '"',
                        array: "[]"
                    }
                },
                externals: !0,
                messages: {},
                nonEnumerables: !1,
                noDefaults: !1,
                presence: "optional",
                skipFunctions: !1,
                stripUnknown: !1,
                warnings: !1
            }, t.symbols = {
                any: Symbol.for("@hapi/joi/schema"),
                arraySingle: Symbol("arraySingle"),
                deepDefault: Symbol("deepDefault"),
                errors: Symbol("errors"),
                literal: Symbol("literal"),
                override: Symbol("override"),
                parent: Symbol("parent"),
                prefs: Symbol("prefs"),
                ref: Symbol("ref"),
                template: Symbol("template"),
                values: Symbol("values")
            }, t.assertOptions = function(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "Options";
                s(e && "object" == typeof e && !Array.isArray(e), "Options must be of type object");
                const n = Object.keys(e).filter((e)=>!t.includes(e));
                s(0 === n.length, `${r} contain unknown keys: ${n}`);
            }, t.checkPreferences = function(e) {
                o = o || r(3378);
                const t = o.preferences.validate(e);
                if (t.error) throw new n([
                    t.error.details[0].message
                ]);
            }, t.compare = function(e, t, r) {
                switch(r){
                    case "=":
                        return e === t;
                    case ">":
                        return e > t;
                    case "<":
                        return e < t;
                    case ">=":
                        return e >= t;
                    case "<=":
                        return e <= t;
                }
            }, t.default = function(e, t) {
                return void 0 === e ? t : e;
            }, t.isIsoDate = function(e) {
                return l.isoDate.test(e);
            }, t.isNumber = function(e) {
                return "number" == typeof e && !isNaN(e);
            }, t.isResolvable = function(e) {
                return !!e && (e[t.symbols.ref] || e[t.symbols.template]);
            }, t.isSchema = function(e) {
                let r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const n = e && e[t.symbols.any];
                return !!n && (s(r.legacy || n.version === t.version, "Cannot mix different versions of joi schemas"), !0);
            }, t.isValues = function(e) {
                return e[t.symbols.values];
            }, t.limit = function(e) {
                return Number.isSafeInteger(e) && e >= 0;
            }, t.preferences = function(e, s) {
                i = i || r(6914), e = e || {}, s = s || {};
                const n = Object.assign({}, e, s);
                return s.errors && e.errors && (n.errors = Object.assign({}, e.errors, s.errors), n.errors.wrap = Object.assign({}, e.errors.wrap, s.errors.wrap)), s.messages && (n.messages = i.compile(s.messages, e.messages)), delete n[t.symbols.prefs], n;
            }, t.tryWithPath = function(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                try {
                    return e();
                } catch (e) {
                    throw void 0 !== e.path ? e.path = t + "." + e.path : e.path = t, r.append && (e.message = `${e.message} (${e.path})`), e;
                }
            }, t.validateArg = function(e, r, s) {
                let { assert: n, message: a } = s;
                if (t.isSchema(n)) {
                    const t = n.validate(e);
                    if (!t.error) return;
                    return t.error.message;
                }
                if (!n(e)) return r ? `${r} ${a}` : a;
            }, t.verifyFlat = function(e, t) {
                for (const r of e)s(!Array.isArray(r), "Method no longer accepts array arguments:", t);
            };
        },
        3292: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8160), a = r(6133), i = {};
            t.schema = function(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                n.assertOptions(r, [
                    "appendPath",
                    "override"
                ]);
                try {
                    return i.schema(e, t, r);
                } catch (e) {
                    throw r.appendPath && void 0 !== e.path && (e.message = `${e.message} (${e.path})`), e;
                }
            }, i.schema = function(e, t, r) {
                s(void 0 !== t, "Invalid undefined schema"), Array.isArray(t) && (s(t.length, "Invalid empty array schema"), 1 === t.length && (t = t[0]));
                const a = function(t) {
                    for(var s = arguments.length, n = new Array(s > 1 ? s - 1 : 0), a = 1; a < s; a++)n[a - 1] = arguments[a];
                    return !1 !== r.override ? t.valid(e.override, ...n) : t.valid(...n);
                };
                if (i.simple(t)) return a(e, t);
                if ("function" == typeof t) return e.custom(t);
                if (s("object" == typeof t, "Invalid schema content:", typeof t), n.isResolvable(t)) return a(e, t);
                if (n.isSchema(t)) return t;
                if (Array.isArray(t)) {
                    for (const r of t)if (!i.simple(r)) return e.alternatives().try(...t);
                    return a(e, ...t);
                }
                return t instanceof RegExp ? e.string().regex(t) : t instanceof Date ? a(e.date(), t) : (s(Object.getPrototypeOf(t) === Object.getPrototypeOf({}), "Schema can only contain plain objects"), e.object().keys(t));
            }, t.ref = function(e, t) {
                return a.isRef(e) ? e : a.create(e, t);
            }, t.compile = function(e, r) {
                let a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                n.assertOptions(a, [
                    "legacy"
                ]);
                const o = r && r[n.symbols.any];
                if (o) return s(a.legacy || o.version === n.version, "Cannot mix different versions of joi schemas:", o.version, n.version), r;
                if ("object" != typeof r || !a.legacy) return t.schema(e, r, {
                    appendPath: !0
                });
                const l = i.walk(r);
                return l ? l.compile(l.root, r) : t.schema(e, r, {
                    appendPath: !0
                });
            }, i.walk = function(e) {
                if ("object" != typeof e) return null;
                if (Array.isArray(e)) {
                    for (const t of e){
                        const e = i.walk(t);
                        if (e) return e;
                    }
                    return null;
                }
                const t = e[n.symbols.any];
                if (t) return {
                    root: e[t.root],
                    compile: t.compile
                };
                s(Object.getPrototypeOf(e) === Object.getPrototypeOf({}), "Schema can only contain plain objects");
                for(const t in e){
                    const r = i.walk(e[t]);
                    if (r) return r;
                }
                return null;
            }, i.simple = function(e) {
                return null === e || [
                    "boolean",
                    "string",
                    "number"
                ].includes(typeof e);
            }, t.when = function(e, r, o) {
                if (void 0 === o && (s(r && "object" == typeof r, "Missing options"), o = r, r = a.create(".")), Array.isArray(o) && (o = {
                    switch: o
                }), n.assertOptions(o, [
                    "is",
                    "not",
                    "then",
                    "otherwise",
                    "switch",
                    "break"
                ]), n.isSchema(r)) return s(void 0 === o.is, '"is" can not be used with a schema condition'), s(void 0 === o.not, '"not" can not be used with a schema condition'), s(void 0 === o.switch, '"switch" can not be used with a schema condition'), i.condition(e, {
                    is: r,
                    then: o.then,
                    otherwise: o.otherwise,
                    break: o.break
                });
                if (s(a.isRef(r) || "string" == typeof r, "Invalid condition:", r), s(void 0 === o.not || void 0 === o.is, 'Cannot combine "is" with "not"'), void 0 === o.switch) {
                    let l = o;
                    void 0 !== o.not && (l = {
                        is: o.not,
                        then: o.otherwise,
                        otherwise: o.then,
                        break: o.break
                    });
                    let c = void 0 !== l.is ? e.$_compile(l.is) : e.$_root.invalid(null, !1, 0, "").required();
                    return s(void 0 !== l.then || void 0 !== l.otherwise, 'options must have at least one of "then", "otherwise", or "switch"'), s(void 0 === l.break || void 0 === l.then || void 0 === l.otherwise, "Cannot specify then, otherwise, and break all together"), void 0 === o.is || a.isRef(o.is) || n.isSchema(o.is) || (c = c.required()), i.condition(e, {
                        ref: t.ref(r),
                        is: c,
                        then: l.then,
                        otherwise: l.otherwise,
                        break: l.break
                    });
                }
                s(Array.isArray(o.switch), '"switch" must be an array'), s(void 0 === o.is, 'Cannot combine "switch" with "is"'), s(void 0 === o.not, 'Cannot combine "switch" with "not"'), s(void 0 === o.then, 'Cannot combine "switch" with "then"');
                const l = {
                    ref: t.ref(r),
                    switch: [],
                    break: o.break
                };
                for(let t = 0; t < o.switch.length; ++t){
                    const r = o.switch[t], i = t === o.switch.length - 1;
                    n.assertOptions(r, i ? [
                        "is",
                        "then",
                        "otherwise"
                    ] : [
                        "is",
                        "then"
                    ]), s(void 0 !== r.is, 'Switch statement missing "is"'), s(void 0 !== r.then, 'Switch statement missing "then"');
                    const c = {
                        is: e.$_compile(r.is),
                        then: e.$_compile(r.then)
                    };
                    if (a.isRef(r.is) || n.isSchema(r.is) || (c.is = c.is.required()), i) {
                        s(void 0 === o.otherwise || void 0 === r.otherwise, 'Cannot specify "otherwise" inside and outside a "switch"');
                        const t = void 0 !== o.otherwise ? o.otherwise : r.otherwise;
                        void 0 !== t && (s(void 0 === l.break, "Cannot specify both otherwise and break"), c.otherwise = e.$_compile(t));
                    }
                    l.switch.push(c);
                }
                return l;
            }, i.condition = function(e, t) {
                for (const r of [
                    "then",
                    "otherwise"
                ])void 0 === t[r] ? delete t[r] : t[r] = e.$_compile(t[r]);
                return t;
            };
        },
        6354: (e, t, r)=>{
            "use strict";
            const s = r(5688), n = r(8160), a = r(3328);
            t.Report = class {
                constructor(e, r, s, n, a, i, o){
                    if (this.code = e, this.flags = n, this.messages = a, this.path = i.path, this.prefs = o, this.state = i, this.value = r, this.message = null, this.template = null, this.local = s || {}, this.local.label = t.label(this.flags, this.state, this.prefs, this.messages), void 0 === this.value || this.local.hasOwnProperty("value") || (this.local.value = this.value), this.path.length) {
                        const e = this.path[this.path.length - 1];
                        "object" != typeof e && (this.local.key = e);
                    }
                }
                _setTemplate(e) {
                    if (this.template = e, !this.flags.label && 0 === this.path.length) {
                        const e = this._template(this.template, "root");
                        e && (this.local.label = e);
                    }
                }
                toString() {
                    if (this.message) return this.message;
                    const e = this.code;
                    if (!this.prefs.errors.render) return this.code;
                    const t = this._template(this.template) || this._template(this.prefs.messages) || this._template(this.messages);
                    return void 0 === t ? `Error code "${e}" is not defined, your custom type is missing the correct messages definition` : (this.message = t.render(this.value, this.state, this.prefs, this.local, {
                        errors: this.prefs.errors,
                        messages: [
                            this.prefs.messages,
                            this.messages
                        ]
                    }), this.prefs.errors.label || (this.message = this.message.replace(/^"" /, "").trim()), this.message);
                }
                _template(e, r) {
                    return t.template(this.value, e, r || this.code, this.state, this.prefs);
                }
            }, t.path = function(e) {
                let t = "";
                for (const r of e)"object" != typeof r && ("string" == typeof r ? (t && (t += "."), t += r) : t += `[${r}]`);
                return t;
            }, t.template = function(e, t, r, s, i) {
                if (!t) return;
                if (a.isTemplate(t)) return "root" !== r ? t : null;
                let o = i.errors.language;
                if (n.isResolvable(o) && (o = o.resolve(e, s, i)), o && t[o]) {
                    if (void 0 !== t[o][r]) return t[o][r];
                    if (void 0 !== t[o]["*"]) return t[o]["*"];
                }
                return t[r] ? t[r] : t["*"];
            }, t.label = function(e, r, s, n) {
                if (e.label) return e.label;
                if (!s.errors.label) return "";
                let a = r.path;
                "key" === s.errors.label && r.path.length > 1 && (a = r.path.slice(-1));
                return t.path(a) || t.template(null, s.messages, "root", r, s) || n && t.template(null, n, "root", r, s) || "value";
            }, t.process = function(e, r, s) {
                if (!e) return null;
                const { override: n, message: a, details: i } = t.details(e);
                if (n) return n;
                if (s.errors.stack) return new t.ValidationError(a, i, r);
                const o = Error.stackTraceLimit;
                Error.stackTraceLimit = 0;
                const l = new t.ValidationError(a, i, r);
                return Error.stackTraceLimit = o, l;
            }, t.details = function(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = [];
                const s = [];
                for (const n of e){
                    if (n instanceof Error) {
                        if (!1 !== t.override) return {
                            override: n
                        };
                        const e = n.toString();
                        r.push(e), s.push({
                            message: e,
                            type: "override",
                            context: {
                                error: n
                            }
                        });
                        continue;
                    }
                    const e = n.toString();
                    r.push(e), s.push({
                        message: e,
                        path: n.path.filter((e)=>"object" != typeof e),
                        type: n.code,
                        context: n.local
                    });
                }
                return r.length > 1 && (r = [
                    ...new Set(r)
                ]), {
                    message: r.join(". "),
                    details: s
                };
            }, t.ValidationError = class extends Error {
                constructor(e, t, r){
                    super(e), this._original = r, this.details = t;
                }
                static isError(e) {
                    return e instanceof t.ValidationError;
                }
            }, t.ValidationError.prototype.isJoi = !0, t.ValidationError.prototype.name = "ValidationError", t.ValidationError.prototype.annotate = s.error;
        },
        8901: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(8160), i = r(6914), o = {};
            t.type = function(e, t) {
                const r = Object.getPrototypeOf(e), l = n(r), c = e._assign(Object.create(l)), u = Object.assign({}, t);
                delete u.base, l._definition = u;
                const f = r._definition || {};
                u.messages = i.merge(f.messages, u.messages), u.properties = Object.assign({}, f.properties, u.properties), c.type = u.type, u.flags = Object.assign({}, f.flags, u.flags);
                const h = Object.assign({}, f.terms);
                if (u.terms) for(const e in u.terms){
                    const t = u.terms[e];
                    s(void 0 === c.$_terms[e], "Invalid term override for", u.type, e), c.$_terms[e] = t.init, h[e] = t;
                }
                u.terms = h, u.args || (u.args = f.args), u.prepare = o.prepare(u.prepare, f.prepare), u.coerce && ("function" == typeof u.coerce && (u.coerce = {
                    method: u.coerce
                }), u.coerce.from && !Array.isArray(u.coerce.from) && (u.coerce = {
                    method: u.coerce.method,
                    from: [].concat(u.coerce.from)
                })), u.coerce = o.coerce(u.coerce, f.coerce), u.validate = o.validate(u.validate, f.validate);
                const m = Object.assign({}, f.rules);
                if (u.rules) for(const e in u.rules){
                    const t = u.rules[e];
                    s("object" == typeof t, "Invalid rule definition for", u.type, e);
                    let r = t.method;
                    if (void 0 === r && (r = function() {
                        return this.$_addRule(e);
                    }), r && (s(!l[e], "Rule conflict in", u.type, e), l[e] = r), s(!m[e], "Rule conflict in", u.type, e), m[e] = t, t.alias) {
                        const e = [].concat(t.alias);
                        for (const r of e)l[r] = t.method;
                    }
                    t.args && (t.argsByName = new Map, t.args = t.args.map((e)=>("string" == typeof e && (e = {
                            name: e
                        }), s(!t.argsByName.has(e.name), "Duplicated argument name", e.name), a.isSchema(e.assert) && (e.assert = e.assert.strict().label(e.name)), t.argsByName.set(e.name, e), e)));
                }
                u.rules = m;
                const d = Object.assign({}, f.modifiers);
                if (u.modifiers) for(const e in u.modifiers){
                    s(!l[e], "Rule conflict in", u.type, e);
                    const t = u.modifiers[e];
                    s("function" == typeof t, "Invalid modifier definition for", u.type, e);
                    const r = function(t) {
                        return this.rule({
                            [e]: t
                        });
                    };
                    l[e] = r, d[e] = t;
                }
                if (u.modifiers = d, u.overrides) {
                    l._super = r, c.$_super = {};
                    for(const e in u.overrides)s(r[e], "Cannot override missing", e), u.overrides[e][a.symbols.parent] = r[e], c.$_super[e] = r[e].bind(c);
                    Object.assign(l, u.overrides);
                }
                u.cast = Object.assign({}, f.cast, u.cast);
                const p = Object.assign({}, f.manifest, u.manifest);
                return p.build = o.build(u.manifest && u.manifest.build, f.manifest && f.manifest.build), u.manifest = p, u.rebuild = o.rebuild(u.rebuild, f.rebuild), c;
            }, o.build = function(e, t) {
                return e && t ? function(r, s) {
                    return t(e(r, s), s);
                } : e || t;
            }, o.coerce = function(e, t) {
                return e && t ? {
                    from: e.from && t.from ? [
                        ...new Set([
                            ...e.from,
                            ...t.from
                        ])
                    ] : null,
                    method (r, s) {
                        let n;
                        if ((!t.from || t.from.includes(typeof r)) && (n = t.method(r, s), n)) {
                            if (n.errors || void 0 === n.value) return n;
                            r = n.value;
                        }
                        if (!e.from || e.from.includes(typeof r)) {
                            const t = e.method(r, s);
                            if (t) return t;
                        }
                        return n;
                    }
                } : e || t;
            }, o.prepare = function(e, t) {
                return e && t ? function(r, s) {
                    const n = e(r, s);
                    if (n) {
                        if (n.errors || void 0 === n.value) return n;
                        r = n.value;
                    }
                    return t(r, s) || n;
                } : e || t;
            }, o.rebuild = function(e, t) {
                return e && t ? function(r) {
                    t(r), e(r);
                } : e || t;
            }, o.validate = function(e, t) {
                return e && t ? function(r, s) {
                    const n = t(r, s);
                    if (n) {
                        if (n.errors && (!Array.isArray(n.errors) || n.errors.length)) return n;
                        r = n.value;
                    }
                    return e(r, s) || n;
                } : e || t;
            };
        },
        5107: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(8652), i = r(8160), o = r(3292), l = r(6354), c = r(8901), u = r(9708), f = r(6133), h = r(3328), m = r(1152);
            let d;
            const p = {
                types: {
                    alternatives: r(4946),
                    any: r(8068),
                    array: r(546),
                    boolean: r(4937),
                    date: r(7500),
                    function: r(390),
                    link: r(8785),
                    number: r(3832),
                    object: r(8966),
                    string: r(7417),
                    symbol: r(8826)
                },
                aliases: {
                    alt: "alternatives",
                    bool: "boolean",
                    func: "function"
                },
                root: function() {
                    const e = {
                        _types: new Set(Object.keys(p.types))
                    };
                    for (const t of e._types)e[t] = function() {
                        for(var e = arguments.length, r = new Array(e), n = 0; n < e; n++)r[n] = arguments[n];
                        return s(!r.length || [
                            "alternatives",
                            "link",
                            "object"
                        ].includes(t), "The", t, "type does not allow arguments"), p.generate(this, p.types[t], r);
                    };
                    for (const t of [
                        "allow",
                        "custom",
                        "disallow",
                        "equal",
                        "exist",
                        "forbidden",
                        "invalid",
                        "not",
                        "only",
                        "optional",
                        "options",
                        "prefs",
                        "preferences",
                        "required",
                        "strip",
                        "valid",
                        "when"
                    ])e[t] = function() {
                        return this.any()[t](...arguments);
                    };
                    Object.assign(e, p.methods);
                    for(const t in p.aliases){
                        const r = p.aliases[t];
                        e[t] = e[r];
                    }
                    return e.x = e.expression, m.setup && m.setup(e), e;
                }
            };
            p.methods = {
                ValidationError: l.ValidationError,
                version: i.version,
                cache: a.provider,
                assert (e, t) {
                    for(var r = arguments.length, s = new Array(r > 2 ? r - 2 : 0), n = 2; n < r; n++)s[n - 2] = arguments[n];
                    p.assert(e, t, !0, s);
                },
                attempt (e, t) {
                    for(var r = arguments.length, s = new Array(r > 2 ? r - 2 : 0), n = 2; n < r; n++)s[n - 2] = arguments[n];
                    return p.assert(e, t, !1, s);
                },
                build (e) {
                    return s("function" == typeof u.build, "Manifest functionality disabled"), u.build(this, e);
                },
                checkPreferences (e) {
                    i.checkPreferences(e);
                },
                compile (e, t) {
                    return o.compile(this, e, t);
                },
                defaults (e) {
                    s("function" == typeof e, "modifier must be a function");
                    const t = Object.assign({}, this);
                    for (const r of t._types){
                        const n = e(t[r]());
                        s(i.isSchema(n), "modifier must return a valid schema object"), t[r] = function() {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            return p.generate(this, n, t);
                        };
                    }
                    return t;
                },
                expression () {
                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                    return new h(...t);
                },
                extend () {
                    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                    i.verifyFlat(t, "extend"), d = d || r(3378), s(t.length, "You need to provide at least one extension"), this.assert(t, d.extensions);
                    const a = Object.assign({}, this);
                    a._types = new Set(a._types);
                    for (let e of t){
                        "function" == typeof e && (e = e(a)), this.assert(e, d.extension);
                        const t = p.expandExtension(e, a);
                        for (const e of t){
                            s(void 0 === a[e.type] || a._types.has(e.type), "Cannot override name", e.type);
                            const t = e.base || this.any(), r = c.type(t, e);
                            a._types.add(e.type), a[e.type] = function() {
                                for(var e = arguments.length, t = new Array(e), s = 0; s < e; s++)t[s] = arguments[s];
                                return p.generate(this, r, t);
                            };
                        }
                    }
                    return a;
                },
                isError: l.ValidationError.isError,
                isExpression: h.isTemplate,
                isRef: f.isRef,
                isSchema: i.isSchema,
                in () {
                    return f.in(...arguments);
                },
                override: i.symbols.override,
                ref () {
                    return f.create(...arguments);
                },
                types () {
                    const e = {};
                    for (const t of this._types)e[t] = this[t]();
                    for(const t in p.aliases)e[t] = this[t]();
                    return e;
                }
            }, p.assert = function(e, t, r, s) {
                const a = s[0] instanceof Error || "string" == typeof s[0] ? s[0] : null, o = null !== a ? s[1] : s[0], c = t.validate(e, i.preferences({
                    errors: {
                        stack: !0
                    }
                }, o || {}));
                let u = c.error;
                if (!u) return c.value;
                if (a instanceof Error) throw a;
                const f = r && "function" == typeof u.annotate ? u.annotate() : u.message;
                throw u instanceof l.ValidationError == 0 && (u = n(u)), u.message = a ? `${a} ${f}` : f, u;
            }, p.generate = function(e, t, r) {
                return s(e, "Must be invoked on a Joi instance."), t.$_root = e, t._definition.args && r.length ? t._definition.args(t, ...r) : t;
            }, p.expandExtension = function(e, t) {
                if ("string" == typeof e.type) return [
                    e
                ];
                const r = [];
                for (const s of t._types)if (e.type.test(s)) {
                    const n = Object.assign({}, e);
                    n.type = s, n.base = t[s](), r.push(n);
                }
                return r;
            }, e.exports = p.root();
        },
        6914: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(3328);
            t.compile = function(e, t) {
                if ("string" == typeof e) return s(!t, "Cannot set single message string"), new a(e);
                if (a.isTemplate(e)) return s(!t, "Cannot set single message template"), e;
                s("object" == typeof e && !Array.isArray(e), "Invalid message options"), t = t ? n(t) : {};
                for(let r in e){
                    const n = e[r];
                    if ("root" === r || a.isTemplate(n)) {
                        t[r] = n;
                        continue;
                    }
                    if ("string" == typeof n) {
                        t[r] = new a(n);
                        continue;
                    }
                    s("object" == typeof n && !Array.isArray(n), "Invalid message for", r);
                    const i = r;
                    for(r in t[i] = t[i] || {}, n){
                        const e = n[r];
                        "root" === r || a.isTemplate(e) ? t[i][r] = e : (s("string" == typeof e, "Invalid message for", r, "in", i), t[i][r] = new a(e));
                    }
                }
                return t;
            }, t.decompile = function(e) {
                const t = {};
                for(let r in e){
                    const s = e[r];
                    if ("root" === r) {
                        t.root = s;
                        continue;
                    }
                    if (a.isTemplate(s)) {
                        t[r] = s.describe({
                            compact: !0
                        });
                        continue;
                    }
                    const n = r;
                    for(r in t[n] = {}, s){
                        const e = s[r];
                        "root" !== r ? t[n][r] = e.describe({
                            compact: !0
                        }) : t[n].root = e;
                    }
                }
                return t;
            }, t.merge = function(e, r) {
                if (!e) return t.compile(r);
                if (!r) return e;
                if ("string" == typeof r) return new a(r);
                if (a.isTemplate(r)) return r;
                const i = n(e);
                for(let e in r){
                    const t = r[e];
                    if ("root" === e || a.isTemplate(t)) {
                        i[e] = t;
                        continue;
                    }
                    if ("string" == typeof t) {
                        i[e] = new a(t);
                        continue;
                    }
                    s("object" == typeof t && !Array.isArray(t), "Invalid message for", e);
                    const n = e;
                    for(e in i[n] = i[n] || {}, t){
                        const r = t[e];
                        "root" === e || a.isTemplate(r) ? i[n][e] = r : (s("string" == typeof r, "Invalid message for", e, "in", n), i[n][e] = new a(r));
                    }
                }
                return i;
            };
        },
        2294: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8160), a = r(6133), i = {};
            t.Ids = i.Ids = class {
                constructor(){
                    this._byId = new Map, this._byKey = new Map, this._schemaChain = !1;
                }
                clone() {
                    const e = new i.Ids;
                    return e._byId = new Map(this._byId), e._byKey = new Map(this._byKey), e._schemaChain = this._schemaChain, e;
                }
                concat(e) {
                    e._schemaChain && (this._schemaChain = !0);
                    for (const [t, r] of e._byId.entries())s(!this._byKey.has(t), "Schema id conflicts with existing key:", t), this._byId.set(t, r);
                    for (const [t, r] of e._byKey.entries())s(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, r);
                }
                fork(e, t, r) {
                    const a = this._collect(e);
                    a.push({
                        schema: r
                    });
                    const o = a.shift();
                    let l = {
                        id: o.id,
                        schema: t(o.schema)
                    };
                    s(n.isSchema(l.schema), "adjuster function failed to return a joi schema type");
                    for (const e of a)l = {
                        id: e.id,
                        schema: i.fork(e.schema, l.id, l.schema)
                    };
                    return l.schema;
                }
                labels(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                    const r = e[0], s = this._get(r);
                    if (!s) return [
                        ...t,
                        ...e
                    ].join(".");
                    const n = e.slice(1);
                    return t = [
                        ...t,
                        s.schema._flags.label || r
                    ], n.length ? s.schema._ids.labels(n, t) : t.join(".");
                }
                reach(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                    const r = e[0], n = this._get(r);
                    s(n, "Schema does not contain path", [
                        ...t,
                        ...e
                    ].join("."));
                    const a = e.slice(1);
                    return a.length ? n.schema._ids.reach(a, [
                        ...t,
                        r
                    ]) : n.schema;
                }
                register(e) {
                    let { key: t } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (!e || !n.isSchema(e)) return;
                    (e.$_property("schemaChain") || e._ids._schemaChain) && (this._schemaChain = !0);
                    const r = e._flags.id;
                    if (r) {
                        const t = this._byId.get(r);
                        s(!t || t.schema === e, "Cannot add different schemas with the same id:", r), s(!this._byKey.has(r), "Schema id conflicts with existing key:", r), this._byId.set(r, {
                            schema: e,
                            id: r
                        });
                    }
                    t && (s(!this._byKey.has(t), "Schema already contains key:", t), s(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, {
                        schema: e,
                        id: t
                    }));
                }
                reset() {
                    this._byId = new Map, this._byKey = new Map, this._schemaChain = !1;
                }
                _collect(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
                    const n = e[0], a = this._get(n);
                    s(a, "Schema does not contain path", [
                        ...t,
                        ...e
                    ].join(".")), r = [
                        a,
                        ...r
                    ];
                    const i = e.slice(1);
                    return i.length ? a.schema._ids._collect(i, [
                        ...t,
                        n
                    ], r) : r;
                }
                _get(e) {
                    return this._byId.get(e) || this._byKey.get(e);
                }
            }, i.fork = function(e, r, s) {
                const n = t.schema(e, {
                    each: (e, t)=>{
                        let { key: n } = t;
                        if (r === (e._flags.id || n)) return s;
                    },
                    ref: !1
                });
                return n ? n.$_mutateRebuild() : e;
            }, t.schema = function(e, t) {
                let r;
                for(const s in e._flags){
                    if ("_" === s[0]) continue;
                    const n = i.scan(e._flags[s], {
                        source: "flags",
                        name: s
                    }, t);
                    void 0 !== n && (r = r || e.clone(), r._flags[s] = n);
                }
                for(let s = 0; s < e._rules.length; ++s){
                    const n = e._rules[s], a = i.scan(n.args, {
                        source: "rules",
                        name: n.name
                    }, t);
                    if (void 0 !== a) {
                        r = r || e.clone();
                        const t = Object.assign({}, n);
                        t.args = a, r._rules[s] = t, r._singleRules.get(n.name) === n && r._singleRules.set(n.name, t);
                    }
                }
                for(const s in e.$_terms){
                    if ("_" === s[0]) continue;
                    const n = i.scan(e.$_terms[s], {
                        source: "terms",
                        name: s
                    }, t);
                    void 0 !== n && (r = r || e.clone(), r.$_terms[s] = n);
                }
                return r;
            }, i.scan = function(e, t, r, s, o) {
                const l = s || [];
                if (null === e || "object" != typeof e) return;
                let c;
                if (Array.isArray(e)) {
                    for(let s = 0; s < e.length; ++s){
                        const n = "terms" === t.source && "keys" === t.name && e[s].key, a = i.scan(e[s], t, r, [
                            s,
                            ...l
                        ], n);
                        void 0 !== a && (c = c || e.slice(), c[s] = a);
                    }
                    return c;
                }
                if (!1 !== r.schema && n.isSchema(e) || !1 !== r.ref && a.isRef(e)) {
                    const s = r.each(e, {
                        ...t,
                        path: l,
                        key: o
                    });
                    if (s === e) return;
                    return s;
                }
                for(const s in e){
                    if ("_" === s[0]) continue;
                    const n = i.scan(e[s], t, r, [
                        s,
                        ...l
                    ], o);
                    void 0 !== n && (c = c || Object.assign({}, e), c[s] = n);
                }
                return c;
            };
        },
        6133: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(9621), i = r(8160);
            let o;
            const l = {
                symbol: Symbol("ref"),
                defaults: {
                    adjust: null,
                    in: !1,
                    iterables: null,
                    map: null,
                    separator: ".",
                    type: "value"
                }
            };
            t.create = function(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                s("string" == typeof e, "Invalid reference key:", e), i.assertOptions(t, [
                    "adjust",
                    "ancestor",
                    "in",
                    "iterables",
                    "map",
                    "prefix",
                    "render",
                    "separator"
                ]), s(!t.prefix || "object" == typeof t.prefix, "options.prefix must be of type object");
                const r = Object.assign({}, l.defaults, t);
                delete r.prefix;
                const n = r.separator, a = l.context(e, n, t.prefix);
                if (r.type = a.type, e = a.key, "value" === r.type) {
                    if (a.root && (s(!n || e[0] !== n, "Cannot specify relative path with root prefix"), r.ancestor = "root", e || (e = null)), n && n === e) e = null, r.ancestor = 0;
                    else if (void 0 !== r.ancestor) s(!n || !e || e[0] !== n, "Cannot combine prefix with ancestor option");
                    else {
                        const [t, s] = l.ancestor(e, n);
                        s && "" === (e = e.slice(s)) && (e = null), r.ancestor = t;
                    }
                }
                return r.path = n ? null === e ? [] : e.split(n) : [
                    e
                ], new l.Ref(r);
            }, t.in = function(e) {
                let r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return t.create(e, {
                    ...r,
                    in: !0
                });
            }, t.isRef = function(e) {
                return !!e && !!e[i.symbols.ref];
            }, l.Ref = class {
                constructor(e){
                    s("object" == typeof e, "Invalid reference construction"), i.assertOptions(e, [
                        "adjust",
                        "ancestor",
                        "in",
                        "iterables",
                        "map",
                        "path",
                        "render",
                        "separator",
                        "type",
                        "depth",
                        "key",
                        "root",
                        "display"
                    ]), s([
                        !1,
                        void 0
                    ].includes(e.separator) || "string" == typeof e.separator && 1 === e.separator.length, "Invalid separator"), s(!e.adjust || "function" == typeof e.adjust, "options.adjust must be a function"), s(!e.map || Array.isArray(e.map), "options.map must be an array"), s(!e.map || !e.adjust, "Cannot set both map and adjust options"), Object.assign(this, l.defaults, e), s("value" === this.type || void 0 === this.ancestor, "Non-value references cannot reference ancestors"), Array.isArray(this.map) && (this.map = new Map(this.map)), this.depth = this.path.length, this.key = this.path.length ? this.path.join(this.separator) : null, this.root = this.path[0], this.updateDisplay();
                }
                resolve(e, t, r, n) {
                    let a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
                    return s(!this.in || a.in, "Invalid in() reference usage"), "global" === this.type ? this._resolve(r.context, t, a) : "local" === this.type ? this._resolve(n, t, a) : this.ancestor ? "root" === this.ancestor ? this._resolve(t.ancestors[t.ancestors.length - 1], t, a) : (s(this.ancestor <= t.ancestors.length, "Invalid reference exceeds the schema root:", this.display), this._resolve(t.ancestors[this.ancestor - 1], t, a)) : this._resolve(e, t, a);
                }
                _resolve(e, t, r) {
                    let s;
                    if ("value" === this.type && t.mainstay.shadow && !1 !== r.shadow && (s = t.mainstay.shadow.get(this.absolute(t))), void 0 === s && (s = a(e, this.path, {
                        iterables: this.iterables,
                        functions: !0
                    })), this.adjust && (s = this.adjust(s)), this.map) {
                        const e = this.map.get(s);
                        void 0 !== e && (s = e);
                    }
                    return t.mainstay && t.mainstay.tracer.resolve(t, this, s), s;
                }
                toString() {
                    return this.display;
                }
                absolute(e) {
                    return [
                        ...e.path.slice(0, -this.ancestor),
                        ...this.path
                    ];
                }
                clone() {
                    return new l.Ref(this);
                }
                describe() {
                    const e = {
                        path: this.path
                    };
                    "value" !== this.type && (e.type = this.type), "." !== this.separator && (e.separator = this.separator), "value" === this.type && 1 !== this.ancestor && (e.ancestor = this.ancestor), this.map && (e.map = [
                        ...this.map
                    ]);
                    for (const t of [
                        "adjust",
                        "iterables",
                        "render"
                    ])null !== this[t] && void 0 !== this[t] && (e[t] = this[t]);
                    return !1 !== this.in && (e.in = !0), {
                        ref: e
                    };
                }
                updateDisplay() {
                    const e = null !== this.key ? this.key : "";
                    if ("value" !== this.type) return void (this.display = `ref:${this.type}:${e}`);
                    if (!this.separator) return void (this.display = `ref:${e}`);
                    if (!this.ancestor) return void (this.display = `ref:${this.separator}${e}`);
                    if ("root" === this.ancestor) return void (this.display = `ref:root:${e}`);
                    if (1 === this.ancestor) return void (this.display = `ref:${e || ".."}`);
                    const t = new Array(this.ancestor + 1).fill(this.separator).join("");
                    this.display = `ref:${t}${e || ""}`;
                }
            }, l.Ref.prototype[i.symbols.ref] = !0, t.build = function(e) {
                return "value" === (e = Object.assign({}, l.defaults, e)).type && void 0 === e.ancestor && (e.ancestor = 1), new l.Ref(e);
            }, l.context = function(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (e = e.trim(), r) {
                    const s = void 0 === r.global ? "$" : r.global;
                    if (s !== t && e.startsWith(s)) return {
                        key: e.slice(s.length),
                        type: "global"
                    };
                    const n = void 0 === r.local ? "#" : r.local;
                    if (n !== t && e.startsWith(n)) return {
                        key: e.slice(n.length),
                        type: "local"
                    };
                    const a = void 0 === r.root ? "/" : r.root;
                    if (a !== t && e.startsWith(a)) return {
                        key: e.slice(a.length),
                        type: "value",
                        root: !0
                    };
                }
                return {
                    key: e,
                    type: "value"
                };
            }, l.ancestor = function(e, t) {
                if (!t) return [
                    1,
                    0
                ];
                if (e[0] !== t) return [
                    1,
                    0
                ];
                if (e[1] !== t) return [
                    0,
                    1
                ];
                let r = 2;
                for(; e[r] === t;)++r;
                return [
                    r - 1,
                    r
                ];
            }, t.toSibling = 0, t.toParent = 1, t.Manager = class {
                constructor(){
                    this.refs = [];
                }
                register(e, s) {
                    if (e) {
                        if (s = void 0 === s ? t.toParent : s, Array.isArray(e)) for (const t of e)this.register(t, s);
                        else if (i.isSchema(e)) for (const t of e._refs.refs)t.ancestor - s >= 0 && this.refs.push({
                            ancestor: t.ancestor - s,
                            root: t.root
                        });
                        else t.isRef(e) && "value" === e.type && e.ancestor - s >= 0 && this.refs.push({
                            ancestor: e.ancestor - s,
                            root: e.root
                        }), o = o || r(3328), o.isTemplate(e) && this.register(e.refs(), s);
                    }
                }
                get length() {
                    return this.refs.length;
                }
                clone() {
                    const e = new t.Manager;
                    return e.refs = n(this.refs), e;
                }
                reset() {
                    this.refs = [];
                }
                roots() {
                    return this.refs.filter((e)=>!e.ancestor).map((e)=>e.root);
                }
            };
        },
        3378: (e, t, r)=>{
            "use strict";
            const s = r(5107), n = {};
            n.wrap = s.string().min(1).max(2).allow(!1), t.preferences = s.object({
                allowUnknown: s.boolean(),
                abortEarly: s.boolean(),
                artifacts: s.boolean(),
                cache: s.boolean(),
                context: s.object(),
                convert: s.boolean(),
                dateFormat: s.valid("date", "iso", "string", "time", "utc"),
                debug: s.boolean(),
                errors: {
                    escapeHtml: s.boolean(),
                    label: s.valid("path", "key", !1),
                    language: [
                        s.string(),
                        s.object().ref()
                    ],
                    render: s.boolean(),
                    stack: s.boolean(),
                    wrap: {
                        label: n.wrap,
                        array: n.wrap,
                        string: n.wrap
                    }
                },
                externals: s.boolean(),
                messages: s.object(),
                noDefaults: s.boolean(),
                nonEnumerables: s.boolean(),
                presence: s.valid("required", "optional", "forbidden"),
                skipFunctions: s.boolean(),
                stripUnknown: s.object({
                    arrays: s.boolean(),
                    objects: s.boolean()
                }).or("arrays", "objects").allow(!0, !1),
                warnings: s.boolean()
            }).strict(), n.nameRx = /^[a-zA-Z0-9]\w*$/, n.rule = s.object({
                alias: s.array().items(s.string().pattern(n.nameRx)).single(),
                args: s.array().items(s.string(), s.object({
                    name: s.string().pattern(n.nameRx).required(),
                    ref: s.boolean(),
                    assert: s.alternatives([
                        s.function(),
                        s.object().schema()
                    ]).conditional("ref", {
                        is: !0,
                        then: s.required()
                    }),
                    normalize: s.function(),
                    message: s.string().when("assert", {
                        is: s.function(),
                        then: s.required()
                    })
                })),
                convert: s.boolean(),
                manifest: s.boolean(),
                method: s.function().allow(!1),
                multi: s.boolean(),
                validate: s.function()
            }), t.extension = s.object({
                type: s.alternatives([
                    s.string(),
                    s.object().regex()
                ]).required(),
                args: s.function(),
                cast: s.object().pattern(n.nameRx, s.object({
                    from: s.function().maxArity(1).required(),
                    to: s.function().minArity(1).maxArity(2).required()
                })),
                base: s.object().schema().when("type", {
                    is: s.object().regex(),
                    then: s.forbidden()
                }),
                coerce: [
                    s.function().maxArity(3),
                    s.object({
                        method: s.function().maxArity(3).required(),
                        from: s.array().items(s.string()).single()
                    })
                ],
                flags: s.object().pattern(n.nameRx, s.object({
                    setter: s.string(),
                    default: s.any()
                })),
                manifest: {
                    build: s.function().arity(2)
                },
                messages: [
                    s.object(),
                    s.string()
                ],
                modifiers: s.object().pattern(n.nameRx, s.function().minArity(1).maxArity(2)),
                overrides: s.object().pattern(n.nameRx, s.function()),
                prepare: s.function().maxArity(3),
                rebuild: s.function().arity(1),
                rules: s.object().pattern(n.nameRx, n.rule),
                terms: s.object().pattern(n.nameRx, s.object({
                    init: s.array().allow(null).required(),
                    manifest: s.object().pattern(/.+/, [
                        s.valid("schema", "single"),
                        s.object({
                            mapped: s.object({
                                from: s.string().required(),
                                to: s.string().required()
                            }).required()
                        })
                    ])
                })),
                validate: s.function().maxArity(3)
            }).strict(), t.extensions = s.array().items(s.object(), s.function().arity(1)).strict(), n.desc = {
                buffer: s.object({
                    buffer: s.string()
                }),
                func: s.object({
                    function: s.function().required(),
                    options: {
                        literal: !0
                    }
                }),
                override: s.object({
                    override: !0
                }),
                ref: s.object({
                    ref: s.object({
                        type: s.valid("value", "global", "local"),
                        path: s.array().required(),
                        separator: s.string().length(1).allow(!1),
                        ancestor: s.number().min(0).integer().allow("root"),
                        map: s.array().items(s.array().length(2)).min(1),
                        adjust: s.function(),
                        iterables: s.boolean(),
                        in: s.boolean(),
                        render: s.boolean()
                    }).required()
                }),
                regex: s.object({
                    regex: s.string().min(3)
                }),
                special: s.object({
                    special: s.valid("deep").required()
                }),
                template: s.object({
                    template: s.string().required(),
                    options: s.object()
                }),
                value: s.object({
                    value: s.alternatives([
                        s.object(),
                        s.array()
                    ]).required()
                })
            }, n.desc.entity = s.alternatives([
                s.array().items(s.link("...")),
                s.boolean(),
                s.function(),
                s.number(),
                s.string(),
                n.desc.buffer,
                n.desc.func,
                n.desc.ref,
                n.desc.regex,
                n.desc.special,
                n.desc.template,
                n.desc.value,
                s.link("/")
            ]), n.desc.values = s.array().items(null, s.boolean(), s.function(), s.number().allow(1 / 0, -1 / 0), s.string().allow(""), s.symbol(), n.desc.buffer, n.desc.func, n.desc.override, n.desc.ref, n.desc.regex, n.desc.template, n.desc.value), n.desc.messages = s.object().pattern(/.+/, [
                s.string(),
                n.desc.template,
                s.object().pattern(/.+/, [
                    s.string(),
                    n.desc.template
                ])
            ]), t.description = s.object({
                type: s.string().required(),
                flags: s.object({
                    cast: s.string(),
                    default: s.any(),
                    description: s.string(),
                    empty: s.link("/"),
                    failover: n.desc.entity,
                    id: s.string(),
                    label: s.string(),
                    only: !0,
                    presence: [
                        "optional",
                        "required",
                        "forbidden"
                    ],
                    result: [
                        "raw",
                        "strip"
                    ],
                    strip: s.boolean(),
                    unit: s.string()
                }).unknown(),
                preferences: {
                    allowUnknown: s.boolean(),
                    abortEarly: s.boolean(),
                    artifacts: s.boolean(),
                    cache: s.boolean(),
                    convert: s.boolean(),
                    dateFormat: [
                        "date",
                        "iso",
                        "string",
                        "time",
                        "utc"
                    ],
                    errors: {
                        escapeHtml: s.boolean(),
                        label: [
                            "path",
                            "key"
                        ],
                        language: [
                            s.string(),
                            n.desc.ref
                        ],
                        wrap: {
                            label: n.wrap,
                            array: n.wrap
                        }
                    },
                    externals: s.boolean(),
                    messages: n.desc.messages,
                    noDefaults: s.boolean(),
                    nonEnumerables: s.boolean(),
                    presence: [
                        "required",
                        "optional",
                        "forbidden"
                    ],
                    skipFunctions: s.boolean(),
                    stripUnknown: s.object({
                        arrays: s.boolean(),
                        objects: s.boolean()
                    }).or("arrays", "objects").allow(!0, !1),
                    warnings: s.boolean()
                },
                allow: n.desc.values,
                invalid: n.desc.values,
                rules: s.array().min(1).items({
                    name: s.string().required(),
                    args: s.object().min(1),
                    keep: s.boolean(),
                    message: [
                        s.string(),
                        n.desc.messages
                    ],
                    warn: s.boolean()
                }),
                keys: s.object().pattern(/.*/, s.link("/")),
                link: n.desc.ref
            }).pattern(/^[a-z]\w*$/, s.any());
        },
        493: (e, t, r)=>{
            "use strict";
            const s = r(8571), n = r(9621), a = r(8160), i = {
                value: Symbol("value")
            };
            e.exports = i.State = class {
                constructor(e, t, r){
                    this.path = e, this.ancestors = t, this.mainstay = r.mainstay, this.schemas = r.schemas, this.debug = null;
                }
                localize(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                    const s = new i.State(e, t, this);
                    return r && s.schemas && (s.schemas = [
                        i.schemas(r),
                        ...s.schemas
                    ]), s;
                }
                nest(e, t) {
                    const r = new i.State(this.path, this.ancestors, this);
                    return r.schemas = r.schemas && [
                        i.schemas(e),
                        ...r.schemas
                    ], r.debug = t, r;
                }
                shadow(e, t) {
                    this.mainstay.shadow = this.mainstay.shadow || new i.Shadow, this.mainstay.shadow.set(this.path, e, t);
                }
                snapshot() {
                    this.mainstay.shadow && (this._snapshot = s(this.mainstay.shadow.node(this.path))), this.mainstay.snapshot();
                }
                restore() {
                    this.mainstay.shadow && (this.mainstay.shadow.override(this.path, this._snapshot), this._snapshot = void 0), this.mainstay.restore();
                }
            }, i.schemas = function(e) {
                return a.isSchema(e) ? {
                    schema: e
                } : e;
            }, i.Shadow = class {
                constructor(){
                    this._values = null;
                }
                set(e, t, r) {
                    if (!e.length) return;
                    if ("strip" === r && "number" == typeof e[e.length - 1]) return;
                    this._values = this._values || new Map;
                    let s = this._values;
                    for(let t = 0; t < e.length; ++t){
                        const r = e[t];
                        let n = s.get(r);
                        n || (n = new Map, s.set(r, n)), s = n;
                    }
                    s[i.value] = t;
                }
                get(e) {
                    const t = this.node(e);
                    if (t) return t[i.value];
                }
                node(e) {
                    if (this._values) return n(this._values, e, {
                        iterables: !0
                    });
                }
                override(e, t) {
                    if (!this._values) return;
                    const r = e.slice(0, -1), s = e[e.length - 1], a = n(this._values, r, {
                        iterables: !0
                    });
                    t ? a.set(s, t) : a && a.delete(s);
                }
            };
        },
        3328: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(5277), i = r(1447), o = r(8160), l = r(6354), c = r(6133), u = {
                symbol: Symbol("template"),
                opens: new Array(1e3).join("\0"),
                closes: new Array(1e3).join("\x01"),
                dateFormat: {
                    date: Date.prototype.toDateString,
                    iso: Date.prototype.toISOString,
                    string: Date.prototype.toString,
                    time: Date.prototype.toTimeString,
                    utc: Date.prototype.toUTCString
                }
            };
            e.exports = u.Template = class {
                constructor(e, t){
                    s("string" == typeof e, "Template source must be a string"), s(!e.includes("\0") && !e.includes("\x01"), "Template source cannot contain reserved control characters"), this.source = e, this.rendered = e, this._template = null, this._settings = n(t), this._parse();
                }
                _parse() {
                    if (!this.source.includes("{")) return;
                    const e = u.encode(this.source), t = u.split(e);
                    let r = !1;
                    const s = [], n = t.shift();
                    n && s.push(n);
                    for (const e of t){
                        const t = "{" !== e[0], n = t ? "}" : "}}", a = e.indexOf(n);
                        if (-1 === a || "{" === e[1]) {
                            s.push(`{${u.decode(e)}`);
                            continue;
                        }
                        let i = e.slice(t ? 0 : 1, a);
                        const o = ":" === i[0];
                        o && (i = i.slice(1));
                        const l = this._ref(u.decode(i), {
                            raw: t,
                            wrapped: o
                        });
                        s.push(l), "string" != typeof l && (r = !0);
                        const c = e.slice(a + n.length);
                        c && s.push(u.decode(c));
                    }
                    r ? this._template = s : this.rendered = s.join("");
                }
                static date(e, t) {
                    return u.dateFormat[t.dateFormat].call(e);
                }
                describe() {
                    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    if (!this._settings && e.compact) return this.source;
                    const t = {
                        template: this.source
                    };
                    return this._settings && (t.options = this._settings), t;
                }
                static build(e) {
                    return new u.Template(e.template, e.options);
                }
                isDynamic() {
                    return !!this._template;
                }
                static isTemplate(e) {
                    return !!e && !!e[o.symbols.template];
                }
                refs() {
                    if (!this._template) return;
                    const e = [];
                    for (const t of this._template)"string" != typeof t && e.push(...t.refs);
                    return e;
                }
                resolve(e, t, r, s) {
                    return this._template && 1 === this._template.length ? this._part(this._template[0], e, t, r, s, {}) : this.render(e, t, r, s);
                }
                _part(e) {
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)r[s - 1] = arguments[s];
                    return e.ref ? e.ref.resolve(...r) : e.formula.evaluate(r);
                }
                render(e, t, r, s) {
                    let n = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
                    if (!this.isDynamic()) return this.rendered;
                    const i = [];
                    for (const o of this._template)if ("string" == typeof o) i.push(o);
                    else {
                        const l = this._part(o, e, t, r, s, n), c = u.stringify(l, e, t, r, s, n);
                        if (void 0 !== c) {
                            const e = o.raw || !1 === (n.errors && n.errors.escapeHtml) ? c : a(c);
                            i.push(u.wrap(e, o.wrapped && r.errors.wrap.label));
                        }
                    }
                    return i.join("");
                }
                _ref(e, t) {
                    let { raw: r, wrapped: s } = t;
                    const n = [], a = (e)=>{
                        const t = c.create(e, this._settings);
                        return n.push(t), (e)=>t.resolve(...e);
                    };
                    try {
                        var o = new i.Parser(e, {
                            reference: a,
                            functions: u.functions,
                            constants: u.constants
                        });
                    } catch (t) {
                        throw t.message = `Invalid template variable "${e}" fails due to: ${t.message}`, t;
                    }
                    if (o.single) {
                        if ("reference" === o.single.type) {
                            const e = n[0];
                            return {
                                ref: e,
                                raw: r,
                                refs: n,
                                wrapped: s || "local" === e.type && "label" === e.key
                            };
                        }
                        return u.stringify(o.single.value);
                    }
                    return {
                        formula: o,
                        raw: r,
                        refs: n
                    };
                }
                toString() {
                    return this.source;
                }
            }, u.Template.prototype[o.symbols.template] = !0, u.Template.prototype.isImmutable = !0, u.encode = function(e) {
                return e.replace(/\\(\{+)/g, (e, t)=>u.opens.slice(0, t.length)).replace(/\\(\}+)/g, (e, t)=>u.closes.slice(0, t.length));
            }, u.decode = function(e) {
                return e.replace(/\u0000/g, "{").replace(/\u0001/g, "}");
            }, u.split = function(e) {
                const t = [];
                let r = "";
                for(let s = 0; s < e.length; ++s){
                    const n = e[s];
                    if ("{" === n) {
                        let n = "";
                        for(; s + 1 < e.length && "{" === e[s + 1];)n += "{", ++s;
                        t.push(r), r = n;
                    } else r += n;
                }
                return t.push(r), t;
            }, u.wrap = function(e, t) {
                return t ? 1 === t.length ? `${t}${e}${t}` : `${t[0]}${e}${t[1]}` : e;
            }, u.stringify = function(e, t, r, s, n) {
                let a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
                const i = typeof e, o = s && s.errors && s.errors.wrap || {};
                let l = !1;
                if (c.isRef(e) && e.render && (l = e.in, e = e.resolve(t, r, s, n, {
                    in: e.in,
                    ...a
                })), null === e) return "null";
                if ("string" === i) return u.wrap(e, a.arrayItems && o.string);
                if ("number" === i || "function" === i || "symbol" === i) return e.toString();
                if ("object" !== i) return JSON.stringify(e);
                if (e instanceof Date) return u.Template.date(e, s);
                if (e instanceof Map) {
                    const t = [];
                    for (const [r, s] of e.entries())t.push(`${r.toString()} -> ${s.toString()}`);
                    e = t;
                }
                if (!Array.isArray(e)) return e.toString();
                const f = [];
                for (const i of e)f.push(u.stringify(i, t, r, s, n, {
                    arrayItems: !0,
                    ...a
                }));
                return u.wrap(f.join(", "), !l && o.array);
            }, u.constants = {
                true: !0,
                false: !1,
                null: null,
                second: 1e3,
                minute: 6e4,
                hour: 36e5,
                day: 864e5
            }, u.functions = {
                if: (e, t, r)=>e ? t : r,
                length: (e)=>"string" == typeof e ? e.length : e && "object" == typeof e ? Array.isArray(e) ? e.length : Object.keys(e).length : null,
                msg (e) {
                    const [t, r, s, n, a] = this, i = a.messages;
                    if (!i) return "";
                    const o = l.template(t, i[0], e, r, s) || l.template(t, i[1], e, r, s);
                    return o ? o.render(t, r, s, n, a) : "";
                },
                number: (e)=>"number" == typeof e ? e : "string" == typeof e ? parseFloat(e) : "boolean" == typeof e ? e ? 1 : 0 : e instanceof Date ? e.getTime() : null
            };
        },
        4946: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(1687), a = r(8068), i = r(8160), o = r(3292), l = r(6354), c = r(6133), u = {};
            e.exports = a.extend({
                type: "alternatives",
                flags: {
                    match: {
                        default: "any"
                    }
                },
                terms: {
                    matches: {
                        init: [],
                        register: c.toSibling
                    }
                },
                args (e) {
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)r[s - 1] = arguments[s];
                    return 1 === r.length && Array.isArray(r[0]) ? e.try(...r[0]) : e.try(...r);
                },
                validate (e, t) {
                    const { schema: r, error: s, state: a, prefs: i } = t;
                    if (r._flags.match) {
                        const t = [], o = [];
                        for(let s = 0; s < r.$_terms.matches.length; ++s){
                            const n = r.$_terms.matches[s], l = a.nest(n.schema, `match.${s}`);
                            l.snapshot();
                            const c = n.schema.$_validate(e, l, i);
                            c.errors ? (o.push(c.errors), l.restore()) : t.push(c.value);
                        }
                        if (0 === t.length) return {
                            errors: s("alternatives.any", {
                                details: o.map((e)=>l.details(e, {
                                        override: !1
                                    }))
                            })
                        };
                        if ("one" === r._flags.match) return 1 === t.length ? {
                            value: t[0]
                        } : {
                            errors: s("alternatives.one")
                        };
                        if (t.length !== r.$_terms.matches.length) return {
                            errors: s("alternatives.all", {
                                details: o.map((e)=>l.details(e, {
                                        override: !1
                                    }))
                            })
                        };
                        const c = (e)=>e.$_terms.matches.some((e)=>"object" === e.schema.type || "alternatives" === e.schema.type && c(e.schema));
                        return c(r) ? {
                            value: t.reduce((e, t)=>n(e, t, {
                                    mergeArrays: !1
                                }))
                        } : {
                            value: t[t.length - 1]
                        };
                    }
                    const o = [];
                    for(let t = 0; t < r.$_terms.matches.length; ++t){
                        const s = r.$_terms.matches[t];
                        if (s.schema) {
                            const r = a.nest(s.schema, `match.${t}`);
                            r.snapshot();
                            const n = s.schema.$_validate(e, r, i);
                            if (!n.errors) return n;
                            r.restore(), o.push({
                                schema: s.schema,
                                reports: n.errors
                            });
                            continue;
                        }
                        const n = s.ref ? s.ref.resolve(e, a, i) : e, l = s.is ? [
                            s
                        ] : s.switch;
                        for(let r = 0; r < l.length; ++r){
                            const o = l[r], { is: c, then: u, otherwise: f } = o, h = `match.${t}${s.switch ? "." + r : ""}`;
                            if (c.$_match(n, a.nest(c, `${h}.is`), i)) {
                                if (u) return u.$_validate(e, a.nest(u, `${h}.then`), i);
                            } else if (f) return f.$_validate(e, a.nest(f, `${h}.otherwise`), i);
                        }
                    }
                    return u.errors(o, t);
                },
                rules: {
                    conditional: {
                        method (e, t) {
                            s(!this._flags._endedSwitch, "Unreachable condition"), s(!this._flags.match, "Cannot combine match mode", this._flags.match, "with conditional rule"), s(void 0 === t.break, "Cannot use break option with alternatives conditional");
                            const r = this.clone(), n = o.when(r, e, t), a = n.is ? [
                                n
                            ] : n.switch;
                            for (const e of a)if (e.then && e.otherwise) {
                                r.$_setFlag("_endedSwitch", !0, {
                                    clone: !1
                                });
                                break;
                            }
                            return r.$_terms.matches.push(n), r.$_mutateRebuild();
                        }
                    },
                    match: {
                        method (e) {
                            if (s([
                                "any",
                                "one",
                                "all"
                            ].includes(e), "Invalid alternatives match mode", e), "any" !== e) for (const t of this.$_terms.matches)s(t.schema, "Cannot combine match mode", e, "with conditional rules");
                            return this.$_setFlag("match", e);
                        }
                    },
                    try: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            s(t.length, "Missing alternative schemas"), i.verifyFlat(t, "try"), s(!this._flags._endedSwitch, "Unreachable condition");
                            const n = this.clone();
                            for (const e of t)n.$_terms.matches.push({
                                schema: n.$_compile(e)
                            });
                            return n.$_mutateRebuild();
                        }
                    }
                },
                overrides: {
                    label (e) {
                        return this.$_parent("label", e).$_modify({
                            each: (t, r)=>"is" !== r.path[0] ? t.label(e) : void 0,
                            ref: !1
                        });
                    }
                },
                rebuild (e) {
                    e.$_modify({
                        each: (t)=>{
                            i.isSchema(t) && "array" === t.type && e.$_setFlag("_arrayItems", !0, {
                                clone: !1
                            });
                        }
                    });
                },
                manifest: {
                    build (e, t) {
                        if (t.matches) for (const r of t.matches){
                            const { schema: t, ref: s, is: n, not: a, then: i, otherwise: o } = r;
                            e = t ? e.try(t) : s ? e.conditional(s, {
                                is: n,
                                then: i,
                                not: a,
                                otherwise: o,
                                switch: r.switch
                            }) : e.conditional(n, {
                                then: i,
                                otherwise: o
                            });
                        }
                        return e;
                    }
                },
                messages: {
                    "alternatives.all": "{{#label}} does not match all of the required types",
                    "alternatives.any": "{{#label}} does not match any of the allowed types",
                    "alternatives.match": "{{#label}} does not match any of the allowed types",
                    "alternatives.one": "{{#label}} matches more than one allowed type",
                    "alternatives.types": "{{#label}} must be one of {{#types}}"
                }
            }), u.errors = function(e, t) {
                let { error: r, state: s } = t;
                if (!e.length) return {
                    errors: r("alternatives.any")
                };
                if (1 === e.length) return {
                    errors: e[0].reports
                };
                const n = new Set, a = [];
                for (const { reports: t, schema: i } of e){
                    if (t.length > 1) return u.unmatched(e, r);
                    const o = t[0];
                    if (o instanceof l.Report == 0) return u.unmatched(e, r);
                    if (o.state.path.length !== s.path.length) {
                        a.push({
                            type: i.type,
                            report: o
                        });
                        continue;
                    }
                    if ("any.only" === o.code) {
                        for (const e of o.local.valids)n.add(e);
                        continue;
                    }
                    const [c, f] = o.code.split(".");
                    "base" === f ? n.add(c) : a.push({
                        type: i.type,
                        report: o
                    });
                }
                return a.length ? 1 === a.length ? {
                    errors: a[0].report
                } : u.unmatched(e, r) : {
                    errors: r("alternatives.types", {
                        types: [
                            ...n
                        ]
                    })
                };
            }, u.unmatched = function(e, t) {
                const r = [];
                for (const t of e)r.push(...t.reports);
                return {
                    errors: t("alternatives.match", l.details(r, {
                        override: !1
                    }))
                };
            };
        },
        8068: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(7629), a = r(8160), i = r(6914);
            e.exports = n.extend({
                type: "any",
                flags: {
                    only: {
                        default: !1
                    }
                },
                terms: {
                    alterations: {
                        init: null
                    },
                    examples: {
                        init: null
                    },
                    externals: {
                        init: null
                    },
                    metas: {
                        init: []
                    },
                    notes: {
                        init: []
                    },
                    shared: {
                        init: null
                    },
                    tags: {
                        init: []
                    },
                    whens: {
                        init: null
                    }
                },
                rules: {
                    custom: {
                        method (e, t) {
                            return s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this.$_addRule({
                                name: "custom",
                                args: {
                                    method: e,
                                    description: t
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { method: s } = r;
                            try {
                                return s(e, t);
                            } catch (e) {
                                return t.error("any.custom", {
                                    error: e
                                });
                            }
                        },
                        args: [
                            "method",
                            "description"
                        ],
                        multi: !0
                    },
                    messages: {
                        method (e) {
                            return this.prefs({
                                messages: e
                            });
                        }
                    },
                    shared: {
                        method (e) {
                            s(a.isSchema(e) && e._flags.id, "Schema must be a schema with an id");
                            const t = this.clone();
                            return t.$_terms.shared = t.$_terms.shared || [], t.$_terms.shared.push(e), t.$_mutateRegister(e), t;
                        }
                    },
                    warning: {
                        method (e, t) {
                            return s(e && "string" == typeof e, "Invalid warning code"), this.$_addRule({
                                name: "warning",
                                args: {
                                    code: e,
                                    local: t
                                },
                                warn: !0
                            });
                        },
                        validate (e, t, r) {
                            let { code: s, local: n } = r;
                            return t.error(s, n);
                        },
                        args: [
                            "code",
                            "local"
                        ],
                        multi: !0
                    }
                },
                modifiers: {
                    keep (e) {
                        let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                        e.keep = t;
                    },
                    message (e, t) {
                        e.message = i.compile(t);
                    },
                    warn (e) {
                        let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                        e.warn = t;
                    }
                },
                manifest: {
                    build (e, t) {
                        for(const r in t){
                            const s = t[r];
                            if ([
                                "examples",
                                "externals",
                                "metas",
                                "notes",
                                "tags"
                            ].includes(r)) for (const t of s)e = e[r.slice(0, -1)](t);
                            else if ("alterations" !== r) {
                                if ("whens" !== r) {
                                    if ("shared" === r) for (const t of s)e = e.shared(t);
                                } else for (const t of s){
                                    const { ref: r, is: s, not: n, then: a, otherwise: i, concat: o } = t;
                                    e = o ? e.concat(o) : r ? e.when(r, {
                                        is: s,
                                        not: n,
                                        then: a,
                                        otherwise: i,
                                        switch: t.switch,
                                        break: t.break
                                    }) : e.when(s, {
                                        then: a,
                                        otherwise: i,
                                        break: t.break
                                    });
                                }
                            } else {
                                const t = {};
                                for (const { target: e, adjuster: r } of s)t[e] = r;
                                e = e.alter(t);
                            }
                        }
                        return e;
                    }
                },
                messages: {
                    "any.custom": "{{#label}} failed custom validation because {{#error.message}}",
                    "any.default": "{{#label}} threw an error when running default method",
                    "any.failover": "{{#label}} threw an error when running failover method",
                    "any.invalid": "{{#label}} contains an invalid value",
                    "any.only": '{{#label}} must be {if(#valids.length == 1, "", "one of ")}{{#valids}}',
                    "any.ref": "{{#label}} {{#arg}} references {{:#ref}} which {{#reason}}",
                    "any.required": "{{#label}} is required",
                    "any.unknown": "{{#label}} is not allowed"
                }
            });
        },
        546: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(9474), a = r(9621), i = r(8068), o = r(8160), l = r(3292), c = {};
            e.exports = i.extend({
                type: "array",
                flags: {
                    single: {
                        default: !1
                    },
                    sparse: {
                        default: !1
                    }
                },
                terms: {
                    items: {
                        init: [],
                        manifest: "schema"
                    },
                    ordered: {
                        init: [],
                        manifest: "schema"
                    },
                    _exclusions: {
                        init: []
                    },
                    _inclusions: {
                        init: []
                    },
                    _requireds: {
                        init: []
                    }
                },
                coerce: {
                    from: "object",
                    method (e, t) {
                        let { schema: r, state: s, prefs: n } = t;
                        if (!Array.isArray(e)) return;
                        const a = r.$_getRule("sort");
                        return a ? c.sort(r, e, a.args.options, s, n) : void 0;
                    }
                },
                validate (e, t) {
                    let { schema: r, error: s } = t;
                    if (!Array.isArray(e)) {
                        if (r._flags.single) {
                            const t = [
                                e
                            ];
                            return t[o.symbols.arraySingle] = !0, {
                                value: t
                            };
                        }
                        return {
                            errors: s("array.base")
                        };
                    }
                    if (r.$_getRule("items") || r.$_terms.externals) return {
                        value: e.slice()
                    };
                },
                rules: {
                    has: {
                        method (e) {
                            e = this.$_compile(e, {
                                appendPath: !0
                            });
                            const t = this.$_addRule({
                                name: "has",
                                args: {
                                    schema: e
                                }
                            });
                            return t.$_mutateRegister(e), t;
                        },
                        validate (e, t, r) {
                            let { state: s, prefs: n, error: a } = t, { schema: i } = r;
                            const o = [
                                e,
                                ...s.ancestors
                            ];
                            for(let t = 0; t < e.length; ++t){
                                const r = s.localize([
                                    ...s.path,
                                    t
                                ], o, i);
                                if (i.$_match(e[t], r, n)) return e;
                            }
                            const l = i._flags.label;
                            return l ? a("array.hasKnown", {
                                patternLabel: l
                            }) : a("array.hasUnknown", null);
                        },
                        multi: !0
                    },
                    items: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            o.verifyFlat(t, "items");
                            const s = this.$_addRule("items");
                            for(let e = 0; e < t.length; ++e){
                                const r = o.tryWithPath(()=>this.$_compile(t[e]), e, {
                                    append: !0
                                });
                                s.$_terms.items.push(r);
                            }
                            return s.$_mutateRebuild();
                        },
                        validate (e, t) {
                            let { schema: r, error: s, state: n, prefs: a, errorsArray: i } = t;
                            const l = r.$_terms._requireds.slice(), u = r.$_terms.ordered.slice(), f = [
                                ...r.$_terms._inclusions,
                                ...l
                            ], h = !e[o.symbols.arraySingle];
                            delete e[o.symbols.arraySingle];
                            const m = i();
                            let d = e.length;
                            for(let t = 0; t < d; ++t){
                                const i = e[t];
                                let o = !1, p = !1;
                                const g = h ? t : new Number(t), y = [
                                    ...n.path,
                                    g
                                ];
                                if (!r._flags.sparse && void 0 === i) {
                                    if (m.push(s("array.sparse", {
                                        key: g,
                                        path: y,
                                        pos: t,
                                        value: void 0
                                    }, n.localize(y))), a.abortEarly) return m;
                                    u.shift();
                                    continue;
                                }
                                const b = [
                                    e,
                                    ...n.ancestors
                                ];
                                for (const e of r.$_terms._exclusions)if (e.$_match(i, n.localize(y, b, e), a, {
                                    presence: "ignore"
                                })) {
                                    if (m.push(s("array.excludes", {
                                        pos: t,
                                        value: i
                                    }, n.localize(y))), a.abortEarly) return m;
                                    o = !0, u.shift();
                                    break;
                                }
                                if (o) continue;
                                if (r.$_terms.ordered.length) {
                                    if (u.length) {
                                        const o = u.shift(), l = o.$_validate(i, n.localize(y, b, o), a);
                                        if (l.errors) {
                                            if (m.push(...l.errors), a.abortEarly) return m;
                                        } else if ("strip" === o._flags.result) c.fastSplice(e, t), --t, --d;
                                        else {
                                            if (!r._flags.sparse && void 0 === l.value) {
                                                if (m.push(s("array.sparse", {
                                                    key: g,
                                                    path: y,
                                                    pos: t,
                                                    value: void 0
                                                }, n.localize(y))), a.abortEarly) return m;
                                                continue;
                                            }
                                            e[t] = l.value;
                                        }
                                        continue;
                                    }
                                    if (!r.$_terms.items.length) {
                                        if (m.push(s("array.orderedLength", {
                                            pos: t,
                                            limit: r.$_terms.ordered.length
                                        })), a.abortEarly) return m;
                                        break;
                                    }
                                }
                                const v = [];
                                let _ = l.length;
                                for(let o = 0; o < _; ++o){
                                    const u = n.localize(y, b, l[o]);
                                    u.snapshot();
                                    const f = l[o].$_validate(i, u, a);
                                    if (v[o] = f, !f.errors) {
                                        if (e[t] = f.value, p = !0, c.fastSplice(l, o), --o, --_, !r._flags.sparse && void 0 === f.value && (m.push(s("array.sparse", {
                                            key: g,
                                            path: y,
                                            pos: t,
                                            value: void 0
                                        }, n.localize(y))), a.abortEarly)) return m;
                                        break;
                                    }
                                    u.restore();
                                }
                                if (p) continue;
                                const w = a.stripUnknown && !!a.stripUnknown.arrays || !1;
                                _ = f.length;
                                for (const u of f){
                                    let f;
                                    const h = l.indexOf(u);
                                    if (-1 !== h) f = v[h];
                                    else {
                                        const l = n.localize(y, b, u);
                                        if (l.snapshot(), f = u.$_validate(i, l, a), !f.errors) {
                                            "strip" === u._flags.result ? (c.fastSplice(e, t), --t, --d) : r._flags.sparse || void 0 !== f.value ? e[t] = f.value : (m.push(s("array.sparse", {
                                                key: g,
                                                path: y,
                                                pos: t,
                                                value: void 0
                                            }, n.localize(y))), o = !0), p = !0;
                                            break;
                                        }
                                        l.restore();
                                    }
                                    if (1 === _) {
                                        if (w) {
                                            c.fastSplice(e, t), --t, --d, p = !0;
                                            break;
                                        }
                                        if (m.push(...f.errors), a.abortEarly) return m;
                                        o = !0;
                                        break;
                                    }
                                }
                                if (!o && (r.$_terms._inclusions.length || r.$_terms._requireds.length) && !p) {
                                    if (w) {
                                        c.fastSplice(e, t), --t, --d;
                                        continue;
                                    }
                                    if (m.push(s("array.includes", {
                                        pos: t,
                                        value: i
                                    }, n.localize(y))), a.abortEarly) return m;
                                }
                            }
                            return l.length && c.fillMissedErrors(r, m, l, e, n, a), u.length && (c.fillOrderedErrors(r, m, u, e, n, a), m.length || c.fillDefault(u, e, n, a)), m.length ? m : e;
                        },
                        priority: !0,
                        manifest: !1
                    },
                    length: {
                        method (e) {
                            return this.$_addRule({
                                name: "length",
                                args: {
                                    limit: e
                                },
                                operator: "="
                            });
                        },
                        validate (e, t, r, s) {
                            let { limit: n } = r, { name: a, operator: i, args: l } = s;
                            return o.compare(e.length, n, i) ? e : t.error("array." + a, {
                                limit: l.limit,
                                value: e
                            });
                        },
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: o.limit,
                                message: "must be a positive integer"
                            }
                        ]
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    ordered: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            o.verifyFlat(t, "ordered");
                            const s = this.$_addRule("items");
                            for(let e = 0; e < t.length; ++e){
                                const r = o.tryWithPath(()=>this.$_compile(t[e]), e, {
                                    append: !0
                                });
                                c.validateSingle(r, s), s.$_mutateRegister(r), s.$_terms.ordered.push(r);
                            }
                            return s.$_mutateRebuild();
                        }
                    },
                    single: {
                        method (e) {
                            const t = void 0 === e || !!e;
                            return s(!t || !this._flags._arrayItems, "Cannot specify single rule when array has array items"), this.$_setFlag("single", t);
                        }
                    },
                    sort: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            o.assertOptions(e, [
                                "by",
                                "order"
                            ]);
                            const t = {
                                order: e.order || "ascending"
                            };
                            return e.by && (t.by = l.ref(e.by, {
                                ancestor: 0
                            }), s(!t.by.ancestor, "Cannot sort by ancestor")), this.$_addRule({
                                name: "sort",
                                args: {
                                    options: t
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { error: s, state: n, prefs: a, schema: i } = t, { options: o } = r;
                            const { value: l, errors: u } = c.sort(i, e, o, n, a);
                            if (u) return u;
                            for(let t = 0; t < e.length; ++t)if (e[t] !== l[t]) return s("array.sort", {
                                order: o.order,
                                by: o.by ? o.by.key : "value"
                            });
                            return e;
                        },
                        convert: !0
                    },
                    sparse: {
                        method (e) {
                            const t = void 0 === e || !!e;
                            return this._flags.sparse === t ? this : (t ? this.clone() : this.$_addRule("items")).$_setFlag("sparse", t, {
                                clone: !1
                            });
                        }
                    },
                    unique: {
                        method (e) {
                            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            s(!e || "function" == typeof e || "string" == typeof e, "comparator must be a function or a string"), o.assertOptions(t, [
                                "ignoreUndefined",
                                "separator"
                            ]);
                            const r = {
                                name: "unique",
                                args: {
                                    options: t,
                                    comparator: e
                                }
                            };
                            if (e) {
                                if ("string" == typeof e) {
                                    const s = o.default(t.separator, ".");
                                    r.path = s ? e.split(s) : [
                                        e
                                    ];
                                } else r.comparator = e;
                            }
                            return this.$_addRule(r);
                        },
                        validate (e, t, r, i) {
                            let { state: o, error: l, schema: c } = t, { comparator: u, options: f } = r, { comparator: h, path: m } = i;
                            const d = {
                                string: Object.create(null),
                                number: Object.create(null),
                                undefined: Object.create(null),
                                boolean: Object.create(null),
                                object: new Map,
                                function: new Map,
                                custom: new Map
                            }, p = h || n, g = f.ignoreUndefined;
                            for(let t = 0; t < e.length; ++t){
                                const r = m ? a(e[t], m) : e[t], n = h ? d.custom : d[typeof r];
                                if (s(n, "Failed to find unique map container for type", typeof r), n instanceof Map) {
                                    const s = n.entries();
                                    let a;
                                    for(; !(a = s.next()).done;)if (p(a.value[0], r)) {
                                        const r = o.localize([
                                            ...o.path,
                                            t
                                        ], [
                                            e,
                                            ...o.ancestors
                                        ]), s = {
                                            pos: t,
                                            value: e[t],
                                            dupePos: a.value[1],
                                            dupeValue: e[a.value[1]]
                                        };
                                        return m && (s.path = u), l("array.unique", s, r);
                                    }
                                    n.set(r, t);
                                } else {
                                    if ((!g || void 0 !== r) && void 0 !== n[r]) {
                                        const s = {
                                            pos: t,
                                            value: e[t],
                                            dupePos: n[r],
                                            dupeValue: e[n[r]]
                                        };
                                        return m && (s.path = u), l("array.unique", s, o.localize([
                                            ...o.path,
                                            t
                                        ], [
                                            e,
                                            ...o.ancestors
                                        ]));
                                    }
                                    n[r] = t;
                                }
                            }
                            return e;
                        },
                        args: [
                            "comparator",
                            "options"
                        ],
                        multi: !0
                    }
                },
                cast: {
                    set: {
                        from: Array.isArray,
                        to: (e, t)=>new Set(e)
                    }
                },
                rebuild (e) {
                    e.$_terms._inclusions = [], e.$_terms._exclusions = [], e.$_terms._requireds = [];
                    for (const t of e.$_terms.items)c.validateSingle(t, e), "required" === t._flags.presence ? e.$_terms._requireds.push(t) : "forbidden" === t._flags.presence ? e.$_terms._exclusions.push(t) : e.$_terms._inclusions.push(t);
                    for (const t of e.$_terms.ordered)c.validateSingle(t, e);
                },
                manifest: {
                    build: (e, t)=>(t.items && (e = e.items(...t.items)), t.ordered && (e = e.ordered(...t.ordered)), e)
                },
                messages: {
                    "array.base": "{{#label}} must be an array",
                    "array.excludes": "{{#label}} contains an excluded value",
                    "array.hasKnown": "{{#label}} does not contain at least one required match for type {:#patternLabel}",
                    "array.hasUnknown": "{{#label}} does not contain at least one required match",
                    "array.includes": "{{#label}} does not match any of the allowed types",
                    "array.includesRequiredBoth": "{{#label}} does not contain {{#knownMisses}} and {{#unknownMisses}} other required value(s)",
                    "array.includesRequiredKnowns": "{{#label}} does not contain {{#knownMisses}}",
                    "array.includesRequiredUnknowns": "{{#label}} does not contain {{#unknownMisses}} required value(s)",
                    "array.length": "{{#label}} must contain {{#limit}} items",
                    "array.max": "{{#label}} must contain less than or equal to {{#limit}} items",
                    "array.min": "{{#label}} must contain at least {{#limit}} items",
                    "array.orderedLength": "{{#label}} must contain at most {{#limit}} items",
                    "array.sort": "{{#label}} must be sorted in {#order} order by {{#by}}",
                    "array.sort.mismatching": "{{#label}} cannot be sorted due to mismatching types",
                    "array.sort.unsupported": "{{#label}} cannot be sorted due to unsupported type {#type}",
                    "array.sparse": "{{#label}} must not be a sparse array item",
                    "array.unique": "{{#label}} contains a duplicate value"
                }
            }), c.fillMissedErrors = function(e, t, r, s, n, a) {
                const i = [];
                let o = 0;
                for (const e of r){
                    const t = e._flags.label;
                    t ? i.push(t) : ++o;
                }
                i.length ? o ? t.push(e.$_createError("array.includesRequiredBoth", s, {
                    knownMisses: i,
                    unknownMisses: o
                }, n, a)) : t.push(e.$_createError("array.includesRequiredKnowns", s, {
                    knownMisses: i
                }, n, a)) : t.push(e.$_createError("array.includesRequiredUnknowns", s, {
                    unknownMisses: o
                }, n, a));
            }, c.fillOrderedErrors = function(e, t, r, s, n, a) {
                const i = [];
                for (const e of r)"required" === e._flags.presence && i.push(e);
                i.length && c.fillMissedErrors(e, t, i, s, n, a);
            }, c.fillDefault = function(e, t, r, s) {
                const n = [];
                let a = !0;
                for(let i = e.length - 1; i >= 0; --i){
                    const o = e[i], l = [
                        t,
                        ...r.ancestors
                    ], c = o.$_validate(void 0, r.localize(r.path, l, o), s).value;
                    if (a) {
                        if (void 0 === c) continue;
                        a = !1;
                    }
                    n.unshift(c);
                }
                n.length && t.push(...n);
            }, c.fastSplice = function(e, t) {
                let r = t;
                for(; r < e.length;)e[r++] = e[r];
                --e.length;
            }, c.validateSingle = function(e, t) {
                ("array" === e.type || e._flags._arrayItems) && (s(!t._flags.single, "Cannot specify array item with single rule enabled"), t.$_setFlag("_arrayItems", !0, {
                    clone: !1
                }));
            }, c.sort = function(e, t, r, s, n) {
                const a = "ascending" === r.order ? 1 : -1, i = -1 * a, o = a, l = (l, u)=>{
                    let f = c.compare(l, u, i, o);
                    if (null !== f) return f;
                    if (r.by && (l = r.by.resolve(l, s, n), u = r.by.resolve(u, s, n)), f = c.compare(l, u, i, o), null !== f) return f;
                    const h = typeof l;
                    if (h !== typeof u) throw e.$_createError("array.sort.mismatching", t, null, s, n);
                    if ("number" !== h && "string" !== h) throw e.$_createError("array.sort.unsupported", t, {
                        type: h
                    }, s, n);
                    return "number" === h ? (l - u) * a : l < u ? i : o;
                };
                try {
                    return {
                        value: t.slice().sort(l)
                    };
                } catch (e) {
                    return {
                        errors: e
                    };
                }
            }, c.compare = function(e, t, r, s) {
                return e === t ? 0 : void 0 === e ? 1 : void 0 === t ? -1 : null === e ? s : null === t ? r : null;
            };
        },
        4937: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8068), a = r(8160), i = r(2036), o = {
                isBool: function(e) {
                    return "boolean" == typeof e;
                }
            };
            e.exports = n.extend({
                type: "boolean",
                flags: {
                    sensitive: {
                        default: !1
                    }
                },
                terms: {
                    falsy: {
                        init: null,
                        manifest: "values"
                    },
                    truthy: {
                        init: null,
                        manifest: "values"
                    }
                },
                coerce (e, t) {
                    let { schema: r } = t;
                    if ("boolean" != typeof e) {
                        if ("string" == typeof e) {
                            const t = r._flags.sensitive ? e : e.toLowerCase();
                            e = "true" === t || "false" !== t && e;
                        }
                        return "boolean" != typeof e && (e = r.$_terms.truthy && r.$_terms.truthy.has(e, null, null, !r._flags.sensitive) || (!r.$_terms.falsy || !r.$_terms.falsy.has(e, null, null, !r._flags.sensitive)) && e), {
                            value: e
                        };
                    }
                },
                validate (e, t) {
                    let { error: r } = t;
                    if ("boolean" != typeof e) return {
                        value: e,
                        errors: r("boolean.base")
                    };
                },
                rules: {
                    truthy: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            a.verifyFlat(t, "truthy");
                            const n = this.clone();
                            n.$_terms.truthy = n.$_terms.truthy || new i;
                            for(let e = 0; e < t.length; ++e){
                                const r = t[e];
                                s(void 0 !== r, "Cannot call truthy with undefined"), n.$_terms.truthy.add(r);
                            }
                            return n;
                        }
                    },
                    falsy: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            a.verifyFlat(t, "falsy");
                            const n = this.clone();
                            n.$_terms.falsy = n.$_terms.falsy || new i;
                            for(let e = 0; e < t.length; ++e){
                                const r = t[e];
                                s(void 0 !== r, "Cannot call falsy with undefined"), n.$_terms.falsy.add(r);
                            }
                            return n;
                        }
                    },
                    sensitive: {
                        method () {
                            let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                            return this.$_setFlag("sensitive", e);
                        }
                    }
                },
                cast: {
                    number: {
                        from: o.isBool,
                        to: (e, t)=>e ? 1 : 0
                    },
                    string: {
                        from: o.isBool,
                        to: (e, t)=>e ? "true" : "false"
                    }
                },
                manifest: {
                    build: (e, t)=>(t.truthy && (e = e.truthy(...t.truthy)), t.falsy && (e = e.falsy(...t.falsy)), e)
                },
                messages: {
                    "boolean.base": "{{#label}} must be a boolean"
                }
            });
        },
        7500: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8068), a = r(8160), i = r(3328), o = {
                isDate: function(e) {
                    return e instanceof Date;
                }
            };
            e.exports = n.extend({
                type: "date",
                coerce: {
                    from: [
                        "number",
                        "string"
                    ],
                    method (e, t) {
                        let { schema: r } = t;
                        return {
                            value: o.parse(e, r._flags.format) || e
                        };
                    }
                },
                validate (e, t) {
                    let { schema: r, error: s, prefs: n } = t;
                    if (e instanceof Date && !isNaN(e.getTime())) return;
                    const a = r._flags.format;
                    return n.convert && a && "string" == typeof e ? {
                        value: e,
                        errors: s("date.format", {
                            format: a
                        })
                    } : {
                        value: e,
                        errors: s("date.base")
                    };
                },
                rules: {
                    compare: {
                        method: !1,
                        validate (e, t, r, s) {
                            let { date: n } = r, { name: i, operator: o, args: l } = s;
                            const c = "now" === n ? Date.now() : n.getTime();
                            return a.compare(e.getTime(), c, o) ? e : t.error("date." + i, {
                                limit: l.date,
                                value: e
                            });
                        },
                        args: [
                            {
                                name: "date",
                                ref: !0,
                                normalize: (e)=>"now" === e ? e : o.parse(e),
                                assert: (e)=>null !== e,
                                message: "must have a valid date format"
                            }
                        ]
                    },
                    format: {
                        method (e) {
                            return s([
                                "iso",
                                "javascript",
                                "unix"
                            ].includes(e), "Unknown date format", e), this.$_setFlag("format", e);
                        }
                    },
                    greater: {
                        method (e) {
                            return this.$_addRule({
                                name: "greater",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: ">"
                            });
                        }
                    },
                    iso: {
                        method () {
                            return this.format("iso");
                        }
                    },
                    less: {
                        method (e) {
                            return this.$_addRule({
                                name: "less",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: "<"
                            });
                        }
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    timestamp: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "javascript";
                            return s([
                                "javascript",
                                "unix"
                            ].includes(e), '"type" must be one of "javascript, unix"'), this.format(e);
                        }
                    }
                },
                cast: {
                    number: {
                        from: o.isDate,
                        to: (e, t)=>e.getTime()
                    },
                    string: {
                        from: o.isDate,
                        to (e, t) {
                            let { prefs: r } = t;
                            return i.date(e, r);
                        }
                    }
                },
                messages: {
                    "date.base": "{{#label}} must be a valid date",
                    "date.format": '{{#label}} must be in {msg("date.format." + #format) || #format} format',
                    "date.greater": "{{#label}} must be greater than {{:#limit}}",
                    "date.less": "{{#label}} must be less than {{:#limit}}",
                    "date.max": "{{#label}} must be less than or equal to {{:#limit}}",
                    "date.min": "{{#label}} must be greater than or equal to {{:#limit}}",
                    "date.format.iso": "ISO 8601 date",
                    "date.format.javascript": "timestamp or number of milliseconds",
                    "date.format.unix": "timestamp or number of seconds"
                }
            }), o.parse = function(e, t) {
                if (e instanceof Date) return e;
                if ("string" != typeof e && (isNaN(e) || !isFinite(e))) return null;
                if (/^\s*$/.test(e)) return null;
                if ("iso" === t) return a.isIsoDate(e) ? o.date(e.toString()) : null;
                const r = e;
                if ("string" == typeof e && /^[+-]?\d+(\.\d+)?$/.test(e) && (e = parseFloat(e)), t) {
                    if ("javascript" === t) return o.date(1 * e);
                    if ("unix" === t) return o.date(1e3 * e);
                    if ("string" == typeof r) return null;
                }
                return o.date(e);
            }, o.date = function(e) {
                const t = new Date(e);
                return isNaN(t.getTime()) ? null : t;
            };
        },
        390: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(7824);
            e.exports = n.extend({
                type: "function",
                properties: {
                    typeof: "function"
                },
                rules: {
                    arity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                                name: "arity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { n: s } = r;
                            return e.length === s ? e : t.error("function.arity", {
                                n: s
                            });
                        }
                    },
                    class: {
                        method () {
                            return this.$_addRule("class");
                        },
                        validate: (e, t)=>/^\s*class\s/.test(e.toString()) ? e : t.error("function.class", {
                                value: e
                            })
                    },
                    minArity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e > 0, "n must be a strict positive integer"), this.$_addRule({
                                name: "minArity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { n: s } = r;
                            return e.length >= s ? e : t.error("function.minArity", {
                                n: s
                            });
                        }
                    },
                    maxArity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                                name: "maxArity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { n: s } = r;
                            return e.length <= s ? e : t.error("function.maxArity", {
                                n: s
                            });
                        }
                    }
                },
                messages: {
                    "function.arity": "{{#label}} must have an arity of {{#n}}",
                    "function.class": "{{#label}} must be a class",
                    "function.maxArity": "{{#label}} must have an arity lesser or equal to {{#n}}",
                    "function.minArity": "{{#label}} must have an arity greater or equal to {{#n}}"
                }
            });
        },
        7824: (e, t, r)=>{
            "use strict";
            const s = r(978), n = r(375), a = r(8571), i = r(3652), o = r(8068), l = r(8160), c = r(3292), u = r(6354), f = r(6133), h = r(3328), m = {
                renameDefaults: {
                    alias: !1,
                    multiple: !1,
                    override: !1
                }
            };
            e.exports = o.extend({
                type: "_keys",
                properties: {
                    typeof: "object"
                },
                flags: {
                    unknown: {
                        default: !1
                    }
                },
                terms: {
                    dependencies: {
                        init: null
                    },
                    keys: {
                        init: null,
                        manifest: {
                            mapped: {
                                from: "schema",
                                to: "key"
                            }
                        }
                    },
                    patterns: {
                        init: null
                    },
                    renames: {
                        init: null
                    }
                },
                args: (e, t)=>e.keys(t),
                validate (e, t) {
                    let { schema: r, error: s, state: n, prefs: a } = t;
                    if (!e || typeof e !== r.$_property("typeof") || Array.isArray(e)) return {
                        value: e,
                        errors: s("object.base", {
                            type: r.$_property("typeof")
                        })
                    };
                    if (!(r.$_terms.renames || r.$_terms.dependencies || r.$_terms.keys || r.$_terms.patterns || r.$_terms.externals)) return;
                    e = m.clone(e, a);
                    const i = [];
                    if (r.$_terms.renames && !m.rename(r, e, n, a, i)) return {
                        value: e,
                        errors: i
                    };
                    if (!r.$_terms.keys && !r.$_terms.patterns && !r.$_terms.dependencies) return {
                        value: e,
                        errors: i
                    };
                    const o = new Set(Object.keys(e));
                    if (r.$_terms.keys) {
                        const t = [
                            e,
                            ...n.ancestors
                        ];
                        for (const s of r.$_terms.keys){
                            const r = s.key, l = e[r];
                            o.delete(r);
                            const c = n.localize([
                                ...n.path,
                                r
                            ], t, s), u = s.schema.$_validate(l, c, a);
                            if (u.errors) {
                                if (a.abortEarly) return {
                                    value: e,
                                    errors: u.errors
                                };
                                void 0 !== u.value && (e[r] = u.value), i.push(...u.errors);
                            } else "strip" === s.schema._flags.result || void 0 === u.value && void 0 !== l ? delete e[r] : void 0 !== u.value && (e[r] = u.value);
                        }
                    }
                    if (o.size || r._flags._hasPatternMatch) {
                        const t = m.unknown(r, e, o, i, n, a);
                        if (t) return t;
                    }
                    if (r.$_terms.dependencies) for (const t of r.$_terms.dependencies){
                        if (null !== t.key && !1 === m.isPresent(t.options)(t.key.resolve(e, n, a, null, {
                            shadow: !1
                        }))) continue;
                        const s = m.dependencies[t.rel](r, t, e, n, a);
                        if (s) {
                            const t = r.$_createError(s.code, e, s.context, n, a);
                            if (a.abortEarly) return {
                                value: e,
                                errors: t
                            };
                            i.push(t);
                        }
                    }
                    return {
                        value: e,
                        errors: i
                    };
                },
                rules: {
                    and: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            return l.verifyFlat(t, "and"), m.dependency(this, "and", null, t);
                        }
                    },
                    append: {
                        method (e) {
                            return null == e || 0 === Object.keys(e).length ? this : this.keys(e);
                        }
                    },
                    assert: {
                        method (e, t, r) {
                            h.isTemplate(e) || (e = c.ref(e)), n(void 0 === r || "string" == typeof r, "Message must be a string"), t = this.$_compile(t, {
                                appendPath: !0
                            });
                            const s = this.$_addRule({
                                name: "assert",
                                args: {
                                    subject: e,
                                    schema: t,
                                    message: r
                                }
                            });
                            return s.$_mutateRegister(e), s.$_mutateRegister(t), s;
                        },
                        validate (e, t, r) {
                            let { error: s, prefs: n, state: a } = t, { subject: i, schema: o, message: l } = r;
                            const c = i.resolve(e, a, n), u = f.isRef(i) ? i.absolute(a) : [];
                            return o.$_match(c, a.localize(u, [
                                e,
                                ...a.ancestors
                            ], o), n) ? e : s("object.assert", {
                                subject: i,
                                message: l
                            });
                        },
                        args: [
                            "subject",
                            "schema",
                            "message"
                        ],
                        multi: !0
                    },
                    instance: {
                        method (e, t) {
                            return n("function" == typeof e, "constructor must be a function"), t = t || e.name, this.$_addRule({
                                name: "instance",
                                args: {
                                    constructor: e,
                                    name: t
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { constructor: s, name: n } = r;
                            return e instanceof s ? e : t.error("object.instance", {
                                type: n,
                                value: e
                            });
                        },
                        args: [
                            "constructor",
                            "name"
                        ]
                    },
                    keys: {
                        method (e) {
                            n(void 0 === e || "object" == typeof e, "Object schema must be a valid object"), n(!l.isSchema(e), "Object schema cannot be a joi schema");
                            const t = this.clone();
                            if (e) {
                                if (Object.keys(e).length) {
                                    t.$_terms.keys = t.$_terms.keys ? t.$_terms.keys.filter((t)=>!e.hasOwnProperty(t.key)) : new m.Keys;
                                    for(const r in e)l.tryWithPath(()=>t.$_terms.keys.push({
                                            key: r,
                                            schema: this.$_compile(e[r])
                                        }), r);
                                } else t.$_terms.keys = new m.Keys;
                            } else t.$_terms.keys = null;
                            return t.$_mutateRebuild();
                        }
                    },
                    length: {
                        method (e) {
                            return this.$_addRule({
                                name: "length",
                                args: {
                                    limit: e
                                },
                                operator: "="
                            });
                        },
                        validate (e, t, r, s) {
                            let { limit: n } = r, { name: a, operator: i, args: o } = s;
                            return l.compare(Object.keys(e).length, n, i) ? e : t.error("object." + a, {
                                limit: o.limit,
                                value: e
                            });
                        },
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: l.limit,
                                message: "must be a positive integer"
                            }
                        ]
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    nand: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            return l.verifyFlat(t, "nand"), m.dependency(this, "nand", null, t);
                        }
                    },
                    or: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            return l.verifyFlat(t, "or"), m.dependency(this, "or", null, t);
                        }
                    },
                    oxor: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            return m.dependency(this, "oxor", null, t);
                        }
                    },
                    pattern: {
                        method (e, t) {
                            let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                            const s = e instanceof RegExp;
                            s || (e = this.$_compile(e, {
                                appendPath: !0
                            })), n(void 0 !== t, "Invalid rule"), l.assertOptions(r, [
                                "fallthrough",
                                "matches"
                            ]), s && n(!e.flags.includes("g") && !e.flags.includes("y"), "pattern should not use global or sticky mode"), t = this.$_compile(t, {
                                appendPath: !0
                            });
                            const a = this.clone();
                            a.$_terms.patterns = a.$_terms.patterns || [];
                            const i = {
                                [s ? "regex" : "schema"]: e,
                                rule: t
                            };
                            return r.matches && (i.matches = this.$_compile(r.matches), "array" !== i.matches.type && (i.matches = i.matches.$_root.array().items(i.matches)), a.$_mutateRegister(i.matches), a.$_setFlag("_hasPatternMatch", !0, {
                                clone: !1
                            })), r.fallthrough && (i.fallthrough = !0), a.$_terms.patterns.push(i), a.$_mutateRegister(t), a;
                        }
                    },
                    ref: {
                        method () {
                            return this.$_addRule("ref");
                        },
                        validate: (e, t)=>f.isRef(e) ? e : t.error("object.refType", {
                                value: e
                            })
                    },
                    regex: {
                        method () {
                            return this.$_addRule("regex");
                        },
                        validate: (e, t)=>e instanceof RegExp ? e : t.error("object.regex", {
                                value: e
                            })
                    },
                    rename: {
                        method (e, t) {
                            let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                            n("string" == typeof e || e instanceof RegExp, "Rename missing the from argument"), n("string" == typeof t || t instanceof h, "Invalid rename to argument"), n(t !== e, "Cannot rename key to same name:", e), l.assertOptions(r, [
                                "alias",
                                "ignoreUndefined",
                                "override",
                                "multiple"
                            ]);
                            const a = this.clone();
                            a.$_terms.renames = a.$_terms.renames || [];
                            for (const t of a.$_terms.renames)n(t.from !== e, "Cannot rename the same key multiple times");
                            return t instanceof h && a.$_mutateRegister(t), a.$_terms.renames.push({
                                from: e,
                                to: t,
                                options: s(m.renameDefaults, r)
                            }), a;
                        }
                    },
                    schema: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "any";
                            return this.$_addRule({
                                name: "schema",
                                args: {
                                    type: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { type: s } = r;
                            return !l.isSchema(e) || "any" !== s && e.type !== s ? t.error("object.schema", {
                                type: s
                            }) : e;
                        }
                    },
                    unknown: {
                        method (e) {
                            return this.$_setFlag("unknown", !1 !== e);
                        }
                    },
                    with: {
                        method (e, t) {
                            let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                            return m.dependency(this, "with", e, t, r);
                        }
                    },
                    without: {
                        method (e, t) {
                            let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                            return m.dependency(this, "without", e, t, r);
                        }
                    },
                    xor: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            return l.verifyFlat(t, "xor"), m.dependency(this, "xor", null, t);
                        }
                    }
                },
                overrides: {
                    default (e, t) {
                        return void 0 === e && (e = l.symbols.deepDefault), this.$_parent("default", e, t);
                    }
                },
                rebuild (e) {
                    if (e.$_terms.keys) {
                        const t = new i.Sorter;
                        for (const r of e.$_terms.keys)l.tryWithPath(()=>t.add(r, {
                                after: r.schema.$_rootReferences(),
                                group: r.key
                            }), r.key);
                        e.$_terms.keys = new m.Keys(...t.nodes);
                    }
                },
                manifest: {
                    build (e, t) {
                        if (t.keys && (e = e.keys(t.keys)), t.dependencies) for (const { rel: r, key: s = null, peers: n, options: a } of t.dependencies)e = m.dependency(e, r, s, n, a);
                        if (t.patterns) for (const { regex: r, schema: s, rule: n, fallthrough: a, matches: i } of t.patterns)e = e.pattern(r || s, n, {
                            fallthrough: a,
                            matches: i
                        });
                        if (t.renames) for (const { from: r, to: s, options: n } of t.renames)e = e.rename(r, s, n);
                        return e;
                    }
                },
                messages: {
                    "object.and": "{{#label}} contains {{#presentWithLabels}} without its required peers {{#missingWithLabels}}",
                    "object.assert": '{{#label}} is invalid because {if(#subject.key, `"` + #subject.key + `" failed to ` + (#message || "pass the assertion test"), #message || "the assertion failed")}',
                    "object.base": "{{#label}} must be of type {{#type}}",
                    "object.instance": "{{#label}} must be an instance of {{:#type}}",
                    "object.length": '{{#label}} must have {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.max": '{{#label}} must have less than or equal to {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.min": '{{#label}} must have at least {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.missing": "{{#label}} must contain at least one of {{#peersWithLabels}}",
                    "object.nand": "{{:#mainWithLabel}} must not exist simultaneously with {{#peersWithLabels}}",
                    "object.oxor": "{{#label}} contains a conflict between optional exclusive peers {{#peersWithLabels}}",
                    "object.pattern.match": "{{#label}} keys failed to match pattern requirements",
                    "object.refType": "{{#label}} must be a Joi reference",
                    "object.regex": "{{#label}} must be a RegExp object",
                    "object.rename.multiple": "{{#label}} cannot rename {{:#from}} because multiple renames are disabled and another key was already renamed to {{:#to}}",
                    "object.rename.override": "{{#label}} cannot rename {{:#from}} because override is disabled and target {{:#to}} exists",
                    "object.schema": "{{#label}} must be a Joi schema of {{#type}} type",
                    "object.unknown": "{{#label}} is not allowed",
                    "object.with": "{{:#mainWithLabel}} missing required peer {{:#peerWithLabel}}",
                    "object.without": "{{:#mainWithLabel}} conflict with forbidden peer {{:#peerWithLabel}}",
                    "object.xor": "{{#label}} contains a conflict between exclusive peers {{#peersWithLabels}}"
                }
            }), m.clone = function(e, t) {
                if ("object" == typeof e) {
                    if (t.nonEnumerables) return a(e, {
                        shallow: !0
                    });
                    const r = Object.create(Object.getPrototypeOf(e));
                    return Object.assign(r, e), r;
                }
                const r = function() {
                    for(var t = arguments.length, r = new Array(t), s = 0; s < t; s++)r[s] = arguments[s];
                    return e.apply(this, r);
                };
                return r.prototype = a(e.prototype), Object.defineProperty(r, "name", {
                    value: e.name,
                    writable: !1
                }), Object.defineProperty(r, "length", {
                    value: e.length,
                    writable: !1
                }), Object.assign(r, e), r;
            }, m.dependency = function(e, t, r, s, a) {
                n(null === r || "string" == typeof r, t, "key must be a strings"), a || (a = s.length > 1 && "object" == typeof s[s.length - 1] ? s.pop() : {}), l.assertOptions(a, [
                    "separator",
                    "isPresent"
                ]), s = [].concat(s);
                const i = l.default(a.separator, "."), o = [];
                for (const e of s)n("string" == typeof e, t, "peers must be strings"), o.push(c.ref(e, {
                    separator: i,
                    ancestor: 0,
                    prefix: !1
                }));
                null !== r && (r = c.ref(r, {
                    separator: i,
                    ancestor: 0,
                    prefix: !1
                }));
                const u = e.clone();
                return u.$_terms.dependencies = u.$_terms.dependencies || [], u.$_terms.dependencies.push(new m.Dependency(t, r, o, s, a)), u;
            }, m.dependencies = {
                and (e, t, r, s, n) {
                    const a = [], i = [], o = t.peers.length, l = m.isPresent(t.options);
                    for (const e of t.peers)!1 === l(e.resolve(r, s, n, null, {
                        shadow: !1
                    })) ? a.push(e.key) : i.push(e.key);
                    if (a.length !== o && i.length !== o) return {
                        code: "object.and",
                        context: {
                            present: i,
                            presentWithLabels: m.keysToLabels(e, i),
                            missing: a,
                            missingWithLabels: m.keysToLabels(e, a)
                        }
                    };
                },
                nand (e, t, r, s, n) {
                    const a = [], i = m.isPresent(t.options);
                    for (const e of t.peers)i(e.resolve(r, s, n, null, {
                        shadow: !1
                    })) && a.push(e.key);
                    if (a.length !== t.peers.length) return;
                    const o = t.paths[0], l = t.paths.slice(1);
                    return {
                        code: "object.nand",
                        context: {
                            main: o,
                            mainWithLabel: m.keysToLabels(e, o),
                            peers: l,
                            peersWithLabels: m.keysToLabels(e, l)
                        }
                    };
                },
                or (e, t, r, s, n) {
                    const a = m.isPresent(t.options);
                    for (const e of t.peers)if (a(e.resolve(r, s, n, null, {
                        shadow: !1
                    }))) return;
                    return {
                        code: "object.missing",
                        context: {
                            peers: t.paths,
                            peersWithLabels: m.keysToLabels(e, t.paths)
                        }
                    };
                },
                oxor (e, t, r, s, n) {
                    const a = [], i = m.isPresent(t.options);
                    for (const e of t.peers)i(e.resolve(r, s, n, null, {
                        shadow: !1
                    })) && a.push(e.key);
                    if (!a.length || 1 === a.length) return;
                    const o = {
                        peers: t.paths,
                        peersWithLabels: m.keysToLabels(e, t.paths)
                    };
                    return o.present = a, o.presentWithLabels = m.keysToLabels(e, a), {
                        code: "object.oxor",
                        context: o
                    };
                },
                with (e, t, r, s, n) {
                    const a = m.isPresent(t.options);
                    for (const i of t.peers)if (!1 === a(i.resolve(r, s, n, null, {
                        shadow: !1
                    }))) return {
                        code: "object.with",
                        context: {
                            main: t.key.key,
                            mainWithLabel: m.keysToLabels(e, t.key.key),
                            peer: i.key,
                            peerWithLabel: m.keysToLabels(e, i.key)
                        }
                    };
                },
                without (e, t, r, s, n) {
                    const a = m.isPresent(t.options);
                    for (const i of t.peers)if (a(i.resolve(r, s, n, null, {
                        shadow: !1
                    }))) return {
                        code: "object.without",
                        context: {
                            main: t.key.key,
                            mainWithLabel: m.keysToLabels(e, t.key.key),
                            peer: i.key,
                            peerWithLabel: m.keysToLabels(e, i.key)
                        }
                    };
                },
                xor (e, t, r, s, n) {
                    const a = [], i = m.isPresent(t.options);
                    for (const e of t.peers)i(e.resolve(r, s, n, null, {
                        shadow: !1
                    })) && a.push(e.key);
                    if (1 === a.length) return;
                    const o = {
                        peers: t.paths,
                        peersWithLabels: m.keysToLabels(e, t.paths)
                    };
                    return 0 === a.length ? {
                        code: "object.missing",
                        context: o
                    } : (o.present = a, o.presentWithLabels = m.keysToLabels(e, a), {
                        code: "object.xor",
                        context: o
                    });
                }
            }, m.keysToLabels = function(e, t) {
                return Array.isArray(t) ? t.map((t)=>e.$_mapLabels(t)) : e.$_mapLabels(t);
            }, m.isPresent = function(e) {
                return "function" == typeof e.isPresent ? e.isPresent : (e)=>void 0 !== e;
            }, m.rename = function(e, t, r, s, n) {
                const a = {};
                for (const i of e.$_terms.renames){
                    const o = [], l = "string" != typeof i.from;
                    if (l) for(const e in t){
                        if (void 0 === t[e] && i.options.ignoreUndefined) continue;
                        if (e === i.to) continue;
                        const r = i.from.exec(e);
                        r && o.push({
                            from: e,
                            to: i.to,
                            match: r
                        });
                    }
                    else !Object.prototype.hasOwnProperty.call(t, i.from) || void 0 === t[i.from] && i.options.ignoreUndefined || o.push(i);
                    for (const c of o){
                        const o = c.from;
                        let u = c.to;
                        if (u instanceof h && (u = u.render(t, r, s, c.match)), o !== u) {
                            if (!i.options.multiple && a[u] && (n.push(e.$_createError("object.rename.multiple", t, {
                                from: o,
                                to: u,
                                pattern: l
                            }, r, s)), s.abortEarly)) return !1;
                            if (Object.prototype.hasOwnProperty.call(t, u) && !i.options.override && !a[u] && (n.push(e.$_createError("object.rename.override", t, {
                                from: o,
                                to: u,
                                pattern: l
                            }, r, s)), s.abortEarly)) return !1;
                            void 0 === t[o] ? delete t[u] : t[u] = t[o], a[u] = !0, i.options.alias || delete t[o];
                        }
                    }
                }
                return !0;
            }, m.unknown = function(e, t, r, s, n, a) {
                if (e.$_terms.patterns) {
                    let i = !1;
                    const o = e.$_terms.patterns.map((e)=>{
                        if (e.matches) return i = !0, [];
                    }), l = [
                        t,
                        ...n.ancestors
                    ];
                    for (const i of r){
                        const c = t[i], u = [
                            ...n.path,
                            i
                        ];
                        for(let f = 0; f < e.$_terms.patterns.length; ++f){
                            const h = e.$_terms.patterns[f];
                            if (h.regex) {
                                const e = h.regex.test(i);
                                if (n.mainstay.tracer.debug(n, "rule", `pattern.${f}`, e ? "pass" : "error"), !e) continue;
                            } else if (!h.schema.$_match(i, n.nest(h.schema, `pattern.${f}`), a)) continue;
                            r.delete(i);
                            const m = n.localize(u, l, {
                                schema: h.rule,
                                key: i
                            }), d = h.rule.$_validate(c, m, a);
                            if (d.errors) {
                                if (a.abortEarly) return {
                                    value: t,
                                    errors: d.errors
                                };
                                s.push(...d.errors);
                            }
                            if (h.matches && o[f].push(i), t[i] = d.value, !h.fallthrough) break;
                        }
                    }
                    if (i) for(let r = 0; r < o.length; ++r){
                        const i = o[r];
                        if (!i) continue;
                        const c = e.$_terms.patterns[r].matches, f = n.localize(n.path, l, c), h = c.$_validate(i, f, a);
                        if (h.errors) {
                            const r = u.details(h.errors, {
                                override: !1
                            });
                            r.matches = i;
                            const o = e.$_createError("object.pattern.match", t, r, n, a);
                            if (a.abortEarly) return {
                                value: t,
                                errors: o
                            };
                            s.push(o);
                        }
                    }
                }
                if (r.size && (e.$_terms.keys || e.$_terms.patterns)) {
                    if (a.stripUnknown && !e._flags.unknown || a.skipFunctions) {
                        const e = !(!a.stripUnknown || !0 !== a.stripUnknown && !a.stripUnknown.objects);
                        for (const s of r)e ? (delete t[s], r.delete(s)) : "function" == typeof t[s] && r.delete(s);
                    }
                    if (!l.default(e._flags.unknown, a.allowUnknown)) for (const i of r){
                        const r = n.localize([
                            ...n.path,
                            i
                        ], []), o = e.$_createError("object.unknown", t[i], {
                            child: i
                        }, r, a, {
                            flags: !1
                        });
                        if (a.abortEarly) return {
                            value: t,
                            errors: o
                        };
                        s.push(o);
                    }
                }
            }, m.Dependency = class {
                constructor(e, t, r, s, n){
                    this.rel = e, this.key = t, this.peers = r, this.paths = s, this.options = n;
                }
                describe() {
                    const e = {
                        rel: this.rel,
                        peers: this.paths
                    };
                    return null !== this.key && (e.key = this.key.key), "." !== this.peers[0].separator && (e.options = {
                        ...e.options,
                        separator: this.peers[0].separator
                    }), this.options.isPresent && (e.options = {
                        ...e.options,
                        isPresent: this.options.isPresent
                    }), e;
                }
            }, m.Keys = class extends Array {
                concat(e) {
                    const t = this.slice(), r = new Map;
                    for(let e = 0; e < t.length; ++e)r.set(t[e].key, e);
                    for (const s of e){
                        const e = s.key, n = r.get(e);
                        void 0 !== n ? t[n] = {
                            key: e,
                            schema: t[n].schema.concat(s.schema)
                        } : t.push(s);
                    }
                    return t;
                }
            };
        },
        8785: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8068), a = r(8160), i = r(3292), o = r(6354), l = {};
            e.exports = n.extend({
                type: "link",
                properties: {
                    schemaChain: !0
                },
                terms: {
                    link: {
                        init: null,
                        manifest: "single",
                        register: !1
                    }
                },
                args: (e, t)=>e.ref(t),
                validate (e, t) {
                    let { schema: r, state: n, prefs: a } = t;
                    s(r.$_terms.link, "Uninitialized link schema");
                    const i = l.generate(r, e, n, a), o = r.$_terms.link[0].ref;
                    return i.$_validate(e, n.nest(i, `link:${o.display}:${i.type}`), a);
                },
                generate: (e, t, r, s)=>l.generate(e, t, r, s),
                rules: {
                    ref: {
                        method (e) {
                            s(!this.$_terms.link, "Cannot reinitialize schema"), e = i.ref(e), s("value" === e.type || "local" === e.type, "Invalid reference type:", e.type), s("local" === e.type || "root" === e.ancestor || e.ancestor > 0, "Link cannot reference itself");
                            const t = this.clone();
                            return t.$_terms.link = [
                                {
                                    ref: e
                                }
                            ], t;
                        }
                    },
                    relative: {
                        method () {
                            let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                            return this.$_setFlag("relative", e);
                        }
                    }
                },
                overrides: {
                    concat (e) {
                        s(this.$_terms.link, "Uninitialized link schema"), s(a.isSchema(e), "Invalid schema object"), s("link" !== e.type, "Cannot merge type link with another link");
                        const t = this.clone();
                        return t.$_terms.whens || (t.$_terms.whens = []), t.$_terms.whens.push({
                            concat: e
                        }), t.$_mutateRebuild();
                    }
                },
                manifest: {
                    build: (e, t)=>(s(t.link, "Invalid link description missing link"), e.ref(t.link))
                }
            }), l.generate = function(e, t, r, s) {
                let n = r.mainstay.links.get(e);
                if (n) return n._generate(t, r, s).schema;
                const a = e.$_terms.link[0].ref, { perspective: i, path: o } = l.perspective(a, r);
                l.assert(i, "which is outside of schema boundaries", a, e, r, s);
                try {
                    n = o.length ? i.$_reach(o) : i;
                } catch (t) {
                    l.assert(!1, "to non-existing schema", a, e, r, s);
                }
                return l.assert("link" !== n.type, "which is another link", a, e, r, s), e._flags.relative || r.mainstay.links.set(e, n), n._generate(t, r, s).schema;
            }, l.perspective = function(e, t) {
                if ("local" === e.type) {
                    for (const { schema: r, key: s } of t.schemas){
                        if ((r._flags.id || s) === e.path[0]) return {
                            perspective: r,
                            path: e.path.slice(1)
                        };
                        if (r.$_terms.shared) {
                            for (const t of r.$_terms.shared)if (t._flags.id === e.path[0]) return {
                                perspective: t,
                                path: e.path.slice(1)
                            };
                        }
                    }
                    return {
                        perspective: null,
                        path: null
                    };
                }
                return "root" === e.ancestor ? {
                    perspective: t.schemas[t.schemas.length - 1].schema,
                    path: e.path
                } : {
                    perspective: t.schemas[e.ancestor] && t.schemas[e.ancestor].schema,
                    path: e.path
                };
            }, l.assert = function(e, t, r, n, a, i) {
                e || s(!1, `"${o.label(n._flags, a, i)}" contains link reference "${r.display}" ${t}`);
            };
        },
        3832: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8068), a = r(8160), i = {
                numberRx: /^\s*[+-]?(?:(?:\d+(?:\.\d*)?)|(?:\.\d+))(?:e([+-]?\d+))?\s*$/i,
                precisionRx: /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/,
                exponentialPartRegex: /[eE][+-]?\d+$/,
                leadingSignAndZerosRegex: /^[+-]?(0*)?/,
                dotRegex: /\./,
                trailingZerosRegex: /0+$/
            };
            e.exports = n.extend({
                type: "number",
                flags: {
                    unsafe: {
                        default: !1
                    }
                },
                coerce: {
                    from: "string",
                    method (e, t) {
                        let { schema: r, error: s } = t;
                        if (!e.match(i.numberRx)) return;
                        e = e.trim();
                        const n = {
                            value: parseFloat(e)
                        };
                        if (0 === n.value && (n.value = 0), !r._flags.unsafe) {
                            if (e.match(/e/i)) {
                                if (i.extractSignificantDigits(e) !== i.extractSignificantDigits(String(n.value))) return n.errors = s("number.unsafe"), n;
                            } else {
                                const t = n.value.toString();
                                if (t.match(/e/i)) return n;
                                if (t !== i.normalizeDecimal(e)) return n.errors = s("number.unsafe"), n;
                            }
                        }
                        return n;
                    }
                },
                validate (e, t) {
                    let { schema: r, error: s, prefs: n } = t;
                    if (e === 1 / 0 || e === -1 / 0) return {
                        value: e,
                        errors: s("number.infinity")
                    };
                    if (!a.isNumber(e)) return {
                        value: e,
                        errors: s("number.base")
                    };
                    const i = {
                        value: e
                    };
                    if (n.convert) {
                        const e = r.$_getRule("precision");
                        if (e) {
                            const t = Math.pow(10, e.args.limit);
                            i.value = Math.round(i.value * t) / t;
                        }
                    }
                    return 0 === i.value && (i.value = 0), !r._flags.unsafe && (e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) && (i.errors = s("number.unsafe")), i;
                },
                rules: {
                    compare: {
                        method: !1,
                        validate (e, t, r, s) {
                            let { limit: n } = r, { name: i, operator: o, args: l } = s;
                            return a.compare(e, n, o) ? e : t.error("number." + i, {
                                limit: l.limit,
                                value: e
                            });
                        },
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: a.isNumber,
                                message: "must be a number"
                            }
                        ]
                    },
                    greater: {
                        method (e) {
                            return this.$_addRule({
                                name: "greater",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: ">"
                            });
                        }
                    },
                    integer: {
                        method () {
                            return this.$_addRule("integer");
                        },
                        validate: (e, t)=>Math.trunc(e) - e == 0 ? e : t.error("number.integer")
                    },
                    less: {
                        method (e) {
                            return this.$_addRule({
                                name: "less",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: "<"
                            });
                        }
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    multiple: {
                        method (e) {
                            return this.$_addRule({
                                name: "multiple",
                                args: {
                                    base: e
                                }
                            });
                        },
                        validate (e, t, r, s) {
                            let { base: n } = r;
                            return e * (1 / n) % 1 == 0 ? e : t.error("number.multiple", {
                                multiple: s.args.base,
                                value: e
                            });
                        },
                        args: [
                            {
                                name: "base",
                                ref: !0,
                                assert: (e)=>"number" == typeof e && isFinite(e) && e > 0,
                                message: "must be a positive number"
                            }
                        ],
                        multi: !0
                    },
                    negative: {
                        method () {
                            return this.sign("negative");
                        }
                    },
                    port: {
                        method () {
                            return this.$_addRule("port");
                        },
                        validate: (e, t)=>Number.isSafeInteger(e) && e >= 0 && e <= 65535 ? e : t.error("number.port")
                    },
                    positive: {
                        method () {
                            return this.sign("positive");
                        }
                    },
                    precision: {
                        method (e) {
                            return s(Number.isSafeInteger(e), "limit must be an integer"), this.$_addRule({
                                name: "precision",
                                args: {
                                    limit: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { limit: s } = r;
                            const n = e.toString().match(i.precisionRx);
                            return Math.max((n[1] ? n[1].length : 0) - (n[2] ? parseInt(n[2], 10) : 0), 0) <= s ? e : t.error("number.precision", {
                                limit: s,
                                value: e
                            });
                        },
                        convert: !0
                    },
                    sign: {
                        method (e) {
                            return s([
                                "negative",
                                "positive"
                            ].includes(e), "Invalid sign", e), this.$_addRule({
                                name: "sign",
                                args: {
                                    sign: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { sign: s } = r;
                            return "negative" === s && e < 0 || "positive" === s && e > 0 ? e : t.error(`number.${s}`);
                        }
                    },
                    unsafe: {
                        method () {
                            let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                            return s("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("unsafe", e);
                        }
                    }
                },
                cast: {
                    string: {
                        from: (e)=>"number" == typeof e,
                        to: (e, t)=>e.toString()
                    }
                },
                messages: {
                    "number.base": "{{#label}} must be a number",
                    "number.greater": "{{#label}} must be greater than {{#limit}}",
                    "number.infinity": "{{#label}} cannot be infinity",
                    "number.integer": "{{#label}} must be an integer",
                    "number.less": "{{#label}} must be less than {{#limit}}",
                    "number.max": "{{#label}} must be less than or equal to {{#limit}}",
                    "number.min": "{{#label}} must be greater than or equal to {{#limit}}",
                    "number.multiple": "{{#label}} must be a multiple of {{#multiple}}",
                    "number.negative": "{{#label}} must be a negative number",
                    "number.port": "{{#label}} must be a valid port",
                    "number.positive": "{{#label}} must be a positive number",
                    "number.precision": "{{#label}} must have no more than {{#limit}} decimal places",
                    "number.unsafe": "{{#label}} must be a safe number"
                }
            }), i.extractSignificantDigits = function(e) {
                return e.replace(i.exponentialPartRegex, "").replace(i.dotRegex, "").replace(i.trailingZerosRegex, "").replace(i.leadingSignAndZerosRegex, "");
            }, i.normalizeDecimal = function(e) {
                return (e = e.replace(/^\+/, "").replace(/\.0*$/, "").replace(/^(-?)\.([^\.]*)$/, "$10.$2").replace(/^(-?)0+([0-9])/, "$1$2")).includes(".") && e.endsWith("0") && (e = e.replace(/0+$/, "")), "-0" === e ? "0" : e;
            };
        },
        8966: (e, t, r)=>{
            "use strict";
            const s = r(7824);
            e.exports = s.extend({
                type: "object",
                cast: {
                    map: {
                        from: (e)=>e && "object" == typeof e,
                        to: (e, t)=>new Map(Object.entries(e))
                    }
                }
            });
        },
        7417: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(5380), a = r(1745), i = r(9959), o = r(6064), l = r(9926), c = r(5752), u = r(8068), f = r(8160), h = {
                tlds: l instanceof Set && {
                    tlds: {
                        allow: l,
                        deny: null
                    }
                },
                base64Regex: {
                    true: {
                        true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}==|[\w\-]{3}=)?$/,
                        false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/
                    },
                    false: {
                        true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}(==)?|[\w\-]{3}=?)?$/,
                        false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}(==)?|[A-Za-z0-9+\/]{3}=?)?$/
                    }
                },
                dataUriRegex: /^data:[\w+.-]+\/[\w+.-]+;((charset=[\w-]+|base64),)?(.*)$/,
                hexRegex: /^[a-f0-9]+$/i,
                ipRegex: i.regex({
                    cidr: "forbidden"
                }).regex,
                isoDurationRegex: /^P(?!$)(\d+Y)?(\d+M)?(\d+W)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?$/,
                guidBrackets: {
                    "{": "}",
                    "[": "]",
                    "(": ")",
                    "": ""
                },
                guidVersions: {
                    uuidv1: "1",
                    uuidv2: "2",
                    uuidv3: "3",
                    uuidv4: "4",
                    uuidv5: "5"
                },
                guidSeparators: new Set([
                    void 0,
                    !0,
                    !1,
                    "-",
                    ":"
                ]),
                normalizationForms: [
                    "NFC",
                    "NFD",
                    "NFKC",
                    "NFKD"
                ]
            };
            e.exports = u.extend({
                type: "string",
                flags: {
                    insensitive: {
                        default: !1
                    },
                    truncate: {
                        default: !1
                    }
                },
                terms: {
                    replacements: {
                        init: null
                    }
                },
                coerce: {
                    from: "string",
                    method (e, t) {
                        let { schema: r, state: s, prefs: n } = t;
                        const a = r.$_getRule("normalize");
                        a && (e = e.normalize(a.args.form));
                        const i = r.$_getRule("case");
                        i && (e = "upper" === i.args.direction ? e.toLocaleUpperCase() : e.toLocaleLowerCase());
                        const o = r.$_getRule("trim");
                        if (o && o.args.enabled && (e = e.trim()), r.$_terms.replacements) for (const t of r.$_terms.replacements)e = e.replace(t.pattern, t.replacement);
                        const l = r.$_getRule("hex");
                        if (l && l.args.options.byteAligned && e.length % 2 != 0 && (e = `0${e}`), r.$_getRule("isoDate")) {
                            const t = h.isoDate(e);
                            t && (e = t);
                        }
                        if (r._flags.truncate) {
                            const t = r.$_getRule("max");
                            if (t) {
                                let a = t.args.limit;
                                if (f.isResolvable(a) && (a = a.resolve(e, s, n), !f.limit(a))) return {
                                    value: e,
                                    errors: r.$_createError("any.ref", a, {
                                        ref: t.args.limit,
                                        arg: "limit",
                                        reason: "must be a positive integer"
                                    }, s, n)
                                };
                                e = e.slice(0, a);
                            }
                        }
                        return {
                            value: e
                        };
                    }
                },
                validate (e, t) {
                    let { schema: r, error: s } = t;
                    if ("string" != typeof e) return {
                        value: e,
                        errors: s("string.base")
                    };
                    if ("" === e) {
                        const t = r.$_getRule("min");
                        if (t && 0 === t.args.limit) return;
                        return {
                            value: e,
                            errors: s("string.empty")
                        };
                    }
                },
                rules: {
                    alphanum: {
                        method () {
                            return this.$_addRule("alphanum");
                        },
                        validate: (e, t)=>/^[a-zA-Z0-9]+$/.test(e) ? e : t.error("string.alphanum")
                    },
                    base64: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            return f.assertOptions(e, [
                                "paddingRequired",
                                "urlSafe"
                            ]), e = {
                                urlSafe: !1,
                                paddingRequired: !0,
                                ...e
                            }, s("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), s("boolean" == typeof e.urlSafe, "urlSafe must be boolean"), this.$_addRule({
                                name: "base64",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { options: s } = r;
                            return h.base64Regex[s.paddingRequired][s.urlSafe].test(e) ? e : t.error("string.base64");
                        }
                    },
                    case: {
                        method (e) {
                            return s([
                                "lower",
                                "upper"
                            ].includes(e), "Invalid case:", e), this.$_addRule({
                                name: "case",
                                args: {
                                    direction: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { direction: s } = r;
                            return "lower" === s && e === e.toLocaleLowerCase() || "upper" === s && e === e.toLocaleUpperCase() ? e : t.error(`string.${s}case`);
                        },
                        convert: !0
                    },
                    creditCard: {
                        method () {
                            return this.$_addRule("creditCard");
                        },
                        validate (e, t) {
                            let r = e.length, s = 0, n = 1;
                            for(; r--;){
                                const t = e.charAt(r) * n;
                                s += t - 9 * (t > 9), n ^= 3;
                            }
                            return s > 0 && s % 10 == 0 ? e : t.error("string.creditCard");
                        }
                    },
                    dataUri: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            return f.assertOptions(e, [
                                "paddingRequired"
                            ]), e = {
                                paddingRequired: !0,
                                ...e
                            }, s("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), this.$_addRule({
                                name: "dataUri",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { options: s } = r;
                            const n = e.match(h.dataUriRegex);
                            if (n) {
                                if (!n[2]) return e;
                                if ("base64" !== n[2]) return e;
                                if (h.base64Regex[s.paddingRequired].false.test(n[3])) return e;
                            }
                            return t.error("string.dataUri");
                        }
                    },
                    domain: {
                        method (e) {
                            e && f.assertOptions(e, [
                                "allowFullyQualified",
                                "allowUnicode",
                                "maxDomainSegments",
                                "minDomainSegments",
                                "tlds"
                            ]);
                            const t = h.addressOptions(e);
                            return this.$_addRule({
                                name: "domain",
                                args: {
                                    options: e
                                },
                                address: t
                            });
                        },
                        validate (e, t, r, s) {
                            let { address: a } = s;
                            return n.isValid(e, a) ? e : t.error("string.domain");
                        }
                    },
                    email: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            f.assertOptions(e, [
                                "allowFullyQualified",
                                "allowUnicode",
                                "ignoreLength",
                                "maxDomainSegments",
                                "minDomainSegments",
                                "multiple",
                                "separator",
                                "tlds"
                            ]), s(void 0 === e.multiple || "boolean" == typeof e.multiple, "multiple option must be an boolean");
                            const t = h.addressOptions(e), r = new RegExp(`\\s*[${e.separator ? o(e.separator) : ","}]\\s*`);
                            return this.$_addRule({
                                name: "email",
                                args: {
                                    options: e
                                },
                                regex: r,
                                address: t
                            });
                        },
                        validate (e, t, r, s) {
                            let { options: n } = r, { regex: i, address: o } = s;
                            const l = n.multiple ? e.split(i) : [
                                e
                            ], c = [];
                            for (const e of l)a.isValid(e, o) || c.push(e);
                            return c.length ? t.error("string.email", {
                                value: e,
                                invalids: c
                            }) : e;
                        }
                    },
                    guid: {
                        alias: "uuid",
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            f.assertOptions(e, [
                                "version",
                                "separator"
                            ]);
                            let t = "";
                            if (e.version) {
                                const r = [].concat(e.version);
                                s(r.length >= 1, "version must have at least 1 valid version specified");
                                const n = new Set;
                                for(let e = 0; e < r.length; ++e){
                                    const a = r[e];
                                    s("string" == typeof a, "version at position " + e + " must be a string");
                                    const i = h.guidVersions[a.toLowerCase()];
                                    s(i, "version at position " + e + " must be one of " + Object.keys(h.guidVersions).join(", ")), s(!n.has(i), "version at position " + e + " must not be a duplicate"), t += i, n.add(i);
                                }
                            }
                            s(h.guidSeparators.has(e.separator), 'separator must be one of true, false, "-", or ":"');
                            const r = void 0 === e.separator ? "[:-]?" : !0 === e.separator ? "[:-]" : !1 === e.separator ? "[]?" : `\\${e.separator}`, n = new RegExp(`^([\\[{\\(]?)[0-9A-F]{8}(${r})[0-9A-F]{4}\\2?[${t || "0-9A-F"}][0-9A-F]{3}\\2?[${t ? "89AB" : "0-9A-F"}][0-9A-F]{3}\\2?[0-9A-F]{12}([\\]}\\)]?)$`, "i");
                            return this.$_addRule({
                                name: "guid",
                                args: {
                                    options: e
                                },
                                regex: n
                            });
                        },
                        validate (e, t, r, s) {
                            let { regex: n } = s;
                            const a = n.exec(e);
                            return a ? h.guidBrackets[a[1]] !== a[a.length - 1] ? t.error("string.guid") : e : t.error("string.guid");
                        }
                    },
                    hex: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            return f.assertOptions(e, [
                                "byteAligned"
                            ]), e = {
                                byteAligned: !1,
                                ...e
                            }, s("boolean" == typeof e.byteAligned, "byteAligned must be boolean"), this.$_addRule({
                                name: "hex",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { options: s } = r;
                            return h.hexRegex.test(e) ? s.byteAligned && e.length % 2 != 0 ? t.error("string.hexAlign") : e : t.error("string.hex");
                        }
                    },
                    hostname: {
                        method () {
                            return this.$_addRule("hostname");
                        },
                        validate: (e, t)=>n.isValid(e, {
                                minDomainSegments: 1
                            }) || h.ipRegex.test(e) ? e : t.error("string.hostname")
                    },
                    insensitive: {
                        method () {
                            return this.$_setFlag("insensitive", !0);
                        }
                    },
                    ip: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            f.assertOptions(e, [
                                "cidr",
                                "version"
                            ]);
                            const { cidr: t, versions: r, regex: s } = i.regex(e), n = e.version ? r : void 0;
                            return this.$_addRule({
                                name: "ip",
                                args: {
                                    options: {
                                        cidr: t,
                                        version: n
                                    }
                                },
                                regex: s
                            });
                        },
                        validate (e, t, r, s) {
                            let { options: n } = r, { regex: a } = s;
                            return a.test(e) ? e : n.version ? t.error("string.ipVersion", {
                                value: e,
                                cidr: n.cidr,
                                version: n.version
                            }) : t.error("string.ip", {
                                value: e,
                                cidr: n.cidr
                            });
                        }
                    },
                    isoDate: {
                        method () {
                            return this.$_addRule("isoDate");
                        },
                        validate (e, t) {
                            let { error: r } = t;
                            return h.isoDate(e) ? e : r("string.isoDate");
                        }
                    },
                    isoDuration: {
                        method () {
                            return this.$_addRule("isoDuration");
                        },
                        validate: (e, t)=>h.isoDurationRegex.test(e) ? e : t.error("string.isoDuration")
                    },
                    length: {
                        method (e, t) {
                            return h.length(this, "length", e, "=", t);
                        },
                        validate (e, t, r, s) {
                            let { limit: n, encoding: a } = r, { name: i, operator: o, args: l } = s;
                            const c = !a && e.length;
                            return f.compare(c, n, o) ? e : t.error("string." + i, {
                                limit: l.limit,
                                value: e,
                                encoding: a
                            });
                        },
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: f.limit,
                                message: "must be a positive integer"
                            },
                            "encoding"
                        ]
                    },
                    lowercase: {
                        method () {
                            return this.case("lower");
                        }
                    },
                    max: {
                        method (e, t) {
                            return h.length(this, "max", e, "<=", t);
                        },
                        args: [
                            "limit",
                            "encoding"
                        ]
                    },
                    min: {
                        method (e, t) {
                            return h.length(this, "min", e, ">=", t);
                        },
                        args: [
                            "limit",
                            "encoding"
                        ]
                    },
                    normalize: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "NFC";
                            return s(h.normalizationForms.includes(e), "normalization form must be one of " + h.normalizationForms.join(", ")), this.$_addRule({
                                name: "normalize",
                                args: {
                                    form: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { error: s } = t, { form: n } = r;
                            return e === e.normalize(n) ? e : s("string.normalize", {
                                value: e,
                                form: n
                            });
                        },
                        convert: !0
                    },
                    pattern: {
                        alias: "regex",
                        method (e) {
                            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            s(e instanceof RegExp, "regex must be a RegExp"), s(!e.flags.includes("g") && !e.flags.includes("y"), "regex should not use global or sticky mode"), "string" == typeof t && (t = {
                                name: t
                            }), f.assertOptions(t, [
                                "invert",
                                "name"
                            ]);
                            const r = [
                                "string.pattern",
                                t.invert ? ".invert" : "",
                                t.name ? ".name" : ".base"
                            ].join("");
                            return this.$_addRule({
                                name: "pattern",
                                args: {
                                    regex: e,
                                    options: t
                                },
                                errorCode: r
                            });
                        },
                        validate (e, t, r, s) {
                            let { regex: n, options: a } = r, { errorCode: i } = s;
                            return n.test(e) ^ a.invert ? e : t.error(i, {
                                name: a.name,
                                regex: n,
                                value: e
                            });
                        },
                        args: [
                            "regex",
                            "options"
                        ],
                        multi: !0
                    },
                    replace: {
                        method (e, t) {
                            "string" == typeof e && (e = new RegExp(o(e), "g")), s(e instanceof RegExp, "pattern must be a RegExp"), s("string" == typeof t, "replacement must be a String");
                            const r = this.clone();
                            return r.$_terms.replacements || (r.$_terms.replacements = []), r.$_terms.replacements.push({
                                pattern: e,
                                replacement: t
                            }), r;
                        }
                    },
                    token: {
                        method () {
                            return this.$_addRule("token");
                        },
                        validate: (e, t)=>/^\w+$/.test(e) ? e : t.error("string.token")
                    },
                    trim: {
                        method () {
                            let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                            return s("boolean" == typeof e, "enabled must be a boolean"), this.$_addRule({
                                name: "trim",
                                args: {
                                    enabled: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { enabled: s } = r;
                            return s && e !== e.trim() ? t.error("string.trim") : e;
                        },
                        convert: !0
                    },
                    truncate: {
                        method () {
                            let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                            return s("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("truncate", e);
                        }
                    },
                    uppercase: {
                        method () {
                            return this.case("upper");
                        }
                    },
                    uri: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            f.assertOptions(e, [
                                "allowRelative",
                                "allowQuerySquareBrackets",
                                "domain",
                                "relativeOnly",
                                "scheme"
                            ]), e.domain && f.assertOptions(e.domain, [
                                "allowFullyQualified",
                                "allowUnicode",
                                "maxDomainSegments",
                                "minDomainSegments",
                                "tlds"
                            ]);
                            const { regex: t, scheme: r } = c.regex(e), s = e.domain ? h.addressOptions(e.domain) : null;
                            return this.$_addRule({
                                name: "uri",
                                args: {
                                    options: e
                                },
                                regex: t,
                                domain: s,
                                scheme: r
                            });
                        },
                        validate (e, t, r, s) {
                            let { options: a } = r, { regex: i, domain: o, scheme: l } = s;
                            if ([
                                "http:/",
                                "https:/"
                            ].includes(e)) return t.error("string.uri");
                            const c = i.exec(e);
                            if (c) {
                                const r = c[1] || c[2];
                                return !o || a.allowRelative && !r || n.isValid(r, o) ? e : t.error("string.domain", {
                                    value: r
                                });
                            }
                            return a.relativeOnly ? t.error("string.uriRelativeOnly") : a.scheme ? t.error("string.uriCustomScheme", {
                                scheme: l,
                                value: e
                            }) : t.error("string.uri");
                        }
                    }
                },
                manifest: {
                    build (e, t) {
                        if (t.replacements) for (const { pattern: r, replacement: s } of t.replacements)e = e.replace(r, s);
                        return e;
                    }
                },
                messages: {
                    "string.alphanum": "{{#label}} must only contain alpha-numeric characters",
                    "string.base": "{{#label}} must be a string",
                    "string.base64": "{{#label}} must be a valid base64 string",
                    "string.creditCard": "{{#label}} must be a credit card",
                    "string.dataUri": "{{#label}} must be a valid dataUri string",
                    "string.domain": "{{#label}} must contain a valid domain name",
                    "string.email": "{{#label}} must be a valid email",
                    "string.empty": "{{#label}} is not allowed to be empty",
                    "string.guid": "{{#label}} must be a valid GUID",
                    "string.hex": "{{#label}} must only contain hexadecimal characters",
                    "string.hexAlign": "{{#label}} hex decoded representation must be byte aligned",
                    "string.hostname": "{{#label}} must be a valid hostname",
                    "string.ip": "{{#label}} must be a valid ip address with a {{#cidr}} CIDR",
                    "string.ipVersion": "{{#label}} must be a valid ip address of one of the following versions {{#version}} with a {{#cidr}} CIDR",
                    "string.isoDate": "{{#label}} must be in iso format",
                    "string.isoDuration": "{{#label}} must be a valid ISO 8601 duration",
                    "string.length": "{{#label}} length must be {{#limit}} characters long",
                    "string.lowercase": "{{#label}} must only contain lowercase characters",
                    "string.max": "{{#label}} length must be less than or equal to {{#limit}} characters long",
                    "string.min": "{{#label}} length must be at least {{#limit}} characters long",
                    "string.normalize": "{{#label}} must be unicode normalized in the {{#form}} form",
                    "string.token": "{{#label}} must only contain alpha-numeric and underscore characters",
                    "string.pattern.base": "{{#label}} with value {:[.]} fails to match the required pattern: {{#regex}}",
                    "string.pattern.name": "{{#label}} with value {:[.]} fails to match the {{#name}} pattern",
                    "string.pattern.invert.base": "{{#label}} with value {:[.]} matches the inverted pattern: {{#regex}}",
                    "string.pattern.invert.name": "{{#label}} with value {:[.]} matches the inverted {{#name}} pattern",
                    "string.trim": "{{#label}} must not have leading or trailing whitespace",
                    "string.uri": "{{#label}} must be a valid uri",
                    "string.uriCustomScheme": "{{#label}} must be a valid uri with a scheme matching the {{#scheme}} pattern",
                    "string.uriRelativeOnly": "{{#label}} must be a valid relative uri",
                    "string.uppercase": "{{#label}} must only contain uppercase characters"
                }
            }), h.addressOptions = function(e) {
                if (!e) return e;
                if (s(void 0 === e.minDomainSegments || Number.isSafeInteger(e.minDomainSegments) && e.minDomainSegments > 0, "minDomainSegments must be a positive integer"), s(void 0 === e.maxDomainSegments || Number.isSafeInteger(e.maxDomainSegments) && e.maxDomainSegments > 0, "maxDomainSegments must be a positive integer"), !1 === e.tlds) return e;
                if (!0 === e.tlds || void 0 === e.tlds) return s(h.tlds, "Built-in TLD list disabled"), Object.assign({}, e, h.tlds);
                s("object" == typeof e.tlds, "tlds must be true, false, or an object");
                const t = e.tlds.deny;
                if (t) return Array.isArray(t) && (e = Object.assign({}, e, {
                    tlds: {
                        deny: new Set(t)
                    }
                })), s(e.tlds.deny instanceof Set, "tlds.deny must be an array, Set, or boolean"), s(!e.tlds.allow, "Cannot specify both tlds.allow and tlds.deny lists"), h.validateTlds(e.tlds.deny, "tlds.deny"), e;
                const r = e.tlds.allow;
                return r ? !0 === r ? (s(h.tlds, "Built-in TLD list disabled"), Object.assign({}, e, h.tlds)) : (Array.isArray(r) && (e = Object.assign({}, e, {
                    tlds: {
                        allow: new Set(r)
                    }
                })), s(e.tlds.allow instanceof Set, "tlds.allow must be an array, Set, or boolean"), h.validateTlds(e.tlds.allow, "tlds.allow"), e) : e;
            }, h.validateTlds = function(e, t) {
                for (const r of e)s(n.isValid(r, {
                    minDomainSegments: 1,
                    maxDomainSegments: 1
                }), `${t} must contain valid top level domain names`);
            }, h.isoDate = function(e) {
                if (!f.isIsoDate(e)) return null;
                /.*T.*[+-]\d\d$/.test(e) && (e += "00");
                const t = new Date(e);
                return isNaN(t.getTime()) ? null : t.toISOString();
            }, h.length = function(e, t, r, n, a) {
                return s(!a || !1, "Invalid encoding:", a), e.$_addRule({
                    name: t,
                    method: "length",
                    args: {
                        limit: r,
                        encoding: a
                    },
                    operator: n
                });
            };
        },
        8826: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8068), a = {};
            a.Map = class extends Map {
                slice() {
                    return new a.Map(this);
                }
            }, e.exports = n.extend({
                type: "symbol",
                terms: {
                    map: {
                        init: new a.Map
                    }
                },
                coerce: {
                    method (e, t) {
                        let { schema: r, error: s } = t;
                        const n = r.$_terms.map.get(e);
                        return n && (e = n), r._flags.only && "symbol" != typeof e ? {
                            value: e,
                            errors: s("symbol.map", {
                                map: r.$_terms.map
                            })
                        } : {
                            value: e
                        };
                    }
                },
                validate (e, t) {
                    let { error: r } = t;
                    if ("symbol" != typeof e) return {
                        value: e,
                        errors: r("symbol.base")
                    };
                },
                rules: {
                    map: {
                        method (e) {
                            e && !e[Symbol.iterator] && "object" == typeof e && (e = Object.entries(e)), s(e && e[Symbol.iterator], "Iterable must be an iterable or object");
                            const t = this.clone(), r = [];
                            for (const n of e){
                                s(n && n[Symbol.iterator], "Entry must be an iterable");
                                const [e, a] = n;
                                s("object" != typeof e && "function" != typeof e && "symbol" != typeof e, "Key must not be of type object, function, or Symbol"), s("symbol" == typeof a, "Value must be a Symbol"), t.$_terms.map.set(e, a), r.push(a);
                            }
                            return t.valid(...r);
                        }
                    }
                },
                manifest: {
                    build: (e, t)=>(t.map && (e = e.map(t.map)), e)
                },
                messages: {
                    "symbol.base": "{{#label}} must be a symbol",
                    "symbol.map": "{{#label}} must be one of {{#map}}"
                }
            });
        },
        8863: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(738), i = r(9621), o = r(8160), l = r(6354), c = r(493), u = {
                result: Symbol("result")
            };
            t.entry = function(e, t, r) {
                let n = o.defaults;
                r && (s(void 0 === r.warnings, "Cannot override warnings preference in synchronous validation"), s(void 0 === r.artifacts, "Cannot override artifacts preference in synchronous validation"), n = o.preferences(o.defaults, r));
                const a = u.entry(e, t, n);
                s(!a.mainstay.externals.length, "Schema with external rules must use validateAsync()");
                const i = {
                    value: a.value
                };
                return a.error && (i.error = a.error), a.mainstay.warnings.length && (i.warning = l.details(a.mainstay.warnings)), a.mainstay.debug && (i.debug = a.mainstay.debug), a.mainstay.artifacts && (i.artifacts = a.mainstay.artifacts), i;
            }, t.entryAsync = async function(e, t, r) {
                let s = o.defaults;
                r && (s = o.preferences(o.defaults, r));
                const n = u.entry(e, t, s), a = n.mainstay;
                if (n.error) throw a.debug && (n.error.debug = a.debug), n.error;
                if (a.externals.length) {
                    let t = n.value;
                    const c = [];
                    for (const n of a.externals){
                        const f = n.state.path, h = "link" === n.schema.type ? a.links.get(n.schema) : null;
                        let m, d, p = t;
                        const g = f.length ? [
                            t
                        ] : [], y = f.length ? i(e, f) : e;
                        if (f.length) {
                            m = f[f.length - 1];
                            let e = t;
                            for (const t of f.slice(0, -1))e = e[t], g.unshift(e);
                            d = g[0], p = d[m];
                        }
                        try {
                            const e = (e, t)=>(h || n.schema).$_createError(e, p, t, n.state, s), i = await n.method(p, {
                                schema: n.schema,
                                linked: h,
                                state: n.state,
                                prefs: r,
                                original: y,
                                error: e,
                                errorsArray: u.errorsArray,
                                warn: (e, t)=>a.warnings.push((h || n.schema).$_createError(e, p, t, n.state, s)),
                                message: (e, t)=>(h || n.schema).$_createError("external", p, t, n.state, s, {
                                        messages: e
                                    })
                            });
                            if (void 0 === i || i === p) continue;
                            if (i instanceof l.Report) {
                                if (a.tracer.log(n.schema, n.state, "rule", "external", "error"), c.push(i), s.abortEarly) break;
                                continue;
                            }
                            if (Array.isArray(i) && i[o.symbols.errors]) {
                                if (a.tracer.log(n.schema, n.state, "rule", "external", "error"), c.push(...i), s.abortEarly) break;
                                continue;
                            }
                            d ? (a.tracer.value(n.state, "rule", p, i, "external"), d[m] = i) : (a.tracer.value(n.state, "rule", t, i, "external"), t = i);
                        } catch (e) {
                            throw s.errors.label && (e.message += ` (${n.label})`), e;
                        }
                    }
                    if (n.value = t, c.length) throw n.error = l.process(c, e, s), a.debug && (n.error.debug = a.debug), n.error;
                }
                if (!s.warnings && !s.debug && !s.artifacts) return n.value;
                const c = {
                    value: n.value
                };
                return a.warnings.length && (c.warning = l.details(a.warnings)), a.debug && (c.debug = a.debug), a.artifacts && (c.artifacts = a.artifacts), c;
            }, u.Mainstay = class {
                constructor(e, t, r){
                    this.externals = [], this.warnings = [], this.tracer = e, this.debug = t, this.links = r, this.shadow = null, this.artifacts = null, this._snapshots = [];
                }
                snapshot() {
                    this._snapshots.push({
                        externals: this.externals.slice(),
                        warnings: this.warnings.slice()
                    });
                }
                restore() {
                    const e = this._snapshots.pop();
                    this.externals = e.externals, this.warnings = e.warnings;
                }
            }, u.entry = function(e, r, s) {
                const { tracer: n, cleanup: a } = u.tracer(r, s), i = s.debug ? [] : null, o = r._ids._schemaChain ? new Map : null, f = new u.Mainstay(n, i, o), h = r._ids._schemaChain ? [
                    {
                        schema: r
                    }
                ] : null, m = new c([], [], {
                    mainstay: f,
                    schemas: h
                }), d = t.validate(e, r, m, s);
                a && r.$_root.untrace();
                const p = l.process(d.errors, e, s);
                return {
                    value: d.value,
                    error: p,
                    mainstay: f
                };
            }, u.tracer = function(e, t) {
                return e.$_root._tracer ? {
                    tracer: e.$_root._tracer._register(e)
                } : t.debug ? (s(e.$_root.trace, "Debug mode not supported"), {
                    tracer: e.$_root.trace()._register(e),
                    cleanup: !0
                }) : {
                    tracer: u.ignore
                };
            }, t.validate = function(e, t, r, s) {
                let n = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
                if (t.$_terms.whens && (t = t._generate(e, r, s).schema), t._preferences && (s = u.prefs(t, s)), t._cache && s.cache) {
                    const s = t._cache.get(e);
                    if (r.mainstay.tracer.debug(r, "validate", "cached", !!s), s) return s;
                }
                const a = (n, a, i)=>t.$_createError(n, e, a, i || r, s), i = {
                    original: e,
                    prefs: s,
                    schema: t,
                    state: r,
                    error: a,
                    errorsArray: u.errorsArray,
                    warn: (e, t, s)=>r.mainstay.warnings.push(a(e, t, s)),
                    message: (n, a)=>t.$_createError("custom", e, a, r, s, {
                            messages: n
                        })
                };
                r.mainstay.tracer.entry(t, r);
                const l = t._definition;
                if (l.prepare && void 0 !== e && s.convert) {
                    const t = l.prepare(e, i);
                    if (t) {
                        if (r.mainstay.tracer.value(r, "prepare", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), i);
                        e = t.value;
                    }
                }
                if (l.coerce && void 0 !== e && s.convert && (!l.coerce.from || l.coerce.from.includes(typeof e))) {
                    const t = l.coerce.method(e, i);
                    if (t) {
                        if (r.mainstay.tracer.value(r, "coerced", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), i);
                        e = t.value;
                    }
                }
                const c = t._flags.empty;
                c && c.$_match(u.trim(e, t), r.nest(c), o.defaults) && (r.mainstay.tracer.value(r, "empty", e, void 0), e = void 0);
                const f = n.presence || t._flags.presence || (t._flags._endedSwitch ? null : s.presence);
                if (void 0 === e) {
                    if ("forbidden" === f) return u.finalize(e, null, i);
                    if ("required" === f) return u.finalize(e, [
                        t.$_createError("any.required", e, null, r, s)
                    ], i);
                    if ("optional" === f) {
                        if (t._flags.default !== o.symbols.deepDefault) return u.finalize(e, null, i);
                        r.mainstay.tracer.value(r, "default", e, {}), e = {};
                    }
                } else if ("forbidden" === f) return u.finalize(e, [
                    t.$_createError("any.unknown", e, null, r, s)
                ], i);
                const h = [];
                if (t._valids) {
                    const n = t._valids.get(e, r, s, t._flags.insensitive);
                    if (n) return s.convert && (r.mainstay.tracer.value(r, "valids", e, n.value), e = n.value), r.mainstay.tracer.filter(t, r, "valid", n), u.finalize(e, null, i);
                    if (t._flags.only) {
                        const n = t.$_createError("any.only", e, {
                            valids: t._valids.values({
                                display: !0
                            })
                        }, r, s);
                        if (s.abortEarly) return u.finalize(e, [
                            n
                        ], i);
                        h.push(n);
                    }
                }
                if (t._invalids) {
                    const n = t._invalids.get(e, r, s, t._flags.insensitive);
                    if (n) {
                        r.mainstay.tracer.filter(t, r, "invalid", n);
                        const a = t.$_createError("any.invalid", e, {
                            invalids: t._invalids.values({
                                display: !0
                            })
                        }, r, s);
                        if (s.abortEarly) return u.finalize(e, [
                            a
                        ], i);
                        h.push(a);
                    }
                }
                if (l.validate) {
                    const t = l.validate(e, i);
                    if (t && (r.mainstay.tracer.value(r, "base", e, t.value), e = t.value, t.errors)) {
                        if (!Array.isArray(t.errors)) return h.push(t.errors), u.finalize(e, h, i);
                        if (t.errors.length) return h.push(...t.errors), u.finalize(e, h, i);
                    }
                }
                return t._rules.length ? u.rules(e, h, i) : u.finalize(e, h, i);
            }, u.rules = function(e, t, r) {
                const { schema: s, state: n, prefs: a } = r;
                for (const i of s._rules){
                    const l = s._definition.rules[i.method];
                    if (l.convert && a.convert) {
                        n.mainstay.tracer.log(s, n, "rule", i.name, "full");
                        continue;
                    }
                    let c, f = i.args;
                    if (i._resolve.length) {
                        f = Object.assign({}, f);
                        for (const t of i._resolve){
                            const r = l.argsByName.get(t), i = f[t].resolve(e, n, a), u = r.normalize ? r.normalize(i) : i, h = o.validateArg(u, null, r);
                            if (h) {
                                c = s.$_createError("any.ref", i, {
                                    arg: t,
                                    ref: f[t],
                                    reason: h
                                }, n, a);
                                break;
                            }
                            f[t] = u;
                        }
                    }
                    c = c || l.validate(e, r, f, i);
                    const h = u.rule(c, i);
                    if (h.errors) {
                        if (n.mainstay.tracer.log(s, n, "rule", i.name, "error"), i.warn) {
                            n.mainstay.warnings.push(...h.errors);
                            continue;
                        }
                        if (a.abortEarly) return u.finalize(e, h.errors, r);
                        t.push(...h.errors);
                    } else n.mainstay.tracer.log(s, n, "rule", i.name, "pass"), n.mainstay.tracer.value(n, "rule", e, h.value, i.name), e = h.value;
                }
                return u.finalize(e, t, r);
            }, u.rule = function(e, t) {
                return e instanceof l.Report ? (u.error(e, t), {
                    errors: [
                        e
                    ],
                    value: null
                }) : Array.isArray(e) && e[o.symbols.errors] ? (e.forEach((e)=>u.error(e, t)), {
                    errors: e,
                    value: null
                }) : {
                    errors: null,
                    value: e
                };
            }, u.error = function(e, t) {
                return t.message && e._setTemplate(t.message), e;
            }, u.finalize = function(e, t, r) {
                t = t || [];
                const { schema: n, state: a, prefs: i } = r;
                if (t.length) {
                    const s = u.default("failover", void 0, t, r);
                    void 0 !== s && (a.mainstay.tracer.value(a, "failover", e, s), e = s, t = []);
                }
                if (t.length && n._flags.error) {
                    if ("function" == typeof n._flags.error) {
                        t = n._flags.error(t), Array.isArray(t) || (t = [
                            t
                        ]);
                        for (const e of t)s(e instanceof Error || e instanceof l.Report, "error() must return an Error object");
                    } else t = [
                        n._flags.error
                    ];
                }
                if (void 0 === e) {
                    const s = u.default("default", e, t, r);
                    a.mainstay.tracer.value(a, "default", e, s), e = s;
                }
                if (n._flags.cast && void 0 !== e) {
                    const t = n._definition.cast[n._flags.cast];
                    if (t.from(e)) {
                        const s = t.to(e, r);
                        a.mainstay.tracer.value(a, "cast", e, s, n._flags.cast), e = s;
                    }
                }
                if (n.$_terms.externals && i.externals && !1 !== i._externals) for (const { method: e } of n.$_terms.externals)a.mainstay.externals.push({
                    method: e,
                    schema: n,
                    state: a,
                    label: l.label(n._flags, a, i)
                });
                const o = {
                    value: e,
                    errors: t.length ? t : null
                };
                return n._flags.result && (o.value = "strip" === n._flags.result ? void 0 : r.original, a.mainstay.tracer.value(a, n._flags.result, e, o.value), a.shadow(e, n._flags.result)), n._cache && !1 !== i.cache && !n._refs.length && n._cache.set(r.original, o), void 0 === e || o.errors || void 0 === n._flags.artifact || (a.mainstay.artifacts = a.mainstay.artifacts || new Map, a.mainstay.artifacts.has(n._flags.artifact) || a.mainstay.artifacts.set(n._flags.artifact, []), a.mainstay.artifacts.get(n._flags.artifact).push(a.path)), o;
            }, u.prefs = function(e, t) {
                const r = t === o.defaults;
                return r && e._preferences[o.symbols.prefs] ? e._preferences[o.symbols.prefs] : (t = o.preferences(t, e._preferences), r && (e._preferences[o.symbols.prefs] = t), t);
            }, u.default = function(e, t, r, s) {
                const { schema: a, state: i, prefs: l } = s, c = a._flags[e];
                if (l.noDefaults || void 0 === c) return t;
                if (i.mainstay.tracer.log(a, i, "rule", e, "full"), !c) return c;
                if ("function" == typeof c) {
                    const t = c.length ? [
                        n(i.ancestors[0]),
                        s
                    ] : [];
                    try {
                        return c(...t);
                    } catch (t) {
                        return void r.push(a.$_createError(`any.${e}`, null, {
                            error: t
                        }, i, l));
                    }
                }
                return "object" != typeof c ? c : c[o.symbols.literal] ? c.literal : o.isResolvable(c) ? c.resolve(t, i, l) : n(c);
            }, u.trim = function(e, t) {
                if ("string" != typeof e) return e;
                const r = t.$_getRule("trim");
                return r && r.args.enabled ? e.trim() : e;
            }, u.ignore = {
                active: !1,
                debug: a,
                entry: a,
                filter: a,
                log: a,
                resolve: a,
                value: a
            }, u.errorsArray = function() {
                const e = [];
                return e[o.symbols.errors] = !0, e;
            };
        },
        2036: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(9474), a = r(8160), i = {};
            e.exports = i.Values = class {
                constructor(e, t){
                    this._values = new Set(e), this._refs = new Set(t), this._lowercase = i.lowercases(e), this._override = !1;
                }
                get length() {
                    return this._values.size + this._refs.size;
                }
                add(e, t) {
                    a.isResolvable(e) ? this._refs.has(e) || (this._refs.add(e), t && t.register(e)) : this.has(e, null, null, !1) || (this._values.add(e), "string" == typeof e && this._lowercase.set(e.toLowerCase(), e));
                }
                static merge(e, t, r) {
                    if (e = e || new i.Values, t) {
                        if (t._override) return t.clone();
                        for (const r of [
                            ...t._values,
                            ...t._refs
                        ])e.add(r);
                    }
                    if (r) for (const t of [
                        ...r._values,
                        ...r._refs
                    ])e.remove(t);
                    return e.length ? e : null;
                }
                remove(e) {
                    a.isResolvable(e) ? this._refs.delete(e) : (this._values.delete(e), "string" == typeof e && this._lowercase.delete(e.toLowerCase()));
                }
                has(e, t, r, s) {
                    return !!this.get(e, t, r, s);
                }
                get(e, t, r, s) {
                    if (!this.length) return !1;
                    if (this._values.has(e)) return {
                        value: e
                    };
                    if ("string" == typeof e && e && s) {
                        const t = this._lowercase.get(e.toLowerCase());
                        if (t) return {
                            value: t
                        };
                    }
                    if (!this._refs.size && "object" != typeof e) return !1;
                    if ("object" == typeof e) {
                        for (const t of this._values)if (n(t, e)) return {
                            value: t
                        };
                    }
                    if (t) for (const a of this._refs){
                        const i = a.resolve(e, t, r, null, {
                            in: !0
                        });
                        if (void 0 === i) continue;
                        const o = a.in && "object" == typeof i ? Array.isArray(i) ? i : Object.keys(i) : [
                            i
                        ];
                        for (const t of o)if (typeof t == typeof e) {
                            if (s && e && "string" == typeof e) {
                                if (t.toLowerCase() === e.toLowerCase()) return {
                                    value: t,
                                    ref: a
                                };
                            } else if (n(t, e)) return {
                                value: t,
                                ref: a
                            };
                        }
                    }
                    return !1;
                }
                override() {
                    this._override = !0;
                }
                values(e) {
                    if (e && e.display) {
                        const e = [];
                        for (const t of [
                            ...this._values,
                            ...this._refs
                        ])void 0 !== t && e.push(t);
                        return e;
                    }
                    return Array.from([
                        ...this._values,
                        ...this._refs
                    ]);
                }
                clone() {
                    const e = new i.Values(this._values, this._refs);
                    return e._override = this._override, e;
                }
                concat(e) {
                    s(!e._override, "Cannot concat override set of values");
                    const t = new i.Values([
                        ...this._values,
                        ...e._values
                    ], [
                        ...this._refs,
                        ...e._refs
                    ]);
                    return t._override = this._override, t;
                }
                describe() {
                    const e = [];
                    this._override && e.push({
                        override: !0
                    });
                    for (const t of this._values.values())e.push(t && "object" == typeof t ? {
                        value: t
                    } : t);
                    for (const t of this._refs.values())e.push(t.describe());
                    return e;
                }
            }, i.Values.prototype[a.symbols.values] = !0, i.Values.prototype.slice = i.Values.prototype.clone, i.lowercases = function(e) {
                const t = new Map;
                if (e) for (const r of e)"string" == typeof r && t.set(r.toLowerCase(), r);
                return t;
            };
        },
        978: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(1687), i = r(9621), o = {};
            e.exports = function(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (s(e && "object" == typeof e, "Invalid defaults value: must be an object"), s(!t || !0 === t || "object" == typeof t, "Invalid source value: must be true, falsy or an object"), s("object" == typeof r, "Invalid options: must be an object"), !t) return null;
                if (r.shallow) return o.applyToDefaultsWithShallow(e, t, r);
                const i = n(e);
                if (!0 === t) return i;
                const l = void 0 !== r.nullOverride && r.nullOverride;
                return a(i, t, {
                    nullOverride: l,
                    mergeArrays: !1
                });
            }, o.applyToDefaultsWithShallow = function(e, t, r) {
                const l = r.shallow;
                s(Array.isArray(l), "Invalid keys");
                const c = new Map, u = !0 === t ? null : new Set;
                for (let r of l){
                    r = Array.isArray(r) ? r : r.split(".");
                    const s = i(e, r);
                    s && "object" == typeof s ? c.set(s, u && i(t, r) || s) : u && u.add(r);
                }
                const f = n(e, {}, c);
                if (!u) return f;
                for (const e of u)o.reachCopy(f, t, e);
                const h = void 0 !== r.nullOverride && r.nullOverride;
                return a(f, t, {
                    nullOverride: h,
                    mergeArrays: !1
                });
            }, o.reachCopy = function(e, t, r) {
                for (const e of r){
                    if (!(e in t)) return;
                    const r = t[e];
                    if ("object" != typeof r || null === r) return;
                    t = r;
                }
                const s = t;
                let n = e;
                for(let e = 0; e < r.length - 1; ++e){
                    const t = r[e];
                    "object" != typeof n[t] && (n[t] = {}), n = n[t];
                }
                n[r[r.length - 1]] = s;
            };
        },
        375: (e, t, r)=>{
            "use strict";
            const s = r(7916);
            e.exports = function(e) {
                if (!e) {
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                    if (1 === r.length && r[0] instanceof Error) throw r[0];
                    throw new s(r);
                }
            };
        },
        8571: (e, t, r)=>{
            "use strict";
            const s = r(9621), n = r(4277), a = r(7043), i = {
                needsProtoHack: new Set([
                    n.set,
                    n.map,
                    n.weakSet,
                    n.weakMap
                ])
            };
            e.exports = i.clone = function(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                if ("object" != typeof e || null === e) return e;
                let s = i.clone, o = r;
                if (t.shallow) {
                    if (!0 !== t.shallow) return i.cloneWithShallow(e, t);
                    s = (e)=>e;
                } else if (o) {
                    const t = o.get(e);
                    if (t) return t;
                } else o = new Map;
                const l = n.getInternalProto(e);
                if (l === n.buffer) return !1;
                if (l === n.date) return new Date(e.getTime());
                if (l === n.regex) return new RegExp(e);
                const c = i.base(e, l, t);
                if (c === e) return e;
                if (o && o.set(e, c), l === n.set) for (const r of e)c.add(s(r, t, o));
                else if (l === n.map) for (const [r, n] of e)c.set(r, s(n, t, o));
                const u = a.keys(e, t);
                for (const r of u){
                    if ("__proto__" === r) continue;
                    if (l === n.array && "length" === r) {
                        c.length = e.length;
                        continue;
                    }
                    const a = Object.getOwnPropertyDescriptor(e, r);
                    a ? a.get || a.set ? Object.defineProperty(c, r, a) : a.enumerable ? c[r] = s(e[r], t, o) : Object.defineProperty(c, r, {
                        enumerable: !1,
                        writable: !0,
                        configurable: !0,
                        value: s(e[r], t, o)
                    }) : Object.defineProperty(c, r, {
                        enumerable: !0,
                        writable: !0,
                        configurable: !0,
                        value: s(e[r], t, o)
                    });
                }
                return c;
            }, i.cloneWithShallow = function(e, t) {
                const r = t.shallow;
                (t = Object.assign({}, t)).shallow = !1;
                const n = new Map;
                for (const t of r){
                    const r = s(e, t);
                    "object" != typeof r && "function" != typeof r || n.set(r, r);
                }
                return i.clone(e, t, n);
            }, i.base = function(e, t, r) {
                if (!1 === r.prototype) return i.needsProtoHack.has(t) ? new t.constructor : t === n.array ? [] : {};
                const s = Object.getPrototypeOf(e);
                if (s && s.isImmutable) return e;
                if (t === n.array) {
                    const e = [];
                    return s !== t && Object.setPrototypeOf(e, s), e;
                }
                if (i.needsProtoHack.has(t)) {
                    const e = new s.constructor;
                    return s !== t && Object.setPrototypeOf(e, s), e;
                }
                return Object.create(s);
            };
        },
        9474: (e, t, r)=>{
            "use strict";
            const s = r(4277), n = {
                mismatched: null
            };
            e.exports = function(e, t, r) {
                return r = Object.assign({
                    prototype: !0
                }, r), !!n.isDeepEqual(e, t, r, []);
            }, n.isDeepEqual = function(e, t, r, a) {
                if (e === t) return 0 !== e || 1 / e == 1 / t;
                const i = typeof e;
                if (i !== typeof t) return !1;
                if (null === e || null === t) return !1;
                if ("function" === i) {
                    if (!r.deepFunction || e.toString() !== t.toString()) return !1;
                } else if ("object" !== i) return e != e && t != t;
                const o = n.getSharedType(e, t, !!r.prototype);
                switch(o){
                    case s.buffer:
                        return !1;
                    case s.promise:
                        return e === t;
                    case s.regex:
                        return e.toString() === t.toString();
                    case n.mismatched:
                        return !1;
                }
                for(let r = a.length - 1; r >= 0; --r)if (a[r].isSame(e, t)) return !0;
                a.push(new n.SeenEntry(e, t));
                try {
                    return !!n.isDeepEqualObj(o, e, t, r, a);
                } finally{
                    a.pop();
                }
            }, n.getSharedType = function(e, t, r) {
                if (r) return Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? n.mismatched : s.getInternalProto(e);
                const a = s.getInternalProto(e);
                return a !== s.getInternalProto(t) ? n.mismatched : a;
            }, n.valueOf = function(e) {
                const t = e.valueOf;
                if (void 0 === t) return e;
                try {
                    return t.call(e);
                } catch (e) {
                    return e;
                }
            }, n.hasOwnEnumerableProperty = function(e, t) {
                return Object.prototype.propertyIsEnumerable.call(e, t);
            }, n.isSetSimpleEqual = function(e, t) {
                for (const r of Set.prototype.values.call(e))if (!Set.prototype.has.call(t, r)) return !1;
                return !0;
            }, n.isDeepEqualObj = function(e, t, r, a, i) {
                const { isDeepEqual: o, valueOf: l, hasOwnEnumerableProperty: c } = n, { keys: u, getOwnPropertySymbols: f } = Object;
                if (e === s.array) {
                    if (!a.part) {
                        if (t.length !== r.length) return !1;
                        for(let e = 0; e < t.length; ++e)if (!o(t[e], r[e], a, i)) return !1;
                        return !0;
                    }
                    for (const e of t)for (const t of r)if (o(e, t, a, i)) return !0;
                } else if (e === s.set) {
                    if (t.size !== r.size) return !1;
                    if (!n.isSetSimpleEqual(t, r)) {
                        const e = new Set(Set.prototype.values.call(r));
                        for (const r of Set.prototype.values.call(t)){
                            if (e.delete(r)) continue;
                            let t = !1;
                            for (const s of e)if (o(r, s, a, i)) {
                                e.delete(s), t = !0;
                                break;
                            }
                            if (!t) return !1;
                        }
                    }
                } else if (e === s.map) {
                    if (t.size !== r.size) return !1;
                    for (const [e, s] of Map.prototype.entries.call(t)){
                        if (void 0 === s && !Map.prototype.has.call(r, e)) return !1;
                        if (!o(s, Map.prototype.get.call(r, e), a, i)) return !1;
                    }
                } else if (e === s.error && (t.name !== r.name || t.message !== r.message)) return !1;
                const h = l(t), m = l(r);
                if ((t !== h || r !== m) && !o(h, m, a, i)) return !1;
                const d = u(t);
                if (!a.part && d.length !== u(r).length && !a.skip) return !1;
                let p = 0;
                for (const e of d)if (a.skip && a.skip.includes(e)) void 0 === r[e] && ++p;
                else {
                    if (!c(r, e)) return !1;
                    if (!o(t[e], r[e], a, i)) return !1;
                }
                if (!a.part && d.length - p !== u(r).length) return !1;
                if (!1 !== a.symbols) {
                    const e = f(t), s = new Set(f(r));
                    for (const n of e){
                        if (!a.skip || !a.skip.includes(n)) {
                            if (c(t, n)) {
                                if (!c(r, n)) return !1;
                                if (!o(t[n], r[n], a, i)) return !1;
                            } else if (c(r, n)) return !1;
                        }
                        s.delete(n);
                    }
                    for (const e of s)if (c(r, e)) return !1;
                }
                return !0;
            }, n.SeenEntry = class {
                constructor(e, t){
                    this.obj = e, this.ref = t;
                }
                isSame(e, t) {
                    return this.obj === e && this.ref === t;
                }
            };
        },
        7916: (e, t, r)=>{
            "use strict";
            const s = r(8761);
            e.exports = class extends Error {
                constructor(e){
                    super(e.filter((e)=>"" !== e).map((e)=>"string" == typeof e ? e : e instanceof Error ? e.message : s(e)).join(" ") || "Unknown error"), "function" == typeof Error.captureStackTrace && Error.captureStackTrace(this, t.assert);
                }
            };
        },
        5277: (e)=>{
            "use strict";
            const t = {};
            e.exports = function(e) {
                if (!e) return "";
                let r = "";
                for(let s = 0; s < e.length; ++s){
                    const n = e.charCodeAt(s);
                    t.isSafe(n) ? r += e[s] : r += t.escapeHtmlChar(n);
                }
                return r;
            }, t.escapeHtmlChar = function(e) {
                return t.namedHtml.get(e) || (e >= 256 ? "&#" + e + ";" : `&#x${e.toString(16).padStart(2, "0")};`);
            }, t.isSafe = function(e) {
                return t.safeCharCodes.has(e);
            }, t.namedHtml = new Map([
                [
                    38,
                    "&amp;"
                ],
                [
                    60,
                    "&lt;"
                ],
                [
                    62,
                    "&gt;"
                ],
                [
                    34,
                    "&quot;"
                ],
                [
                    160,
                    "&nbsp;"
                ],
                [
                    162,
                    "&cent;"
                ],
                [
                    163,
                    "&pound;"
                ],
                [
                    164,
                    "&curren;"
                ],
                [
                    169,
                    "&copy;"
                ],
                [
                    174,
                    "&reg;"
                ]
            ]), t.safeCharCodes = function() {
                const e = new Set;
                for(let t = 32; t < 123; ++t)(t >= 97 || t >= 65 && t <= 90 || t >= 48 && t <= 57 || 32 === t || 46 === t || 44 === t || 45 === t || 58 === t || 95 === t) && e.add(t);
                return e;
            }();
        },
        6064: (e)=>{
            "use strict";
            e.exports = function(e) {
                return e.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, "\\$&");
            };
        },
        738: (e)=>{
            "use strict";
            e.exports = function() {};
        },
        1687: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(7043), i = {};
            e.exports = i.merge = function(e, t, r) {
                if (s(e && "object" == typeof e, "Invalid target value: must be an object"), s(null == t || "object" == typeof t, "Invalid source value: must be null, undefined, or an object"), !t) return e;
                if (r = Object.assign({
                    nullOverride: !0,
                    mergeArrays: !0
                }, r), Array.isArray(t)) {
                    s(Array.isArray(e), "Cannot merge array onto an object"), r.mergeArrays || (e.length = 0);
                    for(let s = 0; s < t.length; ++s)e.push(n(t[s], {
                        symbols: r.symbols
                    }));
                    return e;
                }
                const o = a.keys(t, r);
                for(let s = 0; s < o.length; ++s){
                    const a = o[s];
                    if ("__proto__" === a || !Object.prototype.propertyIsEnumerable.call(t, a)) continue;
                    const l = t[a];
                    if (l && "object" == typeof l) {
                        if (e[a] === l) continue;
                        !e[a] || "object" != typeof e[a] || Array.isArray(e[a]) !== Array.isArray(l) || l instanceof Date || l instanceof RegExp ? e[a] = n(l, {
                            symbols: r.symbols
                        }) : i.merge(e[a], l, r);
                    } else (null != l || r.nullOverride) && (e[a] = l);
                }
                return e;
            };
        },
        9621: (e, t, r)=>{
            "use strict";
            const s = r(375), n = {};
            e.exports = function(e, t, r) {
                if (!1 === t || null == t) return e;
                "string" == typeof (r = r || {}) && (r = {
                    separator: r
                });
                const a = Array.isArray(t);
                s(!a || !r.separator, "Separator option is not valid for array-based chain");
                const i = a ? t : t.split(r.separator || ".");
                let o = e;
                for(let e = 0; e < i.length; ++e){
                    let a = i[e];
                    const l = r.iterables && n.iterables(o);
                    if (Array.isArray(o) || "set" === l) {
                        const e = Number(a);
                        Number.isInteger(e) && (a = e < 0 ? o.length + e : e);
                    }
                    if (!o || "function" == typeof o && !1 === r.functions || !l && void 0 === o[a]) {
                        s(!r.strict || e + 1 === i.length, "Missing segment", a, "in reach path ", t), s("object" == typeof o || !0 === r.functions || "function" != typeof o, "Invalid segment", a, "in reach path ", t), o = r.default;
                        break;
                    }
                    o = l ? "set" === l ? [
                        ...o
                    ][a] : o.get(a) : o[a];
                }
                return o;
            }, n.iterables = function(e) {
                return e instanceof Set ? "set" : e instanceof Map ? "map" : void 0;
            };
        },
        8761: (e)=>{
            "use strict";
            e.exports = function() {
                try {
                    return JSON.stringify(...arguments);
                } catch (e) {
                    return "[Cannot display object: " + e.message + "]";
                }
            };
        },
        4277: (e, t)=>{
            "use strict";
            const r = {};
            t = e.exports = {
                array: Array.prototype,
                buffer: !1,
                date: Date.prototype,
                error: Error.prototype,
                generic: Object.prototype,
                map: Map.prototype,
                promise: Promise.prototype,
                regex: RegExp.prototype,
                set: Set.prototype,
                weakMap: WeakMap.prototype,
                weakSet: WeakSet.prototype
            }, r.typeMap = new Map([
                [
                    "[object Error]",
                    t.error
                ],
                [
                    "[object Map]",
                    t.map
                ],
                [
                    "[object Promise]",
                    t.promise
                ],
                [
                    "[object Set]",
                    t.set
                ],
                [
                    "[object WeakMap]",
                    t.weakMap
                ],
                [
                    "[object WeakSet]",
                    t.weakSet
                ]
            ]), t.getInternalProto = function(e) {
                if (Array.isArray(e)) return t.array;
                if (e instanceof Date) return t.date;
                if (e instanceof RegExp) return t.regex;
                if (e instanceof Error) return t.error;
                const s = Object.prototype.toString.call(e);
                return r.typeMap.get(s) || t.generic;
            };
        },
        7043: (e, t)=>{
            "use strict";
            t.keys = function(e) {
                return !1 !== (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).symbols ? Reflect.ownKeys(e) : Object.getOwnPropertyNames(e);
            };
        },
        3652: (e, t, r)=>{
            "use strict";
            const s = r(375), n = {};
            t.Sorter = class {
                constructor(){
                    this._items = [], this.nodes = [];
                }
                add(e, t) {
                    const r = [].concat((t = t || {}).before || []), n = [].concat(t.after || []), a = t.group || "?", i = t.sort || 0;
                    s(!r.includes(a), `Item cannot come before itself: ${a}`), s(!r.includes("?"), "Item cannot come before unassociated items"), s(!n.includes(a), `Item cannot come after itself: ${a}`), s(!n.includes("?"), "Item cannot come after unassociated items"), Array.isArray(e) || (e = [
                        e
                    ]);
                    for (const t of e){
                        const e = {
                            seq: this._items.length,
                            sort: i,
                            before: r,
                            after: n,
                            group: a,
                            node: t
                        };
                        this._items.push(e);
                    }
                    if (!t.manual) {
                        const e = this._sort();
                        s(e, "item", "?" !== a ? `added into group ${a}` : "", "created a dependencies error");
                    }
                    return this.nodes;
                }
                merge(e) {
                    Array.isArray(e) || (e = [
                        e
                    ]);
                    for (const t of e)if (t) for (const e of t._items)this._items.push(Object.assign({}, e));
                    this._items.sort(n.mergeSort);
                    for(let e = 0; e < this._items.length; ++e)this._items[e].seq = e;
                    const t = this._sort();
                    return s(t, "merge created a dependencies error"), this.nodes;
                }
                sort() {
                    const e = this._sort();
                    return s(e, "sort created a dependencies error"), this.nodes;
                }
                _sort() {
                    const e = {}, t = Object.create(null), r = Object.create(null);
                    for (const s of this._items){
                        const n = s.seq, a = s.group;
                        r[a] = r[a] || [], r[a].push(n), e[n] = s.before;
                        for (const e of s.after)t[e] = t[e] || [], t[e].push(n);
                    }
                    for(const t in e){
                        const s = [];
                        for(const n in e[t]){
                            const a = e[t][n];
                            r[a] = r[a] || [], s.push(...r[a]);
                        }
                        e[t] = s;
                    }
                    for(const s in t)if (r[s]) for (const n of r[s])e[n].push(...t[s]);
                    const s = {};
                    for(const t in e){
                        const r = e[t];
                        for (const e of r)s[e] = s[e] || [], s[e].push(t);
                    }
                    const n = {}, a = [];
                    for(let e = 0; e < this._items.length; ++e){
                        let t = e;
                        if (s[e]) {
                            t = null;
                            for(let e = 0; e < this._items.length; ++e){
                                if (!0 === n[e]) continue;
                                s[e] || (s[e] = []);
                                const r = s[e].length;
                                let a = 0;
                                for(let t = 0; t < r; ++t)n[s[e][t]] && ++a;
                                if (a === r) {
                                    t = e;
                                    break;
                                }
                            }
                        }
                        null !== t && (n[t] = !0, a.push(t));
                    }
                    if (a.length !== this._items.length) return !1;
                    const i = {};
                    for (const e of this._items)i[e.seq] = e;
                    this._items = [], this.nodes = [];
                    for (const e of a){
                        const t = i[e];
                        this.nodes.push(t.node), this._items.push(t);
                    }
                    return !0;
                }
            }, n.mergeSort = (e, t)=>e.sort === t.sort ? 0 : e.sort < t.sort ? -1 : 1;
        },
        5380: (e, t, r)=>{
            "use strict";
            const s = r(443), n = r(2178), a = {
                minDomainSegments: 2,
                nonAsciiRx: /[^\x00-\x7f]/,
                domainControlRx: /[\x00-\x20@\:\/\\#!\$&\'\(\)\*\+,;=\?]/,
                tldSegmentRx: /^[a-zA-Z](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
                domainSegmentRx: /^[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
                URL: s.URL || URL
            };
            t.analyze = function(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (!e) return n.code("DOMAIN_NON_EMPTY_STRING");
                if ("string" != typeof e) throw new Error("Invalid input: domain must be a string");
                if (e.length > 256) return n.code("DOMAIN_TOO_LONG");
                if (a.nonAsciiRx.test(e)) {
                    if (!1 === t.allowUnicode) return n.code("DOMAIN_INVALID_UNICODE_CHARS");
                    e = e.normalize("NFC");
                }
                if (a.domainControlRx.test(e)) return n.code("DOMAIN_INVALID_CHARS");
                e = a.punycode(e), t.allowFullyQualified && "." === e[e.length - 1] && (e = e.slice(0, -1));
                const r = t.minDomainSegments || a.minDomainSegments, s = e.split(".");
                if (s.length < r) return n.code("DOMAIN_SEGMENTS_COUNT");
                if (t.maxDomainSegments && s.length > t.maxDomainSegments) return n.code("DOMAIN_SEGMENTS_COUNT_MAX");
                const i = t.tlds;
                if (i) {
                    const e = s[s.length - 1].toLowerCase();
                    if (i.deny && i.deny.has(e) || i.allow && !i.allow.has(e)) return n.code("DOMAIN_FORBIDDEN_TLDS");
                }
                for(let e = 0; e < s.length; ++e){
                    const t = s[e];
                    if (!t.length) return n.code("DOMAIN_EMPTY_SEGMENT");
                    if (t.length > 63) return n.code("DOMAIN_LONG_SEGMENT");
                    if (e < s.length - 1) {
                        if (!a.domainSegmentRx.test(t)) return n.code("DOMAIN_INVALID_CHARS");
                    } else if (!a.tldSegmentRx.test(t)) return n.code("DOMAIN_INVALID_TLDS_CHARS");
                }
                return null;
            }, t.isValid = function(e, r) {
                return !t.analyze(e, r);
            }, a.punycode = function(e) {
                e.includes("%") && (e = e.replace(/%/g, "%25"));
                try {
                    return new a.URL(`http://${e}`).host;
                } catch (t) {
                    return e;
                }
            };
        },
        1745: (e, t, r)=>{
            "use strict";
            const s = r(9848), n = r(5380), a = r(2178), i = {
                nonAsciiRx: /[^\x00-\x7f]/,
                encoder: new (s.TextEncoder || TextEncoder)
            };
            t.analyze = function(e, t) {
                return i.email(e, t);
            }, t.isValid = function(e, t) {
                return !i.email(e, t);
            }, i.email = function(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if ("string" != typeof e) throw new Error("Invalid input: email must be a string");
                if (!e) return a.code("EMPTY_STRING");
                const r = !i.nonAsciiRx.test(e);
                if (!r) {
                    if (!1 === t.allowUnicode) return a.code("FORBIDDEN_UNICODE");
                    e = e.normalize("NFC");
                }
                const s = e.split("@");
                if (2 !== s.length) return s.length > 2 ? a.code("MULTIPLE_AT_CHAR") : a.code("MISSING_AT_CHAR");
                const [o, l] = s;
                if (!o) return a.code("EMPTY_LOCAL");
                if (!t.ignoreLength) {
                    if (e.length > 254) return a.code("ADDRESS_TOO_LONG");
                    if (i.encoder.encode(o).length > 64) return a.code("LOCAL_TOO_LONG");
                }
                return i.local(o, r) || n.analyze(l, t);
            }, i.local = function(e, t) {
                const r = e.split(".");
                for (const e of r){
                    if (!e.length) return a.code("EMPTY_LOCAL_SEGMENT");
                    if (t) {
                        if (!i.atextRx.test(e)) return a.code("INVALID_LOCAL_CHARS");
                    } else for (const t of e){
                        if (i.atextRx.test(t)) continue;
                        const e = i.binary(t);
                        if (!i.atomRx.test(e)) return a.code("INVALID_LOCAL_CHARS");
                    }
                }
            }, i.binary = function(e) {
                return Array.from(i.encoder.encode(e)).map((e)=>String.fromCharCode(e)).join("");
            }, i.atextRx = /^[\w!#\$%&'\*\+\-/=\?\^`\{\|\}~]+$/, i.atomRx = new RegExp([
                "(?:[\\xc2-\\xdf][\\x80-\\xbf])",
                "(?:\\xe0[\\xa0-\\xbf][\\x80-\\xbf])|(?:[\\xe1-\\xec][\\x80-\\xbf]{2})|(?:\\xed[\\x80-\\x9f][\\x80-\\xbf])|(?:[\\xee-\\xef][\\x80-\\xbf]{2})",
                "(?:\\xf0[\\x90-\\xbf][\\x80-\\xbf]{2})|(?:[\\xf1-\\xf3][\\x80-\\xbf]{3})|(?:\\xf4[\\x80-\\x8f][\\x80-\\xbf]{2})"
            ].join("|"));
        },
        2178: (e, t)=>{
            "use strict";
            t.codes = {
                EMPTY_STRING: "Address must be a non-empty string",
                FORBIDDEN_UNICODE: "Address contains forbidden Unicode characters",
                MULTIPLE_AT_CHAR: "Address cannot contain more than one @ character",
                MISSING_AT_CHAR: "Address must contain one @ character",
                EMPTY_LOCAL: "Address local part cannot be empty",
                ADDRESS_TOO_LONG: "Address too long",
                LOCAL_TOO_LONG: "Address local part too long",
                EMPTY_LOCAL_SEGMENT: "Address local part contains empty dot-separated segment",
                INVALID_LOCAL_CHARS: "Address local part contains invalid character",
                DOMAIN_NON_EMPTY_STRING: "Domain must be a non-empty string",
                DOMAIN_TOO_LONG: "Domain too long",
                DOMAIN_INVALID_UNICODE_CHARS: "Domain contains forbidden Unicode characters",
                DOMAIN_INVALID_CHARS: "Domain contains invalid character",
                DOMAIN_INVALID_TLDS_CHARS: "Domain contains invalid tld character",
                DOMAIN_SEGMENTS_COUNT: "Domain lacks the minimum required number of segments",
                DOMAIN_SEGMENTS_COUNT_MAX: "Domain contains too many segments",
                DOMAIN_FORBIDDEN_TLDS: "Domain uses forbidden TLD",
                DOMAIN_EMPTY_SEGMENT: "Domain contains empty dot-separated segment",
                DOMAIN_LONG_SEGMENT: "Domain contains dot-separated segment that is too long"
            }, t.code = function(e) {
                return {
                    code: e,
                    error: t.codes[e]
                };
            };
        },
        9959: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(5752);
            t.regex = function() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                s(void 0 === e.cidr || "string" == typeof e.cidr, "options.cidr must be a string");
                const t = e.cidr ? e.cidr.toLowerCase() : "optional";
                s([
                    "required",
                    "optional",
                    "forbidden"
                ].includes(t), "options.cidr must be one of required, optional, forbidden"), s(void 0 === e.version || "string" == typeof e.version || Array.isArray(e.version), "options.version must be a string or an array of string");
                let r = e.version || [
                    "ipv4",
                    "ipv6",
                    "ipvfuture"
                ];
                Array.isArray(r) || (r = [
                    r
                ]), s(r.length >= 1, "options.version must have at least 1 version specified");
                for(let e = 0; e < r.length; ++e)s("string" == typeof r[e], "options.version must only contain strings"), r[e] = r[e].toLowerCase(), s([
                    "ipv4",
                    "ipv6",
                    "ipvfuture"
                ].includes(r[e]), "options.version contains unknown version " + r[e] + " - must be one of ipv4, ipv6, ipvfuture");
                r = Array.from(new Set(r));
                const a = `(?:${r.map((e)=>{
                    if ("forbidden" === t) return n.ip[e];
                    const r = `\\/${"ipv4" === e ? n.ip.v4Cidr : n.ip.v6Cidr}`;
                    return "required" === t ? `${n.ip[e]}${r}` : `${n.ip[e]}(?:${r})?`;
                }).join("|")})`, i = new RegExp(`^${a}$`);
                return {
                    cidr: t,
                    versions: r,
                    regex: i,
                    raw: a
                };
            };
        },
        5752: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(6064), a = {
                generate: function() {
                    const e = {}, t = "\\dA-Fa-f", r = "[" + t + "]", s = "\\w-\\.~", n = "!\\$&'\\(\\)\\*\\+,;=", a = "%" + t, i = s + a + n + ":@", o = "[" + i + "]", l = "(?:0{0,2}\\d|0?[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])";
                    e.ipv4address = "(?:" + l + "\\.){3}" + l;
                    const c = r + "{1,4}", u = "(?:" + c + ":" + c + "|" + e.ipv4address + ")", f = "(?:" + c + ":){6}" + u, h = "::(?:" + c + ":){5}" + u, m = "(?:" + c + ")?::(?:" + c + ":){4}" + u, d = "(?:(?:" + c + ":){0,1}" + c + ")?::(?:" + c + ":){3}" + u, p = "(?:(?:" + c + ":){0,2}" + c + ")?::(?:" + c + ":){2}" + u, g = "(?:(?:" + c + ":){0,3}" + c + ")?::" + c + ":" + u, y = "(?:(?:" + c + ":){0,4}" + c + ")?::" + u, b = "(?:(?:" + c + ":){0,5}" + c + ")?::" + c, v = "(?:(?:" + c + ":){0,6}" + c + ")?::";
                    e.ipv4Cidr = "(?:\\d|[1-2]\\d|3[0-2])", e.ipv6Cidr = "(?:0{0,2}\\d|0?[1-9]\\d|1[01]\\d|12[0-8])", e.ipv6address = "(?:" + f + "|" + h + "|" + m + "|" + d + "|" + p + "|" + g + "|" + y + "|" + b + "|" + v + ")", e.ipvFuture = "v" + r + "+\\.[" + s + n + ":]+", e.scheme = "[a-zA-Z][a-zA-Z\\d+-\\.]*", e.schemeRegex = new RegExp(e.scheme);
                    const _ = "[" + s + a + n + ":]*", w = "[" + s + a + n + "]{1,255}", $ = "(?:\\[(?:" + e.ipv6address + "|" + e.ipvFuture + ")\\]|" + e.ipv4address + "|" + w + ")", x = "(?:" + _ + "@)?" + $ + "(?::\\d*)?", j = "(?:" + _ + "@)?(" + $ + ")(?::\\d*)?", k = o + "*", R = o + "+", A = "(?:\\/" + k + ")*", S = "\\/(?:" + R + A + ")?", O = R + A, E = "[" + s + a + n + "@]+" + A, D = "(?:\\/\\/\\/" + k + A + ")";
                    return e.hierPart = "(?:(?:\\/\\/" + x + A + ")|" + S + "|" + O + "|" + D + ")", e.hierPartCapture = "(?:(?:\\/\\/" + j + A + ")|" + S + "|" + O + ")", e.relativeRef = "(?:(?:\\/\\/" + x + A + ")|" + S + "|" + E + "|)", e.relativeRefCapture = "(?:(?:\\/\\/" + j + A + ")|" + S + "|" + E + "|)", e.query = "[" + i + "\\/\\?]*(?=#|$)", e.queryWithSquareBrackets = "[" + i + "\\[\\]\\/\\?]*(?=#|$)", e.fragment = "[" + i + "\\/\\?]*", e;
                }
            };
            a.rfc3986 = a.generate(), t.ip = {
                v4Cidr: a.rfc3986.ipv4Cidr,
                v6Cidr: a.rfc3986.ipv6Cidr,
                ipv4: a.rfc3986.ipv4address,
                ipv6: a.rfc3986.ipv6address,
                ipvfuture: a.rfc3986.ipvFuture
            }, a.createRegex = function(e) {
                const t = a.rfc3986, r = "(?:\\?" + (e.allowQuerySquareBrackets ? t.queryWithSquareBrackets : t.query) + ")?(?:#" + t.fragment + ")?", i = e.domain ? t.relativeRefCapture : t.relativeRef;
                if (e.relativeOnly) return a.wrap(i + r);
                let o = "";
                if (e.scheme) {
                    s(e.scheme instanceof RegExp || "string" == typeof e.scheme || Array.isArray(e.scheme), "scheme must be a RegExp, String, or Array");
                    const r = [].concat(e.scheme);
                    s(r.length >= 1, "scheme must have at least 1 scheme specified");
                    const a = [];
                    for(let e = 0; e < r.length; ++e){
                        const i = r[e];
                        s(i instanceof RegExp || "string" == typeof i, "scheme at position " + e + " must be a RegExp or String"), i instanceof RegExp ? a.push(i.source.toString()) : (s(t.schemeRegex.test(i), "scheme at position " + e + " must be a valid scheme"), a.push(n(i)));
                    }
                    o = a.join("|");
                }
                const l = "(?:" + (o ? "(?:" + o + ")" : t.scheme) + ":" + (e.domain ? t.hierPartCapture : t.hierPart) + ")", c = e.allowRelative ? "(?:" + l + "|" + i + ")" : l;
                return a.wrap(c + r, o);
            }, a.wrap = function(e, t) {
                return {
                    raw: e = `(?=.)(?!https?:/(?:$|[^/]))(?!https?:///)(?!https?:[^/])${e}`,
                    regex: new RegExp(`^${e}$`),
                    scheme: t
                };
            }, a.uriRegex = a.createRegex({}), t.regex = function() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return e.scheme || e.allowRelative || e.relativeOnly || e.allowQuerySquareBrackets || e.domain ? a.createRegex(e) : a.uriRegex;
            };
        },
        1447: (e, t)=>{
            "use strict";
            const r = {
                operators: [
                    "!",
                    "^",
                    "*",
                    "/",
                    "%",
                    "+",
                    "-",
                    "<",
                    "<=",
                    ">",
                    ">=",
                    "==",
                    "!=",
                    "&&",
                    "||",
                    "??"
                ],
                operatorCharacters: [
                    "!",
                    "^",
                    "*",
                    "/",
                    "%",
                    "+",
                    "-",
                    "<",
                    "=",
                    ">",
                    "&",
                    "|",
                    "?"
                ],
                operatorsOrder: [
                    [
                        "^"
                    ],
                    [
                        "*",
                        "/",
                        "%"
                    ],
                    [
                        "+",
                        "-"
                    ],
                    [
                        "<",
                        "<=",
                        ">",
                        ">="
                    ],
                    [
                        "==",
                        "!="
                    ],
                    [
                        "&&"
                    ],
                    [
                        "||",
                        "??"
                    ]
                ],
                operatorsPrefix: [
                    "!",
                    "n"
                ],
                literals: {
                    '"': '"',
                    "`": "`",
                    "'": "'",
                    "[": "]"
                },
                numberRx: /^(?:[0-9]*(\.[0-9]*)?){1}$/,
                tokenRx: /^[\w\$\#\.\@\:\{\}]+$/,
                symbol: Symbol("formula"),
                settings: Symbol("settings")
            };
            t.Parser = class {
                constructor(e){
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (!t[r.settings] && t.constants) for(const e in t.constants){
                        const r = t.constants[e];
                        if (null !== r && ![
                            "boolean",
                            "number",
                            "string"
                        ].includes(typeof r)) throw new Error(`Formula constant ${e} contains invalid ${typeof r} value type`);
                    }
                    this.settings = t[r.settings] ? t : Object.assign({
                        [r.settings]: !0,
                        constants: {},
                        functions: {}
                    }, t), this.single = null, this._parts = null, this._parse(e);
                }
                _parse(e) {
                    let s = [], n = "", a = 0, i = !1;
                    const o = (e)=>{
                        if (a) throw new Error("Formula missing closing parenthesis");
                        const o = s.length ? s[s.length - 1] : null;
                        if (i || n || e) {
                            if (o && "reference" === o.type && ")" === e) return o.type = "function", o.value = this._subFormula(n, o.value), void (n = "");
                            if (")" === e) {
                                const e = new t.Parser(n, this.settings);
                                s.push({
                                    type: "segment",
                                    value: e
                                });
                            } else if (i) {
                                if ("]" === i) return s.push({
                                    type: "reference",
                                    value: n
                                }), void (n = "");
                                s.push({
                                    type: "literal",
                                    value: n
                                });
                            } else if (r.operatorCharacters.includes(n)) o && "operator" === o.type && r.operators.includes(o.value + n) ? o.value += n : s.push({
                                type: "operator",
                                value: n
                            });
                            else if (n.match(r.numberRx)) s.push({
                                type: "constant",
                                value: parseFloat(n)
                            });
                            else if (void 0 !== this.settings.constants[n]) s.push({
                                type: "constant",
                                value: this.settings.constants[n]
                            });
                            else {
                                if (!n.match(r.tokenRx)) throw new Error(`Formula contains invalid token: ${n}`);
                                s.push({
                                    type: "reference",
                                    value: n
                                });
                            }
                            n = "";
                        }
                    };
                    for (const t of e)i ? t === i ? (o(), i = !1) : n += t : a ? "(" === t ? (n += t, ++a) : ")" === t ? (--a, a ? n += t : o(t)) : n += t : t in r.literals ? i = r.literals[t] : "(" === t ? (o(), ++a) : r.operatorCharacters.includes(t) ? (o(), n = t, o()) : " " !== t ? n += t : o();
                    o(), s = s.map((e, t)=>"operator" !== e.type || "-" !== e.value || t && "operator" !== s[t - 1].type ? e : {
                            type: "operator",
                            value: "n"
                        });
                    let l = !1;
                    for (const e of s){
                        if ("operator" === e.type) {
                            if (r.operatorsPrefix.includes(e.value)) continue;
                            if (!l) throw new Error("Formula contains an operator in invalid position");
                            if (!r.operators.includes(e.value)) throw new Error(`Formula contains an unknown operator ${e.value}`);
                        } else if (l) throw new Error("Formula missing expected operator");
                        l = !l;
                    }
                    if (!l) throw new Error("Formula contains invalid trailing operator");
                    1 === s.length && [
                        "reference",
                        "literal",
                        "constant"
                    ].includes(s[0].type) && (this.single = {
                        type: "reference" === s[0].type ? "reference" : "value",
                        value: s[0].value
                    }), this._parts = s.map((e)=>{
                        if ("operator" === e.type) return r.operatorsPrefix.includes(e.value) ? e : e.value;
                        if ("reference" !== e.type) return e.value;
                        if (this.settings.tokenRx && !this.settings.tokenRx.test(e.value)) throw new Error(`Formula contains invalid reference ${e.value}`);
                        return this.settings.reference ? this.settings.reference(e.value) : r.reference(e.value);
                    });
                }
                _subFormula(e, s) {
                    const n = this.settings.functions[s];
                    if ("function" != typeof n) throw new Error(`Formula contains unknown function ${s}`);
                    let a = [];
                    if (e) {
                        let t = "", n = 0, i = !1;
                        const o = ()=>{
                            if (!t) throw new Error(`Formula contains function ${s} with invalid arguments ${e}`);
                            a.push(t), t = "";
                        };
                        for(let s = 0; s < e.length; ++s){
                            const a = e[s];
                            i ? (t += a, a === i && (i = !1)) : a in r.literals && !n ? (t += a, i = r.literals[a]) : "," !== a || n ? (t += a, "(" === a ? ++n : ")" === a && --n) : o();
                        }
                        o();
                    }
                    return a = a.map((e)=>new t.Parser(e, this.settings)), function(e) {
                        const t = [];
                        for (const r of a)t.push(r.evaluate(e));
                        return n.call(e, ...t);
                    };
                }
                evaluate(e) {
                    const t = this._parts.slice();
                    for(let s = t.length - 2; s >= 0; --s){
                        const n = t[s];
                        if (n && "operator" === n.type) {
                            const a = t[s + 1];
                            t.splice(s + 1, 1);
                            const i = r.evaluate(a, e);
                            t[s] = r.single(n.value, i);
                        }
                    }
                    return r.operatorsOrder.forEach((s)=>{
                        for(let n = 1; n < t.length - 1;)if (s.includes(t[n])) {
                            const s = t[n], a = r.evaluate(t[n - 1], e), i = r.evaluate(t[n + 1], e);
                            t.splice(n, 2);
                            const o = r.calculate(s, a, i);
                            t[n - 1] = 0 === o ? 0 : o;
                        } else n += 2;
                    }), r.evaluate(t[0], e);
                }
            }, t.Parser.prototype[r.symbol] = !0, r.reference = function(e) {
                return function(t) {
                    return t && void 0 !== t[e] ? t[e] : null;
                };
            }, r.evaluate = function(e, t) {
                return null === e ? null : "function" == typeof e ? e(t) : e[r.symbol] ? e.evaluate(t) : e;
            }, r.single = function(e, t) {
                if ("!" === e) return !t;
                const r = -t;
                return 0 === r ? 0 : r;
            }, r.calculate = function(e, t, s) {
                if ("??" === e) return r.exists(t) ? t : s;
                if ("string" == typeof t || "string" == typeof s) {
                    if ("+" === e) return (t = r.exists(t) ? t : "") + (r.exists(s) ? s : "");
                } else switch(e){
                    case "^":
                        return Math.pow(t, s);
                    case "*":
                        return t * s;
                    case "/":
                        return t / s;
                    case "%":
                        return t % s;
                    case "+":
                        return t + s;
                    case "-":
                        return t - s;
                }
                switch(e){
                    case "<":
                        return t < s;
                    case "<=":
                        return t <= s;
                    case ">":
                        return t > s;
                    case ">=":
                        return t >= s;
                    case "==":
                        return t === s;
                    case "!=":
                        return t !== s;
                    case "&&":
                        return t && s;
                    case "||":
                        return t || s;
                }
                return null;
            }, r.exists = function(e) {
                return null != e;
            };
        },
        9926: ()=>{},
        5688: ()=>{},
        9708: ()=>{},
        1152: ()=>{},
        443: ()=>{},
        9848: ()=>{},
        5934: (e)=>{
            "use strict";
            e.exports = {
                version: "17.9.1"
            };
        }
    }, t = {}, function r(s) {
        var n = t[s];
        if (void 0 !== n) return n.exports;
        var a = t[s] = {
            exports: {}
        };
        return e[s](a, a.exports, r), a.exports;
    }(5107);
});

});

parcelRegister("bib7R", function(module, exports) {
$parcel$export(module.exports, "ProviderRpcErrorCode", () => (parcelRequire("7oBBe")).ProviderRpcErrorCode);
$parcel$export(module.exports, "validate", () => (parcelRequire("fsqu3")).validate);
$parcel$export(module.exports, "chainNamespaceValidation", () => (parcelRequire("fsqu3")).chainNamespaceValidation);
$parcel$export(module.exports, "chainIdValidation", () => (parcelRequire("fsqu3")).chainIdValidation);
$parcel$export(module.exports, "chainValidation", () => (parcelRequire("fsqu3")).chainValidation);

$parcel$export(module.exports, "createEIP1193Provider", () => (parcelRequire("kMjQs")).createEIP1193Provider);
$parcel$export(module.exports, "InterVar", () => (parcelRequire("jdCzx")).InterVar);
$parcel$export(module.exports, "weiToEth", () => (parcelRequire("jXBIn")).weiToEth);

var $gl6Kc = parcelRequire("gl6Kc");

var $kMjQs = parcelRequire("kMjQs");

var $jdCzx = parcelRequire("jdCzx");

var $jXBIn = parcelRequire("jXBIn");
parcelRequire("7oBBe");
parcelRequire("fsqu3");

});
parcelRegister("gl6Kc", function(module, exports) {

$parcel$export(module.exports, "ProviderRpcError", () => $be53d6baf74b9aa3$export$417589b978208a8f);
class $be53d6baf74b9aa3$export$417589b978208a8f extends Error {
    constructor(error){
        super(error.message);
        this.message = error.message;
        this.code = error.code;
        this.data = error.data;
    }
}

});

parcelRegister("kMjQs", function(module, exports) {

$parcel$export(module.exports, "createEIP1193Provider", () => $f207af2540fcceff$export$3179d0f9b8fae2a4);

var $gl6Kc = parcelRequire("gl6Kc");
const $f207af2540fcceff$export$3179d0f9b8fae2a4 = (provider, requestPatch)=>{
    let baseRequest;
    if (provider.request) // Copy the original request method and bind the provider context to it
    baseRequest = provider.request.bind(provider);
    else if (provider.sendAsync) baseRequest = $f207af2540fcceff$var$createRequest(provider);
    const request = async ({ method: method, params: params })=>{
        const key = method;
        // If the request method is set to null
        // this indicates this method is not supported
        if (requestPatch && requestPatch[key] === null) throw new (0, $gl6Kc.ProviderRpcError)({
            code: 4200,
            message: `The Provider does not support the requested method: ${method}`
        });
        if (requestPatch && requestPatch[key]) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore // @TODO - Fix this type error
        return requestPatch[key]({
            baseRequest: baseRequest,
            params: params
        });
        else if (baseRequest) return baseRequest({
            method: method,
            params: params
        });
        else throw new (0, $gl6Kc.ProviderRpcError)({
            code: 4200,
            message: `The Provider does not support the requested method: ${method}`
        });
    };
    provider.request = request;
    return provider;
};
const $f207af2540fcceff$var$createRequest = (provider)=>({ method: method, params: params })=>new Promise((resolve, reject)=>{
            provider.sendAsync({
                id: 0,
                jsonrpc: "2.0",
                method: method,
                params: params
            }, (error, { result: result })=>{
                if (error) reject(JSON.parse(error));
                else resolve(result == undefined ? null : result);
            });
        });

});

parcelRegister("jdCzx", function(module, exports) {

$parcel$export(module.exports, "InterVar", () => $dfdd26d859a34dd6$export$c6987e893c5dcce7);
const $dfdd26d859a34dd6$export$c6987e893c5dcce7 = `
@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 300 600;
  font-display: swap;
  src: url("https://rsms.me/inter/font-files/InterVariable.woff2") format("woff2-variations");
}
`;

});

parcelRegister("jXBIn", function(module, exports) {

$parcel$export(module.exports, "weiToEth", () => $e880c860cc76f779$export$5c738bdb4a4e27c5);

var $5Kq8F = parcelRequire("5Kq8F");
function $e880c860cc76f779$export$5c738bdb4a4e27c5(wei) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(wei).div(1e18).toString(10);
}

});
parcelRegister("5Kq8F", function(module, exports) {
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(module.exports);

});


parcelRegister("7oBBe", function(module, exports) {

$parcel$export(module.exports, "ProviderRpcErrorCode", () => $5627f0c5dfcc160f$export$a9b3d16f1898eb51);
var $5627f0c5dfcc160f$export$a9b3d16f1898eb51;
(function(ProviderRpcErrorCode) {
    ProviderRpcErrorCode[ProviderRpcErrorCode["ACCOUNT_ACCESS_REJECTED"] = 4001] = "ACCOUNT_ACCESS_REJECTED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["ACCOUNT_ACCESS_ALREADY_REQUESTED"] = -32002] = "ACCOUNT_ACCESS_ALREADY_REQUESTED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["UNAUTHORIZED"] = 4100] = "UNAUTHORIZED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["INVALID_PARAMS"] = -32602] = "INVALID_PARAMS";
    ProviderRpcErrorCode[ProviderRpcErrorCode["UNSUPPORTED_METHOD"] = 4200] = "UNSUPPORTED_METHOD";
    ProviderRpcErrorCode[ProviderRpcErrorCode["DISCONNECTED"] = 4900] = "DISCONNECTED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["CHAIN_DISCONNECTED"] = 4901] = "CHAIN_DISCONNECTED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["CHAIN_NOT_ADDED"] = 4902] = "CHAIN_NOT_ADDED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["DOES_NOT_EXIST"] = -32601] = "DOES_NOT_EXIST";
    ProviderRpcErrorCode[ProviderRpcErrorCode["UNRECOGNIZED_CHAIN_ID"] = -32603] = "UNRECOGNIZED_CHAIN_ID";
})($5627f0c5dfcc160f$export$a9b3d16f1898eb51 || ($5627f0c5dfcc160f$export$a9b3d16f1898eb51 = {}));

});

parcelRegister("fsqu3", function(module, exports) {

$parcel$export(module.exports, "validate", () => $b40e03adbce82356$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "chainIdValidation", () => $b40e03adbce82356$export$82499834ac435e76);
$parcel$export(module.exports, "chainNamespaceValidation", () => $b40e03adbce82356$export$339f369556873e03);
$parcel$export(module.exports, "chainValidation", () => $b40e03adbce82356$export$392a124a91f4a641);

var $kmsNQ = parcelRequire("kmsNQ");
function $b40e03adbce82356$export$a22775fa5e2eebd9(validator, data) {
    const result = validator.validate(data);
    return result.error ? result : null;
}
const $b40e03adbce82356$export$82499834ac435e76 = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).alternatives().try((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().pattern(/^0x[0-9a-fA-F]+$/), (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number().positive());
const $b40e03adbce82356$export$339f369556873e03 = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().valid("evm");
const $b40e03adbce82356$export$d180213c9972dcad = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    url: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    headers: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object(),
    user: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    password: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    allowInsecureAuthentication: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    allowGzip: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    throttleLimit: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number(),
    throttleSlotInterval: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number(),
    throttleCallback: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function(),
    timeout: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number()
});
const $b40e03adbce82356$var$secondaryTokenValidation = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    address: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().optional()
});
const $b40e03adbce82356$export$392a124a91f4a641 = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    namespace: $b40e03adbce82356$export$339f369556873e03,
    id: $b40e03adbce82356$export$82499834ac435e76.required(),
    rpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    token: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    secondaryTokens: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).array().max(5).items($b40e03adbce82356$var$secondaryTokenValidation).optional(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    color: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    publicRpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    protectedRpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    blockExplorerUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    providerConnectionInfoValidation: $b40e03adbce82356$export$d180213c9972dcad
});

});


parcelRegister("4yR7b", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function baseAggregator(collection, setter, iteratee, accumulator) {
    baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
        return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
    };
}
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var partition = createAggregator(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = partition;

});

parcelRegister("jdnbt", function(module, exports) {

$parcel$export(module.exports, "ethers", () => (parcelRequire("95AgJ")));

var $95AgJ = parcelRequire("95AgJ");
var $lLoTq = parcelRequire("lLoTq");
var $bNCEM = parcelRequire("bNCEM");
var $S29ji = parcelRequire("S29ji");
var $9iY0i = parcelRequire("9iY0i");
var $kVZhy = parcelRequire("kVZhy");
var $hNSak = parcelRequire("hNSak");
var $kVh5l = parcelRequire("kVh5l");
var $l6EVj = parcelRequire("l6EVj");
var $jd9Pa = parcelRequire("jd9Pa");
var $katF7 = parcelRequire("katF7");
var $7t7AK = parcelRequire("7t7AK");
var $guH6I = parcelRequire("guH6I");
"use strict";
try {
    const anyGlobal = window;
    if (anyGlobal._ethers == null) anyGlobal._ethers = $95AgJ;
} catch (error) {}

});
parcelRegister("95AgJ", function(module, exports) {

$parcel$export(module.exports, "logger", () => $69e0b6e7a653c065$export$af88d00dbe7f521);
$parcel$export(module.exports, "Signer", () => (parcelRequire("lLoTq")).Signer);
$parcel$export(module.exports, "Wallet", () => (parcelRequire("bNCEM")).Wallet);
$parcel$export(module.exports, "VoidSigner", () => (parcelRequire("lLoTq")).VoidSigner);
$parcel$export(module.exports, "getDefaultProvider", () => (parcelRequire("S29ji")).getDefaultProvider);
$parcel$export(module.exports, "providers", () => (parcelRequire("S29ji")));
$parcel$export(module.exports, "BaseContract", () => (parcelRequire("9iY0i")).BaseContract);
$parcel$export(module.exports, "Contract", () => (parcelRequire("9iY0i")).Contract);
$parcel$export(module.exports, "ContractFactory", () => (parcelRequire("9iY0i")).ContractFactory);
$parcel$export(module.exports, "BigNumber", () => (parcelRequire("kVZhy")).BigNumber);
$parcel$export(module.exports, "FixedNumber", () => (parcelRequire("hNSak")).FixedNumber);
$parcel$export(module.exports, "constants", () => (parcelRequire("kVh5l")));
$parcel$export(module.exports, "errors", () => (parcelRequire("l6EVj")).ErrorCode);
$parcel$export(module.exports, "utils", () => (parcelRequire("jd9Pa")));
$parcel$export(module.exports, "wordlists", () => (parcelRequire("katF7")).wordlists);
$parcel$export(module.exports, "version", () => (parcelRequire("7t7AK")).version);
$parcel$export(module.exports, "Wordlist", () => (parcelRequire("guH6I")).Wordlist);

var $9iY0i = parcelRequire("9iY0i");

var $kVZhy = parcelRequire("kVZhy");
var $hNSak = parcelRequire("hNSak");

var $lLoTq = parcelRequire("lLoTq");

var $bNCEM = parcelRequire("bNCEM");

var $kVh5l = parcelRequire("kVh5l");

var $S29ji = parcelRequire("S29ji");

var $katF7 = parcelRequire("katF7");
var $guH6I = parcelRequire("guH6I");

var $jd9Pa = parcelRequire("jd9Pa");

var $l6EVj = parcelRequire("l6EVj");

var $7t7AK = parcelRequire("7t7AK");
"use strict";
const $69e0b6e7a653c065$export$af88d00dbe7f521 = new (0, $l6EVj.Logger)((0, $7t7AK.version));

});
parcelRegister("9iY0i", function(module, exports) {

$parcel$export(module.exports, "BaseContract", () => $6c6457024709b10b$export$304faa4fc17528db);
$parcel$export(module.exports, "Contract", () => $6c6457024709b10b$export$8517d80acf00e19a);
$parcel$export(module.exports, "ContractFactory", () => $6c6457024709b10b$export$505569a6bf584fd9);

var $hPcX2 = parcelRequire("hPcX2");
var $64Jjf = parcelRequire("64Jjf");

var $hMfVR = parcelRequire("hMfVR");

var $lLoTq = parcelRequire("lLoTq");

var $1qOxQ = parcelRequire("1qOxQ");

var $kVZhy = parcelRequire("kVZhy");

var $kniO8 = parcelRequire("kniO8");

var $7veey = parcelRequire("7veey");

var $equjW = parcelRequire("equjW");

var $l6EVj = parcelRequire("l6EVj");

var $3A3Wy = parcelRequire("3A3Wy");
"use strict";
var $6c6457024709b10b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $6c6457024709b10b$var$logger = new (0, $l6EVj.Logger)((0, $3A3Wy.version));
///////////////////////////////
const $6c6457024709b10b$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true
};
function $6c6457024709b10b$var$resolveName(resolver, nameOrPromise) {
    return $6c6457024709b10b$var$__awaiter(this, void 0, void 0, function*() {
        const name = yield nameOrPromise;
        if (typeof name !== "string") $6c6457024709b10b$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
        // If it is already an address, just use it (after adding checksum)
        try {
            return (0, $1qOxQ.getAddress)(name);
        } catch (error) {}
        if (!resolver) $6c6457024709b10b$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resolveName"
        });
        const address = yield resolver.resolveName(name);
        if (address == null) $6c6457024709b10b$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $6c6457024709b10b$var$resolveAddresses(resolver, value, paramType) {
    return $6c6457024709b10b$var$__awaiter(this, void 0, void 0, function*() {
        if (Array.isArray(paramType)) return yield Promise.all(paramType.map((paramType, index)=>{
            return $6c6457024709b10b$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
        }));
        if (paramType.type === "address") return yield $6c6457024709b10b$var$resolveName(resolver, value);
        if (paramType.type === "tuple") return yield $6c6457024709b10b$var$resolveAddresses(resolver, value, paramType.components);
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) return Promise.reject($6c6457024709b10b$var$logger.makeError("invalid value for array", (0, $l6EVj.Logger).errors.INVALID_ARGUMENT, {
                argument: "value",
                value: value
            }));
            return yield Promise.all(value.map((v)=>$6c6457024709b10b$var$resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function $6c6457024709b10b$var$populateTransaction(contract, fragment, args) {
    return $6c6457024709b10b$var$__awaiter(this, void 0, void 0, function*() {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $7veey.shallowCopy)(args.pop());
        // Make sure the parameter count matches
        $6c6457024709b10b$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
            // but we allow overriding "from" if it matches the signer
            overrides.from = (0, $7veey.resolveProperties)({
                override: $6c6457024709b10b$var$resolveName(contract.signer, overrides.from),
                signer: contract.signer.getAddress()
            }).then((check)=>$6c6457024709b10b$var$__awaiter(this, void 0, void 0, function*() {
                    if ((0, $1qOxQ.getAddress)(check.signer) !== check.override) $6c6457024709b10b$var$logger.throwError("Contract with a Signer cannot override from", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.from"
                    });
                    return check.override;
                }));
            else overrides.from = contract.signer.getAddress();
        } else if (overrides.from) overrides.from = $6c6457024709b10b$var$resolveName(contract.provider, overrides.from);
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield (0, $7veey.resolveProperties)({
            args: $6c6457024709b10b$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: (0, $7veey.resolveProperties)(overrides) || {}
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) tx.nonce = (0, $kVZhy.BigNumber).from(ro.nonce).toNumber();
        if (ro.gasLimit != null) tx.gasLimit = (0, $kVZhy.BigNumber).from(ro.gasLimit);
        if (ro.gasPrice != null) tx.gasPrice = (0, $kVZhy.BigNumber).from(ro.gasPrice);
        if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $kVZhy.BigNumber).from(ro.maxFeePerGas);
        if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $kVZhy.BigNumber).from(ro.maxPriorityFeePerGas);
        if (ro.from != null) tx.from = ro.from;
        if (ro.type != null) tx.type = ro.type;
        if (ro.accessList != null) tx.accessList = (0, $equjW.accessListify)(ro.accessList);
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = (0, $kniO8.arrayify)(data);
            for(let i = 0; i < bytes.length; i++){
                intrinsic += 4;
                if (bytes[i]) intrinsic += 64;
            }
            tx.gasLimit = (0, $kVZhy.BigNumber).from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = (0, $kVZhy.BigNumber).from(ro.value);
            if (!roValue.isZero() && !fragment.payable) $6c6457024709b10b$var$logger.throwError("non-payable method cannot override value", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: overrides.value
            });
            tx.value = roValue;
        }
        if (ro.customData) tx.customData = (0, $7veey.shallowCopy)(ro.customData);
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key)=>overrides[key] != null);
        if (leftovers.length) $6c6457024709b10b$var$logger.throwError(`cannot override ${leftovers.map((l)=>JSON.stringify(l)).join(",")}`, (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "overrides",
            overrides: leftovers
        });
        return tx;
    });
}
function $6c6457024709b10b$var$buildPopulate(contract, fragment) {
    return function(...args) {
        return $6c6457024709b10b$var$populateTransaction(contract, fragment, args);
    };
}
function $6c6457024709b10b$var$buildEstimate(contract, fragment) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $6c6457024709b10b$var$__awaiter(this, void 0, void 0, function*() {
            if (!signerOrProvider) $6c6457024709b10b$var$logger.throwError("estimate require a provider or signer", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
            });
            const tx = yield $6c6457024709b10b$var$populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function $6c6457024709b10b$var$addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations)=>{
        return wait(confirmations).then((receipt)=>{
            receipt.events = receipt.logs.map((log)=>{
                let event = (0, $7veey.deepCopy)(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics)=>{
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = ()=>{
                    return contract.provider;
                };
                event.getBlock = ()=>{
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = ()=>{
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = ()=>{
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $6c6457024709b10b$var$buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $6c6457024709b10b$var$__awaiter(this, void 0, void 0, function*() {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                const overrides = (0, $7veey.shallowCopy)(args.pop());
                if (overrides.blockTag != null) blockTag = yield overrides.blockTag;
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed(blockTag);
            // Call a node and get the result
            const tx = yield $6c6457024709b10b$var$populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                return value;
            } catch (error) {
                if (error.code === (0, $l6EVj.Logger).errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function $6c6457024709b10b$var$buildSend(contract, fragment) {
    return function(...args) {
        return $6c6457024709b10b$var$__awaiter(this, void 0, void 0, function*() {
            if (!contract.signer) $6c6457024709b10b$var$logger.throwError("sending a transaction requires a signer", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
            });
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed();
            const txRequest = yield $6c6457024709b10b$var$populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            $6c6457024709b10b$var$addContractWait(contract, tx);
            return tx;
        });
    };
}
function $6c6457024709b10b$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $6c6457024709b10b$var$buildCall(contract, fragment, collapseSimple);
    return $6c6457024709b10b$var$buildSend(contract, fragment);
}
function $6c6457024709b10b$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic)=>{
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
class $6c6457024709b10b$var$RunningEvent {
    constructor(tag, filter){
        (0, $7veey.defineReadOnly)(this, "tag", tag);
        (0, $7veey.defineReadOnly)(this, "filter", filter);
        this._listeners = [];
    }
    addListener(listener, once) {
        this._listeners.push({
            listener: listener,
            once: once
        });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item)=>{
            if (done || item.listener !== listener) return true;
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i)=>i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item)=>{
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(()=>{
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !item.once;
        });
        return listenerCount;
    }
    prepareEvent(event) {}
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [
            event
        ];
    }
}
class $6c6457024709b10b$var$ErrorRunningEvent extends $6c6457024709b10b$var$RunningEvent {
    constructor(){
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class $6c6457024709b10b$var$FragmentRunningEvent extends $6c6457024709b10b$var$RunningEvent {
    constructor(address, contractInterface, fragment, topics){
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $6c6457024709b10b$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        super($6c6457024709b10b$var$getEventTag(filter), filter);
        (0, $7veey.defineReadOnly)(this, "address", address);
        (0, $7veey.defineReadOnly)(this, "interface", contractInterface);
        (0, $7veey.defineReadOnly)(this, "fragment", fragment);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics)=>{
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        } catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = (0, $hPcX2.checkResultErrors)(event.args);
        if (errors.length) throw errors[0].error;
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class $6c6457024709b10b$var$WildcardRunningEvent extends $6c6457024709b10b$var$RunningEvent {
    constructor(address, contractInterface){
        super("*", {
            address: address
        });
        (0, $7veey.defineReadOnly)(this, "address", address);
        (0, $7veey.defineReadOnly)(this, "interface", contractInterface);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics)=>{
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        } catch (error) {
        // No matching event
        }
    }
}
class $6c6457024709b10b$export$304faa4fc17528db {
    constructor(addressOrName, contractInterface, signerOrProvider){
        $6c6457024709b10b$var$logger.checkNew(new.target, $6c6457024709b10b$export$8517d80acf00e19a);
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $7veey.defineReadOnly)(this, "interface", (0, $7veey.getStatic)(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $7veey.defineReadOnly)(this, "provider", null);
            (0, $7veey.defineReadOnly)(this, "signer", null);
        } else if ((0, $lLoTq.Signer).isSigner(signerOrProvider)) {
            (0, $7veey.defineReadOnly)(this, "provider", signerOrProvider.provider || null);
            (0, $7veey.defineReadOnly)(this, "signer", signerOrProvider);
        } else if ((0, $hMfVR.Provider).isProvider(signerOrProvider)) {
            (0, $7veey.defineReadOnly)(this, "provider", signerOrProvider);
            (0, $7veey.defineReadOnly)(this, "signer", null);
        } else $6c6457024709b10b$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $7veey.defineReadOnly)(this, "callStatic", {});
        (0, $7veey.defineReadOnly)(this, "estimateGas", {});
        (0, $7veey.defineReadOnly)(this, "functions", {});
        (0, $7veey.defineReadOnly)(this, "populateTransaction", {});
        (0, $7veey.defineReadOnly)(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature)=>{
                const event = this.interface.events[eventSignature];
                (0, $7veey.defineReadOnly)(this.filters, eventSignature, (...args)=>{
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name)=>{
                const filters = uniqueFilters[name];
                if (filters.length === 1) (0, $7veey.defineReadOnly)(this.filters, name, this.filters[filters[0]]);
                else $6c6457024709b10b$var$logger.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
            });
        }
        (0, $7veey.defineReadOnly)(this, "_runningEvents", {});
        (0, $7veey.defineReadOnly)(this, "_wrappedEmits", {});
        if (addressOrName == null) $6c6457024709b10b$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $7veey.defineReadOnly)(this, "address", addressOrName);
        if (this.provider) (0, $7veey.defineReadOnly)(this, "resolvedAddress", $6c6457024709b10b$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $7veey.defineReadOnly)(this, "resolvedAddress", Promise.resolve((0, $1qOxQ.getAddress)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $6c6457024709b10b$var$logger.throwError("provider is required to use ENS name as contract address", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature)=>{
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $6c6457024709b10b$var$logger.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) uniqueNames[`%${name}`] = [];
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) (0, $7veey.defineReadOnly)(this, signature, $6c6457024709b10b$var$buildDefault(this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) (0, $7veey.defineReadOnly)(this.functions, signature, $6c6457024709b10b$var$buildDefault(this, fragment, false));
            if (this.callStatic[signature] == null) (0, $7veey.defineReadOnly)(this.callStatic, signature, $6c6457024709b10b$var$buildCall(this, fragment, true));
            if (this.populateTransaction[signature] == null) (0, $7veey.defineReadOnly)(this.populateTransaction, signature, $6c6457024709b10b$var$buildPopulate(this, fragment));
            if (this.estimateGas[signature] == null) (0, $7veey.defineReadOnly)(this.estimateGas, signature, $6c6457024709b10b$var$buildEstimate(this, fragment));
        });
        Object.keys(uniqueNames).forEach((name)=>{
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) (0, $7veey.defineReadOnly)(this, name, this[signature]);
            } catch (e) {}
            if (this.functions[name] == null) (0, $7veey.defineReadOnly)(this.functions, name, this.functions[signature]);
            if (this.callStatic[name] == null) (0, $7veey.defineReadOnly)(this.callStatic, name, this.callStatic[signature]);
            if (this.populateTransaction[name] == null) (0, $7veey.defineReadOnly)(this.populateTransaction, name, this.populateTransaction[signature]);
            if (this.estimateGas[name] == null) (0, $7veey.defineReadOnly)(this.estimateGas, name, this.estimateGas[signature]);
        });
    }
    static getContractAddress(transaction) {
        return (0, $1qOxQ.getContractAddress)(transaction);
    }
    static getInterface(contractInterface) {
        if ((0, $64Jjf.Interface).isInterface(contractInterface)) return contractInterface;
        return new (0, $64Jjf.Interface)(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(()=>{
                return this;
            });
            else // @TODO: Once we allow a timeout to be passed in, we will wait
            // up to that many blocks for getCode
            // Otherwise, poll for our code to be deployed
            this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code)=>{
                if (code === "0x") $6c6457024709b10b$var$logger.throwError("contract not deployed", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                    contractAddress: this.address,
                    operation: "getDeployed"
                });
                return this;
            });
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) $6c6457024709b10b$var$logger.throwError("sending a transactions require a signer", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "sendTransaction(fallback)"
        });
        const tx = (0, $7veey.shallowCopy)(overrides || {});
        [
            "from",
            "to"
        ].forEach(function(key) {
            if (tx[key] == null) return;
            $6c6457024709b10b$var$logger.throwError("cannot override " + key, (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(()=>{
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof signerOrProvider === "string") signerOrProvider = new (0, $lLoTq.VoidSigner)(signerOrProvider, this.provider);
        const contract = new this.constructor(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) (0, $7veey.defineReadOnly)(contract, "deployTransaction", this.deployTransaction);
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return (0, $64Jjf.Indexed).isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof eventName === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") return this._normalizeRunningEvent(new $6c6457024709b10b$var$ErrorRunningEvent());
            // Listen for any event that is registered
            if (eventName === "event") return this._normalizeRunningEvent(new $6c6457024709b10b$var$RunningEvent("event", null));
            // Listen for any event
            if (eventName === "*") return this._normalizeRunningEvent(new $6c6457024709b10b$var$WildcardRunningEvent(this.address, this.interface));
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new $6c6457024709b10b$var$FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new $6c6457024709b10b$var$FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            } catch (error) {}
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new $6c6457024709b10b$var$RunningEvent($6c6457024709b10b$var$getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new $6c6457024709b10b$var$WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = (0, $7veey.deepCopy)(log);
        event.removeListener = ()=>{
            if (!listener) return;
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = ()=>{
            return this.provider.getBlock(log.blockHash);
        };
        event.getTransaction = ()=>{
            return this.provider.getTransaction(log.transactionHash);
        };
        event.getTransactionReceipt = ()=>{
            return this.provider.getTransactionReceipt(log.transactionHash);
        };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) $6c6457024709b10b$var$logger.throwError("events require a provider or a signer with a provider", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "once"
        });
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log)=>{
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) try {
                    const args = runningEvent.getEmit(event);
                    this.emit(runningEvent.filter, ...args);
                } catch (error) {
                    event.decodeError = error.error;
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) this.emit("event", event);
                // Emit "error" if there was an error
                if (event.decodeError != null) this.emit("error", event.decodeError, event);
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = (0, $7veey.shallowCopy)(runningEvent.filter);
        if (typeof fromBlockOrBlockhash === "string" && (0, $kniO8.isHexString)(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) $6c6457024709b10b$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            filter.blockHash = fromBlockOrBlockhash;
        } else {
            filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
            filter.toBlock = toBlock != null ? toBlock : "latest";
        }
        return this.provider.getLogs(filter).then((logs)=>{
            return logs.map((log)=>this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) return false;
        const runningEvent = this._getRunningEvent(eventName);
        const result = runningEvent.run(args) > 0;
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) return 0;
        if (eventName == null) return Object.keys(this._runningEvents).reduce((accum, key)=>{
            return accum + this._runningEvents[key].listenerCount();
        }, 0);
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) return [];
        if (eventName == null) {
            const result = [];
            for(let tag in this._runningEvents)this._runningEvents[tag].listeners().forEach((listener)=>{
                result.push(listener);
            });
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) return this;
        if (eventName == null) {
            for(const tag in this._runningEvents){
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) return this;
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
}
class $6c6457024709b10b$export$8517d80acf00e19a extends $6c6457024709b10b$export$304faa4fc17528db {
}
class $6c6457024709b10b$export$505569a6bf584fd9 {
    constructor(contractInterface, bytecode, signer){
        let bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $kniO8.isBytes)(bytecode)) bytecodeHex = (0, $kniO8.hexlify)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $kniO8.isHexString)(bytecodeHex) || bytecodeHex.length % 2) $6c6457024709b10b$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $lLoTq.Signer).isSigner(signer)) $6c6457024709b10b$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $7veey.defineReadOnly)(this, "bytecode", bytecodeHex);
        (0, $7veey.defineReadOnly)(this, "interface", (0, $7veey.getStatic)(new.target, "getInterface")(contractInterface));
        (0, $7veey.defineReadOnly)(this, "signer", signer || null);
    }
    // @TODO: Future; rename to populateTransaction?
    getDeployTransaction(...args) {
        let tx = {};
        // If we have 1 additional argument, we allow transaction overrides
        if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
            tx = (0, $7veey.shallowCopy)(args.pop());
            for(const key in tx){
                if (!$6c6457024709b10b$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
            }
        }
        // Do not allow these to be overridden in a deployment transaction
        [
            "data",
            "from",
            "to"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            $6c6457024709b10b$var$logger.throwError("cannot override " + key, (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        if (tx.value) {
            const value = (0, $kVZhy.BigNumber).from(tx.value);
            if (!value.isZero() && !this.interface.deploy.payable) $6c6457024709b10b$var$logger.throwError("non-payable constructor cannot override value", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: tx.value
            });
        }
        // Make sure the call matches the constructor signature
        $6c6457024709b10b$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
        // Set the data to the bytecode + the encoded constructor arguments
        tx.data = (0, $kniO8.hexlify)((0, $kniO8.concat)([
            this.bytecode,
            this.interface.encodeDeploy(args)
        ]));
        return tx;
    }
    deploy(...args) {
        return $6c6457024709b10b$var$__awaiter(this, void 0, void 0, function*() {
            let overrides = {};
            // If 1 extra parameter was passed in, it contains overrides
            if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
            // Make sure the call matches the constructor signature
            $6c6457024709b10b$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
            // Resolve ENS names and promises in the arguments
            const params = yield $6c6457024709b10b$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            params.push(overrides);
            // Get the deployment transaction (with optional overrides)
            const unsignedTx = this.getDeployTransaction(...params);
            // Send the deployment transaction
            const tx = yield this.signer.sendTransaction(unsignedTx);
            const address = (0, $7veey.getStatic)(this.constructor, "getContractAddress")(tx);
            const contract = (0, $7veey.getStatic)(this.constructor, "getContract")(address, this.interface, this.signer);
            // Add the modified wait that wraps events
            $6c6457024709b10b$var$addContractWait(contract, tx);
            (0, $7veey.defineReadOnly)(contract, "deployTransaction", tx);
            return contract;
        });
    }
    attach(address) {
        return this.constructor.getContract(address, this.interface, this.signer);
    }
    connect(signer) {
        return new this.constructor(this.interface, this.bytecode, signer);
    }
    static fromSolidity(compilerOutput, signer) {
        if (compilerOutput == null) $6c6457024709b10b$var$logger.throwError("missing compiler output", (0, $l6EVj.Logger).errors.MISSING_ARGUMENT, {
            argument: "compilerOutput"
        });
        if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
        const abi = compilerOutput.abi;
        let bytecode = null;
        if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
        else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
        return new this(abi, bytecode, signer);
    }
    static getInterface(contractInterface) {
        return $6c6457024709b10b$export$8517d80acf00e19a.getInterface(contractInterface);
    }
    static getContractAddress(tx) {
        return (0, $1qOxQ.getContractAddress)(tx);
    }
    static getContract(address, contractInterface, signer) {
        return new $6c6457024709b10b$export$8517d80acf00e19a(address, contractInterface, signer);
    }
}

});
parcelRegister("hPcX2", function(module, exports) {

$parcel$export(module.exports, "checkResultErrors", () => $cfa13ef42b829fd0$export$5546b9ec21157cc2);
$parcel$export(module.exports, "Coder", () => $cfa13ef42b829fd0$export$2c0c39526f8bad46);
$parcel$export(module.exports, "Writer", () => $cfa13ef42b829fd0$export$d7a960146e1a269e);
$parcel$export(module.exports, "Reader", () => $cfa13ef42b829fd0$export$2f7a2f0e90c07dc4);

var $kniO8 = parcelRequire("kniO8");

var $kVZhy = parcelRequire("kVZhy");

var $7veey = parcelRequire("7veey");

var $l6EVj = parcelRequire("l6EVj");

var $bj8Og = parcelRequire("bj8Og");
"use strict";
const $cfa13ef42b829fd0$var$logger = new (0, $l6EVj.Logger)((0, $bj8Og.version));
function $cfa13ef42b829fd0$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $cfa13ef42b829fd0$export$2c0c39526f8bad46 {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        $cfa13ef42b829fd0$var$logger.throwArgumentError(message, this.localName, value);
    }
}
class $cfa13ef42b829fd0$export$d7a960146e1a269e {
    constructor(wordSize){
        (0, $7veey.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, $kniO8.hexConcat)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $kniO8.concat)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $kniO8.arrayify)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $kniO8.concat)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $kniO8.arrayify)((0, $kVZhy.BigNumber).from(value));
        if (bytes.length > this.wordSize) $cfa13ef42b829fd0$var$logger.throwError("value out-of-bounds", (0, $l6EVj.Logger).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $kniO8.concat)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class $cfa13ef42b829fd0$export$2f7a2f0e90c07dc4 {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $7veey.defineReadOnly)(this, "_data", (0, $kniO8.arrayify)(data));
        (0, $7veey.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $7veey.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $7veey.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, $kniO8.hexlify)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $cfa13ef42b829fd0$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $cfa13ef42b829fd0$var$logger.throwError("data out-of-bounds", (0, $l6EVj.Logger).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $cfa13ef42b829fd0$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $kVZhy.BigNumber).from(this.readBytes(this.wordSize));
    }
}

});
parcelRegister("kniO8", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", () => $ed548b6fa55ae105$export$9a14abb1a440cd5e);
$parcel$export(module.exports, "isHexString", () => $ed548b6fa55ae105$export$b02a40aff8e4ad18);
$parcel$export(module.exports, "isBytes", () => $ed548b6fa55ae105$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "arrayify", () => $ed548b6fa55ae105$export$3131421a7d01b4fb);
$parcel$export(module.exports, "concat", () => $ed548b6fa55ae105$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "stripZeros", () => $ed548b6fa55ae105$export$a8f4574d0e56446c);
$parcel$export(module.exports, "zeroPad", () => $ed548b6fa55ae105$export$3cdc770bf8b2ed3d);
$parcel$export(module.exports, "hexlify", () => $ed548b6fa55ae105$export$2b0d6b5fbe698c70);
$parcel$export(module.exports, "hexDataLength", () => $ed548b6fa55ae105$export$13882f896d3c0683);
$parcel$export(module.exports, "hexDataSlice", () => $ed548b6fa55ae105$export$15da666eba198c18);
$parcel$export(module.exports, "hexConcat", () => $ed548b6fa55ae105$export$6d4b99629b38754a);
$parcel$export(module.exports, "hexValue", () => $ed548b6fa55ae105$export$6916af760a341dd3);
$parcel$export(module.exports, "hexStripZeros", () => $ed548b6fa55ae105$export$967bc0082a978949);
$parcel$export(module.exports, "hexZeroPad", () => $ed548b6fa55ae105$export$e9c46a54370b47e8);
$parcel$export(module.exports, "splitSignature", () => $ed548b6fa55ae105$export$7fb170f1e457988f);
$parcel$export(module.exports, "joinSignature", () => $ed548b6fa55ae105$export$71bb9d78a59bbe25);

var $l6EVj = parcelRequire("l6EVj");

var $gMDhl = parcelRequire("gMDhl");
"use strict";
const $ed548b6fa55ae105$var$logger = new (0, $l6EVj.Logger)((0, $gMDhl.version));
///////////////////////////////
function $ed548b6fa55ae105$var$isHexable(value) {
    return !!value.toHexString;
}
function $ed548b6fa55ae105$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $ed548b6fa55ae105$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $ed548b6fa55ae105$export$9a14abb1a440cd5e(value) {
    return $ed548b6fa55ae105$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $ed548b6fa55ae105$export$c6fabfbfd097fc30(value);
}
function $ed548b6fa55ae105$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $ed548b6fa55ae105$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$ed548b6fa55ae105$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$ed548b6fa55ae105$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $ed548b6fa55ae105$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $ed548b6fa55ae105$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $ed548b6fa55ae105$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($ed548b6fa55ae105$var$isHexable(value)) value = value.toHexString();
    if ($ed548b6fa55ae105$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0x0" + hex.substring(2);
            else if (options.hexPad === "right") hex += "0";
            else $ed548b6fa55ae105$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $ed548b6fa55ae105$var$addSlice(new Uint8Array(result));
    }
    if ($ed548b6fa55ae105$export$c6fabfbfd097fc30(value)) return $ed548b6fa55ae105$var$addSlice(new Uint8Array(value));
    return $ed548b6fa55ae105$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $ed548b6fa55ae105$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$ed548b6fa55ae105$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $ed548b6fa55ae105$var$addSlice(result);
}
function $ed548b6fa55ae105$export$a8f4574d0e56446c(value) {
    let result = $ed548b6fa55ae105$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $ed548b6fa55ae105$export$3cdc770bf8b2ed3d(value, length) {
    value = $ed548b6fa55ae105$export$3131421a7d01b4fb(value);
    if (value.length > length) $ed548b6fa55ae105$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $ed548b6fa55ae105$var$addSlice(result);
}
function $ed548b6fa55ae105$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $ed548b6fa55ae105$var$HexCharacters = "0123456789abcdef";
function $ed548b6fa55ae105$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $ed548b6fa55ae105$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $ed548b6fa55ae105$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($ed548b6fa55ae105$var$isHexable(value)) return value.toHexString();
    if ($ed548b6fa55ae105$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $ed548b6fa55ae105$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($ed548b6fa55ae105$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $ed548b6fa55ae105$var$HexCharacters[(v & 0xf0) >> 4] + $ed548b6fa55ae105$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $ed548b6fa55ae105$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $ed548b6fa55ae105$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $ed548b6fa55ae105$export$2b0d6b5fbe698c70(data);
    else if (!$ed548b6fa55ae105$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $ed548b6fa55ae105$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $ed548b6fa55ae105$export$2b0d6b5fbe698c70(data);
    else if (!$ed548b6fa55ae105$export$b02a40aff8e4ad18(data) || data.length % 2) $ed548b6fa55ae105$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $ed548b6fa55ae105$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $ed548b6fa55ae105$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $ed548b6fa55ae105$export$6916af760a341dd3(value) {
    const trimmed = $ed548b6fa55ae105$export$967bc0082a978949($ed548b6fa55ae105$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $ed548b6fa55ae105$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $ed548b6fa55ae105$export$2b0d6b5fbe698c70(value);
    if (!$ed548b6fa55ae105$export$b02a40aff8e4ad18(value)) $ed548b6fa55ae105$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $ed548b6fa55ae105$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $ed548b6fa55ae105$export$2b0d6b5fbe698c70(value);
    else if (!$ed548b6fa55ae105$export$b02a40aff8e4ad18(value)) $ed548b6fa55ae105$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $ed548b6fa55ae105$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $ed548b6fa55ae105$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0
    };
    if ($ed548b6fa55ae105$export$9a14abb1a440cd5e(signature)) {
        const bytes = $ed548b6fa55ae105$export$3131421a7d01b4fb(signature);
        if (bytes.length !== 65) $ed548b6fa55ae105$var$logger.throwArgumentError("invalid signature string; must be 65 bytes", "signature", signature);
        // Get the r, s and v
        result.r = $ed548b6fa55ae105$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
        result.s = $ed548b6fa55ae105$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        result.v = bytes[64];
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $ed548b6fa55ae105$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $ed548b6fa55ae105$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $ed548b6fa55ae105$export$3cdc770bf8b2ed3d($ed548b6fa55ae105$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $ed548b6fa55ae105$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $ed548b6fa55ae105$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $ed548b6fa55ae105$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $ed548b6fa55ae105$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $ed548b6fa55ae105$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $ed548b6fa55ae105$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$ed548b6fa55ae105$export$b02a40aff8e4ad18(result.r)) $ed548b6fa55ae105$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $ed548b6fa55ae105$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$ed548b6fa55ae105$export$b02a40aff8e4ad18(result.s)) $ed548b6fa55ae105$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $ed548b6fa55ae105$export$e9c46a54370b47e8(result.s, 32);
        const vs = $ed548b6fa55ae105$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $ed548b6fa55ae105$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $ed548b6fa55ae105$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$ed548b6fa55ae105$export$b02a40aff8e4ad18(result._vs)) $ed548b6fa55ae105$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $ed548b6fa55ae105$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $ed548b6fa55ae105$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    return result;
}
function $ed548b6fa55ae105$export$71bb9d78a59bbe25(signature) {
    signature = $ed548b6fa55ae105$export$7fb170f1e457988f(signature);
    return $ed548b6fa55ae105$export$2b0d6b5fbe698c70($ed548b6fa55ae105$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRegister("l6EVj", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", () => $f5d9e70cadab6fc2$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "Logger", () => $f5d9e70cadab6fc2$export$efa9a398d6368992);

var $3lt4b = parcelRequire("3lt4b");
"use strict";
let $f5d9e70cadab6fc2$var$_permanentCensorErrors = false;
let $f5d9e70cadab6fc2$var$_censorErrors = false;
const $f5d9e70cadab6fc2$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $f5d9e70cadab6fc2$var$_logLevel = $f5d9e70cadab6fc2$var$LogLevels["default"];
let $f5d9e70cadab6fc2$var$_globalLogger = null;
function $f5d9e70cadab6fc2$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $f5d9e70cadab6fc2$var$_normalizeError = $f5d9e70cadab6fc2$var$_checkNormalize();
var $f5d9e70cadab6fc2$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($f5d9e70cadab6fc2$export$243e62d78d3b544d || ($f5d9e70cadab6fc2$export$243e62d78d3b544d = {}));
var $f5d9e70cadab6fc2$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($f5d9e70cadab6fc2$export$d4e71bc0b80dc0fb || ($f5d9e70cadab6fc2$export$d4e71bc0b80dc0fb = {}));
const $f5d9e70cadab6fc2$var$HEX = "0123456789abcdef";
class $f5d9e70cadab6fc2$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($f5d9e70cadab6fc2$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($f5d9e70cadab6fc2$var$_logLevel > $f5d9e70cadab6fc2$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($f5d9e70cadab6fc2$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($f5d9e70cadab6fc2$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($f5d9e70cadab6fc2$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($f5d9e70cadab6fc2$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $f5d9e70cadab6fc2$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $f5d9e70cadab6fc2$var$HEX[value[i] >> 4];
                        hex += $f5d9e70cadab6fc2$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $f5d9e70cadab6fc2$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($f5d9e70cadab6fc2$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $f5d9e70cadab6fc2$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $f5d9e70cadab6fc2$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $f5d9e70cadab6fc2$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $f5d9e70cadab6fc2$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $f5d9e70cadab6fc2$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $f5d9e70cadab6fc2$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $f5d9e70cadab6fc2$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $f5d9e70cadab6fc2$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $f5d9e70cadab6fc2$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$f5d9e70cadab6fc2$var$_globalLogger) $f5d9e70cadab6fc2$var$_globalLogger = new $f5d9e70cadab6fc2$export$efa9a398d6368992((0, $3lt4b.version));
        return $f5d9e70cadab6fc2$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $f5d9e70cadab6fc2$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($f5d9e70cadab6fc2$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $f5d9e70cadab6fc2$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $f5d9e70cadab6fc2$var$_censorErrors = !!censorship;
        $f5d9e70cadab6fc2$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $f5d9e70cadab6fc2$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $f5d9e70cadab6fc2$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $f5d9e70cadab6fc2$var$_logLevel = level;
    }
    static from(version) {
        return new $f5d9e70cadab6fc2$export$efa9a398d6368992(version);
    }
}
$f5d9e70cadab6fc2$export$efa9a398d6368992.errors = $f5d9e70cadab6fc2$export$d4e71bc0b80dc0fb;
$f5d9e70cadab6fc2$export$efa9a398d6368992.levels = $f5d9e70cadab6fc2$export$243e62d78d3b544d;

});
parcelRegister("3lt4b", function(module, exports) {

$parcel$export(module.exports, "version", () => $26f9e146f0a4c084$export$83d89fbfd8236492);
const $26f9e146f0a4c084$export$83d89fbfd8236492 = "logger/5.5.0";

});


parcelRegister("gMDhl", function(module, exports) {

$parcel$export(module.exports, "version", () => $c37f98fd5490e5a0$export$83d89fbfd8236492);
const $c37f98fd5490e5a0$export$83d89fbfd8236492 = "bytes/5.5.0";

});


parcelRegister("kVZhy", function(module, exports) {

$parcel$export(module.exports, "isBigNumberish", () => $f3d8aadb23ea11e3$export$a3d0a7fa9b65683b);
$parcel$export(module.exports, "BigNumber", () => $f3d8aadb23ea11e3$export$d97aa349ed20696);
$parcel$export(module.exports, "_base36To16", () => $f3d8aadb23ea11e3$export$51e4a08295f7770f);
$parcel$export(module.exports, "_base16To36", () => $f3d8aadb23ea11e3$export$1293db5d29c264ff);

var $aRmvy = parcelRequire("aRmvy");

var $kniO8 = parcelRequire("kniO8");

var $l6EVj = parcelRequire("l6EVj");

var $9D1ea = parcelRequire("9D1ea");
"use strict";
var $f3d8aadb23ea11e3$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy))).BN;
const $f3d8aadb23ea11e3$var$logger = new (0, $l6EVj.Logger)((0, $9D1ea.version));
const $f3d8aadb23ea11e3$var$_constructorGuard = {};
const $f3d8aadb23ea11e3$var$MAX_SAFE = 0x1fffffffffffff;
function $f3d8aadb23ea11e3$export$a3d0a7fa9b65683b(value) {
    return value != null && ($f3d8aadb23ea11e3$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $kniO8.isHexString)(value) || typeof value === "bigint" || (0, $kniO8.isBytes)(value));
}
// Only warn about passing 10 into radix once
let $f3d8aadb23ea11e3$var$_warnedToStringRadix = false;
class $f3d8aadb23ea11e3$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        $f3d8aadb23ea11e3$var$logger.checkNew(new.target, $f3d8aadb23ea11e3$export$d97aa349ed20696);
        if (constructorGuard !== $f3d8aadb23ea11e3$var$_constructorGuard) $f3d8aadb23ea11e3$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $f3d8aadb23ea11e3$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).add($f3d8aadb23ea11e3$var$toBN(other)));
    }
    sub(other) {
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).sub($f3d8aadb23ea11e3$var$toBN(other)));
    }
    div(other) {
        const o = $f3d8aadb23ea11e3$export$d97aa349ed20696.from(other);
        if (o.isZero()) $f3d8aadb23ea11e3$var$throwFault("division by zero", "div");
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).div($f3d8aadb23ea11e3$var$toBN(other)));
    }
    mul(other) {
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).mul($f3d8aadb23ea11e3$var$toBN(other)));
    }
    mod(other) {
        const value = $f3d8aadb23ea11e3$var$toBN(other);
        if (value.isNeg()) $f3d8aadb23ea11e3$var$throwFault("cannot modulo negative values", "mod");
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $f3d8aadb23ea11e3$var$toBN(other);
        if (value.isNeg()) $f3d8aadb23ea11e3$var$throwFault("cannot raise to negative values", "pow");
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $f3d8aadb23ea11e3$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $f3d8aadb23ea11e3$var$throwFault("cannot 'and' negative values", "and");
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).and(value));
    }
    or(other) {
        const value = $f3d8aadb23ea11e3$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $f3d8aadb23ea11e3$var$throwFault("cannot 'or' negative values", "or");
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $f3d8aadb23ea11e3$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $f3d8aadb23ea11e3$var$throwFault("cannot 'xor' negative values", "xor");
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $f3d8aadb23ea11e3$var$throwFault("cannot mask negative values", "mask");
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $f3d8aadb23ea11e3$var$throwFault("cannot shift negative values", "shl");
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $f3d8aadb23ea11e3$var$throwFault("cannot shift negative values", "shr");
        return $f3d8aadb23ea11e3$var$toBigNumber($f3d8aadb23ea11e3$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $f3d8aadb23ea11e3$var$toBN(this).eq($f3d8aadb23ea11e3$var$toBN(other));
    }
    lt(other) {
        return $f3d8aadb23ea11e3$var$toBN(this).lt($f3d8aadb23ea11e3$var$toBN(other));
    }
    lte(other) {
        return $f3d8aadb23ea11e3$var$toBN(this).lte($f3d8aadb23ea11e3$var$toBN(other));
    }
    gt(other) {
        return $f3d8aadb23ea11e3$var$toBN(this).gt($f3d8aadb23ea11e3$var$toBN(other));
    }
    gte(other) {
        return $f3d8aadb23ea11e3$var$toBN(this).gte($f3d8aadb23ea11e3$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $f3d8aadb23ea11e3$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $f3d8aadb23ea11e3$var$toBN(this).toNumber();
        } catch (error) {
            $f3d8aadb23ea11e3$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $f3d8aadb23ea11e3$var$logger.throwError("this platform does not support BigInt", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$f3d8aadb23ea11e3$var$_warnedToStringRadix) {
                    $f3d8aadb23ea11e3$var$_warnedToStringRadix = true;
                    $f3d8aadb23ea11e3$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $f3d8aadb23ea11e3$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $l6EVj.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else $f3d8aadb23ea11e3$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $l6EVj.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $f3d8aadb23ea11e3$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $f3d8aadb23ea11e3$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $f3d8aadb23ea11e3$export$d97aa349ed20696($f3d8aadb23ea11e3$var$_constructorGuard, $f3d8aadb23ea11e3$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $f3d8aadb23ea11e3$export$d97aa349ed20696($f3d8aadb23ea11e3$var$_constructorGuard, $f3d8aadb23ea11e3$var$toHex(new $f3d8aadb23ea11e3$var$BN(value)));
            return $f3d8aadb23ea11e3$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $f3d8aadb23ea11e3$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $f3d8aadb23ea11e3$var$MAX_SAFE || value <= -$f3d8aadb23ea11e3$var$MAX_SAFE) $f3d8aadb23ea11e3$var$throwFault("overflow", "BigNumber.from", value);
            return $f3d8aadb23ea11e3$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $f3d8aadb23ea11e3$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $kniO8.isBytes)(anyValue)) return $f3d8aadb23ea11e3$export$d97aa349ed20696.from((0, $kniO8.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $f3d8aadb23ea11e3$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $kniO8.isHexString)(hex) || hex[0] === "-" && (0, $kniO8.isHexString)(hex.substring(1))) return $f3d8aadb23ea11e3$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $f3d8aadb23ea11e3$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $f3d8aadb23ea11e3$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $f3d8aadb23ea11e3$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $f3d8aadb23ea11e3$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $f3d8aadb23ea11e3$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $f3d8aadb23ea11e3$var$toBigNumber(value) {
    return $f3d8aadb23ea11e3$export$d97aa349ed20696.from($f3d8aadb23ea11e3$var$toHex(value));
}
function $f3d8aadb23ea11e3$var$toBN(value) {
    const hex = $f3d8aadb23ea11e3$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $f3d8aadb23ea11e3$var$BN("-" + hex.substring(3), 16);
    return new $f3d8aadb23ea11e3$var$BN(hex.substring(2), 16);
}
function $f3d8aadb23ea11e3$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $f3d8aadb23ea11e3$var$logger.throwError(fault, (0, $l6EVj.Logger).errors.NUMERIC_FAULT, params);
}
function $f3d8aadb23ea11e3$export$51e4a08295f7770f(value) {
    return new $f3d8aadb23ea11e3$var$BN(value, 36).toString(16);
}
function $f3d8aadb23ea11e3$export$1293db5d29c264ff(value) {
    return new $f3d8aadb23ea11e3$var$BN(value, 16).toString(36);
}

});
parcelRegister("aRmvy", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("9D1ea", function(module, exports) {

$parcel$export(module.exports, "version", () => $7028b552cd408453$export$83d89fbfd8236492);
const $7028b552cd408453$export$83d89fbfd8236492 = "bignumber/5.5.0";

});


parcelRegister("7veey", function(module, exports) {

$parcel$export(module.exports, "defineReadOnly", () => $57667829e2380474$export$104236534534f9be);
$parcel$export(module.exports, "getStatic", () => $57667829e2380474$export$f695fbbf3cdaaf47);
$parcel$export(module.exports, "resolveProperties", () => $57667829e2380474$export$d503dd157d963b60);
$parcel$export(module.exports, "checkProperties", () => $57667829e2380474$export$ae5a316ba623b73a);
$parcel$export(module.exports, "shallowCopy", () => $57667829e2380474$export$9c13236873b118a5);
$parcel$export(module.exports, "deepCopy", () => $57667829e2380474$export$6c40052bed430212);
$parcel$export(module.exports, "Description", () => $57667829e2380474$export$393edc798c47379d);

var $l6EVj = parcelRequire("l6EVj");

var $5vutA = parcelRequire("5vutA");
"use strict";
var $57667829e2380474$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $57667829e2380474$var$logger = new (0, $l6EVj.Logger)((0, $5vutA.version));
function $57667829e2380474$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $57667829e2380474$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $57667829e2380474$export$d503dd157d963b60(object) {
    return $57667829e2380474$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $57667829e2380474$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $57667829e2380474$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $57667829e2380474$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $57667829e2380474$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $57667829e2380474$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $57667829e2380474$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $57667829e2380474$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$57667829e2380474$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $57667829e2380474$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $57667829e2380474$var$_deepCopy(object) {
    if ($57667829e2380474$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$57667829e2380474$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $57667829e2380474$export$104236534534f9be(result, key, $57667829e2380474$export$6c40052bed430212(value));
        }
        return result;
    }
    return $57667829e2380474$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $57667829e2380474$export$6c40052bed430212(object) {
    return $57667829e2380474$var$_deepCopy(object);
}
class $57667829e2380474$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $57667829e2380474$export$6c40052bed430212(info[key]);
    }
}

});
parcelRegister("5vutA", function(module, exports) {

$parcel$export(module.exports, "version", () => $40277cf0452147fc$export$83d89fbfd8236492);
const $40277cf0452147fc$export$83d89fbfd8236492 = "properties/5.5.0";

});


parcelRegister("bj8Og", function(module, exports) {

$parcel$export(module.exports, "version", () => $83b84d7c07419195$export$83d89fbfd8236492);
const $83b84d7c07419195$export$83d89fbfd8236492 = "abi/5.5.0";

});


parcelRegister("64Jjf", function(module, exports) {

$parcel$export(module.exports, "LogDescription", () => $46c6434b0ac52385$export$c2ab6499be98b3c5);
$parcel$export(module.exports, "TransactionDescription", () => $46c6434b0ac52385$export$7a3223b0fadb690b);
$parcel$export(module.exports, "Indexed", () => $46c6434b0ac52385$export$8ef99100a3c56f8c);
$parcel$export(module.exports, "Interface", () => $46c6434b0ac52385$export$48cefb51a4e315b2);

var $1qOxQ = parcelRequire("1qOxQ");

var $kVZhy = parcelRequire("kVZhy");

var $kniO8 = parcelRequire("kniO8");

var $bnVEQ = parcelRequire("bnVEQ");

var $jGTTU = parcelRequire("jGTTU");

var $7veey = parcelRequire("7veey");

var $dbchf = parcelRequire("dbchf");

var $hPcX2 = parcelRequire("hPcX2");

var $7py7d = parcelRequire("7py7d");

var $l6EVj = parcelRequire("l6EVj");

var $bj8Og = parcelRequire("bj8Og");
"use strict";
const $46c6434b0ac52385$var$logger = new (0, $l6EVj.Logger)((0, $bj8Og.version));
class $46c6434b0ac52385$export$c2ab6499be98b3c5 extends (0, $7veey.Description) {
}
class $46c6434b0ac52385$export$7a3223b0fadb690b extends (0, $7veey.Description) {
}
class $46c6434b0ac52385$export$cfba08fc0e40e2ab extends (0, $7veey.Description) {
}
class $46c6434b0ac52385$export$8ef99100a3c56f8c extends (0, $7veey.Description) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const $46c6434b0ac52385$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $46c6434b0ac52385$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $46c6434b0ac52385$export$48cefb51a4e315b2 {
    constructor(fragments){
        $46c6434b0ac52385$var$logger.checkNew(new.target, $46c6434b0ac52385$export$48cefb51a4e315b2);
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $7veey.defineReadOnly)(this, "fragments", abi.map((fragment)=>{
            return (0, $7py7d.Fragment).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $7veey.defineReadOnly)(this, "_abiCoder", (0, $7veey.getStatic)(new.target, "getAbiCoder")());
        (0, $7veey.defineReadOnly)(this, "functions", {});
        (0, $7veey.defineReadOnly)(this, "errors", {});
        (0, $7veey.defineReadOnly)(this, "events", {});
        (0, $7veey.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $46c6434b0ac52385$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $7veey.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $46c6434b0ac52385$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $7veey.defineReadOnly)(this, "deploy", (0, $7py7d.ConstructorFragment).from({
            payable: false,
            type: "constructor"
        }));
        (0, $7veey.defineReadOnly)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, $7py7d.FormatTypes).full;
        if (format === (0, $7py7d.FormatTypes).sighash) $46c6434b0ac52385$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $7py7d.FormatTypes).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $dbchf.defaultAbiCoder;
    }
    static getAddress(address) {
        return (0, $1qOxQ.getAddress)(address);
    }
    static getSighash(fragment) {
        return (0, $kniO8.hexDataSlice)((0, $bnVEQ.id)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $bnVEQ.id)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $kniO8.isHexString)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $46c6434b0ac52385$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $46c6434b0ac52385$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $46c6434b0ac52385$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, $7py7d.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $46c6434b0ac52385$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $kniO8.isHexString)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $46c6434b0ac52385$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $46c6434b0ac52385$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $46c6434b0ac52385$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, $7py7d.EventFragment).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $46c6434b0ac52385$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, $kniO8.isHexString)(nameOrSignatureOrSighash)) {
            const getSighash = (0, $7veey.getStatic)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            $46c6434b0ac52385$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $46c6434b0ac52385$var$logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) $46c6434b0ac52385$var$logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, $7py7d.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $46c6434b0ac52385$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, $7veey.getStatic)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $7veey.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, $kniO8.arrayify)(data);
        if ((0, $kniO8.hexlify)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $46c6434b0ac52385$var$logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, $kniO8.hexlify)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, $kniO8.hexlify)((0, $kniO8.concat)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $kniO8.arrayify)(data);
        if ((0, $kniO8.hexlify)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $46c6434b0ac52385$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $kniO8.hexlify)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $kniO8.hexlify)((0, $kniO8.concat)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $kniO8.arrayify)(data);
        let reason = null;
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, $kniO8.hexlify)(bytes.slice(0, 4));
                    const builtin = $46c6434b0ac52385$var$BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {
                        console.log(error);
                    }
                    break;
                }
        }
        return $46c6434b0ac52385$var$logger.throwError("call revert exception", (0, $l6EVj.Logger).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            errorArgs: errorArgs,
            errorName: errorName,
            errorSignature: errorSignature,
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $kniO8.hexlify)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $46c6434b0ac52385$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $l6EVj.Logger).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $bnVEQ.id)(value);
            else if (param.type === "bytes") return (0, $jGTTU.keccak256)((0, $kniO8.hexlify)(value));
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $kniO8.hexZeroPad)((0, $kniO8.hexlify)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $46c6434b0ac52385$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $46c6434b0ac52385$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $46c6434b0ac52385$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $bnVEQ.id)(value));
                else if (param.type === "bytes") topics.push((0, $jGTTU.keccak256)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $kniO8.isHexString)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $46c6434b0ac52385$var$logger.throwError("fragment/topic mismatch", (0, $l6EVj.Logger).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $7py7d.ParamType).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $kniO8.concat)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $46c6434b0ac52385$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $46c6434b0ac52385$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw $46c6434b0ac52385$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw $46c6434b0ac52385$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $46c6434b0ac52385$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $kVZhy.BigNumber).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $46c6434b0ac52385$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, $kniO8.hexlify)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $46c6434b0ac52385$export$cfba08fc0e40e2ab({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}

});
parcelRegister("1qOxQ", function(module, exports) {

$parcel$export(module.exports, "getAddress", () => $10af6d4c0a206608$export$88411125f012957a);
$parcel$export(module.exports, "isAddress", () => $10af6d4c0a206608$export$977e255126d763d6);
$parcel$export(module.exports, "getIcapAddress", () => $10af6d4c0a206608$export$962c4ddada9f668f);
$parcel$export(module.exports, "getContractAddress", () => $10af6d4c0a206608$export$b7fbffef12272e40);
$parcel$export(module.exports, "getCreate2Address", () => $10af6d4c0a206608$export$e0b22d96621f73a2);

var $kniO8 = parcelRequire("kniO8");

var $kVZhy = parcelRequire("kVZhy");

var $jGTTU = parcelRequire("jGTTU");

var $3wc1X = parcelRequire("3wc1X");

var $l6EVj = parcelRequire("l6EVj");

var $ifUbm = parcelRequire("ifUbm");
"use strict";
const $10af6d4c0a206608$var$logger = new (0, $l6EVj.Logger)((0, $ifUbm.version));
function $10af6d4c0a206608$var$getChecksumAddress(address) {
    if (!(0, $kniO8.isHexString)(address, 20)) $10af6d4c0a206608$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $kniO8.arrayify)((0, $jGTTU.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $10af6d4c0a206608$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $10af6d4c0a206608$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $10af6d4c0a206608$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$10af6d4c0a206608$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$10af6d4c0a206608$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $10af6d4c0a206608$var$safeDigits = Math.floor($10af6d4c0a206608$var$log10($10af6d4c0a206608$var$MAX_SAFE_INTEGER));
function $10af6d4c0a206608$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $10af6d4c0a206608$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $10af6d4c0a206608$var$safeDigits){
        let block = expanded.substring(0, $10af6d4c0a206608$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $10af6d4c0a206608$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $10af6d4c0a206608$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $10af6d4c0a206608$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $10af6d4c0a206608$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $10af6d4c0a206608$var$ibanChecksum(address)) $10af6d4c0a206608$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $kVZhy._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $10af6d4c0a206608$var$getChecksumAddress("0x" + result);
    } else $10af6d4c0a206608$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $10af6d4c0a206608$export$977e255126d763d6(address) {
    try {
        $10af6d4c0a206608$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $10af6d4c0a206608$export$962c4ddada9f668f(address) {
    let base36 = (0, $kVZhy._base16To36)($10af6d4c0a206608$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $10af6d4c0a206608$var$ibanChecksum("XE00" + base36) + base36;
}
function $10af6d4c0a206608$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $10af6d4c0a206608$export$88411125f012957a(transaction.from);
    } catch (error) {
        $10af6d4c0a206608$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $kniO8.stripZeros)((0, $kniO8.arrayify)((0, $kVZhy.BigNumber).from(transaction.nonce).toHexString()));
    return $10af6d4c0a206608$export$88411125f012957a((0, $kniO8.hexDataSlice)((0, $jGTTU.keccak256)((0, $3wc1X.encode)([
        from,
        nonce
    ])), 12));
}
function $10af6d4c0a206608$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $kniO8.hexDataLength)(salt) !== 32) $10af6d4c0a206608$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $kniO8.hexDataLength)(initCodeHash) !== 32) $10af6d4c0a206608$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $10af6d4c0a206608$export$88411125f012957a((0, $kniO8.hexDataSlice)((0, $jGTTU.keccak256)((0, $kniO8.concat)([
        "0xff",
        $10af6d4c0a206608$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRegister("jGTTU", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $e55d4d4c87f68473$export$f8151fce47ad1c35);

var $1IGmO = parcelRequire("1IGmO");

var $kniO8 = parcelRequire("kniO8");
"use strict";
function $e55d4d4c87f68473$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($1IGmO))).keccak_256((0, $kniO8.arrayify)(data));
}

});
parcelRegister("1IGmO", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $hPtJY === "object" && $hPtJY.versions && $hPtJY.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});



parcelRegister("3wc1X", function(module, exports) {

$parcel$export(module.exports, "encode", () => $28fdb14899749e88$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $28fdb14899749e88$export$2f872c0f2117be69);

var $kniO8 = parcelRequire("kniO8");

var $l6EVj = parcelRequire("l6EVj");

var $gWXGV = parcelRequire("gWXGV");
"use strict";
const $28fdb14899749e88$var$logger = new (0, $l6EVj.Logger)((0, $gWXGV.version));
function $28fdb14899749e88$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $28fdb14899749e88$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $28fdb14899749e88$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($28fdb14899749e88$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $28fdb14899749e88$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $kniO8.isBytesLike)(object)) $28fdb14899749e88$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $kniO8.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $28fdb14899749e88$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $28fdb14899749e88$export$c564cdbbe6da493(object) {
    return (0, $kniO8.hexlify)($28fdb14899749e88$var$_encode(object));
}
function $28fdb14899749e88$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $28fdb14899749e88$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $28fdb14899749e88$var$logger.throwError("child data too short", (0, $l6EVj.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $28fdb14899749e88$var$_decode(data, offset) {
    if (data.length === 0) $28fdb14899749e88$var$logger.throwError("data too short", (0, $l6EVj.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $28fdb14899749e88$var$logger.throwError("data short segment too short", (0, $l6EVj.Logger).errors.BUFFER_OVERRUN, {});
        const length = $28fdb14899749e88$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $28fdb14899749e88$var$logger.throwError("data long segment too short", (0, $l6EVj.Logger).errors.BUFFER_OVERRUN, {});
        return $28fdb14899749e88$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $28fdb14899749e88$var$logger.throwError("data array too short", (0, $l6EVj.Logger).errors.BUFFER_OVERRUN, {});
        return $28fdb14899749e88$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $28fdb14899749e88$var$logger.throwError("data array too short", (0, $l6EVj.Logger).errors.BUFFER_OVERRUN, {});
        const length = $28fdb14899749e88$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $28fdb14899749e88$var$logger.throwError("data array too short", (0, $l6EVj.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $kniO8.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $28fdb14899749e88$var$logger.throwError("data too short", (0, $l6EVj.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $kniO8.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $kniO8.hexlify)(data[offset])
    };
}
function $28fdb14899749e88$export$2f872c0f2117be69(data) {
    const bytes = (0, $kniO8.arrayify)(data);
    const decoded = $28fdb14899749e88$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $28fdb14899749e88$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRegister("gWXGV", function(module, exports) {

$parcel$export(module.exports, "version", () => $c5705d9751fc63ff$export$83d89fbfd8236492);
const $c5705d9751fc63ff$export$83d89fbfd8236492 = "rlp/5.5.0";

});


parcelRegister("ifUbm", function(module, exports) {

$parcel$export(module.exports, "version", () => $d4a535580dfc6207$export$83d89fbfd8236492);
const $d4a535580dfc6207$export$83d89fbfd8236492 = "address/5.5.0";

});


parcelRegister("bnVEQ", function(module, exports) {

$parcel$export(module.exports, "id", () => $849e9158ce415409$export$d560c7e4a29451c2);

var $jGTTU = parcelRequire("jGTTU");

var $1z44X = parcelRequire("1z44X");
function $849e9158ce415409$export$d560c7e4a29451c2(text) {
    return (0, $jGTTU.keccak256)((0, $1z44X.toUtf8Bytes)(text));
}

});
parcelRegister("1z44X", function(module, exports) {

$parcel$export(module.exports, "UnicodeNormalizationForm", () => $123c39540a5c5e35$export$c6986442964129f5);
$parcel$export(module.exports, "Utf8ErrorReason", () => $123c39540a5c5e35$export$c285fa6ac15ff6a6);
$parcel$export(module.exports, "Utf8ErrorFuncs", () => $123c39540a5c5e35$export$c6e2180c5bb5bc05);
$parcel$export(module.exports, "toUtf8Bytes", () => $123c39540a5c5e35$export$8feeb310b4b4752f);
$parcel$export(module.exports, "_toEscapedUtf8String", () => $123c39540a5c5e35$export$a7a0ec15960b9055);
$parcel$export(module.exports, "_toUtf8String", () => $123c39540a5c5e35$export$232e1dab03132235);
$parcel$export(module.exports, "toUtf8String", () => $123c39540a5c5e35$export$7643a1dc2c38d5eb);
$parcel$export(module.exports, "toUtf8CodePoints", () => $123c39540a5c5e35$export$ae470a36a31b28c2);

var $kniO8 = parcelRequire("kniO8");

var $l6EVj = parcelRequire("l6EVj");

var $1Xj5v = parcelRequire("1Xj5v");
"use strict";
const $123c39540a5c5e35$var$logger = new (0, $l6EVj.Logger)((0, $1Xj5v.version));
var $123c39540a5c5e35$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($123c39540a5c5e35$export$c6986442964129f5 || ($123c39540a5c5e35$export$c6986442964129f5 = {}));
var $123c39540a5c5e35$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($123c39540a5c5e35$export$c285fa6ac15ff6a6 || ($123c39540a5c5e35$export$c285fa6ac15ff6a6 = {}));
function $123c39540a5c5e35$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $123c39540a5c5e35$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $123c39540a5c5e35$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $123c39540a5c5e35$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $123c39540a5c5e35$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $123c39540a5c5e35$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $123c39540a5c5e35$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $123c39540a5c5e35$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $123c39540a5c5e35$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $123c39540a5c5e35$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $123c39540a5c5e35$var$errorFunc,
    ignore: $123c39540a5c5e35$var$ignoreFunc,
    replace: $123c39540a5c5e35$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $123c39540a5c5e35$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $123c39540a5c5e35$export$c6e2180c5bb5bc05.error;
    bytes = (0, $kniO8.arrayify)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($123c39540a5c5e35$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($123c39540a5c5e35$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($123c39540a5c5e35$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($123c39540a5c5e35$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($123c39540a5c5e35$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($123c39540a5c5e35$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($123c39540a5c5e35$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $123c39540a5c5e35$export$8feeb310b4b4752f(str, form = $123c39540a5c5e35$export$c6986442964129f5.current) {
    if (form != $123c39540a5c5e35$export$c6986442964129f5.current) {
        $123c39540a5c5e35$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $kniO8.arrayify)(result);
}
function $123c39540a5c5e35$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $123c39540a5c5e35$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $123c39540a5c5e35$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $123c39540a5c5e35$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $123c39540a5c5e35$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $123c39540a5c5e35$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $123c39540a5c5e35$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $123c39540a5c5e35$export$7643a1dc2c38d5eb(bytes, onError) {
    return $123c39540a5c5e35$export$232e1dab03132235($123c39540a5c5e35$var$getUtf8CodePoints(bytes, onError));
}
function $123c39540a5c5e35$export$ae470a36a31b28c2(str, form = $123c39540a5c5e35$export$c6986442964129f5.current) {
    return $123c39540a5c5e35$var$getUtf8CodePoints($123c39540a5c5e35$export$8feeb310b4b4752f(str, form));
}

});
parcelRegister("1Xj5v", function(module, exports) {

$parcel$export(module.exports, "version", () => $16ca1b8dbf55aea4$export$83d89fbfd8236492);
const $16ca1b8dbf55aea4$export$83d89fbfd8236492 = "strings/5.5.0";

});



parcelRegister("dbchf", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", () => $9985d373e7b73d31$export$fe041e1a83d3efc6);
$parcel$export(module.exports, "defaultAbiCoder", () => $9985d373e7b73d31$export$51d1cfcdb913adff);

var $kniO8 = parcelRequire("kniO8");

var $7veey = parcelRequire("7veey");

var $l6EVj = parcelRequire("l6EVj");

var $bj8Og = parcelRequire("bj8Og");

var $hPcX2 = parcelRequire("hPcX2");

var $36LFm = parcelRequire("36LFm");

var $GeeSg = parcelRequire("GeeSg");

var $ai7gF = parcelRequire("ai7gF");

var $iHGVe = parcelRequire("iHGVe");

var $hcIMQ = parcelRequire("hcIMQ");

var $pidPB = parcelRequire("pidPB");

var $6jodh = parcelRequire("6jodh");

var $6XceR = parcelRequire("6XceR");

var $b5SW6 = parcelRequire("b5SW6");

var $7py7d = parcelRequire("7py7d");
"use strict";
const $9985d373e7b73d31$var$logger = new (0, $l6EVj.Logger)((0, $bj8Og.version));
const $9985d373e7b73d31$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $9985d373e7b73d31$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $9985d373e7b73d31$export$fe041e1a83d3efc6 {
    constructor(coerceFunc){
        $9985d373e7b73d31$var$logger.checkNew(new.target, $9985d373e7b73d31$export$fe041e1a83d3efc6);
        (0, $7veey.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $36LFm.AddressCoder)(param.name);
            case "bool":
                return new (0, $ai7gF.BooleanCoder)(param.name);
            case "string":
                return new (0, $6XceR.StringCoder)(param.name);
            case "bytes":
                return new (0, $iHGVe.BytesCoder)(param.name);
            case "array":
                return new (0, $GeeSg.ArrayCoder)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $b5SW6.TupleCoder)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $pidPB.NullCoder)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($9985d373e7b73d31$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $9985d373e7b73d31$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $6jodh.NumberCoder)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($9985d373e7b73d31$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $9985d373e7b73d31$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $hcIMQ.FixedBytesCoder)(size, param.name);
        }
        return $9985d373e7b73d31$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $hPcX2.Reader)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $hPcX2.Writer)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, $7py7d.ParamType).from(type)));
        const coder = new (0, $b5SW6.TupleCoder)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) $9985d373e7b73d31$var$logger.throwError("types/values length mismatch", (0, $l6EVj.Logger).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $7py7d.ParamType).from(type)));
        const coder = new (0, $b5SW6.TupleCoder)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $7py7d.ParamType).from(type)));
        const coder = new (0, $b5SW6.TupleCoder)(coders, "_");
        return coder.decode(this._getReader((0, $kniO8.arrayify)(data), loose));
    }
}
const $9985d373e7b73d31$export$51d1cfcdb913adff = new $9985d373e7b73d31$export$fe041e1a83d3efc6();

});
parcelRegister("36LFm", function(module, exports) {

$parcel$export(module.exports, "AddressCoder", () => $2436e81ed482e449$export$59dbbded7775bfe7);

var $1qOxQ = parcelRequire("1qOxQ");

var $kniO8 = parcelRequire("kniO8");

var $hPcX2 = parcelRequire("hPcX2");
"use strict";
class $2436e81ed482e449$export$59dbbded7775bfe7 extends (0, $hPcX2.Coder) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, $1qOxQ.getAddress)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $1qOxQ.getAddress)((0, $kniO8.hexZeroPad)(reader.readValue().toHexString(), 20));
    }
}

});

parcelRegister("GeeSg", function(module, exports) {

$parcel$export(module.exports, "pack", () => $07eef7e8b28c21bb$export$2a703dbb0cb35339);
$parcel$export(module.exports, "unpack", () => $07eef7e8b28c21bb$export$417857010dc9287f);
$parcel$export(module.exports, "ArrayCoder", () => $07eef7e8b28c21bb$export$88bc419d2df11f54);

var $l6EVj = parcelRequire("l6EVj");

var $bj8Og = parcelRequire("bj8Og");

var $hPcX2 = parcelRequire("hPcX2");

var $klXYh = parcelRequire("klXYh");
"use strict";
const $07eef7e8b28c21bb$var$logger = new (0, $l6EVj.Logger)((0, $bj8Og.version));
function $07eef7e8b28c21bb$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $07eef7e8b28c21bb$var$logger.throwError("cannot encode object for signature with missing names", (0, $l6EVj.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $07eef7e8b28c21bb$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $l6EVj.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $07eef7e8b28c21bb$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $07eef7e8b28c21bb$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $hPcX2.Writer)(writer.wordSize);
    let dynamicWriter = new (0, $hPcX2.Writer)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $07eef7e8b28c21bb$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $l6EVj.Logger).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $l6EVj.Logger).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $07eef7e8b28c21bb$export$88bc419d2df11f54 extends (0, $hPcX2.Coder) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $07eef7e8b28c21bb$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $07eef7e8b28c21bb$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) $07eef7e8b28c21bb$var$logger.throwError("insufficient data length", (0, $l6EVj.Logger).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $klXYh.AnonymousCoder)(this.coder));
        return reader.coerce(this.name, $07eef7e8b28c21bb$export$417857010dc9287f(reader, coders));
    }
}

});
parcelRegister("klXYh", function(module, exports) {

$parcel$export(module.exports, "AnonymousCoder", () => $ed1449dbcea00335$export$87c41d1139a03fa2);

var $hPcX2 = parcelRequire("hPcX2");
"use strict";
class $ed1449dbcea00335$export$87c41d1139a03fa2 extends (0, $hPcX2.Coder) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}

});


parcelRegister("ai7gF", function(module, exports) {

$parcel$export(module.exports, "BooleanCoder", () => $77e1390a47f86ab6$export$fe9118d6c093150c);

var $hPcX2 = parcelRequire("hPcX2");
"use strict";
class $77e1390a47f86ab6$export$fe9118d6c093150c extends (0, $hPcX2.Coder) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}

});

parcelRegister("iHGVe", function(module, exports) {

$parcel$export(module.exports, "DynamicBytesCoder", () => $d9dd8994739dad2e$export$db9eadd8df12ad2e);
$parcel$export(module.exports, "BytesCoder", () => $d9dd8994739dad2e$export$e5823e9574df18d2);

var $kniO8 = parcelRequire("kniO8");

var $hPcX2 = parcelRequire("hPcX2");
"use strict";
class $d9dd8994739dad2e$export$db9eadd8df12ad2e extends (0, $hPcX2.Coder) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $kniO8.arrayify)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class $d9dd8994739dad2e$export$e5823e9574df18d2 extends $d9dd8994739dad2e$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $kniO8.hexlify)(super.decode(reader)));
    }
}

});

parcelRegister("hcIMQ", function(module, exports) {

$parcel$export(module.exports, "FixedBytesCoder", () => $c8664c5cf361786f$export$7dec9db68e6bcf5a);

var $kniO8 = parcelRequire("kniO8");

var $hPcX2 = parcelRequire("hPcX2");
"use strict";
class $c8664c5cf361786f$export$7dec9db68e6bcf5a extends (0, $hPcX2.Coder) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, $kniO8.arrayify)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $kniO8.hexlify)(reader.readBytes(this.size)));
    }
}

});

parcelRegister("pidPB", function(module, exports) {

$parcel$export(module.exports, "NullCoder", () => $04c07870de86fe59$export$70982cadf2d6b4ec);

var $hPcX2 = parcelRequire("hPcX2");
"use strict";
class $04c07870de86fe59$export$70982cadf2d6b4ec extends (0, $hPcX2.Coder) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}

});

parcelRegister("6jodh", function(module, exports) {

$parcel$export(module.exports, "NumberCoder", () => $012f9a02b06aee8a$export$b934dc8cfe13938c);

var $kVZhy = parcelRequire("kVZhy");

var $gYmoN = parcelRequire("gYmoN");

var $hPcX2 = parcelRequire("hPcX2");
"use strict";
class $012f9a02b06aee8a$export$b934dc8cfe13938c extends (0, $hPcX2.Coder) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, $kVZhy.BigNumber).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $gYmoN.MaxUint256).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $gYmoN.One)).mul((0, $gYmoN.NegativeOne)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $gYmoN.Zero)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}

});
parcelRegister("gYmoN", function(module, exports) {

$parcel$export(module.exports, "NegativeOne", () => $c5b39feb78e849f2$export$c83ef0909a6ddeec);
$parcel$export(module.exports, "Zero", () => $c5b39feb78e849f2$export$aaef8a3eae948f03);
$parcel$export(module.exports, "One", () => $c5b39feb78e849f2$export$9aa05a5866350bcf);
$parcel$export(module.exports, "Two", () => $c5b39feb78e849f2$export$9276dd97bf62cc8d);
$parcel$export(module.exports, "WeiPerEther", () => $c5b39feb78e849f2$export$c8db55bd7405209e);
$parcel$export(module.exports, "MaxUint256", () => $c5b39feb78e849f2$export$1b53890de5aabdd0);
$parcel$export(module.exports, "MinInt256", () => $c5b39feb78e849f2$export$963c9b9317b80aaf);
$parcel$export(module.exports, "MaxInt256", () => $c5b39feb78e849f2$export$6f8dbb07ebe6d738);

var $kVZhy = parcelRequire("kVZhy");
const $c5b39feb78e849f2$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $kVZhy.BigNumber).from(-1);
const $c5b39feb78e849f2$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $kVZhy.BigNumber).from(0);
const $c5b39feb78e849f2$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $kVZhy.BigNumber).from(1);
const $c5b39feb78e849f2$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $kVZhy.BigNumber).from(2);
const $c5b39feb78e849f2$export$c8db55bd7405209e = /*#__PURE__*/ (0, $kVZhy.BigNumber).from("1000000000000000000");
const $c5b39feb78e849f2$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $kVZhy.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $c5b39feb78e849f2$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $kVZhy.BigNumber).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $c5b39feb78e849f2$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $kVZhy.BigNumber).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

});


parcelRegister("6XceR", function(module, exports) {

$parcel$export(module.exports, "StringCoder", () => $5101bf1f3a1cfb6a$export$2d1b854518731426);

var $1z44X = parcelRequire("1z44X");

var $iHGVe = parcelRequire("iHGVe");
"use strict";
class $5101bf1f3a1cfb6a$export$2d1b854518731426 extends (0, $iHGVe.DynamicBytesCoder) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, $1z44X.toUtf8Bytes)(value));
    }
    decode(reader) {
        return (0, $1z44X.toUtf8String)(super.decode(reader));
    }
}

});

parcelRegister("b5SW6", function(module, exports) {

$parcel$export(module.exports, "TupleCoder", () => $813ac684bc672d28$export$e9fceba8f110fea6);

var $hPcX2 = parcelRequire("hPcX2");

var $GeeSg = parcelRequire("GeeSg");
"use strict";
class $813ac684bc672d28$export$e9fceba8f110fea6 extends (0, $hPcX2.Coder) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, $GeeSg.pack)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $GeeSg.unpack)(reader, this.coders));
    }
}

});

parcelRegister("7py7d", function(module, exports) {

$parcel$export(module.exports, "FormatTypes", () => $565554cdd522e2ef$export$f010f239efc4d445);
$parcel$export(module.exports, "ParamType", () => $565554cdd522e2ef$export$426dc07f493a4c47);
$parcel$export(module.exports, "Fragment", () => $565554cdd522e2ef$export$ffb0004e005737fa);
$parcel$export(module.exports, "FunctionFragment", () => $565554cdd522e2ef$export$8d576c928b93668f);
$parcel$export(module.exports, "EventFragment", () => $565554cdd522e2ef$export$958548f08bac2833);
$parcel$export(module.exports, "ConstructorFragment", () => $565554cdd522e2ef$export$3ac5c9504f801ea4);
$parcel$export(module.exports, "ErrorFragment", () => $565554cdd522e2ef$export$2c42c6d543aa9b59);

var $kVZhy = parcelRequire("kVZhy");

var $7veey = parcelRequire("7veey");

var $l6EVj = parcelRequire("l6EVj");

var $bj8Og = parcelRequire("bj8Og");
"use strict";
const $565554cdd522e2ef$var$logger = new (0, $l6EVj.Logger)((0, $bj8Og.version));
const $565554cdd522e2ef$var$_constructorGuard = {};
let $565554cdd522e2ef$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $565554cdd522e2ef$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $565554cdd522e2ef$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($565554cdd522e2ef$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($565554cdd522e2ef$var$ModifiersNest[name]) return true;
    }
    if ($565554cdd522e2ef$var$ModifiersBytes[name] || name === "payable") $565554cdd522e2ef$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $565554cdd522e2ef$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $565554cdd522e2ef$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $565554cdd522e2ef$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($565554cdd522e2ef$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $565554cdd522e2ef$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($565554cdd522e2ef$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $565554cdd522e2ef$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $565554cdd522e2ef$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($565554cdd522e2ef$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $565554cdd522e2ef$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($565554cdd522e2ef$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $565554cdd522e2ef$var$verifyType(parent.type);
    return parent;
}
function $565554cdd522e2ef$var$populate(object, params) {
    for(let key in params)(0, $7veey.defineReadOnly)(object, key, params[key]);
}
const $565554cdd522e2ef$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $565554cdd522e2ef$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $565554cdd522e2ef$export$426dc07f493a4c47 {
    constructor(constructorGuard, params){
        if (constructorGuard !== $565554cdd522e2ef$var$_constructorGuard) $565554cdd522e2ef$var$logger.throwError("use fromString", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $565554cdd522e2ef$var$populate(this, params);
        let match = this.type.match($565554cdd522e2ef$var$paramTypeArray);
        if (match) $565554cdd522e2ef$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $565554cdd522e2ef$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $565554cdd522e2ef$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = $565554cdd522e2ef$export$f010f239efc4d445.sighash;
        if (!$565554cdd522e2ef$export$f010f239efc4d445[format]) $565554cdd522e2ef$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $565554cdd522e2ef$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $565554cdd522e2ef$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $565554cdd522e2ef$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $565554cdd522e2ef$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $565554cdd522e2ef$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $565554cdd522e2ef$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $565554cdd522e2ef$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($565554cdd522e2ef$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $565554cdd522e2ef$export$426dc07f493a4c47($565554cdd522e2ef$var$_constructorGuard, {
            name: value.name || null,
            type: $565554cdd522e2ef$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($565554cdd522e2ef$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $565554cdd522e2ef$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($565554cdd522e2ef$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function $565554cdd522e2ef$var$parseParams(value, allowIndex) {
    return $565554cdd522e2ef$var$splitNesting(value).map((param)=>$565554cdd522e2ef$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $565554cdd522e2ef$export$ffb0004e005737fa {
    constructor(constructorGuard, params){
        if (constructorGuard !== $565554cdd522e2ef$var$_constructorGuard) $565554cdd522e2ef$var$logger.throwError("use a static from method", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $565554cdd522e2ef$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if ($565554cdd522e2ef$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $565554cdd522e2ef$export$ffb0004e005737fa.fromString(value);
        return $565554cdd522e2ef$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($565554cdd522e2ef$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $565554cdd522e2ef$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $565554cdd522e2ef$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $565554cdd522e2ef$export$3ac5c9504f801ea4.fromObject(value);
            case "error":
                return $565554cdd522e2ef$export$2c42c6d543aa9b59.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $565554cdd522e2ef$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $565554cdd522e2ef$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $565554cdd522e2ef$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $565554cdd522e2ef$export$3ac5c9504f801ea4.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return $565554cdd522e2ef$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
        return $565554cdd522e2ef$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class $565554cdd522e2ef$export$958548f08bac2833 extends $565554cdd522e2ef$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $565554cdd522e2ef$export$f010f239efc4d445.sighash;
        if (!$565554cdd522e2ef$export$f010f239efc4d445[format]) $565554cdd522e2ef$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $565554cdd522e2ef$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $565554cdd522e2ef$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $565554cdd522e2ef$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $565554cdd522e2ef$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $565554cdd522e2ef$export$958548f08bac2833.fromString(value);
        return $565554cdd522e2ef$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($565554cdd522e2ef$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $565554cdd522e2ef$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $565554cdd522e2ef$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($565554cdd522e2ef$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $565554cdd522e2ef$export$958548f08bac2833($565554cdd522e2ef$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($565554cdd522e2ef$var$regexParen);
        if (!match) $565554cdd522e2ef$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $565554cdd522e2ef$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $565554cdd522e2ef$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $565554cdd522e2ef$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $565554cdd522e2ef$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $565554cdd522e2ef$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $565554cdd522e2ef$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $kVZhy.BigNumber).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $565554cdd522e2ef$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $565554cdd522e2ef$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $565554cdd522e2ef$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $565554cdd522e2ef$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $565554cdd522e2ef$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $565554cdd522e2ef$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $565554cdd522e2ef$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $565554cdd522e2ef$export$3ac5c9504f801ea4 extends $565554cdd522e2ef$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $565554cdd522e2ef$export$f010f239efc4d445.sighash;
        if (!$565554cdd522e2ef$export$f010f239efc4d445[format]) $565554cdd522e2ef$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $565554cdd522e2ef$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $565554cdd522e2ef$export$f010f239efc4d445.sighash) $565554cdd522e2ef$var$logger.throwError("cannot format a constructor for sighash", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $565554cdd522e2ef$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $565554cdd522e2ef$export$3ac5c9504f801ea4.fromString(value);
        return $565554cdd522e2ef$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($565554cdd522e2ef$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $565554cdd522e2ef$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $565554cdd522e2ef$var$verifyState(value);
        if (state.constant) $565554cdd522e2ef$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($565554cdd522e2ef$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $kVZhy.BigNumber).from(value.gas) : null
        };
        return new $565554cdd522e2ef$export$3ac5c9504f801ea4($565554cdd522e2ef$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $565554cdd522e2ef$var$parseGas(value, params);
        let parens = value.match($565554cdd522e2ef$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $565554cdd522e2ef$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $565554cdd522e2ef$var$parseParams(parens[2].trim(), false);
        $565554cdd522e2ef$var$parseModifiers(parens[3].trim(), params);
        return $565554cdd522e2ef$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $565554cdd522e2ef$export$8d576c928b93668f extends $565554cdd522e2ef$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $565554cdd522e2ef$export$f010f239efc4d445.sighash;
        if (!$565554cdd522e2ef$export$f010f239efc4d445[format]) $565554cdd522e2ef$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $565554cdd522e2ef$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $565554cdd522e2ef$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $565554cdd522e2ef$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $565554cdd522e2ef$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $565554cdd522e2ef$export$8d576c928b93668f.fromString(value);
        return $565554cdd522e2ef$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($565554cdd522e2ef$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $565554cdd522e2ef$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $565554cdd522e2ef$var$verifyState(value);
        const params = {
            type: value.type,
            name: $565554cdd522e2ef$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($565554cdd522e2ef$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($565554cdd522e2ef$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $kVZhy.BigNumber).from(value.gas) : null
        };
        return new $565554cdd522e2ef$export$8d576c928b93668f($565554cdd522e2ef$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $565554cdd522e2ef$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $565554cdd522e2ef$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($565554cdd522e2ef$var$regexParen);
        if (!parens) $565554cdd522e2ef$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $565554cdd522e2ef$var$verifyIdentifier(params.name);
        params.inputs = $565554cdd522e2ef$var$parseParams(parens[2], false);
        $565554cdd522e2ef$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($565554cdd522e2ef$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $565554cdd522e2ef$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $565554cdd522e2ef$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $565554cdd522e2ef$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function $565554cdd522e2ef$var$checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $565554cdd522e2ef$var$logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class $565554cdd522e2ef$export$2c42c6d543aa9b59 extends $565554cdd522e2ef$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $565554cdd522e2ef$export$f010f239efc4d445.sighash;
        if (!$565554cdd522e2ef$export$f010f239efc4d445[format]) $565554cdd522e2ef$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $565554cdd522e2ef$export$f010f239efc4d445.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $565554cdd522e2ef$export$f010f239efc4d445.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $565554cdd522e2ef$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $565554cdd522e2ef$export$2c42c6d543aa9b59.fromString(value);
        return $565554cdd522e2ef$export$2c42c6d543aa9b59.fromObject(value);
    }
    static fromObject(value) {
        if ($565554cdd522e2ef$export$2c42c6d543aa9b59.isErrorFragment(value)) return value;
        if (value.type !== "error") $565554cdd522e2ef$var$logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: $565554cdd522e2ef$var$verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map($565554cdd522e2ef$export$426dc07f493a4c47.fromObject) : []
        };
        return $565554cdd522e2ef$var$checkForbidden(new $565554cdd522e2ef$export$2c42c6d543aa9b59($565554cdd522e2ef$var$_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match($565554cdd522e2ef$var$regexParen);
        if (!parens) $565554cdd522e2ef$var$logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $565554cdd522e2ef$var$verifyIdentifier(params.name);
        params.inputs = $565554cdd522e2ef$var$parseParams(parens[2], false);
        return $565554cdd522e2ef$var$checkForbidden($565554cdd522e2ef$export$2c42c6d543aa9b59.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function $565554cdd522e2ef$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const $565554cdd522e2ef$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $565554cdd522e2ef$var$verifyIdentifier(value) {
    if (!value || !value.match($565554cdd522e2ef$var$regexIdentifier)) $565554cdd522e2ef$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $565554cdd522e2ef$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $565554cdd522e2ef$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $565554cdd522e2ef$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}

});



parcelRegister("hMfVR", function(module, exports) {

$parcel$export(module.exports, "ForkEvent", () => $cf13472c0aa68f61$export$406ece1549ccd00e);
$parcel$export(module.exports, "Provider", () => $cf13472c0aa68f61$export$2881499e37b75b9a);

var $kVZhy = parcelRequire("kVZhy");

var $kniO8 = parcelRequire("kniO8");

var $7veey = parcelRequire("7veey");

var $l6EVj = parcelRequire("l6EVj");

var $lQUgH = parcelRequire("lQUgH");
"use strict";
var $cf13472c0aa68f61$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $cf13472c0aa68f61$var$logger = new (0, $l6EVj.Logger)((0, $lQUgH.version));
class $cf13472c0aa68f61$export$406ece1549ccd00e extends (0, $7veey.Description) {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class $cf13472c0aa68f61$export$5b2cada8494f9d99 extends $cf13472c0aa68f61$export$406ece1549ccd00e {
    constructor(blockHash, expiry){
        if (!(0, $kniO8.isHexString)(blockHash, 32)) $cf13472c0aa68f61$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
}
class $cf13472c0aa68f61$export$26bcd61a55716c98 extends $cf13472c0aa68f61$export$406ece1549ccd00e {
    constructor(hash, expiry){
        if (!(0, $kniO8.isHexString)(hash, 32)) $cf13472c0aa68f61$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
}
class $cf13472c0aa68f61$export$8f8609bfee47c93 extends $cf13472c0aa68f61$export$406ece1549ccd00e {
    constructor(beforeHash, afterHash, expiry){
        if (!(0, $kniO8.isHexString)(beforeHash, 32)) $cf13472c0aa68f61$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $kniO8.isHexString)(afterHash, 32)) $cf13472c0aa68f61$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
class $cf13472c0aa68f61$export$2881499e37b75b9a {
    constructor(){
        $cf13472c0aa68f61$var$logger.checkAbstract(new.target, $cf13472c0aa68f61$export$2881499e37b75b9a);
        (0, $7veey.defineReadOnly)(this, "_isProvider", true);
    }
    getFeeData() {
        return $cf13472c0aa68f61$var$__awaiter(this, void 0, void 0, function*() {
            const { block: block, gasPrice: gasPrice } = yield (0, $7veey.resolveProperties)({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error)=>{
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                maxPriorityFeePerGas = (0, $kVZhy.BigNumber).from("2500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return {
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                gasPrice: gasPrice
            };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
}

});
parcelRegister("lQUgH", function(module, exports) {

$parcel$export(module.exports, "version", () => $fe8a1a023c281541$export$83d89fbfd8236492);
const $fe8a1a023c281541$export$83d89fbfd8236492 = "abstract-provider/5.5.1";

});


parcelRegister("lLoTq", function(module, exports) {

$parcel$export(module.exports, "Signer", () => $fd814bfeca965778$export$fdf54fdde81cc9f0);
$parcel$export(module.exports, "VoidSigner", () => $fd814bfeca965778$export$7dbc56d9b9612bad);

var $7veey = parcelRequire("7veey");

var $l6EVj = parcelRequire("l6EVj");

var $hz8cC = parcelRequire("hz8cC");
"use strict";
var $fd814bfeca965778$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $fd814bfeca965778$var$logger = new (0, $l6EVj.Logger)((0, $hz8cC.version));
const $fd814bfeca965778$var$allowedTransactionKeys = [
    "accessList",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
const $fd814bfeca965778$var$forwardErrors = [
    (0, $l6EVj.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $l6EVj.Logger).errors.NONCE_EXPIRED,
    (0, $l6EVj.Logger).errors.REPLACEMENT_UNDERPRICED
];
class $fd814bfeca965778$export$fdf54fdde81cc9f0 {
    ///////////////////
    // Sub-classes MUST call super
    constructor(){
        $fd814bfeca965778$var$logger.checkAbstract(new.target, $fd814bfeca965778$export$fdf54fdde81cc9f0);
        (0, $7veey.defineReadOnly)(this, "_isSigner", true);
    }
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return $fd814bfeca965778$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return $fd814bfeca965778$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return $fd814bfeca965778$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("estimateGas");
            const tx = yield (0, $7veey.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return $fd814bfeca965778$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("call");
            const tx = yield (0, $7veey.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return $fd814bfeca965778$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return $fd814bfeca965778$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return $fd814bfeca965778$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return $fd814bfeca965778$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return $fd814bfeca965778$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for(const key in transaction)if ($fd814bfeca965778$var$allowedTransactionKeys.indexOf(key) === -1) $fd814bfeca965778$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
        const tx = (0, $7veey.shallowCopy)(transaction);
        if (tx.from == null) tx.from = this.getAddress();
        else // Make sure any provided address matches this signer
        tx.from = Promise.all([
            Promise.resolve(tx.from),
            this.getAddress()
        ]).then((result)=>{
            if (result[0].toLowerCase() !== result[1].toLowerCase()) $fd814bfeca965778$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            return result[0];
        });
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return $fd814bfeca965778$var$__awaiter(this, void 0, void 0, function*() {
            const tx = yield (0, $7veey.resolveProperties)(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to)=>$fd814bfeca965778$var$__awaiter(this, void 0, void 0, function*() {
                        if (to == null) return null;
                        const address = yield this.resolveName(to);
                        if (address == null) $fd814bfeca965778$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                        return address;
                    }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error)=>{});
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $fd814bfeca965778$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $fd814bfeca965778$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            if ((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
            tx.type = 2;
            else if (tx.type === 0 || tx.type === 1) // Explicit Legacy or EIP-2930 transaction
            // Populate missing gasPrice
            {
                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
            } else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        } else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                        }
                    } else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) $fd814bfeca965778$var$logger.throwError("network does not support EIP-1559", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                            operation: "populateTransaction"
                        });
                        // Populate missing fee data
                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    } else // getFeeData has failed us.
                    $fd814bfeca965778$var$logger.throwError("failed to get consistent fee data", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "signer.getFeeData"
                    });
                } else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                }
            }
            if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
            if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch((error)=>{
                if ($fd814bfeca965778$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                return $fd814bfeca965778$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $l6EVj.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
                    error: error,
                    tx: tx
                });
            });
            if (tx.chainId == null) tx.chainId = this.getChainId();
            else tx.chainId = Promise.all([
                Promise.resolve(tx.chainId),
                this.getChainId()
            ]).then((results)=>{
                if (results[1] !== 0 && results[0] !== results[1]) $fd814bfeca965778$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                return results[0];
            });
            return yield (0, $7veey.resolveProperties)(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) $fd814bfeca965778$var$logger.throwError("missing provider", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: operation || "_checkProvider"
        });
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
}
class $fd814bfeca965778$export$7dbc56d9b9612bad extends $fd814bfeca965778$export$fdf54fdde81cc9f0 {
    constructor(address, provider){
        $fd814bfeca965778$var$logger.checkNew(new.target, $fd814bfeca965778$export$7dbc56d9b9612bad);
        super();
        (0, $7veey.defineReadOnly)(this, "address", address);
        (0, $7veey.defineReadOnly)(this, "provider", provider || null);
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(()=>{
            $fd814bfeca965778$var$logger.throwError(message, (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: operation
            });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new $fd814bfeca965778$export$7dbc56d9b9612bad(this.address, provider);
    }
}

});
parcelRegister("hz8cC", function(module, exports) {

$parcel$export(module.exports, "version", () => $cc9c1163a7811ffd$export$83d89fbfd8236492);
const $cc9c1163a7811ffd$export$83d89fbfd8236492 = "abstract-signer/5.5.0";

});


parcelRegister("equjW", function(module, exports) {

$parcel$export(module.exports, "TransactionTypes", () => $a80b036f2ef40d8e$export$80349e05e0724e11);
$parcel$export(module.exports, "computeAddress", () => $a80b036f2ef40d8e$export$e67e2732ba9803f9);
$parcel$export(module.exports, "recoverAddress", () => $a80b036f2ef40d8e$export$23cc18f96d8510e2);
$parcel$export(module.exports, "accessListify", () => $a80b036f2ef40d8e$export$6c8662b1600dce2);
$parcel$export(module.exports, "serialize", () => $a80b036f2ef40d8e$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "parse", () => $a80b036f2ef40d8e$export$98e6a39c04603d36);

var $1qOxQ = parcelRequire("1qOxQ");

var $kVZhy = parcelRequire("kVZhy");

var $kniO8 = parcelRequire("kniO8");

var $gYmoN = parcelRequire("gYmoN");

var $jGTTU = parcelRequire("jGTTU");

var $7veey = parcelRequire("7veey");

var $3wc1X = parcelRequire("3wc1X");

var $hZMsZ = parcelRequire("hZMsZ");

var $l6EVj = parcelRequire("l6EVj");

var $1fEKo = parcelRequire("1fEKo");
"use strict";
const $a80b036f2ef40d8e$var$logger = new (0, $l6EVj.Logger)((0, $1fEKo.version));
var $a80b036f2ef40d8e$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($a80b036f2ef40d8e$export$80349e05e0724e11 || ($a80b036f2ef40d8e$export$80349e05e0724e11 = {}));
///////////////////////////////
function $a80b036f2ef40d8e$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $1qOxQ.getAddress)(value);
}
function $a80b036f2ef40d8e$var$handleNumber(value) {
    if (value === "0x") return 0, $gYmoN.Zero;
    return (0, $kVZhy.BigNumber).from(value);
}
// Legacy Transaction Fields
const $a80b036f2ef40d8e$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $a80b036f2ef40d8e$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $a80b036f2ef40d8e$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $hZMsZ.computePublicKey)(key);
    return (0, $1qOxQ.getAddress)((0, $kniO8.hexDataSlice)((0, $jGTTU.keccak256)((0, $kniO8.hexDataSlice)(publicKey, 1)), 12));
}
function $a80b036f2ef40d8e$export$23cc18f96d8510e2(digest, signature) {
    return $a80b036f2ef40d8e$export$e67e2732ba9803f9((0, $hZMsZ.recoverPublicKey)((0, $kniO8.arrayify)(digest), signature));
}
function $a80b036f2ef40d8e$var$formatNumber(value, name) {
    const result = (0, $kniO8.stripZeros)((0, $kVZhy.BigNumber).from(value).toHexString());
    if (result.length > 32) $a80b036f2ef40d8e$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $a80b036f2ef40d8e$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $1qOxQ.getAddress)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $kniO8.hexDataLength)(storageKey) !== 32) $a80b036f2ef40d8e$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $a80b036f2ef40d8e$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $a80b036f2ef40d8e$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $a80b036f2ef40d8e$var$accessSetify(set[0], set[1]);
        }
        return $a80b036f2ef40d8e$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $a80b036f2ef40d8e$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $a80b036f2ef40d8e$var$formatAccessList(value) {
    return $a80b036f2ef40d8e$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $a80b036f2ef40d8e$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $kVZhy.BigNumber).from(transaction.gasPrice);
        const maxFeePerGas = (0, $kVZhy.BigNumber).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $a80b036f2ef40d8e$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $a80b036f2ef40d8e$var$formatNumber(transaction.chainId || 0, "chainId"),
        $a80b036f2ef40d8e$var$formatNumber(transaction.nonce || 0, "nonce"),
        $a80b036f2ef40d8e$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $a80b036f2ef40d8e$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $a80b036f2ef40d8e$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $1qOxQ.getAddress)(transaction.to) : "0x",
        $a80b036f2ef40d8e$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $a80b036f2ef40d8e$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $kniO8.splitSignature)(signature);
        fields.push($a80b036f2ef40d8e$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $kniO8.stripZeros)(sig.r));
        fields.push((0, $kniO8.stripZeros)(sig.s));
    }
    return (0, $kniO8.hexConcat)([
        "0x02",
        $3wc1X.encode(fields)
    ]);
}
function $a80b036f2ef40d8e$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $a80b036f2ef40d8e$var$formatNumber(transaction.chainId || 0, "chainId"),
        $a80b036f2ef40d8e$var$formatNumber(transaction.nonce || 0, "nonce"),
        $a80b036f2ef40d8e$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $a80b036f2ef40d8e$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $1qOxQ.getAddress)(transaction.to) : "0x",
        $a80b036f2ef40d8e$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $a80b036f2ef40d8e$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $kniO8.splitSignature)(signature);
        fields.push($a80b036f2ef40d8e$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $kniO8.stripZeros)(sig.r));
        fields.push((0, $kniO8.stripZeros)(sig.s));
    }
    return (0, $kniO8.hexConcat)([
        "0x01",
        $3wc1X.encode(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $a80b036f2ef40d8e$var$_serialize(transaction, signature) {
    (0, $7veey.checkProperties)(transaction, $a80b036f2ef40d8e$var$allowedTransactionKeys);
    const raw = [];
    $a80b036f2ef40d8e$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $kniO8.arrayify)((0, $kniO8.hexlify)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $a80b036f2ef40d8e$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $kniO8.stripZeros)(value);
            if (value.length > fieldInfo.maxLength) $a80b036f2ef40d8e$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $kniO8.hexlify)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $a80b036f2ef40d8e$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $kniO8.isBytesLike)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $kniO8.hexlify)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $3wc1X.encode(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $kniO8.splitSignature)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $a80b036f2ef40d8e$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $a80b036f2ef40d8e$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $kniO8.hexlify)(v));
    raw.push((0, $kniO8.stripZeros)((0, $kniO8.arrayify)(sig.r)));
    raw.push((0, $kniO8.stripZeros)((0, $kniO8.arrayify)(sig.s)));
    return $3wc1X.encode(raw);
}
function $a80b036f2ef40d8e$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $a80b036f2ef40d8e$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $a80b036f2ef40d8e$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $a80b036f2ef40d8e$var$_serializeEip2930(transaction, signature);
        case 2:
            return $a80b036f2ef40d8e$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $a80b036f2ef40d8e$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $a80b036f2ef40d8e$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $a80b036f2ef40d8e$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $a80b036f2ef40d8e$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $kniO8.hexZeroPad)(fields[1], 32);
    tx.s = (0, $kniO8.hexZeroPad)(fields[2], 32);
    try {
        const digest = (0, $jGTTU.keccak256)(serialize(tx));
        tx.from = $a80b036f2ef40d8e$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {
        console.log(error);
    }
}
function $a80b036f2ef40d8e$var$_parseEip1559(payload) {
    const transaction = $3wc1X.decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $a80b036f2ef40d8e$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $kniO8.hexlify)(payload));
    const maxPriorityFeePerGas = $a80b036f2ef40d8e$var$handleNumber(transaction[2]);
    const maxFeePerGas = $a80b036f2ef40d8e$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $a80b036f2ef40d8e$var$handleNumber(transaction[0]).toNumber(),
        nonce: $a80b036f2ef40d8e$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $a80b036f2ef40d8e$var$handleNumber(transaction[4]),
        to: $a80b036f2ef40d8e$var$handleAddress(transaction[5]),
        value: $a80b036f2ef40d8e$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $a80b036f2ef40d8e$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $jGTTU.keccak256)(payload);
    $a80b036f2ef40d8e$var$_parseEipSignature(tx, transaction.slice(9), $a80b036f2ef40d8e$var$_serializeEip1559);
    return tx;
}
function $a80b036f2ef40d8e$var$_parseEip2930(payload) {
    const transaction = $3wc1X.decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $a80b036f2ef40d8e$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $kniO8.hexlify)(payload));
    const tx = {
        type: 1,
        chainId: $a80b036f2ef40d8e$var$handleNumber(transaction[0]).toNumber(),
        nonce: $a80b036f2ef40d8e$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $a80b036f2ef40d8e$var$handleNumber(transaction[2]),
        gasLimit: $a80b036f2ef40d8e$var$handleNumber(transaction[3]),
        to: $a80b036f2ef40d8e$var$handleAddress(transaction[4]),
        value: $a80b036f2ef40d8e$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $a80b036f2ef40d8e$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $jGTTU.keccak256)(payload);
    $a80b036f2ef40d8e$var$_parseEipSignature(tx, transaction.slice(8), $a80b036f2ef40d8e$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $a80b036f2ef40d8e$var$_parse(rawTransaction) {
    const transaction = $3wc1X.decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $a80b036f2ef40d8e$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $a80b036f2ef40d8e$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $a80b036f2ef40d8e$var$handleNumber(transaction[1]),
        gasLimit: $a80b036f2ef40d8e$var$handleNumber(transaction[2]),
        to: $a80b036f2ef40d8e$var$handleAddress(transaction[3]),
        value: $a80b036f2ef40d8e$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $kVZhy.BigNumber).from(transaction[6]).toNumber();
    } catch (error) {
        console.log(error);
        return tx;
    }
    tx.r = (0, $kniO8.hexZeroPad)(transaction[7], 32);
    tx.s = (0, $kniO8.hexZeroPad)(transaction[8], 32);
    if ((0, $kVZhy.BigNumber).from(tx.r).isZero() && (0, $kVZhy.BigNumber).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $kniO8.hexlify)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $jGTTU.keccak256)($3wc1X.encode(raw));
        try {
            tx.from = $a80b036f2ef40d8e$export$23cc18f96d8510e2(digest, {
                r: (0, $kniO8.hexlify)(tx.r),
                s: (0, $kniO8.hexlify)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {
            console.log(error);
        }
        tx.hash = (0, $jGTTU.keccak256)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $a80b036f2ef40d8e$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $kniO8.arrayify)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $a80b036f2ef40d8e$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $a80b036f2ef40d8e$var$_parseEip2930(payload);
        case 2:
            return $a80b036f2ef40d8e$var$_parseEip1559(payload);
        default:
            break;
    }
    return $a80b036f2ef40d8e$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}

});
parcelRegister("hZMsZ", function(module, exports) {

$parcel$export(module.exports, "SigningKey", () => $d19dba9fa6d35aec$export$21643ca94aed3e83);
$parcel$export(module.exports, "computePublicKey", () => $d19dba9fa6d35aec$export$4a89473d39301224);
$parcel$export(module.exports, "recoverPublicKey", () => $d19dba9fa6d35aec$export$952dd09fbe0232b7);

var $fQxuG = parcelRequire("fQxuG");

var $kniO8 = parcelRequire("kniO8");

var $7veey = parcelRequire("7veey");

var $l6EVj = parcelRequire("l6EVj");

var $3zSLU = parcelRequire("3zSLU");
"use strict";
const $d19dba9fa6d35aec$var$logger = new (0, $l6EVj.Logger)((0, $3zSLU.version));
let $d19dba9fa6d35aec$var$_curve = null;
function $d19dba9fa6d35aec$var$getCurve() {
    if (!$d19dba9fa6d35aec$var$_curve) $d19dba9fa6d35aec$var$_curve = new (0, $fQxuG.EC)("secp256k1");
    return $d19dba9fa6d35aec$var$_curve;
}
class $d19dba9fa6d35aec$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $7veey.defineReadOnly)(this, "curve", "secp256k1");
        (0, $7veey.defineReadOnly)(this, "privateKey", (0, $kniO8.hexlify)(privateKey));
        const keyPair = $d19dba9fa6d35aec$var$getCurve().keyFromPrivate((0, $kniO8.arrayify)(this.privateKey));
        (0, $7veey.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $7veey.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $7veey.defineReadOnly)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $d19dba9fa6d35aec$var$getCurve().keyFromPublic((0, $kniO8.arrayify)(this.publicKey));
        const p1 = $d19dba9fa6d35aec$var$getCurve().keyFromPublic((0, $kniO8.arrayify)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $d19dba9fa6d35aec$var$getCurve().keyFromPrivate((0, $kniO8.arrayify)(this.privateKey));
        const digestBytes = (0, $kniO8.arrayify)(digest);
        if (digestBytes.length !== 32) $d19dba9fa6d35aec$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $kniO8.splitSignature)({
            recoveryParam: signature.recoveryParam,
            r: (0, $kniO8.hexZeroPad)("0x" + signature.r.toString(16), 32),
            s: (0, $kniO8.hexZeroPad)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $d19dba9fa6d35aec$var$getCurve().keyFromPrivate((0, $kniO8.arrayify)(this.privateKey));
        const otherKeyPair = $d19dba9fa6d35aec$var$getCurve().keyFromPublic((0, $kniO8.arrayify)($d19dba9fa6d35aec$export$4a89473d39301224(otherKey)));
        return (0, $kniO8.hexZeroPad)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $d19dba9fa6d35aec$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $kniO8.splitSignature)(signature);
    const rs = {
        r: (0, $kniO8.arrayify)(sig.r),
        s: (0, $kniO8.arrayify)(sig.s)
    };
    return "0x" + $d19dba9fa6d35aec$var$getCurve().recoverPubKey((0, $kniO8.arrayify)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $d19dba9fa6d35aec$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $kniO8.arrayify)(key);
    if (bytes.length === 32) {
        const signingKey = new $d19dba9fa6d35aec$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $d19dba9fa6d35aec$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $kniO8.hexlify)(bytes);
        return "0x" + $d19dba9fa6d35aec$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $kniO8.hexlify)(bytes);
        return "0x" + $d19dba9fa6d35aec$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $d19dba9fa6d35aec$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}

});
parcelRegister("fQxuG", function(module, exports) {

$parcel$export(module.exports, "EC", () => $b895b18eb35fd21b$export$129fe12d32abc311);

var $aRmvy = parcelRequire("aRmvy");

var $kiSKt = parcelRequire("kiSKt");
var $b895b18eb35fd21b$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $b895b18eb35fd21b$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $b895b18eb35fd21b$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $b895b18eb35fd21b$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $b895b18eb35fd21b$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $b895b18eb35fd21b$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $b895b18eb35fd21b$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $b895b18eb35fd21b$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $b895b18eb35fd21b$var$minimalisticAssert = $b895b18eb35fd21b$var$assert;
function $b895b18eb35fd21b$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$b895b18eb35fd21b$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $b895b18eb35fd21b$var$utils_1 = $b895b18eb35fd21b$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $b895b18eb35fd21b$var$utils_1$1 = $b895b18eb35fd21b$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $b895b18eb35fd21b$var$minimalisticAssert;
    utils.toArray = $b895b18eb35fd21b$var$utils_1.toArray;
    utils.zero2 = $b895b18eb35fd21b$var$utils_1.zero2;
    utils.toHex = $b895b18eb35fd21b$var$utils_1.toHex;
    utils.encode = $b895b18eb35fd21b$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $b895b18eb35fd21b$var$getNAF = $b895b18eb35fd21b$var$utils_1$1.getNAF;
var $b895b18eb35fd21b$var$getJSF = $b895b18eb35fd21b$var$utils_1$1.getJSF;
var $b895b18eb35fd21b$var$assert$1 = $b895b18eb35fd21b$var$utils_1$1.assert;
function $b895b18eb35fd21b$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $b895b18eb35fd21b$var$base = $b895b18eb35fd21b$var$BaseCurve;
$b895b18eb35fd21b$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$b895b18eb35fd21b$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$b895b18eb35fd21b$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $b895b18eb35fd21b$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $b895b18eb35fd21b$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$b895b18eb35fd21b$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $b895b18eb35fd21b$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $b895b18eb35fd21b$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$b895b18eb35fd21b$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $b895b18eb35fd21b$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $b895b18eb35fd21b$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $b895b18eb35fd21b$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $b895b18eb35fd21b$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$b895b18eb35fd21b$var$BaseCurve.BasePoint = $b895b18eb35fd21b$var$BasePoint;
$b895b18eb35fd21b$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$b895b18eb35fd21b$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$b895b18eb35fd21b$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $b895b18eb35fd21b$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $b895b18eb35fd21b$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $b895b18eb35fd21b$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$b895b18eb35fd21b$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$b895b18eb35fd21b$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$b895b18eb35fd21b$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $b895b18eb35fd21b$var$utils_1$1.encode(this._encode(compact), enc);
};
$b895b18eb35fd21b$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$b895b18eb35fd21b$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$b895b18eb35fd21b$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$b895b18eb35fd21b$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$b895b18eb35fd21b$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$b895b18eb35fd21b$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $b895b18eb35fd21b$var$inherits_browser = $b895b18eb35fd21b$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $b895b18eb35fd21b$var$assert$2 = $b895b18eb35fd21b$var$utils_1$1.assert;
function $b895b18eb35fd21b$var$ShortCurve(conf) {
    $b895b18eb35fd21b$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$b895b18eb35fd21b$var$inherits_browser($b895b18eb35fd21b$var$ShortCurve, $b895b18eb35fd21b$var$base);
var $b895b18eb35fd21b$var$short_1 = $b895b18eb35fd21b$var$ShortCurve;
$b895b18eb35fd21b$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $b895b18eb35fd21b$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$b895b18eb35fd21b$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$b895b18eb35fd21b$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$b895b18eb35fd21b$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$b895b18eb35fd21b$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$b895b18eb35fd21b$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$b895b18eb35fd21b$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $b895b18eb35fd21b$var$Point(curve, x, y, isRed) {
    $b895b18eb35fd21b$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$b895b18eb35fd21b$var$inherits_browser($b895b18eb35fd21b$var$Point, $b895b18eb35fd21b$var$base.BasePoint);
$b895b18eb35fd21b$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $b895b18eb35fd21b$var$Point(this, x, y, isRed);
};
$b895b18eb35fd21b$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $b895b18eb35fd21b$var$Point.fromJSON(this, obj, red);
};
$b895b18eb35fd21b$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$b895b18eb35fd21b$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$b895b18eb35fd21b$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$b895b18eb35fd21b$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$b895b18eb35fd21b$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$b895b18eb35fd21b$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$b895b18eb35fd21b$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$b895b18eb35fd21b$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$b895b18eb35fd21b$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$b895b18eb35fd21b$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$b895b18eb35fd21b$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$b895b18eb35fd21b$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$b895b18eb35fd21b$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$b895b18eb35fd21b$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$b895b18eb35fd21b$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $b895b18eb35fd21b$var$JPoint(curve, x, y, z) {
    $b895b18eb35fd21b$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$b895b18eb35fd21b$var$inherits_browser($b895b18eb35fd21b$var$JPoint, $b895b18eb35fd21b$var$base.BasePoint);
$b895b18eb35fd21b$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $b895b18eb35fd21b$var$JPoint(this, x, y, z);
};
$b895b18eb35fd21b$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$b895b18eb35fd21b$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$b895b18eb35fd21b$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$b895b18eb35fd21b$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$b895b18eb35fd21b$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$b895b18eb35fd21b$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$b895b18eb35fd21b$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$b895b18eb35fd21b$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$b895b18eb35fd21b$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$b895b18eb35fd21b$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$b895b18eb35fd21b$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$b895b18eb35fd21b$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$b895b18eb35fd21b$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$b895b18eb35fd21b$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$b895b18eb35fd21b$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $b895b18eb35fd21b$var$curve_1 = $b895b18eb35fd21b$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $b895b18eb35fd21b$var$base;
    curve.short = $b895b18eb35fd21b$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $b895b18eb35fd21b$var$curves_1 = $b895b18eb35fd21b$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $b895b18eb35fd21b$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $b895b18eb35fd21b$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $b895b18eb35fd21b$var$curve_1.edwards(options);
        else this.curve = new $b895b18eb35fd21b$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $b895b18eb35fd21b$var$HmacDRBG(options) {
    if (!(this instanceof $b895b18eb35fd21b$var$HmacDRBG)) return new $b895b18eb35fd21b$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $b895b18eb35fd21b$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $b895b18eb35fd21b$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $b895b18eb35fd21b$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $b895b18eb35fd21b$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $b895b18eb35fd21b$var$hmacDrbg = $b895b18eb35fd21b$var$HmacDRBG;
$b895b18eb35fd21b$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$b895b18eb35fd21b$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).hmac(this.hash, this.K);
};
$b895b18eb35fd21b$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$b895b18eb35fd21b$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $b895b18eb35fd21b$var$utils_1.toArray(entropy, entropyEnc);
    add = $b895b18eb35fd21b$var$utils_1.toArray(add, addEnc);
    $b895b18eb35fd21b$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$b895b18eb35fd21b$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $b895b18eb35fd21b$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $b895b18eb35fd21b$var$utils_1.encode(res, enc);
};
"use strict";
var $b895b18eb35fd21b$var$assert$3 = $b895b18eb35fd21b$var$utils_1$1.assert;
function $b895b18eb35fd21b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $b895b18eb35fd21b$var$key = $b895b18eb35fd21b$var$KeyPair;
$b895b18eb35fd21b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $b895b18eb35fd21b$var$KeyPair) return pub;
    return new $b895b18eb35fd21b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$b895b18eb35fd21b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $b895b18eb35fd21b$var$KeyPair) return priv;
    return new $b895b18eb35fd21b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$b895b18eb35fd21b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$b895b18eb35fd21b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$b895b18eb35fd21b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$b895b18eb35fd21b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$b895b18eb35fd21b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $b895b18eb35fd21b$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $b895b18eb35fd21b$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$b895b18eb35fd21b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $b895b18eb35fd21b$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$b895b18eb35fd21b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$b895b18eb35fd21b$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$b895b18eb35fd21b$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $b895b18eb35fd21b$var$assert$4 = $b895b18eb35fd21b$var$utils_1$1.assert;
function $b895b18eb35fd21b$var$Signature(options, enc) {
    if (options instanceof $b895b18eb35fd21b$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $b895b18eb35fd21b$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $b895b18eb35fd21b$var$signature = $b895b18eb35fd21b$var$Signature;
function $b895b18eb35fd21b$var$Position() {
    this.place = 0;
}
function $b895b18eb35fd21b$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $b895b18eb35fd21b$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$b895b18eb35fd21b$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $b895b18eb35fd21b$var$utils_1$1.toArray(data, enc);
    var p = new $b895b18eb35fd21b$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $b895b18eb35fd21b$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $b895b18eb35fd21b$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $b895b18eb35fd21b$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(s);
    this.recoveryParam = null;
    return true;
};
function $b895b18eb35fd21b$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$b895b18eb35fd21b$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $b895b18eb35fd21b$var$rmPadding(r);
    s = $b895b18eb35fd21b$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $b895b18eb35fd21b$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $b895b18eb35fd21b$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $b895b18eb35fd21b$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $b895b18eb35fd21b$var$utils_1$1.encode(res, enc);
};
"use strict";
var $b895b18eb35fd21b$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $b895b18eb35fd21b$var$assert$5 = $b895b18eb35fd21b$var$utils_1$1.assert;
function $b895b18eb35fd21b$var$EC(options) {
    if (!(this instanceof $b895b18eb35fd21b$var$EC)) return new $b895b18eb35fd21b$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $b895b18eb35fd21b$var$assert$5(Object.prototype.hasOwnProperty.call($b895b18eb35fd21b$var$curves_1, options), "Unknown curve " + options);
        options = $b895b18eb35fd21b$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $b895b18eb35fd21b$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $b895b18eb35fd21b$var$ec = $b895b18eb35fd21b$var$EC;
$b895b18eb35fd21b$var$EC.prototype.keyPair = function keyPair(options) {
    return new $b895b18eb35fd21b$var$key(this, options);
};
$b895b18eb35fd21b$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $b895b18eb35fd21b$var$key.fromPrivate(this, priv, enc);
};
$b895b18eb35fd21b$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $b895b18eb35fd21b$var$key.fromPublic(this, pub, enc);
};
$b895b18eb35fd21b$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $b895b18eb35fd21b$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $b895b18eb35fd21b$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$b895b18eb35fd21b$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$b895b18eb35fd21b$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $b895b18eb35fd21b$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $b895b18eb35fd21b$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$b895b18eb35fd21b$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $b895b18eb35fd21b$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$b895b18eb35fd21b$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $b895b18eb35fd21b$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $b895b18eb35fd21b$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($aRmvy)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$b895b18eb35fd21b$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $b895b18eb35fd21b$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $b895b18eb35fd21b$var$elliptic_1 = $b895b18eb35fd21b$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $b895b18eb35fd21b$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $b895b18eb35fd21b$var$curve_1;
    elliptic.curves = $b895b18eb35fd21b$var$curves_1;
    // Protocols
    elliptic.ec = $b895b18eb35fd21b$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $b895b18eb35fd21b$export$129fe12d32abc311 = $b895b18eb35fd21b$var$elliptic_1.ec;

});
parcelRegister("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});


parcelRegister("3zSLU", function(module, exports) {

$parcel$export(module.exports, "version", () => $29af207b06d0d727$export$83d89fbfd8236492);
const $29af207b06d0d727$export$83d89fbfd8236492 = "signing-key/5.5.0";

});


parcelRegister("1fEKo", function(module, exports) {

$parcel$export(module.exports, "version", () => $0e96ccb49bc5d1eb$export$83d89fbfd8236492);
const $0e96ccb49bc5d1eb$export$83d89fbfd8236492 = "transactions/5.5.0";

});


parcelRegister("3A3Wy", function(module, exports) {

$parcel$export(module.exports, "version", () => $29b7caf96f104cea$export$83d89fbfd8236492);
const $29b7caf96f104cea$export$83d89fbfd8236492 = "contracts/5.5.0";

});


parcelRegister("hNSak", function(module, exports) {

$parcel$export(module.exports, "formatFixed", () => $cf6107726cf6eae2$export$cc011b843b5d69f2);
$parcel$export(module.exports, "parseFixed", () => $cf6107726cf6eae2$export$1b039987e86d7269);
$parcel$export(module.exports, "FixedNumber", () => $cf6107726cf6eae2$export$d4693c66c2213e45);

var $kniO8 = parcelRequire("kniO8");

var $l6EVj = parcelRequire("l6EVj");

var $9D1ea = parcelRequire("9D1ea");

var $kVZhy = parcelRequire("kVZhy");
"use strict";
const $cf6107726cf6eae2$var$logger = new (0, $l6EVj.Logger)((0, $9D1ea.version));
const $cf6107726cf6eae2$var$_constructorGuard = {};
const $cf6107726cf6eae2$var$Zero = (0, $kVZhy.BigNumber).from(0);
const $cf6107726cf6eae2$var$NegativeOne = (0, $kVZhy.BigNumber).from(-1);
function $cf6107726cf6eae2$var$throwFault(message, fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $cf6107726cf6eae2$var$logger.throwError(message, (0, $l6EVj.Logger).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let $cf6107726cf6eae2$var$zeros = "0";
while($cf6107726cf6eae2$var$zeros.length < 256)$cf6107726cf6eae2$var$zeros += $cf6107726cf6eae2$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $cf6107726cf6eae2$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $kVZhy.BigNumber).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $cf6107726cf6eae2$var$zeros.substring(0, decimals);
    return $cf6107726cf6eae2$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $cf6107726cf6eae2$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $cf6107726cf6eae2$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $kVZhy.BigNumber).from(value);
    const negative = value.lt($cf6107726cf6eae2$var$Zero);
    if (negative) value = value.mul($cf6107726cf6eae2$var$NegativeOne);
    let fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $cf6107726cf6eae2$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $cf6107726cf6eae2$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $cf6107726cf6eae2$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    const negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $cf6107726cf6eae2$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) $cf6107726cf6eae2$var$logger.throwArgumentError("too many decimal points", "value", value);
    let whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $cf6107726cf6eae2$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    const wholeValue = (0, $kVZhy.BigNumber).from(whole);
    const fractionValue = (0, $kVZhy.BigNumber).from(fraction);
    let wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($cf6107726cf6eae2$var$NegativeOne);
    return wei;
}
class $cf6107726cf6eae2$export$1f3ec5b8f47ebd4d {
    constructor(constructorGuard, signed, width, decimals){
        if (constructorGuard !== $cf6107726cf6eae2$var$_constructorGuard) $cf6107726cf6eae2$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $cf6107726cf6eae2$var$getMultiplier(decimals);
        Object.freeze(this);
    }
    static from(value) {
        if (value instanceof $cf6107726cf6eae2$export$1f3ec5b8f47ebd4d) return value;
        if (typeof value === "number") value = `fixed128x${value}`;
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof value === "string") {
            if (value === "fixed") ;
            else if (value === "ufixed") signed = false;
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) $cf6107726cf6eae2$var$logger.throwArgumentError("invalid fixed format", "format", value);
                signed = match[1] !== "u";
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        } else if (value) {
            const check = (key, type, defaultValue)=>{
                if (value[key] == null) return defaultValue;
                if (typeof value[key] !== type) $cf6107726cf6eae2$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) $cf6107726cf6eae2$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        if (decimals > 80) $cf6107726cf6eae2$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        return new $cf6107726cf6eae2$export$1f3ec5b8f47ebd4d($cf6107726cf6eae2$var$_constructorGuard, signed, width, decimals);
    }
}
class $cf6107726cf6eae2$export$d4693c66c2213e45 {
    constructor(constructorGuard, hex, value, format){
        $cf6107726cf6eae2$var$logger.checkNew(new.target, $cf6107726cf6eae2$export$d4693c66c2213e45);
        if (constructorGuard !== $cf6107726cf6eae2$var$_constructorGuard) $cf6107726cf6eae2$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    _checkFormat(other) {
        if (this.format.name !== other.format.name) $cf6107726cf6eae2$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = $cf6107726cf6eae2$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $cf6107726cf6eae2$export$1b039987e86d7269(other._value, other.format.decimals);
        return $cf6107726cf6eae2$export$d4693c66c2213e45.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = $cf6107726cf6eae2$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $cf6107726cf6eae2$export$1b039987e86d7269(other._value, other.format.decimals);
        return $cf6107726cf6eae2$export$d4693c66c2213e45.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = $cf6107726cf6eae2$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $cf6107726cf6eae2$export$1b039987e86d7269(other._value, other.format.decimals);
        return $cf6107726cf6eae2$export$d4693c66c2213e45.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = $cf6107726cf6eae2$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $cf6107726cf6eae2$export$1b039987e86d7269(other._value, other.format.decimals);
        return $cf6107726cf6eae2$export$d4693c66c2213e45.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $cf6107726cf6eae2$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) result = result.subUnsafe($cf6107726cf6eae2$var$ONE.toFormat(result.format));
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $cf6107726cf6eae2$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) result = result.addUnsafe($cf6107726cf6eae2$var$ONE.toFormat(result.format));
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) decimals = 0;
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        if (decimals < 0 || decimals > 80 || decimals % 1) $cf6107726cf6eae2$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        if (comps[1].length <= decimals) return this;
        const factor = $cf6107726cf6eae2$export$d4693c66c2213e45.from("1" + $cf6107726cf6eae2$var$zeros.substring(0, decimals), this.format);
        const bump = $cf6107726cf6eae2$var$BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(width) {
        if (width == null) return this._hex;
        if (width % 8) $cf6107726cf6eae2$var$logger.throwArgumentError("invalid byte width", "width", width);
        const hex = (0, $kVZhy.BigNumber).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return (0, $kniO8.hexZeroPad)(hex, width / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(format) {
        return $cf6107726cf6eae2$export$d4693c66c2213e45.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !(0, $kVZhy.isBigNumberish)(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) decimals = 0;
        if (format == null) format = "fixed";
        return $cf6107726cf6eae2$export$d4693c66c2213e45.fromString($cf6107726cf6eae2$export$cc011b843b5d69f2(value, decimals), $cf6107726cf6eae2$export$1f3ec5b8f47ebd4d.from(format));
    }
    static fromString(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $cf6107726cf6eae2$export$1f3ec5b8f47ebd4d.from(format);
        const numeric = $cf6107726cf6eae2$export$1b039987e86d7269(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt($cf6107726cf6eae2$var$Zero)) $cf6107726cf6eae2$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
        let hex = null;
        if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
        else {
            hex = numeric.toHexString();
            hex = (0, $kniO8.hexZeroPad)(hex, fixedFormat.width / 8);
        }
        const decimal = $cf6107726cf6eae2$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $cf6107726cf6eae2$export$d4693c66c2213e45($cf6107726cf6eae2$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $cf6107726cf6eae2$export$1f3ec5b8f47ebd4d.from(format);
        if ((0, $kniO8.arrayify)(value).length > fixedFormat.width / 8) throw new Error("overflow");
        let numeric = (0, $kVZhy.BigNumber).from(value);
        if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = $cf6107726cf6eae2$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $cf6107726cf6eae2$export$d4693c66c2213e45($cf6107726cf6eae2$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof value === "string") return $cf6107726cf6eae2$export$d4693c66c2213e45.fromString(value, format);
        if ((0, $kniO8.isBytes)(value)) return $cf6107726cf6eae2$export$d4693c66c2213e45.fromBytes(value, format);
        try {
            return $cf6107726cf6eae2$export$d4693c66c2213e45.fromValue(value, 0, format);
        } catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== (0, $l6EVj.Logger).errors.INVALID_ARGUMENT) throw error;
        }
        return $cf6107726cf6eae2$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
}
const $cf6107726cf6eae2$var$ONE = $cf6107726cf6eae2$export$d4693c66c2213e45.from(1);
const $cf6107726cf6eae2$var$BUMP = $cf6107726cf6eae2$export$d4693c66c2213e45.from("0.5");

});

parcelRegister("bNCEM", function(module, exports) {

$parcel$export(module.exports, "Wallet", () => $897241be277c01dc$export$bcca3ea514774656);
$parcel$export(module.exports, "verifyMessage", () => $897241be277c01dc$export$228d0e772cc158cb);
$parcel$export(module.exports, "verifyTypedData", () => $897241be277c01dc$export$3603b1c1bcd76798);

var $1qOxQ = parcelRequire("1qOxQ");

var $hMfVR = parcelRequire("hMfVR");

var $lLoTq = parcelRequire("lLoTq");

var $kniO8 = parcelRequire("kniO8");

var $ktAWM = parcelRequire("ktAWM");
var $4oRy9 = parcelRequire("4oRy9");

var $jURra = parcelRequire("jURra");

var $jGTTU = parcelRequire("jGTTU");

var $7veey = parcelRequire("7veey");

var $82eL2 = parcelRequire("82eL2");

var $hZMsZ = parcelRequire("hZMsZ");

var $2vAOQ = parcelRequire("2vAOQ");
var $3c0Hw = parcelRequire("3c0Hw");

var $equjW = parcelRequire("equjW");

var $l6EVj = parcelRequire("l6EVj");

var $khYbT = parcelRequire("khYbT");
"use strict";
var $897241be277c01dc$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $897241be277c01dc$var$logger = new (0, $l6EVj.Logger)((0, $khYbT.version));
function $897241be277c01dc$var$isAccount(value) {
    return value != null && (0, $kniO8.isHexString)(value.privateKey, 32) && value.address != null;
}
function $897241be277c01dc$var$hasMnemonic(value) {
    const mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
class $897241be277c01dc$export$bcca3ea514774656 extends (0, $lLoTq.Signer) {
    constructor(privateKey, provider){
        $897241be277c01dc$var$logger.checkNew(new.target, $897241be277c01dc$export$bcca3ea514774656);
        super();
        if ($897241be277c01dc$var$isAccount(privateKey)) {
            const signingKey = new (0, $hZMsZ.SigningKey)(privateKey.privateKey);
            (0, $7veey.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            (0, $7veey.defineReadOnly)(this, "address", (0, $equjW.computeAddress)(this.publicKey));
            if (this.address !== (0, $1qOxQ.getAddress)(privateKey.address)) $897241be277c01dc$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($897241be277c01dc$var$hasMnemonic(privateKey)) {
                const srcMnemonic = privateKey.mnemonic;
                (0, $7veey.defineReadOnly)(this, "_mnemonic", ()=>({
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $jURra.defaultPath),
                        locale: srcMnemonic.locale || "en"
                    }));
                const mnemonic = this.mnemonic;
                const node = (0, $jURra.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $equjW.computeAddress)(node.privateKey) !== this.address) $897241be277c01dc$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $7veey.defineReadOnly)(this, "_mnemonic", ()=>null);
        } else {
            if ((0, $hZMsZ.SigningKey).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $897241be277c01dc$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $7veey.defineReadOnly)(this, "_signingKey", ()=>privateKey);
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                const signingKey = new (0, $hZMsZ.SigningKey)(privateKey);
                (0, $7veey.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            }
            (0, $7veey.defineReadOnly)(this, "_mnemonic", ()=>null);
            (0, $7veey.defineReadOnly)(this, "address", (0, $equjW.computeAddress)(this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $hMfVR.Provider).isProvider(provider)) $897241be277c01dc$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $7veey.defineReadOnly)(this, "provider", provider || null);
    }
    get mnemonic() {
        return this._mnemonic();
    }
    get privateKey() {
        return this._signingKey().privateKey;
    }
    get publicKey() {
        return this._signingKey().publicKey;
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    connect(provider) {
        return new $897241be277c01dc$export$bcca3ea514774656(this, provider);
    }
    signTransaction(transaction) {
        return (0, $7veey.resolveProperties)(transaction).then((tx)=>{
            if (tx.from != null) {
                if ((0, $1qOxQ.getAddress)(tx.from) !== this.address) $897241be277c01dc$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                delete tx.from;
            }
            const signature = this._signingKey().signDigest((0, $jGTTU.keccak256)((0, $equjW.serialize)(tx)));
            return (0, $equjW.serialize)(tx, signature);
        });
    }
    signMessage(message) {
        return $897241be277c01dc$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $kniO8.joinSignature)(this._signingKey().signDigest((0, $ktAWM.hashMessage)(message)));
        });
    }
    _signTypedData(domain, types, value) {
        return $897241be277c01dc$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names
            const populated = yield (0, $4oRy9.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                if (this.provider == null) $897241be277c01dc$var$logger.throwError("cannot resolve ENS names without a provider", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "resolveName",
                    value: name
                });
                return this.provider.resolveName(name);
            });
            return (0, $kniO8.joinSignature)(this._signingKey().signDigest((0, $4oRy9.TypedDataEncoder).hash(populated.domain, types, populated.value)));
        });
    }
    encrypt(password, options, progressCallback) {
        if (typeof options === "function" && !progressCallback) {
            progressCallback = options;
            options = {};
        }
        if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
        if (!options) options = {};
        return (0, $2vAOQ.encrypt)(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */ static createRandom(options) {
        let entropy = (0, $82eL2.randomBytes)(16);
        if (!options) options = {};
        if (options.extraEntropy) entropy = (0, $kniO8.arrayify)((0, $kniO8.hexDataSlice)((0, $jGTTU.keccak256)((0, $kniO8.concat)([
            entropy,
            options.extraEntropy
        ])), 0, 16));
        const mnemonic = (0, $jURra.entropyToMnemonic)(entropy, options.locale);
        return $897241be277c01dc$export$bcca3ea514774656.fromMnemonic(mnemonic, options.path, options.locale);
    }
    static fromEncryptedJson(json, password, progressCallback) {
        return (0, $3c0Hw.decryptJsonWallet)(json, password, progressCallback).then((account)=>{
            return new $897241be277c01dc$export$bcca3ea514774656(account);
        });
    }
    static fromEncryptedJsonSync(json, password) {
        return new $897241be277c01dc$export$bcca3ea514774656((0, $3c0Hw.decryptJsonWalletSync)(json, password));
    }
    static fromMnemonic(mnemonic, path, wordlist) {
        if (!path) path = (0, $jURra.defaultPath);
        return new $897241be277c01dc$export$bcca3ea514774656((0, $jURra.HDNode).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
}
function $897241be277c01dc$export$228d0e772cc158cb(message, signature) {
    return (0, $equjW.recoverAddress)((0, $ktAWM.hashMessage)(message), signature);
}
function $897241be277c01dc$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $equjW.recoverAddress)((0, $4oRy9.TypedDataEncoder).hash(domain, types, value), signature);
}

});
parcelRegister("ktAWM", function(module, exports) {

$parcel$export(module.exports, "hashMessage", () => $ee832d004e91231e$export$d4c241cec96564c1);

var $kniO8 = parcelRequire("kniO8");

var $jGTTU = parcelRequire("jGTTU");

var $1z44X = parcelRequire("1z44X");
const $ee832d004e91231e$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $ee832d004e91231e$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $1z44X.toUtf8Bytes)(message);
    return (0, $jGTTU.keccak256)((0, $kniO8.concat)([
        (0, $1z44X.toUtf8Bytes)($ee832d004e91231e$export$1ff3fdc4802a2ba6),
        (0, $1z44X.toUtf8Bytes)(String(message.length)),
        message
    ]));
}

});

parcelRegister("4oRy9", function(module, exports) {

$parcel$export(module.exports, "TypedDataEncoder", () => $3342f13130e6a70f$export$458ab927ae635c3);

var $1qOxQ = parcelRequire("1qOxQ");

var $kVZhy = parcelRequire("kVZhy");

var $kniO8 = parcelRequire("kniO8");

var $jGTTU = parcelRequire("jGTTU");

var $7veey = parcelRequire("7veey");

var $l6EVj = parcelRequire("l6EVj");

var $l1Hdc = parcelRequire("l1Hdc");

var $bnVEQ = parcelRequire("bnVEQ");
var $3342f13130e6a70f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $3342f13130e6a70f$var$logger = new (0, $l6EVj.Logger)((0, $l1Hdc.version));
const $3342f13130e6a70f$var$padding = new Uint8Array(32);
$3342f13130e6a70f$var$padding.fill(0);
const $3342f13130e6a70f$var$NegativeOne = (0, $kVZhy.BigNumber).from(-1);
const $3342f13130e6a70f$var$Zero = (0, $kVZhy.BigNumber).from(0);
const $3342f13130e6a70f$var$One = (0, $kVZhy.BigNumber).from(1);
const $3342f13130e6a70f$var$MaxUint256 = (0, $kVZhy.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $3342f13130e6a70f$var$hexPadRight(value) {
    const bytes = (0, $kniO8.arrayify)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $kniO8.hexConcat)([
        bytes,
        $3342f13130e6a70f$var$padding.slice(padOffset)
    ]);
    return (0, $kniO8.hexlify)(bytes);
}
const $3342f13130e6a70f$var$hexTrue = (0, $kniO8.hexZeroPad)($3342f13130e6a70f$var$One.toHexString(), 32);
const $3342f13130e6a70f$var$hexFalse = (0, $kniO8.hexZeroPad)($3342f13130e6a70f$var$Zero.toHexString(), 32);
const $3342f13130e6a70f$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $3342f13130e6a70f$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $3342f13130e6a70f$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $3342f13130e6a70f$var$logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $3342f13130e6a70f$var$domainChecks = {
    name: $3342f13130e6a70f$var$checkString("name"),
    version: $3342f13130e6a70f$var$checkString("version"),
    chainId: function(value) {
        try {
            return (0, $kVZhy.BigNumber).from(value).toString();
        } catch (error) {}
        return $3342f13130e6a70f$var$logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $1qOxQ.getAddress)(value).toLowerCase();
        } catch (error) {}
        return $3342f13130e6a70f$var$logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        try {
            const bytes = (0, $kniO8.arrayify)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $kniO8.hexlify)(bytes);
        } catch (error) {}
        return $3342f13130e6a70f$var$logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function $3342f13130e6a70f$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $3342f13130e6a70f$var$logger.throwArgumentError("invalid numeric width", "type", type);
            const boundsUpper = $3342f13130e6a70f$var$MaxUint256.mask(signed ? width - 1 : width);
            const boundsLower = signed ? boundsUpper.add($3342f13130e6a70f$var$One).mul($3342f13130e6a70f$var$NegativeOne) : $3342f13130e6a70f$var$Zero;
            return function(value) {
                const v = (0, $kVZhy.BigNumber).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $3342f13130e6a70f$var$logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                return (0, $kniO8.hexZeroPad)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) $3342f13130e6a70f$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $kniO8.arrayify)(value);
                if (bytes.length !== width) $3342f13130e6a70f$var$logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                return $3342f13130e6a70f$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $kniO8.hexZeroPad)((0, $1qOxQ.getAddress)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $3342f13130e6a70f$var$hexFalse : $3342f13130e6a70f$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $jGTTU.keccak256)(value);
            };
        case "string":
            return function(value) {
                return (0, $bnVEQ.id)(value);
            };
    }
    return null;
}
function $3342f13130e6a70f$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
class $3342f13130e6a70f$export$458ab927ae635c3 {
    constructor(types){
        (0, $7veey.defineReadOnly)(this, "types", Object.freeze((0, $7veey.deepCopy)(types)));
        (0, $7veey.defineReadOnly)(this, "_encoderCache", {});
        (0, $7veey.defineReadOnly)(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type)=>{
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(const name in types){
            const uniqueNames = {};
            types[name].forEach((field)=>{
                // Check each field has a unique name
                if (uniqueNames[field.name]) $3342f13130e6a70f$var$logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $3342f13130e6a70f$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                // Is this a base encoding type?
                const encoder = $3342f13130e6a70f$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $3342f13130e6a70f$var$logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n)=>parents[n].length === 0);
        if (primaryTypes.length === 0) $3342f13130e6a70f$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $3342f13130e6a70f$var$logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", types);
        (0, $7veey.defineReadOnly)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $3342f13130e6a70f$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach((child)=>{
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype)=>{
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(const name in subtypes){
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = $3342f13130e6a70f$var$encodeType(name, types[name]) + st.map((t)=>$3342f13130e6a70f$var$encodeType(t, types[t])).join("");
        }
    }
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $3342f13130e6a70f$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value)=>{
                if (length >= 0 && value.length !== length) $3342f13130e6a70f$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                let result = value.map(subEncoder);
                if (this._types[subtype]) result = result.map((0, $jGTTU.keccak256));
                return (0, $jGTTU.keccak256)((0, $kniO8.hexConcat)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $bnVEQ.id)(this._types[type]);
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) return (0, $jGTTU.keccak256)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $kniO8.hexConcat)(values);
            };
        }
        return $3342f13130e6a70f$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) $3342f13130e6a70f$var$logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return (0, $jGTTU.keccak256)(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $3342f13130e6a70f$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) $3342f13130e6a70f$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            return value.map((v)=>this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        return $3342f13130e6a70f$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new $3342f13130e6a70f$export$458ab927ae635c3(types);
    }
    static getPrimaryType(types) {
        return $3342f13130e6a70f$export$458ab927ae635c3.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return $3342f13130e6a70f$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            const type = $3342f13130e6a70f$var$domainFieldTypes[name];
            if (!type) $3342f13130e6a70f$var$logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $3342f13130e6a70f$var$domainFieldNames.indexOf(a.name) - $3342f13130e6a70f$var$domainFieldNames.indexOf(b.name);
        });
        return $3342f13130e6a70f$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    static encode(domain, types, value) {
        return (0, $kniO8.hexConcat)([
            "0x1901",
            $3342f13130e6a70f$export$458ab927ae635c3.hashDomain(domain),
            $3342f13130e6a70f$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return (0, $jGTTU.keccak256)($3342f13130e6a70f$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return $3342f13130e6a70f$var$__awaiter(this, void 0, void 0, function*() {
            // Make a copy to isolate it from the object passed in
            domain = (0, $7veey.shallowCopy)(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !(0, $kniO8.isHexString)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
            // We are going to use the encoder to visit all the base values
            const encoder = $3342f13130e6a70f$export$458ab927ae635c3.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value)=>{
                if (type === "address" && !(0, $kniO8.isHexString)(value, 20)) ensCache[value] = "0x";
                return value;
            });
            // Lookup each name
            for(const name in ensCache)ensCache[name] = yield resolveName(name);
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value)=>{
                if (type === "address" && ensCache[value]) return ensCache[value];
                return value;
            });
            return {
                domain: domain,
                value: value
            };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        $3342f13130e6a70f$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $3342f13130e6a70f$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $3342f13130e6a70f$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $3342f13130e6a70f$var$domainFieldTypes[name]
            });
        });
        const encoder = $3342f13130e6a70f$export$458ab927ae635c3.from(types);
        const typesWithDomain = (0, $7veey.shallowCopy)(types);
        if (typesWithDomain.EIP712Domain) $3342f13130e6a70f$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        else typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $kniO8.hexlify)((0, $kniO8.arrayify)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $kVZhy.BigNumber).from(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof value !== "string") $3342f13130e6a70f$var$logger.throwArgumentError(`invalid string`, "value", value);
                        return value;
                }
                return $3342f13130e6a70f$var$logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
}

});
parcelRegister("l1Hdc", function(module, exports) {

$parcel$export(module.exports, "version", () => $f4eb35f0ac698fd9$export$83d89fbfd8236492);
const $f4eb35f0ac698fd9$export$83d89fbfd8236492 = "hash/5.5.0";

});


parcelRegister("jURra", function(module, exports) {

$parcel$export(module.exports, "defaultPath", () => $e7fcb2d04f475fa5$export$d48ad89f7e11a603);
$parcel$export(module.exports, "HDNode", () => $e7fcb2d04f475fa5$export$b68640c53e22b952);
$parcel$export(module.exports, "entropyToMnemonic", () => $e7fcb2d04f475fa5$export$4becd65eb23312e6);
$parcel$export(module.exports, "mnemonicToEntropy", () => $e7fcb2d04f475fa5$export$135e090d58b310ca);
$parcel$export(module.exports, "mnemonicToSeed", () => $e7fcb2d04f475fa5$export$3dee74f1204ab09f);
$parcel$export(module.exports, "isValidMnemonic", () => $e7fcb2d04f475fa5$export$5eea3393c6119c80);
$parcel$export(module.exports, "getAccountPath", () => $e7fcb2d04f475fa5$export$22b80e4f9eff636d);

var $lepF3 = parcelRequire("lepF3");

var $kniO8 = parcelRequire("kniO8");

var $kVZhy = parcelRequire("kVZhy");

var $1z44X = parcelRequire("1z44X");

var $4poWL = parcelRequire("4poWL");

var $7veey = parcelRequire("7veey");

var $hZMsZ = parcelRequire("hZMsZ");

var $3QUg5 = parcelRequire("3QUg5");
var $a6Cmu = parcelRequire("a6Cmu");

var $equjW = parcelRequire("equjW");

var $katF7 = parcelRequire("katF7");

var $l6EVj = parcelRequire("l6EVj");

var $bI278 = parcelRequire("bI278");
"use strict";
const $e7fcb2d04f475fa5$var$logger = new (0, $l6EVj.Logger)((0, $bI278.version));
const $e7fcb2d04f475fa5$var$N = (0, $kVZhy.BigNumber).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
const $e7fcb2d04f475fa5$var$MasterSecret = (0, $1z44X.toUtf8Bytes)("Bitcoin seed");
const $e7fcb2d04f475fa5$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $e7fcb2d04f475fa5$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $e7fcb2d04f475fa5$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $e7fcb2d04f475fa5$var$bytes32(value) {
    return (0, $kniO8.hexZeroPad)((0, $kniO8.hexlify)(value), 32);
}
function $e7fcb2d04f475fa5$var$base58check(data) {
    return (0, $lepF3.Base58).encode((0, $kniO8.concat)([
        data,
        (0, $kniO8.hexDataSlice)((0, $3QUg5.sha256)((0, $3QUg5.sha256)(data)), 0, 4)
    ]));
}
function $e7fcb2d04f475fa5$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $katF7.wordlists)["en"];
    if (typeof wordlist === "string") {
        const words = (0, $katF7.wordlists)[wordlist];
        if (words == null) $e7fcb2d04f475fa5$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
const $e7fcb2d04f475fa5$var$_constructorGuard = {};
const $e7fcb2d04f475fa5$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
class $e7fcb2d04f475fa5$export$b68640c53e22b952 {
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */ constructor(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath){
        $e7fcb2d04f475fa5$var$logger.checkNew(new.target, $e7fcb2d04f475fa5$export$b68640c53e22b952);
        /* istanbul ignore if */ if (constructorGuard !== $e7fcb2d04f475fa5$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            const signingKey = new (0, $hZMsZ.SigningKey)(privateKey);
            (0, $7veey.defineReadOnly)(this, "privateKey", signingKey.privateKey);
            (0, $7veey.defineReadOnly)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $7veey.defineReadOnly)(this, "privateKey", null);
            (0, $7veey.defineReadOnly)(this, "publicKey", (0, $kniO8.hexlify)(publicKey));
        }
        (0, $7veey.defineReadOnly)(this, "parentFingerprint", parentFingerprint);
        (0, $7veey.defineReadOnly)(this, "fingerprint", (0, $kniO8.hexDataSlice)((0, $3QUg5.ripemd160)((0, $3QUg5.sha256)(this.publicKey)), 0, 4));
        (0, $7veey.defineReadOnly)(this, "address", (0, $equjW.computeAddress)(this.publicKey));
        (0, $7veey.defineReadOnly)(this, "chainCode", chainCode);
        (0, $7veey.defineReadOnly)(this, "index", index);
        (0, $7veey.defineReadOnly)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $7veey.defineReadOnly)(this, "mnemonic", null);
            (0, $7veey.defineReadOnly)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $7veey.defineReadOnly)(this, "mnemonic", null);
            (0, $7veey.defineReadOnly)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $7veey.defineReadOnly)(this, "mnemonic", mnemonicOrPath);
            (0, $7veey.defineReadOnly)(this, "path", mnemonicOrPath.path);
        }
    }
    get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        if (this.depth >= 256) throw new Error("Depth too large!");
        return $e7fcb2d04f475fa5$var$base58check((0, $kniO8.concat)([
            this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
            (0, $kniO8.hexlify)(this.depth),
            this.parentFingerprint,
            (0, $kniO8.hexZeroPad)((0, $kniO8.hexlify)(this.index), 4),
            this.chainCode,
            this.privateKey != null ? (0, $kniO8.concat)([
                "0x00",
                this.privateKey
            ]) : this.publicKey
        ]));
    }
    neuter() {
        return new $e7fcb2d04f475fa5$export$b68640c53e22b952($e7fcb2d04f475fa5$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
    }
    _derive(index) {
        if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
        // Base path
        let path = this.path;
        if (path) path += "/" + (index & ~$e7fcb2d04f475fa5$var$HardenedBit);
        const data = new Uint8Array(37);
        if (index & $e7fcb2d04f475fa5$var$HardenedBit) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            // Data = 0x00 || ser_256(k_par)
            data.set((0, $kniO8.arrayify)(this.privateKey), 1);
            // Hardened path
            if (path) path += "'";
        } else // Data = ser_p(point(k_par))
        data.set((0, $kniO8.arrayify)(this.publicKey));
        // Data += ser_32(i)
        for(let i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
        const I = (0, $kniO8.arrayify)((0, $3QUg5.computeHmac)((0, $a6Cmu.SupportedAlgorithm).sha512, this.chainCode, data));
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // The private key
        let ki = null;
        // The public key
        let Ki = null;
        if (this.privateKey) ki = $e7fcb2d04f475fa5$var$bytes32((0, $kVZhy.BigNumber).from(IL).add(this.privateKey).mod($e7fcb2d04f475fa5$var$N));
        else {
            const ek = new (0, $hZMsZ.SigningKey)((0, $kniO8.hexlify)(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        let mnemonicOrPath = path;
        const srcMnemonic = this.mnemonic;
        if (srcMnemonic) mnemonicOrPath = Object.freeze({
            phrase: srcMnemonic.phrase,
            path: path,
            locale: srcMnemonic.locale || "en"
        });
        return new $e7fcb2d04f475fa5$export$b68640c53e22b952($e7fcb2d04f475fa5$var$_constructorGuard, ki, Ki, this.fingerprint, $e7fcb2d04f475fa5$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
    }
    derivePath(path) {
        const components = path.split("/");
        if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
        if (components[0] === "m") components.shift();
        let result = this;
        for(let i = 0; i < components.length; i++){
            const component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                const index = parseInt(component.substring(0, component.length - 1));
                if (index >= $e7fcb2d04f475fa5$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive($e7fcb2d04f475fa5$var$HardenedBit + index);
            } else if (component.match(/^[0-9]+$/)) {
                const index = parseInt(component);
                if (index >= $e7fcb2d04f475fa5$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive(index);
            } else throw new Error("invalid path component - " + component);
        }
        return result;
    }
    static _fromSeed(seed, mnemonic) {
        const seedArray = (0, $kniO8.arrayify)(seed);
        if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
        const I = (0, $kniO8.arrayify)((0, $3QUg5.computeHmac)((0, $a6Cmu.SupportedAlgorithm).sha512, $e7fcb2d04f475fa5$var$MasterSecret, seedArray));
        return new $e7fcb2d04f475fa5$export$b68640c53e22b952($e7fcb2d04f475fa5$var$_constructorGuard, $e7fcb2d04f475fa5$var$bytes32(I.slice(0, 32)), null, "0x00000000", $e7fcb2d04f475fa5$var$bytes32(I.slice(32)), 0, 0, mnemonic);
    }
    static fromMnemonic(mnemonic, password, wordlist) {
        // If a locale name was passed in, find the associated wordlist
        wordlist = $e7fcb2d04f475fa5$var$getWordlist(wordlist);
        // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
        mnemonic = $e7fcb2d04f475fa5$export$4becd65eb23312e6($e7fcb2d04f475fa5$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
        return $e7fcb2d04f475fa5$export$b68640c53e22b952._fromSeed($e7fcb2d04f475fa5$export$3dee74f1204ab09f(mnemonic, password), {
            phrase: mnemonic,
            path: "m",
            locale: wordlist.locale
        });
    }
    static fromSeed(seed) {
        return $e7fcb2d04f475fa5$export$b68640c53e22b952._fromSeed(seed, null);
    }
    static fromExtendedKey(extendedKey) {
        const bytes = (0, $lepF3.Base58).decode(extendedKey);
        if (bytes.length !== 82 || $e7fcb2d04f475fa5$var$base58check(bytes.slice(0, 78)) !== extendedKey) $e7fcb2d04f475fa5$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
        const depth = bytes[4];
        const parentFingerprint = (0, $kniO8.hexlify)(bytes.slice(5, 9));
        const index = parseInt((0, $kniO8.hexlify)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0, $kniO8.hexlify)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch((0, $kniO8.hexlify)(bytes.slice(0, 4))){
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                return new $e7fcb2d04f475fa5$export$b68640c53e22b952($e7fcb2d04f475fa5$var$_constructorGuard, null, (0, $kniO8.hexlify)(key), parentFingerprint, chainCode, index, depth, null);
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) break;
                return new $e7fcb2d04f475fa5$export$b68640c53e22b952($e7fcb2d04f475fa5$var$_constructorGuard, (0, $kniO8.hexlify)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
        }
        return $e7fcb2d04f475fa5$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    }
}
function $e7fcb2d04f475fa5$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    const salt = (0, $1z44X.toUtf8Bytes)("mnemonic" + password, (0, $1z44X.UnicodeNormalizationForm).NFKD);
    return (0, $4poWL.pbkdf2)((0, $1z44X.toUtf8Bytes)(mnemonic, (0, $1z44X.UnicodeNormalizationForm).NFKD), salt, 2048, 64, "sha512");
}
function $e7fcb2d04f475fa5$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $e7fcb2d04f475fa5$var$getWordlist(wordlist);
    $e7fcb2d04f475fa5$var$logger.checkNormalize();
    const words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    const entropy = (0, $kniO8.arrayify)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    let offset = 0;
    for(let i = 0; i < words.length; i++){
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(let bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = $e7fcb2d04f475fa5$var$getUpperMask(checksumBits);
    const checksum = (0, $kniO8.arrayify)((0, $3QUg5.sha256)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $kniO8.hexlify)(entropy.slice(0, entropyBits / 8));
}
function $e7fcb2d04f475fa5$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $e7fcb2d04f475fa5$var$getWordlist(wordlist);
    entropy = (0, $kniO8.arrayify)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    const indices = [
        0
    ];
    let remainingBits = 11;
    for(let i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $e7fcb2d04f475fa5$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = (0, $kniO8.arrayify)((0, $3QUg5.sha256)(entropy))[0] & $e7fcb2d04f475fa5$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map((index)=>wordlist.getWord(index)));
}
function $e7fcb2d04f475fa5$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $e7fcb2d04f475fa5$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $e7fcb2d04f475fa5$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $e7fcb2d04f475fa5$var$HardenedBit || index % 1) $e7fcb2d04f475fa5$var$logger.throwArgumentError("invalid account index", "index", index);
    return `m/44'/60'/${index}'/0/0`;
}

});
parcelRegister("lepF3", function(module, exports) {

$parcel$export(module.exports, "Base58", () => $f74ecf89f280ec1a$export$45a587635c9954b2);
/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 
var $kniO8 = parcelRequire("kniO8");

var $7veey = parcelRequire("7veey");
class $f74ecf89f280ec1a$export$240043ab8e806ec7 {
    constructor(alphabet){
        (0, $7veey.defineReadOnly)(this, "alphabet", alphabet);
        (0, $7veey.defineReadOnly)(this, "base", alphabet.length);
        (0, $7veey.defineReadOnly)(this, "_alphabetMap", {});
        (0, $7veey.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(let i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    encode(value) {
        let source = (0, $kniO8.arrayify)(value);
        if (source.length === 0) return "";
        let digits = [
            0
        ];
        for(let i = 0; i < source.length; ++i){
            let carry = source[i];
            for(let j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for(let k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(let q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    }
    decode(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        let bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(let i = 0; i < value.length; i++){
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            let carry = byte;
            for(let j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(let k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return (0, $kniO8.arrayify)(new Uint8Array(bytes.reverse()));
    }
}
const $f74ecf89f280ec1a$export$cfabb2852920f5ec = new $f74ecf89f280ec1a$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
const $f74ecf89f280ec1a$export$45a587635c9954b2 = new $f74ecf89f280ec1a$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))

});

parcelRegister("4poWL", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $335cd9205f862931$export$448fa22aedc9dbca);

var $kniO8 = parcelRequire("kniO8");

var $3QUg5 = parcelRequire("3QUg5");
"use strict";
function $335cd9205f862931$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $kniO8.arrayify)(password);
    salt = (0, $kniO8.arrayify)(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for(let i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = (0, $kniO8.arrayify)((0, $3QUg5.computeHmac)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(let j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $kniO8.arrayify)((0, $3QUg5.computeHmac)(hashAlgorithm, password, U));
            for(let k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $kniO8.arrayify)(T).slice(0, len), destPos);
    }
    return (0, $kniO8.hexlify)(DK);
}

});
parcelRegister("3QUg5", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $2ce1de2f4cbced24$export$d1cea0ee4e3f0d3e);
$parcel$export(module.exports, "sha256", () => $2ce1de2f4cbced24$export$bced8d2aada2d1c9);
$parcel$export(module.exports, "sha512", () => $2ce1de2f4cbced24$export$a888d2532e6dc7bb);
$parcel$export(module.exports, "computeHmac", () => $2ce1de2f4cbced24$export$967075d2f3b8e7ff);

var $kiSKt = parcelRequire("kiSKt");

var $kniO8 = parcelRequire("kniO8");

var $a6Cmu = parcelRequire("a6Cmu");

var $l6EVj = parcelRequire("l6EVj");

var $9jOmR = parcelRequire("9jOmR");
"use strict";
const $2ce1de2f4cbced24$var$logger = new (0, $l6EVj.Logger)((0, $9jOmR.version));
function $2ce1de2f4cbced24$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).ripemd160().update((0, $kniO8.arrayify)(data)).digest("hex");
}
function $2ce1de2f4cbced24$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256().update((0, $kniO8.arrayify)(data)).digest("hex");
}
function $2ce1de2f4cbced24$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha512().update((0, $kniO8.arrayify)(data)).digest("hex");
}
function $2ce1de2f4cbced24$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $a6Cmu.SupportedAlgorithm)[algorithm]) $2ce1de2f4cbced24$var$logger.throwError("unsupported algorithm " + algorithm, (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($kiSKt)))[algorithm], (0, $kniO8.arrayify)(key)).update((0, $kniO8.arrayify)(data)).digest("hex");
}

});
parcelRegister("a6Cmu", function(module, exports) {

$parcel$export(module.exports, "SupportedAlgorithm", () => $75b838bce05b62e1$export$d2a8849cfb277c);
var $75b838bce05b62e1$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($75b838bce05b62e1$export$d2a8849cfb277c || ($75b838bce05b62e1$export$d2a8849cfb277c = {}));

});

parcelRegister("9jOmR", function(module, exports) {

$parcel$export(module.exports, "version", () => $6c8cf562912dca8e$export$83d89fbfd8236492);
const $6c8cf562912dca8e$export$83d89fbfd8236492 = "sha2/5.5.0";

});



parcelRegister("katF7", function(module, exports) {

$parcel$export(module.exports, "wordlists", () => $eaebc01d1594eea7$export$e8e1b4711c2d1939);

var $cL9Db = parcelRequire("cL9Db");
"use strict";
const $eaebc01d1594eea7$export$e8e1b4711c2d1939 = {
    en: (0, $cL9Db.langEn)
};

});
parcelRegister("cL9Db", function(module, exports) {

$parcel$export(module.exports, "langEn", () => $94a1585543bf217b$export$a2c9518710cf1f49);

var $guH6I = parcelRequire("guH6I");
"use strict";
const $94a1585543bf217b$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let $94a1585543bf217b$var$wordlist = null;
function $94a1585543bf217b$var$loadWords(lang) {
    if ($94a1585543bf217b$var$wordlist != null) return;
    $94a1585543bf217b$var$wordlist = $94a1585543bf217b$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $guH6I.Wordlist).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $94a1585543bf217b$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
class $94a1585543bf217b$var$LangEn extends (0, $guH6I.Wordlist) {
    constructor(){
        super("en");
    }
    getWord(index) {
        $94a1585543bf217b$var$loadWords(this);
        return $94a1585543bf217b$var$wordlist[index];
    }
    getWordIndex(word) {
        $94a1585543bf217b$var$loadWords(this);
        return $94a1585543bf217b$var$wordlist.indexOf(word);
    }
}
const $94a1585543bf217b$export$a2c9518710cf1f49 = new $94a1585543bf217b$var$LangEn();
(0, $guH6I.Wordlist).register($94a1585543bf217b$export$a2c9518710cf1f49);

});
parcelRegister("guH6I", function(module, exports) {

$parcel$export(module.exports, "Wordlist", () => $c020e2e3855949a2$export$4d9531a8ddb0ebca);

var $bnVEQ = parcelRequire("bnVEQ");

var $7veey = parcelRequire("7veey");

var $l6EVj = parcelRequire("l6EVj");

var $8SuuW = parcelRequire("8SuuW");
"use strict";
// This gets overridden by rollup
const $c020e2e3855949a2$var$exportWordlist = false;
const $c020e2e3855949a2$export$af88d00dbe7f521 = new (0, $l6EVj.Logger)((0, $8SuuW.version));
class $c020e2e3855949a2$export$4d9531a8ddb0ebca {
    constructor(locale){
        $c020e2e3855949a2$export$af88d00dbe7f521.checkAbstract(new.target, $c020e2e3855949a2$export$4d9531a8ddb0ebca);
        (0, $7veey.defineReadOnly)(this, "locale", locale);
    }
    // Subclasses may override this
    split(mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    }
    // Subclasses may override this
    join(words) {
        return words.join(" ");
    }
    static check(wordlist) {
        const words = [];
        for(let i = 0; i < 2048; i++){
            const word = wordlist.getWord(i);
            /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
            words.push(word);
        }
        return (0, $bnVEQ.id)(words.join("\n") + "\n");
    }
    static register(lang, name) {
        if (!name) name = lang.locale;
        /* istanbul ignore if */ if ($c020e2e3855949a2$var$exportWordlist) try {
            const anyGlobal = window;
            if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                if (!anyGlobal._ethers.wordlists[name]) (0, $7veey.defineReadOnly)(anyGlobal._ethers.wordlists, name, lang);
            }
        } catch (error) {}
    }
}

});
parcelRegister("8SuuW", function(module, exports) {

$parcel$export(module.exports, "version", () => $676b062d938fc42a$export$83d89fbfd8236492);
const $676b062d938fc42a$export$83d89fbfd8236492 = "wordlists/5.5.0";

});




parcelRegister("bI278", function(module, exports) {

$parcel$export(module.exports, "version", () => $886571994f5d38ee$export$83d89fbfd8236492);
const $886571994f5d38ee$export$83d89fbfd8236492 = "hdnode/5.5.0";

});


parcelRegister("82eL2", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $5d99f5312dcf2f92$export$5f828d93ff035aa8);

var $kniO8 = parcelRequire("kniO8");

var $l6EVj = parcelRequire("l6EVj");

var $bn6zx = parcelRequire("bn6zx");
"use strict";
const $5d99f5312dcf2f92$var$logger = new (0, $l6EVj.Logger)((0, $bn6zx.version));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $5d99f5312dcf2f92$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $5d99f5312dcf2f92$var$anyGlobal = $5d99f5312dcf2f92$var$getGlobal();
let $5d99f5312dcf2f92$var$crypto = $5d99f5312dcf2f92$var$anyGlobal.crypto || $5d99f5312dcf2f92$var$anyGlobal.msCrypto;
if (!$5d99f5312dcf2f92$var$crypto || !$5d99f5312dcf2f92$var$crypto.getRandomValues) {
    $5d99f5312dcf2f92$var$logger.warn("WARNING: Missing strong random number source");
    $5d99f5312dcf2f92$var$crypto = {
        getRandomValues: function(buffer) {
            return $5d99f5312dcf2f92$var$logger.throwError("no secure random source avaialble", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $5d99f5312dcf2f92$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $5d99f5312dcf2f92$var$logger.throwArgumentError("invalid length", "length", length);
    const result = new Uint8Array(length);
    $5d99f5312dcf2f92$var$crypto.getRandomValues(result);
    return (0, $kniO8.arrayify)(result);
}

});
parcelRegister("bn6zx", function(module, exports) {

$parcel$export(module.exports, "version", () => $8476f0c97e6bd2f1$export$83d89fbfd8236492);
const $8476f0c97e6bd2f1$export$83d89fbfd8236492 = "random/5.5.1";

});


parcelRegister("2vAOQ", function(module, exports) {

$parcel$export(module.exports, "decryptSync", () => $1d3b098333cb4e8e$export$9bd2c37889ee5e36);
$parcel$export(module.exports, "decrypt", () => $1d3b098333cb4e8e$export$e85a0c9a1067c5d3);
$parcel$export(module.exports, "encrypt", () => $1d3b098333cb4e8e$export$5b0f6292f11d1d18);

var $jcj12 = parcelRequire("jcj12");

var $innAd = parcelRequire("innAd");

var $1qOxQ = parcelRequire("1qOxQ");

var $kniO8 = parcelRequire("kniO8");

var $jURra = parcelRequire("jURra");

var $jGTTU = parcelRequire("jGTTU");

var $4poWL = parcelRequire("4poWL");

var $82eL2 = parcelRequire("82eL2");

var $7veey = parcelRequire("7veey");

var $equjW = parcelRequire("equjW");

var $jsDra = parcelRequire("jsDra");

var $l6EVj = parcelRequire("l6EVj");

var $g8N1C = parcelRequire("g8N1C");
"use strict";
var $1d3b098333cb4e8e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $1d3b098333cb4e8e$var$logger = new (0, $l6EVj.Logger)((0, $g8N1C.version));
// Exported Types
function $1d3b098333cb4e8e$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
class $1d3b098333cb4e8e$export$cf9dc4fd6dde0315 extends (0, $7veey.Description) {
    isKeystoreAccount(value) {
        return !!(value && value._isKeystoreAccount);
    }
}
function $1d3b098333cb4e8e$var$_decrypt(data, key, ciphertext) {
    const cipher = (0, $jsDra.searchPath)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        const iv = (0, $jsDra.looseArrayify)((0, $jsDra.searchPath)(data, "crypto/cipherparams/iv"));
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).ModeOfOperation.ctr(key, counter);
        return (0, $kniO8.arrayify)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $1d3b098333cb4e8e$var$_getAccount(data, key) {
    const ciphertext = (0, $jsDra.looseArrayify)((0, $jsDra.searchPath)(data, "crypto/ciphertext"));
    const computedMAC = (0, $kniO8.hexlify)((0, $jGTTU.keccak256)((0, $kniO8.concat)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $jsDra.searchPath)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    const privateKey = $1d3b098333cb4e8e$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $1d3b098333cb4e8e$var$logger.throwError("unsupported cipher", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    const mnemonicKey = key.slice(32, 64);
    const address = (0, $equjW.computeAddress)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $1qOxQ.getAddress)(check) !== address) throw new Error("address mismatch");
    }
    const account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $kniO8.hexlify)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $jsDra.searchPath)(data, "x-ethers/version") === "0.1") {
        const mnemonicCiphertext = (0, $jsDra.looseArrayify)((0, $jsDra.searchPath)(data, "x-ethers/mnemonicCiphertext"));
        const mnemonicIv = (0, $jsDra.looseArrayify)((0, $jsDra.searchPath)(data, "x-ethers/mnemonicCounter"));
        const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).Counter(mnemonicIv);
        const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        const path = (0, $jsDra.searchPath)(data, "x-ethers/path") || (0, $jURra.defaultPath);
        const locale = (0, $jsDra.searchPath)(data, "x-ethers/locale") || "en";
        const entropy = (0, $kniO8.arrayify)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            const mnemonic = (0, $jURra.entropyToMnemonic)(entropy, locale);
            const node = (0, $jURra.HDNode).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $l6EVj.Logger).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $1d3b098333cb4e8e$export$cf9dc4fd6dde0315(account);
}
function $1d3b098333cb4e8e$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $kniO8.arrayify)((0, $4poWL.pbkdf2)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $1d3b098333cb4e8e$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($1d3b098333cb4e8e$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $1d3b098333cb4e8e$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    const passwordBytes = (0, $jsDra.getPassword)(password);
    const kdf = (0, $jsDra.searchPath)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        const throwError = function(name, value) {
            return $1d3b098333cb4e8e$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0, $jsDra.looseArrayify)((0, $jsDra.searchPath)(data, "crypto/kdfparams/salt"));
            const N = parseInt((0, $jsDra.searchPath)(data, "crypto/kdfparams/n"));
            const r = parseInt((0, $jsDra.searchPath)(data, "crypto/kdfparams/r"));
            const p = parseInt((0, $jsDra.searchPath)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            const dkLen = parseInt((0, $jsDra.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0, $jsDra.looseArrayify)((0, $jsDra.searchPath)(data, "crypto/kdfparams/salt"));
            let prfFunc = null;
            const prf = (0, $jsDra.searchPath)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            const count = parseInt((0, $jsDra.searchPath)(data, "crypto/kdfparams/c"));
            const dkLen = parseInt((0, $jsDra.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return pbkdf2Func(passwordBytes, salt, count, dkLen, prfFunc);
        }
    }
    return $1d3b098333cb4e8e$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $1d3b098333cb4e8e$export$9bd2c37889ee5e36(json, password) {
    const data = JSON.parse(json);
    const key = $1d3b098333cb4e8e$var$_computeKdfKey(data, password, $1d3b098333cb4e8e$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($innAd))).syncScrypt);
    return $1d3b098333cb4e8e$var$_getAccount(data, key);
}
function $1d3b098333cb4e8e$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $1d3b098333cb4e8e$var$__awaiter(this, void 0, void 0, function*() {
        const data = JSON.parse(json);
        const key = yield $1d3b098333cb4e8e$var$_computeKdfKey(data, password, $1d3b098333cb4e8e$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($innAd))).scrypt, progressCallback);
        return $1d3b098333cb4e8e$var$_getAccount(data, key);
    });
}
function $1d3b098333cb4e8e$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $1qOxQ.getAddress)(account.address) !== (0, $equjW.computeAddress)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($1d3b098333cb4e8e$var$hasMnemonic(account)) {
            const mnemonic = account.mnemonic;
            const node = (0, $jURra.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $jURra.defaultPath));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    const privateKey = (0, $kniO8.arrayify)(account.privateKey);
    const passwordBytes = (0, $jsDra.getPassword)(password);
    let entropy = null;
    let path = null;
    let locale = null;
    if ($1d3b098333cb4e8e$var$hasMnemonic(account)) {
        const srcMnemonic = account.mnemonic;
        entropy = (0, $kniO8.arrayify)((0, $jURra.mnemonicToEntropy)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $jURra.defaultPath);
        locale = srcMnemonic.locale || "en";
    }
    let client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    let salt = null;
    if (options.salt) salt = (0, $kniO8.arrayify)(options.salt);
    else salt = (0, $82eL2.randomBytes)(32);
    // Override initialization vector
    let iv = null;
    if (options.iv) {
        iv = (0, $kniO8.arrayify)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $82eL2.randomBytes)(16);
    // Override the uuid
    let uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $kniO8.arrayify)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $82eL2.randomBytes)(16);
    // Override the scrypt password-based key derivation function parameters
    let N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($innAd))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then((key)=>{
        key = (0, $kniO8.arrayify)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        const derivedKey = key.slice(0, 16);
        const macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        const mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).ModeOfOperation.ctr(derivedKey, counter);
        const ciphertext = (0, $kniO8.arrayify)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        const mac = (0, $jGTTU.keccak256)((0, $kniO8.concat)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        const data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $jsDra.uuidV4)(uuidRandom),
            version: 3,
            Crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $kniO8.hexlify)(iv).substring(2)
                },
                ciphertext: (0, $kniO8.hexlify)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $kniO8.hexlify)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            const mnemonicIv = (0, $82eL2.randomBytes)(16);
            const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).Counter(mnemonicIv);
            const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            const mnemonicCiphertext = (0, $kniO8.arrayify)(mnemonicAesCtr.encrypt(entropy));
            const now = new Date();
            const timestamp = now.getUTCFullYear() + "-" + (0, $jsDra.zpad)(now.getUTCMonth() + 1, 2) + "-" + (0, $jsDra.zpad)(now.getUTCDate(), 2) + "T" + (0, $jsDra.zpad)(now.getUTCHours(), 2) + "-" + (0, $jsDra.zpad)(now.getUTCMinutes(), 2) + "-" + (0, $jsDra.zpad)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $kniO8.hexlify)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $kniO8.hexlify)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}

});
parcelRegister("jcj12", function(module, exports) {
"use strict";
(function(root) {
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    module.exports = aesjs;
})(module.exports);

});

parcelRegister("innAd", function(module, exports) {
"use strict";
(function(root) {
    const MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        const K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        const w = new Uint32Array(64);
        function blocks(p) {
            let off = 0, len = p.length;
            while(len >= 64){
                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        let i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        const innerLen = 64 + salt.length + 4;
        const inner = new Array(innerLen);
        const outerKey = new Array(64);
        let i;
        let dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(let i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        let i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(let i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(let i = 0; i < 16; ++i)B[i] += x[i];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(let i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(let i = 0; i < o.length; i++){
            const v = o[i];
            if (typeof v !== "number" || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error("invalid " + name);
        return value;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        const B = new Uint32Array(p * 32 * r);
        for(let i = 0; i < B.length; i++){
            const j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        const XY = new Uint32Array(64 * r);
        const V = new Uint32Array(32 * r * N);
        const Yi = 32 * r;
        // scratch space
        const x = new Uint32Array(16); // salsa20_8
        const _X = new Uint32Array(16); // blockmix_salsa8
        const totalOps = p * N * 2;
        let currentOp = 0;
        let lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        let stop = false;
        // State information
        let state = 0;
        let i0 = 0, i1;
        let Bi;
        // How many blockmix_salsa8 can we do per step?
        const limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        const nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        const incrementalSMix = function() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            let steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        const offset = (2 * r - 1) * 16; // ROMix - 7
                        const j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(let i = 0; i < B.length; i++){
                        b.push(B[i] >> 0 & 0xff);
                        b.push(B[i] >> 8 & 0xff);
                        b.push(B[i] >> 16 & 0xff);
                        b.push(B[i] >> 24 & 0xff);
                    }
                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            const derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    }
    const lib = {
        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                let lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof module.exports !== "undefined") module.exports = lib;
    else if (typeof define === "function" && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})(module.exports);

});

parcelRegister("jsDra", function(module, exports) {

$parcel$export(module.exports, "looseArrayify", () => $e2af3944f8b2fdc2$export$2cde08bde0cfd932);
$parcel$export(module.exports, "zpad", () => $e2af3944f8b2fdc2$export$67752b99d3bc61c6);
$parcel$export(module.exports, "getPassword", () => $e2af3944f8b2fdc2$export$350bd33120f7413e);
$parcel$export(module.exports, "searchPath", () => $e2af3944f8b2fdc2$export$5a5c1dbd910e2c32);
$parcel$export(module.exports, "uuidV4", () => $e2af3944f8b2fdc2$export$ec7b18ebad55a3a9);

var $kniO8 = parcelRequire("kniO8");

var $1z44X = parcelRequire("1z44X");
"use strict";
function $e2af3944f8b2fdc2$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $kniO8.arrayify)(hexString);
}
function $e2af3944f8b2fdc2$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $e2af3944f8b2fdc2$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $1z44X.toUtf8Bytes)(password, (0, $1z44X.UnicodeNormalizationForm).NFKC);
    return (0, $kniO8.arrayify)(password);
}
function $e2af3944f8b2fdc2$export$5a5c1dbd910e2c32(object, path) {
    let currentChild = object;
    const comps = path.toLowerCase().split("/");
    for(let i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for(const key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $e2af3944f8b2fdc2$export$ec7b18ebad55a3a9(randomBytes) {
    const bytes = (0, $kniO8.arrayify)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const value = (0, $kniO8.hexlify)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}

});

parcelRegister("g8N1C", function(module, exports) {

$parcel$export(module.exports, "version", () => $bc036c0fb715d5c9$export$83d89fbfd8236492);
const $bc036c0fb715d5c9$export$83d89fbfd8236492 = "json-wallets/5.5.0";

});


parcelRegister("3c0Hw", function(module, exports) {

$parcel$export(module.exports, "decryptJsonWallet", () => $2533094a1916edea$export$e74fcde37488267a);
$parcel$export(module.exports, "decryptJsonWalletSync", () => $2533094a1916edea$export$7a81c437a678891a);

var $jjt0L = parcelRequire("jjt0L");

var $hCKkd = parcelRequire("hCKkd");

var $2vAOQ = parcelRequire("2vAOQ");
"use strict";
function $2533094a1916edea$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $hCKkd.isCrowdsaleWallet)(json)) {
        if (progressCallback) progressCallback(0);
        const account = (0, $jjt0L.decrypt)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $hCKkd.isKeystoreWallet)(json)) return (0, $2vAOQ.decrypt)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $2533094a1916edea$export$7a81c437a678891a(json, password) {
    if ((0, $hCKkd.isCrowdsaleWallet)(json)) return (0, $jjt0L.decrypt)(json, password);
    if ((0, $hCKkd.isKeystoreWallet)(json)) return (0, $2vAOQ.decryptSync)(json, password);
    throw new Error("invalid JSON wallet");
}

});
parcelRegister("jjt0L", function(module, exports) {

$parcel$export(module.exports, "decrypt", () => $e0f64bba612dd6b5$export$e85a0c9a1067c5d3);

var $jcj12 = parcelRequire("jcj12");

var $1qOxQ = parcelRequire("1qOxQ");

var $kniO8 = parcelRequire("kniO8");

var $jGTTU = parcelRequire("jGTTU");

var $4poWL = parcelRequire("4poWL");

var $1z44X = parcelRequire("1z44X");

var $7veey = parcelRequire("7veey");

var $l6EVj = parcelRequire("l6EVj");

var $g8N1C = parcelRequire("g8N1C");

var $jsDra = parcelRequire("jsDra");
"use strict";
const $e0f64bba612dd6b5$var$logger = new (0, $l6EVj.Logger)((0, $g8N1C.version));
class $e0f64bba612dd6b5$export$93a76d16f88f2b3 extends (0, $7veey.Description) {
    isCrowdsaleAccount(value) {
        return !!(value && value._isCrowdsaleAccount);
    }
}
function $e0f64bba612dd6b5$export$e85a0c9a1067c5d3(json, password) {
    const data = JSON.parse(json);
    password = (0, $jsDra.getPassword)(password);
    // Ethereum Address
    const ethaddr = (0, $1qOxQ.getAddress)((0, $jsDra.searchPath)(data, "ethaddr"));
    // Encrypted Seed
    const encseed = (0, $jsDra.looseArrayify)((0, $jsDra.searchPath)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $e0f64bba612dd6b5$var$logger.throwArgumentError("invalid encseed", "json", json);
    const key = (0, $kniO8.arrayify)((0, $4poWL.pbkdf2)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).ModeOfOperation.cbc(key, iv);
    const seed = (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).padding.pkcs7.strip((0, $kniO8.arrayify)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for(let i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    const seedHexBytes = (0, $1z44X.toUtf8Bytes)(seedHex);
    const privateKey = (0, $jGTTU.keccak256)(seedHexBytes);
    return new $e0f64bba612dd6b5$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}

});

parcelRegister("hCKkd", function(module, exports) {

$parcel$export(module.exports, "isCrowdsaleWallet", () => $cd49eb785a3f1507$export$724d6cf6b9fd8578);
$parcel$export(module.exports, "isKeystoreWallet", () => $cd49eb785a3f1507$export$67dc926b8e68b2d8);
$parcel$export(module.exports, "getJsonWalletAddress", () => $cd49eb785a3f1507$export$9a68ee9f8f3afd38);

var $1qOxQ = parcelRequire("1qOxQ");
"use strict";
function $cd49eb785a3f1507$export$724d6cf6b9fd8578(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $cd49eb785a3f1507$export$67dc926b8e68b2d8(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $cd49eb785a3f1507$export$9a68ee9f8f3afd38(json) {
    if ($cd49eb785a3f1507$export$724d6cf6b9fd8578(json)) try {
        return (0, $1qOxQ.getAddress)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($cd49eb785a3f1507$export$67dc926b8e68b2d8(json)) try {
        return (0, $1qOxQ.getAddress)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}

});


parcelRegister("khYbT", function(module, exports) {

$parcel$export(module.exports, "version", () => $ec5415d365db763e$export$83d89fbfd8236492);
const $ec5415d365db763e$export$83d89fbfd8236492 = "wallet/5.5.0";

});


parcelRegister("kVh5l", function(module, exports) {

$parcel$export(module.exports, "AddressZero", () => (parcelRequire("3aKAP")).AddressZero);
$parcel$export(module.exports, "NegativeOne", () => (parcelRequire("gYmoN")).NegativeOne);
$parcel$export(module.exports, "Zero", () => (parcelRequire("gYmoN")).Zero);
$parcel$export(module.exports, "One", () => (parcelRequire("gYmoN")).One);
$parcel$export(module.exports, "Two", () => (parcelRequire("gYmoN")).Two);
$parcel$export(module.exports, "WeiPerEther", () => (parcelRequire("gYmoN")).WeiPerEther);
$parcel$export(module.exports, "MaxUint256", () => (parcelRequire("gYmoN")).MaxUint256);
$parcel$export(module.exports, "MinInt256", () => (parcelRequire("gYmoN")).MinInt256);
$parcel$export(module.exports, "MaxInt256", () => (parcelRequire("gYmoN")).MaxInt256);
$parcel$export(module.exports, "HashZero", () => (parcelRequire("5phKy")).HashZero);
$parcel$export(module.exports, "EtherSymbol", () => (parcelRequire("dbilz")).EtherSymbol);

var $3aKAP = parcelRequire("3aKAP");

var $gYmoN = parcelRequire("gYmoN");

var $5phKy = parcelRequire("5phKy");

var $dbilz = parcelRequire("dbilz");
"use strict";

});
parcelRegister("3aKAP", function(module, exports) {

$parcel$export(module.exports, "AddressZero", () => $24f672a68f2bf23b$export$badd13187c087617);
const $24f672a68f2bf23b$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";

});

parcelRegister("5phKy", function(module, exports) {

$parcel$export(module.exports, "HashZero", () => $3efd0e53a47ea12c$export$71c2e4e213dcb7f2);
const $3efd0e53a47ea12c$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";

});

parcelRegister("dbilz", function(module, exports) {

$parcel$export(module.exports, "EtherSymbol", () => $998a88c6a482e2ee$export$c7e79fcb6f8ac048);
// NFKC (composed)             // (decomposed)
const $998a88c6a482e2ee$export$c7e79fcb6f8ac048 = "\u039E"; // "\uD835\uDF63";

});


parcelRegister("S29ji", function(module, exports) {

$parcel$export(module.exports, "getDefaultProvider", () => $0a26b60a26762d39$export$4f77a1d3c1ac6642);
$parcel$export(module.exports, "Provider", () => (parcelRequire("hMfVR")).Provider);
$parcel$export(module.exports, "BaseProvider", () => (parcelRequire("98KlH")).BaseProvider);
$parcel$export(module.exports, "Resolver", () => (parcelRequire("98KlH")).Resolver);
$parcel$export(module.exports, "UrlJsonRpcProvider", () => (parcelRequire("4HuFM")).UrlJsonRpcProvider);
$parcel$export(module.exports, "FallbackProvider", () => (parcelRequire("6VM9N")).FallbackProvider);
$parcel$export(module.exports, "AlchemyProvider", () => (parcelRequire("7z4rz")).AlchemyProvider);
$parcel$export(module.exports, "AlchemyWebSocketProvider", () => (parcelRequire("7z4rz")).AlchemyWebSocketProvider);
$parcel$export(module.exports, "CloudflareProvider", () => (parcelRequire("eGnPy")).CloudflareProvider);
$parcel$export(module.exports, "EtherscanProvider", () => (parcelRequire("2EBww")).EtherscanProvider);
$parcel$export(module.exports, "InfuraProvider", () => (parcelRequire("frY0B")).InfuraProvider);
$parcel$export(module.exports, "InfuraWebSocketProvider", () => (parcelRequire("frY0B")).InfuraWebSocketProvider);
$parcel$export(module.exports, "JsonRpcProvider", () => (parcelRequire("3pw3F")).JsonRpcProvider);
$parcel$export(module.exports, "JsonRpcBatchProvider", () => (parcelRequire("8iJqx")).JsonRpcBatchProvider);
$parcel$export(module.exports, "NodesmithProvider", () => (parcelRequire("eLtE8")).NodesmithProvider);
$parcel$export(module.exports, "PocketProvider", () => (parcelRequire("144p0")).PocketProvider);
$parcel$export(module.exports, "StaticJsonRpcProvider", () => (parcelRequire("4HuFM")).StaticJsonRpcProvider);
$parcel$export(module.exports, "Web3Provider", () => (parcelRequire("4zhJC")).Web3Provider);
$parcel$export(module.exports, "WebSocketProvider", () => (parcelRequire("70jvO")).WebSocketProvider);
$parcel$export(module.exports, "IpcProvider", () => (parcelRequire("2tAFx")).IpcProvider);
$parcel$export(module.exports, "JsonRpcSigner", () => (parcelRequire("3pw3F")).JsonRpcSigner);
$parcel$export(module.exports, "getNetwork", () => (parcelRequire("eDBOW")).getNetwork);
$parcel$export(module.exports, "isCommunityResource", () => (parcelRequire("jqMZF")).isCommunityResource);
$parcel$export(module.exports, "isCommunityResourcable", () => (parcelRequire("jqMZF")).isCommunityResourcable);
$parcel$export(module.exports, "showThrottleMessage", () => (parcelRequire("jqMZF")).showThrottleMessage);
$parcel$export(module.exports, "Formatter", () => (parcelRequire("jqMZF")).Formatter);

var $hMfVR = parcelRequire("hMfVR");

var $eDBOW = parcelRequire("eDBOW");

var $98KlH = parcelRequire("98KlH");

var $7z4rz = parcelRequire("7z4rz");

var $eGnPy = parcelRequire("eGnPy");

var $2EBww = parcelRequire("2EBww");

var $6VM9N = parcelRequire("6VM9N");

var $2tAFx = parcelRequire("2tAFx");

var $frY0B = parcelRequire("frY0B");

var $3pw3F = parcelRequire("3pw3F");

var $8iJqx = parcelRequire("8iJqx");

var $eLtE8 = parcelRequire("eLtE8");

var $144p0 = parcelRequire("144p0");

var $4HuFM = parcelRequire("4HuFM");

var $4zhJC = parcelRequire("4zhJC");

var $70jvO = parcelRequire("70jvO");

var $jqMZF = parcelRequire("jqMZF");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");
"use strict";
const $0a26b60a26762d39$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
////////////////////////
// Helper Functions
function $0a26b60a26762d39$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        const match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1]){
            case "http":
                return new (0, $3pw3F.JsonRpcProvider)(network);
            case "ws":
                return new (0, $70jvO.WebSocketProvider)(network);
            default:
                $0a26b60a26762d39$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    const n = (0, $eDBOW.getNetwork)(network);
    if (!n || !n._defaultProvider) $0a26b60a26762d39$var$logger.throwError("unsupported getDefaultProvider network", (0, $l6EVj.Logger).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: $6VM9N.FallbackProvider,
        AlchemyProvider: $7z4rz.AlchemyProvider,
        CloudflareProvider: $eGnPy.CloudflareProvider,
        EtherscanProvider: $2EBww.EtherscanProvider,
        InfuraProvider: $frY0B.InfuraProvider,
        JsonRpcProvider: $3pw3F.JsonRpcProvider,
        NodesmithProvider: $eLtE8.NodesmithProvider,
        PocketProvider: $144p0.PocketProvider,
        Web3Provider: $4zhJC.Web3Provider,
        IpcProvider: $2tAFx.IpcProvider
    }, options);
}

});
parcelRegister("eDBOW", function(module, exports) {

$parcel$export(module.exports, "getNetwork", () => $aa820b929028121b$export$7de4970ebfd8206d);

var $l6EVj = parcelRequire("l6EVj");

var $kcUPr = parcelRequire("kcUPr");
"use strict";
const $aa820b929028121b$var$logger = new (0, $l6EVj.Logger)((0, $kcUPr.version));
function $aa820b929028121b$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $aa820b929028121b$var$ethDefaultProvider(network) {
    const func = function(providers, options) {
        if (options == null) options = {};
        const providerList = [];
        if (providers.InfuraProvider) try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider) try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider) try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider) {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = [
                "goerli",
                "ropsten",
                "rinkeby"
            ];
            try {
                const provider = new providers.PocketProvider(network);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider) try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $aa820b929028121b$var$ethDefaultProvider(network);
    };
    return func;
}
function $aa820b929028121b$var$etcDefaultProvider(url, network) {
    const func = function(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $aa820b929028121b$var$etcDefaultProvider(url, network);
    };
    return func;
}
const $aa820b929028121b$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $aa820b929028121b$var$ethDefaultProvider("homestead")
};
const $aa820b929028121b$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $aa820b929028121b$var$ethDefaultProvider("ropsten")
};
const $aa820b929028121b$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $aa820b929028121b$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const $aa820b929028121b$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $aa820b929028121b$var$homestead,
    mainnet: $aa820b929028121b$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $aa820b929028121b$var$ropsten,
    testnet: $aa820b929028121b$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $aa820b929028121b$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $aa820b929028121b$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $aa820b929028121b$var$ethDefaultProvider("goerli")
    },
    kintsugi: {
        chainId: 1337702,
        name: "kintsugi"
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $aa820b929028121b$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $aa820b929028121b$var$classicMordor,
    classicTestnet: $aa820b929028121b$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $aa820b929028121b$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic"
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    optimism: {
        chainId: 10,
        name: "optimism"
    },
    "optimism-kovan": {
        chainId: 69,
        name: "optimism-kovan"
    },
    "optimism-goerli": {
        chainId: 420,
        name: "optimism-goerli"
    },
    arbitrum: {
        chainId: 42161,
        name: "arbitrum"
    },
    "arbitrum-rinkeby": {
        chainId: 421611,
        name: "arbitrum-rinkeby"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $aa820b929028121b$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(const name in $aa820b929028121b$var$networks){
            const standard = $aa820b929028121b$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        const standard = $aa820b929028121b$var$networks[network];
        if (standard == null) return null;
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: standard._defaultProvider || null
        };
    }
    const standard = $aa820b929028121b$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof network.chainId !== "number") $aa820b929028121b$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) $aa820b929028121b$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if ($aa820b929028121b$var$isRenetworkable(standard._defaultProvider)) defaultProvider = standard._defaultProvider.renetwork(network);
        else defaultProvider = standard._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: network.ensAddress || standard.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}

});
parcelRegister("kcUPr", function(module, exports) {

$parcel$export(module.exports, "version", () => $eb6102a75d2ffe21$export$83d89fbfd8236492);
const $eb6102a75d2ffe21$export$83d89fbfd8236492 = "networks/5.5.2";

});


parcelRegister("98KlH", function(module, exports) {

$parcel$export(module.exports, "Resolver", () => $6a78d056df40e716$export$8b4c839865b08288);
$parcel$export(module.exports, "BaseProvider", () => $6a78d056df40e716$export$ff3f6dd83125ac45);

var $hMfVR = parcelRequire("hMfVR");

var $lepF3 = parcelRequire("lepF3");

var $kVZhy = parcelRequire("kVZhy");

var $kniO8 = parcelRequire("kniO8");

var $5phKy = parcelRequire("5phKy");

var $aafAp = parcelRequire("aafAp");

var $eDBOW = parcelRequire("eDBOW");

var $7veey = parcelRequire("7veey");

var $3QUg5 = parcelRequire("3QUg5");

var $1z44X = parcelRequire("1z44X");

var $7J8He = parcelRequire("7J8He");

var $7CtKW = parcelRequire("7CtKW");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");

var $jqMZF = parcelRequire("jqMZF");
"use strict";
var $6a78d056df40e716$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $6a78d056df40e716$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
//////////////////////////////
// Event Serializeing
function $6a78d056df40e716$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $kniO8.hexDataLength)(topic) !== 32) $6a78d056df40e716$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $6a78d056df40e716$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map((topic)=>{
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic)=>{
                unique[$6a78d056df40e716$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $6a78d056df40e716$var$checkTopic(topic);
    }).join("&");
}
function $6a78d056df40e716$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map((topic)=>{
        if (topic === "") return [];
        const comps = topic.split("|").map((topic)=>{
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $6a78d056df40e716$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $kniO8.hexDataLength)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $6a78d056df40e716$var$serializeTopics(eventName);
    else if ((0, $hMfVR.ForkEvent).isForkEvent(eventName)) {
        $6a78d056df40e716$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $6a78d056df40e716$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $6a78d056df40e716$var$getTime() {
    return new Date().getTime();
}
function $6a78d056df40e716$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ const $6a78d056df40e716$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
class $6a78d056df40e716$export$d61e24a684f9e51 {
    constructor(tag, listener, once){
        (0, $7veey.defineReadOnly)(this, "tag", tag);
        (0, $7veey.defineReadOnly)(this, "listener", listener);
        (0, $7veey.defineReadOnly)(this, "once", once);
    }
    get event() {
        switch(this.type){
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") return null;
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") return null;
        const address = comps[1];
        const topics = $6a78d056df40e716$var$deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) filter.topics = topics;
        if (address && address !== "*") filter.address = address;
        return filter;
    }
    pollable() {
        return this.tag.indexOf(":") >= 0 || $6a78d056df40e716$var$PollableEvents.indexOf(this.tag) >= 0;
    }
}
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const $6a78d056df40e716$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $6a78d056df40e716$var$bytes32ify(value) {
    return (0, $kniO8.hexZeroPad)((0, $kVZhy.BigNumber).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $6a78d056df40e716$var$base58Encode(data) {
    return (0, $lepF3.Base58).encode((0, $kniO8.concat)([
        data,
        (0, $kniO8.hexDataSlice)((0, $3QUg5.sha256)((0, $3QUg5.sha256)(data)), 0, 4)
    ]));
}
const $6a78d056df40e716$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $6a78d056df40e716$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $6a78d056df40e716$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $6a78d056df40e716$var$_parseString(result) {
    try {
        return (0, $1z44X.toUtf8String)($6a78d056df40e716$var$_parseBytes(result));
    } catch (error) {}
    return null;
}
function $6a78d056df40e716$var$_parseBytes(result) {
    if (result === "0x") return null;
    const offset = (0, $kVZhy.BigNumber).from((0, $kniO8.hexDataSlice)(result, 0, 32)).toNumber();
    const length = (0, $kVZhy.BigNumber).from((0, $kniO8.hexDataSlice)(result, offset, offset + 32)).toNumber();
    return (0, $kniO8.hexDataSlice)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function $6a78d056df40e716$var$getIpfsLink(link) {
    return `https:/\/gateway.ipfs.io/ipfs/${link.substring(7)}`;
}
class $6a78d056df40e716$export$8b4c839865b08288 {
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress){
        (0, $7veey.defineReadOnly)(this, "provider", provider);
        (0, $7veey.defineReadOnly)(this, "name", name);
        (0, $7veey.defineReadOnly)(this, "address", provider.formatter.address(address));
        (0, $7veey.defineReadOnly)(this, "_resolvedAddress", resolvedAddress);
    }
    _fetchBytes(selector, parameters) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                data: (0, $kniO8.hexConcat)([
                    selector,
                    (0, $aafAp.namehash)(this.name),
                    parameters || "0x"
                ])
            };
            try {
                return $6a78d056df40e716$var$_parseBytes((yield this.provider.call(tx)));
            } catch (error) {
                if (error.code === (0, $l6EVj.Logger).errors.CALL_EXCEPTION) return null;
                return null;
            }
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = $6a78d056df40e716$var$coinInfos[String(coinType)];
        if (coinInfo == null) $6a78d056df40e716$var$logger.throwError(`unsupported coin type: ${coinType}`, (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: `getAddress(${coinType})`
        });
        if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
        const bytes = (0, $kniO8.arrayify)(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $6a78d056df40e716$var$base58Encode((0, $kniO8.concat)([
                    [
                        coinInfo.p2pkh
                    ],
                    "0x" + p2pkh[2]
                ]));
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) return $6a78d056df40e716$var$base58Encode((0, $kniO8.concat)([
                    [
                        coinInfo.p2sh
                    ],
                    "0x" + p2sh[2]
                ]));
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) version = -1;
            } else version = -1;
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = (0, (/*@__PURE__*/$parcel$interopDefault($7CtKW))).toWords(bytes.slice(2));
                words.unshift(version);
                return (0, (/*@__PURE__*/$parcel$interopDefault($7CtKW))).encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            if (coinType == null) coinType = 60;
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) try {
                // keccak256("addr(bytes32)")
                const transaction = {
                    to: this.address,
                    data: "0x3b3b57de" + (0, $aafAp.namehash)(this.name).substring(2)
                };
                const hexBytes = yield this.provider.call(transaction);
                // No address
                if (hexBytes === "0x" || hexBytes === (0, $5phKy.HashZero)) return null;
                return this.provider.formatter.callAddress(hexBytes);
            } catch (error) {
                if (error.code === (0, $l6EVj.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", $6a78d056df40e716$var$bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") return null;
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) $6a78d056df40e716$var$logger.throwError(`invalid or unsupported coin data`, (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`,
                coinType: coinType,
                data: hexBytes
            });
            return address;
        });
    }
    getAvatar() {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            const linkage = [
                {
                    type: "name",
                    content: this.name
                }
            ];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) return null;
                for(let i = 0; i < $6a78d056df40e716$var$matchers.length; i++){
                    const match = avatar.match($6a78d056df40e716$var$matchers[i]);
                    if (match == null) continue;
                    const scheme = match[1].toLowerCase();
                    switch(scheme){
                        case "https":
                            linkage.push({
                                type: "url",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "data":
                            linkage.push({
                                type: "data",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "ipfs":
                            linkage.push({
                                type: "ipfs",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: $6a78d056df40e716$var$getIpfsLink(avatar)
                            };
                        case "erc721":
                        case "erc1155":
                            {
                                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                                const selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: scheme,
                                    content: avatar
                                });
                                // The owner of this name
                                const owner = this._resolvedAddress || (yield this.getAddress());
                                const comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return null;
                                const addr = yield this.provider.formatter.address(comps[0]);
                                const tokenId = (0, $kniO8.hexZeroPad)((0, $kVZhy.BigNumber).from(comps[1]).toHexString(), 32);
                                // Check that this account owns the token
                                if (scheme === "erc721") {
                                    // ownerOf(uint256 tokenId)
                                    const tokenOwner = this.provider.formatter.callAddress((yield this.provider.call({
                                        to: addr,
                                        data: (0, $kniO8.hexConcat)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })));
                                    if (owner !== tokenOwner) return null;
                                    linkage.push({
                                        type: "owner",
                                        content: tokenOwner
                                    });
                                } else if (scheme === "erc1155") {
                                    // balanceOf(address owner, uint256 tokenId)
                                    const balance = (0, $kVZhy.BigNumber).from((yield this.provider.call({
                                        to: addr,
                                        data: (0, $kniO8.hexConcat)([
                                            "0x00fdd58e",
                                            (0, $kniO8.hexZeroPad)(owner, 32),
                                            tokenId
                                        ])
                                    })));
                                    if (balance.isZero()) return null;
                                    linkage.push({
                                        type: "balance",
                                        content: balance.toString()
                                    });
                                }
                                // Call the token contract for the metadata URL
                                const tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $kniO8.hexConcat)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                let metadataUrl = $6a78d056df40e716$var$_parseString((yield this.provider.call(tx)));
                                if (metadataUrl == null) return null;
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (scheme === "erc1155") {
                                    metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                    linkage.push({
                                        type: "metadata-url-expanded",
                                        content: metadataUrl
                                    });
                                }
                                // Get the token metadata
                                const metadata = yield (0, $7J8He.fetchJson)(metadataUrl);
                                if (!metadata) return null;
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                // Pull the image URL out
                                let imageUrl = metadata.image;
                                if (typeof imageUrl !== "string") return null;
                                if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                                else {
                                    // Transform IPFS link to gateway
                                    const ipfs = imageUrl.match($6a78d056df40e716$var$matcherIpfs);
                                    if (ipfs == null) return null;
                                    linkage.push({
                                        type: "url-ipfs",
                                        content: imageUrl
                                    });
                                    imageUrl = $6a78d056df40e716$var$getIpfsLink(imageUrl);
                                }
                                linkage.push({
                                    type: "url",
                                    content: imageUrl
                                });
                                return {
                                    linkage: linkage,
                                    url: imageUrl
                                };
                            }
                    }
                }
            } catch (error) {}
            return null;
        });
    }
    getContentHash() {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") return null;
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) return "ipfs://" + (0, $lepF3.Base58).encode("0x" + ipfs[1]);
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === 64) return "bzz://" + swarm[1];
            }
            return $6a78d056df40e716$var$logger.throwError(`invalid or unsupported content hash data`, (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            // The key encoded as parameter to fetchBytes
            let keyBytes = (0, $1z44X.toUtf8Bytes)(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = (0, $kniO8.concat)([
                $6a78d056df40e716$var$bytes32ify(64),
                $6a78d056df40e716$var$bytes32ify(keyBytes.length),
                keyBytes
            ]);
            // Pad to word-size (32 bytes)
            if (keyBytes.length % 32 !== 0) keyBytes = (0, $kniO8.concat)([
                keyBytes,
                (0, $kniO8.hexZeroPad)("0x", 32 - key.length % 32)
            ]);
            const hexBytes = yield this._fetchBytes("0x59d1d43c", (0, $kniO8.hexlify)(keyBytes));
            if (hexBytes == null || hexBytes === "0x") return null;
            return (0, $1z44X.toUtf8String)(hexBytes);
        });
    }
}
let $6a78d056df40e716$var$defaultFormatter = null;
let $6a78d056df40e716$var$nextPollId = 1;
class $6a78d056df40e716$export$ff3f6dd83125ac45 extends (0, $hMfVR.Provider) {
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */ constructor(network){
        $6a78d056df40e716$var$logger.checkNew(new.target, (0, $hMfVR.Provider));
        super();
        // Events being listened to
        this._events = [];
        this._emitted = {
            block: -2
        };
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $7veey.defineReadOnly)(this, "anyNetwork", network === "any");
        if (this.anyNetwork) network = this.detectNetwork();
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error)=>{});
            // Trigger initial network setting (async)
            this._ready().catch((error)=>{});
        } else {
            const knownNetwork = (0, $7veey.getStatic)(new.target, "getNetwork")(network);
            if (knownNetwork) {
                (0, $7veey.defineReadOnly)(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            } else $6a78d056df40e716$var$logger.throwArgumentError("invalid network", "network", network);
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
    _ready() {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) try {
                    network = yield this._networkPromise;
                } catch (error) {}
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) network = yield this.detectNetwork();
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) $6a78d056df40e716$var$logger.throwError("no network detected", (0, $l6EVj.Logger).errors.UNKNOWN_ERROR, {});
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) this._network = network;
                    else (0, $7veey.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return (0, $7J8He.poll)(()=>{
            return this._ready().then((network)=>{
                return network;
            }, (error)=>{
                // If the network isn't running yet, we will wait
                if (error.code === (0, $l6EVj.Logger).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if ($6a78d056df40e716$var$defaultFormatter == null) $6a78d056df40e716$var$defaultFormatter = new (0, $jqMZF.Formatter)();
        return $6a78d056df40e716$var$defaultFormatter;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return (0, $eDBOW.getNetwork)(network == null ? "homestead" : network);
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) // While there are pending internal block requests...
            while(this._internalBlockNumber){
                // ..."remember" which fetch we started with
                const internalBlockNumber = this._internalBlockNumber;
                try {
                    // Check the result is not too stale
                    const result = yield internalBlockNumber;
                    if ($6a78d056df40e716$var$getTime() - result.respTime <= maxAge) return result.blockNumber;
                    break;
                } catch (error) {
                    // The fetch rejected; if we are the first to get the
                    // rejection, drop through so we replace it with a new
                    // fetch; all others blocked will then get that fetch
                    // which won't match the one they "remembered" and loop
                    if (this._internalBlockNumber === internalBlockNumber) break;
                }
            }
            const reqTime = $6a78d056df40e716$var$getTime();
            const checkInternalBlockNumber = (0, $7veey.resolveProperties)({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network)=>null, (error)=>error)
            }).then(({ blockNumber: blockNumber, networkError: networkError })=>{
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
                    throw networkError;
                }
                const respTime = $6a78d056df40e716$var$getTime();
                blockNumber = (0, $kVZhy.BigNumber).from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) blockNumber = this._maxInternalBlockNumber;
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return {
                    blockNumber: blockNumber,
                    reqTime: reqTime,
                    respTime: respTime
                };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error)=>{
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            const pollId = $6a78d056df40e716$var$nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            } catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
            if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                $6a78d056df40e716$var$logger.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", $6a78d056df40e716$var$logger.makeError("network block skew detected", (0, $l6EVj.Logger).errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            } else // Notify all listener for each block that has passed
            for(let i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key)=>{
                    // The block event does not expire
                    if (key === "block") return;
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") return;
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) delete this._emitted[key];
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
            // Find all transaction hashes we are waiting on
            this._events.forEach((event)=>{
                switch(event.type){
                    case "tx":
                        {
                            const hash = event.hash;
                            let runner = this.getTransactionReceipt(hash).then((receipt)=>{
                                if (!receipt || receipt.blockNumber == null) return null;
                                this._emitted["t:" + hash] = receipt.blockNumber;
                                this.emit(hash, receipt);
                                return null;
                            }).catch((error)=>{
                                this.emit("error", error);
                            });
                            runners.push(runner);
                            break;
                        }
                    case "filter":
                        {
                            const filter = event.filter;
                            filter.fromBlock = this._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            const runner = this.getLogs(filter).then((logs)=>{
                                if (logs.length === 0) return;
                                logs.forEach((log)=>{
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error)=>{
                                this.emit("error", error);
                            });
                            runners.push(runner);
                            break;
                        }
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(()=>{
                this.emit("didPoll", pollId);
            }).catch((error)=>{
                this.emit("error", error);
            });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) this.poll();
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            return $6a78d056df40e716$var$logger.throwError("provider does not support network detection", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield $6a78d056df40e716$var$stall(0);
                    return this._network;
                }
                const error = $6a78d056df40e716$var$logger.makeError("underlying network changed", (0, $l6EVj.Logger).errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber)=>{
            this._setFastBlockNumber(blockNumber);
        }, (error)=>{});
        return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
    }
    get polling() {
        return this._poller != null;
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(()=>{
                this.poll();
            }, this.pollingInterval);
            if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(()=>{
                this.poll();
                // We block additional polls until the polling interval
                // is done, to prevent overwhelming the poll function
                this._bootstrapPoll = setTimeout(()=>{
                    // If polling was disabled, something may require a poke
                    // since starting the bootstrap poll and it was disabled
                    if (!this._poller) this.poll();
                    // Clear out the bootstrap so we can do another
                    this._bootstrapPoll = null;
                }, this.pollingInterval);
            }, 0);
        } else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(()=>{
                this.poll();
            }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = $6a78d056df40e716$var$getTime();
        // Stale block number, request a newer value
        if (now - this._fastQueryDate > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber)=>{
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) this._fastBlockNumber = blockNumber;
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
        // Update the time we updated the blocknumber
        this._fastQueryDate = $6a78d056df40e716$var$getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            return this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) return receipt;
            // Poll until the receipt is good...
            return new Promise((resolve, reject)=>{
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function() {
                    if (done) return true;
                    done = true;
                    cancelFuncs.forEach((func)=>{
                        func();
                    });
                    return false;
                };
                const minedHandler = (receipt)=>{
                    if (receipt.confirmations < confirmations) return;
                    if (alreadyDone()) return;
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(()=>{
                    this.removeListener(transactionHash, minedHandler);
                });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber)=>$6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
                            if (done) return;
                            // Wait 1 second; this is only used in the case of a fault, so
                            // we will trade off a little bit of latency for more consistent
                            // results and fewer JSON-RPC calls
                            yield $6a78d056df40e716$var$stall(1000);
                            this.getTransactionCount(replaceable.from).then((nonce)=>$6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
                                    if (done) return;
                                    if (nonce <= replaceable.nonce) lastBlockNumber = blockNumber;
                                    else {
                                        // First check if the transaction was mined
                                        {
                                            const mined = yield this.getTransaction(transactionHash);
                                            if (mined && mined.blockNumber != null) return;
                                        }
                                        // First time scanning. We start a little earlier for some
                                        // wiggle room here to handle the eventually consistent nature
                                        // of blockchain (e.g. the getTransactionCount was for a
                                        // different block)
                                        if (scannedBlock == null) {
                                            scannedBlock = lastBlockNumber - 3;
                                            if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                        }
                                        while(scannedBlock <= blockNumber){
                                            if (done) return;
                                            const block = yield this.getBlockWithTransactions(scannedBlock);
                                            for(let ti = 0; ti < block.transactions.length; ti++){
                                                const tx = block.transactions[ti];
                                                // Successfully mined!
                                                if (tx.hash === transactionHash) return;
                                                // Matches our transaction from and nonce; its a replacement
                                                if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                                    if (done) return;
                                                    // Get the receipt of the replacement
                                                    const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                                    // Already resolved or rejected (prolly a timeout)
                                                    if (alreadyDone()) return;
                                                    // The reason we were replaced
                                                    let reason = "replaced";
                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                    // Explain why we were replaced
                                                    reject($6a78d056df40e716$var$logger.makeError("transaction was replaced", (0, $l6EVj.Logger).errors.TRANSACTION_REPLACED, {
                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                        reason: reason,
                                                        replacement: this._wrapTransaction(tx),
                                                        hash: transactionHash,
                                                        receipt: receipt
                                                    }));
                                                    return;
                                                }
                                            }
                                            scannedBlock++;
                                        }
                                    }
                                    if (done) return;
                                    this.once("block", replaceHandler);
                                }), (error)=>{
                                if (done) return;
                                this.once("block", replaceHandler);
                            });
                        });
                    if (done) return;
                    this.once("block", replaceHandler);
                    cancelFuncs.push(()=>{
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof timeout === "number" && timeout > 0) {
                    const timer = setTimeout(()=>{
                        if (alreadyDone()) return;
                        reject($6a78d056df40e716$var$logger.makeError("timeout exceeded", (0, $l6EVj.Logger).errors.TIMEOUT, {
                            timeout: timeout
                        }));
                    }, timeout);
                    if (timer.unref) timer.unref();
                    cancelFuncs.push(()=>{
                        clearTimeout(timer);
                    });
                }
            });
        });
    }
    getBlockNumber() {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return (0, $kVZhy.BigNumber).from(result);
            } catch (error) {
                return $6a78d056df40e716$var$logger.throwError("bad result from backend", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result: result,
                    error: error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $7veey.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return (0, $kVZhy.BigNumber).from(result);
            } catch (error) {
                return $6a78d056df40e716$var$logger.throwError("bad result from backend", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
                    method: "getBalance",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $7veey.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return (0, $kVZhy.BigNumber).from(result).toNumber();
            } catch (error) {
                return $6a78d056df40e716$var$logger.throwError("bad result from backend", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $7veey.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return (0, $kniO8.hexlify)(result);
            } catch (error) {
                return $6a78d056df40e716$var$logger.throwError("bad result from backend", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
                    method: "getCode",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $7veey.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p)=>(0, $kniO8.hexValue)(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return (0, $kniO8.hexlify)(result);
            } catch (error) {
                return $6a78d056df40e716$var$logger.throwError("bad result from backend", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && (0, $kniO8.hexDataLength)(hash) !== 32) throw new Error("invalid response - sendTransaction");
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) $6a78d056df40e716$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $l6EVj.Logger).errors.UNKNOWN_ERROR, {
            expectedHash: tx.hash,
            returnedHash: hash
        });
        result.wait = (confirms, timeout)=>$6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
                if (confirms == null) confirms = 1;
                if (timeout == null) timeout = 0;
                // Get the details to detect replacement
                let replacement = undefined;
                if (confirms !== 0 && startBlock != null) replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock: startBlock
                };
                const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
                if (receipt == null && confirms === 0) return null;
                // No longer pending, allow the polling loop to garbage collect this
                this._emitted["t:" + tx.hash] = receipt.blockNumber;
                if (receipt.status === 0) $6a78d056df40e716$var$logger.throwError("transaction failed", (0, $l6EVj.Logger).errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
                return receipt;
            });
        return result;
    }
    sendTransaction(signedTransaction) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then((t)=>(0, $kniO8.hexlify)(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) tx.confirmations = 0;
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", {
                    signedTransaction: hexTx
                });
                return this._wrapTransaction(tx, hash, blockNumber);
            } catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            const values = yield transaction;
            const tx = {};
            [
                "from",
                "to"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? this._getAddress(v) : null);
            });
            [
                "gasLimit",
                "gasPrice",
                "maxFeePerGas",
                "maxPriorityFeePerGas",
                "value"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $kVZhy.BigNumber).from(v) : null);
            });
            [
                "type"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v != null ? v : null);
            });
            if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
            [
                "data"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $kniO8.hexlify)(v) : null);
            });
            return this.formatter.transactionRequest((yield (0, $7veey.resolveProperties)(tx)));
        });
    }
    _getFilter(filter) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            filter = yield filter;
            const result = {};
            if (filter.address != null) result.address = this._getAddress(filter.address);
            [
                "blockHash",
                "topics"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = filter[key];
            });
            [
                "fromBlock",
                "toBlock"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter((yield (0, $7veey.resolveProperties)(result)));
        });
    }
    call(transaction, blockTag) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $7veey.resolveProperties)({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("call", params);
            try {
                return (0, $kniO8.hexlify)(result);
            } catch (error) {
                return $6a78d056df40e716$var$logger.throwError("bad result from backend", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
                    method: "call",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    estimateGas(transaction) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $7veey.resolveProperties)({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return (0, $kVZhy.BigNumber).from(result);
            } catch (error) {
                return $6a78d056df40e716$var$logger.throwError("bad result from backend", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            addressOrName = yield addressOrName;
            if (typeof addressOrName !== "string") $6a78d056df40e716$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            const address = yield this.resolveName(addressOrName);
            if (address == null) $6a78d056df40e716$var$logger.throwError("ENS name not configured", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `resolveName(${JSON.stringify(addressOrName)})`
            });
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if ((0, $kniO8.isHexString)(blockHashOrBlockTag, 32)) params.blockHash = blockHashOrBlockTag;
            else try {
                params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                if ((0, $kniO8.isHexString)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
            } catch (error) {
                $6a78d056df40e716$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
            }
            return (0, $7J8He.poll)(()=>$6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
                    const block = yield this.perform("getBlock", params);
                    // Block was not found
                    if (block == null) {
                        // For blockhashes, if we didn't say it existed, that blockhash may
                        // not exist. If we did see it though, perhaps from a log, we know
                        // it exists, and this node is just not caught up yet.
                        if (params.blockHash != null) {
                            if (this._emitted["b:" + params.blockHash] == null) return null;
                        }
                        // For block tags, if we are asking for a future block, we return null
                        if (params.blockTag != null) {
                            if (blockNumber > this._emitted.block) return null;
                        }
                        // Retry on the next block
                        return undefined;
                    }
                    // Add transactions
                    if (includeTransactions) {
                        let blockNumber = null;
                        for(let i = 0; i < block.transactions.length; i++){
                            const tx = block.transactions[i];
                            if (tx.blockNumber == null) tx.confirmations = 0;
                            else if (tx.confirmations == null) {
                                if (blockNumber == null) blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                                // Add the confirmations using the fast block number (pessimistic)
                                let confirmations = blockNumber - tx.blockNumber + 1;
                                if (confirmations <= 0) confirmations = 1;
                                tx.confirmations = confirmations;
                            }
                        }
                        const blockWithTxs = this.formatter.blockWithTransactions(block);
                        blockWithTxs.transactions = blockWithTxs.transactions.map((tx)=>this._wrapTransaction(tx));
                        return blockWithTxs;
                    }
                    return this.formatter.block(block);
                }), {
                oncePoll: this
            });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, false);
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, true);
    }
    getTransaction(transactionHash) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $7J8He.poll)(()=>$6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransaction", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    const tx = this.formatter.transactionResponse(result);
                    if (tx.blockNumber == null) tx.confirmations = 0;
                    else if (tx.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - tx.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        tx.confirmations = confirmations;
                    }
                    return this._wrapTransaction(tx);
                }), {
                oncePoll: this
            });
        });
    }
    getTransactionReceipt(transactionHash) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $7J8He.poll)(()=>$6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransactionReceipt", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    // "geth-etc" returns receipts before they are ready
                    if (result.blockHash == null) return undefined;
                    const receipt = this.formatter.receipt(result);
                    if (receipt.blockNumber == null) receipt.confirmations = 0;
                    else if (receipt.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - receipt.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        receipt.confirmations = confirmations;
                    }
                    return receipt;
                }), {
                oncePoll: this
            });
        });
    }
    getLogs(filter) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $7veey.resolveProperties)({
                filter: this._getFilter(filter)
            });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log)=>{
                if (log.removed == null) log.removed = false;
            });
            return (0, $jqMZF.Formatter).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            blockTag = yield blockTag;
            if (typeof blockTag === "number" && blockTag < 0) {
                if (blockTag % 1) $6a78d056df40e716$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) blockNumber = 0;
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const address = yield this._getResolver(name);
                if (address == null) return null;
                return new $6a78d056df40e716$export$8b4c839865b08288(this, address, name);
            } catch (error) {
                if (error.code === (0, $l6EVj.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
        });
    }
    _getResolver(name) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            // Get the resolver from the blockchain
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) $6a78d056df40e716$var$logger.throwError("network does not support ENS", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "ENS",
                network: network.name
            });
            // keccak256("resolver(bytes32)")
            const transaction = {
                to: network.ensAddress,
                data: "0x0178b8bf" + (0, $aafAp.namehash)(name).substring(2)
            };
            try {
                return this.formatter.callAddress((yield this.call(transaction)));
            } catch (error) {
                if (error.code === (0, $l6EVj.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
        });
    }
    resolveName(name) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            } catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if ((0, $kniO8.isHexString)(name)) throw error;
            }
            if (typeof name !== "string") $6a78d056df40e716$var$logger.throwArgumentError("invalid ENS name", "name", name);
            // Get the addr from the resovler
            const resolver = yield this.getResolver(name);
            if (!resolver) return null;
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            address = yield address;
            address = this.formatter.address(address);
            const reverseName = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddress = yield this._getResolver(reverseName);
            if (!resolverAddress) return null;
            // keccak("name(bytes32)")
            let bytes = (0, $kniO8.arrayify)((yield this.call({
                to: resolverAddress,
                data: "0x691f3431" + (0, $aafAp.namehash)(reverseName).substring(2)
            })));
            // Strip off the dynamic string pointer (0x20)
            if (bytes.length < 32 || !(0, $kVZhy.BigNumber).from(bytes.slice(0, 32)).eq(32)) return null;
            bytes = bytes.slice(32);
            // Not a length-prefixed string
            if (bytes.length < 32) return null;
            // Get the length of the string (from the length-prefix)
            const length = (0, $kVZhy.BigNumber).from(bytes.slice(0, 32)).toNumber();
            bytes = bytes.slice(32);
            // Length longer than available data
            if (length > bytes.length) return null;
            const name = (0, $1z44X.toUtf8String)(bytes.slice(0, length));
            // Make sure the reverse record matches the foward record
            const addr = yield this.resolveName(name);
            if (addr != address) return null;
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return $6a78d056df40e716$var$__awaiter(this, void 0, void 0, function*() {
            let resolver = null;
            if ((0, $kniO8.isHexString)(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const reverseName = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(reverseName);
                if (!resolverAddress) return null;
                resolver = new $6a78d056df40e716$export$8b4c839865b08288(this, resolverAddress, "_", address);
            } else {
                // ENS name; forward lookup
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) return null;
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) return null;
            return avatar.url;
        });
    }
    perform(method, params) {
        return $6a78d056df40e716$var$logger.throwError(method + " not implemented", (0, $l6EVj.Logger).errors.NOT_IMPLEMENTED, {
            operation: method
        });
    }
    _startEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _stopEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _addEventListener(eventName, listener, once) {
        const event = new $6a78d056df40e716$export$d61e24a684f9e51($6a78d056df40e716$var$getEventTag(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = $6a78d056df40e716$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag) return true;
            setTimeout(()=>{
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) return this._events.length;
        let eventTag = $6a78d056df40e716$var$getEventTag(eventName);
        return this._events.filter((event)=>{
            return event.tag === eventTag;
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) return this._events.map((event)=>event.listener);
        let eventTag = $6a78d056df40e716$var$getEventTag(eventName);
        return this._events.filter((event)=>event.tag === eventTag).map((event)=>event.listener);
    }
    off(eventName, listener) {
        if (listener == null) return this.removeAllListeners(eventName);
        const stopped = [];
        let found = false;
        let eventTag = $6a78d056df40e716$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag || event.listener != listener) return true;
            if (found) return true;
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        } else {
            const eventTag = $6a78d056df40e716$var$getEventTag(eventName);
            this._events = this._events.filter((event)=>{
                if (event.tag !== eventTag) return true;
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
}

});
parcelRegister("aafAp", function(module, exports) {

$parcel$export(module.exports, "isValidName", () => $7666eda28d08a8d5$export$cce2300886e7ace6);
$parcel$export(module.exports, "namehash", () => $7666eda28d08a8d5$export$91d651ee363e1209);

var $kniO8 = parcelRequire("kniO8");

var $goqbq = parcelRequire("goqbq");
var $1z44X = parcelRequire("1z44X");

var $jGTTU = parcelRequire("jGTTU");

var $l6EVj = parcelRequire("l6EVj");

var $l1Hdc = parcelRequire("l1Hdc");
const $7666eda28d08a8d5$var$logger = new (0, $l6EVj.Logger)((0, $l1Hdc.version));
const $7666eda28d08a8d5$var$Zeros = new Uint8Array(32);
$7666eda28d08a8d5$var$Zeros.fill(0);
const $7666eda28d08a8d5$var$Partition = new RegExp("^((.*)\\.)?([^.]+)$");
function $7666eda28d08a8d5$export$cce2300886e7ace6(name) {
    try {
        const comps = name.split(".");
        for(let i = 0; i < comps.length; i++){
            if ((0, $goqbq.nameprep)(comps[i]).length === 0) throw new Error("empty");
        }
        return true;
    } catch (error) {}
    return false;
}
function $7666eda28d08a8d5$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $7666eda28d08a8d5$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    let current = name;
    let result = $7666eda28d08a8d5$var$Zeros;
    while(current.length){
        const partition = current.match($7666eda28d08a8d5$var$Partition);
        if (partition == null || partition[2] === "") $7666eda28d08a8d5$var$logger.throwArgumentError("invalid ENS address; missing component", "name", name);
        const label = (0, $1z44X.toUtf8Bytes)((0, $goqbq.nameprep)(partition[3]));
        result = (0, $jGTTU.keccak256)((0, $kniO8.concat)([
            result,
            (0, $jGTTU.keccak256)(label)
        ]));
        current = partition[2] || "";
    }
    return (0, $kniO8.hexlify)(result);
}

});
parcelRegister("goqbq", function(module, exports) {

$parcel$export(module.exports, "nameprep", () => $bef332b2c8bdd876$export$94f0b6f93c619bc);

var $1z44X = parcelRequire("1z44X");
"use strict";
function $bef332b2c8bdd876$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    let result = [];
    for(let i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $bef332b2c8bdd876$var$createTable(data, func) {
    if (!func) func = function(value) {
        return [
            parseInt(value, 16)
        ];
    };
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair)=>{
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $bef332b2c8bdd876$var$createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v)=>{
        let comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $bef332b2c8bdd876$var$matchMap(value, ranges) {
    let lo = 0;
    for(let i = 0; i < ranges.length; i++){
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
const $bef332b2c8bdd876$var$Table_A_1_ranges = $bef332b2c8bdd876$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const $bef332b2c8bdd876$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v)=>parseInt(v, 16));
const $bef332b2c8bdd876$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
const $bef332b2c8bdd876$var$Table_B_2_lut_abs = $bef332b2c8bdd876$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const $bef332b2c8bdd876$var$Table_B_2_lut_rel = $bef332b2c8bdd876$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const $bef332b2c8bdd876$var$Table_B_2_complex = $bef332b2c8bdd876$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $bef332b2c8bdd876$var$bytes2);
const $bef332b2c8bdd876$var$Table_C_ranges = $bef332b2c8bdd876$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $bef332b2c8bdd876$var$flatten(values) {
    return values.reduce((accum, value)=>{
        value.forEach((value)=>{
            accum.push(value);
        });
        return accum;
    }, []);
}
function $bef332b2c8bdd876$export$d1ae0d802533bef0(codepoint) {
    return !!$bef332b2c8bdd876$var$matchMap(codepoint, $bef332b2c8bdd876$var$Table_A_1_ranges);
}
function $bef332b2c8bdd876$export$9630a1f26a43b76c(codepoint) {
    let range = $bef332b2c8bdd876$var$matchMap(codepoint, $bef332b2c8bdd876$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    let codes = $bef332b2c8bdd876$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    let shift = $bef332b2c8bdd876$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    let complex = $bef332b2c8bdd876$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $bef332b2c8bdd876$export$e07a548cae6d1553(codepoint) {
    return !!$bef332b2c8bdd876$var$matchMap(codepoint, $bef332b2c8bdd876$var$Table_C_ranges);
}
function $bef332b2c8bdd876$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    let codes = (0, $1z44X.toUtf8CodePoints)(value);
    codes = $bef332b2c8bdd876$var$flatten(codes.map((code)=>{
        // Substitute Table B.1 (Maps to Nothing)
        if ($bef332b2c8bdd876$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = $bef332b2c8bdd876$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $1z44X.toUtf8CodePoints)((0, $1z44X._toUtf8String)(codes), (0, $1z44X.UnicodeNormalizationForm).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code)=>{
        if ($bef332b2c8bdd876$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code)=>{
        if ($bef332b2c8bdd876$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    let name = (0, $1z44X._toUtf8String)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    // IDNA: 4.2.4
    if (name.length > 63) throw new Error("too long");
    return name;
}

});


parcelRegister("7J8He", function(module, exports) {

$parcel$export(module.exports, "_fetchData", () => $5a037b4173e3462e$export$e37fa27017c6c012);
$parcel$export(module.exports, "fetchJson", () => $5a037b4173e3462e$export$6d71b655afe1638d);
$parcel$export(module.exports, "poll", () => $5a037b4173e3462e$export$e0c10349b2c5e1d4);

var $hyB5G = parcelRequire("hyB5G");

var $kniO8 = parcelRequire("kniO8");

var $7veey = parcelRequire("7veey");

var $1z44X = parcelRequire("1z44X");

var $l6EVj = parcelRequire("l6EVj");

var $7DVJG = parcelRequire("7DVJG");

var $hqwMq = parcelRequire("hqwMq");
"use strict";
var $5a037b4173e3462e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $5a037b4173e3462e$var$logger = new (0, $l6EVj.Logger)((0, $7DVJG.version));
function $5a037b4173e3462e$var$staller(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $5a037b4173e3462e$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $kniO8.isBytesLike)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $1z44X.toUtf8String)(value);
        } catch (error) {}
        return (0, $kniO8.hexlify)(value);
    }
    return value;
}
function $5a037b4173e3462e$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $5a037b4173e3462e$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    const throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $5a037b4173e3462e$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET"
    };
    let allow304 = false;
    let timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $5a037b4173e3462e$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(const key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $5a037b4173e3462e$var$logger.throwError("basic authentication requires a secure https url", (0, $l6EVj.Logger).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $hyB5G.encode)((0, $1z44X.toUtf8Bytes)(authorization))
            };
        }
    }
    const reData = new RegExp("^data:([a-z0-9-]+/[a-z0-9-]+);base64,(.*)$", "i");
    const dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        const response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1]
            },
            body: (0, $hyB5G.decode)(dataMatch[2])
        };
        let result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $5a037b4173e3462e$var$logger.throwError("processing response error", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
            body: $5a037b4173e3462e$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key)=>{
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = function() {
        let timer = null;
        const promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                reject($5a037b4173e3462e$var$logger.makeError("timeout", (0, $l6EVj.Logger).errors.TIMEOUT, {
                    requestBody: $5a037b4173e3462e$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        const cancel = function() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    const runningFetch = function() {
        return $5a037b4173e3462e$var$__awaiter(this, void 0, void 0, function*() {
            for(let attempt = 0; attempt < attemptLimit; attempt++){
                let response = null;
                try {
                    response = yield (0, $hqwMq.getUrl)(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        } else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                                else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling 429");
                                yield $5a037b4173e3462e$var$staller(stall);
                                continue;
                            }
                        }
                    }
                } catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        $5a037b4173e3462e$var$logger.throwError("missing response", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
                            requestBody: $5a037b4173e3462e$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) body = null;
                else if (response.statusCode < 200 || response.statusCode >= 300) {
                    runningTimeout.cancel();
                    $5a037b4173e3462e$var$logger.throwError("bad response", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: $5a037b4173e3462e$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        requestBody: $5a037b4173e3462e$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) try {
                    const result = yield processFunc(body, response);
                    runningTimeout.cancel();
                    return result;
                } catch (error) {
                    // Allow the processFunc to trigger a throttle
                    if (error.throttleRetry && attempt < attemptLimit) {
                        let tryAgain = true;
                        if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                        if (tryAgain) {
                            const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                            //console.log("Stalling callback");
                            yield $5a037b4173e3462e$var$staller(timeout);
                            continue;
                        }
                    }
                    runningTimeout.cancel();
                    $5a037b4173e3462e$var$logger.throwError("processing response error", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
                        body: $5a037b4173e3462e$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        error: error,
                        requestBody: $5a037b4173e3462e$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return $5a037b4173e3462e$var$logger.throwError("failed response", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
                requestBody: $5a037b4173e3462e$var$bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $5a037b4173e3462e$export$6d71b655afe1638d(connection, json, processFunc) {
    let processJsonFunc = (value, response)=>{
        let result = null;
        if (value != null) try {
            result = JSON.parse((0, $1z44X.toUtf8String)(value));
        } catch (error) {
            $5a037b4173e3462e$var$logger.throwError("invalid JSON", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = (0, $1z44X.toUtf8Bytes)(json);
        // Create a connection with the content-type set for JSON
        const updated = typeof connection === "string" ? {
            url: connection
        } : (0, $7veey.shallowCopy)(connection);
        if (updated.headers) {
            const hasContentType = Object.keys(updated.headers).filter((k)=>k.toLowerCase() === "content-type").length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $7veey.shallowCopy)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $5a037b4173e3462e$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $5a037b4173e3462e$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $7veey.shallowCopy)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = ()=>{
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(()=>{
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}

});
parcelRegister("hyB5G", function(module, exports) {

$parcel$export(module.exports, "decode", () => $cc82621498fc0060$export$2f872c0f2117be69);
$parcel$export(module.exports, "encode", () => $cc82621498fc0060$export$c564cdbbe6da493);

var $kniO8 = parcelRequire("kniO8");
"use strict";
function $cc82621498fc0060$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    const data = [];
    for(let i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $kniO8.arrayify)(data);
}
function $cc82621498fc0060$export$c564cdbbe6da493(data) {
    data = (0, $kniO8.arrayify)(data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}

});

parcelRegister("7DVJG", function(module, exports) {

$parcel$export(module.exports, "version", () => $5908f60b5ff0a07a$export$83d89fbfd8236492);
const $5908f60b5ff0a07a$export$83d89fbfd8236492 = "web/5.5.1";

});

parcelRegister("hqwMq", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $cafe4ad4277dda6c$export$94df0e59ebebf4a7);

var $kniO8 = parcelRequire("kniO8");
"use strict";
var $cafe4ad4277dda6c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $cafe4ad4277dda6c$export$94df0e59ebebf4a7(href, options) {
    return $cafe4ad4277dda6c$var$__awaiter(this, void 0, void 0, function*() {
        if (options == null) options = {};
        const request = {
            method: options.method || "GET",
            headers: options.headers || {},
            body: options.body || undefined
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) response.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        else response.headers.keys().forEach((key)=>{
            headers[key.toLowerCase()] = response.headers.get(key);
        });
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: (0, $kniO8.arrayify)(new Uint8Array(body))
        };
    });
}

});


parcelRegister("7CtKW", function(module, exports) {
"use strict";
var $58c329f65c659a19$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $58c329f65c659a19$var$ALPHABET_MAP = {};
for(var $58c329f65c659a19$var$z = 0; $58c329f65c659a19$var$z < $58c329f65c659a19$var$ALPHABET.length; $58c329f65c659a19$var$z++){
    var $58c329f65c659a19$var$x = $58c329f65c659a19$var$ALPHABET.charAt($58c329f65c659a19$var$z);
    if ($58c329f65c659a19$var$ALPHABET_MAP[$58c329f65c659a19$var$x] !== undefined) throw new TypeError($58c329f65c659a19$var$x + " is ambiguous");
    $58c329f65c659a19$var$ALPHABET_MAP[$58c329f65c659a19$var$x] = $58c329f65c659a19$var$z;
}
function $58c329f65c659a19$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $58c329f65c659a19$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $58c329f65c659a19$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $58c329f65c659a19$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $58c329f65c659a19$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $58c329f65c659a19$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $58c329f65c659a19$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $58c329f65c659a19$var$polymodStep(chk) ^ x;
        result += $58c329f65c659a19$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $58c329f65c659a19$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $58c329f65c659a19$var$ALPHABET.charAt(v);
    }
    return result;
}
function $58c329f65c659a19$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $58c329f65c659a19$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $58c329f65c659a19$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $58c329f65c659a19$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $58c329f65c659a19$var$decodeUnsafe() {
    var res = $58c329f65c659a19$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $58c329f65c659a19$var$decode(str) {
    var res = $58c329f65c659a19$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $58c329f65c659a19$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $58c329f65c659a19$var$toWordsUnsafe(bytes) {
    var res = $58c329f65c659a19$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $58c329f65c659a19$var$toWords(bytes) {
    var res = $58c329f65c659a19$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $58c329f65c659a19$var$fromWordsUnsafe(words) {
    var res = $58c329f65c659a19$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $58c329f65c659a19$var$fromWords(words) {
    var res = $58c329f65c659a19$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $58c329f65c659a19$var$decodeUnsafe,
    decode: $58c329f65c659a19$var$decode,
    encode: $58c329f65c659a19$var$encode,
    toWordsUnsafe: $58c329f65c659a19$var$toWordsUnsafe,
    toWords: $58c329f65c659a19$var$toWords,
    fromWordsUnsafe: $58c329f65c659a19$var$fromWordsUnsafe,
    fromWords: $58c329f65c659a19$var$fromWords
};

});

parcelRegister("jyK7L", function(module, exports) {

$parcel$export(module.exports, "version", () => $e3d4f89f9b4b91dd$export$83d89fbfd8236492);
const $e3d4f89f9b4b91dd$export$83d89fbfd8236492 = "providers/5.5.2";

});

parcelRegister("jqMZF", function(module, exports) {

$parcel$export(module.exports, "Formatter", () => $e2567329aaff23c7$export$a06636add2a09fd8);
$parcel$export(module.exports, "isCommunityResourcable", () => $e2567329aaff23c7$export$3091239f5b20b896);
$parcel$export(module.exports, "isCommunityResource", () => $e2567329aaff23c7$export$d93d5f61c2498b6);
$parcel$export(module.exports, "showThrottleMessage", () => $e2567329aaff23c7$export$4c41bd49e82e82ab);

var $1qOxQ = parcelRequire("1qOxQ");

var $kVZhy = parcelRequire("kVZhy");

var $kniO8 = parcelRequire("kniO8");

var $3aKAP = parcelRequire("3aKAP");

var $7veey = parcelRequire("7veey");

var $equjW = parcelRequire("equjW");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");
"use strict";
const $e2567329aaff23c7$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
class $e2567329aaff23c7$export$a06636add2a09fd8 {
    constructor(){
        $e2567329aaff23c7$var$logger.checkNew(new.target, $e2567329aaff23c7$export$a06636add2a09fd8);
        this.formats = this.getDefaultFormats();
    }
    getDefaultFormats() {
        const formats = {};
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v)=>{
            return this.data(v, true);
        };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null),
            blockHash: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(hash, null),
            blockNumber: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(number, null),
            transactionIndex: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(number, null),
            confirmations: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(this.uint256),
            s: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(this.uint256),
            v: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(number),
            creates: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(address, null),
            raw: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(data)
        };
        formats.transactionRequest = {
            from: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(address),
            nonce: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(number),
            gasLimit: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(bigNumber),
            gasPrice: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(bigNumber),
            to: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(address),
            value: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(bigNumber),
            data: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(strictData),
            type: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(number),
            accessList: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null)
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: $e2567329aaff23c7$export$a06636add2a09fd8.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash
        };
        formats.receipt = {
            to: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(this.address, null),
            from: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(this.address, null),
            contractAddress: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: $e2567329aaff23c7$export$a06636add2a09fd8.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(bigNumber),
            status: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(number),
            type: type
        };
        formats.block = {
            hash: hash,
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: address,
            extraData: data,
            transactions: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull($e2567329aaff23c7$export$a06636add2a09fd8.arrayOf(hash)),
            baseFeePerGas: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(bigNumber)
        };
        formats.blockWithTransactions = (0, $7veey.shallowCopy)(formats.block);
        formats.blockWithTransactions.transactions = $e2567329aaff23c7$export$a06636add2a09fd8.allowNull($e2567329aaff23c7$export$a06636add2a09fd8.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            toBlock: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            blockHash: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(hash, undefined),
            address: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(address, undefined),
            topics: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(this.topics.bind(this), undefined)
        };
        formats.filterLog = {
            blockNumber: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(number),
            blockHash: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(hash),
            transactionIndex: number,
            removed: $e2567329aaff23c7$export$a06636add2a09fd8.allowNull(this.boolean.bind(this)),
            address: address,
            data: $e2567329aaff23c7$export$a06636add2a09fd8.allowFalsish(data, "0x"),
            topics: $e2567329aaff23c7$export$a06636add2a09fd8.arrayOf(hash),
            transactionHash: hash,
            logIndex: number
        };
        return formats;
    }
    accessList(accessList) {
        return (0, $equjW.accessListify)(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") return 0;
        return (0, $kVZhy.BigNumber).from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) return 0;
        return (0, $kVZhy.BigNumber).from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return (0, $kVZhy.BigNumber).from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") {
            value = value.toLowerCase();
            if (value === "true") return true;
            if (value === "false") return false;
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof value === "string") {
            if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
            if ((0, $kniO8.isHexString)(value)) return value.toLowerCase();
        }
        return $e2567329aaff23c7$var$logger.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return (0, $1qOxQ.getAddress)(value);
    }
    callAddress(value) {
        if (!(0, $kniO8.isHexString)(value, 32)) return null;
        const address = (0, $1qOxQ.getAddress)((0, $kniO8.hexDataSlice)(value, 12));
        return address === (0, $3aKAP.AddressZero) ? null : address;
    }
    contractAddress(value) {
        return (0, $1qOxQ.getContractAddress)(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) return "latest";
        if (blockTag === "earliest") return "0x0";
        if (blockTag === "latest" || blockTag === "pending") return blockTag;
        if (typeof blockTag === "number" || (0, $kniO8.isHexString)(blockTag)) return (0, $kniO8.hexValue)(blockTag);
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if ((0, $kniO8.hexDataLength)(result) !== 32) return $e2567329aaff23c7$var$logger.throwArgumentError("invalid hash", "value", value);
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) return null;
        const v = (0, $kVZhy.BigNumber).from(value);
        try {
            return v.toNumber();
        } catch (error) {}
        return null;
    }
    uint256(value) {
        if (!(0, $kniO8.isHexString)(value)) throw new Error("invalid uint256");
        return (0, $kniO8.hexZeroPad)(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) value.miner = value.author;
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
        const result = $e2567329aaff23c7$export$a06636add2a09fd8.check(format, value);
        result._difficulty = difficulty == null ? null : (0, $kVZhy.BigNumber).from(difficulty);
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return $e2567329aaff23c7$export$a06636add2a09fd8.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && (0, $kVZhy.BigNumber).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
        // Rename input to data
        if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
        const result = $e2567329aaff23c7$export$a06636add2a09fd8.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if ((0, $kniO8.isHexString)(chainId)) chainId = (0, $kVZhy.BigNumber).from(chainId).toNumber();
            result.chainId = chainId;
        } else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) chainId = transaction.chainId;
            if ((0, $kniO8.isHexString)(chainId)) chainId = (0, $kVZhy.BigNumber).from(chainId).toNumber();
            if (typeof chainId !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) chainId = 0;
                chainId = parseInt(chainId);
            }
            if (typeof chainId !== "number") chainId = 0;
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
        return result;
    }
    transaction(value) {
        return (0, $equjW.parse)(value);
    }
    receiptLog(value) {
        return $e2567329aaff23c7$export$a06636add2a09fd8.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = $e2567329aaff23c7$export$a06636add2a09fd8.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = (0, $kVZhy.BigNumber).from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && result.status !== value) $e2567329aaff23c7$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                        root: result.root,
                        status: result.status
                    });
                    result.status = value;
                    delete result.root;
                } else $e2567329aaff23c7$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
            } else if (result.root.length !== 66) // Must be a valid bytes32
            $e2567329aaff23c7$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
        }
        if (result.status != null) result.byzantium = true;
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) return value.map((v)=>this.topics(v));
        else if (value != null) return this.hash(value, true);
        return null;
    }
    filter(value) {
        return $e2567329aaff23c7$export$a06636add2a09fd8.check(this.formats.filter, value);
    }
    filterLog(value) {
        return $e2567329aaff23c7$export$a06636add2a09fd8.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for(const key in format)try {
            const value = format[key](object[key]);
            if (value !== undefined) result[key] = value;
        } catch (error) {
            error.checkKey = key;
            error.checkValue = object[key];
            throw error;
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return function(value) {
            if (value == null) return nullValue;
            return format(value);
        };
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return function(value) {
            if (!value) return replaceValue;
            return format(value);
        };
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return function(array) {
            if (!Array.isArray(array)) throw new Error("not an array");
            const result = [];
            array.forEach(function(value) {
                result.push(format(value));
            });
            return result;
        };
    }
}
function $e2567329aaff23c7$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $e2567329aaff23c7$export$d93d5f61c2498b6(value) {
    return $e2567329aaff23c7$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
let $e2567329aaff23c7$var$throttleMessage = false;
function $e2567329aaff23c7$export$4c41bd49e82e82ab() {
    if ($e2567329aaff23c7$var$throttleMessage) return;
    $e2567329aaff23c7$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}

});


parcelRegister("7z4rz", function(module, exports) {

$parcel$export(module.exports, "AlchemyWebSocketProvider", () => $581f3fba649af87f$export$f6c13301c7b76371);
$parcel$export(module.exports, "AlchemyProvider", () => $581f3fba649af87f$export$999cc40da3fbc6f);

var $7veey = parcelRequire("7veey");

var $jqMZF = parcelRequire("jqMZF");

var $70jvO = parcelRequire("70jvO");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");

var $4HuFM = parcelRequire("4HuFM");
"use strict";
const $581f3fba649af87f$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
const $581f3fba649af87f$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class $581f3fba649af87f$export$f6c13301c7b76371 extends (0, $70jvO.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $581f3fba649af87f$export$999cc40da3fbc6f(network, apiKey);
        const url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        super(url, provider.network);
        (0, $7veey.defineReadOnly)(this, "apiKey", provider.apiKey);
    }
    isCommunityResource() {
        return this.apiKey === $581f3fba649af87f$var$defaultApiKey;
    }
}
class $581f3fba649af87f$export$999cc40da3fbc6f extends (0, $4HuFM.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $581f3fba649af87f$export$f6c13301c7b76371(network, apiKey);
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $581f3fba649af87f$var$defaultApiKey;
        if (apiKey && typeof apiKey !== "string") $581f3fba649af87f$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "eth-mainnet.alchemyapi.io/v2/";
                break;
            case "ropsten":
                host = "eth-ropsten.alchemyapi.io/v2/";
                break;
            case "rinkeby":
                host = "eth-rinkeby.alchemyapi.io/v2/";
                break;
            case "goerli":
                host = "eth-goerli.alchemyapi.io/v2/";
                break;
            case "kovan":
                host = "eth-kovan.alchemyapi.io/v2/";
                break;
            case "matic":
                host = "polygon-mainnet.g.alchemy.com/v2/";
                break;
            case "maticmum":
                host = "polygon-mumbai.g.alchemy.com/v2/";
                break;
            case "arbitrum":
                host = "arb-mainnet.g.alchemy.com/v2/";
                break;
            case "arbitrum-rinkeby":
                host = "arb-rinkeby.g.alchemy.com/v2/";
                break;
            case "optimism":
                host = "opt-mainnet.g.alchemy.com/v2/";
                break;
            case "optimism-kovan":
                host = "opt-kovan.g.alchemy.com/v2/";
                break;
            default:
                $581f3fba649af87f$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return {
            allowGzip: true,
            url: "https://" + host + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey === $581f3fba649af87f$var$defaultApiKey) (0, $jqMZF.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
    }
    isCommunityResource() {
        return this.apiKey === $581f3fba649af87f$var$defaultApiKey;
    }
}

});
parcelRegister("70jvO", function(module, exports) {

$parcel$export(module.exports, "WebSocketProvider", () => $5197ab2a09298583$export$bfafe629242f30bd);

var $kVZhy = parcelRequire("kVZhy");

var $7veey = parcelRequire("7veey");

var $3pw3F = parcelRequire("3pw3F");

var $8uf4g = parcelRequire("8uf4g");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");
"use strict";
var $5197ab2a09298583$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $5197ab2a09298583$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ let $5197ab2a09298583$var$NextId = 1;
class $5197ab2a09298583$export$bfafe629242f30bd extends (0, $3pw3F.JsonRpcProvider) {
    constructor(url, network){
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $5197ab2a09298583$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        super(url, network);
        this._pollingInterval = -1;
        this._wsReady = false;
        (0, $7veey.defineReadOnly)(this, "_websocket", new (0, $8uf4g.WebSocket)(this.connection.url));
        (0, $7veey.defineReadOnly)(this, "_requests", {});
        (0, $7veey.defineReadOnly)(this, "_subs", {});
        (0, $7veey.defineReadOnly)(this, "_subIds", {});
        (0, $7veey.defineReadOnly)(this, "_detectNetwork", super.detectNetwork());
        // Stall sending requests until the socket is open...
        this._websocket.onopen = ()=>{
            this._wsReady = true;
            Object.keys(this._requests).forEach((id)=>{
                this._websocket.send(this._requests[id].payload);
            });
        };
        this._websocket.onmessage = (messageEvent)=>{
            const data = messageEvent.data;
            const result = JSON.parse(data);
            if (result.id != null) {
                const id = String(result.id);
                const request = this._requests[id];
                delete this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: this
                    });
                } else {
                    let error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $7veey.defineReadOnly)(error, "code", result.error.code || null);
                        (0, $7veey.defineReadOnly)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: this
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                const sub = this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        const fauxPoll = setInterval(()=>{
            this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
    }
    detectNetwork() {
        return this._detectNetwork;
    }
    get pollingInterval() {
        return 0;
    }
    resetEventsBlock(blockNumber) {
        $5197ab2a09298583$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resetEventBlock"
        });
    }
    set pollingInterval(value) {
        $5197ab2a09298583$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPollingInterval"
        });
    }
    poll() {
        return $5197ab2a09298583$var$__awaiter(this, void 0, void 0, function*() {
            return null;
        });
    }
    set polling(value) {
        if (!value) return;
        $5197ab2a09298583$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPolling"
        });
    }
    send(method, params) {
        const rid = $5197ab2a09298583$var$NextId++;
        return new Promise((resolve, reject)=>{
            function callback(error, result) {
                if (error) return reject(error);
                return resolve(result);
            }
            const payload = JSON.stringify({
                method: method,
                params: params,
                id: rid,
                jsonrpc: "2.0"
            });
            this.emit("debug", {
                action: "request",
                request: JSON.parse(payload),
                provider: this
            });
            this._requests[String(rid)] = {
                callback: callback,
                payload: payload
            };
            if (this._wsReady) this._websocket.send(payload);
        });
    }
    static defaultUrl() {
        return "ws://localhost:8546";
    }
    _subscribe(tag, param, processFunc) {
        return $5197ab2a09298583$var$__awaiter(this, void 0, void 0, function*() {
            let subIdPromise = this._subIds[tag];
            if (subIdPromise == null) {
                subIdPromise = Promise.all(param).then((param)=>{
                    return this.send("eth_subscribe", param);
                });
                this._subIds[tag] = subIdPromise;
            }
            const subId = yield subIdPromise;
            this._subs[subId] = {
                tag: tag,
                processFunc: processFunc
            };
        });
    }
    _startEvent(event) {
        switch(event.type){
            case "block":
                this._subscribe("block", [
                    "newHeads"
                ], (result)=>{
                    const blockNumber = (0, $kVZhy.BigNumber).from(result.number).toNumber();
                    this._emitted.block = blockNumber;
                    this.emit("block", blockNumber);
                });
                break;
            case "pending":
                this._subscribe("pending", [
                    "newPendingTransactions"
                ], (result)=>{
                    this.emit("pending", result);
                });
                break;
            case "filter":
                this._subscribe(event.tag, [
                    "logs",
                    this._getFilter(event.filter)
                ], (result)=>{
                    if (result.removed == null) result.removed = false;
                    this.emit(event.filter, this.formatter.filterLog(result));
                });
                break;
            case "tx":
                {
                    const emitReceipt = (event)=>{
                        const hash = event.hash;
                        this.getTransactionReceipt(hash).then((receipt)=>{
                            if (!receipt) return;
                            this.emit(hash, receipt);
                        });
                    };
                    // In case it is already mined
                    emitReceipt(event);
                    // To keep things simple, we start up a single newHeads subscription
                    // to keep an eye out for transactions we are watching for.
                    // Starting a subscription for an event (i.e. "tx") that is already
                    // running is (basically) a nop.
                    this._subscribe("tx", [
                        "newHeads"
                    ], (result)=>{
                        this._events.filter((e)=>e.type === "tx").forEach(emitReceipt);
                    });
                    break;
                }
            // Nothing is needed
            case "debug":
            case "poll":
            case "willPoll":
            case "didPoll":
            case "error":
                break;
            default:
                console.log("unhandled:", event);
                break;
        }
    }
    _stopEvent(event) {
        let tag = event.tag;
        if (event.type === "tx") {
            // There are remaining transaction event listeners
            if (this._events.filter((e)=>e.type === "tx").length) return;
            tag = "tx";
        } else if (this.listenerCount(event.event)) // There are remaining event listeners
        return;
        const subId = this._subIds[tag];
        if (!subId) return;
        delete this._subIds[tag];
        subId.then((subId)=>{
            if (!this._subs[subId]) return;
            delete this._subs[subId];
            this.send("eth_unsubscribe", [
                subId
            ]);
        });
    }
    destroy() {
        return $5197ab2a09298583$var$__awaiter(this, void 0, void 0, function*() {
            // Wait until we have connected before trying to disconnect
            if (this._websocket.readyState === (0, $8uf4g.WebSocket).CONNECTING) yield new Promise((resolve)=>{
                this._websocket.onopen = function() {
                    resolve(true);
                };
                this._websocket.onerror = function() {
                    resolve(false);
                };
            });
            // Hangup
            // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
            this._websocket.close(1000);
        });
    }
}

});
parcelRegister("3pw3F", function(module, exports) {

$parcel$export(module.exports, "JsonRpcSigner", () => $27bc92fe0e4122fd$export$5f7b5fca3508545a);
$parcel$export(module.exports, "JsonRpcProvider", () => $27bc92fe0e4122fd$export$da28308012bf6748);

var $lLoTq = parcelRequire("lLoTq");

var $kVZhy = parcelRequire("kVZhy");

var $kniO8 = parcelRequire("kniO8");

var $4oRy9 = parcelRequire("4oRy9");

var $7veey = parcelRequire("7veey");

var $1z44X = parcelRequire("1z44X");

var $equjW = parcelRequire("equjW");

var $7J8He = parcelRequire("7J8He");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");

var $98KlH = parcelRequire("98KlH");
"use strict";
var $27bc92fe0e4122fd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $27bc92fe0e4122fd$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
const $27bc92fe0e4122fd$var$errorGas = [
    "call",
    "estimateGas"
];
function $27bc92fe0e4122fd$var$checkError(method, error, params) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $l6EVj.Logger).errors.SERVER_ERROR) {
        const e = error.error;
        if (e && e.message.match("reverted") && (0, $kniO8.isHexString)(e.data)) return e.data;
        $27bc92fe0e4122fd$var$logger.throwError("missing revert data in call exception", (0, $l6EVj.Logger).errors.CALL_EXCEPTION, {
            error: error,
            data: "0x"
        });
    }
    let message = error.message;
    if (error.code === (0, $l6EVj.Logger).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    const transaction = params.transaction || params.signedTransaction;
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit/)) $27bc92fe0e4122fd$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $l6EVj.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce too low/)) $27bc92fe0e4122fd$var$logger.throwError("nonce has already been used", (0, $l6EVj.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced/)) $27bc92fe0e4122fd$var$logger.throwError("replacement fee too low", (0, $l6EVj.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/)) $27bc92fe0e4122fd$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($27bc92fe0e4122fd$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted/)) $27bc92fe0e4122fd$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $l6EVj.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $27bc92fe0e4122fd$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $27bc92fe0e4122fd$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $27bc92fe0e4122fd$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
const $27bc92fe0e4122fd$var$_constructorGuard = {};
class $27bc92fe0e4122fd$export$5f7b5fca3508545a extends (0, $lLoTq.Signer) {
    constructor(constructorGuard, provider, addressOrIndex){
        $27bc92fe0e4122fd$var$logger.checkNew(new.target, $27bc92fe0e4122fd$export$5f7b5fca3508545a);
        super();
        if (constructorGuard !== $27bc92fe0e4122fd$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $7veey.defineReadOnly)(this, "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $7veey.defineReadOnly)(this, "_address", this.provider.formatter.address(addressOrIndex));
            (0, $7veey.defineReadOnly)(this, "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $7veey.defineReadOnly)(this, "_index", addressOrIndex);
            (0, $7veey.defineReadOnly)(this, "_address", null);
        } else $27bc92fe0e4122fd$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
    }
    connect(provider) {
        return $27bc92fe0e4122fd$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new $27bc92fe0e4122fd$var$UncheckedJsonRpcSigner($27bc92fe0e4122fd$var$_constructorGuard, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) return Promise.resolve(this._address);
        return this.provider.send("eth_accounts", []).then((accounts)=>{
            if (accounts.length <= this._index) $27bc92fe0e4122fd$var$logger.throwError("unknown account #" + this._index, (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getAddress"
            });
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = (0, $7veey.shallowCopy)(transaction);
        const fromAddress = this.getAddress().then((address)=>{
            if (address) address = address.toLowerCase();
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = (0, $7veey.shallowCopy)(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then((to)=>$27bc92fe0e4122fd$var$__awaiter(this, void 0, void 0, function*() {
                if (to == null) return null;
                const address = yield this.provider.resolveName(to);
                if (address == null) $27bc92fe0e4122fd$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                return address;
            }));
        return (0, $7veey.resolveProperties)({
            tx: (0, $7veey.resolveProperties)(transaction),
            sender: fromAddress
        }).then(({ tx: tx, sender: sender })=>{
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) $27bc92fe0e4122fd$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            } else tx.from = sender;
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, {
                from: true
            });
            return this.provider.send("eth_sendTransaction", [
                hexTx
            ]).then((hash)=>{
                return hash;
            }, (error)=>{
                return $27bc92fe0e4122fd$var$checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return $27bc92fe0e4122fd$var$logger.throwError("signing transactions is unsupported", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return $27bc92fe0e4122fd$var$__awaiter(this, void 0, void 0, function*() {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield (0, $7J8He.poll)(()=>$27bc92fe0e4122fd$var$__awaiter(this, void 0, void 0, function*() {
                        const tx = yield this.provider.getTransaction(hash);
                        if (tx === null) return undefined;
                        return this.provider._wrapTransaction(tx, hash, blockNumber);
                    }), {
                    oncePoll: this.provider
                });
            } catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return $27bc92fe0e4122fd$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $1z44X.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            return yield this.provider.send("personal_sign", [
                (0, $kniO8.hexlify)(data),
                address.toLowerCase()
            ]);
        });
    }
    _legacySignMessage(message) {
        return $27bc92fe0e4122fd$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $1z44X.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
            return yield this.provider.send("eth_sign", [
                address.toLowerCase(),
                (0, $kniO8.hexlify)(data)
            ]);
        });
    }
    _signTypedData(domain, types, value) {
        return $27bc92fe0e4122fd$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names (in-place)
            const populated = yield (0, $4oRy9.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            return yield this.provider.send("eth_signTypedData_v4", [
                address.toLowerCase(),
                JSON.stringify((0, $4oRy9.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
            ]);
        });
    }
    unlock(password) {
        return $27bc92fe0e4122fd$var$__awaiter(this, void 0, void 0, function*() {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [
                address.toLowerCase(),
                password,
                null
            ]);
        });
    }
}
class $27bc92fe0e4122fd$var$UncheckedJsonRpcSigner extends $27bc92fe0e4122fd$export$5f7b5fca3508545a {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash)=>{
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations)=>{
                    return this.provider.waitForTransaction(hash, confirmations);
                }
            };
        });
    }
}
const $27bc92fe0e4122fd$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
class $27bc92fe0e4122fd$export$da28308012bf6748 extends (0, $98KlH.BaseProvider) {
    constructor(url, network){
        $27bc92fe0e4122fd$var$logger.checkNew(new.target, $27bc92fe0e4122fd$export$da28308012bf6748);
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then((network)=>{
                    resolve(network);
                }, (error)=>{
                    reject(error);
                });
            }, 0);
        });
        super(networkOrReady);
        // Default URL
        if (!url) url = (0, $7veey.getStatic)(this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $7veey.defineReadOnly)(this, "connection", Object.freeze({
            url: url
        }));
        else (0, $7veey.defineReadOnly)(this, "connection", Object.freeze((0, $7veey.shallowCopy)(url)));
        this._nextId = 42;
    }
    get _cache() {
        if (this._eventLoopCache == null) this._eventLoopCache = {};
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http://localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(()=>{
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return $27bc92fe0e4122fd$var$__awaiter(this, void 0, void 0, function*() {
            yield $27bc92fe0e4122fd$var$timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            } catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                } catch (error) {}
            }
            if (chainId != null) {
                const getNetwork = (0, $7veey.getStatic)(this.constructor, "getNetwork");
                try {
                    return getNetwork((0, $kVZhy.BigNumber).from(chainId).toNumber());
                } catch (error) {
                    return $27bc92fe0e4122fd$var$logger.throwError("could not detect network", (0, $l6EVj.Logger).errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return $27bc92fe0e4122fd$var$logger.throwError("could not detect network", (0, $l6EVj.Logger).errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new $27bc92fe0e4122fd$export$5f7b5fca3508545a($27bc92fe0e4122fd$var$_constructorGuard, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts)=>{
            return accounts.map((a)=>this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: (0, $7veey.deepCopy)(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = [
            "eth_chainId",
            "eth_blockNumber"
        ].indexOf(method) >= 0;
        if (cache && this._cache[method]) return this._cache[method];
        const result = (0, $7J8He.fetchJson)(this.connection, JSON.stringify(request), $27bc92fe0e4122fd$var$getResult).then((result)=>{
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(()=>{
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch(method){
            case "getBlockNumber":
                return [
                    "eth_blockNumber",
                    []
                ];
            case "getGasPrice":
                return [
                    "eth_gasPrice",
                    []
                ];
            case "getBalance":
                return [
                    "eth_getBalance",
                    [
                        $27bc92fe0e4122fd$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getTransactionCount":
                return [
                    "eth_getTransactionCount",
                    [
                        $27bc92fe0e4122fd$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getCode":
                return [
                    "eth_getCode",
                    [
                        $27bc92fe0e4122fd$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getStorageAt":
                return [
                    "eth_getStorageAt",
                    [
                        $27bc92fe0e4122fd$var$getLowerCase(params.address),
                        params.position,
                        params.blockTag
                    ]
                ];
            case "sendTransaction":
                return [
                    "eth_sendRawTransaction",
                    [
                        params.signedTransaction
                    ]
                ];
            case "getBlock":
                if (params.blockTag) return [
                    "eth_getBlockByNumber",
                    [
                        params.blockTag,
                        !!params.includeTransactions
                    ]
                ];
                else if (params.blockHash) return [
                    "eth_getBlockByHash",
                    [
                        params.blockHash,
                        !!params.includeTransactions
                    ]
                ];
                return null;
            case "getTransaction":
                return [
                    "eth_getTransactionByHash",
                    [
                        params.transactionHash
                    ]
                ];
            case "getTransactionReceipt":
                return [
                    "eth_getTransactionReceipt",
                    [
                        params.transactionHash
                    ]
                ];
            case "call":
                {
                    const hexlifyTransaction = (0, $7veey.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_call",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            }),
                            params.blockTag
                        ]
                    ];
                }
            case "estimateGas":
                {
                    const hexlifyTransaction = (0, $7veey.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_estimateGas",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            })
                        ]
                    ];
                }
            case "getLogs":
                if (params.filter && params.filter.address != null) params.filter.address = $27bc92fe0e4122fd$var$getLowerCase(params.filter.address);
                return [
                    "eth_getLogs",
                    [
                        params.filter
                    ]
                ];
            default:
                break;
        }
        return null;
    }
    perform(method, params) {
        return $27bc92fe0e4122fd$var$__awaiter(this, void 0, void 0, function*() {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && (0, $kVZhy.BigNumber).from(tx.type).isZero()) // If there are no EIP-1559 properties, it might be non-EIP-a559
                {
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = (0, $7veey.shallowCopy)(params);
                            params.transaction = (0, $7veey.shallowCopy)(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) $27bc92fe0e4122fd$var$logger.throwError(method + " not implemented", (0, $l6EVj.Logger).errors.NOT_IMPLEMENTED, {
                operation: method
            });
            try {
                return yield this.send(args[0], args[1]);
            } catch (error) {
                return $27bc92fe0e4122fd$var$checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") this._startPending();
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) return;
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function(filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [
                    filterId
                ]).then(function(hashes) {
                    if (self._pendingFilter != pendingFilter) return null;
                    let seq = Promise.resolve();
                    hashes.forEach(function(hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function() {
                            return self.getTransaction(hash).then(function(tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function() {
                        return $27bc92fe0e4122fd$var$timer(1000);
                    });
                }).then(function() {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [
                            filterId
                        ]);
                        return;
                    }
                    setTimeout(function() {
                        poll();
                    }, 0);
                    return null;
                }).catch((error)=>{});
            }
            poll();
            return filterId;
        }).catch((error)=>{});
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = (0, $7veey.shallowCopy)($27bc92fe0e4122fd$var$allowedTransactionKeys);
        if (allowExtra) {
            for(const key in allowExtra)if (allowExtra[key]) allowed[key] = true;
        }
        (0, $7veey.checkProperties)(transaction, allowed);
        const result = {};
        // Some nodes (INFURA ropsten; INFURA mainnet is fine) do not like leading zeros.
        [
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            const value = (0, $kniO8.hexValue)(transaction[key]);
            if (key === "gasLimit") key = "gas";
            result[key] = value;
        });
        [
            "from",
            "to",
            "data"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            result[key] = (0, $kniO8.hexlify)(transaction[key]);
        });
        if (transaction.accessList) result["accessList"] = (0, $equjW.accessListify)(transaction.accessList);
        return result;
    }
}

});

parcelRegister("8uf4g", function(module, exports) {

$parcel$export(module.exports, "WebSocket", () => $62dcd03cdd39f934$export$3909fb301d3dc8c9);

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");
"use strict";
let $62dcd03cdd39f934$export$3909fb301d3dc8c9 = null;
try {
    $62dcd03cdd39f934$export$3909fb301d3dc8c9 = WebSocket;
    if ($62dcd03cdd39f934$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    const logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
    $62dcd03cdd39f934$export$3909fb301d3dc8c9 = function() {
        logger.throwError("WebSockets not supported in this environment", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}

});


parcelRegister("4HuFM", function(module, exports) {

$parcel$export(module.exports, "StaticJsonRpcProvider", () => $36c2f893ec745479$export$b3d647c1c29df44d);
$parcel$export(module.exports, "UrlJsonRpcProvider", () => $36c2f893ec745479$export$664128d6239ccf96);

var $7veey = parcelRequire("7veey");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");

var $3pw3F = parcelRequire("3pw3F");
"use strict";
var $36c2f893ec745479$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $36c2f893ec745479$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
class $36c2f893ec745479$export$b3d647c1c29df44d extends (0, $3pw3F.JsonRpcProvider) {
    detectNetwork() {
        const _super = Object.create(null, {
            detectNetwork: {
                get: ()=>super.detectNetwork
            }
        });
        return $36c2f893ec745479$var$__awaiter(this, void 0, void 0, function*() {
            let network = this.network;
            if (network == null) {
                network = yield _super.detectNetwork.call(this);
                if (!network) $36c2f893ec745479$var$logger.throwError("no network detected", (0, $l6EVj.Logger).errors.UNKNOWN_ERROR, {});
                // If still not set, set it
                if (this._network == null) {
                    // A static network does not support "any"
                    (0, $7veey.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return network;
        });
    }
}
class $36c2f893ec745479$export$664128d6239ccf96 extends $36c2f893ec745479$export$b3d647c1c29df44d {
    constructor(network, apiKey){
        $36c2f893ec745479$var$logger.checkAbstract(new.target, $36c2f893ec745479$export$664128d6239ccf96);
        // Normalize the Network and API Key
        network = (0, $7veey.getStatic)(new.target, "getNetwork")(network);
        apiKey = (0, $7veey.getStatic)(new.target, "getApiKey")(apiKey);
        const connection = (0, $7veey.getStatic)(new.target, "getUrl")(network, apiKey);
        super(connection, network);
        if (typeof apiKey === "string") (0, $7veey.defineReadOnly)(this, "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach((key)=>{
            (0, $7veey.defineReadOnly)(this, key, apiKey[key]);
        });
    }
    _startPending() {
        $36c2f893ec745479$var$logger.warn("WARNING: API provider does not support pending filters");
    }
    isCommunityResource() {
        return false;
    }
    getSigner(address) {
        return $36c2f893ec745479$var$logger.throwError("API provider does not support signing", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "getSigner"
        });
    }
    listAccounts() {
        return Promise.resolve([]);
    }
    // Return a defaultApiKey if null, otherwise validate the API key
    static getApiKey(apiKey) {
        return apiKey;
    }
    // Returns the url or connection for the given network and API key. The
    // API key will have been sanitized by the getApiKey first, so any validation
    // or transformations can be done there.
    static getUrl(network, apiKey) {
        return $36c2f893ec745479$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $l6EVj.Logger).errors.NOT_IMPLEMENTED, {
            operation: "getUrl"
        });
    }
}

});


parcelRegister("eGnPy", function(module, exports) {

$parcel$export(module.exports, "CloudflareProvider", () => $ab077928b89a1023$export$7113381f8f264fc0);

var $4HuFM = parcelRequire("4HuFM");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");
"use strict";
var $ab077928b89a1023$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $ab077928b89a1023$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
class $ab077928b89a1023$export$7113381f8f264fc0 extends (0, $4HuFM.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey != null) $ab077928b89a1023$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
        return null;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://cloudflare-eth.com/";
                break;
            default:
                $ab077928b89a1023$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host;
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $ab077928b89a1023$var$__awaiter(this, void 0, void 0, function*() {
            // The Cloudflare provider does not support eth_blockNumber,
            // so we get the latest block and pull it from that
            if (method === "getBlockNumber") {
                const block = yield _super.perform.call(this, "getBlock", {
                    blockTag: "latest"
                });
                return block.number;
            }
            return _super.perform.call(this, method, params);
        });
    }
}

});

parcelRegister("2EBww", function(module, exports) {

$parcel$export(module.exports, "EtherscanProvider", () => $1eec6c9bc77476f7$export$dd1d942a536c7912);

var $kniO8 = parcelRequire("kniO8");

var $7veey = parcelRequire("7veey");

var $equjW = parcelRequire("equjW");

var $7J8He = parcelRequire("7J8He");

var $jqMZF = parcelRequire("jqMZF");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");

var $98KlH = parcelRequire("98KlH");
"use strict";
var $1eec6c9bc77476f7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $1eec6c9bc77476f7$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
// The transaction has already been sanitized by the calls in Provider
function $1eec6c9bc77476f7$var$getTransactionPostData(transaction) {
    const result = {};
    for(let key in transaction){
        if (transaction[key] == null) continue;
        let value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $kniO8.hexValue)((0, $kniO8.hexlify)(value));
        else if (key === "accessList") value = "[" + (0, $equjW.accessListify)(value).map((set)=>{
            return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
        }).join(",") + "]";
        else value = (0, $kniO8.hexlify)(value);
        result[key] = value;
    }
    return result;
}
function $1eec6c9bc77476f7$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || result.message != "OK") {
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $1eec6c9bc77476f7$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        const error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        throw error;
    }
    if (result.error) {
        // @TODO: not any
        const error = new Error(result.error.message || "unknown error");
        if (result.error.code) error.code = result.error.code;
        if (result.error.data) error.data = result.error.data;
        throw error;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $1eec6c9bc77476f7$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
const $1eec6c9bc77476f7$var$defaultApiKey = "9D13ZE7XSBTJ94N9BNJ2MA33VMAY2YPIRB";
function $1eec6c9bc77476f7$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $l6EVj.Logger).errors.SERVER_ERROR) {
        const e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            let data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $kniO8.isHexString)(data)) return data;
            $1eec6c9bc77476f7$var$logger.throwError("missing revert data in call exception", (0, $l6EVj.Logger).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    let message = error.message;
    if (error.code === (0, $l6EVj.Logger).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $1eec6c9bc77476f7$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $l6EVj.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $1eec6c9bc77476f7$var$logger.throwError("nonce has already been used", (0, $l6EVj.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $1eec6c9bc77476f7$var$logger.throwError("replacement fee too low", (0, $l6EVj.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $1eec6c9bc77476f7$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $l6EVj.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
class $1eec6c9bc77476f7$export$dd1d942a536c7912 extends (0, $98KlH.BaseProvider) {
    constructor(network, apiKey){
        $1eec6c9bc77476f7$var$logger.checkNew(new.target, $1eec6c9bc77476f7$export$dd1d942a536c7912);
        super(network);
        (0, $7veey.defineReadOnly)(this, "baseUrl", this.getBaseUrl());
        (0, $7veey.defineReadOnly)(this, "apiKey", apiKey || $1eec6c9bc77476f7$var$defaultApiKey);
    }
    getBaseUrl() {
        switch(this.network ? this.network.name : "invalid"){
            case "homestead":
                return "https://api.etherscan.io";
            case "ropsten":
                return "https://api-ropsten.etherscan.io";
            case "rinkeby":
                return "https://api-rinkeby.etherscan.io";
            case "kovan":
                return "https://api-kovan.etherscan.io";
            case "goerli":
                return "https://api-goerli.etherscan.io";
            default:
        }
        return $1eec6c9bc77476f7$var$logger.throwArgumentError("unsupported network", "network", name);
    }
    getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key)=>{
            const value = params[key];
            if (value != null) accum += `&${key}=${value}`;
            return accum;
        }, "");
        const apiKey = this.apiKey ? `&apikey=${this.apiKey}` : "";
        return `${this.baseUrl}/api?module=${module}${query}${apiKey}`;
    }
    getPostUrl() {
        return `${this.baseUrl}/api`;
    }
    getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    fetch(module, params, post) {
        return $1eec6c9bc77476f7$var$__awaiter(this, void 0, void 0, function*() {
            const url = post ? this.getPostUrl() : this.getUrl(module, params);
            const payload = post ? this.getPostData(module, params) : null;
            const procFunc = module === "proxy" ? $1eec6c9bc77476f7$var$getJsonResult : $1eec6c9bc77476f7$var$getResult;
            this.emit("debug", {
                action: "request",
                request: url,
                provider: this
            });
            const connection = {
                url: url,
                throttleSlotInterval: 1000,
                throttleCallback: (attempt, url)=>{
                    if (this.isCommunityResource()) (0, $jqMZF.showThrottleMessage)();
                    return Promise.resolve(true);
                }
            };
            let payloadStr = null;
            if (payload) {
                connection.headers = {
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                };
                payloadStr = Object.keys(payload).map((key)=>{
                    return `${key}=${payload[key]}`;
                }).join("&");
            }
            const result = yield (0, $7J8He.fetchJson)(connection, payloadStr, procFunc || $1eec6c9bc77476f7$var$getJsonResult);
            this.emit("debug", {
                action: "response",
                request: url,
                response: (0, $7veey.deepCopy)(result),
                provider: this
            });
            return result;
        });
    }
    detectNetwork() {
        return $1eec6c9bc77476f7$var$__awaiter(this, void 0, void 0, function*() {
            return this.network;
        });
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $1eec6c9bc77476f7$var$__awaiter(this, void 0, void 0, function*() {
            switch(method){
                case "getBlockNumber":
                    return this.fetch("proxy", {
                        action: "eth_blockNumber"
                    });
                case "getGasPrice":
                    return this.fetch("proxy", {
                        action: "eth_gasPrice"
                    });
                case "getBalance":
                    // Returns base-10 result
                    return this.fetch("account", {
                        action: "balance",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getTransactionCount":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionCount",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getCode":
                    return this.fetch("proxy", {
                        action: "eth_getCode",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getStorageAt":
                    return this.fetch("proxy", {
                        action: "eth_getStorageAt",
                        address: params.address,
                        position: params.position,
                        tag: params.blockTag
                    });
                case "sendTransaction":
                    return this.fetch("proxy", {
                        action: "eth_sendRawTransaction",
                        hex: params.signedTransaction
                    }, true).catch((error)=>{
                        return $1eec6c9bc77476f7$var$checkError("sendTransaction", error, params.signedTransaction);
                    });
                case "getBlock":
                    if (params.blockTag) return this.fetch("proxy", {
                        action: "eth_getBlockByNumber",
                        tag: params.blockTag,
                        boolean: params.includeTransactions ? "true" : "false"
                    });
                    throw new Error("getBlock by blockHash not implemented");
                case "getTransaction":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionByHash",
                        txhash: params.transactionHash
                    });
                case "getTransactionReceipt":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionReceipt",
                        txhash: params.transactionHash
                    });
                case "call":
                    {
                        if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                        const postData = $1eec6c9bc77476f7$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_call";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $1eec6c9bc77476f7$var$checkError("call", error, params.transaction);
                        }
                    }
                case "estimateGas":
                    {
                        const postData = $1eec6c9bc77476f7$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_estimateGas";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $1eec6c9bc77476f7$var$checkError("estimateGas", error, params.transaction);
                        }
                    }
                case "getLogs":
                    {
                        const args = {
                            action: "getLogs"
                        };
                        if (params.filter.fromBlock) args.fromBlock = $1eec6c9bc77476f7$var$checkLogTag(params.filter.fromBlock);
                        if (params.filter.toBlock) args.toBlock = $1eec6c9bc77476f7$var$checkLogTag(params.filter.toBlock);
                        if (params.filter.address) args.address = params.filter.address;
                        // @TODO: We can handle slightly more complicated logs using the logs API
                        if (params.filter.topics && params.filter.topics.length > 0) {
                            if (params.filter.topics.length > 1) $1eec6c9bc77476f7$var$logger.throwError("unsupported topic count", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                                topics: params.filter.topics
                            });
                            if (params.filter.topics.length === 1) {
                                const topic0 = params.filter.topics[0];
                                if (typeof topic0 !== "string" || topic0.length !== 66) $1eec6c9bc77476f7$var$logger.throwError("unsupported topic format", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
                                    topic0: topic0
                                });
                                args.topic0 = topic0;
                            }
                        }
                        const logs = yield this.fetch("logs", args);
                        // Cache txHash => blockHash
                        let blocks = {};
                        // Add any missing blockHash to the logs
                        for(let i = 0; i < logs.length; i++){
                            const log = logs[i];
                            if (log.blockHash != null) continue;
                            if (blocks[log.blockNumber] == null) {
                                const block = yield this.getBlock(log.blockNumber);
                                if (block) blocks[log.blockNumber] = block.hash;
                            }
                            log.blockHash = blocks[log.blockNumber];
                        }
                        return logs;
                    }
                case "getEtherPrice":
                    if (this.network.name !== "homestead") return 0.0;
                    return parseFloat((yield this.fetch("stats", {
                        action: "ethprice"
                    })).ethusd);
                default:
                    break;
            }
            return _super.perform.call(this, method, params);
        });
    }
    // Note: The `page` page parameter only allows pagination within the
    //       10,000 window available without a page and offset parameter
    //       Error: Result window is too large, PageNo x Offset size must
    //              be less than or equal to 10000
    getHistory(addressOrName, startBlock, endBlock) {
        return $1eec6c9bc77476f7$var$__awaiter(this, void 0, void 0, function*() {
            const params = {
                action: "txlist",
                address: yield this.resolveName(addressOrName),
                startblock: startBlock == null ? 0 : startBlock,
                endblock: endBlock == null ? 99999999 : endBlock,
                sort: "asc"
            };
            const result = yield this.fetch("account", params);
            return result.map((tx)=>{
                [
                    "contractAddress",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == "") delete tx[key];
                });
                if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                const item = this.formatter.transactionResponse(tx);
                if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                return item;
            });
        });
    }
    isCommunityResource() {
        return this.apiKey === $1eec6c9bc77476f7$var$defaultApiKey;
    }
}

});

parcelRegister("6VM9N", function(module, exports) {

$parcel$export(module.exports, "FallbackProvider", () => $50bd6be8f3fb2d72$export$cb1d0beacb55feb7);

var $hMfVR = parcelRequire("hMfVR");

var $kVZhy = parcelRequire("kVZhy");

var $kniO8 = parcelRequire("kniO8");

var $7veey = parcelRequire("7veey");

var $9XwuO = parcelRequire("9XwuO");

var $7J8He = parcelRequire("7J8He");

var $98KlH = parcelRequire("98KlH");

var $jqMZF = parcelRequire("jqMZF");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");
"use strict";
var $50bd6be8f3fb2d72$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $50bd6be8f3fb2d72$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
function $50bd6be8f3fb2d72$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $50bd6be8f3fb2d72$var$checkNetworks(networks) {
    let result = null;
    for(let i = 0; i < networks.length; i++){
        const network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $50bd6be8f3fb2d72$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $50bd6be8f3fb2d72$var$median(values, maxDelta) {
    values = values.slice().sort();
    const middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    const a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $50bd6be8f3fb2d72$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $kVZhy.BigNumber).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map((i)=>$50bd6be8f3fb2d72$var$serialize(i)));
    else if (typeof value === "object") {
        const keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map((key)=>{
            let v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $50bd6be8f3fb2d72$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + typeof value);
}
// Next request ID to use for emitting debug info
let $50bd6be8f3fb2d72$var$nextRid = 1;
function $50bd6be8f3fb2d72$var$stall(duration) {
    let cancel = null;
    let timer = null;
    let promise = new Promise((resolve)=>{
        cancel = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    const wait = (func)=>{
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
const $50bd6be8f3fb2d72$var$ForwardErrors = [
    (0, $l6EVj.Logger).errors.CALL_EXCEPTION,
    (0, $l6EVj.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $l6EVj.Logger).errors.NONCE_EXPIRED,
    (0, $l6EVj.Logger).errors.REPLACEMENT_UNDERPRICED,
    (0, $l6EVj.Logger).errors.UNPREDICTABLE_GAS_LIMIT
];
const $50bd6be8f3fb2d72$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $50bd6be8f3fb2d72$var$exposeDebugConfig(config, now) {
    const result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: ()=>config.provider
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $50bd6be8f3fb2d72$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        const tally = {};
        configs.forEach((c)=>{
            const value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        const keys = Object.keys(tally);
        for(let i = 0; i < keys.length; i++){
            const check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $50bd6be8f3fb2d72$var$getProcessFunc(provider, method, params) {
    let normalize = $50bd6be8f3fb2d72$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                // Get the median block number
                let blockNumber = $50bd6be8f3fb2d72$var$median(configs.map((c)=>c.result), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $50bd6be8f3fb2d72$var$median(configs.map((c)=>c.result));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function(tx) {
                if (tx == null) return null;
                tx = (0, $7veey.shallowCopy)(tx);
                tx.confirmations = -1;
                return $50bd6be8f3fb2d72$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function(block) {
                if (block == null) return null;
                block = (0, $7veey.shallowCopy)(block);
                block.transactions = block.transactions.map((tx)=>{
                    tx = (0, $7veey.shallowCopy)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $50bd6be8f3fb2d72$var$serialize(block);
            };
            else normalize = function(block) {
                if (block == null) return null;
                return $50bd6be8f3fb2d72$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $50bd6be8f3fb2d72$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $50bd6be8f3fb2d72$var$waitForSync(config, blockNumber) {
    return $50bd6be8f3fb2d72$var$__awaiter(this, void 0, void 0, function*() {
        const provider = config.provider;
        if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return provider;
        return (0, $7J8He.poll)(()=>{
            return new Promise((resolve, reject)=>{
                setTimeout(function() {
                    // We are synced
                    if (provider.blockNumber >= blockNumber) return resolve(provider);
                    // We're done; just quit
                    if (config.cancelled) return resolve(null);
                    // Try again, next block
                    return resolve(undefined);
                }, 0);
            });
        }, {
            oncePoll: provider
        });
    });
}
function $50bd6be8f3fb2d72$var$getRunner(config, currentBlockNumber, method, params) {
    return $50bd6be8f3fb2d72$var$__awaiter(this, void 0, void 0, function*() {
        let provider = config.provider;
        switch(method){
            case "getBlockNumber":
            case "getGasPrice":
                return provider[method]();
            case "getEtherPrice":
                if (provider.getEtherPrice) return provider.getEtherPrice();
                break;
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
                if (params.blockTag && (0, $kniO8.isHexString)(params.blockTag)) provider = yield $50bd6be8f3fb2d72$var$waitForSync(config, currentBlockNumber);
                return provider[method](params.address, params.blockTag || "latest");
            case "getStorageAt":
                if (params.blockTag && (0, $kniO8.isHexString)(params.blockTag)) provider = yield $50bd6be8f3fb2d72$var$waitForSync(config, currentBlockNumber);
                return provider.getStorageAt(params.address, params.position, params.blockTag || "latest");
            case "getBlock":
                if (params.blockTag && (0, $kniO8.isHexString)(params.blockTag)) provider = yield $50bd6be8f3fb2d72$var$waitForSync(config, currentBlockNumber);
                return provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash);
            case "call":
            case "estimateGas":
                if (params.blockTag && (0, $kniO8.isHexString)(params.blockTag)) provider = yield $50bd6be8f3fb2d72$var$waitForSync(config, currentBlockNumber);
                return provider[method](params.transaction);
            case "getTransaction":
            case "getTransactionReceipt":
                return provider[method](params.transactionHash);
            case "getLogs":
                {
                    let filter = params.filter;
                    if (filter.fromBlock && (0, $kniO8.isHexString)(filter.fromBlock) || filter.toBlock && (0, $kniO8.isHexString)(filter.toBlock)) provider = yield $50bd6be8f3fb2d72$var$waitForSync(config, currentBlockNumber);
                    return provider.getLogs(filter);
                }
        }
        return $50bd6be8f3fb2d72$var$logger.throwError("unknown method error", (0, $l6EVj.Logger).errors.UNKNOWN_ERROR, {
            method: method,
            params: params
        });
    });
}
class $50bd6be8f3fb2d72$export$cb1d0beacb55feb7 extends (0, $98KlH.BaseProvider) {
    constructor(providers, quorum){
        $50bd6be8f3fb2d72$var$logger.checkNew(new.target, $50bd6be8f3fb2d72$export$cb1d0beacb55feb7);
        if (providers.length === 0) $50bd6be8f3fb2d72$var$logger.throwArgumentError("missing providers", "providers", providers);
        const providerConfigs = providers.map((configOrProvider, index)=>{
            if ((0, $hMfVR.Provider).isProvider(configOrProvider)) {
                const stallTimeout = (0, $jqMZF.isCommunityResource)(configOrProvider) ? 2000 : 750;
                const priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            const config = (0, $7veey.shallowCopy)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $jqMZF.isCommunityResource)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            const weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $50bd6be8f3fb2d72$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${index}].weight`, weight);
            return Object.freeze(config);
        });
        const total = providerConfigs.reduce((accum, c)=>accum + c.weight, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $50bd6be8f3fb2d72$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        let networkOrReady = $50bd6be8f3fb2d72$var$checkNetworks(providerConfigs.map((c)=>c.provider.network));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        super(networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $7veey.defineReadOnly)(this, "providerConfigs", Object.freeze(providerConfigs));
        (0, $7veey.defineReadOnly)(this, "quorum", quorum);
        this._highestBlockNumber = -1;
    }
    detectNetwork() {
        return $50bd6be8f3fb2d72$var$__awaiter(this, void 0, void 0, function*() {
            const networks = yield Promise.all(this.providerConfigs.map((c)=>c.provider.getNetwork()));
            return $50bd6be8f3fb2d72$var$checkNetworks(networks);
        });
    }
    perform(method, params) {
        return $50bd6be8f3fb2d72$var$__awaiter(this, void 0, void 0, function*() {
            // Sending transactions is special; always broadcast it to all backends
            if (method === "sendTransaction") {
                const results = yield Promise.all(this.providerConfigs.map((c)=>{
                    return c.provider.sendTransaction(params.signedTransaction).then((result)=>{
                        return result.hash;
                    }, (error)=>{
                        return error;
                    });
                }));
                // Any success is good enough (other errors are likely "already seen" errors
                for(let i = 0; i < results.length; i++){
                    const result = results[i];
                    if (typeof result === "string") return result;
                }
                // They were all an error; pick the first error
                throw results[0];
            }
            // We need to make sure we are in sync with our backends, so we need
            // to know this before we can make a lot of calls
            if (this._highestBlockNumber === -1 && method !== "getBlockNumber") yield this.getBlockNumber();
            const processFunc = $50bd6be8f3fb2d72$var$getProcessFunc(this, method, params);
            // Shuffle the providers and then sort them by their priority; we
            // shallowCopy them since we will store the result in them too
            const configs = (0, $9XwuO.shuffled)(this.providerConfigs.map((0, $7veey.shallowCopy)));
            configs.sort((a, b)=>a.priority - b.priority);
            const currentBlockNumber = this._highestBlockNumber;
            let i = 0;
            let first = true;
            while(true){
                const t0 = $50bd6be8f3fb2d72$var$now();
                // Compute the inflight weight (exclude anything past)
                let inflightWeight = configs.filter((c)=>c.runner && t0 - c.start < c.stallTimeout).reduce((accum, c)=>accum + c.weight, 0);
                // Start running enough to meet quorum
                while(inflightWeight < this.quorum && i < configs.length){
                    const config = configs[i++];
                    const rid = $50bd6be8f3fb2d72$var$nextRid++;
                    config.start = $50bd6be8f3fb2d72$var$now();
                    config.staller = $50bd6be8f3fb2d72$var$stall(config.stallTimeout);
                    config.staller.wait(()=>{
                        config.staller = null;
                    });
                    config.runner = $50bd6be8f3fb2d72$var$getRunner(config, currentBlockNumber, method, params).then((result)=>{
                        config.done = true;
                        config.result = result;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $50bd6be8f3fb2d72$var$exposeDebugConfig(config, $50bd6be8f3fb2d72$var$now()),
                            request: {
                                method: method,
                                params: (0, $7veey.deepCopy)(params)
                            },
                            provider: this
                        });
                    }, (error)=>{
                        config.done = true;
                        config.error = error;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $50bd6be8f3fb2d72$var$exposeDebugConfig(config, $50bd6be8f3fb2d72$var$now()),
                            request: {
                                method: method,
                                params: (0, $7veey.deepCopy)(params)
                            },
                            provider: this
                        });
                    });
                    if (this.listenerCount("debug")) this.emit("debug", {
                        action: "request",
                        rid: rid,
                        backend: $50bd6be8f3fb2d72$var$exposeDebugConfig(config, null),
                        request: {
                            method: method,
                            params: (0, $7veey.deepCopy)(params)
                        },
                        provider: this
                    });
                    inflightWeight += config.weight;
                }
                // Wait for anything meaningful to finish or stall out
                const waiting = [];
                configs.forEach((c)=>{
                    if (c.done || !c.runner) return;
                    waiting.push(c.runner);
                    if (c.staller) waiting.push(c.staller.getPromise());
                });
                if (waiting.length) yield Promise.race(waiting);
                // Check the quorum and process the results; the process function
                // may additionally decide the quorum is not met
                const results = configs.filter((c)=>c.done && c.error == null);
                if (results.length >= this.quorum) {
                    const result = processFunc(results);
                    if (result !== undefined) {
                        // Shut down any stallers
                        configs.forEach((c)=>{
                            if (c.staller) c.staller.cancel();
                            c.cancelled = true;
                        });
                        return result;
                    }
                    if (!first) yield $50bd6be8f3fb2d72$var$stall(100).getPromise();
                    first = false;
                }
                // No result, check for errors that should be forwarded
                const errors = configs.reduce((accum, c)=>{
                    if (!c.done || c.error == null) return accum;
                    const code = c.error.code;
                    if ($50bd6be8f3fb2d72$var$ForwardErrors.indexOf(code) >= 0) {
                        if (!accum[code]) accum[code] = {
                            error: c.error,
                            weight: 0
                        };
                        accum[code].weight += c.weight;
                    }
                    return accum;
                }, {});
                Object.keys(errors).forEach((errorCode)=>{
                    const tally = errors[errorCode];
                    if (tally.weight < this.quorum) return;
                    // Shut down any stallers
                    configs.forEach((c)=>{
                        if (c.staller) c.staller.cancel();
                        c.cancelled = true;
                    });
                    const e = tally.error;
                    const props = {};
                    $50bd6be8f3fb2d72$var$ForwardProperties.forEach((name)=>{
                        if (e[name] == null) return;
                        props[name] = e[name];
                    });
                    $50bd6be8f3fb2d72$var$logger.throwError(e.reason || e.message, errorCode, props);
                });
                // All configs have run to completion; we will never get more data
                if (configs.filter((c)=>!c.done).length === 0) break;
            }
            // Shut down any stallers; shouldn't be any
            configs.forEach((c)=>{
                if (c.staller) c.staller.cancel();
                c.cancelled = true;
            });
            return $50bd6be8f3fb2d72$var$logger.throwError("failed to meet quorum", (0, $l6EVj.Logger).errors.SERVER_ERROR, {
                method: method,
                params: params,
                //results: configs.map((c) => c.result),
                //errors: configs.map((c) => c.error),
                results: configs.map((c)=>$50bd6be8f3fb2d72$var$exposeDebugConfig(c)),
                provider: this
            });
        });
    }
}

});
parcelRegister("9XwuO", function(module, exports) {

$parcel$export(module.exports, "shuffled", () => $7402d4cab1098176$export$e6c7296801b9b341);
"use strict";
function $7402d4cab1098176$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}

});


parcelRegister("2tAFx", function(module, exports) {

$parcel$export(module.exports, "IpcProvider", () => $1cdabbeacc1eace0$export$fbe151f90a1ece01);
"use strict";
const $1cdabbeacc1eace0$export$fbe151f90a1ece01 = null;

});

parcelRegister("frY0B", function(module, exports) {

$parcel$export(module.exports, "InfuraWebSocketProvider", () => $b3f7ed1fdfe3ac38$export$dd168a807d60da4f);
$parcel$export(module.exports, "InfuraProvider", () => $b3f7ed1fdfe3ac38$export$60ff1a559b5c6ebd);

var $7veey = parcelRequire("7veey");

var $70jvO = parcelRequire("70jvO");

var $jqMZF = parcelRequire("jqMZF");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");

var $4HuFM = parcelRequire("4HuFM");
"use strict";
const $b3f7ed1fdfe3ac38$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
const $b3f7ed1fdfe3ac38$var$defaultProjectId = "84842078b09946638c03157f83405213";
class $b3f7ed1fdfe3ac38$export$dd168a807d60da4f extends (0, $70jvO.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $b3f7ed1fdfe3ac38$export$60ff1a559b5c6ebd(network, apiKey);
        const connection = provider.connection;
        if (connection.password) $b3f7ed1fdfe3ac38$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $l6EVj.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        const url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, network);
        (0, $7veey.defineReadOnly)(this, "apiKey", provider.projectId);
        (0, $7veey.defineReadOnly)(this, "projectId", provider.projectId);
        (0, $7veey.defineReadOnly)(this, "projectSecret", provider.projectSecret);
    }
    isCommunityResource() {
        return this.projectId === $b3f7ed1fdfe3ac38$var$defaultProjectId;
    }
}
class $b3f7ed1fdfe3ac38$export$60ff1a559b5c6ebd extends (0, $4HuFM.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $b3f7ed1fdfe3ac38$export$dd168a807d60da4f(network, apiKey);
    }
    static getApiKey(apiKey) {
        const apiKeyObj = {
            apiKey: $b3f7ed1fdfe3ac38$var$defaultProjectId,
            projectId: $b3f7ed1fdfe3ac38$var$defaultProjectId,
            projectSecret: null
        };
        if (apiKey == null) return apiKeyObj;
        if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
        else if (apiKey.projectSecret != null) {
            $b3f7ed1fdfe3ac38$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
            $b3f7ed1fdfe3ac38$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
            apiKeyObj.projectId = apiKey.projectId;
            apiKeyObj.projectSecret = apiKey.projectSecret;
        } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
        apiKeyObj.apiKey = apiKeyObj.projectId;
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "homestead":
                host = "mainnet.infura.io";
                break;
            case "ropsten":
                host = "ropsten.infura.io";
                break;
            case "rinkeby":
                host = "rinkeby.infura.io";
                break;
            case "kovan":
                host = "kovan.infura.io";
                break;
            case "goerli":
                host = "goerli.infura.io";
                break;
            case "matic":
                host = "polygon-mainnet.infura.io";
                break;
            case "maticmum":
                host = "polygon-mumbai.infura.io";
                break;
            case "optimism":
                host = "optimism-mainnet.infura.io";
                break;
            case "optimism-kovan":
                host = "optimism-kovan.infura.io";
                break;
            case "arbitrum":
                host = "arbitrum-mainnet.infura.io";
                break;
            case "arbitrum-rinkeby":
                host = "arbitrum-rinkeby.infura.io";
                break;
            default:
                $b3f7ed1fdfe3ac38$var$logger.throwError("unsupported network", (0, $l6EVj.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const connection = {
            allowGzip: true,
            url: "https://" + host + "/v3/" + apiKey.projectId,
            throttleCallback: (attempt, url)=>{
                if (apiKey.projectId === $b3f7ed1fdfe3ac38$var$defaultProjectId) (0, $jqMZF.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
    isCommunityResource() {
        return this.projectId === $b3f7ed1fdfe3ac38$var$defaultProjectId;
    }
}

});

parcelRegister("8iJqx", function(module, exports) {

$parcel$export(module.exports, "JsonRpcBatchProvider", () => $60b33e0b573cd18f$export$5a16092bf20edf97);

var $7veey = parcelRequire("7veey");

var $7J8He = parcelRequire("7J8He");

var $3pw3F = parcelRequire("3pw3F");
class $60b33e0b573cd18f$export$5a16092bf20edf97 extends (0, $3pw3F.JsonRpcProvider) {
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        if (this._pendingBatch == null) this._pendingBatch = [];
        const inflightRequest = {
            request: request,
            resolve: null,
            reject: null
        };
        const promise = new Promise((resolve, reject)=>{
            inflightRequest.resolve = resolve;
            inflightRequest.reject = reject;
        });
        this._pendingBatch.push(inflightRequest);
        if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
        this._pendingBatchAggregator = setTimeout(()=>{
            // Get teh current batch and clear it, so new requests
            // go into the next batch
            const batch = this._pendingBatch;
            this._pendingBatch = null;
            this._pendingBatchAggregator = null;
            // Get the request as an array of requests
            const request = batch.map((inflight)=>inflight.request);
            this.emit("debug", {
                action: "requestBatch",
                request: (0, $7veey.deepCopy)(request),
                provider: this
            });
            return (0, $7J8He.fetchJson)(this.connection, JSON.stringify(request)).then((result)=>{
                this.emit("debug", {
                    action: "response",
                    request: request,
                    response: result,
                    provider: this
                });
                // For each result, feed it to the correct Promise, depending
                // on whether it was a success or error
                batch.forEach((inflightRequest, index)=>{
                    const payload = result[index];
                    if (payload.error) {
                        const error = new Error(payload.error.message);
                        error.code = payload.error.code;
                        error.data = payload.error.data;
                        inflightRequest.reject(error);
                    } else inflightRequest.resolve(payload.result);
                });
            }, (error)=>{
                this.emit("debug", {
                    action: "response",
                    error: error,
                    request: request,
                    provider: this
                });
                batch.forEach((inflightRequest)=>{
                    inflightRequest.reject(error);
                });
            });
        }, 10);
        return promise;
    }
}

});

parcelRegister("eLtE8", function(module, exports) {

$parcel$export(module.exports, "NodesmithProvider", () => $abfc739ff5f4187c$export$8235cbce3ce273bd);
/* istanbul ignore file */ 
var $4HuFM = parcelRequire("4HuFM");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");
"use strict";
const $abfc739ff5f4187c$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
// Special API key provided by Nodesmith for ethers.js
const $abfc739ff5f4187c$var$defaultApiKey = "ETHERS_JS_SHARED";
class $abfc739ff5f4187c$export$8235cbce3ce273bd extends (0, $4HuFM.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey && typeof apiKey !== "string") $abfc739ff5f4187c$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey || $abfc739ff5f4187c$var$defaultApiKey;
    }
    static getUrl(network, apiKey) {
        $abfc739ff5f4187c$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                break;
            case "ropsten":
                host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                break;
            case "rinkeby":
                host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                break;
            case "goerli":
                host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                break;
            case "kovan":
                host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                break;
            default:
                $abfc739ff5f4187c$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host + "?apiKey=" + apiKey;
    }
}

});

parcelRegister("144p0", function(module, exports) {

$parcel$export(module.exports, "PocketProvider", () => $0c6994603fb516a0$export$58bb47e42f6b092e);

var $7veey = parcelRequire("7veey");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");

var $4HuFM = parcelRequire("4HuFM");
"use strict";
const $0c6994603fb516a0$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
// These are load-balancer-based application IDs
const $0c6994603fb516a0$var$defaultApplicationIds = {
    homestead: "6004bcd10040261633ade990",
    ropsten: "6004bd4d0040261633ade991",
    rinkeby: "6004bda20040261633ade994",
    goerli: "6004bd860040261633ade992"
};
class $0c6994603fb516a0$export$58bb47e42f6b092e extends (0, $4HuFM.UrlJsonRpcProvider) {
    constructor(network, apiKey){
        // We need a bit of creativity in the constructor because
        // Pocket uses different default API keys based on the network
        if (apiKey == null) {
            const n = (0, $7veey.getStatic)(new.target, "getNetwork")(network);
            if (n) {
                const applicationId = $0c6994603fb516a0$var$defaultApplicationIds[n.name];
                if (applicationId) apiKey = {
                    applicationId: applicationId,
                    loadBalancer: true
                };
            }
            // If there was any issue above, we don't know this network
            if (apiKey == null) $0c6994603fb516a0$var$logger.throwError("unsupported network", (0, $l6EVj.Logger).errors.INVALID_ARGUMENT, {
                argument: "network",
                value: network
            });
        }
        super(network, apiKey);
    }
    static getApiKey(apiKey) {
        // Most API Providers allow null to get the default configuration, but
        // Pocket requires the network to decide the default provider, so we
        // rely on hijacking the constructor to add a sensible default for us
        if (apiKey == null) $0c6994603fb516a0$var$logger.throwArgumentError("PocketProvider.getApiKey does not support null apiKey", "apiKey", apiKey);
        const apiKeyObj = {
            applicationId: null,
            loadBalancer: false,
            applicationSecretKey: null
        };
        // Parse applicationId and applicationSecretKey
        if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
        else if (apiKey.applicationSecretKey != null) {
            $0c6994603fb516a0$var$logger.assertArgument(typeof apiKey.applicationId === "string", "applicationSecretKey requires an applicationId", "applicationId", apiKey.applicationId);
            $0c6994603fb516a0$var$logger.assertArgument(typeof apiKey.applicationSecretKey === "string", "invalid applicationSecretKey", "applicationSecretKey", "[REDACTED]");
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
            apiKeyObj.loadBalancer = !!apiKey.loadBalancer;
        } else if (apiKey.applicationId) {
            $0c6994603fb516a0$var$logger.assertArgument(typeof apiKey.applicationId === "string", "apiKey.applicationId must be a string", "apiKey.applicationId", apiKey.applicationId);
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.loadBalancer = !!apiKey.loadBalancer;
        } else $0c6994603fb516a0$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "homestead":
                host = "eth-mainnet.gateway.pokt.network";
                break;
            case "ropsten":
                host = "eth-ropsten.gateway.pokt.network";
                break;
            case "rinkeby":
                host = "eth-rinkeby.gateway.pokt.network";
                break;
            case "goerli":
                host = "eth-goerli.gateway.pokt.network";
                break;
            default:
                $0c6994603fb516a0$var$logger.throwError("unsupported network", (0, $l6EVj.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        let url = null;
        if (apiKey.loadBalancer) url = `https:/\/${host}/v1/lb/${apiKey.applicationId}`;
        else url = `https:/\/${host}/v1/${apiKey.applicationId}`;
        const connection = {
            url: url
        };
        // Initialize empty headers
        connection.headers = {};
        // Apply application secret key
        if (apiKey.applicationSecretKey != null) {
            connection.user = "";
            connection.password = apiKey.applicationSecretKey;
        }
        return connection;
    }
    isCommunityResource() {
        return this.applicationId === $0c6994603fb516a0$var$defaultApplicationIds[this.network.name];
    }
}

});

parcelRegister("4zhJC", function(module, exports) {

$parcel$export(module.exports, "Web3Provider", () => $35383015898d87ee$export$d05096c9fd9d936d);

var $7veey = parcelRequire("7veey");

var $l6EVj = parcelRequire("l6EVj");

var $jyK7L = parcelRequire("jyK7L");

var $3pw3F = parcelRequire("3pw3F");
"use strict";
const $35383015898d87ee$var$logger = new (0, $l6EVj.Logger)((0, $jyK7L.version));
let $35383015898d87ee$var$_nextId = 1;
function $35383015898d87ee$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    const fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        const request = {
            method: method,
            params: params,
            id: $35383015898d87ee$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise((resolve, reject)=>{
            this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $7veey.deepCopy)(request),
                provider: this
            });
            sendFunc(request, (error, response)=>{
                if (error) {
                    this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: this
                    });
                    return reject(error);
                }
                this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: this
                });
                if (response.error) {
                    const error = new Error(response.error.message);
                    error.code = response.error.code;
                    error.data = response.error.data;
                    return reject(error);
                }
                resolve(response.result);
            });
        });
    };
}
function $35383015898d87ee$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        if (params == null) params = [];
        const request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $7veey.deepCopy)(request),
            provider: this
        });
        return provider.request(request).then((response)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: this
            });
            return response;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: this
            });
            throw error;
        });
    };
}
class $35383015898d87ee$export$d05096c9fd9d936d extends (0, $3pw3F.JsonRpcProvider) {
    constructor(provider, network){
        $35383015898d87ee$var$logger.checkNew(new.target, $35383015898d87ee$export$d05096c9fd9d936d);
        if (provider == null) $35383015898d87ee$var$logger.throwArgumentError("missing provider", "provider", provider);
        let path = null;
        let jsonRpcFetchFunc = null;
        let subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $35383015898d87ee$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $35383015898d87ee$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $35383015898d87ee$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $35383015898d87ee$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        super(path, network);
        (0, $7veey.defineReadOnly)(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $7veey.defineReadOnly)(this, "provider", subprovider);
    }
    send(method, params) {
        return this.jsonRpcFetchFunc(method, params);
    }
}

});


parcelRegister("jd9Pa", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", () => (parcelRequire("dbchf")).AbiCoder);
$parcel$export(module.exports, "defaultAbiCoder", () => (parcelRequire("dbchf")).defaultAbiCoder);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("7py7d")).Fragment);
$parcel$export(module.exports, "ConstructorFragment", () => (parcelRequire("7py7d")).ConstructorFragment);
$parcel$export(module.exports, "ErrorFragment", () => (parcelRequire("7py7d")).ErrorFragment);
$parcel$export(module.exports, "EventFragment", () => (parcelRequire("7py7d")).EventFragment);
$parcel$export(module.exports, "FunctionFragment", () => (parcelRequire("7py7d")).FunctionFragment);
$parcel$export(module.exports, "ParamType", () => (parcelRequire("7py7d")).ParamType);
$parcel$export(module.exports, "FormatTypes", () => (parcelRequire("7py7d")).FormatTypes);
$parcel$export(module.exports, "checkResultErrors", () => (parcelRequire("hPcX2")).checkResultErrors);
$parcel$export(module.exports, "Logger", () => (parcelRequire("l6EVj")).Logger);
$parcel$export(module.exports, "RLP", () => (parcelRequire("3wc1X")));
$parcel$export(module.exports, "_fetchData", () => (parcelRequire("7J8He"))._fetchData);
$parcel$export(module.exports, "fetchJson", () => (parcelRequire("7J8He")).fetchJson);
$parcel$export(module.exports, "poll", () => (parcelRequire("7J8He")).poll);
$parcel$export(module.exports, "checkProperties", () => (parcelRequire("7veey")).checkProperties);
$parcel$export(module.exports, "deepCopy", () => (parcelRequire("7veey")).deepCopy);
$parcel$export(module.exports, "defineReadOnly", () => (parcelRequire("7veey")).defineReadOnly);
$parcel$export(module.exports, "getStatic", () => (parcelRequire("7veey")).getStatic);
$parcel$export(module.exports, "resolveProperties", () => (parcelRequire("7veey")).resolveProperties);
$parcel$export(module.exports, "shallowCopy", () => (parcelRequire("7veey")).shallowCopy);
$parcel$export(module.exports, "arrayify", () => (parcelRequire("kniO8")).arrayify);
$parcel$export(module.exports, "concat", () => (parcelRequire("kniO8")).concat);
$parcel$export(module.exports, "stripZeros", () => (parcelRequire("kniO8")).stripZeros);
$parcel$export(module.exports, "zeroPad", () => (parcelRequire("kniO8")).zeroPad);
$parcel$export(module.exports, "isBytes", () => (parcelRequire("kniO8")).isBytes);
$parcel$export(module.exports, "isBytesLike", () => (parcelRequire("kniO8")).isBytesLike);
$parcel$export(module.exports, "defaultPath", () => (parcelRequire("jURra")).defaultPath);
$parcel$export(module.exports, "HDNode", () => (parcelRequire("jURra")).HDNode);
$parcel$export(module.exports, "SigningKey", () => (parcelRequire("hZMsZ")).SigningKey);
$parcel$export(module.exports, "Interface", () => (parcelRequire("64Jjf")).Interface);
$parcel$export(module.exports, "LogDescription", () => (parcelRequire("64Jjf")).LogDescription);
$parcel$export(module.exports, "TransactionDescription", () => (parcelRequire("64Jjf")).TransactionDescription);
$parcel$export(module.exports, "base58", () => (parcelRequire("lepF3")).Base58);
$parcel$export(module.exports, "base64", () => (parcelRequire("5TBV7")));
$parcel$export(module.exports, "hexlify", () => (parcelRequire("kniO8")).hexlify);
$parcel$export(module.exports, "isHexString", () => (parcelRequire("kniO8")).isHexString);
$parcel$export(module.exports, "hexConcat", () => (parcelRequire("kniO8")).hexConcat);
$parcel$export(module.exports, "hexStripZeros", () => (parcelRequire("kniO8")).hexStripZeros);
$parcel$export(module.exports, "hexValue", () => (parcelRequire("kniO8")).hexValue);
$parcel$export(module.exports, "hexZeroPad", () => (parcelRequire("kniO8")).hexZeroPad);
$parcel$export(module.exports, "hexDataLength", () => (parcelRequire("kniO8")).hexDataLength);
$parcel$export(module.exports, "hexDataSlice", () => (parcelRequire("kniO8")).hexDataSlice);
$parcel$export(module.exports, "nameprep", () => (parcelRequire("goqbq")).nameprep);
$parcel$export(module.exports, "_toEscapedUtf8String", () => (parcelRequire("1z44X"))._toEscapedUtf8String);
$parcel$export(module.exports, "toUtf8Bytes", () => (parcelRequire("1z44X")).toUtf8Bytes);
$parcel$export(module.exports, "toUtf8CodePoints", () => (parcelRequire("1z44X")).toUtf8CodePoints);
$parcel$export(module.exports, "toUtf8String", () => (parcelRequire("1z44X")).toUtf8String);
$parcel$export(module.exports, "Utf8ErrorFuncs", () => (parcelRequire("1z44X")).Utf8ErrorFuncs);
$parcel$export(module.exports, "formatBytes32String", () => (parcelRequire("4DWOT")).formatBytes32String);
$parcel$export(module.exports, "parseBytes32String", () => (parcelRequire("4DWOT")).parseBytes32String);
$parcel$export(module.exports, "hashMessage", () => (parcelRequire("ktAWM")).hashMessage);
$parcel$export(module.exports, "namehash", () => (parcelRequire("aafAp")).namehash);
$parcel$export(module.exports, "isValidName", () => (parcelRequire("aafAp")).isValidName);
$parcel$export(module.exports, "id", () => (parcelRequire("bnVEQ")).id);
$parcel$export(module.exports, "_TypedDataEncoder", () => (parcelRequire("4oRy9")).TypedDataEncoder);
$parcel$export(module.exports, "getAddress", () => (parcelRequire("1qOxQ")).getAddress);
$parcel$export(module.exports, "getIcapAddress", () => (parcelRequire("1qOxQ")).getIcapAddress);
$parcel$export(module.exports, "getContractAddress", () => (parcelRequire("1qOxQ")).getContractAddress);
$parcel$export(module.exports, "getCreate2Address", () => (parcelRequire("1qOxQ")).getCreate2Address);
$parcel$export(module.exports, "isAddress", () => (parcelRequire("1qOxQ")).isAddress);
$parcel$export(module.exports, "formatEther", () => (parcelRequire("hiikT")).formatEther);
$parcel$export(module.exports, "parseEther", () => (parcelRequire("hiikT")).parseEther);
$parcel$export(module.exports, "formatUnits", () => (parcelRequire("hiikT")).formatUnits);
$parcel$export(module.exports, "parseUnits", () => (parcelRequire("hiikT")).parseUnits);
$parcel$export(module.exports, "commify", () => (parcelRequire("hiikT")).commify);
$parcel$export(module.exports, "computeHmac", () => (parcelRequire("3QUg5")).computeHmac);
$parcel$export(module.exports, "keccak256", () => (parcelRequire("jGTTU")).keccak256);
$parcel$export(module.exports, "ripemd160", () => (parcelRequire("3QUg5")).ripemd160);
$parcel$export(module.exports, "sha256", () => (parcelRequire("3QUg5")).sha256);
$parcel$export(module.exports, "sha512", () => (parcelRequire("3QUg5")).sha512);
$parcel$export(module.exports, "randomBytes", () => (parcelRequire("82eL2")).randomBytes);
$parcel$export(module.exports, "shuffled", () => (parcelRequire("9XwuO")).shuffled);
$parcel$export(module.exports, "solidityPack", () => (parcelRequire("cIuOz")).pack);
$parcel$export(module.exports, "solidityKeccak256", () => (parcelRequire("cIuOz")).keccak256);
$parcel$export(module.exports, "soliditySha256", () => (parcelRequire("cIuOz")).sha256);
$parcel$export(module.exports, "splitSignature", () => (parcelRequire("kniO8")).splitSignature);
$parcel$export(module.exports, "joinSignature", () => (parcelRequire("kniO8")).joinSignature);
$parcel$export(module.exports, "accessListify", () => (parcelRequire("equjW")).accessListify);
$parcel$export(module.exports, "parseTransaction", () => (parcelRequire("equjW")).parse);
$parcel$export(module.exports, "serializeTransaction", () => (parcelRequire("equjW")).serialize);
$parcel$export(module.exports, "TransactionTypes", () => (parcelRequire("equjW")).TransactionTypes);
$parcel$export(module.exports, "getJsonWalletAddress", () => (parcelRequire("hCKkd")).getJsonWalletAddress);
$parcel$export(module.exports, "computeAddress", () => (parcelRequire("equjW")).computeAddress);
$parcel$export(module.exports, "recoverAddress", () => (parcelRequire("equjW")).recoverAddress);
$parcel$export(module.exports, "computePublicKey", () => (parcelRequire("hZMsZ")).computePublicKey);
$parcel$export(module.exports, "recoverPublicKey", () => (parcelRequire("hZMsZ")).recoverPublicKey);
$parcel$export(module.exports, "verifyMessage", () => (parcelRequire("bNCEM")).verifyMessage);
$parcel$export(module.exports, "verifyTypedData", () => (parcelRequire("bNCEM")).verifyTypedData);
$parcel$export(module.exports, "getAccountPath", () => (parcelRequire("jURra")).getAccountPath);
$parcel$export(module.exports, "mnemonicToEntropy", () => (parcelRequire("jURra")).mnemonicToEntropy);
$parcel$export(module.exports, "entropyToMnemonic", () => (parcelRequire("jURra")).entropyToMnemonic);
$parcel$export(module.exports, "isValidMnemonic", () => (parcelRequire("jURra")).isValidMnemonic);
$parcel$export(module.exports, "mnemonicToSeed", () => (parcelRequire("jURra")).mnemonicToSeed);
$parcel$export(module.exports, "SupportedAlgorithm", () => (parcelRequire("a6Cmu")).SupportedAlgorithm);
$parcel$export(module.exports, "UnicodeNormalizationForm", () => (parcelRequire("1z44X")).UnicodeNormalizationForm);
$parcel$export(module.exports, "Utf8ErrorReason", () => (parcelRequire("1z44X")).Utf8ErrorReason);
$parcel$export(module.exports, "Indexed", () => (parcelRequire("64Jjf")).Indexed);

var $dbchf = parcelRequire("dbchf");
var $7py7d = parcelRequire("7py7d");
var $hPcX2 = parcelRequire("hPcX2");
var $64Jjf = parcelRequire("64Jjf");

var $1qOxQ = parcelRequire("1qOxQ");

var $5TBV7 = parcelRequire("5TBV7");

var $lepF3 = parcelRequire("lepF3");

var $kniO8 = parcelRequire("kniO8");

var $ktAWM = parcelRequire("ktAWM");
var $aafAp = parcelRequire("aafAp");
var $bnVEQ = parcelRequire("bnVEQ");
var $4oRy9 = parcelRequire("4oRy9");

var $jURra = parcelRequire("jURra");

var $hCKkd = parcelRequire("hCKkd");

var $jGTTU = parcelRequire("jGTTU");

var $l6EVj = parcelRequire("l6EVj");

var $3QUg5 = parcelRequire("3QUg5");
var $a6Cmu = parcelRequire("a6Cmu");

var $cIuOz = parcelRequire("cIuOz");

var $82eL2 = parcelRequire("82eL2");
var $9XwuO = parcelRequire("9XwuO");

var $7veey = parcelRequire("7veey");

var $3wc1X = parcelRequire("3wc1X");

var $hZMsZ = parcelRequire("hZMsZ");

var $goqbq = parcelRequire("goqbq");
var $1z44X = parcelRequire("1z44X");
var $4DWOT = parcelRequire("4DWOT");

var $equjW = parcelRequire("equjW");

var $hiikT = parcelRequire("hiikT");

var $bNCEM = parcelRequire("bNCEM");

var $7J8He = parcelRequire("7J8He");
"use strict";

});
parcelRegister("5TBV7", function(module, exports) {

$parcel$export(module.exports, "decode", () => (parcelRequire("hyB5G")).decode);
$parcel$export(module.exports, "encode", () => (parcelRequire("hyB5G")).encode);

var $hyB5G = parcelRequire("hyB5G");
"use strict";

});

parcelRegister("cIuOz", function(module, exports) {

$parcel$export(module.exports, "pack", () => $94217f38505ee964$export$2a703dbb0cb35339);
$parcel$export(module.exports, "keccak256", () => $94217f38505ee964$export$f8151fce47ad1c35);
$parcel$export(module.exports, "sha256", () => $94217f38505ee964$export$bced8d2aada2d1c9);

var $kVZhy = parcelRequire("kVZhy");

var $kniO8 = parcelRequire("kniO8");

var $jGTTU = parcelRequire("jGTTU");

var $3QUg5 = parcelRequire("3QUg5");

var $1z44X = parcelRequire("1z44X");

var $l6EVj = parcelRequire("l6EVj");

var $eD2lO = parcelRequire("eD2lO");
"use strict";
const $94217f38505ee964$var$regexBytes = new RegExp("^bytes([0-9]+)$");
const $94217f38505ee964$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
const $94217f38505ee964$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const $94217f38505ee964$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
const $94217f38505ee964$var$logger = new (0, $l6EVj.Logger)((0, $eD2lO.version));
function $94217f38505ee964$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $kniO8.zeroPad)(value, 32);
            return (0, $kniO8.arrayify)(value);
        case "string":
            return (0, $1z44X.toUtf8Bytes)(value);
        case "bytes":
            return (0, $kniO8.arrayify)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $kniO8.zeroPad)(value, 32);
            return (0, $kniO8.arrayify)(value);
    }
    let match = type.match($94217f38505ee964$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $94217f38505ee964$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $kVZhy.BigNumber).from(value).toTwos(size);
        return (0, $kniO8.zeroPad)(value, size / 8);
    }
    match = type.match($94217f38505ee964$var$regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) $94217f38505ee964$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $kniO8.arrayify)(value).byteLength !== size) $94217f38505ee964$var$logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        if (isArray) return (0, $kniO8.arrayify)((value + $94217f38505ee964$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($94217f38505ee964$var$regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) $94217f38505ee964$var$logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        const result = [];
        value.forEach(function(value) {
            result.push($94217f38505ee964$var$_pack(baseType, value, true));
        });
        return (0, $kniO8.concat)(result);
    }
    return $94217f38505ee964$var$logger.throwArgumentError("invalid type", "type", type);
}
function $94217f38505ee964$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $94217f38505ee964$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    const tight = [];
    types.forEach(function(type, index) {
        tight.push($94217f38505ee964$var$_pack(type, values[index]));
    });
    return (0, $kniO8.hexlify)((0, $kniO8.concat)(tight));
}
function $94217f38505ee964$export$f8151fce47ad1c35(types, values) {
    return (0, $jGTTU.keccak256)($94217f38505ee964$export$2a703dbb0cb35339(types, values));
}
function $94217f38505ee964$export$bced8d2aada2d1c9(types, values) {
    return (0, $3QUg5.sha256)($94217f38505ee964$export$2a703dbb0cb35339(types, values));
}

});
parcelRegister("eD2lO", function(module, exports) {

$parcel$export(module.exports, "version", () => $aa6688098bb8507e$export$83d89fbfd8236492);
const $aa6688098bb8507e$export$83d89fbfd8236492 = "solidity/5.5.0";

});


parcelRegister("4DWOT", function(module, exports) {

$parcel$export(module.exports, "formatBytes32String", () => $36186e58fcb1c3d2$export$b97e949c0076e971);
$parcel$export(module.exports, "parseBytes32String", () => $36186e58fcb1c3d2$export$49340cb8f3954db8);

var $5phKy = parcelRequire("5phKy");

var $kniO8 = parcelRequire("kniO8");

var $1z44X = parcelRequire("1z44X");
"use strict";
function $36186e58fcb1c3d2$export$b97e949c0076e971(text) {
    // Get the bytes
    const bytes = (0, $1z44X.toUtf8Bytes)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $kniO8.hexlify)((0, $kniO8.concat)([
        bytes,
        (0, $5phKy.HashZero)
    ]).slice(0, 32));
}
function $36186e58fcb1c3d2$export$49340cb8f3954db8(bytes) {
    const data = (0, $kniO8.arrayify)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    let length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $1z44X.toUtf8String)(data.slice(0, length));
}

});

parcelRegister("hiikT", function(module, exports) {

$parcel$export(module.exports, "commify", () => $c9725742a603a4ee$export$de1294767e6ef661);
$parcel$export(module.exports, "formatUnits", () => $c9725742a603a4ee$export$bd39b96f71da1885);
$parcel$export(module.exports, "parseUnits", () => $c9725742a603a4ee$export$203ae30b4f6490b3);
$parcel$export(module.exports, "formatEther", () => $c9725742a603a4ee$export$11bc63b4c03ea518);
$parcel$export(module.exports, "parseEther", () => $c9725742a603a4ee$export$642c4e67bbdc0bc7);

var $hNSak = parcelRequire("hNSak");

var $l6EVj = parcelRequire("l6EVj");

var $4fRNd = parcelRequire("4fRNd");
"use strict";
const $c9725742a603a4ee$var$logger = new (0, $l6EVj.Logger)((0, $4fRNd.version));
const $c9725742a603a4ee$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $c9725742a603a4ee$export$de1294767e6ef661(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $c9725742a603a4ee$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    let suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    const formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        const index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $c9725742a603a4ee$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        const index = $c9725742a603a4ee$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $hNSak.formatFixed)(value, unitName != null ? unitName : 18);
}
function $c9725742a603a4ee$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $c9725742a603a4ee$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        const index = $c9725742a603a4ee$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $hNSak.parseFixed)(value, unitName != null ? unitName : 18);
}
function $c9725742a603a4ee$export$11bc63b4c03ea518(wei) {
    return $c9725742a603a4ee$export$bd39b96f71da1885(wei, 18);
}
function $c9725742a603a4ee$export$642c4e67bbdc0bc7(ether) {
    return $c9725742a603a4ee$export$203ae30b4f6490b3(ether, 18);
}

});
parcelRegister("4fRNd", function(module, exports) {

$parcel$export(module.exports, "version", () => $31924a42b5175da3$export$83d89fbfd8236492);
const $31924a42b5175da3$export$83d89fbfd8236492 = "units/5.5.0";

});



parcelRegister("7t7AK", function(module, exports) {

$parcel$export(module.exports, "version", () => $57012168f72c2526$export$83d89fbfd8236492);
const $57012168f72c2526$export$83d89fbfd8236492 = "ethers/5.5.3";

});



parcelRegister("bgFCw", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = merge;

});

parcelRegister("3vRz3", function(module, exports) {
"use strict";
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});

parcelRegister("8O6s0", function(module, exports) {

$parcel$export(module.exports, "a7", () => $6697ff39d54b09bb$export$a93c5207d687da10);
$parcel$export(module.exports, "ae", () => $6697ff39d54b09bb$export$f787f51d84a910ad);
$parcel$export(module.exports, "a0", () => $6697ff39d54b09bb$export$34aec0b863436764);
$parcel$export(module.exports, "E", () => $6697ff39d54b09bb$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "D", () => $6697ff39d54b09bb$export$96f57966bedc81b4);
$parcel$export(module.exports, "Q", () => $6697ff39d54b09bb$export$3722cfe417b6ed86);
$parcel$export(module.exports, "ar", () => $6697ff39d54b09bb$export$d24c54395ce0c509);
$parcel$export(module.exports, "aq", () => $6697ff39d54b09bb$export$8a5498727ef6be21);
$parcel$export(module.exports, "r", () => $6697ff39d54b09bb$export$43caf9889c228507);
$parcel$export(module.exports, "ap", () => $6697ff39d54b09bb$export$2f6ca3d3b1f80bf5);
$parcel$export(module.exports, "as", () => $6697ff39d54b09bb$export$6554612db691658e);
$parcel$export(module.exports, "a6", () => $6697ff39d54b09bb$export$2e2af4578d910ddf);
$parcel$export(module.exports, "a4", () => $6697ff39d54b09bb$export$efca4cbe5dd06740);
$parcel$export(module.exports, "h", () => $6697ff39d54b09bb$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "ao", () => $6697ff39d54b09bb$export$7a38258bbe170828);
$parcel$export(module.exports, "af", () => $6697ff39d54b09bb$export$c9170ad7d4cd7e57);
$parcel$export(module.exports, "ah", () => $6697ff39d54b09bb$export$995eb9fca571757);
$parcel$export(module.exports, "a5", () => $6697ff39d54b09bb$export$a8550f7dbe79f93a);
$parcel$export(module.exports, "a3", () => $6697ff39d54b09bb$export$6559d589eb85fbb6);
$parcel$export(module.exports, "n", () => $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "L", () => $6697ff39d54b09bb$export$61196ced6d74a310);
$parcel$export(module.exports, "Z", () => $6697ff39d54b09bb$export$dc98b0b04f4c7758);
$parcel$export(module.exports, "s", () => $6697ff39d54b09bb$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "a1", () => $6697ff39d54b09bb$export$3c2fa207a37baaea);
$parcel$export(module.exports, "c", () => $6697ff39d54b09bb$export$db3b6bfb95261072);
$parcel$export(module.exports, "l", () => $6697ff39d54b09bb$export$882b5998b3b9117c);
$parcel$export(module.exports, "m", () => $6697ff39d54b09bb$export$953cecd6e717a553);
$parcel$export(module.exports, "a", () => $6697ff39d54b09bb$export$407448d2b89b1813);
$parcel$export(module.exports, "j", () => $6697ff39d54b09bb$export$35e795649ee09318);
$parcel$export(module.exports, "b", () => $6697ff39d54b09bb$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "d", () => $6697ff39d54b09bb$export$4368d992c4eafac0);
$parcel$export(module.exports, "B", () => $6697ff39d54b09bb$export$ef35774e6d314e91);
$parcel$export(module.exports, "t", () => $6697ff39d54b09bb$export$625550452a3fa3ec);
$parcel$export(module.exports, "G", () => $6697ff39d54b09bb$export$2329c99376c9d0a4);
$parcel$export(module.exports, "e", () => $6697ff39d54b09bb$export$f1e1789686576879);
$parcel$export(module.exports, "p", () => $6697ff39d54b09bb$export$ffb5f4729a158638);
$parcel$export(module.exports, "J", () => $6697ff39d54b09bb$export$b4171a6734a65d42);
$parcel$export(module.exports, "k", () => $6697ff39d54b09bb$export$342063e11d6c3cad);
$parcel$export(module.exports, "v", () => $6697ff39d54b09bb$export$90a7f3efeed30595);
$parcel$export(module.exports, "T", () => $6697ff39d54b09bb$export$971d5caa766a69d7);
$parcel$export(module.exports, "o", () => $6697ff39d54b09bb$export$ae1af26003f05816);
$parcel$export(module.exports, "H", () => $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "a2", () => $6697ff39d54b09bb$export$ce26c07117d59d6a);
$parcel$export(module.exports, "az", () => $6697ff39d54b09bb$export$3d12bd131bb975d1);
$parcel$export(module.exports, "ax", () => $6697ff39d54b09bb$export$9fa96a7d116ea3ce);
$parcel$export(module.exports, "ay", () => $6697ff39d54b09bb$export$28f7fcd39efa255);
$parcel$export(module.exports, "al", () => $6697ff39d54b09bb$export$ab83b03e4111b1d0);
$parcel$export(module.exports, "ai", () => $6697ff39d54b09bb$export$f38c853ae54ed474);
$parcel$export(module.exports, "g", () => $6697ff39d54b09bb$export$39b482c5e57630a8);
$parcel$export(module.exports, "U", () => $6697ff39d54b09bb$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "ad", () => $6697ff39d54b09bb$export$4c3d22f3d993c33f);
$parcel$export(module.exports, "y", () => $6697ff39d54b09bb$export$4a5767248b18ef41);
$parcel$export(module.exports, "z", () => $6697ff39d54b09bb$export$df995fae86a55f06);
$parcel$export(module.exports, "x", () => $6697ff39d54b09bb$export$d141bba7fdc215a3);
$parcel$export(module.exports, "A", () => $6697ff39d54b09bb$export$ebd11618f299a286);
$parcel$export(module.exports, "V", () => $6697ff39d54b09bb$export$e7c866399fa523f5);
$parcel$export(module.exports, "ak", () => $6697ff39d54b09bb$export$21579262ef46735b);
$parcel$export(module.exports, "a9", () => $6697ff39d54b09bb$export$a9c996f45e5784d0);
$parcel$export(module.exports, "_", () => $6697ff39d54b09bb$export$71511d61b312f219);
$parcel$export(module.exports, "$", () => $6697ff39d54b09bb$export$3d8c2f653ac9d0b9);
$parcel$export(module.exports, "q", () => $6697ff39d54b09bb$export$9e5f44173e64f162);
$parcel$export(module.exports, "a8", () => $6697ff39d54b09bb$export$c3950d9923825c02);
$parcel$export(module.exports, "aA", () => $6697ff39d54b09bb$export$91c6e00c14e7e6fd);
$parcel$export(module.exports, "u", () => $6697ff39d54b09bb$export$3b14a55fb2447963);
$parcel$export(module.exports, "ac", () => $6697ff39d54b09bb$export$2219238a014317b0);
$parcel$export(module.exports, "F", () => $6697ff39d54b09bb$export$d66501df72047452);
$parcel$export(module.exports, "I", () => $6697ff39d54b09bb$export$9bb611d729802a56);
$parcel$export(module.exports, "K", () => $6697ff39d54b09bb$export$3466f893ebf79586);
$parcel$export(module.exports, "i", () => $6697ff39d54b09bb$export$23f2a1d2818174ef);
$parcel$export(module.exports, "S", () => $6697ff39d54b09bb$export$25ce5a424b770e84);
$parcel$export(module.exports, "N", () => $6697ff39d54b09bb$export$a07804094c3ecf2d);
$parcel$export(module.exports, "w", () => $6697ff39d54b09bb$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "at", () => $6697ff39d54b09bb$export$493d36ec626b6698);
$parcel$export(module.exports, "av", () => $6697ff39d54b09bb$export$d66dc83d8cfc8dd);
$parcel$export(module.exports, "O", () => $6697ff39d54b09bb$export$c4ce752e73470fba);
$parcel$export(module.exports, "am", () => $6697ff39d54b09bb$export$1a82df3d29112e01);
$parcel$export(module.exports, "aw", () => $6697ff39d54b09bb$export$92108d983e8ee699);
$parcel$export(module.exports, "au", () => $6697ff39d54b09bb$export$1fbe638ecf81657e);
$parcel$export(module.exports, "aj", () => $6697ff39d54b09bb$export$3b513254972cfc9c);
$parcel$export(module.exports, "C", () => $6697ff39d54b09bb$export$e7094788287c5e9b);
$parcel$export(module.exports, "M", () => $6697ff39d54b09bb$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "P", () => $6697ff39d54b09bb$export$56c0d5a1e737357d);
$parcel$export(module.exports, "ag", () => $6697ff39d54b09bb$export$ee7c8ad385a60b7b);
$parcel$export(module.exports, "f", () => $6697ff39d54b09bb$export$2d1720544b23b823);
$parcel$export(module.exports, "an", () => $6697ff39d54b09bb$export$306ddfe3a8403e2);
$parcel$export(module.exports, "aa", () => $6697ff39d54b09bb$export$7910e0436ed8d1de);
$parcel$export(module.exports, "X", () => $6697ff39d54b09bb$export$78acf4525d8a74c4);
$parcel$export(module.exports, "ab", () => $6697ff39d54b09bb$export$555508cbc6add439);
$parcel$export(module.exports, "Y", () => $6697ff39d54b09bb$export$8743009a87fcb00f);
$parcel$export(module.exports, "R", () => $6697ff39d54b09bb$export$db202ddc8be9136);
$parcel$export(module.exports, "W", () => $6697ff39d54b09bb$export$71cec2538cb2c617);
$parcel$export(module.exports, "aB", () => $6697ff39d54b09bb$export$9d398bebfec1c039);

var $axHCK = parcelRequire("axHCK");
var $bfHa8 = parcelRequire("bfHa8");
var $9AGP8 = parcelRequire("9AGP8");
var $d6DLj = parcelRequire("d6DLj");
var $jKULm = parcelRequire("jKULm");
var $l9kJq = parcelRequire("l9kJq");
var $hU8PB = parcelRequire("hU8PB");
var $8Ydqd = parcelRequire("8Ydqd");
var $hDTQV = parcelRequire("hDTQV");
var $fy9c8 = parcelRequire("fy9c8");
var $3TBY8 = parcelRequire("3TBY8");
var $jGgch = parcelRequire("jGgch");
var $jXWpp = parcelRequire("jXWpp");

var $7QREK = parcelRequire("7QREK");
var $d6DLj = parcelRequire("d6DLj");
var $d4PzE = parcelRequire("d4PzE");
var $6vUKV = parcelRequire("6vUKV");
var $16oXE = parcelRequire("16oXE");
var $hDTQV = parcelRequire("hDTQV");
var $fy9c8 = parcelRequire("fy9c8");
var $466t7 = parcelRequire("466t7");
var $jGgch = parcelRequire("jGgch");
var $jXWpp = parcelRequire("jXWpp");
var $eUlHv = parcelRequire("eUlHv");

var $kyrHl = parcelRequire("kyrHl");

var $6y4qQ = parcelRequire("6y4qQ");

var $kBJxW = parcelRequire("kBJxW");

var $kmsNQ = parcelRequire("kmsNQ");
parcelRequire("bib7R");
var $fsqu3 = parcelRequire("fsqu3");
var $7oBBe = parcelRequire("7oBBe");
var $jXBIn = parcelRequire("jXBIn");

var $5Kq8F = parcelRequire("5Kq8F");
parcelRequire("hLpYp");
var $6ojdr = parcelRequire("6ojdr");

var $4yR7b = parcelRequire("4yR7b");

var $kVZhy = parcelRequire("kVZhy");parcelRequire("jdnbt");
var $95AgJ = parcelRequire("95AgJ");
var $S29ji = parcelRequire("S29ji");
var $jd9Pa = parcelRequire("jd9Pa");

var $bgFCw = parcelRequire("bgFCw");

var $3vRz3 = parcelRequire("3vRz3");
var $6697ff39d54b09bb$var$defaultBnIcon = `<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="56" height="56" rx="8" fill="#262A3D"/>
<g clip-path="url(#clip0_15747_103507)">
<path d="M20.6176 35.9801L16.0142 27.9949H25.2218L29.826 35.9801H20.6176Z" fill="#262A3D"/>
<path d="M20.6176 35.9801L16.0142 27.9949H25.2218L29.826 35.9801H20.6176Z" fill="white"/>
<path d="M25.2218 27.9947H16.0142L20.6176 20.0095H29.826L25.2218 27.9947Z" fill="url(#paint0_linear_15747_103507)"/>
<path d="M34.4302 27.9948L29.826 20.0096H20.6176L16.0142 12.0244H34.4302L43.6379 27.9948H34.4302Z" fill="#262A3D"/>
<path d="M34.4302 27.9948L29.826 20.0096H20.6176L16.0142 12.0244H34.4302L43.6379 27.9948H34.4302Z" fill="white"/>
<path d="M34.4302 43.9652H16.0142L20.6176 35.9801H29.826L34.4302 27.9949H43.6379L34.4302 43.9652Z" fill="url(#paint1_linear_15747_103507)"/>
</g>
<defs>
<linearGradient id="paint0_linear_15747_103507" x1="16.0142" y1="24.0021" x2="29.826" y2="24.0021" gradientUnits="userSpaceOnUse">
<stop stop-color="#55CCFE"/>
<stop offset="1" stop-color="#5E93EF"/>
</linearGradient>
<linearGradient id="paint1_linear_15747_103507" x1="76.5102" y1="5214.05" x2="10391.8" y2="5214.05" gradientUnits="userSpaceOnUse">
<stop stop-color="#55CCFE"/>
<stop offset="1" stop-color="#5E93EF"/>
</linearGradient>
<clipPath id="clip0_15747_103507">
<rect width="27.6667" height="32" fill="white" transform="translate(16 12)"/>
</clipPath>
</defs>
</svg>
`;
var $6697ff39d54b09bb$export$a93c5207d687da10 = `
<svg width="152" height="16" viewBox="0 0 152 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.03641 6.252C3.23241 6.252 2.41641 6.636 2.04441 7.272V6.396H1.00041V14.724H2.04441V11.124C2.41641 11.784 3.20841 12.144 4.04841 12.144C5.58441 12.144 6.84441 10.98 6.84441 9.204C6.84441 7.44 5.57241 6.252 4.03641 6.252ZM3.94041 11.16C3.02841 11.16 2.04441 10.428 2.04441 9.216C2.04441 8.016 2.94441 7.236 3.94041 7.236C4.97241 7.236 5.78841 8.1 5.78841 9.216C5.78841 10.344 4.97241 11.16 3.94041 11.16ZM10.8452 12.144C12.4412 12.144 13.7852 10.968 13.7852 9.192C13.7852 7.416 12.4412 6.252 10.8452 6.252C9.24919 6.252 7.91719 7.416 7.91719 9.192C7.91719 10.968 9.24919 12.144 10.8452 12.144ZM10.8452 11.16C9.82519 11.16 8.97319 10.356 8.97319 9.192C8.97319 8.04 9.82519 7.236 10.8452 7.236C11.8772 7.236 12.7412 8.04 12.7412 9.192C12.7412 10.356 11.8772 11.16 10.8452 11.16ZM22.2729 6.396L20.8449 10.38L19.4049 6.396H18.3849L16.9569 10.38L15.5289 6.396H14.4009L16.5369 12H17.4009L18.8889 7.836L20.4369 12H21.3129L23.4009 6.396H22.2729ZM29.6948 9.18C29.6948 7.404 28.5068 6.252 26.9108 6.252C25.3148 6.252 24.0308 7.404 24.0308 9.18C24.0308 10.956 25.3148 12.144 26.9108 12.144C27.9908 12.144 28.9988 11.616 29.4788 10.644L28.5788 10.284C28.2548 10.848 27.6308 11.16 26.9468 11.16C25.9868 11.16 25.2668 10.644 25.1108 9.648H29.6708C29.6828 9.492 29.6948 9.336 29.6948 9.18ZM25.1228 8.748C25.2908 7.74 25.9628 7.236 26.9108 7.236C27.8348 7.236 28.5188 7.788 28.6508 8.748H25.1228ZM33.7456 6.252C33.0016 6.252 32.4616 6.684 32.1736 7.668V6.396H31.1176V12H32.1736V9.948C32.1736 8.472 32.6176 7.26 33.7336 7.26C33.9496 7.26 34.2496 7.308 34.5496 7.452L34.7176 6.468C34.5496 6.36 34.1416 6.252 33.7456 6.252ZM40.8627 9.18C40.8627 7.404 39.6747 6.252 38.0787 6.252C36.4827 6.252 35.1987 7.404 35.1987 9.18C35.1987 10.956 36.4827 12.144 38.0787 12.144C39.1587 12.144 40.1667 11.616 40.6467 10.644L39.7467 10.284C39.4227 10.848 38.7987 11.16 38.1147 11.16C37.1547 11.16 36.4347 10.644 36.2787 9.648H40.8387C40.8507 9.492 40.8627 9.336 40.8627 9.18ZM36.2907 8.748C36.4587 7.74 37.1307 7.236 38.0787 7.236C39.0027 7.236 39.6867 7.788 39.8187 8.748H36.2907ZM46.7136 3.348V7.272C46.3416 6.612 45.5496 6.252 44.7096 6.252C43.1736 6.252 41.9136 7.416 41.9136 9.192C41.9136 10.956 43.1856 12.144 44.7216 12.144C45.5256 12.144 46.3416 11.76 46.7136 11.124V12H47.7576V3.348H46.7136ZM44.8056 11.16C43.7856 11.16 42.9696 10.296 42.9696 9.18C42.9696 8.052 43.7856 7.236 44.8056 7.236C45.7296 7.236 46.7136 7.968 46.7136 9.18C46.7136 10.38 45.8136 11.16 44.8056 11.16ZM55.6695 6.252C54.8295 6.252 54.0375 6.612 53.6655 7.272V3.348H52.6215V12H53.6655V11.124C54.0375 11.76 54.8535 12.144 55.6575 12.144C57.1935 12.144 58.4655 10.956 58.4655 9.192C58.4655 7.416 57.2055 6.252 55.6695 6.252ZM55.5615 11.16C54.5655 11.16 53.6655 10.38 53.6655 9.18C53.6655 7.968 54.6495 7.236 55.5615 7.236C56.5935 7.236 57.4095 8.052 57.4095 9.18C57.4095 10.296 56.5935 11.16 55.5615 11.16ZM63.6097 6.396L61.8937 10.524L60.2017 6.396H59.0737L61.3297 11.832L60.1537 14.724H61.2577L64.7377 6.396H63.6097Z" fill="var(--w3o-text-color, #707481)"/>
<g clip-path="url(#clip0_13558_103869)">
<path d="M143.502 11.0888L141.863 8.24889H145.142L146.782 11.0888H143.502Z" fill="currentColor"/>
<path d="M145.142 8.24887H141.863L143.502 5.40895H146.782L145.142 8.24887Z" fill="url(#paint0_linear_13558_103869)"/>
<path d="M148.421 8.24888L146.782 5.40896H143.502L141.863 2.56903H148.421L151.701 8.24888H148.421Z" fill="currentColor"/>
<path d="M148.421 13.9287H141.863L143.502 11.0888H146.782L148.421 8.24889H151.701L148.421 13.9287Z" fill="url(#paint1_linear_13558_103869)"/>
<path d="M76.4774 8.89232C76.4774 10.9327 74.9716 12.5077 73.1366 12.5077C72.1369 12.5077 71.4106 12.1378 70.9181 11.508V12.316H69.1513V2.71994L70.9181 2.17606V6.27771C71.4106 5.64894 72.1369 5.27797 73.1366 5.27797C74.9716 5.27797 76.4774 6.85198 76.4774 8.89232ZM74.7106 8.89232C74.7106 7.73959 73.9037 6.96201 72.8076 6.96201C71.7114 6.96201 70.9213 7.74273 70.9213 8.89232C70.9213 10.0419 71.7292 10.8237 72.8076 10.8237C73.8859 10.8237 74.7106 10.043 74.7106 8.89232Z" fill="currentColor"/>
<path d="M77.2718 2.71994L79.0376 2.17606V12.316H77.2718V2.71994Z" fill="currentColor"/>
<path d="M79.8183 8.89232C79.8171 8.17544 80.0286 7.47431 80.4261 6.87774C80.8236 6.28117 81.3893 5.816 82.0514 5.54113C82.7135 5.26627 83.4422 5.19408 84.1454 5.33371C84.8485 5.47333 85.4944 5.8185 86.0013 6.32549C86.5081 6.83247 86.8531 7.47847 86.9925 8.18166C87.1319 8.88486 87.0595 9.61361 86.7845 10.2756C86.5094 10.9376 86.0441 11.5031 85.4474 11.9005C84.8507 12.2978 84.1495 12.5092 83.4326 12.5077C82.9565 12.5128 82.4842 12.4227 82.0433 12.2428C81.6024 12.0629 81.2019 11.7967 80.8653 11.46C80.5286 11.1232 80.2626 10.7227 80.0828 10.2817C79.903 9.84083 79.8131 9.36845 79.8183 8.89232ZM85.2948 8.89232C85.2948 7.78359 84.4869 7.00602 83.4326 7.00602C82.3784 7.00602 81.5841 7.78674 81.5841 8.89232C81.5841 9.9979 82.392 10.7786 83.4326 10.7786C84.4733 10.7786 85.2948 10.0021 85.2948 8.89232Z" fill="currentColor"/>
<path d="M87.7313 8.89233C87.7313 6.85198 89.2645 5.27797 91.3457 5.27797C92.6881 5.27797 93.8513 5.98952 94.413 7.04375L92.8935 7.93451C92.6189 7.37281 92.03 7.01651 91.3321 7.01651C90.2778 7.01651 89.4971 7.79723 89.4971 8.89233C89.4971 9.98743 90.2778 10.7545 91.3321 10.7545C92.0447 10.7545 92.6326 10.4129 92.904 9.8512L94.4371 10.7273C94.1281 11.2741 93.6779 11.7279 93.1335 12.0413C92.5891 12.3547 91.9706 12.5161 91.3425 12.5088C89.2645 12.5077 87.7313 10.9327 87.7313 8.89233Z" fill="currentColor"/>
<path d="M99.5123 12.316L97.0203 9.20776V12.316H95.2534V2.71994L97.0203 2.17606V8.48153L99.374 5.46974H101.482L98.7316 8.85145L101.566 12.316H99.5123Z" fill="currentColor"/>
<path d="M108.623 8.11161V12.316H106.856V8.33377C106.856 7.40215 106.296 6.92324 105.501 6.92324C104.639 6.92324 103.994 7.4294 103.994 8.62091V12.316H102.229V5.46974H103.994V6.23579C104.405 5.6196 105.118 5.27797 106.035 5.27797C107.486 5.27797 108.623 6.29657 108.623 8.11161Z" fill="currentColor"/>
<path d="M116.74 5.46974V12.316H114.975V11.508C114.481 12.1242 113.742 12.5077 112.743 12.5077C110.921 12.5077 109.415 10.9358 109.415 8.89233C109.415 6.84884 110.921 5.27797 112.743 5.27797C113.742 5.27797 114.481 5.66152 114.975 6.27771V5.46974H116.74ZM114.975 8.89233C114.975 7.73959 114.167 6.96201 113.071 6.96201C111.974 6.96201 111.184 7.74273 111.184 8.89233C111.184 10.0419 111.992 10.8237 113.071 10.8237C114.149 10.8237 114.975 10.043 114.975 8.89233Z" fill="currentColor"/>
<path d="M121.344 7.16742V5.46975H119.796V3.45665L118.027 4.00053V10.0157C118.027 11.8643 118.866 12.5895 121.342 12.3212V10.7137C120.329 10.7692 119.794 10.7545 119.794 10.0157V7.16742H121.344Z" fill="currentColor"/>
<path d="M122.582 5.46974H124.347V12.316H122.582V5.46974Z" fill="currentColor"/>
<path d="M132.293 5.46974L129.691 12.316H127.678L125.077 5.46974H127.021L128.678 10.262L130.348 5.46974H132.293Z" fill="currentColor"/>
<path d="M136.073 10.9075C136.757 10.9075 137.305 10.6204 137.607 10.2232L139.03 11.0448C138.387 11.9754 137.36 12.5119 136.046 12.5119C133.74 12.5119 132.294 10.94 132.294 8.89652C132.294 6.85303 133.761 5.28217 135.908 5.28217C137.935 5.28217 139.373 6.88447 139.373 8.89652C139.37 9.13886 139.346 9.38049 139.301 9.61856H134.143C134.389 10.5219 135.142 10.9075 136.073 10.9075ZM137.607 8.25099C137.387 7.26487 136.648 6.8677 135.908 6.8677C134.965 6.8677 134.321 7.37491 134.114 8.25099H137.607Z" fill="currentColor"/>
</g>
<defs>
<linearGradient id="paint0_linear_13558_103869" x1="141.863" y1="6.82891" x2="146.782" y2="6.82891" gradientUnits="userSpaceOnUse">
<stop stop-color="#55CCFE"/>
<stop offset="1" stop-color="#5E93EF"/>
</linearGradient>
<linearGradient id="paint1_linear_13558_103869" x1="6973.93" y1="500.862" x2="7897.53" y2="500.862" gradientUnits="userSpaceOnUse">
<stop stop-color="#55CCFE"/>
<stop offset="1" stop-color="#5E93EF"/>
</linearGradient>
<clipPath id="clip0_13558_103869">
<rect width="82.8232" height="12" fill="white" transform="translate(69.0884 2)"/>
</clipPath>
</defs>
</svg>
`;
var $6697ff39d54b09bb$var$ethereumIcon = `
  <svg height="100%" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.99902 0.12619V5.20805L9.58065 7.12736L4.99902 0.12619Z" fill="white" fill-opacity="0.602"/>
    <path d="M4.99923 0.12619L0.416992 7.12736L4.99923 5.20805V0.12619Z" fill="white"/>
    <path d="M4.99902 10.4207V13.8737L9.58371 7.92728L4.99902 10.4207Z" fill="white" fill-opacity="0.602"/>
    <path d="M4.99923 13.8737V10.4201L0.416992 7.92728L4.99923 13.8737Z" fill="white"/>
    <path d="M4.99902 9.62134L9.58065 7.12739L4.99902 5.20923V9.62134Z" fill="white" fill-opacity="0.2"/>
    <path d="M0.416992 7.12739L4.99923 9.62134V5.20923L0.416992 7.12739Z" fill="white" fill-opacity="0.602"/>
  </svg>
`;
var $6697ff39d54b09bb$var$polygonIcon = `
  <svg width="100%" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5091 4.05856C10.2585 3.91901 9.9362 3.91901 9.64974 4.05856L7.64453 5.20986L6.28385 5.94251L4.31445 7.09382C4.0638 7.23337 3.74154 7.23337 3.45508 7.09382L1.91536 6.18673C1.66471 6.04718 1.48568 5.76807 1.48568 5.45408V3.70968C1.48568 3.43057 1.62891 3.15147 1.91536 2.97703L3.45508 2.10483C3.70573 1.96527 4.02799 1.96527 4.31445 2.10483L5.85417 3.01192C6.10482 3.15147 6.28385 3.43057 6.28385 3.74457V4.89587L7.64453 4.12833V2.94214C7.64453 2.66304 7.5013 2.38393 7.21484 2.20949L4.35026 0.569752C4.09961 0.4302 3.77734 0.4302 3.49089 0.569752L0.554687 2.24438C0.268229 2.38393 0.125 2.66304 0.125 2.94214V6.22162C0.125 6.50072 0.268229 6.77983 0.554687 6.95427L3.45508 8.59401C3.70573 8.73356 4.02799 8.73356 4.31445 8.59401L6.28385 7.47759L7.64453 6.71005L9.61393 5.59363C9.86458 5.45408 10.1868 5.45408 10.4733 5.59363L12.013 6.46583C12.2637 6.60539 12.4427 6.88449 12.4427 7.19848V8.94289C12.4427 9.22199 12.2995 9.50109 12.013 9.67553L10.5091 10.5477C10.2585 10.6873 9.9362 10.6873 9.64974 10.5477L8.11002 9.67553C7.85937 9.53598 7.68034 9.25688 7.68034 8.94289V7.82647L6.31966 8.59401V9.74531C6.31966 10.0244 6.46289 10.3035 6.74935 10.478L9.64974 12.1177C9.90039 12.2572 10.2227 12.2572 10.5091 12.1177L13.4095 10.478C13.6602 10.3384 13.8392 10.0593 13.8392 9.74531V6.43095C13.8392 6.15184 13.696 5.87274 13.4095 5.6983L10.5091 4.05856Z" fill="white"/>
  </svg>
`;
var $6697ff39d54b09bb$var$binanceIcon = `
  <svg width="100%" height="100%" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.32975 5.90275L7 3.2325L9.67163 5.90413L11.2254 4.35038L7 0.125L2.776 4.349L4.32975 5.90275ZM0.125 7L1.67875 5.44625L3.2325 7L1.67875 8.55375L0.125 7ZM4.32975 8.09725L7 10.7675L9.67163 8.09587L11.2254 9.64894L7 13.875L2.776 9.651L2.77394 9.64894L4.32975 8.09725ZM10.7675 7L12.3212 5.44625L13.875 7L12.3212 8.55375L10.7675 7ZM8.57575 6.99863H8.57713V7L7 8.57713L5.42494 7.00275L5.42219 7L5.42494 6.99794L5.70062 6.72156L5.83469 6.5875L7 5.42288L8.57644 6.99931L8.57575 6.99863Z" fill="white"/>
  </svg>
`;
var $6697ff39d54b09bb$var$fantomIcon = `
  <svg height="100%" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.26613 0.133876C5.46683 0.0457135 5.68592 0 5.90775 0C6.12958 0 6.34867 0.0457135 6.54938 0.133876L10.2679 1.9598C10.3617 1.99893 10.4437 2.05898 10.5068 2.13465C10.5699 2.21033 10.6121 2.29932 10.6298 2.3938H10.6335V11.5637C10.6245 11.6667 10.5857 11.7654 10.5213 11.8495C10.457 11.9336 10.3694 11.9998 10.2679 12.0411L6.54938 13.8656C6.34867 13.9538 6.12958 13.9995 5.90775 13.9995C5.68592 13.9995 5.46683 13.9538 5.26613 13.8656L1.54762 12.0397C1.44724 11.9979 1.36095 11.9313 1.29799 11.8472C1.23504 11.7631 1.19779 11.6646 1.19025 11.5623C1.19025 11.5465 1.19025 11.5332 1.19025 11.522V2.39205C1.20579 2.29767 1.24673 2.20852 1.30923 2.13292C1.37173 2.05733 1.45375 1.99776 1.54762 1.9598L5.26613 0.133876ZM10.0478 7.50898L6.54938 9.22396C6.34872 9.31229 6.12961 9.35809 5.90775 9.35809C5.68589 9.35809 5.46678 9.31229 5.26613 9.22396L1.77525 7.51283V11.5455L5.26613 13.2493C5.43937 13.3471 5.62982 13.4154 5.82863 13.4512L5.9085 13.4558C6.12668 13.4357 6.3373 13.3704 6.525 13.2647L10.05 11.5301V7.50898H10.0478ZM0.585375 11.3642C0.568078 11.6186 0.612957 11.8734 0.716625 12.1093C0.805331 12.2602 0.936232 12.3857 1.09538 12.4726L1.10662 12.4796C1.1505 12.5069 1.1985 12.5356 1.25663 12.5692L1.32563 12.6081L1.53675 12.7267L1.23375 13.1922L0.9975 13.0592L0.95775 13.0365C0.889125 12.9973 0.8325 12.9637 0.779625 12.9315C0.214875 12.5769 0.004125 12.1912 0 11.3887V11.3642H0.585H0.585375ZM5.61412 5.05096C5.58845 5.05933 5.5634 5.06926 5.53912 5.08071L1.82137 6.90524L1.81013 6.91119H1.80675L1.81275 6.91469L1.82137 6.91889L5.53988 8.74341C5.56405 8.75505 5.58912 8.76499 5.61487 8.77316L5.61412 5.05096ZM6.201 5.05096V8.77456C6.22675 8.76639 6.25182 8.75645 6.276 8.74481L9.9945 6.92029L10.0057 6.91434H10.0091L10.0031 6.91154L9.9945 6.90699L6.276 5.08246C6.25182 5.07083 6.22675 5.06088 6.201 5.05271V5.05096ZM10.0478 3.04479L6.71025 4.68137L10.0478 6.31795V3.04304V3.04479ZM1.77525 3.04864V6.3141L5.103 4.68137L1.77525 3.04864ZM6.27525 0.61617C6.15894 0.569406 6.03364 0.545286 5.907 0.545286C5.78036 0.545286 5.65506 0.569406 5.53875 0.61617L1.821 2.4393L1.80975 2.4449L1.80638 2.44665L1.81238 2.4498L1.821 2.45365L5.5395 4.27817C5.65571 4.32526 5.78106 4.34956 5.90775 4.34956C6.03444 4.34956 6.15979 4.32526 6.276 4.27817L9.9945 2.45365L10.0057 2.4498L10.0091 2.44805L10.0031 2.4449L9.9945 2.4407L6.27525 0.61617ZM10.5968 0.816717L10.833 0.949365L10.875 0.970015C10.9432 1.00921 10.9999 1.04316 11.0528 1.07501C11.6179 1.42851 11.8282 1.81455 11.8328 2.61709V2.64159H11.2459C11.2632 2.38703 11.2183 2.13212 11.1146 1.8961C11.0258 1.74528 10.8948 1.61983 10.7355 1.53316L10.7242 1.52616C10.6807 1.49851 10.6327 1.47016 10.5743 1.43656L10.5056 1.39981L10.2945 1.28151L10.5975 0.816017L10.5968 0.816717Z" fill="white"/>
  </svg>
`;
var $6697ff39d54b09bb$var$optimismIcon = `
  <svg width="100%" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.33611 9.25254C2.38341 9.25254 1.60287 9.02834 0.99442 8.58002C0.393974 8.1237 0.09375 7.47526 0.09375 6.63462C0.09375 6.45849 0.113782 6.2423 0.153782 5.9861C0.257909 5.40972 0.406006 4.71718 0.598133 3.9086C1.14252 1.707 2.54757 0.606201 4.81323 0.606201C5.42967 0.606201 5.98206 0.710266 6.47044 0.918394C6.95882 1.11852 7.34308 1.42278 7.62327 1.8311C7.90346 2.23135 8.04362 2.71174 8.04362 3.27212C8.04362 3.44025 8.02359 3.65241 7.98352 3.9086C7.86346 4.62111 7.71933 5.31366 7.55121 5.9861C7.27101 7.08294 6.78666 7.90354 6.09815 8.44793C5.40964 8.98431 4.489 9.25254 3.33611 9.25254ZM3.50424 7.52326C3.95262 7.52326 4.33284 7.39116 4.6451 7.12697C4.96535 6.86278 5.19351 6.45849 5.32958 5.9141C5.51371 5.16153 5.65387 4.50502 5.74993 3.94463C5.78193 3.7765 5.79793 3.60441 5.79793 3.42822C5.79793 2.6997 5.41764 2.33542 4.65713 2.33542C4.20875 2.33542 3.82449 2.46751 3.50424 2.7317C3.19205 2.99596 2.96786 3.40025 2.83179 3.94463C2.68766 4.48102 2.54354 5.13753 2.39947 5.9141C2.36741 6.07417 2.35141 6.2423 2.35141 6.41842C2.35141 7.155 2.73573 7.52326 3.50424 7.52326Z" fill="white"/>
    <path d="M8.59569 9.13247C8.50762 9.13247 8.43953 9.10443 8.39153 9.04837C8.35146 8.98431 8.33949 8.9123 8.35549 8.83224L10.0127 1.02648C10.0287 0.938417 10.0727 0.866353 10.1448 0.810289C10.2169 0.754289 10.2929 0.726257 10.373 0.726257H13.5673C14.456 0.726257 15.1685 0.910385 15.7049 1.27864C16.2493 1.64696 16.5215 2.17931 16.5215 2.87582C16.5215 3.07595 16.4975 3.28415 16.4495 3.50027C16.2493 4.42098 15.845 5.10149 15.2366 5.54181C14.6361 5.98213 13.8115 6.20229 12.7627 6.20229H11.1415L10.5892 8.83224C10.5731 8.92031 10.5291 8.99231 10.4571 9.04837C10.385 9.10443 10.3089 9.13247 10.2289 9.13247H8.59569ZM12.8468 4.54507C13.183 4.54507 13.4752 4.45298 13.7234 4.26885C13.9796 4.08472 14.1478 3.82053 14.2278 3.47627C14.2518 3.34015 14.2639 3.22008 14.2639 3.11602C14.2639 2.88383 14.1958 2.7077 14.0597 2.58763C13.9236 2.45951 13.6914 2.3955 13.3632 2.3955H11.9221L11.4658 4.54507H12.8468Z" fill="white"/>
  </svg>
`;
var $6697ff39d54b09bb$var$avalancheIcon = `
  <svg width="100%" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.8682 0.489349H0.110352V18.4468H19.8682V0.489349Z" fill="white"/>
  </svg>
`;
var $6697ff39d54b09bb$var$celoIcon = `
  <svg width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.1511 8.08001C19.1511 4.11201 15.9191 0.880005 11.9511 0.880005C8.94313 0.880005 6.38313 2.70401 5.29513 5.32801C2.73513 6.41601 0.911133 8.976 0.911133 11.952C0.911133 15.92 4.14313 19.152 8.11113 19.152C11.1191 19.152 13.6791 17.328 14.7671 14.704C17.2951 13.616 19.1511 11.056 19.1511 8.08001ZM8.11113 17.36C5.13513 17.36 2.70313 14.928 2.70313 11.952C2.70313 10.256 3.50313 8.72001 4.75113 7.72801C4.75113 7.85601 4.75113 7.98401 4.75113 8.08001C4.75113 12.048 7.98313 15.28 11.9511 15.28C12.1111 15.28 12.2391 15.28 12.3991 15.28C11.3751 16.56 9.83913 17.36 8.11113 17.36ZM13.3591 13.296C12.9111 13.424 12.4311 13.488 11.9511 13.488C8.97513 13.488 6.54313 11.056 6.54313 8.08001C6.54313 7.60001 6.60713 7.15201 6.73513 6.736C7.18313 6.60801 7.66313 6.54401 8.14313 6.54401C11.1191 6.54401 13.5511 8.976 13.5511 11.952C13.5191 12.432 13.4551 12.88 13.3591 13.296ZM15.3111 12.304C15.3111 12.176 15.3111 12.048 15.3111 11.952C15.3111 7.984 12.0791 4.752 8.11113 4.752C7.95113 4.752 7.82313 4.752 7.66313 4.752C8.65513 3.472 10.1911 2.67201 11.9191 2.67201C14.8951 2.67201 17.3271 5.10401 17.3271 8.08001C17.3271 9.80801 16.5271 11.312 15.3111 12.304Z" fill="white"/>
  </svg>
`;
var $6697ff39d54b09bb$var$gnosisIcon = `
  <svg width="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z" fill="#04795B"/>
    <path d="M11.6529 17.4492C12.2831 17.4492 12.8648 17.2392 13.3334 16.8758L9.4877 13.0316C9.12413 13.4919 8.9141 14.0734 8.9141 14.7114C8.906 16.2216 10.134 17.4492 11.6529 17.4492Z" fill="#EFEFEF"/>
    <path d="M23.0931 14.7033C23.0931 14.0734 22.8831 13.4919 22.5195 13.0234L18.6738 16.8677C19.1343 17.2311 19.716 17.4411 20.3543 17.4411C21.8651 17.4492 23.0931 16.2216 23.0931 14.7033Z" fill="#EFEFEF"/>
    <path d="M25.0322 10.528L23.3275 12.2321C23.8931 12.9105 24.2324 13.7666 24.2324 14.7195C24.2324 16.8597 22.4954 18.5961 20.3544 18.5961C19.4092 18.5961 18.5447 18.2569 17.866 17.6915L15.9998 19.5571L14.1335 17.6915C13.4549 18.2569 12.5985 18.5961 11.6451 18.5961C9.50416 18.5961 7.7672 16.8597 7.7672 14.7195C7.7672 13.7746 8.10651 12.9105 8.67206 12.2321L7.79947 11.3599L6.96736 10.528C5.99787 12.1271 5.44043 13.9927 5.44043 15.9956C5.44043 21.8265 10.1667 26.543 15.9917 26.543C21.8167 26.543 26.543 21.8185 26.543 15.9956C26.5591 13.9846 26.0017 12.119 25.0322 10.528Z" fill="#EFEFEF"/>
    <path d="M23.6338 8.71084C21.7191 6.6999 19.0045 5.44 15.9991 5.44C12.9937 5.44 10.2872 6.6999 8.36435 8.71084C8.10584 8.98545 7.85539 9.27617 7.62109 9.575L15.991 17.9419L24.361 9.56695C24.1509 9.27617 23.9005 8.97734 23.6338 8.71084ZM15.9991 6.81297C18.4713 6.81297 20.7658 7.76593 22.4866 9.50231L15.9991 15.9874L9.5116 9.50231C11.2405 7.76593 13.5269 6.81297 15.9991 6.81297Z" fill="#EFEFEF"/>
  </svg>
`;
var $6697ff39d54b09bb$var$harmonyOneIcon = `
  <svg width="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5484 1.04102e-06C11.6346 -0.000708404 10.7578 0.361217 10.1105 1.00633C9.46322 1.65145 9.09835 2.52703 9.096 3.44089V7.256C8.74045 7.28 8.37689 7.29511 8 7.29511C7.62311 7.29511 7.26133 7.31022 6.904 7.33156V3.44089C6.88946 2.53496 6.51938 1.67105 5.87358 1.03553C5.22779 0.400017 4.35805 0.0438409 3.452 0.0438409C2.54595 0.0438409 1.67621 0.400017 1.03042 1.03553C0.384623 1.67105 0.0145378 2.53496 0 3.44089V12.5591C0.0145378 13.465 0.384623 14.329 1.03042 14.9645C1.67621 15.6 2.54595 15.9562 3.452 15.9562C4.35805 15.9562 5.22779 15.6 5.87358 14.9645C6.51938 14.329 6.88946 13.465 6.904 12.5591V8.744C7.25956 8.72 7.62311 8.70489 8 8.70489C8.37689 8.70489 8.73867 8.68978 9.096 8.66845V12.5591C9.11054 13.465 9.48062 14.329 10.1264 14.9645C10.7722 15.6 11.6419 15.9562 12.548 15.9562C13.4541 15.9562 14.3238 15.6 14.9696 14.9645C15.6154 14.329 15.9855 13.465 16 12.5591V3.44089C15.9976 2.52719 15.6329 1.65173 14.9858 1.00665C14.3387 0.361557 13.4622 -0.000472854 12.5484 1.04102e-06ZM3.45156 1.40978C3.99089 1.40954 4.50828 1.62326 4.89023 2.00404C5.27218 2.38482 5.48748 2.90156 5.48889 3.44089V7.48089C4.47892 7.62724 3.49264 7.90609 2.55556 8.31023C2.14954 8.48842 1.76733 8.71655 1.41778 8.98934V3.44089C1.41919 2.90218 1.634 2.38597 2.01518 2.00529C2.39636 1.62462 2.91284 1.41048 3.45156 1.40978ZM5.48889 12.5591C5.48889 13.0994 5.27424 13.6177 4.89217 13.9997C4.51009 14.3818 3.99189 14.5964 3.45156 14.5964C2.91122 14.5964 2.39302 14.3818 2.01094 13.9997C1.62887 13.6177 1.41422 13.0994 1.41422 12.5591V11.6444C1.41422 10.8364 2.05422 10.0711 3.12711 9.59467C3.88309 9.26852 4.6763 9.03656 5.48889 8.904V12.5591ZM12.5484 14.5902C12.0091 14.5905 11.4917 14.3767 11.1098 13.996C10.7278 13.6152 10.5125 13.0984 10.5111 12.5591V8.51911C11.5211 8.37276 12.5074 8.09392 13.4444 7.68978C13.8505 7.51159 14.2327 7.28345 14.5822 7.01067V12.5591C14.5808 13.0978 14.366 13.614 13.9848 13.9947C13.6036 14.3754 13.0872 14.5895 12.5484 14.5902ZM12.8729 6.4C12.1169 6.72615 11.3237 6.95811 10.5111 7.09067V3.44089C10.5111 2.90056 10.7258 2.38235 11.1078 2.00028C11.4899 1.6182 12.0081 1.40356 12.5484 1.40356C13.0888 1.40356 13.607 1.6182 13.9891 2.00028C14.3711 2.38235 14.5858 2.90056 14.5858 3.44089V4.35556C14.5858 5.16 13.9458 5.92534 12.8729 6.4Z" fill="url(#paint0_linear_10254_2422)"/>
    <defs>
      <linearGradient id="paint0_linear_10254_2422" x1="1.01333" y1="14.7674" x2="14.8954" y2="0.847434" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00AEE9"/>
        <stop offset="1" stop-color="#69FABD"/>
      </linearGradient>
    </defs>
  </svg>
`;
var $6697ff39d54b09bb$var$arbitrumIcon = `
  <svg height="100%" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.7827 11.3172L15.5966 8.23933L20.4858 15.8545L20.4881 17.3159L20.4722 7.25942C20.4606 7.0136 20.3301 6.7887 20.1218 6.6561L11.3194 1.5928C11.1135 1.49162 10.8523 1.49269 10.6468 1.59594C10.6191 1.60989 10.593 1.62499 10.568 1.64147L10.5374 1.66079L1.99318 6.6121L1.95999 6.62712C1.91737 6.64674 1.8743 6.67165 1.83382 6.70063C1.67186 6.81683 1.56424 6.98861 1.52944 7.18131C1.52423 7.21052 1.52039 7.24026 1.51855 7.27023L1.53197 15.4653L6.08607 8.40666C6.65942 7.47067 7.90869 7.1692 9.06835 7.1856L10.4295 7.22155L2.40986 20.0827L3.3552 20.627L11.4709 7.23458L15.0581 7.22155L6.96327 20.9519L10.3366 22.8921L10.7396 23.1239C10.9101 23.1932 11.111 23.1967 11.283 23.1347L20.2091 17.9618L18.5026 18.9507L13.7827 11.3172ZM14.4747 21.2849L11.0677 15.9375L13.1474 12.4083L17.622 19.461L14.4747 21.2849Z" fill="#2D374B"/>
    <path d="M11.0684 15.9375L14.4754 21.2849L17.6228 19.4609L13.1482 12.4083L11.0684 15.9375Z" fill="#28A0F0"/>
    <path d="M20.4887 17.3159L20.4864 15.8545L15.5972 8.23932L13.7832 11.3172L18.5031 18.9507L20.2097 17.9618C20.3771 17.8259 20.4783 17.6264 20.489 17.4111L20.4887 17.3159Z" fill="#28A0F0"/>
    <path d="M7.71943e-05 18.694L2.41 20.0826L10.4296 7.22152L9.0685 7.18557C7.90883 7.16916 6.65964 7.47063 6.08621 8.40662L1.53211 15.4652L0 17.8193V18.694H7.71943e-05Z" fill="white"/>
    <path d="M15.0582 7.22156L11.4712 7.23459L3.35547 20.627L6.19211 22.2603L6.96354 20.9519L15.0582 7.22156Z" fill="white"/>
    <path d="M21.9999 7.20306C21.97 6.45287 21.5638 5.76608 20.9275 5.36626L12.0097 0.237888C11.3803 -0.079066 10.594 -0.0794494 9.96363 0.237658C9.88913 0.275218 1.2912 5.26171 1.2912 5.26171C1.17223 5.31874 1.05764 5.38673 0.949789 5.46384C0.381801 5.87094 0.0355663 6.50346 0 7.19846V17.8194L1.53211 15.4653L1.5187 7.27029C1.52054 7.24032 1.52429 7.21088 1.52958 7.18175C1.56415 6.9889 1.67185 6.81689 1.83397 6.70069C1.87444 6.67171 10.6192 1.60995 10.647 1.596C10.8526 1.49275 11.1137 1.49168 11.3195 1.59286L20.122 6.65616C20.3302 6.78876 20.4608 7.01366 20.4723 7.25948V17.4111C20.4617 17.6265 20.3766 17.8259 20.2092 17.9619L18.5026 18.9508L17.6221 19.461L14.4748 21.285L11.283 23.1347C11.1111 23.1968 10.9101 23.1933 10.7397 23.124L6.96334 20.952L6.19191 22.2603L9.58559 24.2142C9.6978 24.278 9.79784 24.3345 9.87985 24.3807C10.0069 24.452 10.0935 24.4996 10.1241 24.5144C10.3653 24.6315 10.7123 24.6997 11.025 24.6997C11.3118 24.6997 11.5913 24.647 11.8559 24.5434L21.1266 19.1745C21.6587 18.7623 21.9717 18.1406 21.9999 17.467V7.20306Z" fill="#96BEDC"/>
  </svg>
`;
var $6697ff39d54b09bb$var$baseIcon = `
<svg height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1607_202)">
<mask id="mask0_1607_202" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
<path d="M32 0H0V32H32V0Z" fill="white"/>
</mask>
<g mask="url(#mask0_1607_202)">
<path d="M16 32C19.1645 32 22.258 31.0616 24.8892 29.3036C27.5204 27.5454 29.571 25.0466 30.782 22.123C31.993 19.1993 32.31 15.9823 31.6926 12.8786C31.0752 9.77486 29.5514 6.92394 27.3138 4.6863C25.076 2.44866 22.2252 0.924806 19.1214 0.307442C16.0177 -0.30992 12.8007 0.0069325 9.87706 1.21793C6.95344 2.42894 4.45458 4.4797 2.69648 7.11088C0.938384 9.74206 0 12.8355 0 16C0 20.2434 1.68571 24.3132 4.6863 27.3138C7.68688 30.3142 11.7565 32 16 32Z" fill="#0052FF"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9624 27.2676C22.1852 27.2676 27.23 22.223 27.23 16C27.23 9.7771 22.1852 4.73242 15.9624 4.73242C10.0588 4.73242 5.21566 9.2726 4.7341 15.0518H21.4546V16.928H4.73242C5.20432 22.7168 10.0519 27.2676 15.9624 27.2676Z" fill="white"/>
</g>
</g>
<defs>
<clipPath id="clip0_1607_202">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
`;
var $6697ff39d54b09bb$var$hourglass = `
<svg width="100%" height="100%" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 0L0.0100002 6L4 10L0.0100002 14.01L0 20H12V14L8 10L12 6.01V0H0ZM10 14.5V18H2V14.5L6 10.5L10 14.5Z" fill="#929BED"/>
</svg>
`;
var $6697ff39d54b09bb$export$f787f51d84a910ad = `
  <svg width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.07 12.85C11.84 11.46 13.32 10.64 14.18 9.41C15.09 8.12 14.58 5.71 12 5.71C10.31 5.71 9.48 6.99 9.13 8.05L6.54 6.96C7.25 4.83 9.18 3 11.99 3C14.34 3 15.95 4.07 16.77 5.41C17.47 6.56 17.88 8.71 16.8 10.31C15.6 12.08 14.45 12.62 13.83 13.76C13.58 14.22 13.48 14.52 13.48 16H10.59C10.58 15.22 10.46 13.95 11.07 12.85ZM14 20C14 21.1 13.1 22 12 22C10.9 22 10 21.1 10 20C10 18.9 10.9 18 12 18C13.1 18 14 18.9 14 20Z" fill="currentColor"/>
  </svg>
`;
var $6697ff39d54b09bb$var$checkmark = `
<svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.48076 8.10881L1.33076 4.95881L0.280762 6.00881L4.48076 10.2088L13.4808 1.20881L12.4308 0.158813L4.48076 8.10881Z" fill="#A4F4C6"/>
</svg>
`;
var $6697ff39d54b09bb$var$errorIcon = `<svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.666992 13.0002H15.3337L8.00033 0.333496L0.666992 13.0002ZM8.66699 11.0002H7.33366V9.66683H8.66699V11.0002ZM8.66699 8.3335H7.33366V5.66683H8.66699V8.3335Z" fill="#FFB3B3"/>
</svg>
`;
var $6697ff39d54b09bb$var$infoIcon = `
  <svg width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="currentColor"/>
  </svg>
`;
var $6697ff39d54b09bb$var$successIcon = `
  <svg width="100%" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.74999 12.15L3.59999 9L2.54999 10.05L6.74999 14.25L15.75 5.25L14.7 4.2L6.74999 12.15Z" fill="currentColor"/>
  </svg>
`;
var $6697ff39d54b09bb$var$pendingIcon = `
  <svg width="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 2L6.01 8L10 12L6.01 16.01L6 22H18V16L14 12L18 8.01V2H6ZM16 16.5V20H8V16.5L12 12.5L16 16.5Z" fill="currenColor"/>
  </svg>
`;
function $6697ff39d54b09bb$var$getDevice() {
    if (typeof window !== "undefined") {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($kyrHl))).getParser(window.navigator.userAgent);
        const os = parsed.getOS();
        const browser = parsed.getBrowser();
        const { type: type } = parsed.getPlatform();
        return {
            type: type,
            os: os,
            browser: browser
        };
    } else return {
        type: null,
        os: null,
        browser: null
    };
}
const $6697ff39d54b09bb$var$notNullish = (value)=>value != null;
function $6697ff39d54b09bb$var$validEnsChain(chainId) {
    // return L2s as Eth for ens resolution
    switch(chainId){
        case "0x1":
        case "0x89":
        case "0xa":
        case "0xa4b1":
        case "0xa4ba":
        case "0x144":
            return "0x1";
        case "0x5":
            return chainId;
        case "0xaa36a7":
            return chainId;
        default:
            return null;
    }
}
function $6697ff39d54b09bb$export$34aec0b863436764(str) {
    return str.includes("<svg");
}
function $6697ff39d54b09bb$export$a9c23c6ac3fc3eca(add) {
    return `${add.slice(0, 6)}\u{2026}${add.slice(-4)}`;
}
function $6697ff39d54b09bb$export$96f57966bedc81b4(domain) {
    return domain.length > 11 ? `${domain.slice(0, 4)}\u{2026}${domain.slice(-6)}` : domain;
}
async function $6697ff39d54b09bb$export$3722cfe417b6ed86(text) {
    try {
        const copy = await navigator.clipboard.writeText(text);
        return copy;
    } catch (err) {
        console.error("Failed to copy: ", err);
    }
}
const $6697ff39d54b09bb$export$d24c54395ce0c509 = (val)=>typeof val === "number" ? `0x${val.toString(16)}` : val;
function $6697ff39d54b09bb$var$chainIdToHex(chains) {
    return chains.map(({ id: id, ...rest })=>{
        const hexId = $6697ff39d54b09bb$export$d24c54395ce0c509(id);
        return {
            id: hexId,
            ...rest
        };
    });
}
function $6697ff39d54b09bb$export$8a5498727ef6be21(gwei) {
    return `0x${(gwei * 1e9).toString(16)}`;
}
const $6697ff39d54b09bb$export$43caf9889c228507 = {
    "0x1": "Ethereum",
    "0x3": "Ropsten",
    "0x4": "Rinkeby",
    "0x5": "Goerli",
    "0xaa36a7": "Sepolia",
    "0x2a": "Kovan",
    "0x38": "Binance",
    "0x89": "Polygon",
    "0xfa": "Fantom",
    "0xa": "Optimism",
    "0x45": "Optimism Kovan",
    "0xa86a": "Avalanche",
    "0xa4ec": "Celo",
    "0x2105": "Base",
    "0x14a33": "Base Goerli",
    "0x64": "Gnosis",
    "0x63564C40": "Harmony One",
    "0xa4b1": "Arbitrum One",
    "0xa4ba": "Arbitrum Nova"
};
const $6697ff39d54b09bb$export$2f6ca3d3b1f80bf5 = {
    main: "0x1",
    ropsten: "0x3",
    rinkeby: "0x4",
    goerli: "0x5",
    kovan: "0x2a",
    xdai: "0x64",
    "bsc-main": "0x38",
    "matic-main": "0x89",
    "fantom-main": "0xfa",
    "matic-mumbai": "0x80001"
};
const $6697ff39d54b09bb$export$6554612db691658e = {
    "0x1": {
        icon: $6697ff39d54b09bb$var$ethereumIcon,
        color: "#627EEA"
    },
    "0x3": {
        icon: $6697ff39d54b09bb$var$ethereumIcon,
        color: "#627EEA"
    },
    "0x4": {
        icon: $6697ff39d54b09bb$var$ethereumIcon,
        color: "#627EEA"
    },
    "0x5": {
        icon: $6697ff39d54b09bb$var$ethereumIcon,
        color: "#627EEA"
    },
    "0x2a": {
        icon: $6697ff39d54b09bb$var$ethereumIcon,
        color: "#627EEA"
    },
    "0xaa36a7": {
        icon: $6697ff39d54b09bb$var$ethereumIcon,
        color: "#627EEA"
    },
    "0x38": {
        icon: $6697ff39d54b09bb$var$binanceIcon,
        color: "#F3BA2F"
    },
    "0x89": {
        icon: $6697ff39d54b09bb$var$polygonIcon,
        color: "#8247E5"
    },
    "0xfa": {
        icon: $6697ff39d54b09bb$var$fantomIcon,
        color: "#1969FF"
    },
    "0xa": {
        icon: $6697ff39d54b09bb$var$optimismIcon,
        color: "#FF0420"
    },
    "0x45": {
        icon: $6697ff39d54b09bb$var$optimismIcon,
        color: "#FF0420"
    },
    "0xa86a": {
        icon: $6697ff39d54b09bb$var$avalancheIcon,
        color: "#E84142"
    },
    "0xa4ec": {
        icon: $6697ff39d54b09bb$var$celoIcon,
        color: "#FBCC5C"
    },
    "0x64": {
        icon: $6697ff39d54b09bb$var$gnosisIcon,
        color: "#04795B"
    },
    "0x63564C40": {
        icon: $6697ff39d54b09bb$var$harmonyOneIcon,
        color: "#ffffff"
    },
    "0xa4b1": {
        icon: $6697ff39d54b09bb$var$arbitrumIcon,
        color: "#33394B"
    },
    "0xa4ba": {
        icon: $6697ff39d54b09bb$var$arbitrumIcon,
        color: "#33394B"
    },
    "0x2105": {
        icon: $6697ff39d54b09bb$var$baseIcon,
        color: "#0259F9"
    },
    "0x14a33": {
        icon: $6697ff39d54b09bb$var$baseIcon,
        color: "#0259F9"
    },
    "0x80001": {
        icon: $6697ff39d54b09bb$var$polygonIcon,
        color: "#8247E5"
    }
};
const $6697ff39d54b09bb$export$2e2af4578d910ddf = {
    icon: $6697ff39d54b09bb$export$f787f51d84a910ad,
    color: "#33394B"
};
function $6697ff39d54b09bb$export$efca4cbe5dd06740(chainId) {
    return chainId ? $6697ff39d54b09bb$export$6554612db691658e[chainId.toLowerCase()] : undefined;
}
function $6697ff39d54b09bb$export$dda1d9f60106f0e9(walletConnectedChain, chains) {
    return !!chains.find(({ id: id, namespace: namespace })=>id === walletConnectedChain.id && namespace === walletConnectedChain.namespace);
}
const $6697ff39d54b09bb$export$7a38258bbe170828 = {
    pending: {
        backgroundColor: "var(--onboard-primary-700, var(--primary-700))",
        borderColor: "#6370E5",
        eventIcon: $6697ff39d54b09bb$var$hourglass
    },
    success: {
        backgroundColor: "#052E17",
        borderColor: "var(--onboard-success-300, var(--success-300))",
        eventIcon: $6697ff39d54b09bb$var$checkmark
    },
    error: {
        backgroundColor: "#FDB1B11A",
        borderColor: "var(--onboard-danger-300, var(--danger-300))",
        eventIcon: $6697ff39d54b09bb$var$errorIcon
    },
    hint: {
        backgroundColor: "var(--onboard-gray-500, var(--gray-500))",
        borderColor: "var(--onboard-gray-500, var(--gray-500))",
        iconColor: "var(--onboard-gray-100, var(--gray-100))",
        eventIcon: $6697ff39d54b09bb$var$infoIcon
    }
};
const $6697ff39d54b09bb$var$wait$1 = (time)=>new Promise((resolve)=>setTimeout(resolve, time));
function $6697ff39d54b09bb$var$getLocalStore(key) {
    try {
        const result = localStorage.getItem(key);
        return result;
    } catch (error) {
        return null;
    }
}
function $6697ff39d54b09bb$var$setLocalStore(key, value) {
    try {
        localStorage.setItem(key, value);
    } catch (error) {
        return;
    }
}
function $6697ff39d54b09bb$var$delLocalStore(key) {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        return;
    }
}
let $6697ff39d54b09bb$export$c9170ad7d4cd7e57 = {
    svelteInstance: null,
    apiKey: null,
    device: $6697ff39d54b09bb$var$getDevice(),
    initialWalletInit: [],
    gas: null,
    containerElements: {
        accountCenter: null,
        connectModal: null
    },
    transactionPreview: null,
    unstoppableResolution: null
};
function $6697ff39d54b09bb$var$updateConfiguration(update) {
    $6697ff39d54b09bb$export$c9170ad7d4cd7e57 = {
        ...$6697ff39d54b09bb$export$c9170ad7d4cd7e57,
        ...update
    };
}
const $6697ff39d54b09bb$var$APP_INITIAL_STATE = {
    wallets: [],
    walletModules: [],
    chains: [],
    accountCenter: {
        enabled: true,
        position: "bottomRight",
        expanded: false,
        minimal: true
    },
    notify: {
        enabled: true,
        transactionHandler: ()=>{},
        position: "topRight",
        replacement: {
            gasPriceProbability: {
                speedup: 80,
                cancel: 95
            }
        }
    },
    notifications: [],
    locale: "",
    connect: {
        showSidebar: true,
        disableClose: false
    },
    appMetadata: null
};
const $6697ff39d54b09bb$var$STORAGE_KEYS = {
    TERMS_AGREEMENT: "onboard.js:agreement",
    LAST_CONNECTED_WALLET: "onboard.js:last_connected_wallet"
};
const $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH = 768;
const $6697ff39d54b09bb$export$995eb9fca571757 = "https://rpc.blocknative.com/boost";
const $6697ff39d54b09bb$export$a8550f7dbe79f93a = "https://docs.blocknative.com/blocknative-mev-protection/transaction-boost";
const $6697ff39d54b09bb$var$ADD_CHAINS = "add_chains";
const $6697ff39d54b09bb$var$UPDATE_CHAINS = "update_chains";
const $6697ff39d54b09bb$var$RESET_STORE = "reset_store";
const $6697ff39d54b09bb$var$ADD_WALLET = "add_wallet";
const $6697ff39d54b09bb$var$UPDATE_WALLET = "update_wallet";
const $6697ff39d54b09bb$var$REMOVE_WALLET = "remove_wallet";
const $6697ff39d54b09bb$var$UPDATE_ACCOUNT = "update_account";
const $6697ff39d54b09bb$var$UPDATE_ACCOUNT_CENTER = "update_account_center";
const $6697ff39d54b09bb$var$UPDATE_CONNECT_MODAL = "update_connect_modal";
const $6697ff39d54b09bb$var$SET_WALLET_MODULES = "set_wallet_modules";
const $6697ff39d54b09bb$var$SET_LOCALE = "set_locale";
const $6697ff39d54b09bb$var$UPDATE_NOTIFY = "update_notify";
const $6697ff39d54b09bb$var$ADD_NOTIFICATION = "add_notification";
const $6697ff39d54b09bb$var$REMOVE_NOTIFICATION = "remove_notification";
const $6697ff39d54b09bb$var$UPDATE_ALL_WALLETS = "update_balance";
const $6697ff39d54b09bb$var$UPDATE_APP_METADATA = "update_app_metadata";
function $6697ff39d54b09bb$var$reducer(state1, action) {
    const { type: type, payload: payload } = action;
    switch(type){
        case $6697ff39d54b09bb$var$ADD_CHAINS:
            return {
                ...state1,
                chains: [
                    ...state1.chains,
                    ...payload
                ]
            };
        case $6697ff39d54b09bb$var$UPDATE_CHAINS:
            {
                const updatedChain = payload;
                const chains = state1.chains;
                const index = chains.findIndex((chain)=>chain.id === updatedChain.id);
                chains[index] = updatedChain;
                return {
                    ...state1,
                    chains: chains
                };
            }
        case $6697ff39d54b09bb$var$ADD_WALLET:
            {
                const wallet = payload;
                const existingWallet = state1.wallets.find(({ label: label })=>label === wallet.label);
                return {
                    ...state1,
                    wallets: [
                        // add to front of wallets as it is now the primary wallet
                        existingWallet || payload,
                        // filter out wallet if it already existed
                        ...state1.wallets.filter(({ label: label })=>label !== wallet.label)
                    ]
                };
            }
        case $6697ff39d54b09bb$var$UPDATE_WALLET:
            {
                const update = payload;
                const { id: id, ...walletUpdate } = update;
                const updatedWallets = state1.wallets.map((wallet)=>wallet.label === id ? {
                        ...wallet,
                        ...walletUpdate
                    } : wallet);
                return {
                    ...state1,
                    wallets: updatedWallets
                };
            }
        case $6697ff39d54b09bb$var$REMOVE_WALLET:
            {
                const update = payload;
                return {
                    ...state1,
                    wallets: state1.wallets.filter(({ label: label })=>label !== update.id)
                };
            }
        case $6697ff39d54b09bb$var$UPDATE_ACCOUNT:
            {
                const update = payload;
                const { id: id, address: address, ...accountUpdate } = update;
                const updatedWallets = state1.wallets.map((wallet)=>{
                    if (wallet.label === id) wallet.accounts = wallet.accounts.map((account)=>{
                        if (account.address === address) return {
                            ...account,
                            ...accountUpdate
                        };
                        return account;
                    });
                    return wallet;
                });
                return {
                    ...state1,
                    wallets: updatedWallets
                };
            }
        case $6697ff39d54b09bb$var$UPDATE_ALL_WALLETS:
            {
                const updatedWallets = payload;
                return {
                    ...state1,
                    wallets: updatedWallets
                };
            }
        case $6697ff39d54b09bb$var$UPDATE_CONNECT_MODAL:
            {
                const update = payload;
                return {
                    ...state1,
                    connect: {
                        ...state1.connect,
                        ...update
                    }
                };
            }
        case $6697ff39d54b09bb$var$UPDATE_ACCOUNT_CENTER:
            {
                const update = payload;
                return {
                    ...state1,
                    accountCenter: {
                        ...state1.accountCenter,
                        ...update
                    }
                };
            }
        case $6697ff39d54b09bb$var$UPDATE_NOTIFY:
            {
                const update = payload;
                return {
                    ...state1,
                    notify: {
                        ...state1.notify,
                        ...update
                    }
                };
            }
        case $6697ff39d54b09bb$var$ADD_NOTIFICATION:
            {
                const update = payload;
                const notificationsUpdate = [
                    ...state1.notifications
                ];
                const notificationExistsIndex = notificationsUpdate.findIndex(({ id: id })=>id === update.id);
                if (notificationExistsIndex !== -1) // if notification with same id, replace it with update
                notificationsUpdate[notificationExistsIndex] = update;
                else // otherwise add it to the beginning of array as new notification
                notificationsUpdate.unshift(update);
                return {
                    ...state1,
                    notifications: notificationsUpdate
                };
            }
        case $6697ff39d54b09bb$var$REMOVE_NOTIFICATION:
            {
                const id = payload;
                return {
                    ...state1,
                    notifications: state1.notifications.filter((notification)=>notification.id !== id)
                };
            }
        case $6697ff39d54b09bb$var$SET_WALLET_MODULES:
            return {
                ...state1,
                walletModules: payload
            };
        case $6697ff39d54b09bb$var$SET_LOCALE:
            // Set the locale in the svelte-i18n internal state
            (0, $6y4qQ.locale).set(payload);
            return {
                ...state1,
                locale: payload
            };
        case $6697ff39d54b09bb$var$UPDATE_APP_METADATA:
            {
                const update = payload;
                return {
                    ...state1,
                    appMetadata: {
                        ...state1.appMetadata,
                        ...update
                    }
                };
            }
        case $6697ff39d54b09bb$var$RESET_STORE:
            return $6697ff39d54b09bb$var$APP_INITIAL_STATE;
        default:
            throw new Error(`Unknown type: ${type} in appStore reducer`);
    }
}
const $6697ff39d54b09bb$var$_store = new (0, $axHCK.BehaviorSubject)($6697ff39d54b09bb$var$APP_INITIAL_STATE);
const $6697ff39d54b09bb$var$_stateUpdates = new (0, $3TBY8.Subject)();
$6697ff39d54b09bb$var$_stateUpdates.subscribe($6697ff39d54b09bb$var$_store);
function $6697ff39d54b09bb$var$dispatch$1(action) {
    const state1 = $6697ff39d54b09bb$var$_store.getValue();
    $6697ff39d54b09bb$var$_stateUpdates.next($6697ff39d54b09bb$var$reducer(state1, action));
}
function $6697ff39d54b09bb$var$select(stateKey) {
    if (!stateKey) return $6697ff39d54b09bb$var$_stateUpdates.asObservable();
    const validStateKeys = Object.keys($6697ff39d54b09bb$var$_store.getValue());
    if (!validStateKeys.includes(String(stateKey))) throw new Error(`key: ${stateKey} does not exist on this store`);
    return $6697ff39d54b09bb$var$_stateUpdates.asObservable().pipe((0, $7QREK.distinctUntilKeyChanged)(stateKey), (0, $6vUKV.pluck)(stateKey), (0, $d6DLj.filter)($6697ff39d54b09bb$var$notNullish));
}
function $6697ff39d54b09bb$var$get() {
    return $6697ff39d54b09bb$var$_store.getValue();
}
const $6697ff39d54b09bb$export$6559d589eb85fbb6 = {
    select: $6697ff39d54b09bb$var$select,
    get: $6697ff39d54b09bb$var$get
};
function $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5() {}
const $6697ff39d54b09bb$var$identity = (x)=>x;
function $6697ff39d54b09bb$var$assign(tar, src) {
    // @ts-ignore
    for(const k in src)tar[k] = src[k];
    return tar;
}
// Adapted from https://github.com/then/is-promise/blob/master/index.js
// Distributed under MIT License https://github.com/then/is-promise/blob/master/LICENSE
function $6697ff39d54b09bb$var$is_promise(value) {
    return !!value && (typeof value === "object" || typeof value === "function") && typeof value.then === "function";
}
function $6697ff39d54b09bb$var$run(fn) {
    return fn();
}
function $6697ff39d54b09bb$var$blank_object() {
    return Object.create(null);
}
function $6697ff39d54b09bb$export$61196ced6d74a310(fns) {
    fns.forEach($6697ff39d54b09bb$var$run);
}
function $6697ff39d54b09bb$export$dc98b0b04f4c7758(thing) {
    return typeof thing === "function";
}
function $6697ff39d54b09bb$export$2408f22a0fab9ae5(a, b) {
    return a != a ? b == b : a !== b || a && typeof a === "object" || typeof a === "function";
}
let $6697ff39d54b09bb$var$src_url_equal_anchor;
function $6697ff39d54b09bb$export$3c2fa207a37baaea(element_src, url) {
    if (!$6697ff39d54b09bb$var$src_url_equal_anchor) $6697ff39d54b09bb$var$src_url_equal_anchor = document.createElement("a");
    $6697ff39d54b09bb$var$src_url_equal_anchor.href = url;
    return element_src === $6697ff39d54b09bb$var$src_url_equal_anchor.href;
}
function $6697ff39d54b09bb$var$is_empty(obj) {
    return Object.keys(obj).length === 0;
}
function $6697ff39d54b09bb$var$subscribe(store, ...callbacks) {
    if (store == null) return $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5;
    const unsub = store.subscribe(...callbacks);
    return unsub.unsubscribe ? ()=>unsub.unsubscribe() : unsub;
}
function $6697ff39d54b09bb$export$db3b6bfb95261072(component, store, callback) {
    component.$$.on_destroy.push($6697ff39d54b09bb$var$subscribe(store, callback));
}
function $6697ff39d54b09bb$var$create_slot(definition, ctx, $$scope, fn) {
    if (definition) {
        const slot_ctx = $6697ff39d54b09bb$var$get_slot_context(definition, ctx, $$scope, fn);
        return definition[0](slot_ctx);
    }
}
function $6697ff39d54b09bb$var$get_slot_context(definition, ctx, $$scope, fn) {
    return definition[1] && fn ? $6697ff39d54b09bb$var$assign($$scope.ctx.slice(), definition[1](fn(ctx))) : $$scope.ctx;
}
function $6697ff39d54b09bb$var$get_slot_changes(definition, $$scope, dirty, fn) {
    if (definition[2] && fn) {
        const lets = definition[2](fn(dirty));
        if ($$scope.dirty === undefined) return lets;
        if (typeof lets === "object") {
            const merged = [];
            const len = Math.max($$scope.dirty.length, lets.length);
            for(let i = 0; i < len; i += 1)merged[i] = $$scope.dirty[i] | lets[i];
            return merged;
        }
        return $$scope.dirty | lets;
    }
    return $$scope.dirty;
}
function $6697ff39d54b09bb$var$update_slot_base(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn) {
    if (slot_changes) {
        const slot_context = $6697ff39d54b09bb$var$get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
        slot.p(slot_context, slot_changes);
    }
}
function $6697ff39d54b09bb$var$get_all_dirty_from_scope($$scope) {
    if ($$scope.ctx.length > 32) {
        const dirty = [];
        const length = $$scope.ctx.length / 32;
        for(let i = 0; i < length; i++)dirty[i] = -1;
        return dirty;
    }
    return -1;
}
function $6697ff39d54b09bb$export$882b5998b3b9117c(value) {
    return value == null ? "" : value;
}
function $6697ff39d54b09bb$var$split_css_unit(value) {
    const split = typeof value === "string" && value.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
    return split ? [
        parseFloat(split[1]),
        split[2] || "px"
    ] : [
        value,
        "px"
    ];
}
const $6697ff39d54b09bb$var$is_client = typeof window !== "undefined";
let $6697ff39d54b09bb$var$now = $6697ff39d54b09bb$var$is_client ? ()=>window.performance.now() : ()=>Date.now();
let $6697ff39d54b09bb$var$raf = $6697ff39d54b09bb$var$is_client ? (cb)=>requestAnimationFrame(cb) : $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5;
const $6697ff39d54b09bb$var$tasks = new Set();
function $6697ff39d54b09bb$var$run_tasks(now) {
    $6697ff39d54b09bb$var$tasks.forEach((task)=>{
        if (!task.c(now)) {
            $6697ff39d54b09bb$var$tasks.delete(task);
            task.f();
        }
    });
    if ($6697ff39d54b09bb$var$tasks.size !== 0) $6697ff39d54b09bb$var$raf($6697ff39d54b09bb$var$run_tasks);
}
/**
 * Creates a new task that runs on each raf frame
 * until it returns a falsy value or is aborted
 */ function $6697ff39d54b09bb$var$loop(callback) {
    let task;
    if ($6697ff39d54b09bb$var$tasks.size === 0) $6697ff39d54b09bb$var$raf($6697ff39d54b09bb$var$run_tasks);
    return {
        promise: new Promise((fulfill)=>{
            $6697ff39d54b09bb$var$tasks.add(task = {
                c: callback,
                f: fulfill
            });
        }),
        abort () {
            $6697ff39d54b09bb$var$tasks.delete(task);
        }
    };
}
function $6697ff39d54b09bb$export$953cecd6e717a553(target, node) {
    target.appendChild(node);
}
function $6697ff39d54b09bb$export$407448d2b89b1813(target, style_sheet_id, styles) {
    const append_styles_to = $6697ff39d54b09bb$var$get_root_for_style(target);
    if (!append_styles_to.getElementById(style_sheet_id)) {
        const style = $6697ff39d54b09bb$export$35e795649ee09318("style");
        style.id = style_sheet_id;
        style.textContent = styles;
        $6697ff39d54b09bb$var$append_stylesheet(append_styles_to, style);
    }
}
function $6697ff39d54b09bb$var$get_root_for_style(node) {
    if (!node) return document;
    const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
    if (root && root.host) return root;
    return node.ownerDocument;
}
function $6697ff39d54b09bb$var$append_empty_stylesheet(node) {
    const style_element = $6697ff39d54b09bb$export$35e795649ee09318("style");
    $6697ff39d54b09bb$var$append_stylesheet($6697ff39d54b09bb$var$get_root_for_style(node), style_element);
    return style_element.sheet;
}
function $6697ff39d54b09bb$var$append_stylesheet(node, style) {
    $6697ff39d54b09bb$export$953cecd6e717a553(node.head || node, style);
    return style.sheet;
}
function $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, node, anchor) {
    target.insertBefore(node, anchor || null);
}
function $6697ff39d54b09bb$export$4368d992c4eafac0(node) {
    if (node.parentNode) node.parentNode.removeChild(node);
}
function $6697ff39d54b09bb$export$ef35774e6d314e91(iterations, detaching) {
    for(let i = 0; i < iterations.length; i += 1)if (iterations[i]) iterations[i].d(detaching);
}
function $6697ff39d54b09bb$export$35e795649ee09318(name) {
    return document.createElement(name);
}
function $6697ff39d54b09bb$var$svg_element(name) {
    return document.createElementNS("http://www.w3.org/2000/svg", name);
}
function $6697ff39d54b09bb$export$625550452a3fa3ec(data) {
    return document.createTextNode(data);
}
function $6697ff39d54b09bb$export$2329c99376c9d0a4() {
    return $6697ff39d54b09bb$export$625550452a3fa3ec(" ");
}
function $6697ff39d54b09bb$export$f1e1789686576879() {
    return $6697ff39d54b09bb$export$625550452a3fa3ec("");
}
function $6697ff39d54b09bb$export$ffb5f4729a158638(node, event, handler, options) {
    node.addEventListener(event, handler, options);
    return ()=>node.removeEventListener(event, handler, options);
}
function $6697ff39d54b09bb$export$b4171a6734a65d42(fn) {
    return function(event) {
        event.stopPropagation();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function $6697ff39d54b09bb$export$342063e11d6c3cad(node, attribute, value) {
    if (value == null) node.removeAttribute(attribute);
    else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}
function $6697ff39d54b09bb$var$children(element) {
    return Array.from(element.childNodes);
}
function $6697ff39d54b09bb$export$90a7f3efeed30595(text, data) {
    data = "" + data;
    if (text.data === data) return;
    text.data = data;
}
function $6697ff39d54b09bb$export$971d5caa766a69d7(node, key, value, important) {
    if (value == null) node.style.removeProperty(key);
    else node.style.setProperty(key, value, important ? "important" : "");
}
function $6697ff39d54b09bb$export$ae1af26003f05816(select, value, mounting) {
    for(let i = 0; i < select.options.length; i += 1){
        const option = select.options[i];
        if (option.__value === value) {
            option.selected = true;
            return;
        }
    }
    if (!mounting || value !== undefined) select.selectedIndex = -1; // no option should be selected
}
function $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(element, name, toggle) {
    element.classList[toggle ? "add" : "remove"](name);
}
function $6697ff39d54b09bb$var$custom_event(type, detail, { bubbles: bubbles = false, cancelable: cancelable = false } = {}) {
    const e = document.createEvent("CustomEvent");
    e.initCustomEvent(type, bubbles, cancelable, detail);
    return e;
}
class $6697ff39d54b09bb$export$ce26c07117d59d6a {
    constructor(is_svg = false){
        this.is_svg = false;
        this.is_svg = is_svg;
        this.e = this.n = null;
    }
    c(html) {
        this.h(html);
    }
    m(html, target, anchor = null) {
        if (!this.e) {
            if (this.is_svg) this.e = $6697ff39d54b09bb$var$svg_element(target.nodeName);
            else this.e = $6697ff39d54b09bb$export$35e795649ee09318(target.nodeType === 11 ? "TEMPLATE" : target.nodeName);
            this.t = target.tagName !== "TEMPLATE" ? target : target.content;
            this.c(html);
        }
        this.i(anchor);
    }
    h(html) {
        this.e.innerHTML = html;
        this.n = Array.from(this.e.nodeName === "TEMPLATE" ? this.e.content.childNodes : this.e.childNodes);
    }
    i(anchor) {
        for(let i = 0; i < this.n.length; i += 1)$6697ff39d54b09bb$export$8b22cf2602fb60ce(this.t, this.n[i], anchor);
    }
    p(html) {
        this.d();
        this.h(html);
        this.i(this.a);
    }
    d() {
        this.n.forEach($6697ff39d54b09bb$export$4368d992c4eafac0);
    }
}
function $6697ff39d54b09bb$var$construct_svelte_component(component, props) {
    return new component(props);
}
// we need to store the information for multiple documents because a Svelte application could also contain iframes
// https://github.com/sveltejs/svelte/issues/3624
const $6697ff39d54b09bb$var$managed_styles = new Map();
let $6697ff39d54b09bb$var$active = 0;
// https://github.com/darkskyapp/string-hash/blob/master/index.js
function $6697ff39d54b09bb$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i--)hash = (hash << 5) - hash ^ str.charCodeAt(i);
    return hash >>> 0;
}
function $6697ff39d54b09bb$var$create_style_information(doc, node) {
    const info = {
        stylesheet: $6697ff39d54b09bb$var$append_empty_stylesheet(node),
        rules: {}
    };
    $6697ff39d54b09bb$var$managed_styles.set(doc, info);
    return info;
}
function $6697ff39d54b09bb$var$create_rule(node, a, b, duration, delay, ease, fn, uid = 0) {
    const step = 16.666 / duration;
    let keyframes = "{\n";
    for(let p = 0; p <= 1; p += step){
        const t = a + (b - a) * ease(p);
        keyframes += p * 100 + `%{${fn(t, 1 - t)}}\n`;
    }
    const rule = keyframes + `100% {${fn(b, 1 - b)}}\n}`;
    const name = `__svelte_${$6697ff39d54b09bb$var$hash(rule)}_${uid}`;
    const doc = $6697ff39d54b09bb$var$get_root_for_style(node);
    const { stylesheet: stylesheet, rules: rules } = $6697ff39d54b09bb$var$managed_styles.get(doc) || $6697ff39d54b09bb$var$create_style_information(doc, node);
    if (!rules[name]) {
        rules[name] = true;
        stylesheet.insertRule(`@keyframes ${name} ${rule}`, stylesheet.cssRules.length);
    }
    const animation = node.style.animation || "";
    node.style.animation = `${animation ? `${animation}, ` : ""}${name} ${duration}ms linear ${delay}ms 1 both`;
    $6697ff39d54b09bb$var$active += 1;
    return name;
}
function $6697ff39d54b09bb$var$delete_rule(node, name) {
    const previous = (node.style.animation || "").split(", ");
    const next = previous.filter(name ? (anim)=>anim.indexOf(name) < 0 // remove specific animation
     : (anim)=>anim.indexOf("__svelte") === -1 // remove all Svelte animations
    );
    const deleted = previous.length - next.length;
    if (deleted) {
        node.style.animation = next.join(", ");
        $6697ff39d54b09bb$var$active -= deleted;
        if (!$6697ff39d54b09bb$var$active) $6697ff39d54b09bb$var$clear_rules();
    }
}
function $6697ff39d54b09bb$var$clear_rules() {
    $6697ff39d54b09bb$var$raf(()=>{
        if ($6697ff39d54b09bb$var$active) return;
        $6697ff39d54b09bb$var$managed_styles.forEach((info)=>{
            const { ownerNode: ownerNode } = info.stylesheet;
            // there is no ownerNode if it runs on jsdom.
            if (ownerNode) $6697ff39d54b09bb$export$4368d992c4eafac0(ownerNode);
        });
        $6697ff39d54b09bb$var$managed_styles.clear();
    });
}
function $6697ff39d54b09bb$export$3d12bd131bb975d1(node, from, fn, params) {
    if (!from) return $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5;
    const to = node.getBoundingClientRect();
    if (from.left === to.left && from.right === to.right && from.top === to.top && from.bottom === to.bottom) return $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5;
    const { delay: delay = 0, duration: duration = 300, easing: easing = $6697ff39d54b09bb$var$identity, // @ts-ignore todo: should this be separated from destructuring? Or start/end added to public api and documentation?
    start: start_time = $6697ff39d54b09bb$var$now() + delay, end: // @ts-ignore todo:
    end = start_time + duration, tick: tick = $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5, css: css } = fn(node, {
        from: from,
        to: to
    }, params);
    let running = true;
    let started = false;
    let name;
    function start() {
        if (css) name = $6697ff39d54b09bb$var$create_rule(node, 0, 1, duration, delay, easing, css);
        if (!delay) started = true;
    }
    function stop() {
        if (css) $6697ff39d54b09bb$var$delete_rule(node, name);
        running = false;
    }
    $6697ff39d54b09bb$var$loop((now)=>{
        if (!started && now >= start_time) started = true;
        if (started && now >= end) {
            tick(1, 0);
            stop();
        }
        if (!running) return false;
        if (started) {
            const p = now - start_time;
            const t = 0 + 1 * easing(p / duration);
            tick(t, 1 - t);
        }
        return true;
    });
    start();
    tick(0, 1);
    return stop;
}
function $6697ff39d54b09bb$export$9fa96a7d116ea3ce(node) {
    const style = getComputedStyle(node);
    if (style.position !== "absolute" && style.position !== "fixed") {
        const { width: width, height: height } = style;
        const a = node.getBoundingClientRect();
        node.style.position = "absolute";
        node.style.width = width;
        node.style.height = height;
        $6697ff39d54b09bb$export$28f7fcd39efa255(node, a);
    }
}
function $6697ff39d54b09bb$export$28f7fcd39efa255(node, a) {
    const b = node.getBoundingClientRect();
    if (a.left !== b.left || a.top !== b.top) {
        const style = getComputedStyle(node);
        const transform = style.transform === "none" ? "" : style.transform;
        node.style.transform = `${transform} translate(${a.left - b.left}px, ${a.top - b.top}px)`;
    }
}
let $6697ff39d54b09bb$var$current_component;
function $6697ff39d54b09bb$var$set_current_component(component) {
    $6697ff39d54b09bb$var$current_component = component;
}
function $6697ff39d54b09bb$var$get_current_component() {
    if (!$6697ff39d54b09bb$var$current_component) throw new Error("Function called outside component initialization");
    return $6697ff39d54b09bb$var$current_component;
}
/**
 * Schedules a callback to run immediately before the component is updated after any state change.
 *
 * The first time the callback runs will be before the initial `onMount`
 *
 * https://svelte.dev/docs#run-time-svelte-beforeupdate
 */ function $6697ff39d54b09bb$var$beforeUpdate(fn) {
    $6697ff39d54b09bb$var$get_current_component().$$.before_update.push(fn);
}
/**
 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
 * it can be called from an external module).
 *
 * `onMount` does not run inside a [server-side component](/docs#run-time-server-side-component-api).
 *
 * https://svelte.dev/docs#run-time-svelte-onmount
 */ function $6697ff39d54b09bb$var$onMount(fn) {
    $6697ff39d54b09bb$var$get_current_component().$$.on_mount.push(fn);
}
/**
 * Schedules a callback to run immediately after the component has been updated.
 *
 * The first time the callback runs will be after the initial `onMount`
 */ function $6697ff39d54b09bb$var$afterUpdate(fn) {
    $6697ff39d54b09bb$var$get_current_component().$$.after_update.push(fn);
}
/**
 * Schedules a callback to run immediately before the component is unmounted.
 *
 * Out of `onMount`, `beforeUpdate`, `afterUpdate` and `onDestroy`, this is the
 * only one that runs inside a server-side component.
 *
 * https://svelte.dev/docs#run-time-svelte-ondestroy
 */ function $6697ff39d54b09bb$export$ab83b03e4111b1d0(fn) {
    $6697ff39d54b09bb$var$get_current_component().$$.on_destroy.push(fn);
}
// TODO figure out if we still want to support
// shorthand events, or if we want to implement
// a real bubbling mechanism
function $6697ff39d54b09bb$export$f38c853ae54ed474(component, event) {
    const callbacks = component.$$.callbacks[event.type];
    if (callbacks) // @ts-ignore
    callbacks.slice().forEach((fn)=>fn.call(this, event));
}
const $6697ff39d54b09bb$var$dirty_components = [];
const $6697ff39d54b09bb$export$39b482c5e57630a8 = [];
let $6697ff39d54b09bb$var$render_callbacks = [];
const $6697ff39d54b09bb$var$flush_callbacks = [];
const $6697ff39d54b09bb$var$resolved_promise = /* @__PURE__ */ Promise.resolve();
let $6697ff39d54b09bb$var$update_scheduled = false;
function $6697ff39d54b09bb$var$schedule_update() {
    if (!$6697ff39d54b09bb$var$update_scheduled) {
        $6697ff39d54b09bb$var$update_scheduled = true;
        $6697ff39d54b09bb$var$resolved_promise.then($6697ff39d54b09bb$var$flush);
    }
}
function $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(fn) {
    $6697ff39d54b09bb$var$render_callbacks.push(fn);
}
function $6697ff39d54b09bb$export$4c3d22f3d993c33f(fn) {
    $6697ff39d54b09bb$var$flush_callbacks.push(fn);
}
// flush() calls callbacks in this order:
// 1. All beforeUpdate callbacks, in order: parents before children
// 2. All bind:this callbacks, in reverse order: children before parents.
// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
//    for afterUpdates called during the initial onMount, which are called in
//    reverse order: children before parents.
// Since callbacks might update component values, which could trigger another
// call to flush(), the following steps guard against this:
// 1. During beforeUpdate, any updated components will be added to the
//    dirty_components array and will cause a reentrant call to flush(). Because
//    the flush index is kept outside the function, the reentrant call will pick
//    up where the earlier call left off and go through all dirty components. The
//    current_component value is saved and restored so that the reentrant call will
//    not interfere with the "parent" flush() call.
// 2. bind:this callbacks cannot trigger new flush() calls.
// 3. During afterUpdate, any updated components will NOT have their afterUpdate
//    callback called a second time; the seen_callbacks set, outside the flush()
//    function, guarantees this behavior.
const $6697ff39d54b09bb$var$seen_callbacks = new Set();
let $6697ff39d54b09bb$var$flushidx = 0; // Do *not* move this inside the flush() function
function $6697ff39d54b09bb$var$flush() {
    // Do not reenter flush while dirty components are updated, as this can
    // result in an infinite loop. Instead, let the inner flush handle it.
    // Reentrancy is ok afterwards for bindings etc.
    if ($6697ff39d54b09bb$var$flushidx !== 0) return;
    const saved_component = $6697ff39d54b09bb$var$current_component;
    do {
        // first, call beforeUpdate functions
        // and update components
        try {
            while($6697ff39d54b09bb$var$flushidx < $6697ff39d54b09bb$var$dirty_components.length){
                const component = $6697ff39d54b09bb$var$dirty_components[$6697ff39d54b09bb$var$flushidx];
                $6697ff39d54b09bb$var$flushidx++;
                $6697ff39d54b09bb$var$set_current_component(component);
                $6697ff39d54b09bb$var$update(component.$$);
            }
        } catch (e) {
            // reset dirty state to not end up in a deadlocked state and then rethrow
            $6697ff39d54b09bb$var$dirty_components.length = 0;
            $6697ff39d54b09bb$var$flushidx = 0;
            throw e;
        }
        $6697ff39d54b09bb$var$set_current_component(null);
        $6697ff39d54b09bb$var$dirty_components.length = 0;
        $6697ff39d54b09bb$var$flushidx = 0;
        while($6697ff39d54b09bb$export$39b482c5e57630a8.length)$6697ff39d54b09bb$export$39b482c5e57630a8.pop()();
        // then, once components are updated, call
        // afterUpdate functions. This may cause
        // subsequent updates...
        for(let i = 0; i < $6697ff39d54b09bb$var$render_callbacks.length; i += 1){
            const callback = $6697ff39d54b09bb$var$render_callbacks[i];
            if (!$6697ff39d54b09bb$var$seen_callbacks.has(callback)) {
                // ...so guard against infinite loops
                $6697ff39d54b09bb$var$seen_callbacks.add(callback);
                callback();
            }
        }
        $6697ff39d54b09bb$var$render_callbacks.length = 0;
    }while ($6697ff39d54b09bb$var$dirty_components.length);
    while($6697ff39d54b09bb$var$flush_callbacks.length)$6697ff39d54b09bb$var$flush_callbacks.pop()();
    $6697ff39d54b09bb$var$update_scheduled = false;
    $6697ff39d54b09bb$var$seen_callbacks.clear();
    $6697ff39d54b09bb$var$set_current_component(saved_component);
}
function $6697ff39d54b09bb$var$update($$) {
    if ($$.fragment !== null) {
        $$.update();
        $6697ff39d54b09bb$export$61196ced6d74a310($$.before_update);
        const dirty = $$.dirty;
        $$.dirty = [
            -1
        ];
        $$.fragment && $$.fragment.p($$.ctx, dirty);
        $$.after_update.forEach($6697ff39d54b09bb$export$3a6d5c9ae78a2c08);
    }
}
/**
 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
 */ function $6697ff39d54b09bb$var$flush_render_callbacks(fns) {
    const filtered = [];
    const targets = [];
    $6697ff39d54b09bb$var$render_callbacks.forEach((c)=>fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
    targets.forEach((c)=>c());
    $6697ff39d54b09bb$var$render_callbacks = filtered;
}
let $6697ff39d54b09bb$var$promise;
function $6697ff39d54b09bb$var$wait() {
    if (!$6697ff39d54b09bb$var$promise) {
        $6697ff39d54b09bb$var$promise = Promise.resolve();
        $6697ff39d54b09bb$var$promise.then(()=>{
            $6697ff39d54b09bb$var$promise = null;
        });
    }
    return $6697ff39d54b09bb$var$promise;
}
function $6697ff39d54b09bb$var$dispatch(node, direction, kind) {
    node.dispatchEvent($6697ff39d54b09bb$var$custom_event(`${direction ? "intro" : "outro"}${kind}`));
}
const $6697ff39d54b09bb$var$outroing = new Set();
let $6697ff39d54b09bb$var$outros;
function $6697ff39d54b09bb$export$4a5767248b18ef41() {
    $6697ff39d54b09bb$var$outros = {
        r: 0,
        c: [],
        p: $6697ff39d54b09bb$var$outros // parent group
    };
}
function $6697ff39d54b09bb$export$df995fae86a55f06() {
    if (!$6697ff39d54b09bb$var$outros.r) $6697ff39d54b09bb$export$61196ced6d74a310($6697ff39d54b09bb$var$outros.c);
    $6697ff39d54b09bb$var$outros = $6697ff39d54b09bb$var$outros.p;
}
function $6697ff39d54b09bb$export$d141bba7fdc215a3(block, local) {
    if (block && block.i) {
        $6697ff39d54b09bb$var$outroing.delete(block);
        block.i(local);
    }
}
function $6697ff39d54b09bb$export$ebd11618f299a286(block, local, detach, callback) {
    if (block && block.o) {
        if ($6697ff39d54b09bb$var$outroing.has(block)) return;
        $6697ff39d54b09bb$var$outroing.add(block);
        $6697ff39d54b09bb$var$outros.c.push(()=>{
            $6697ff39d54b09bb$var$outroing.delete(block);
            if (callback) {
                if (detach) block.d(1);
                callback();
            }
        });
        block.o(local);
    } else if (callback) callback();
}
const $6697ff39d54b09bb$var$null_transition = {
    duration: 0
};
function $6697ff39d54b09bb$export$e7c866399fa523f5(node, fn, params) {
    const options = {
        direction: "in"
    };
    let config = fn(node, params, options);
    let running = false;
    let animation_name;
    let task;
    let uid = 0;
    function cleanup() {
        if (animation_name) $6697ff39d54b09bb$var$delete_rule(node, animation_name);
    }
    function go() {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $6697ff39d54b09bb$var$identity, tick: tick = $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5, css: css } = config || $6697ff39d54b09bb$var$null_transition;
        if (css) animation_name = $6697ff39d54b09bb$var$create_rule(node, 0, 1, duration, delay, easing, css, uid++);
        tick(0, 1);
        const start_time = $6697ff39d54b09bb$var$now() + delay;
        const end_time = start_time + duration;
        if (task) task.abort();
        running = true;
        $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(()=>$6697ff39d54b09bb$var$dispatch(node, true, "start"));
        task = $6697ff39d54b09bb$var$loop((now)=>{
            if (running) {
                if (now >= end_time) {
                    tick(1, 0);
                    $6697ff39d54b09bb$var$dispatch(node, true, "end");
                    cleanup();
                    return running = false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(t, 1 - t);
                }
            }
            return running;
        });
    }
    let started = false;
    return {
        start () {
            if (started) return;
            started = true;
            $6697ff39d54b09bb$var$delete_rule(node);
            if ($6697ff39d54b09bb$export$dc98b0b04f4c7758(config)) {
                config = config(options);
                $6697ff39d54b09bb$var$wait().then(go);
            } else go();
        },
        invalidate () {
            started = false;
        },
        end () {
            if (running) {
                cleanup();
                running = false;
            }
        }
    };
}
function $6697ff39d54b09bb$export$21579262ef46735b(node, fn, params) {
    const options = {
        direction: "out"
    };
    let config = fn(node, params, options);
    let running = true;
    let animation_name;
    const group = $6697ff39d54b09bb$var$outros;
    group.r += 1;
    function go() {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $6697ff39d54b09bb$var$identity, tick: tick = $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5, css: css } = config || $6697ff39d54b09bb$var$null_transition;
        if (css) animation_name = $6697ff39d54b09bb$var$create_rule(node, 1, 0, duration, delay, easing, css);
        const start_time = $6697ff39d54b09bb$var$now() + delay;
        const end_time = start_time + duration;
        $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(()=>$6697ff39d54b09bb$var$dispatch(node, false, "start"));
        $6697ff39d54b09bb$var$loop((now)=>{
            if (running) {
                if (now >= end_time) {
                    tick(0, 1);
                    $6697ff39d54b09bb$var$dispatch(node, false, "end");
                    if (!--group.r) // this will result in `end()` being called,
                    // so we don't need to clean up here
                    $6697ff39d54b09bb$export$61196ced6d74a310(group.c);
                    return false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(1 - t, t);
                }
            }
            return running;
        });
    }
    if ($6697ff39d54b09bb$export$dc98b0b04f4c7758(config)) $6697ff39d54b09bb$var$wait().then(()=>{
        // @ts-ignore
        config = config(options);
        go();
    });
    else go();
    return {
        end (reset) {
            if (reset && config.tick) config.tick(1, 0);
            if (running) {
                if (animation_name) $6697ff39d54b09bb$var$delete_rule(node, animation_name);
                running = false;
            }
        }
    };
}
function $6697ff39d54b09bb$export$a9c996f45e5784d0(node, fn, params, intro) {
    const options = {
        direction: "both"
    };
    let config = fn(node, params, options);
    let t = intro ? 0 : 1;
    let running_program = null;
    let pending_program = null;
    let animation_name = null;
    function clear_animation() {
        if (animation_name) $6697ff39d54b09bb$var$delete_rule(node, animation_name);
    }
    function init(program, duration) {
        const d = program.b - t;
        duration *= Math.abs(d);
        return {
            a: t,
            b: program.b,
            d: d,
            duration: duration,
            start: program.start,
            end: program.start + duration,
            group: program.group
        };
    }
    function go(b) {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $6697ff39d54b09bb$var$identity, tick: tick = $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5, css: css } = config || $6697ff39d54b09bb$var$null_transition;
        const program = {
            start: $6697ff39d54b09bb$var$now() + delay,
            b: b
        };
        if (!b) {
            // @ts-ignore todo: improve typings
            program.group = $6697ff39d54b09bb$var$outros;
            $6697ff39d54b09bb$var$outros.r += 1;
        }
        if (running_program || pending_program) pending_program = program;
        else {
            // if this is an intro, and there's a delay, we need to do
            // an initial tick and/or apply CSS animation immediately
            if (css) {
                clear_animation();
                animation_name = $6697ff39d54b09bb$var$create_rule(node, t, b, duration, delay, easing, css);
            }
            if (b) tick(0, 1);
            running_program = init(program, duration);
            $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(()=>$6697ff39d54b09bb$var$dispatch(node, b, "start"));
            $6697ff39d54b09bb$var$loop((now)=>{
                if (pending_program && now > pending_program.start) {
                    running_program = init(pending_program, duration);
                    pending_program = null;
                    $6697ff39d54b09bb$var$dispatch(node, running_program.b, "start");
                    if (css) {
                        clear_animation();
                        animation_name = $6697ff39d54b09bb$var$create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
                    }
                }
                if (running_program) {
                    if (now >= running_program.end) {
                        tick(t = running_program.b, 1 - t);
                        $6697ff39d54b09bb$var$dispatch(node, running_program.b, "end");
                        if (!pending_program) {
                            // we're done
                            if (running_program.b) // intro — we can tidy up immediately
                            clear_animation();
                            else // outro — needs to be coordinated
                            if (!--running_program.group.r) $6697ff39d54b09bb$export$61196ced6d74a310(running_program.group.c);
                        }
                        running_program = null;
                    } else if (now >= running_program.start) {
                        const p = now - running_program.start;
                        t = running_program.a + running_program.d * easing(p / running_program.duration);
                        tick(t, 1 - t);
                    }
                }
                return !!(running_program || pending_program);
            });
        }
    }
    return {
        run (b) {
            if ($6697ff39d54b09bb$export$dc98b0b04f4c7758(config)) $6697ff39d54b09bb$var$wait().then(()=>{
                // @ts-ignore
                config = config(options);
                go(b);
            });
            else go(b);
        },
        end () {
            clear_animation();
            running_program = pending_program = null;
        }
    };
}
function $6697ff39d54b09bb$export$71511d61b312f219(promise, info) {
    const token = info.token = {};
    function update(type, index, key, value) {
        if (info.token !== token) return;
        info.resolved = value;
        let child_ctx = info.ctx;
        if (key !== undefined) {
            child_ctx = child_ctx.slice();
            child_ctx[key] = value;
        }
        const block = type && (info.current = type)(child_ctx);
        let needs_flush = false;
        if (info.block) {
            if (info.blocks) info.blocks.forEach((block, i)=>{
                if (i !== index && block) {
                    $6697ff39d54b09bb$export$4a5767248b18ef41();
                    $6697ff39d54b09bb$export$ebd11618f299a286(block, 1, 1, ()=>{
                        if (info.blocks[i] === block) info.blocks[i] = null;
                    });
                    $6697ff39d54b09bb$export$df995fae86a55f06();
                }
            });
            else info.block.d(1);
            block.c();
            $6697ff39d54b09bb$export$d141bba7fdc215a3(block, 1);
            block.m(info.mount(), info.anchor);
            needs_flush = true;
        }
        info.block = block;
        if (info.blocks) info.blocks[index] = block;
        if (needs_flush) $6697ff39d54b09bb$var$flush();
    }
    if ($6697ff39d54b09bb$var$is_promise(promise)) {
        const current_component = $6697ff39d54b09bb$var$get_current_component();
        promise.then((value)=>{
            $6697ff39d54b09bb$var$set_current_component(current_component);
            update(info.then, 1, info.value, value);
            $6697ff39d54b09bb$var$set_current_component(null);
        }, (error)=>{
            $6697ff39d54b09bb$var$set_current_component(current_component);
            update(info.catch, 2, info.error, error);
            $6697ff39d54b09bb$var$set_current_component(null);
            if (!info.hasCatch) throw error;
        });
        // if we previously had a then/catch block, destroy it
        if (info.current !== info.pending) {
            update(info.pending, 0);
            return true;
        }
    } else {
        if (info.current !== info.then) {
            update(info.then, 1, info.value, promise);
            return true;
        }
        info.resolved = promise;
    }
}
function $6697ff39d54b09bb$export$3d8c2f653ac9d0b9(info, ctx, dirty) {
    const child_ctx = ctx.slice();
    const { resolved: resolved } = info;
    if (info.current === info.then) child_ctx[info.value] = resolved;
    if (info.current === info.catch) child_ctx[info.error] = resolved;
    info.block.p(child_ctx, dirty);
}
function $6697ff39d54b09bb$export$9e5f44173e64f162(block, lookup) {
    block.d(1);
    lookup.delete(block.key);
}
function $6697ff39d54b09bb$export$c3950d9923825c02(block, lookup) {
    $6697ff39d54b09bb$export$ebd11618f299a286(block, 1, 1, ()=>{
        lookup.delete(block.key);
    });
}
function $6697ff39d54b09bb$export$91c6e00c14e7e6fd(block, lookup) {
    block.f();
    $6697ff39d54b09bb$export$c3950d9923825c02(block, lookup);
}
function $6697ff39d54b09bb$export$3b14a55fb2447963(old_blocks, dirty, get_key, dynamic, ctx, list, lookup, node, destroy, create_each_block, next, get_context) {
    let o = old_blocks.length;
    let n = list.length;
    let i = o;
    const old_indexes = {};
    while(i--)old_indexes[old_blocks[i].key] = i;
    const new_blocks = [];
    const new_lookup = new Map();
    const deltas = new Map();
    const updates = [];
    i = n;
    while(i--){
        const child_ctx = get_context(ctx, list, i);
        const key = get_key(child_ctx);
        let block = lookup.get(key);
        if (!block) {
            block = create_each_block(key, child_ctx);
            block.c();
        } else if (dynamic) // defer updates until all the DOM shuffling is done
        updates.push(()=>block.p(child_ctx, dirty));
        new_lookup.set(key, new_blocks[i] = block);
        if (key in old_indexes) deltas.set(key, Math.abs(i - old_indexes[key]));
    }
    const will_move = new Set();
    const did_move = new Set();
    function insert(block) {
        $6697ff39d54b09bb$export$d141bba7fdc215a3(block, 1);
        block.m(node, next);
        lookup.set(block.key, block);
        next = block.first;
        n--;
    }
    while(o && n){
        const new_block = new_blocks[n - 1];
        const old_block = old_blocks[o - 1];
        const new_key = new_block.key;
        const old_key = old_block.key;
        if (new_block === old_block) {
            // do nothing
            next = new_block.first;
            o--;
            n--;
        } else if (!new_lookup.has(old_key)) {
            // remove old block
            destroy(old_block, lookup);
            o--;
        } else if (!lookup.has(new_key) || will_move.has(new_key)) insert(new_block);
        else if (did_move.has(old_key)) o--;
        else if (deltas.get(new_key) > deltas.get(old_key)) {
            did_move.add(new_key);
            insert(new_block);
        } else {
            will_move.add(old_key);
            o--;
        }
    }
    while(o--){
        const old_block = old_blocks[o];
        if (!new_lookup.has(old_block.key)) destroy(old_block, lookup);
    }
    while(n)insert(new_blocks[n - 1]);
    $6697ff39d54b09bb$export$61196ced6d74a310(updates);
    return new_blocks;
}
function $6697ff39d54b09bb$export$2219238a014317b0(component, name, callback) {
    const index = component.$$.props[name];
    if (index !== undefined) {
        component.$$.bound[index] = callback;
        callback(component.$$.ctx[index]);
    }
}
function $6697ff39d54b09bb$export$d66501df72047452(block) {
    block && block.c();
}
function $6697ff39d54b09bb$export$9bb611d729802a56(component, target, anchor, customElement) {
    const { fragment: fragment, after_update: after_update } = component.$$;
    fragment && fragment.m(target, anchor);
    if (!customElement) // onMount happens before the initial afterUpdate
    $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(()=>{
        const new_on_destroy = component.$$.on_mount.map($6697ff39d54b09bb$var$run).filter($6697ff39d54b09bb$export$dc98b0b04f4c7758);
        // if the component was destroyed immediately
        // it will update the `$$.on_destroy` reference to `null`.
        // the destructured on_destroy may still reference to the old array
        if (component.$$.on_destroy) component.$$.on_destroy.push(...new_on_destroy);
        else // Edge case - component was destroyed immediately,
        // most likely as a result of a binding initialising
        $6697ff39d54b09bb$export$61196ced6d74a310(new_on_destroy);
        component.$$.on_mount = [];
    });
    after_update.forEach($6697ff39d54b09bb$export$3a6d5c9ae78a2c08);
}
function $6697ff39d54b09bb$export$3466f893ebf79586(component, detaching) {
    const $$ = component.$$;
    if ($$.fragment !== null) {
        $6697ff39d54b09bb$var$flush_render_callbacks($$.after_update);
        $6697ff39d54b09bb$export$61196ced6d74a310($$.on_destroy);
        $$.fragment && $$.fragment.d(detaching);
        // TODO null out other refs, including component.$$ (but need to
        // preserve final state?)
        $$.on_destroy = $$.fragment = null;
        $$.ctx = [];
    }
}
function $6697ff39d54b09bb$var$make_dirty(component, i) {
    if (component.$$.dirty[0] === -1) {
        $6697ff39d54b09bb$var$dirty_components.push(component);
        $6697ff39d54b09bb$var$schedule_update();
        component.$$.dirty.fill(0);
    }
    component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}
function $6697ff39d54b09bb$export$23f2a1d2818174ef(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [
    -1
]) {
    const parent_component = $6697ff39d54b09bb$var$current_component;
    $6697ff39d54b09bb$var$set_current_component(component);
    const $$ = component.$$ = {
        fragment: null,
        ctx: [],
        props: // state
        props,
        update: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        not_equal: not_equal,
        bound: $6697ff39d54b09bb$var$blank_object(),
        // lifecycle
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
        // everything else
        callbacks: $6697ff39d54b09bb$var$blank_object(),
        dirty: dirty,
        skip_bound: false,
        root: options.target || parent_component.$$.root
    };
    append_styles && append_styles($$.root);
    let ready = false;
    $$.ctx = instance ? instance(component, options.props || {}, (i, ret, ...rest)=>{
        const value = rest.length ? rest[0] : ret;
        if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
            if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
            if (ready) $6697ff39d54b09bb$var$make_dirty(component, i);
        }
        return ret;
    }) : [];
    $$.update();
    ready = true;
    $6697ff39d54b09bb$export$61196ced6d74a310($$.before_update);
    // `false` as a special case of no DOM component
    $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
    if (options.target) {
        if (options.hydrate) {
            const nodes = $6697ff39d54b09bb$var$children(options.target);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $$.fragment && $$.fragment.l(nodes);
            nodes.forEach($6697ff39d54b09bb$export$4368d992c4eafac0);
        } else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $$.fragment && $$.fragment.c();
        if (options.intro) $6697ff39d54b09bb$export$d141bba7fdc215a3(component.$$.fragment);
        $6697ff39d54b09bb$export$9bb611d729802a56(component, options.target, options.anchor, options.customElement);
        $6697ff39d54b09bb$var$flush();
    }
    $6697ff39d54b09bb$var$set_current_component(parent_component);
}
/**
 * Base class for Svelte components. Used when dev=false.
 */ class $6697ff39d54b09bb$export$25ce5a424b770e84 {
    $destroy() {
        $6697ff39d54b09bb$export$3466f893ebf79586(this, 1);
        this.$destroy = $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5;
    }
    $on(type, callback) {
        if (!$6697ff39d54b09bb$export$dc98b0b04f4c7758(callback)) return $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5;
        const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return ()=>{
            const index = callbacks.indexOf(callback);
            if (index !== -1) callbacks.splice(index, 1);
        };
    }
    $set($$props) {
        if (this.$$set && !$6697ff39d54b09bb$var$is_empty($$props)) {
            this.$$.skip_bound = true;
            this.$$set($$props);
            this.$$.skip_bound = false;
        }
    }
}
const $6697ff39d54b09bb$var$reset$ = new (0, $3TBY8.Subject)();
const $6697ff39d54b09bb$var$disconnectWallet$ = new (0, $3TBY8.Subject)();
const $6697ff39d54b09bb$export$a07804094c3ecf2d = new (0, $axHCK.BehaviorSubject)({
    inProgress: false,
    actionRequired: ""
});
const $6697ff39d54b09bb$var$switchChainModal$ = new (0, $axHCK.BehaviorSubject)(null);
const $6697ff39d54b09bb$export$efccba1c4a2ef57b = $6697ff39d54b09bb$export$6559d589eb85fbb6.select("wallets").pipe((0, $hDTQV.shareReplay)(1));
// reset logic
$6697ff39d54b09bb$var$reset$.pipe((0, $eUlHv.withLatestFrom)($6697ff39d54b09bb$export$efccba1c4a2ef57b), (0, $6vUKV.pluck)("1")).subscribe((wallets)=>{
    // disconnect all wallets
    wallets.forEach(({ label: label })=>{
        $6697ff39d54b09bb$var$disconnectWallet$.next(label);
    });
    $6697ff39d54b09bb$var$resetStore();
});
// keep transactions for all notifications for replacement actions
const $6697ff39d54b09bb$export$493d36ec626b6698 = new (0, $axHCK.BehaviorSubject)([]);
function $6697ff39d54b09bb$var$updateTransaction(tx) {
    const currentTransactions = $6697ff39d54b09bb$export$493d36ec626b6698.getValue();
    const txIndex = currentTransactions.findIndex(({ hash: hash })=>hash === tx.hash);
    if (txIndex !== -1) {
        const updatedTransactions = currentTransactions.map((val, i)=>i === txIndex ? tx : val);
        $6697ff39d54b09bb$export$493d36ec626b6698.next(updatedTransactions);
    } else $6697ff39d54b09bb$export$493d36ec626b6698.next([
        ...currentTransactions,
        tx
    ]);
}
function $6697ff39d54b09bb$export$d66dc83d8cfc8dd(hash) {
    const currentTransactions = $6697ff39d54b09bb$export$493d36ec626b6698.getValue();
    $6697ff39d54b09bb$export$493d36ec626b6698.next(currentTransactions.filter((tx)=>tx.hash !== hash));
}
(0, $bfHa8.defer)(()=>{
    const subject = new (0, $3TBY8.Subject)();
    $6697ff39d54b09bb$var$onMount(()=>{
        subject.next();
    });
    return subject.asObservable().pipe((0, $jGgch.take)(1));
});
const $6697ff39d54b09bb$var$onDestroy$ = (0, $bfHa8.defer)(()=>{
    const subject = new (0, $3TBY8.Subject)();
    $6697ff39d54b09bb$export$ab83b03e4111b1d0(()=>{
        subject.next();
    });
    return subject.asObservable().pipe((0, $jGgch.take)(1));
});
(0, $bfHa8.defer)(()=>{
    const subject = new (0, $3TBY8.Subject)();
    $6697ff39d54b09bb$var$afterUpdate(()=>{
        subject.next();
    });
    return subject.asObservable().pipe((0, $jXWpp.takeUntil)($6697ff39d54b09bb$var$onDestroy$));
});
(0, $bfHa8.defer)(()=>{
    const subject = new (0, $3TBY8.Subject)();
    $6697ff39d54b09bb$var$beforeUpdate(()=>{
        subject.next();
    });
    return subject.asObservable().pipe((0, $jXWpp.takeUntil)($6697ff39d54b09bb$var$onDestroy$));
});
const $6697ff39d54b09bb$var$themes = {
    default: {
        "--w3o-background-color": "unset",
        "--w3o-foreground-color": "unset",
        "--w3o-text-color": "unset",
        "--w3o-border-color": "unset",
        "--w3o-action-color": "unset",
        "--w3o-border-radius": "unset",
        "--w3o-font-family": "inherit"
    },
    light: {
        "--w3o-background-color": "#ffffff",
        "--w3o-foreground-color": "#EFF1FC",
        "--w3o-text-color": "#1a1d26",
        "--w3o-border-color": "#d0d4f7",
        "--w3o-action-color": "#6370E5",
        "--w3o-border-radius": "16px",
        "--w3o-font-family": "inherit"
    },
    dark: {
        "--w3o-background-color": "#1A1D26",
        "--w3o-foreground-color": "#242835",
        "--w3o-text-color": "#EFF1FC",
        "--w3o-border-color": "#33394B",
        "--w3o-action-color": "#929bed",
        "--w3o-border-radius": "16px",
        "--w3o-font-family": "inherit"
    }
};
const $6697ff39d54b09bb$var$returnTheme = (theme)=>{
    if (typeof theme === "string" && theme === "system") return $6697ff39d54b09bb$var$watchForSystemThemeChange();
    return $6697ff39d54b09bb$var$returnThemeMap(theme);
};
const $6697ff39d54b09bb$var$returnThemeMap = (theme)=>{
    if (typeof theme === "string" && theme in $6697ff39d54b09bb$var$themes) return $6697ff39d54b09bb$var$themes[theme];
    if (typeof theme === "object") return theme;
};
const $6697ff39d54b09bb$var$handleThemeChange = (update)=>{
    Object.keys(update).forEach((targetStyle)=>{
        document.documentElement.style.setProperty(targetStyle, update[targetStyle]);
    });
};
const $6697ff39d54b09bb$var$watchForSystemThemeChange = ()=>{
    const systemThemeDark = window.matchMedia("(prefers-color-scheme: dark)");
    systemThemeDark.matches ? $6697ff39d54b09bb$var$handleThemeChange($6697ff39d54b09bb$var$themes["dark"]) : $6697ff39d54b09bb$var$handleThemeChange($6697ff39d54b09bb$var$themes["light"]);
    (0, $l9kJq.fromEvent)(systemThemeDark, "change").pipe((0, $jXWpp.takeUntil)($6697ff39d54b09bb$var$reset$)).subscribe((changes)=>{
        const themeChange = changes;
        themeChange.matches ? $6697ff39d54b09bb$var$handleThemeChange($6697ff39d54b09bb$var$themes["dark"]) : $6697ff39d54b09bb$var$handleThemeChange($6697ff39d54b09bb$var$themes["light"]);
    });
};
const $6697ff39d54b09bb$var$unknownObject = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object().unknown();
const $6697ff39d54b09bb$var$connectedChain = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    namespace: (0, $fsqu3.chainNamespaceValidation).required(),
    id: (0, $fsqu3.chainIdValidation).required()
});
const $6697ff39d54b09bb$var$ens = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    avatar: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    contentHash: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(), null),
    getText: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function().arity(1).required()
}), null);
const $6697ff39d54b09bb$var$uns = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required()
}), null);
const $6697ff39d54b09bb$var$balance = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    eth: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number()
}).unknown(), null);
const $6697ff39d54b09bb$var$secondaryTokens = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    balance: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string()
}), null);
const $6697ff39d54b09bb$var$account = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    address: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    ens: $6697ff39d54b09bb$var$ens,
    uns: $6697ff39d54b09bb$var$uns,
    balance: $6697ff39d54b09bb$var$balance,
    secondaryTokens: $6697ff39d54b09bb$var$secondaryTokens
});
const $6697ff39d54b09bb$var$chains = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).array().items((0, $fsqu3.chainValidation)).unique((a, b)=>a.id === b.id).error((e)=>{
    if (e[0].code === "array.unique") return new Error(`There is a duplicate Chain ID in your Onboard Chains array: ${e}`);
    return new Error(`${e}`);
});
const $6697ff39d54b09bb$var$accounts = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).array().items($6697ff39d54b09bb$var$account);
const $6697ff39d54b09bb$var$wallet = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    label: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    provider: $6697ff39d54b09bb$var$unknownObject,
    instance: $6697ff39d54b09bb$var$unknownObject,
    accounts: $6697ff39d54b09bb$var$accounts,
    chains: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).array().items($6697ff39d54b09bb$var$connectedChain)
}).required().error(new Error("wallet must be defined"));
const $6697ff39d54b09bb$var$wallets = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).array().items($6697ff39d54b09bb$var$wallet);
const $6697ff39d54b09bb$var$recommendedWallet = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    url: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().uri().required()
});
const $6697ff39d54b09bb$var$agreement = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    version: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    termsUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().uri(),
    privacyUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().uri()
});
const $6697ff39d54b09bb$var$appMetadata = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    logo: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    gettingStartedGuide: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    email: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    appUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    explore: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    recommendedInjectedWallets: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).array().items($6697ff39d54b09bb$var$recommendedWallet),
    agreement: $6697ff39d54b09bb$var$agreement
});
const $6697ff39d54b09bb$var$appMetadataUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    logo: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    gettingStartedGuide: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    email: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    appUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    explore: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    recommendedInjectedWallets: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).array().items($6697ff39d54b09bb$var$recommendedWallet),
    agreement: $6697ff39d54b09bb$var$agreement
});
(0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    label: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    getInfo: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function().arity(1).required(),
    getInterface: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function().arity(1).required()
});
const $6697ff39d54b09bb$var$walletInit = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function()).required();
const $6697ff39d54b09bb$var$locale = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string();
const $6697ff39d54b09bb$var$commonPositions = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().valid("topRight", "bottomRight", "bottomLeft", "topLeft");
const $6697ff39d54b09bb$var$gasPriceProbabilities = [
    70,
    80,
    90,
    95,
    99
];
const $6697ff39d54b09bb$var$notify$1 = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    transactionHandler: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function(),
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    position: $6697ff39d54b09bb$var$commonPositions,
    replacement: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
        gasPriceProbability: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
            speedup: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number().valid(...$6697ff39d54b09bb$var$gasPriceProbabilities),
            cancel: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number().valid(...$6697ff39d54b09bb$var$gasPriceProbabilities)
        })
    })
});
const $6697ff39d54b09bb$var$notifyOptions = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    desktop: $6697ff39d54b09bb$var$notify$1,
    mobile: $6697ff39d54b09bb$var$notify$1
});
const $6697ff39d54b09bb$var$accountCenterInitOptions = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    position: $6697ff39d54b09bb$var$commonPositions,
    minimal: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    containerElement: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    hideTransactionProtectionBtn: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    transactionProtectionInfoLink: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string()
});
const $6697ff39d54b09bb$var$accountCenter$1 = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    position: $6697ff39d54b09bb$var$commonPositions,
    expanded: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    minimal: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    hideTransactionProtectionBtn: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    transactionProtectionInfoLink: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    containerElement: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string()
});
const $6697ff39d54b09bb$var$connectModalOptions = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    showSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    disableClose: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    autoConnectLastWallet: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    autoConnectAllPreviousWallet: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    iDontHaveAWalletLink: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    wheresMyWalletLink: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    removeWhereIsMyWalletWarning: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    removeIDontHaveAWalletInfoLink: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    disableUDResolution: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean()
});
const $6697ff39d54b09bb$var$containerElements = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    accountCenter: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    connectModal: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string()
});
const $6697ff39d54b09bb$var$themeMap = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    "--w3o-background-color": (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    "--w3o-font-family": (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    "--w3o-foreground-color": (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    "--w3o-text-color": (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    "--w3o-border-color": (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    "--w3o-action-color": (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    "--w3o-border-radius": (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string()
});
const $6697ff39d54b09bb$var$presetTheme = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().valid("default", "dark", "light", "system");
const $6697ff39d54b09bb$var$theme = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).alternatives().try($6697ff39d54b09bb$var$themeMap, $6697ff39d54b09bb$var$presetTheme);
const $6697ff39d54b09bb$var$initOptions = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    wallets: $6697ff39d54b09bb$var$walletInit,
    chains: $6697ff39d54b09bb$var$chains.required(),
    appMetadata: $6697ff39d54b09bb$var$appMetadata,
    i18n: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object().unknown(),
    apiKey: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    accountCenter: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
        desktop: $6697ff39d54b09bb$var$accountCenterInitOptions,
        mobile: $6697ff39d54b09bb$var$accountCenterInitOptions,
        hideTransactionProtectionBtn: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
        transactionProtectionInfoLink: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string()
    }),
    notify: [
        $6697ff39d54b09bb$var$notifyOptions,
        $6697ff39d54b09bb$var$notify$1
    ],
    gas: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
        get: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function().required(),
        stream: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function().required()
    }),
    connect: $6697ff39d54b09bb$var$connectModalOptions,
    containerElements: $6697ff39d54b09bb$var$containerElements,
    transactionPreview: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
        patchProvider: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function().required(),
        init: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function().required(),
        previewTransaction: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function()
    }),
    theme: $6697ff39d54b09bb$var$theme,
    disableFontDownload: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
    unstoppableResolution: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function()
});
const $6697ff39d54b09bb$var$connectOptions = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    autoSelect: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).alternatives().try((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
        disableModals: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean()
    }), (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string())
});
const $6697ff39d54b09bb$var$disconnectOptions = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    label: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required()
}).required();
const $6697ff39d54b09bb$var$secondaryTokenValidation = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    address: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().optional()
});
const $6697ff39d54b09bb$var$setChainOptions = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    chainId: (0, $fsqu3.chainIdValidation).required(),
    chainNamespace: (0, $fsqu3.chainNamespaceValidation),
    wallet: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    rpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    token: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    protectedRpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    secondaryTokens: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).array().max(5).items($6697ff39d54b09bb$var$secondaryTokenValidation).optional()
});
const $6697ff39d54b09bb$var$customNotificationUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    key: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().allow("pending", "error", "success", "hint"),
    eventCode: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    message: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    autoDismiss: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number(),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function(),
    link: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string()
});
const $6697ff39d54b09bb$var$preflightNotifications$1 = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    sendTransaction: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function(),
    estimateGas: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function(),
    gasPrice: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function(),
    balance: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).alternatives((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(), (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number()),
    txDetails: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).alternatives((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(), (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number()),
        to: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
        from: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string()
    }),
    txApproveReminderTimeout: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number()
});
const $6697ff39d54b09bb$var$customNotification$1 = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    key: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().allow("pending", "error", "success", "hint"),
    eventCode: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    message: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    autoDismiss: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number(),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function(),
    link: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string()
});
const $6697ff39d54b09bb$var$notification = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    id: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    key: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().allow("pending", "error", "success", "hint").required(),
    eventCode: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    message: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    autoDismiss: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number().required(),
    network: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    startTime: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).number(),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function(),
    link: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string()
});
const $6697ff39d54b09bb$var$transactionHandlerReturn = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).any().allow($6697ff39d54b09bb$var$customNotificationUpdate, (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean().allow(false));
function $6697ff39d54b09bb$var$validateWallet(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$wallet, data);
}
function $6697ff39d54b09bb$var$validateInitOptions(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$initOptions, data);
}
function $6697ff39d54b09bb$var$validateConnectOptions(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$connectOptions, data);
}
function $6697ff39d54b09bb$var$validateDisconnectOptions(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$disconnectOptions, data);
}
function $6697ff39d54b09bb$var$validateString(str, label) {
    return (0, $fsqu3.validate)((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required().label(label || "value"), str);
}
function $6697ff39d54b09bb$var$validateSetChainOptions(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$setChainOptions, data);
}
function $6697ff39d54b09bb$var$validateAccountCenterUpdate(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$accountCenter$1, data);
}
function $6697ff39d54b09bb$var$validateConnectModalUpdate(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$connectModalOptions, data);
}
function $6697ff39d54b09bb$var$validateWalletInit(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$walletInit, data);
}
function $6697ff39d54b09bb$var$validateLocale(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$locale, data);
}
function $6697ff39d54b09bb$var$validateNotify(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$notify$1, data);
}
function $6697ff39d54b09bb$var$validateNotifyOptions(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$notifyOptions, data);
}
function $6697ff39d54b09bb$var$validateTransactionHandlerReturn(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$transactionHandlerReturn, data);
}
function $6697ff39d54b09bb$var$validateNotification(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$notification, data);
}
function $6697ff39d54b09bb$var$validatePreflightNotifications(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$preflightNotifications$1, data);
}
function $6697ff39d54b09bb$var$validateCustomNotificationUpdate(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$customNotificationUpdate, data);
}
function $6697ff39d54b09bb$var$validateCustomNotification(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$customNotification$1, data);
}
function $6697ff39d54b09bb$var$validateUpdateBalances(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$wallets, data);
}
function $6697ff39d54b09bb$var$validateUpdateTheme(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$theme, data);
}
function $6697ff39d54b09bb$var$validateAppMetadataUpdate(data) {
    return (0, $fsqu3.validate)($6697ff39d54b09bb$var$appMetadataUpdate, data);
}
function $6697ff39d54b09bb$var$addChains(chains) {
    // chains are validated on init
    const action = {
        type: $6697ff39d54b09bb$var$ADD_CHAINS,
        payload: chains.map(({ namespace: namespace = "evm", id: id, rpcUrl: rpcUrl, ...rest })=>({
                ...rest,
                namespace: namespace,
                id: id.toLowerCase(),
                rpcUrl: rpcUrl ? rpcUrl.trim() : null
            }))
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$var$updateChain(updatedChain) {
    const { label: label, token: token, rpcUrl: rpcUrl, id: chainId, namespace: chainNamespace } = updatedChain;
    const error = $6697ff39d54b09bb$var$validateSetChainOptions({
        label: label,
        token: token,
        rpcUrl: rpcUrl,
        chainId: chainId,
        chainNamespace: chainNamespace
    });
    if (error) throw error;
    const action = {
        type: $6697ff39d54b09bb$var$UPDATE_CHAINS,
        payload: updatedChain
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$var$addWallet(wallet) {
    const error = $6697ff39d54b09bb$var$validateWallet(wallet);
    if (error) {
        console.error(error);
        throw error;
    }
    const action = {
        type: $6697ff39d54b09bb$var$ADD_WALLET,
        payload: wallet
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$var$updateWallet(id, update) {
    const error = $6697ff39d54b09bb$var$validateWallet(update);
    if (error) {
        console.error(error);
        throw error;
    }
    const action = {
        type: $6697ff39d54b09bb$var$UPDATE_WALLET,
        payload: {
            id: id,
            ...update
        }
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$var$removeWallet(id) {
    const error = $6697ff39d54b09bb$var$validateString(id, "wallet id");
    if (error) throw error;
    const action = {
        type: $6697ff39d54b09bb$var$REMOVE_WALLET,
        payload: {
            id: id
        }
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$export$c4ce752e73470fba(wallet, address) {
    const error = $6697ff39d54b09bb$var$validateWallet(wallet) || address && $6697ff39d54b09bb$var$validateString(address, "address");
    if (error) throw error;
    // if also setting the primary account
    if (address) {
        const account = wallet.accounts.find((ac)=>ac.address === address);
        if (account) wallet.accounts = [
            account,
            ...wallet.accounts.filter(({ address: address })=>address !== account.address)
        ];
    }
    // add wallet will set it to first wallet since it already exists
    $6697ff39d54b09bb$var$addWallet(wallet);
}
function $6697ff39d54b09bb$var$updateAccount(id, address, update) {
    const action = {
        type: $6697ff39d54b09bb$var$UPDATE_ACCOUNT,
        payload: {
            id: id,
            address: address,
            ...update
        }
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$export$1a82df3d29112e01(update) {
    const error = $6697ff39d54b09bb$var$validateAccountCenterUpdate(update);
    if (error) throw error;
    const action = {
        type: $6697ff39d54b09bb$var$UPDATE_ACCOUNT_CENTER,
        payload: update
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$var$updateConnectModal(update) {
    const error = $6697ff39d54b09bb$var$validateConnectModalUpdate(update);
    if (error) throw error;
    const action = {
        type: $6697ff39d54b09bb$var$UPDATE_CONNECT_MODAL,
        payload: update
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$var$updateNotify(update) {
    const error = $6697ff39d54b09bb$var$validateNotify(update);
    if (error) throw error;
    const action = {
        type: $6697ff39d54b09bb$var$UPDATE_NOTIFY,
        payload: update
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$var$addNotification(notification) {
    const error = $6697ff39d54b09bb$var$validateNotification(notification);
    if (error) throw error;
    const action = {
        type: $6697ff39d54b09bb$var$ADD_NOTIFICATION,
        payload: notification
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$export$92108d983e8ee699(notification) {
    const customNotificationError = $6697ff39d54b09bb$var$validateCustomNotificationUpdate(notification);
    if (customNotificationError) throw customNotificationError;
    const action = {
        type: $6697ff39d54b09bb$var$ADD_NOTIFICATION,
        payload: notification
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$var$customNotification(updatedNotification) {
    const customNotificationError = $6697ff39d54b09bb$var$validateCustomNotification(updatedNotification);
    if (customNotificationError) throw customNotificationError;
    const customIdKey = `customNotification-${(0, $kBJxW.nanoid)()}`;
    const notification = {
        ...updatedNotification,
        id: customIdKey,
        key: customIdKey
    };
    $6697ff39d54b09bb$export$92108d983e8ee699(notification);
    const dismiss = ()=>$6697ff39d54b09bb$export$1fbe638ecf81657e(notification.id);
    const update = (notificationUpdate)=>{
        const customNotificationError = $6697ff39d54b09bb$var$validateCustomNotification(updatedNotification);
        if (customNotificationError) throw customNotificationError;
        const notificationAfterUpdate = {
            ...notificationUpdate,
            id: notification.id,
            key: notification.key
        };
        $6697ff39d54b09bb$export$92108d983e8ee699(notificationAfterUpdate);
        return {
            dismiss: dismiss,
            update: update
        };
    };
    $6697ff39d54b09bb$export$92108d983e8ee699(notification);
    return {
        dismiss: dismiss,
        update: update
    };
}
function $6697ff39d54b09bb$export$1fbe638ecf81657e(id) {
    if (typeof id !== "string") throw new Error("Notification id must be of type string");
    const action = {
        type: $6697ff39d54b09bb$var$REMOVE_NOTIFICATION,
        payload: id
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$var$resetStore() {
    const action = {
        type: $6697ff39d54b09bb$var$RESET_STORE
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$var$setWalletModules(wallets) {
    const error = $6697ff39d54b09bb$var$validateWalletInit(wallets);
    if (error) throw error;
    const modules = $6697ff39d54b09bb$var$initializeWalletModules(wallets);
    const dedupedWallets = $6697ff39d54b09bb$var$uniqueWalletsByLabel(modules);
    const action = {
        type: $6697ff39d54b09bb$var$SET_WALLET_MODULES,
        payload: dedupedWallets
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$var$setLocale(locale) {
    const error = $6697ff39d54b09bb$var$validateLocale(locale);
    if (error) throw error;
    const action = {
        type: $6697ff39d54b09bb$var$SET_LOCALE,
        payload: locale
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
function $6697ff39d54b09bb$var$updateAllWallets(wallets) {
    const error = $6697ff39d54b09bb$var$validateUpdateBalances(wallets);
    if (error) throw error;
    const action = {
        type: $6697ff39d54b09bb$var$UPDATE_ALL_WALLETS,
        payload: wallets
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
// ==== HELPERS ==== //
function $6697ff39d54b09bb$var$initializeWalletModules(modules) {
    const { device: device } = $6697ff39d54b09bb$export$c9170ad7d4cd7e57;
    return modules.reduce((acc, walletInit)=>{
        const initialized = walletInit({
            device: device
        });
        if (initialized) // injected wallets is an array of wallets
        acc.push(...Array.isArray(initialized) ? initialized : [
            initialized
        ]);
        return acc;
    }, []);
}
function $6697ff39d54b09bb$var$uniqueWalletsByLabel(walletModuleList) {
    return walletModuleList.filter((wallet, i)=>wallet && walletModuleList.findIndex((innerWallet)=>innerWallet && innerWallet.label === wallet.label) === i);
}
function $6697ff39d54b09bb$var$updateTheme(theme) {
    const error = $6697ff39d54b09bb$var$validateUpdateTheme(theme);
    if (error) throw error;
    const themingObj = $6697ff39d54b09bb$var$returnTheme(theme);
    themingObj && $6697ff39d54b09bb$var$handleThemeChange(themingObj);
}
function $6697ff39d54b09bb$var$updateAppMetadata(update) {
    const error = $6697ff39d54b09bb$var$validateAppMetadataUpdate(update);
    if (error) throw error;
    const action = {
        type: $6697ff39d54b09bb$var$UPDATE_APP_METADATA,
        payload: update
    };
    $6697ff39d54b09bb$var$dispatch$1(action);
}
async function $6697ff39d54b09bb$export$3b513254972cfc9c(options) {
    if (options) {
        const error = $6697ff39d54b09bb$var$validateConnectOptions(options);
        if (error) throw error;
    }
    const { chains: chains } = $6697ff39d54b09bb$export$6559d589eb85fbb6.get();
    // Wallets require the chains for initializing providers,
    // so we must ensure at least one is set
    if (!chains.length) throw new Error("At least one chain must be set before attempting to connect a wallet");
    const { autoSelect: autoSelect } = options || {
        autoSelect: {
            label: "",
            disableModals: false
        }
    };
    // if auto selecting, wait until next event loop
    if (autoSelect && (typeof autoSelect === "string" || autoSelect.label)) await $6697ff39d54b09bb$var$wait$1(50);
    // first time calling connect, so initialize and set wallet modules
    if (!$6697ff39d54b09bb$export$6559d589eb85fbb6.get().walletModules.length) $6697ff39d54b09bb$var$setWalletModules($6697ff39d54b09bb$export$c9170ad7d4cd7e57.initialWalletInit);
    $6697ff39d54b09bb$export$a07804094c3ecf2d.next({
        autoSelect: typeof autoSelect === "string" ? {
            label: autoSelect,
            disableModals: false
        } : autoSelect,
        inProgress: true
    });
    const result$ = $6697ff39d54b09bb$export$a07804094c3ecf2d.pipe((0, $d6DLj.filter)(({ inProgress: inProgress, actionRequired: actionRequired })=>inProgress === false && !actionRequired), (0, $eUlHv.withLatestFrom)($6697ff39d54b09bb$export$efccba1c4a2ef57b), (0, $6vUKV.pluck)(1));
    return (0, $jKULm.firstValueFrom)(result$);
}
var $6697ff39d54b09bb$var$connect = {
    selectingWallet: {
        header: "Available Wallets",
        sidebar: {
            heading: "",
            subheading: "Connect your wallet",
            paragraph: "Connecting your wallet is like \u201Clogging in\u201D to Web3. Select your wallet from the options to get started.",
            IDontHaveAWallet: "I don't have a wallet"
        },
        recommendedWalletsPart1: "{app} only supports",
        recommendedWalletsPart2: "on this platform. Please use or install one of the supported wallets to continue",
        installWallet: "You do not have any wallets installed that {app} supports, please use a supported wallet",
        agreement: {
            agree: "I agree to the",
            terms: "Terms & Conditions",
            and: "and",
            privacy: "Privacy Policy"
        },
        whyDontISeeMyWallet: "Why don't I see my wallet?",
        learnMore: "Click here to learn more"
    },
    connectingWallet: {
        header: "{connectionRejected, select, false {Connecting to {wallet}...} other {Connection Rejected}}",
        sidebar: {
            subheading: "Approve Connection",
            paragraph: "Please approve the connection in your wallet and authorize access to continue."
        },
        mainText: "Connecting...",
        paragraph: "Make sure to select all accounts that you want to grant access to.",
        previousConnection: "{wallet} already has a pending connection request, please open the {wallet} app to login and connect.",
        rejectedText: "Connection Rejected!",
        rejectedCTA: "Click here to try again",
        primaryButton: "Back to wallets"
    },
    connectedWallet: {
        header: "Connection Successful",
        sidebar: {
            subheading: "Connection Successful!",
            paragraph: "Your wallet is now connected to {app}"
        },
        mainText: "Connected"
    }
};
var $6697ff39d54b09bb$var$modals = {
    actionRequired: {
        heading: "Action required in {wallet}",
        paragraph: "Please switch the active account in your wallet.",
        linkText: "Learn more.",
        buttonText: "Okay"
    },
    switchChain: {
        heading: "Switch Chain",
        paragraph1: "{app} requires that you switch your wallet to the {nextNetworkName} network to continue.",
        paragraph2: "*Some wallets may not support changing networks. If you can not change networks in your wallet you may consider switching to a different wallet."
    },
    confirmDisconnectAll: {
        heading: "Disconnect all Wallets",
        description: "Are you sure that you would like to disconnect all your wallets?",
        confirm: "Confirm",
        cancel: "Cancel"
    },
    confirmTransactionProtection: {
        heading: "Enable Transaction Protection",
        description: "Protect RPC endpoints hide your transaction from front-running and sandwich bots.",
        link: "Learn more",
        enable: "Enable",
        dismiss: "Dismiss"
    }
};
var $6697ff39d54b09bb$var$accountCenter = {
    connectAnotherWallet: "Connect another Wallet",
    disconnectAllWallets: "Disconnect all Wallets",
    currentNetwork: "Current Network",
    enableTransactionProtection: "Enable Transaction Protection",
    appInfo: "App Info",
    learnMore: "Learn More",
    gettingStartedGuide: "Getting Started Guide",
    smartContracts: "Smart Contract(s)",
    explore: "Explore",
    poweredBy: "powered by",
    addAccount: "Add Account",
    setPrimaryAccount: "Set Primary Account",
    disconnectWallet: "Disconnect Wallet",
    copyAddress: "Copy Wallet address"
};
var $6697ff39d54b09bb$var$notify = {
    transaction: {
        txRequest: "Your transaction is waiting for you to confirm",
        nsfFail: "You have insufficient funds for this transaction",
        txUnderpriced: "The gas price for your transaction is too low, try a higher gas price",
        txRepeat: "This could be a repeat transaction",
        txAwaitingApproval: "You have a previous transaction waiting for you to confirm",
        txConfirmReminder: "Please confirm your transaction to continue",
        txSendFail: "You rejected the transaction",
        txSent: "Your transaction has been sent to the network",
        txStallPending: "Your transaction has stalled before it was sent, please try again",
        txStuck: "Your transaction is stuck due to a nonce gap",
        txPool: "Your transaction has started",
        txStallConfirmed: "Your transaction has stalled and hasn't been confirmed",
        txSpeedUp: "Your transaction has been sped up",
        txCancel: "Your transaction is being canceled",
        txFailed: "Your transaction has failed",
        txConfirmed: "Your transaction has succeeded",
        txError: "Oops something went wrong, please try again",
        txReplaceError: "There was an error replacing your transaction, please try again"
    },
    watched: {
        txPool: "Your account is {verb} {formattedValue} {asset} {preposition} {counterpartyShortened}",
        txSpeedUp: "Transaction for {formattedValue} {asset} {preposition} {counterpartyShortened} has been sped up",
        txCancel: "Transaction for {formattedValue} {asset} {preposition} {counterpartyShortened} has been canceled",
        txConfirmed: "Your account successfully {verb} {formattedValue} {asset} {preposition} {counterpartyShortened}",
        txFailed: "Your account failed to {verb} {formattedValue} {asset} {preposition} {counterpartyShortened}",
        txStuck: "Your transaction is stuck due to a nonce gap"
    },
    time: {
        minutes: "min",
        seconds: "sec"
    }
};
var $6697ff39d54b09bb$export$e7094788287c5e9b = {
    connect: $6697ff39d54b09bb$var$connect,
    modals: $6697ff39d54b09bb$var$modals,
    accountCenter: $6697ff39d54b09bb$var$accountCenter,
    notify: $6697ff39d54b09bb$var$notify
};
const $6697ff39d54b09bb$var$ethersProviders = {};
function $6697ff39d54b09bb$var$getProvider(chain) {
    if (!chain) return null;
    if (!$6697ff39d54b09bb$var$ethersProviders[chain.rpcUrl]) $6697ff39d54b09bb$var$ethersProviders[chain.rpcUrl] = new (0, $S29ji).StaticJsonRpcProvider(chain.providerConnectionInfo && chain.providerConnectionInfo.url ? chain.providerConnectionInfo : chain.rpcUrl);
    return $6697ff39d54b09bb$var$ethersProviders[chain.rpcUrl];
}
function $6697ff39d54b09bb$var$requestAccounts(provider) {
    const args = {
        method: "eth_requestAccounts"
    };
    return provider.request(args);
}
function $6697ff39d54b09bb$export$3a1a48c8f6ef640e(provider) {
    const args = {
        method: "eth_selectAccounts"
    };
    return provider.request(args);
}
function $6697ff39d54b09bb$var$getChainId(provider) {
    return provider.request({
        method: "eth_chainId"
    });
}
function $6697ff39d54b09bb$var$listenAccountsChanged(args) {
    const { provider: provider, disconnected$: disconnected$ } = args;
    const addHandler = (handler)=>{
        provider.on("accountsChanged", handler);
    };
    const removeHandler = (handler)=>{
        provider.removeListener("accountsChanged", handler);
    };
    return (0, $hU8PB.fromEventPattern)(addHandler, removeHandler).pipe((0, $jXWpp.takeUntil)(disconnected$));
}
function $6697ff39d54b09bb$var$listenChainChanged(args) {
    const { provider: provider, disconnected$: disconnected$ } = args;
    const addHandler = (handler)=>{
        provider.on("chainChanged", handler);
    };
    const removeHandler = (handler)=>{
        provider.removeListener("chainChanged", handler);
    };
    return (0, $hU8PB.fromEventPattern)(addHandler, removeHandler).pipe((0, $jXWpp.takeUntil)(disconnected$));
}
function $6697ff39d54b09bb$var$trackWallet(provider, label) {
    const disconnected$ = $6697ff39d54b09bb$var$disconnectWallet$.pipe((0, $d6DLj.filter)((wallet)=>wallet === label), (0, $jGgch.take)(1));
    const accountsChanged$ = $6697ff39d54b09bb$var$listenAccountsChanged({
        provider: provider,
        disconnected$: disconnected$
    }).pipe((0, $16oXE.share)());
    // when account changed, set it to first account and subscribe to events
    accountsChanged$.subscribe(async ([address])=>{
        // sync accounts with internal state
        // in the case of an account has been manually disconnected
        try {
            await $6697ff39d54b09bb$var$syncWalletConnectedAccounts(label);
        } catch (error) {
            console.warn("Web3Onboard: Error whilst trying to sync connected accounts:", error);
        }
        // no address, then no account connected, so disconnect wallet
        // this could happen if user locks wallet,
        // or if disconnects app from wallet
        if (!address) {
            $6697ff39d54b09bb$export$56c0d5a1e737357d({
                label: label
            });
            return;
        }
        const { wallets: wallets } = $6697ff39d54b09bb$export$6559d589eb85fbb6.get();
        const { accounts: accounts } = wallets.find((wallet)=>wallet.label === label);
        const [[existingAccount], restAccounts] = (0, (/*@__PURE__*/$parcel$interopDefault($4yR7b)))(accounts, (account)=>account.address === address);
        // update accounts without ens/uns and balance first
        $6697ff39d54b09bb$var$updateWallet(label, {
            accounts: [
                existingAccount || {
                    address: address,
                    ens: null,
                    uns: null,
                    balance: null
                },
                ...restAccounts
            ]
        });
        // if not existing account and notifications,
        // then subscribe to transaction events
        if ($6697ff39d54b09bb$export$6559d589eb85fbb6.get().notify.enabled && !existingAccount) {
            const sdk = await $6697ff39d54b09bb$var$getBNMulitChainSdk();
            if (sdk) {
                const wallet = $6697ff39d54b09bb$export$6559d589eb85fbb6.get().wallets.find((wallet)=>wallet.label === label);
                try {
                    sdk.subscribe({
                        id: address,
                        chainId: wallet.chains[0].id,
                        type: "account"
                    });
                } catch (error) {
                // unsupported network for transaction events
                }
            }
        }
    });
    // also when accounts change, update Balance and ENS/UNS
    accountsChanged$.pipe((0, $466t7.switchMap)(async ([address])=>{
        if (!address) return;
        const { wallets: wallets, chains: chains } = $6697ff39d54b09bb$export$6559d589eb85fbb6.get();
        const primaryWallet = wallets.find((wallet)=>wallet.label === label);
        const { chains: walletChains, accounts: accounts } = primaryWallet;
        const [connectedWalletChain] = walletChains;
        const chain = chains.find(({ namespace: namespace, id: id })=>namespace === "evm" && id === connectedWalletChain.id);
        const balanceProm = $6697ff39d54b09bb$var$getBalance(address, chain);
        const secondaryTokenBal = $6697ff39d54b09bb$var$updateSecondaryTokens(primaryWallet, address, chain);
        const account = accounts.find((account)=>account.address === address);
        const ensChain = chains.find(({ id: id })=>id === $6697ff39d54b09bb$var$validEnsChain(connectedWalletChain.id));
        const ensProm = account && account.ens ? Promise.resolve(account.ens) : ensChain ? $6697ff39d54b09bb$var$getEns(address, ensChain) : Promise.resolve(null);
        const unsProm = account && account.uns ? Promise.resolve(account.uns) : $6697ff39d54b09bb$var$getUns(address, chain);
        return Promise.all([
            Promise.resolve(address),
            balanceProm,
            ensProm,
            unsProm,
            secondaryTokenBal
        ]);
    })).subscribe((res)=>{
        if (!res) return;
        const [address, balance, ens, uns, secondaryTokens] = res;
        $6697ff39d54b09bb$var$updateAccount(label, address, {
            balance: balance,
            ens: ens,
            uns: uns,
            secondaryTokens: secondaryTokens
        });
    });
    const chainChanged$ = $6697ff39d54b09bb$var$listenChainChanged({
        provider: provider,
        disconnected$: disconnected$
    }).pipe((0, $16oXE.share)());
    // Update chain on wallet when chainId changed
    chainChanged$.subscribe(async (chainId)=>{
        const { wallets: wallets } = $6697ff39d54b09bb$export$6559d589eb85fbb6.get();
        const { chains: chains, accounts: accounts } = wallets.find((wallet)=>wallet.label === label);
        const [connectedWalletChain] = chains;
        if (chainId === connectedWalletChain.id) return;
        if ($6697ff39d54b09bb$export$6559d589eb85fbb6.get().notify.enabled) {
            const sdk = await $6697ff39d54b09bb$var$getBNMulitChainSdk();
            if (sdk) {
                const wallet = $6697ff39d54b09bb$export$6559d589eb85fbb6.get().wallets.find((wallet)=>wallet.label === label);
                // Unsubscribe with timeout of 60 seconds
                // to allow for any currently inflight transactions
                wallet.accounts.forEach(({ address: address })=>{
                    sdk.unsubscribe({
                        id: address,
                        chainId: wallet.chains[0].id,
                        timeout: 60000
                    });
                });
                // resubscribe for new chainId
                wallet.accounts.forEach(({ address: address })=>{
                    try {
                        sdk.subscribe({
                            id: address,
                            chainId: chainId,
                            type: "account"
                        });
                    } catch (error) {
                    // unsupported network for transaction events
                    }
                });
            }
        }
        const resetAccounts = accounts.map(({ address: address })=>({
                address: address,
                ens: null,
                uns: null,
                balance: null
            }));
        $6697ff39d54b09bb$var$updateWallet(label, {
            chains: [
                {
                    namespace: "evm",
                    id: chainId
                }
            ],
            accounts: resetAccounts
        });
    });
    // when chain changes get ens/uns and balance for each account for wallet
    chainChanged$.pipe((0, $466t7.switchMap)(async (chainId)=>{
        const { wallets: wallets, chains: chains } = $6697ff39d54b09bb$export$6559d589eb85fbb6.get();
        const primaryWallet = wallets.find((wallet)=>wallet.label === label);
        const { accounts: accounts } = primaryWallet;
        const chain = chains.find(({ namespace: namespace, id: id })=>namespace === "evm" && id === chainId);
        return Promise.all(accounts.map(async ({ address: address })=>{
            const balanceProm = $6697ff39d54b09bb$var$getBalance(address, chain);
            const secondaryTokenBal = $6697ff39d54b09bb$var$updateSecondaryTokens(primaryWallet, address, chain);
            const ensChain = chains.find(({ id: id })=>id === $6697ff39d54b09bb$var$validEnsChain(chainId));
            const ensProm = ensChain ? $6697ff39d54b09bb$var$getEns(address, ensChain) : Promise.resolve(null);
            const unsProm = $6697ff39d54b09bb$var$validEnsChain(chainId) ? $6697ff39d54b09bb$var$getUns(address, ensChain) : Promise.resolve(null);
            const [balance, ens, uns, secondaryTokens] = await Promise.all([
                balanceProm,
                ensProm,
                unsProm,
                secondaryTokenBal
            ]);
            return {
                address: address,
                balance: balance,
                ens: ens,
                uns: uns,
                secondaryTokens: secondaryTokens
            };
        }));
    })).subscribe((updatedAccounts)=>{
        updatedAccounts && $6697ff39d54b09bb$var$updateWallet(label, {
            accounts: updatedAccounts
        });
    });
    disconnected$.subscribe(()=>{
        provider.disconnect && provider.disconnect();
    });
}
async function $6697ff39d54b09bb$var$getEns(address, chain) {
    // chain we don't recognize and don't have a rpcUrl for requests
    if (!chain) return null;
    const provider = $6697ff39d54b09bb$var$getProvider(chain);
    try {
        const name = await provider.lookupAddress(address);
        let ens = null;
        if (name) {
            const resolver = await provider.getResolver(name);
            if (resolver) {
                const [contentHash, avatar] = await Promise.all([
                    resolver.getContentHash(),
                    resolver.getAvatar()
                ]);
                const getText = resolver.getText.bind(resolver);
                ens = {
                    name: name,
                    avatar: avatar,
                    contentHash: contentHash,
                    getText: getText
                };
            }
        }
        return ens;
    } catch (error) {
        console.error(error);
        return null;
    }
}
async function $6697ff39d54b09bb$var$getUns(address, chain) {
    const { unstoppableResolution: unstoppableResolution } = $6697ff39d54b09bb$export$c9170ad7d4cd7e57;
    // check if address is valid ETH address before attempting to resolve
    // chain we don't recognize and don't have a rpcUrl for requests
    if (!unstoppableResolution || !(0, $jd9Pa).isAddress(address) || !chain) return null;
    try {
        return await unstoppableResolution(address);
    } catch (error) {
        console.error(error);
        return null;
    }
}
async function $6697ff39d54b09bb$var$getBalance(address, chain) {
    // chain we don't recognize and don't have a rpcUrl for requests
    if (!chain) return null;
    const { wallets: wallets } = $6697ff39d54b09bb$export$6559d589eb85fbb6.get();
    try {
        const wallet = wallets.find((wallet)=>!!wallet.provider);
        const provider = wallet.provider;
        const balanceHex = await provider.request({
            method: "eth_getBalance",
            params: [
                address,
                "latest"
            ]
        });
        return balanceHex ? {
            [chain.token || "eth"]: (0, $jXBIn.weiToEth)(balanceHex)
        } : null;
    } catch (error) {
        console.error(error);
        return null;
    }
}
function $6697ff39d54b09bb$var$switchChain(provider, chainId) {
    return provider.request({
        method: "wallet_switchEthereumChain",
        params: [
            {
                chainId: chainId
            }
        ]
    });
}
function $6697ff39d54b09bb$var$addNewChain(provider, chain) {
    return provider.request({
        method: "wallet_addEthereumChain",
        params: [
            {
                chainId: chain.id,
                chainName: chain.label,
                nativeCurrency: {
                    name: chain.label,
                    symbol: chain.token,
                    decimals: 18
                },
                rpcUrls: [
                    chain.publicRpcUrl || chain.rpcUrl
                ],
                blockExplorerUrls: chain.blockExplorerUrl ? [
                    chain.blockExplorerUrl
                ] : undefined
            }
        ]
    });
}
function $6697ff39d54b09bb$export$ee7c8ad385a60b7b(provider, chain, rpcUrl) {
    return provider.request({
        method: "wallet_addEthereumChain",
        params: [
            {
                chainId: chain.id,
                chainName: chain.label,
                nativeCurrency: {
                    name: chain.label,
                    symbol: chain.token,
                    decimals: 18
                },
                rpcUrls: [
                    rpcUrl
                ],
                blockExplorerUrls: chain.blockExplorerUrl ? [
                    chain.blockExplorerUrl
                ] : undefined
            }
        ]
    });
}
async function $6697ff39d54b09bb$var$getPermissions(provider) {
    try {
        const permissions = await provider.request({
            method: "wallet_getPermissions"
        });
        return Array.isArray(permissions) ? permissions : [];
    } catch (error) {
        return [];
    }
}
async function $6697ff39d54b09bb$var$syncWalletConnectedAccounts(label) {
    const wallet = $6697ff39d54b09bb$export$6559d589eb85fbb6.get().wallets.find((wallet)=>wallet.label === label);
    const permissions = await $6697ff39d54b09bb$var$getPermissions(wallet.provider);
    const accountsPermissions = permissions.find(({ parentCapability: parentCapability })=>parentCapability === "eth_accounts");
    if (accountsPermissions) {
        const { value: connectedAccounts } = accountsPermissions.caveats.find(({ type: type })=>type === "restrictReturnedAccounts") || {
            value: null
        };
        if (connectedAccounts) {
            const syncedAccounts = wallet.accounts.filter(({ address: address })=>connectedAccounts.includes(address));
            $6697ff39d54b09bb$var$updateWallet(wallet.label, {
                ...wallet,
                accounts: syncedAccounts
            });
        }
    }
}
async function $6697ff39d54b09bb$var$updateBalances(addresses) {
    const { wallets: wallets, chains: chains } = $6697ff39d54b09bb$export$6559d589eb85fbb6.get();
    const updatedWallets = await Promise.all(wallets.map(async (wallet)=>{
        const chain = chains.find(({ id: id })=>id === wallet.chains[0].id);
        const updatedAccounts = await Promise.all(wallet.accounts.map(async (account)=>{
            const secondaryTokens = await $6697ff39d54b09bb$var$updateSecondaryTokens(wallet, account.address, chain);
            // if no provided addresses, we want to update all balances
            // otherwise check if address is in addresses array
            if (!addresses || addresses.some((address)=>address.toLowerCase() === account.address.toLowerCase())) {
                const updatedBalance = await $6697ff39d54b09bb$var$getBalance(account.address, chain);
                return {
                    ...account,
                    balance: updatedBalance,
                    secondaryTokens: secondaryTokens
                };
            }
            return {
                ...account,
                secondaryTokens: secondaryTokens
            };
        }));
        return {
            ...wallet,
            accounts: updatedAccounts
        };
    }));
    $6697ff39d54b09bb$var$updateAllWallets(updatedWallets);
}
const $6697ff39d54b09bb$var$updateSecondaryTokens = async (wallet, account, chain)=>{
    if (!chain) return;
    const chainRPC = chain.rpcUrl;
    if (!chain.secondaryTokens || !chain.secondaryTokens.length || !chainRPC) return;
    const ethersProvider = new (0, $95AgJ).providers.Web3Provider(wallet.provider, "any");
    const signer = ethersProvider.getSigner();
    const erc20ABISubset = [
        {
            inputs: [
                {
                    name: "owner",
                    type: "address"
                }
            ],
            name: "balanceOf",
            outputs: [
                {
                    name: "",
                    type: "uint256"
                }
            ],
            stateMutability: "view",
            type: "function"
        },
        {
            inputs: [],
            name: "symbol",
            outputs: [
                {
                    name: "",
                    type: "string"
                }
            ],
            stateMutability: "view",
            type: "function"
        }
    ];
    const tokenBalances = await Promise.all(chain.secondaryTokens.map(async (token)=>{
        try {
            const swapContract = new (0, $95AgJ).Contract(token.address, erc20ABISubset, signer);
            const bigNumBalance = await swapContract.balanceOf(account);
            const tokenName = await swapContract.symbol();
            return {
                name: tokenName,
                balance: (0, $jXBIn.weiToEth)(bigNumBalance.toHexString()),
                icon: token.icon
            };
        } catch (error) {
            console.error(`There was an error fetching balance and/or symbol 
          for token contract: ${token.address} - ${error}`);
        }
    }));
    return tokenBalances;
};
function $6697ff39d54b09bb$var$handleTransactionUpdates(transaction) {
    const customized = $6697ff39d54b09bb$export$6559d589eb85fbb6.get().notify.transactionHandler(transaction);
    const invalid = $6697ff39d54b09bb$var$validateTransactionHandlerReturn(customized);
    if (invalid) throw invalid;
    if (transaction.eventCode === "txConfirmed") $6697ff39d54b09bb$var$updateBalances([
        transaction.watchedAddress,
        transaction.counterparty
    ]);
    const notification = $6697ff39d54b09bb$var$transactionEventToNotification(transaction, customized);
    $6697ff39d54b09bb$var$addNotification(notification);
    $6697ff39d54b09bb$var$updateTransaction(transaction);
}
function $6697ff39d54b09bb$var$transactionEventToNotification(transaction, customization) {
    const { id: id, hash: hash, startTime: startTime, eventCode: eventCode, direction: direction, counterparty: counterparty, value: value, asset: asset, network: network } = transaction;
    const type = $6697ff39d54b09bb$var$eventToType(eventCode);
    const key = `${id || hash}-${typeof customization === "object" && customization.eventCode || eventCode}`;
    const counterpartyShortened = counterparty && counterparty.substring(0, 4) + "..." + counterparty.substring(counterparty.length - 4);
    const formattedValue = new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(value || 0).div(new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))("1000000000000000000")).toString(10);
    const formatterOptions = counterparty && value ? {
        messageId: `notify.watched['${eventCode}']`,
        values: {
            verb: eventCode === "txConfirmed" ? direction === "incoming" ? "received" : "sent" : direction === "incoming" ? "receiving" : "sending",
            formattedValue: formattedValue,
            preposition: direction === "incoming" ? "from" : "to",
            counterpartyShortened: counterpartyShortened,
            asset: asset
        }
    } : {
        messageId: `notify.transaction['${eventCode}']`,
        values: {
            formattedValue: formattedValue,
            asset: asset
        }
    };
    const formatter = (0, $6ojdr.get_store_value)((0, $6y4qQ._));
    const notificationDefaultMessages = $6697ff39d54b09bb$export$e7094788287c5e9b.notify;
    const typeKey = counterparty ? "watched" : "transaction";
    const notificationMessageType = notificationDefaultMessages[typeKey];
    const defaultMessage = notificationMessageType[eventCode];
    const message = formatter(formatterOptions.messageId, {
        values: formatterOptions.values,
        default: defaultMessage
    });
    let notification = {
        id: id || hash,
        type: type,
        key: key,
        network: network,
        startTime: startTime || Date.now(),
        eventCode: eventCode,
        message: message,
        autoDismiss: $6697ff39d54b09bb$var$typeToDismissTimeout(typeof customization === "object" && customization.type || type)
    };
    if (typeof customization === "object") notification = {
        ...notification,
        ...customization
    };
    return notification;
}
function $6697ff39d54b09bb$var$eventToType(eventCode) {
    switch(eventCode){
        case "txSent":
        case "txPool":
            return "pending";
        case "txSpeedUp":
        case "txCancel":
        case "txRequest":
        case "txRepeat":
        case "txAwaitingApproval":
        case "txConfirmReminder":
        case "txStuck":
            return "hint";
        case "txError":
        case "txSendFail":
        case "txFailed":
        case "txDropped":
        case "nsfFail":
        case "txUnderpriced":
            return "error";
        case "txConfirmed":
            return "success";
        default:
            return "hint";
    }
}
function $6697ff39d54b09bb$var$typeToDismissTimeout(type) {
    switch(type){
        case "success":
        case "hint":
            return 4000;
        default:
            return 0;
    }
}
let $6697ff39d54b09bb$var$blocknativeMultiChainSdk;
let $6697ff39d54b09bb$var$blocknativeSdk;

/**
 *
 * @returns MultiChain SDK if apiKey
 */ async function $6697ff39d54b09bb$var$getBNMulitChainSdk() {
    const { apiKey: apiKey } = $6697ff39d54b09bb$export$c9170ad7d4cd7e57;
    if (!apiKey) return null;
    if (!$6697ff39d54b09bb$var$blocknativeMultiChainSdk) {
        const { default: Blocknative } = await (parcelRequire("k3ihT"));
        $6697ff39d54b09bb$var$blocknativeMultiChainSdk = Blocknative.multichain({
            apiKey: $6697ff39d54b09bb$export$c9170ad7d4cd7e57.apiKey
        });
        $6697ff39d54b09bb$var$blocknativeMultiChainSdk.transactions$.subscribe($6697ff39d54b09bb$var$handleTransactionUpdates);
    }
    return $6697ff39d54b09bb$var$blocknativeMultiChainSdk;
}

/**
 *
 * @returns SDK if apiKey
 */ async function $6697ff39d54b09bb$var$getBlocknativeSdk() {
    const { apiKey: apiKey } = $6697ff39d54b09bb$export$c9170ad7d4cd7e57;
    if (!apiKey) return null;
    if (!$6697ff39d54b09bb$var$blocknativeSdk) {
        const { default: Blocknative } = await (parcelRequire("k3ihT"));
        $6697ff39d54b09bb$var$blocknativeSdk = new Blocknative({
            dappId: $6697ff39d54b09bb$export$c9170ad7d4cd7e57.apiKey,
            networkId: 1
        });
        return $6697ff39d54b09bb$var$blocknativeSdk;
    }
    return $6697ff39d54b09bb$var$blocknativeSdk;
}
async function $6697ff39d54b09bb$export$56c0d5a1e737357d(options) {
    const error = $6697ff39d54b09bb$var$validateDisconnectOptions(options);
    if (error) throw error;
    const { label: label } = options;
    if ($6697ff39d54b09bb$export$6559d589eb85fbb6.get().notify.enabled) {
        // handle unwatching addresses
        const sdk = await $6697ff39d54b09bb$var$getBNMulitChainSdk();
        if (sdk) {
            const wallet = $6697ff39d54b09bb$export$6559d589eb85fbb6.get().wallets.find((wallet)=>wallet.label === label);
            wallet.accounts.forEach(({ address: address })=>{
                sdk.unsubscribe({
                    id: address,
                    chainId: wallet.chains[0].id,
                    timeout: 60000
                });
            });
        }
    }
    $6697ff39d54b09bb$var$disconnectWallet$.next(label);
    $6697ff39d54b09bb$var$removeWallet(label);
    const labels = JSON.parse($6697ff39d54b09bb$var$getLocalStore($6697ff39d54b09bb$var$STORAGE_KEYS.LAST_CONNECTED_WALLET));
    if (Array.isArray(labels) && labels.indexOf(label) >= 0) $6697ff39d54b09bb$var$setLocalStore($6697ff39d54b09bb$var$STORAGE_KEYS.LAST_CONNECTED_WALLET, JSON.stringify(labels.filter((walletLabel)=>walletLabel !== label)));
    if (typeof labels === "string" && labels === label) $6697ff39d54b09bb$var$delLocalStore($6697ff39d54b09bb$var$STORAGE_KEYS.LAST_CONNECTED_WALLET);
    return $6697ff39d54b09bb$export$6559d589eb85fbb6.get().wallets;
}
async function $6697ff39d54b09bb$export$2d1720544b23b823(options) {
    const error = $6697ff39d54b09bb$var$validateSetChainOptions(options);
    if (error) throw error;
    const { wallets: wallets, chains: chains } = $6697ff39d54b09bb$export$6559d589eb85fbb6.get();
    const { chainId: chainId, chainNamespace: chainNamespace = "evm", wallet: walletToSet, rpcUrl: rpcUrl, label: label, token: token } = options;
    const chainIdHex = $6697ff39d54b09bb$export$d24c54395ce0c509(chainId);
    // validate that chainId has been added to chains
    const chain = chains.find(({ namespace: namespace, id: id })=>namespace === chainNamespace && id.toLowerCase() === chainIdHex.toLowerCase());
    if (!chain) throw new Error(`Chain with chainId: ${chainId} and chainNamespace: ${chainNamespace} has not been set and must be added when Onboard is initialized.`);
    const wallet = walletToSet ? wallets.find(({ label: label })=>label === walletToSet) : wallets[0];
    // validate a wallet is connected
    if (!wallet) throw new Error(walletToSet ? `Wallet with label ${walletToSet} is not connected` : "A wallet must be connected before a chain can be set");
    const [walletConnectedChain] = wallet.chains;
    // check if wallet is already connected to chainId
    if (walletConnectedChain.namespace === chainNamespace && walletConnectedChain.id === chainIdHex) return true;
    try {
        await $6697ff39d54b09bb$var$switchChain(wallet.provider, chainIdHex);
        return true;
    } catch (error) {
        const { code: code } = error;
        const switchChainModalClosed$ = $6697ff39d54b09bb$var$switchChainModal$.pipe((0, $d6DLj.filter)((x)=>x === null), (0, $d4PzE.map)(()=>false));
        if (code === (0, $7oBBe.ProviderRpcErrorCode).CHAIN_NOT_ADDED || code === (0, $7oBBe.ProviderRpcErrorCode).UNRECOGNIZED_CHAIN_ID) {
            // chain has not been added to wallet
            if (rpcUrl || label || token) {
                if (rpcUrl) chain.rpcUrl = rpcUrl;
                if (label) chain.label = label;
                if (token) chain.token = token;
                $6697ff39d54b09bb$var$updateChain(chain);
            }
            // add chain to wallet
            return $6697ff39d54b09bb$var$chainNotInWallet(wallet, chain, switchChainModalClosed$, chainIdHex);
        }
        if (code === (0, $7oBBe.ProviderRpcErrorCode).UNSUPPORTED_METHOD) {
            // method not supported
            $6697ff39d54b09bb$var$switchChainModal$.next({
                chain: chain
            });
            return (0, $jKULm.firstValueFrom)(switchChainModalClosed$);
        }
    }
    return false;
}
const $6697ff39d54b09bb$var$chainNotInWallet = async (wallet, chain, switchChainModalClosed$, chainIdHex)=>{
    try {
        await $6697ff39d54b09bb$var$addNewChain(wallet.provider, chain);
        await $6697ff39d54b09bb$var$switchChain(wallet.provider, chainIdHex);
        return true;
    } catch (error) {
        const { code: code } = error;
        if (code === (0, $7oBBe.ProviderRpcErrorCode).ACCOUNT_ACCESS_REJECTED) // add new chain rejected by user
        return false;
        // display notification to user to switch chain
        $6697ff39d54b09bb$var$switchChainModal$.next({
            chain: chain
        });
        return (0, $jKULm.firstValueFrom)(switchChainModalClosed$);
    }
};
function $6697ff39d54b09bb$var$initialize(options) {
    if (options) {
        const { en: customizedEn } = options;
        const merged = (0, (/*@__PURE__*/$parcel$interopDefault($bgFCw)))($6697ff39d54b09bb$export$e7094788287c5e9b, customizedEn || {});
        (0, $6y4qQ.addMessages)("en", merged);
        const customLocales = Object.keys(options).filter((key)=>key !== "en");
        // Sync register all customLocales
        customLocales.forEach((locale)=>{
            const dictionary = options[locale];
            dictionary && (0, $6y4qQ.addMessages)(locale, dictionary);
        });
    } else (0, $6y4qQ.addMessages)("en", $6697ff39d54b09bb$export$e7094788287c5e9b);
    (0, $6y4qQ.init)({
        fallbackLocale: "en",
        initialLocale: (0, $6y4qQ.getLocaleFromNavigator)()
    });
}
var $6697ff39d54b09bb$var$closeIcon = `
  <svg width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
  </svg>
`;
/* src/views/shared/CloseButton.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$i(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-1ubf722", ".close-button.svelte-1ubf722.svelte-1ubf722{position:relative;overflow:hidden;display:flex;align-items:center;justify-content:center;height:2rem;width:2rem;border-radius:2rem;cursor:pointer;color:var(--onboard-close-button-color, inherit)}.close-button.svelte-1ubf722.svelte-1ubf722:hover::before{opacity:0.2}.close-button.svelte-1ubf722:hover .svg-box.svelte-1ubf722{opacity:1}.close-button.svelte-1ubf722.svelte-1ubf722::before{content:'';position:absolute;height:inherit;width:inherit;opacity:0.1;background:currentColor;transition:300ms ease-in-out opacity}.svg-box.svelte-1ubf722.svelte-1ubf722{position:absolute;height:1.5rem;width:1.5rem;opacity:0.6;transition:300ms ease-in-out opacity}");
}
function $6697ff39d54b09bb$var$create_fragment$i(ctx) {
    let div1;
    let div0;
    return {
        c () {
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "svg-box svelte-1ubf722");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "close-button svelte-1ubf722");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div1, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, div0);
            div0.innerHTML = $6697ff39d54b09bb$var$closeIcon;
        },
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div1);
        }
    };
}
class $6697ff39d54b09bb$var$CloseButton extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, null, $6697ff39d54b09bb$var$create_fragment$i, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {}, $6697ff39d54b09bb$var$add_css$i);
    }
}
function $6697ff39d54b09bb$export$306ddfe3a8403e2(t) {
    const f = t - 1.0;
    return f * f * f + 1.0;
}
function $6697ff39d54b09bb$export$7910e0436ed8d1de(t) {
    return Math.pow(t - 1.0, 3.0) * (1.0 - t) + 1.0;
}
function $6697ff39d54b09bb$export$78acf4525d8a74c4(node, { delay: delay = 0, duration: duration = 400, easing: easing = $6697ff39d54b09bb$var$identity } = {}) {
    const o = +getComputedStyle(node).opacity;
    return {
        delay: delay,
        duration: duration,
        easing: easing,
        css: (t)=>`opacity: ${t * o}`
    };
}
function $6697ff39d54b09bb$export$555508cbc6add439(node, { delay: delay = 0, duration: duration = 400, easing: easing = $6697ff39d54b09bb$export$306ddfe3a8403e2, x: x = 0, y: y = 0, opacity: opacity = 0 } = {}) {
    const style = getComputedStyle(node);
    const target_opacity = +style.opacity;
    const transform = style.transform === "none" ? "" : style.transform;
    const od = target_opacity * (1 - opacity);
    const [xValue, xUnit] = $6697ff39d54b09bb$var$split_css_unit(x);
    const [yValue, yUnit] = $6697ff39d54b09bb$var$split_css_unit(y);
    return {
        delay: delay,
        duration: duration,
        easing: easing,
        css: (t, u)=>`
			transform: ${transform} translate(${(1 - t) * xValue}${xUnit}, ${(1 - t) * yValue}${yUnit});
			opacity: ${target_opacity - od * u}`
    };
}
function $6697ff39d54b09bb$var$slide(node, { delay: delay = 0, duration: duration = 400, easing: easing = $6697ff39d54b09bb$export$306ddfe3a8403e2, axis: axis = "y" } = {}) {
    const style = getComputedStyle(node);
    const opacity = +style.opacity;
    const primary_property = axis === "y" ? "height" : "width";
    const primary_property_value = parseFloat(style[primary_property]);
    const secondary_properties = axis === "y" ? [
        "top",
        "bottom"
    ] : [
        "left",
        "right"
    ];
    const capitalized_secondary_properties = secondary_properties.map((e)=>`${e[0].toUpperCase()}${e.slice(1)}`);
    const padding_start_value = parseFloat(style[`padding${capitalized_secondary_properties[0]}`]);
    const padding_end_value = parseFloat(style[`padding${capitalized_secondary_properties[1]}`]);
    const margin_start_value = parseFloat(style[`margin${capitalized_secondary_properties[0]}`]);
    const margin_end_value = parseFloat(style[`margin${capitalized_secondary_properties[1]}`]);
    const border_width_start_value = parseFloat(style[`border${capitalized_secondary_properties[0]}Width`]);
    const border_width_end_value = parseFloat(style[`border${capitalized_secondary_properties[1]}Width`]);
    return {
        delay: delay,
        duration: duration,
        easing: easing,
        css: (t)=>"overflow: hidden;" + `opacity: ${Math.min(t * 20, 1) * opacity};` + `${primary_property}: ${t * primary_property_value}px;` + `padding-${secondary_properties[0]}: ${t * padding_start_value}px;` + `padding-${secondary_properties[1]}: ${t * padding_end_value}px;` + `margin-${secondary_properties[0]}: ${t * margin_start_value}px;` + `margin-${secondary_properties[1]}: ${t * margin_end_value}px;` + `border-${secondary_properties[0]}-width: ${t * border_width_start_value}px;` + `border-${secondary_properties[1]}-width: ${t * border_width_end_value}px;`
    };
}
/* src/views/shared/Modal.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$h(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-7ee2g7", "section.svelte-7ee2g7{top:0;left:0;pointer-events:none;z-index:var(--onboard-modal-z-index, var(--modal-z-index))}.background.svelte-7ee2g7{background:var(--onboard-modal-backdrop, var(--modal-backdrop));pointer-events:all}.full-screen-background.svelte-7ee2g7{width:100vw;height:100vh;height:100dvh}.max-height.svelte-7ee2g7{max-height:calc(100vh - 2rem)}.modal-position.svelte-7ee2g7{top:var(--onboard-modal-top, var(--modal-top));bottom:var(--onboard-modal-bottom, var(--modal-bottom));left:var(--onboard-modal-left, var(--modal-left));right:var(--onboard-modal-right, var(--modal-right))}.modal-overflow.svelte-7ee2g7{overflow:hidden}.modal-styling.svelte-7ee2g7{--border-radius:var(\n      --onboard-modal-border-radius,\n      var(--w3o-border-radius, 1rem)\n    );border-radius:var(--border-radius) var(--border-radius) 0 0;box-shadow:var(--onboard-modal-box-shadow, var(--box-shadow-0));max-width:100vw}.modal.svelte-7ee2g7{overflow-y:auto;background:var(--onboard-modal-background, white);color:var(--onboard-modal-color, initial)}.width-100.svelte-7ee2g7{width:100%}.modal-container-mobile.svelte-7ee2g7{bottom:0}@media all and (min-width: 768px){.modal-styling.svelte-7ee2g7{border-radius:var(--border-radius)}.modal-container-mobile.svelte-7ee2g7{bottom:unset;margin:1rem}.width-100.svelte-7ee2g7{width:unset}}");
}
function $6697ff39d54b09bb$var$create_fragment$h(ctx) {
    let section;
    let div4;
    let div3;
    let div2;
    let div1;
    let div0;
    let section_transition;
    let current;
    let mounted;
    let dispose;
    const default_slot_template = /*#slots*/ ctx[3].default;
    const default_slot = $6697ff39d54b09bb$var$create_slot(default_slot_template, ctx, /*$$scope*/ ctx[2], null);
    return {
        c () {
            section = $6697ff39d54b09bb$export$35e795649ee09318("section");
            div4 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div3 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div2 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if (default_slot) default_slot.c();
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "modal relative svelte-7ee2g7");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "modal-overflow modal-styling relative flex justify-center svelte-7ee2g7");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "style", `${ctx[1] ? "max-width: 100%;" : ""}`);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "class", "flex relative max-height svelte-7ee2g7");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div2, "width-100", /*connectContainerEl*/ ctx[1]);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div3, "class", "modal-container-mobile modal-position flex svelte-7ee2g7");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div3, "absolute", !/*connectContainerEl*/ ctx[1]);
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div3, "width-100", /*connectContainerEl*/ ctx[1]);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div4, "class", "background flex items-center justify-center relative svelte-7ee2g7");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div4, "full-screen-background", !/*connectContainerEl*/ ctx[1]);
            $6697ff39d54b09bb$export$342063e11d6c3cad(section, "class", "svelte-7ee2g7");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(section, "fixed", !/*connectContainerEl*/ ctx[1]);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, section, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(section, div4);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, div3);
            $6697ff39d54b09bb$export$953cecd6e717a553(div3, div2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, div1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, div0);
            if (default_slot) default_slot.m(div0, null);
            current = true;
            if (!mounted) {
                dispose = [
                    $6697ff39d54b09bb$export$ffb5f4729a158638(div2, "click", $6697ff39d54b09bb$export$b4171a6734a65d42(/*click_handler*/ ctx[4])),
                    $6697ff39d54b09bb$export$ffb5f4729a158638(div4, "click", function() {
                        if ($6697ff39d54b09bb$export$dc98b0b04f4c7758(/*close*/ ctx[0])) /*close*/ ctx[0].apply(this, arguments);
                    })
                ];
                mounted = true;
            }
        },
        p (new_ctx, [dirty]) {
            ctx = new_ctx;
            if (default_slot) {
                if (default_slot.p && (!current || dirty & /*$$scope*/ 4)) $6697ff39d54b09bb$var$update_slot_base(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[2], !current ? $6697ff39d54b09bb$var$get_all_dirty_from_scope(/*$$scope*/ ctx[2]) : $6697ff39d54b09bb$var$get_slot_changes(default_slot_template, /*$$scope*/ ctx[2], dirty, null), null);
            }
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(default_slot, local);
            $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(()=>{
                if (!current) return;
                if (!section_transition) section_transition = $6697ff39d54b09bb$export$a9c996f45e5784d0(section, $6697ff39d54b09bb$export$78acf4525d8a74c4, {}, true);
                section_transition.run(1);
            });
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(default_slot, local);
            if (!section_transition) section_transition = $6697ff39d54b09bb$export$a9c996f45e5784d0(section, $6697ff39d54b09bb$export$78acf4525d8a74c4, {}, false);
            section_transition.run(0);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(section);
            if (default_slot) default_slot.d(detaching);
            if (detaching && section_transition) section_transition.end();
            mounted = false;
            $6697ff39d54b09bb$export$61196ced6d74a310(dispose);
        }
    };
}
function $6697ff39d54b09bb$var$instance$h($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    const connectContainerEl = !!$6697ff39d54b09bb$export$c9170ad7d4cd7e57.containerElements.connectModal;
    const html = document.documentElement;
    $6697ff39d54b09bb$var$onMount(()=>{
        if (!connectContainerEl) {
            html.style.position = "sticky";
            html.style.overflow = "hidden";
        }
    });
    $6697ff39d54b09bb$export$ab83b03e4111b1d0(()=>{
        if (!connectContainerEl) {
            html.style.position = "";
            html.style.removeProperty("overflow");
        }
    });
    let { close: close } = $$props;
    function click_handler(event) {
        $6697ff39d54b09bb$export$f38c853ae54ed474.call(this, $$self, event);
    }
    $$self.$$set = ($$props)=>{
        if ("close" in $$props) $$invalidate(0, close = $$props.close);
        if ("$$scope" in $$props) $$invalidate(2, $$scope = $$props.$$scope);
    };
    return [
        close,
        connectContainerEl,
        $$scope,
        slots,
        click_handler
    ];
}
class $6697ff39d54b09bb$export$8743009a87fcb00f extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$h, $6697ff39d54b09bb$var$create_fragment$h, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            close: 0
        }, $6697ff39d54b09bb$var$add_css$h);
    }
}
/* src/views/connect/Agreement.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$g(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-tz7ru1", ".container.svelte-tz7ru1{padding:var(--onboard-spacing-4, var(--spacing-4));font-size:var(--onboard-font-size-6, var(--font-size-6));line-height:24px}input.svelte-tz7ru1{height:1rem;width:1rem;margin-right:0.5rem}");
}
// (43:0) {#if showTermsOfService}
function $6697ff39d54b09bb$var$create_if_block$a(ctx) {
    let div;
    let label;
    let input;
    let t0;
    let span;
    let t1_value = /*$_*/ ctx[1]("connect.selectingWallet.agreement.agree") + "";
    let t1;
    let t2;
    let t3_value = " ";
    let t3;
    let t4;
    let t5;
    let mounted;
    let dispose;
    let if_block0 = /*termsUrl*/ ctx[3] && $6697ff39d54b09bb$var$create_if_block_2$4(ctx);
    let if_block1 = /*privacyUrl*/ ctx[4] && $6697ff39d54b09bb$var$create_if_block_1$5(ctx);
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            label = $6697ff39d54b09bb$export$35e795649ee09318("label");
            input = $6697ff39d54b09bb$export$35e795649ee09318("input");
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            span = $6697ff39d54b09bb$export$35e795649ee09318("span");
            t1 = $6697ff39d54b09bb$export$625550452a3fa3ec(t1_value);
            t2 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            t3 = $6697ff39d54b09bb$export$625550452a3fa3ec(t3_value);
            t4 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block0) if_block0.c();
            t5 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            $6697ff39d54b09bb$export$342063e11d6c3cad(input, "class", " svelte-tz7ru1");
            $6697ff39d54b09bb$export$342063e11d6c3cad(input, "type", "checkbox");
            $6697ff39d54b09bb$export$342063e11d6c3cad(label, "class", "flex");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "container flex items-center svelte-tz7ru1");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div, label);
            $6697ff39d54b09bb$export$953cecd6e717a553(label, input);
            input.checked = /*agreed*/ ctx[0];
            $6697ff39d54b09bb$export$953cecd6e717a553(label, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(label, span);
            $6697ff39d54b09bb$export$953cecd6e717a553(span, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(span, t2);
            $6697ff39d54b09bb$export$953cecd6e717a553(span, t3);
            $6697ff39d54b09bb$export$953cecd6e717a553(span, t4);
            if (if_block0) if_block0.m(span, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(span, t5);
            if (if_block1) if_block1.m(span, null);
            if (!mounted) {
                dispose = $6697ff39d54b09bb$export$ffb5f4729a158638(input, "change", /*input_change_handler*/ ctx[6]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (dirty & /*agreed*/ 1) input.checked = /*agreed*/ ctx[0];
            if (dirty & /*$_*/ 2 && t1_value !== (t1_value = /*$_*/ ctx[1]("connect.selectingWallet.agreement.agree") + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t1, t1_value);
            if (/*termsUrl*/ ctx[3]) if_block0.p(ctx, dirty);
            if (/*privacyUrl*/ ctx[4]) if_block1.p(ctx, dirty);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            mounted = false;
            dispose();
        }
    };
}
// (50:8) {#if termsUrl}
function $6697ff39d54b09bb$var$create_if_block_2$4(ctx) {
    let a;
    let t0_value = /*$_*/ ctx[1]("connect.selectingWallet.agreement.terms") + "";
    let t0;
    let t1_value = /*privacyUrl*/ (ctx[4] ? " " + /*$_*/ ctx[1]("connect.selectingWallet.agreement.and") + " " : ".") + "";
    let t1;
    return {
        c () {
            a = $6697ff39d54b09bb$export$35e795649ee09318("a");
            t0 = $6697ff39d54b09bb$export$625550452a3fa3ec(t0_value);
            t1 = $6697ff39d54b09bb$export$625550452a3fa3ec(t1_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "href", /*termsUrl*/ ctx[3]);
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "target", "_blank");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, a, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(a, t0);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t1, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$_*/ 2 && t0_value !== (t0_value = /*$_*/ ctx[1]("connect.selectingWallet.agreement.terms") + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t0, t0_value);
            if (dirty & /*$_*/ 2 && t1_value !== (t1_value = /*privacyUrl*/ (ctx[4] ? " " + /*$_*/ ctx[1]("connect.selectingWallet.agreement.and") + " " : ".") + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t1, t1_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(a);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t1);
        }
    };
}
// (56:8) {#if privacyUrl}
function $6697ff39d54b09bb$var$create_if_block_1$5(ctx) {
    let a;
    let t0_value = /*$_*/ ctx[1]("connect.selectingWallet.agreement.privacy") + "";
    let t0;
    let t1;
    return {
        c () {
            a = $6697ff39d54b09bb$export$35e795649ee09318("a");
            t0 = $6697ff39d54b09bb$export$625550452a3fa3ec(t0_value);
            t1 = $6697ff39d54b09bb$export$625550452a3fa3ec(".");
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "href", /*privacyUrl*/ ctx[4]);
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "target", "_blank");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, a, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(a, t0);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t1, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$_*/ 2 && t0_value !== (t0_value = /*$_*/ ctx[1]("connect.selectingWallet.agreement.privacy") + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t0, t0_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(a);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t1);
        }
    };
}
function $6697ff39d54b09bb$var$create_fragment$g(ctx) {
    let if_block_anchor;
    let if_block = /*showTermsOfService*/ ctx[5] && $6697ff39d54b09bb$var$create_if_block$a(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
        },
        p (ctx, [dirty]) {
            if (/*showTermsOfService*/ ctx[5]) if_block.p(ctx, dirty);
        },
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
function $6697ff39d54b09bb$var$instance$g($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, (0, $6y4qQ._), ($$value)=>$$invalidate(1, $_ = $$value));
    let { agreed: agreed } = $$props;
    const { terms: termsAgreed, privacy: privacyAgreed, version: versionAgreed } = JSON.parse($6697ff39d54b09bb$var$getLocalStore($6697ff39d54b09bb$var$STORAGE_KEYS.TERMS_AGREEMENT) || "{}");
    const blankAgreement = {
        termsUrl: "",
        privacyUrl: "",
        version: ""
    };
    const appMetadata$ = $6697ff39d54b09bb$export$6559d589eb85fbb6.select("appMetadata").pipe((0, $fy9c8.startWith)($6697ff39d54b09bb$export$6559d589eb85fbb6.get().appMetadata), (0, $hDTQV.shareReplay)(1));
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(7, $appMetadata$ = value));
    const { termsUrl: termsUrl, privacyUrl: privacyUrl, version: version } = $appMetadata$ && $appMetadata$.agreement || blankAgreement;
    const showTermsOfService = !!(termsUrl && !termsAgreed || privacyUrl && !privacyAgreed || version && version !== versionAgreed);
    agreed = !showTermsOfService;
    function input_change_handler() {
        agreed = this.checked;
        $$invalidate(0, agreed);
    }
    $$self.$$set = ($$props)=>{
        if ("agreed" in $$props) $$invalidate(0, agreed = $$props.agreed);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*agreed*/ 1) {
            if (agreed) $6697ff39d54b09bb$var$setLocalStore($6697ff39d54b09bb$var$STORAGE_KEYS.TERMS_AGREEMENT, JSON.stringify({
                version: version,
                terms: !!termsUrl,
                privacy: !!privacyUrl
            }));
            else if (agreed === false) $6697ff39d54b09bb$var$delLocalStore($6697ff39d54b09bb$var$STORAGE_KEYS.TERMS_AGREEMENT);
        }
    };
    return [
        agreed,
        $_,
        appMetadata$,
        termsUrl,
        privacyUrl,
        showTermsOfService,
        input_change_handler
    ];
}
class $6697ff39d54b09bb$var$Agreement extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$g, $6697ff39d54b09bb$var$create_fragment$g, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            agreed: 0
        }, $6697ff39d54b09bb$var$add_css$g);
    }
}
/* src/views/shared/PendingStatusIcon.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$f(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-2btye1", ".icon.svelte-2btye1{color:var(--onboard-white, var(--white));border-radius:50px;bottom:-0.25rem;right:-0.25rem}.yellow.svelte-2btye1{background:var(--onboard-warning-500, var(--warning-500))}");
}
function $6697ff39d54b09bb$var$create_fragment$f(ctx) {
    let div;
    let div_class_value;
    let div_style_value;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", div_class_value = "" + ($6697ff39d54b09bb$export$882b5998b3b9117c(`${ctx[2]} icon flex absolute`) + " svelte-2btye1"));
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "style", div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px; padding: ${ctx[0] / 6}px;`);
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "yellow", /*color*/ ctx[1] === "yellow");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            div.innerHTML = $6697ff39d54b09bb$var$pendingIcon;
        },
        p (ctx, [dirty]) {
            if (dirty & /*className*/ 4 && div_class_value !== (div_class_value = "" + ($6697ff39d54b09bb$export$882b5998b3b9117c(`${ctx[2]} icon flex absolute`) + " svelte-2btye1"))) $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", div_class_value);
            if (dirty & /*size*/ 1 && div_style_value !== (div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px; padding: ${ctx[0] / 6}px;`)) $6697ff39d54b09bb$export$342063e11d6c3cad(div, "style", div_style_value);
            if (dirty & /*className, color*/ 6) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "yellow", /*color*/ ctx[1] === "yellow");
        },
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
        }
    };
}
function $6697ff39d54b09bb$var$instance$f($$self, $$props, $$invalidate) {
    let { size: size } = $$props;
    let { color: color = "yellow" } = $$props;
    let { class: className = "test" } = $$props;
    $$self.$$set = ($$props)=>{
        if ("size" in $$props) $$invalidate(0, size = $$props.size);
        if ("color" in $$props) $$invalidate(1, color = $$props.color);
        if ("class" in $$props) $$invalidate(2, className = $$props.class);
    };
    return [
        size,
        color,
        className
    ];
}
class $6697ff39d54b09bb$var$PendingStatusIcon extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$f, $6697ff39d54b09bb$var$create_fragment$f, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            size: 0,
            color: 1,
            class: 2
        }, $6697ff39d54b09bb$var$add_css$f);
    }
}
/* src/views/shared/SuccessStatusIcon.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$e(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-1bikw7k", ".icon.svelte-1bikw7k{color:var(--onboard-white, var(--white));border-radius:50px}.green.svelte-1bikw7k{background:var(--onboard-success-600, var(--success-600))}.blue.svelte-1bikw7k{background:var(--onboard-primary-1, var(--primary-1))}");
}
function $6697ff39d54b09bb$var$create_fragment$e(ctx) {
    let div;
    let div_style_value;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "icon flex svelte-1bikw7k");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "style", div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px; padding: ${ctx[0] / 5}px;`);
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "green", /*color*/ ctx[1] === "green");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "blue", /*color*/ ctx[1] === "blue");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            div.innerHTML = $6697ff39d54b09bb$var$successIcon;
        },
        p (ctx, [dirty]) {
            if (dirty & /*size*/ 1 && div_style_value !== (div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px; padding: ${ctx[0] / 5}px;`)) $6697ff39d54b09bb$export$342063e11d6c3cad(div, "style", div_style_value);
            if (dirty & /*color*/ 2) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "green", /*color*/ ctx[1] === "green");
            if (dirty & /*color*/ 2) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "blue", /*color*/ ctx[1] === "blue");
        },
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
        }
    };
}
function $6697ff39d54b09bb$var$instance$e($$self, $$props, $$invalidate) {
    let { size: size } = $$props;
    let { color: color = "green" } = $$props;
    $$self.$$set = ($$props)=>{
        if ("size" in $$props) $$invalidate(0, size = $$props.size);
        if ("color" in $$props) $$invalidate(1, color = $$props.color);
    };
    return [
        size,
        color
    ];
}
class $6697ff39d54b09bb$export$db202ddc8be9136 extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$e, $6697ff39d54b09bb$var$create_fragment$e, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            size: 0,
            color: 1
        }, $6697ff39d54b09bb$var$add_css$e);
    }
}
/* src/views/shared/Spinner.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$d(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-1le5672", ".loading-container.svelte-1le5672.svelte-1le5672{font-family:inherit;font-size:inherit;color:inherit}span.svelte-1le5672.svelte-1le5672{font-family:inherit;font-size:0.889em;margin-top:1rem}.loading.svelte-1le5672.svelte-1le5672{display:inline-block}.loading.svelte-1le5672 div.svelte-1le5672{font-size:inherit;display:block;position:absolute;border:3px solid;border-radius:50%;animation:svelte-1le5672-bn-loading 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;border-color:currentColor transparent transparent transparent}.loading.svelte-1le5672 .loading-first.svelte-1le5672{animation-delay:-0.45s}.loading.svelte-1le5672 .loading-second.svelte-1le5672{animation-delay:-0.3s}.loading.svelte-1le5672 .loading-third.svelte-1le5672{animation-delay:-0.15s}@keyframes svelte-1le5672-bn-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}");
}
// (63:2) {#if description}
function $6697ff39d54b09bb$var$create_if_block$9(ctx) {
    let span;
    let t;
    return {
        c () {
            span = $6697ff39d54b09bb$export$35e795649ee09318("span");
            t = $6697ff39d54b09bb$export$625550452a3fa3ec(/*description*/ ctx[0]);
            $6697ff39d54b09bb$export$342063e11d6c3cad(span, "class", "svelte-1le5672");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, span, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(span, t);
        },
        p (ctx, dirty) {
            if (dirty & /*description*/ 1) $6697ff39d54b09bb$export$90a7f3efeed30595(t, /*description*/ ctx[0]);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(span);
        }
    };
}
function $6697ff39d54b09bb$var$create_fragment$d(ctx) {
    let div4;
    let div3;
    let div0;
    let div0_style_value;
    let t0;
    let div1;
    let div1_style_value;
    let t1;
    let div2;
    let div2_style_value;
    let div3_style_value;
    let t2;
    let if_block = /*description*/ ctx[0] && $6697ff39d54b09bb$var$create_if_block$9(ctx);
    return {
        c () {
            div4 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div3 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div2 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t2 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block) if_block.c();
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "loading-first svelte-1le5672");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "style", div0_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "loading-second svelte-1le5672");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "style", div1_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "class", "loading-third svelte-1le5672");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "style", div2_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div3, "class", "loading relative svelte-1le5672");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div3, "style", div3_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div4, "class", "loading-container flex flex-column justify-center items-center absolute svelte-1le5672");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div4, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, div3);
            $6697ff39d54b09bb$export$953cecd6e717a553(div3, div0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div3, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div3, div1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div3, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div3, div2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, t2);
            if (if_block) if_block.m(div4, null);
        },
        p (ctx, [dirty]) {
            if (dirty & /*size*/ 2 && div0_style_value !== (div0_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`)) $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "style", div0_style_value);
            if (dirty & /*size*/ 2 && div1_style_value !== (div1_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`)) $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "style", div1_style_value);
            if (dirty & /*size*/ 2 && div2_style_value !== (div2_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`)) $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "style", div2_style_value);
            if (dirty & /*size*/ 2 && div3_style_value !== (div3_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`)) $6697ff39d54b09bb$export$342063e11d6c3cad(div3, "style", div3_style_value);
            if (/*description*/ ctx[0]) {
                if (if_block) if_block.p(ctx, dirty);
                else {
                    if_block = $6697ff39d54b09bb$var$create_if_block$9(ctx);
                    if_block.c();
                    if_block.m(div4, null);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
        },
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div4);
            if (if_block) if_block.d();
        }
    };
}
function $6697ff39d54b09bb$var$instance$d($$self, $$props, $$invalidate) {
    let { description: description = "" } = $$props;
    let { size: size = "2rem" } = $$props;
    $$self.$$set = ($$props)=>{
        if ("description" in $$props) $$invalidate(0, description = $$props.description);
        if ("size" in $$props) $$invalidate(1, size = $$props.size);
    };
    return [
        description,
        size
    ];
}
class $6697ff39d54b09bb$var$Spinner extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$d, $6697ff39d54b09bb$var$create_fragment$d, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            description: 0,
            size: 1
        }, $6697ff39d54b09bb$var$add_css$d);
    }
}
/* src/views/shared/WalletAppBadge.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$c(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-i129jl", ".icon.svelte-i129jl{height:100%}.border-custom.svelte-i129jl{border:1px solid var(--border-color)}.border-yellow.svelte-i129jl{border:1px solid var(--onboard-warning-500, var(--warning-500))}.border-gray.svelte-i129jl{border:1px solid var(--onboard-gray-400, var(--gray-400))}.border-green.svelte-i129jl{border:1px solid var(--onboard-success-500, var(--success-500))}.border-dark-green.svelte-i129jl{border:1px solid var(--onboard-success-700, var(--success-700))}.border-blue.svelte-i129jl{border:1px solid\n      var(\n        --onboard-wallet-app-icon-border-color,\n        var(--onboard-primary-300, var(--primary-300))\n      )}.border-dark-blue.svelte-i129jl{border:1px solid\n      var(\n        --onboard-wallet-app-icon-border-color,\n        var(--onboard-primary-600, var(--primary-600))\n      )}.border-transparent.svelte-i129jl{border:1px solid transparent}.border-black.svelte-i129jl{border:1px solid var(--onboard-gray-600, var(--gray-600))}.background-gray.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-gray,\n      var(--onboard-gray-500, var(--gray-500))\n    )}.background-light-gray.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-light-gray,\n      var(--onboard-gray-100, var(--gray-100))\n    )}.background-light-blue.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-light-blue,\n      var(--onboard-primary-100, var(--primary-100))\n    )}.background-green.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-green,\n      var(--onboard-success-100, var(--success-100))\n    )}.background-white.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-white,\n      var(--onboard-white, var(--white))\n    )}.background-transparent.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-transparent,\n      transparent\n    )}@keyframes svelte-i129jl-pulse{from{opacity:0}to{opacity:1}}.placeholder-icon.svelte-i129jl{width:100%;height:100%;background:var(--onboard-gray-100, var(--gray-100));border-radius:32px;animation:svelte-i129jl-pulse infinite 750ms alternate ease-in-out}.spinner-container.svelte-i129jl{color:var(--onboard-primary-300, var(--primary-300))}img.svelte-i129jl{max-width:100%;height:auto}.pending-status-icon{z-index:1;fill:white;box-shadow:0px 2px 12px 0px rgba(0, 0, 0, 0.1)}.status-icon-container.svelte-i129jl{right:-0.25rem;bottom:-0.25rem;position:absolute}");
}
const $6697ff39d54b09bb$var$get_status_slot_changes = (dirty)=>({});
const $6697ff39d54b09bb$var$get_status_slot_context = (ctx)=>({});
// (178:2) {:else}
function $6697ff39d54b09bb$var$create_else_block$4(ctx) {
    let await_block_anchor;
    let promise;
    let current;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $6697ff39d54b09bb$var$create_pending_block$1,
        then: $6697ff39d54b09bb$var$create_then_block$1,
        catch: $6697ff39d54b09bb$var$create_catch_block$1,
        value: 13,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $6697ff39d54b09bb$export$71511d61b312f219(promise = /*icon*/ ctx[1], info);
    return {
        c () {
            await_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
            info.block.c();
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, await_block_anchor, anchor);
            info.block.m(target, info.anchor = anchor);
            info.mount = ()=>await_block_anchor.parentNode;
            info.anchor = await_block_anchor;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            info.ctx = ctx;
            if (dirty & /*icon*/ 2 && promise !== (promise = /*icon*/ ctx[1]) && $6697ff39d54b09bb$export$71511d61b312f219(promise, info)) ;
            else $6697ff39d54b09bb$export$3d8c2f653ac9d0b9(info, ctx, dirty);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $6697ff39d54b09bb$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(await_block_anchor);
            info.block.d(detaching);
            info.token = null;
            info = null;
        }
    };
}
// (174:2) {#if loading && windowWidth >= MOBILE_WINDOW_WIDTH}
function $6697ff39d54b09bb$var$create_if_block$8(ctx) {
    let div;
    let spinner;
    let current;
    spinner = new $6697ff39d54b09bb$var$Spinner({
        props: {
            size: "2rem"
        }
    });
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(spinner.$$.fragment);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "spinner-container svelte-i129jl");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            $6697ff39d54b09bb$export$9bb611d729802a56(spinner, div, null);
            current = true;
        },
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(spinner.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(spinner.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            $6697ff39d54b09bb$export$3466f893ebf79586(spinner);
        }
    };
}
// (1:0) <script lang="ts">import { fade }
function $6697ff39d54b09bb$var$create_catch_block$1(ctx) {
    return {
        c: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        m: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5
    };
}
// (181:4) {:then iconLoaded}
function $6697ff39d54b09bb$var$create_then_block$1(ctx) {
    let div;
    let show_if;
    let div_intro;
    let t;
    let if_block1_anchor;
    let current;
    function select_block_type_1(ctx, dirty) {
        if (dirty & /*icon*/ 2) show_if = null;
        if (show_if == null) show_if = !!$6697ff39d54b09bb$export$34aec0b863436764(/*iconLoaded*/ ctx[13]);
        if (show_if) return $6697ff39d54b09bb$var$create_if_block_2$3;
        return $6697ff39d54b09bb$var$create_else_block_1$2;
    }
    let current_block_type = select_block_type_1(ctx, -1);
    let if_block0 = current_block_type(ctx);
    let if_block1 = /*loading*/ ctx[2] && /*windowWidth*/ ctx[9] <= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH && $6697ff39d54b09bb$var$create_if_block_1$4();
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if_block0.c();
            t = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            if_block1_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "icon flex justify-center items-center svelte-i129jl");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            if_block0.m(div, null);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t, anchor);
            if (if_block1) if_block1.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block0) if_block0.p(ctx, dirty);
            else {
                if_block0.d(1);
                if_block0 = current_block_type(ctx);
                if (if_block0) {
                    if_block0.c();
                    if_block0.m(div, null);
                }
            }
            if (/*loading*/ ctx[2] && /*windowWidth*/ ctx[9] <= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH) {
                if (if_block1) {
                    if (dirty & /*loading, windowWidth*/ 516) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block1, 1);
                } else {
                    if_block1 = $6697ff39d54b09bb$var$create_if_block_1$4();
                    if_block1.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block1, 1);
                    if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
                }
            } else if (if_block1) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
        },
        i (local) {
            if (current) return;
            if (local) {
                if (!div_intro) $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(()=>{
                    div_intro = $6697ff39d54b09bb$export$e7c866399fa523f5(div, $6697ff39d54b09bb$export$78acf4525d8a74c4, {});
                    div_intro.start();
                });
            }
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block1);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block1);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            if_block0.d();
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t);
            if (if_block1) if_block1.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block1_anchor);
        }
    };
}
// (186:8) {:else}
function $6697ff39d54b09bb$var$create_else_block_1$2(ctx) {
    let img;
    let img_src_value;
    return {
        c () {
            img = $6697ff39d54b09bb$export$35e795649ee09318("img");
            if (!$6697ff39d54b09bb$export$3c2fa207a37baaea(img.src, img_src_value = /*iconLoaded*/ ctx[13])) $6697ff39d54b09bb$export$342063e11d6c3cad(img, "src", img_src_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(img, "alt", "logo");
            $6697ff39d54b09bb$export$342063e11d6c3cad(img, "class", "svelte-i129jl");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, img, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*icon*/ 2 && !$6697ff39d54b09bb$export$3c2fa207a37baaea(img.src, img_src_value = /*iconLoaded*/ ctx[13])) $6697ff39d54b09bb$export$342063e11d6c3cad(img, "src", img_src_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(img);
        }
    };
}
// (183:8) {#if isSVG(iconLoaded)}
function $6697ff39d54b09bb$var$create_if_block_2$3(ctx) {
    let html_tag;
    let raw_value = /*iconLoaded*/ ctx[13] + "";
    let html_anchor;
    return {
        c () {
            html_tag = new $6697ff39d54b09bb$export$ce26c07117d59d6a(false);
            html_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m(raw_value, target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*icon*/ 2 && raw_value !== (raw_value = /*iconLoaded*/ ctx[13] + "")) html_tag.p(raw_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (191:6) {#if loading && windowWidth <= MOBILE_WINDOW_WIDTH}
function $6697ff39d54b09bb$var$create_if_block_1$4(ctx) {
    let div;
    let pendingstatusicon;
    let current;
    pendingstatusicon = new $6697ff39d54b09bb$var$PendingStatusIcon({
        props: {
            class: "pending-status-icon",
            size: 20
        }
    });
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(pendingstatusicon.$$.fragment);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "status-icon-container svelte-i129jl");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            $6697ff39d54b09bb$export$9bb611d729802a56(pendingstatusicon, div, null);
            current = true;
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(pendingstatusicon.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(pendingstatusicon.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            $6697ff39d54b09bb$export$3466f893ebf79586(pendingstatusicon);
        }
    };
}
// (179:17)        <div class="placeholder-icon" />     {:then iconLoaded}
function $6697ff39d54b09bb$var$create_pending_block$1(ctx) {
    let div;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "placeholder-icon svelte-i129jl");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
        },
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
        }
    };
}
function $6697ff39d54b09bb$var$create_fragment$c(ctx) {
    let div;
    let current_block_type_index;
    let if_block;
    let t;
    let div_style_value;
    let current;
    let mounted;
    let dispose;
    $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[12]);
    const if_block_creators = [
        $6697ff39d54b09bb$var$create_if_block$8,
        $6697ff39d54b09bb$var$create_else_block$4
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (/*loading*/ ctx[2] && /*windowWidth*/ ctx[9] >= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH) return 0;
        return 1;
    }
    current_block_type_index = select_block_type(ctx);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    const status_slot_template = /*#slots*/ ctx[11].status;
    const status_slot = $6697ff39d54b09bb$var$create_slot(status_slot_template, ctx, /*$$scope*/ ctx[10], $6697ff39d54b09bb$var$get_status_slot_context);
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if_block.c();
            t = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (status_slot) status_slot.c();
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "relative svelte-i129jl");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "style", div_style_value = `${ctx[6] === "custom" ? `background-color: ${ctx[7]}` : ""}; padding: ${ctx[3] - 1}px; width: ${ctx[0]}px; height: ${ctx[0]}px; border-radius: ${ctx[8]}px; color: ${ctx[4]};`);
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-custom", /*border*/ ctx[5] === "custom");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-yellow", /*border*/ ctx[5] === "yellow");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-gray", /*border*/ ctx[5] === "gray");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-green", /*border*/ ctx[5] === "green");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-dark-green", /*border*/ ctx[5] === "darkGreen");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-blue", /*border*/ ctx[5] === "blue");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-dark-blue", /*border*/ ctx[5] === "darkBlue");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-transparent", /*border*/ ctx[5] === "transparent");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-black", /*border*/ ctx[5] === "black");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "background-gray", /*background*/ ctx[6] === "gray");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "background-light-gray", /*background*/ ctx[6] === "lightGray");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "background-light-blue", /*background*/ ctx[6] === "lightBlue");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "background-green", /*background*/ ctx[6] === "green");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "background-white", /*background*/ ctx[6] === "white");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "background-transparent", /*background*/ ctx[6] === "transparent");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            if_blocks[current_block_type_index].m(div, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div, t);
            if (status_slot) status_slot.m(div, null);
            current = true;
            if (!mounted) {
                dispose = $6697ff39d54b09bb$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[12]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type(ctx);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block, 1);
                if_block.m(div, t);
            }
            if (status_slot) {
                if (status_slot.p && (!current || dirty & /*$$scope*/ 1024)) $6697ff39d54b09bb$var$update_slot_base(status_slot, status_slot_template, ctx, /*$$scope*/ ctx[10], !current ? $6697ff39d54b09bb$var$get_all_dirty_from_scope(/*$$scope*/ ctx[10]) : $6697ff39d54b09bb$var$get_slot_changes(status_slot_template, /*$$scope*/ ctx[10], dirty, $6697ff39d54b09bb$var$get_status_slot_changes), $6697ff39d54b09bb$var$get_status_slot_context);
            }
            if (!current || dirty & /*background, customBackgroundColor, padding, size, radius, color*/ 473 && div_style_value !== (div_style_value = `${ctx[6] === "custom" ? `background-color: ${ctx[7]}` : ""}; padding: ${ctx[3] - 1}px; width: ${ctx[0]}px; height: ${ctx[0]}px; border-radius: ${ctx[8]}px; color: ${ctx[4]};`)) $6697ff39d54b09bb$export$342063e11d6c3cad(div, "style", div_style_value);
            if (!current || dirty & /*border*/ 32) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-custom", /*border*/ ctx[5] === "custom");
            if (!current || dirty & /*border*/ 32) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-yellow", /*border*/ ctx[5] === "yellow");
            if (!current || dirty & /*border*/ 32) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-gray", /*border*/ ctx[5] === "gray");
            if (!current || dirty & /*border*/ 32) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-green", /*border*/ ctx[5] === "green");
            if (!current || dirty & /*border*/ 32) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-dark-green", /*border*/ ctx[5] === "darkGreen");
            if (!current || dirty & /*border*/ 32) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-blue", /*border*/ ctx[5] === "blue");
            if (!current || dirty & /*border*/ 32) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-dark-blue", /*border*/ ctx[5] === "darkBlue");
            if (!current || dirty & /*border*/ 32) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-transparent", /*border*/ ctx[5] === "transparent");
            if (!current || dirty & /*border*/ 32) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "border-black", /*border*/ ctx[5] === "black");
            if (!current || dirty & /*background*/ 64) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "background-gray", /*background*/ ctx[6] === "gray");
            if (!current || dirty & /*background*/ 64) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "background-light-gray", /*background*/ ctx[6] === "lightGray");
            if (!current || dirty & /*background*/ 64) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "background-light-blue", /*background*/ ctx[6] === "lightBlue");
            if (!current || dirty & /*background*/ 64) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "background-green", /*background*/ ctx[6] === "green");
            if (!current || dirty & /*background*/ 64) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "background-white", /*background*/ ctx[6] === "white");
            if (!current || dirty & /*background*/ 64) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "background-transparent", /*background*/ ctx[6] === "transparent");
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(status_slot, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block);
            $6697ff39d54b09bb$export$ebd11618f299a286(status_slot, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            if_blocks[current_block_type_index].d();
            if (status_slot) status_slot.d(detaching);
            mounted = false;
            dispose();
        }
    };
}
function $6697ff39d54b09bb$var$instance$c($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    let { size: size } = $$props;
    let { icon: icon } = $$props;
    let { loading: loading = false } = $$props;
    let { padding: padding = size / 6 } = $$props;
    let { color: color = "black" } = $$props;
    let { border: border = "transparent" } = $$props;
    let { background: background = "transparent" } = $$props;
    let { customBackgroundColor: customBackgroundColor = "" } = $$props;
    let { radius: radius = 12 } = $$props;
    let windowWidth;
    function onwindowresize() {
        $$invalidate(9, windowWidth = window.innerWidth);
    }
    $$self.$$set = ($$props)=>{
        if ("size" in $$props) $$invalidate(0, size = $$props.size);
        if ("icon" in $$props) $$invalidate(1, icon = $$props.icon);
        if ("loading" in $$props) $$invalidate(2, loading = $$props.loading);
        if ("padding" in $$props) $$invalidate(3, padding = $$props.padding);
        if ("color" in $$props) $$invalidate(4, color = $$props.color);
        if ("border" in $$props) $$invalidate(5, border = $$props.border);
        if ("background" in $$props) $$invalidate(6, background = $$props.background);
        if ("customBackgroundColor" in $$props) $$invalidate(7, customBackgroundColor = $$props.customBackgroundColor);
        if ("radius" in $$props) $$invalidate(8, radius = $$props.radius);
        if ("$$scope" in $$props) $$invalidate(10, $$scope = $$props.$$scope);
    };
    return [
        size,
        icon,
        loading,
        padding,
        color,
        border,
        background,
        customBackgroundColor,
        radius,
        windowWidth,
        $$scope,
        slots,
        onwindowresize
    ];
}
class $6697ff39d54b09bb$export$71cec2538cb2c617 extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$c, $6697ff39d54b09bb$var$create_fragment$c, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            size: 0,
            icon: 1,
            loading: 2,
            padding: 3,
            color: 4,
            border: 5,
            background: 6,
            customBackgroundColor: 7,
            radius: 8
        }, $6697ff39d54b09bb$var$add_css$c);
    }
}
/* src/views/shared/Warning.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$b(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-q2gson", ".container.svelte-q2gson{gap:1rem;padding:0.75rem;color:var(--onboard-warning-700, var(--warning-700));font-size:var(--onboard-font-size-7, var(--font-size-7));line-height:16px;border:1px solid var(--onboard-warning-400, var(--warning-400));background:var(--onboard-warning-100, var(--warning-100));border-radius:12px}.icon.svelte-q2gson{color:var(--onboard-warning-700, var(--warning-700));width:1rem;height:1rem;flex:0 0 auto}");
}
function $6697ff39d54b09bb$var$create_fragment$b(ctx) {
    let div2;
    let div0;
    let t;
    let div1;
    let div2_intro;
    let current;
    const default_slot_template = /*#slots*/ ctx[1].default;
    const default_slot = $6697ff39d54b09bb$var$create_slot(default_slot_template, ctx, /*$$scope*/ ctx[0], null);
    return {
        c () {
            div2 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if (default_slot) default_slot.c();
            t = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "icon svelte-q2gson");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "class", "container flex justify-between svelte-q2gson");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div2, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, div0);
            if (default_slot) default_slot.m(div0, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, t);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, div1);
            div1.innerHTML = $6697ff39d54b09bb$var$infoIcon;
            current = true;
        },
        p (ctx, [dirty]) {
            if (default_slot) {
                if (default_slot.p && (!current || dirty & /*$$scope*/ 1)) $6697ff39d54b09bb$var$update_slot_base(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[0], !current ? $6697ff39d54b09bb$var$get_all_dirty_from_scope(/*$$scope*/ ctx[0]) : $6697ff39d54b09bb$var$get_slot_changes(default_slot_template, /*$$scope*/ ctx[0], dirty, null), null);
            }
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(default_slot, local);
            if (local) {
                if (!div2_intro) $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(()=>{
                    div2_intro = $6697ff39d54b09bb$export$e7c866399fa523f5(div2, $6697ff39d54b09bb$var$slide, {
                        delay: 50,
                        duration: 500
                    });
                    div2_intro.start();
                });
            }
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(default_slot, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div2);
            if (default_slot) default_slot.d(detaching);
        }
    };
}
function $6697ff39d54b09bb$var$instance$b($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    $$self.$$set = ($$props)=>{
        if ("$$scope" in $$props) $$invalidate(0, $$scope = $$props.$$scope);
    };
    return [
        $$scope,
        slots
    ];
}
class $6697ff39d54b09bb$var$Warning extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$b, $6697ff39d54b09bb$var$create_fragment$b, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {}, $6697ff39d54b09bb$var$add_css$b);
    }
}
/* src/views/connect/ConnectedWallet.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$a(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-1kfgpsl", ".container.svelte-1kfgpsl{padding:var(--onboard-spacing-4, var(--spacing-4));color:var(\n      --onboard-connect-accent-text-color,\n      var(--onboard-gray-700, var(--gray-700))\n    )}.connecting-container.svelte-1kfgpsl{padding:var(--onboard-spacing-4, var(--spacing-4));border-radius:var(--onboard-border-radius-1, var(--border-radius-1));background:var(--onboard-success-100, var(--success-100));border:1px solid var(--onboard-success-600, var(--success-600));width:100%}.text.svelte-1kfgpsl{right:var(--onboard-spacing-5, var(--spacing-5))}.tick.svelte-1kfgpsl{color:var(--onboard-success-700, var(--success-700))}");
}
function $6697ff39d54b09bb$var$create_fragment$a(ctx) {
    let div7;
    let div6;
    let div4;
    let div2;
    let walletappbadge0;
    let t0;
    let div0;
    let successstatusicon;
    let t1;
    let div1;
    let walletappbadge1;
    let t2;
    let div3;
    let t3_value = /*$_*/ ctx[2]("connect.connectedWallet.mainText", {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.connectedWallet.mainText,
        values: {
            wallet: /*selectedWallet*/ ctx[0].label
        }
    }) + "";
    let t3;
    let t4;
    let div5;
    let current;
    walletappbadge0 = new $6697ff39d54b09bb$export$71cec2538cb2c617({
        props: {
            size: 40,
            padding: 8,
            background: /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].icon ? "lightBlue" : "lightGray",
            border: "darkGreen",
            icon: /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].icon || $6697ff39d54b09bb$export$f787f51d84a910ad
        }
    });
    successstatusicon = new $6697ff39d54b09bb$export$db202ddc8be9136({
        props: {
            size: 17
        }
    });
    walletappbadge1 = new $6697ff39d54b09bb$export$71cec2538cb2c617({
        props: {
            size: 40,
            padding: 8,
            border: "darkGreen",
            background: "white",
            icon: /*selectedWallet*/ ctx[0].icon
        }
    });
    return {
        c () {
            div7 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div6 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div4 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div2 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(walletappbadge0.$$.fragment);
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(successstatusicon.$$.fragment);
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(walletappbadge1.$$.fragment);
            t2 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div3 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t3 = $6697ff39d54b09bb$export$625550452a3fa3ec(t3_value);
            t4 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div5 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "relative");
            $6697ff39d54b09bb$export$971d5caa766a69d7(div0, "right", "1rem");
            $6697ff39d54b09bb$export$971d5caa766a69d7(div0, "top", "4px");
            $6697ff39d54b09bb$export$971d5caa766a69d7(div0, "z-index", "1");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "relative");
            $6697ff39d54b09bb$export$971d5caa766a69d7(div1, "right", "1.75rem");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "class", "flex justify-center items-end relative");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div3, "class", "text relative svelte-1kfgpsl");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div4, "class", "flex items-center");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div5, "class", "tick flex items-center svelte-1kfgpsl");
            $6697ff39d54b09bb$export$971d5caa766a69d7(div5, "width", "24px");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div6, "class", "connecting-container flex justify-between items-center svelte-1kfgpsl");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div7, "class", "container svelte-1kfgpsl");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div7, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div7, div6);
            $6697ff39d54b09bb$export$953cecd6e717a553(div6, div4);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, div2);
            $6697ff39d54b09bb$export$9bb611d729802a56(walletappbadge0, div2, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, div0);
            $6697ff39d54b09bb$export$9bb611d729802a56(successstatusicon, div0, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, div1);
            $6697ff39d54b09bb$export$9bb611d729802a56(walletappbadge1, div1, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, t2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, div3);
            $6697ff39d54b09bb$export$953cecd6e717a553(div3, t3);
            $6697ff39d54b09bb$export$953cecd6e717a553(div6, t4);
            $6697ff39d54b09bb$export$953cecd6e717a553(div6, div5);
            div5.innerHTML = $6697ff39d54b09bb$var$successIcon;
            current = true;
        },
        p (ctx, [dirty]) {
            const walletappbadge0_changes = {};
            if (dirty & /*$appMetadata$*/ 2) walletappbadge0_changes.background = /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].icon ? "lightBlue" : "lightGray";
            if (dirty & /*$appMetadata$*/ 2) walletappbadge0_changes.icon = /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].icon || $6697ff39d54b09bb$export$f787f51d84a910ad;
            walletappbadge0.$set(walletappbadge0_changes);
            const walletappbadge1_changes = {};
            if (dirty & /*selectedWallet*/ 1) walletappbadge1_changes.icon = /*selectedWallet*/ ctx[0].icon;
            walletappbadge1.$set(walletappbadge1_changes);
            if ((!current || dirty & /*$_, selectedWallet*/ 5) && t3_value !== (t3_value = /*$_*/ ctx[2]("connect.connectedWallet.mainText", {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.connectedWallet.mainText,
                values: {
                    wallet: /*selectedWallet*/ ctx[0].label
                }
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t3, t3_value);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(walletappbadge0.$$.fragment, local);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(successstatusicon.$$.fragment, local);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(walletappbadge1.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(walletappbadge0.$$.fragment, local);
            $6697ff39d54b09bb$export$ebd11618f299a286(successstatusicon.$$.fragment, local);
            $6697ff39d54b09bb$export$ebd11618f299a286(walletappbadge1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div7);
            $6697ff39d54b09bb$export$3466f893ebf79586(walletappbadge0);
            $6697ff39d54b09bb$export$3466f893ebf79586(successstatusicon);
            $6697ff39d54b09bb$export$3466f893ebf79586(walletappbadge1);
        }
    };
}
function $6697ff39d54b09bb$var$instance$a($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, (0, $6y4qQ._), ($$value)=>$$invalidate(2, $_ = $$value));
    let { selectedWallet: selectedWallet } = $$props;
    const appMetadata$ = $6697ff39d54b09bb$export$6559d589eb85fbb6.select("appMetadata").pipe((0, $fy9c8.startWith)($6697ff39d54b09bb$export$6559d589eb85fbb6.get().appMetadata), (0, $hDTQV.shareReplay)(1));
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(1, $appMetadata$ = value));
    $$self.$$set = ($$props)=>{
        if ("selectedWallet" in $$props) $$invalidate(0, selectedWallet = $$props.selectedWallet);
    };
    return [
        selectedWallet,
        $appMetadata$,
        $_,
        appMetadata$
    ];
}
class $6697ff39d54b09bb$var$ConnectedWallet extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$a, $6697ff39d54b09bb$var$create_fragment$a, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            selectedWallet: 0
        }, $6697ff39d54b09bb$var$add_css$a);
    }
}
/* src/views/connect/ConnectingWallet.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$9(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-j1ywa3", ".container.svelte-j1ywa3{padding:var(--onboard-spacing-4, var(--spacing-4))}.connecting-container.svelte-j1ywa3{width:100%;padding:var(--onboard-spacing-4, var(--spacing-4));transition:background-color 100ms ease-in-out,\n      border-color 100ms ease-in-out;border-radius:24px;background:var(--onboard-primary-100, var(--primary-100));border:1px solid;border-color:var(--onboard-primary-300, var(--primary-300));color:var(--onboard-gray-600, var(--gray-600))}.connecting-container.warning.svelte-j1ywa3{background:var(--onboard-warning-100, var(--warning-100));border-color:var(--onboard-warning-400, var(--warning-400))}.text.svelte-j1ywa3{line-height:16px;margin-bottom:var(--onboard-spacing-5, var(--spacing-5))}.text.text-rejected.svelte-j1ywa3{line-height:24px;margin-bottom:0}.subtext.svelte-j1ywa3{font-size:var(--onboard-font-size-7, var(--font-size-7));line-height:16px}.rejected-cta.svelte-j1ywa3{color:var(--onboard-primary-500, var(--primary-500))}.onboard-button-primary.svelte-j1ywa3{bottom:var(--onboard-spacing-3, var(--spacing-3))}.ml.svelte-j1ywa3{margin-left:var(--onboard-spacing-4, var(--spacing-4))}@media all and (max-width: 520px){.connecting-container.svelte-j1ywa3{border-radius:var(--onboard-border-radius-4, var(--border-radius-4))}.container.svelte-j1ywa3{padding-bottom:0}.wallet-badges.svelte-j1ywa3{display:none}.connecting-wallet-info.svelte-j1ywa3{margin:0}.onboard-button-primary.svelte-j1ywa3{display:none}}");
}
// (141:8) {:else}
function $6697ff39d54b09bb$var$create_else_block$3(ctx) {
    let div;
    let t_value = /*$_*/ ctx[7](`connect.connectingWallet.${ctx[5] ? "previousConnection" : "paragraph"}`, {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.connectingWallet.paragraph,
        values: {
            wallet: /*selectedWallet*/ ctx[1].label
        }
    }) + "";
    let t;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t = $6697ff39d54b09bb$export$625550452a3fa3ec(t_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "subtext svelte-j1ywa3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div, t);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, previousConnectionRequest, selectedWallet*/ 162 && t_value !== (t_value = /*$_*/ ctx[7](`connect.connectingWallet.${ctx[5] ? "previousConnection" : "paragraph"}`, {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.connectingWallet.paragraph,
                values: {
                    wallet: /*selectedWallet*/ ctx[1].label
                }
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
        }
    };
}
// (134:8) {#if connectionRejected}
function $6697ff39d54b09bb$var$create_if_block$7(ctx) {
    let div;
    let t_value = /*$_*/ ctx[7]("connect.connectingWallet.rejectedCTA", {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.connectingWallet.rejectedCTA,
        values: {
            wallet: /*selectedWallet*/ ctx[1].label
        }
    }) + "";
    let t;
    let mounted;
    let dispose;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t = $6697ff39d54b09bb$export$625550452a3fa3ec(t_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "rejected-cta pointer subtext svelte-j1ywa3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div, t);
            if (!mounted) {
                dispose = $6697ff39d54b09bb$export$ffb5f4729a158638(div, "click", function() {
                    if ($6697ff39d54b09bb$export$dc98b0b04f4c7758(/*connectWallet*/ ctx[0])) /*connectWallet*/ ctx[0].apply(this, arguments);
                });
                mounted = true;
            }
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty & /*$_, selectedWallet*/ 130 && t_value !== (t_value = /*$_*/ ctx[7]("connect.connectingWallet.rejectedCTA", {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.connectingWallet.rejectedCTA,
                values: {
                    wallet: /*selectedWallet*/ ctx[1].label
                }
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            mounted = false;
            dispose();
        }
    };
}
function $6697ff39d54b09bb$var$create_fragment$9(ctx) {
    let div6;
    let div5;
    let div4;
    let div1;
    let walletappbadge0;
    let t0;
    let div0;
    let walletappbadge1;
    let t1;
    let div3;
    let div2;
    let t2_value = /*$_*/ ctx[7](`connect.connectingWallet.${ctx[4] ? "rejectedText" : "mainText"}`, {
        default: /*connectionRejected*/ ctx[4] ? $6697ff39d54b09bb$export$e7094788287c5e9b.connect.connectingWallet.rejectedText : $6697ff39d54b09bb$export$e7094788287c5e9b.connect.connectingWallet.mainText,
        values: {
            wallet: /*selectedWallet*/ ctx[1].label
        }
    }) + "";
    let t2;
    let t3;
    let t4;
    let button;
    let t5_value = /*$_*/ ctx[7]("connect.connectingWallet.primaryButton", {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.connectingWallet.primaryButton
    }) + "";
    let t5;
    let current;
    let mounted;
    let dispose;
    walletappbadge0 = new $6697ff39d54b09bb$export$71cec2538cb2c617({
        props: {
            size: 40,
            padding: 8,
            icon: /*$appMetadata$*/ ctx[6] && /*$appMetadata$*/ ctx[6].icon || $6697ff39d54b09bb$export$f787f51d84a910ad,
            border: /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5] ? "yellow" : "blue",
            background: "lightGray"
        }
    });
    walletappbadge1 = new $6697ff39d54b09bb$export$71cec2538cb2c617({
        props: {
            size: 40,
            padding: 8,
            border: /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5] ? "yellow" : "blue",
            background: "white",
            icon: /*selectedWallet*/ ctx[1].icon
        }
    });
    function select_block_type(ctx, dirty) {
        if (/*connectionRejected*/ ctx[4]) return $6697ff39d54b09bb$var$create_if_block$7;
        return $6697ff39d54b09bb$var$create_else_block$3;
    }
    let current_block_type = select_block_type(ctx);
    let if_block = current_block_type(ctx);
    return {
        c () {
            div6 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div5 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div4 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(walletappbadge0.$$.fragment);
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(walletappbadge1.$$.fragment);
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div3 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div2 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t2 = $6697ff39d54b09bb$export$625550452a3fa3ec(t2_value);
            t3 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if_block.c();
            t4 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            button = $6697ff39d54b09bb$export$35e795649ee09318("button");
            t5 = $6697ff39d54b09bb$export$625550452a3fa3ec(t5_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "relative");
            $6697ff39d54b09bb$export$971d5caa766a69d7(div0, "right", "0.5rem");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "flex justify-center relative wallet-badges svelte-j1ywa3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "class", "text svelte-j1ywa3");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div2, "text-rejected", /*connectionRejected*/ ctx[4]);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div3, "class", "flex flex-column justify-center ml connecting-wallet-info svelte-j1ywa3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div4, "class", "flex");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div5, "class", "connecting-container flex justify-between items-center svelte-j1ywa3");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div5, "warning", /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5]);
            $6697ff39d54b09bb$export$342063e11d6c3cad(button, "class", "onboard-button-primary absolute svelte-j1ywa3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div6, "class", "container flex flex-column items-center svelte-j1ywa3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div6, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div6, div5);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, div4);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, div1);
            $6697ff39d54b09bb$export$9bb611d729802a56(walletappbadge0, div1, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, div0);
            $6697ff39d54b09bb$export$9bb611d729802a56(walletappbadge1, div0, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, div3);
            $6697ff39d54b09bb$export$953cecd6e717a553(div3, div2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, t2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div3, t3);
            if_block.m(div3, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div6, t4);
            $6697ff39d54b09bb$export$953cecd6e717a553(div6, button);
            $6697ff39d54b09bb$export$953cecd6e717a553(button, t5);
            current = true;
            if (!mounted) {
                dispose = $6697ff39d54b09bb$export$ffb5f4729a158638(button, "click", /*click_handler*/ ctx[9]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            const walletappbadge0_changes = {};
            if (dirty & /*$appMetadata$*/ 64) walletappbadge0_changes.icon = /*$appMetadata$*/ ctx[6] && /*$appMetadata$*/ ctx[6].icon || $6697ff39d54b09bb$export$f787f51d84a910ad;
            if (dirty & /*connectionRejected, previousConnectionRequest*/ 48) walletappbadge0_changes.border = /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5] ? "yellow" : "blue";
            walletappbadge0.$set(walletappbadge0_changes);
            const walletappbadge1_changes = {};
            if (dirty & /*connectionRejected, previousConnectionRequest*/ 48) walletappbadge1_changes.border = /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5] ? "yellow" : "blue";
            if (dirty & /*selectedWallet*/ 2) walletappbadge1_changes.icon = /*selectedWallet*/ ctx[1].icon;
            walletappbadge1.$set(walletappbadge1_changes);
            if ((!current || dirty & /*$_, connectionRejected, selectedWallet*/ 146) && t2_value !== (t2_value = /*$_*/ ctx[7](`connect.connectingWallet.${ctx[4] ? "rejectedText" : "mainText"}`, {
                default: /*connectionRejected*/ ctx[4] ? $6697ff39d54b09bb$export$e7094788287c5e9b.connect.connectingWallet.rejectedText : $6697ff39d54b09bb$export$e7094788287c5e9b.connect.connectingWallet.mainText,
                values: {
                    wallet: /*selectedWallet*/ ctx[1].label
                }
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t2, t2_value);
            if (!current || dirty & /*connectionRejected*/ 16) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div2, "text-rejected", /*connectionRejected*/ ctx[4]);
            if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(div3, null);
                }
            }
            if (!current || dirty & /*connectionRejected, previousConnectionRequest*/ 48) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div5, "warning", /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5]);
            if ((!current || dirty & /*$_*/ 128) && t5_value !== (t5_value = /*$_*/ ctx[7]("connect.connectingWallet.primaryButton", {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.connectingWallet.primaryButton
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t5, t5_value);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(walletappbadge0.$$.fragment, local);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(walletappbadge1.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(walletappbadge0.$$.fragment, local);
            $6697ff39d54b09bb$export$ebd11618f299a286(walletappbadge1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div6);
            $6697ff39d54b09bb$export$3466f893ebf79586(walletappbadge0);
            $6697ff39d54b09bb$export$3466f893ebf79586(walletappbadge1);
            if_block.d();
            mounted = false;
            dispose();
        }
    };
}
function $6697ff39d54b09bb$var$instance$9($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, (0, $6y4qQ._), ($$value)=>$$invalidate(7, $_ = $$value));
    let { connectWallet: connectWallet } = $$props;
    let { selectedWallet: selectedWallet } = $$props;
    let { deselectWallet: deselectWallet } = $$props;
    let { setStep: setStep } = $$props;
    let { connectionRejected: connectionRejected } = $$props;
    let { previousConnectionRequest: previousConnectionRequest } = $$props;
    const appMetadata$ = $6697ff39d54b09bb$export$6559d589eb85fbb6.select("appMetadata").pipe((0, $fy9c8.startWith)($6697ff39d54b09bb$export$6559d589eb85fbb6.get().appMetadata), (0, $hDTQV.shareReplay)(1));
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(6, $appMetadata$ = value));
    const click_handler = ()=>{
        deselectWallet(selectedWallet.label);
        setStep("selectingWallet");
    };
    $$self.$$set = ($$props)=>{
        if ("connectWallet" in $$props) $$invalidate(0, connectWallet = $$props.connectWallet);
        if ("selectedWallet" in $$props) $$invalidate(1, selectedWallet = $$props.selectedWallet);
        if ("deselectWallet" in $$props) $$invalidate(2, deselectWallet = $$props.deselectWallet);
        if ("setStep" in $$props) $$invalidate(3, setStep = $$props.setStep);
        if ("connectionRejected" in $$props) $$invalidate(4, connectionRejected = $$props.connectionRejected);
        if ("previousConnectionRequest" in $$props) $$invalidate(5, previousConnectionRequest = $$props.previousConnectionRequest);
    };
    return [
        connectWallet,
        selectedWallet,
        deselectWallet,
        setStep,
        connectionRejected,
        previousConnectionRequest,
        $appMetadata$,
        $_,
        appMetadata$,
        click_handler
    ];
}
class $6697ff39d54b09bb$var$ConnectingWallet extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$9, $6697ff39d54b09bb$var$create_fragment$9, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            connectWallet: 0,
            selectedWallet: 1,
            deselectWallet: 2,
            setStep: 3,
            connectionRejected: 4,
            previousConnectionRequest: 5
        }, $6697ff39d54b09bb$var$add_css$9);
    }
}
/* src/views/connect/InstallWallet.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$8(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-1uy2ffh", ".outer-container.svelte-1uy2ffh{padding:var(--onboard-spacing-4, var(--spacing-4))}.link.svelte-1uy2ffh{font-size:var(--onboard-font-size-7, var(--font-size-7));line-height:16px;color:var(--onboard-primary-500, var(--primary-500));text-decoration:none}");
}
function $6697ff39d54b09bb$var$get_each_context$1(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[3] = list[i].name;
    child_ctx[4] = list[i].url;
    child_ctx[6] = i;
    return child_ctx;
}
// (44:4) {:else}
function $6697ff39d54b09bb$var$create_else_block$2(ctx) {
    let t_value = /*$_*/ ctx[1]("connect.selectingWallet.installWallet", {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.selectingWallet.installWallet,
        values: {
            app: /*$appMetadata$*/ ctx[0].name || "this app"
        }
    }) + "";
    let t;
    return {
        c () {
            t = $6697ff39d54b09bb$export$625550452a3fa3ec(t_value);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, $appMetadata$*/ 3 && t_value !== (t_value = /*$_*/ ctx[1]("connect.selectingWallet.installWallet", {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.selectingWallet.installWallet,
                values: {
                    app: /*$appMetadata$*/ ctx[0].name || "this app"
                }
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t);
        }
    };
}
// (25:4) {#if $appMetadata$.recommendedInjectedWallets}
function $6697ff39d54b09bb$var$create_if_block$6(ctx) {
    let t0_value = /*$_*/ ctx[1]("connect.selectingWallet.recommendedWalletsPart1", {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.selectingWallet.recommendedWalletsPart1,
        values: {
            app: /*$appMetadata$*/ ctx[0].name || "This app"
        }
    }) + "";
    let t0;
    let t1;
    let t2;
    let t3_value = /*$_*/ ctx[1]("connect.selectingWallet.recommendedWalletsPart2", {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.selectingWallet.recommendedWalletsPart2
    }) + "";
    let t3;
    let each_value = /*$appMetadata$*/ ctx[0].recommendedInjectedWallets;
    let each_blocks = [];
    for(let i = 0; i < each_value.length; i += 1)each_blocks[i] = $6697ff39d54b09bb$var$create_each_block$1($6697ff39d54b09bb$var$get_each_context$1(ctx, each_value, i));
    return {
        c () {
            t0 = $6697ff39d54b09bb$export$625550452a3fa3ec(t0_value);
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            t2 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            t3 = $6697ff39d54b09bb$export$625550452a3fa3ec(t3_value);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t0, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t1, anchor);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t2, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t3, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, $appMetadata$*/ 3 && t0_value !== (t0_value = /*$_*/ ctx[1]("connect.selectingWallet.recommendedWalletsPart1", {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.selectingWallet.recommendedWalletsPart1,
                values: {
                    app: /*$appMetadata$*/ ctx[0].name || "This app"
                }
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t0, t0_value);
            if (dirty & /*$appMetadata$*/ 1) {
                each_value = /*$appMetadata$*/ ctx[0].recommendedInjectedWallets;
                let i;
                for(i = 0; i < each_value.length; i += 1){
                    const child_ctx = $6697ff39d54b09bb$var$get_each_context$1(ctx, each_value, i);
                    if (each_blocks[i]) each_blocks[i].p(child_ctx, dirty);
                    else {
                        each_blocks[i] = $6697ff39d54b09bb$var$create_each_block$1(child_ctx);
                        each_blocks[i].c();
                        each_blocks[i].m(t2.parentNode, t2);
                    }
                }
                for(; i < each_blocks.length; i += 1)each_blocks[i].d(1);
                each_blocks.length = each_value.length;
            }
            if (dirty & /*$_*/ 2 && t3_value !== (t3_value = /*$_*/ ctx[1]("connect.selectingWallet.recommendedWalletsPart2", {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.selectingWallet.recommendedWalletsPart2
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t3, t3_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t0);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t1);
            $6697ff39d54b09bb$export$ef35774e6d314e91(each_blocks, detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t2);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t3);
        }
    };
}
// (32:6) {#each $appMetadata$.recommendedInjectedWallets as { name, url }
function $6697ff39d54b09bb$var$create_each_block$1(ctx) {
    let a;
    let t0_value = /*name*/ ctx[3] + "";
    let t0;
    let t1_value = /*i*/ (ctx[6] < /*$appMetadata$*/ ctx[0].recommendedInjectedWallets.length - 1 ? ", " : "") + "";
    let t1;
    let a_href_value;
    return {
        c () {
            a = $6697ff39d54b09bb$export$35e795649ee09318("a");
            t0 = $6697ff39d54b09bb$export$625550452a3fa3ec(t0_value);
            t1 = $6697ff39d54b09bb$export$625550452a3fa3ec(t1_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "class", "link pointer svelte-1uy2ffh");
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "href", a_href_value = /*url*/ ctx[4]);
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "target", "_blank");
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "rel", "noreferrer noopener");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, a, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(a, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(a, t1);
        },
        p (ctx, dirty) {
            if (dirty & /*$appMetadata$*/ 1 && t0_value !== (t0_value = /*name*/ ctx[3] + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t0, t0_value);
            if (dirty & /*$appMetadata$*/ 1 && t1_value !== (t1_value = /*i*/ (ctx[6] < /*$appMetadata$*/ ctx[0].recommendedInjectedWallets.length - 1 ? ", " : "") + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t1, t1_value);
            if (dirty & /*$appMetadata$*/ 1 && a_href_value !== (a_href_value = /*url*/ ctx[4])) $6697ff39d54b09bb$export$342063e11d6c3cad(a, "href", a_href_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(a);
        }
    };
}
// (24:2) <Warning>
function $6697ff39d54b09bb$var$create_default_slot$4(ctx) {
    let if_block_anchor;
    function select_block_type(ctx, dirty) {
        if (/*$appMetadata$*/ ctx[0].recommendedInjectedWallets) return $6697ff39d54b09bb$var$create_if_block$6;
        return $6697ff39d54b09bb$var$create_else_block$2;
    }
    let current_block_type = select_block_type(ctx);
    let if_block = current_block_type(ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if_block.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            }
        },
        d (detaching) {
            if_block.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
function $6697ff39d54b09bb$var$create_fragment$8(ctx) {
    let div;
    let warning;
    let current;
    warning = new $6697ff39d54b09bb$var$Warning({
        props: {
            $$slots: {
                default: [
                    $6697ff39d54b09bb$var$create_default_slot$4
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(warning.$$.fragment);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "outer-container svelte-1uy2ffh");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            $6697ff39d54b09bb$export$9bb611d729802a56(warning, div, null);
            current = true;
        },
        p (ctx, [dirty]) {
            const warning_changes = {};
            if (dirty & /*$$scope, $_, $appMetadata$*/ 131) warning_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            warning.$set(warning_changes);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(warning.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(warning.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            $6697ff39d54b09bb$export$3466f893ebf79586(warning);
        }
    };
}
function $6697ff39d54b09bb$var$instance$8($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, (0, $6y4qQ._), ($$value)=>$$invalidate(1, $_ = $$value));
    const appMetadata$ = $6697ff39d54b09bb$export$6559d589eb85fbb6.select("appMetadata").pipe((0, $fy9c8.startWith)($6697ff39d54b09bb$export$6559d589eb85fbb6.get().appMetadata), (0, $hDTQV.shareReplay)(1));
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(0, $appMetadata$ = value));
    return [
        $appMetadata$,
        $_,
        appMetadata$
    ];
}
class $6697ff39d54b09bb$var$InstallWallet extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$8, $6697ff39d54b09bb$var$create_fragment$8, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {}, $6697ff39d54b09bb$var$add_css$8);
    }
}
/* src/views/connect/WalletButton.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$7(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-1ct6vh0", "button.svelte-1ct6vh0:disabled{opacity:0.5}button.wallet-button-styling.svelte-1ct6vh0{position:relative;align-items:flex-start;flex:1;padding:0;background:none;color:var(--onboard-wallet-button-color, inherit)}.wallet-button-container.svelte-1ct6vh0{display:flex}.wallet-button-container-inner.svelte-1ct6vh0{position:relative;display:flex;flex-flow:column;align-items:center;gap:0.5rem;padding:0.75rem;width:5rem}.name.svelte-1ct6vh0{font-size:var(--onboard-font-size-7, var(--font-size-7));line-height:1rem;text-overflow:ellipsis;max-width:5rem;max-height:2rem;overflow:hidden}.status-icon.svelte-1ct6vh0{position:absolute;top:3.5rem;left:3.5rem}@media screen and (min-width: 768px){button.wallet-button-styling.svelte-1ct6vh0{transition:background-color 250ms ease-in-out;background:var(--onboard-wallet-button-background, none);border:1px solid transparent;border-color:var(--onboard-wallet-button-border-color, var(--border-color));border-radius:var(--onboard-wallet-button-border-radius, var(--border-radius-1))}button.wallet-button-styling.svelte-1ct6vh0:hover{background:var(--onboard-wallet-button-background-hover, var(--foreground-color));color:var(--onboard-wallet-button-color-hover)}.wallet-button-container-inner.svelte-1ct6vh0{flex:1;flex-flow:row nowrap;gap:1rem;padding:1rem}button.connected.svelte-1ct6vh0{border-color:var(--onboard-success-500, var(--success-500))}.name.svelte-1ct6vh0{font-size:var(--onboard-font-size-5, var(--font-size-5));line-height:1.25rem;text-align:initial;max-width:inherit;max-height:3rem}.status-icon.svelte-1ct6vh0{top:0;bottom:0;left:auto;right:1rem;margin:auto;height:20px}}");
}
// (120:6) {#if connected}
function $6697ff39d54b09bb$var$create_if_block$5(ctx) {
    let div;
    let successstatusicon;
    let current;
    successstatusicon = new $6697ff39d54b09bb$export$db202ddc8be9136({
        props: {
            size: 20
        }
    });
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(successstatusicon.$$.fragment);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "status-icon svelte-1ct6vh0");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            $6697ff39d54b09bb$export$9bb611d729802a56(successstatusicon, div, null);
            current = true;
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(successstatusicon.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(successstatusicon.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            $6697ff39d54b09bb$export$3466f893ebf79586(successstatusicon);
        }
    };
}
function $6697ff39d54b09bb$var$create_fragment$7(ctx) {
    let div2;
    let button;
    let div1;
    let walletappbadge;
    let t0;
    let div0;
    let t1;
    let t2;
    let button_intro;
    let current;
    let mounted;
    let dispose;
    $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[7]);
    walletappbadge = new $6697ff39d54b09bb$export$71cec2538cb2c617({
        props: {
            size: /*windowWidth*/ ctx[6] >= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH ? 48 : 56,
            icon: /*icon*/ ctx[0],
            loading: /*connecting*/ ctx[4],
            border: /*connected*/ ctx[3] ? "green" : "custom",
            background: "transparent"
        }
    });
    let if_block = /*connected*/ ctx[3] && $6697ff39d54b09bb$var$create_if_block$5();
    return {
        c () {
            div2 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            button = $6697ff39d54b09bb$export$35e795649ee09318("button");
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(walletappbadge.$$.fragment);
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t1 = $6697ff39d54b09bb$export$625550452a3fa3ec(/*label*/ ctx[1]);
            t2 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block) if_block.c();
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "name svelte-1ct6vh0");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "wallet-button-container-inner svelte-1ct6vh0");
            $6697ff39d54b09bb$export$342063e11d6c3cad(button, "class", "wallet-button-styling svelte-1ct6vh0");
            button.disabled = /*disabled*/ ctx[5];
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(button, "connected", /*connected*/ ctx[3]);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "class", "wallet-button-container svelte-1ct6vh0");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div2, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, button);
            $6697ff39d54b09bb$export$953cecd6e717a553(button, div1);
            $6697ff39d54b09bb$export$9bb611d729802a56(walletappbadge, div1, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, div0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div0, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t2);
            if (if_block) if_block.m(div1, null);
            current = true;
            if (!mounted) {
                dispose = [
                    $6697ff39d54b09bb$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[7]),
                    $6697ff39d54b09bb$export$ffb5f4729a158638(button, "click", function() {
                        if ($6697ff39d54b09bb$export$dc98b0b04f4c7758(/*onClick*/ ctx[2])) /*onClick*/ ctx[2].apply(this, arguments);
                    })
                ];
                mounted = true;
            }
        },
        p (new_ctx, [dirty]) {
            ctx = new_ctx;
            const walletappbadge_changes = {};
            if (dirty & /*windowWidth*/ 64) walletappbadge_changes.size = /*windowWidth*/ ctx[6] >= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH ? 48 : 56;
            if (dirty & /*icon*/ 1) walletappbadge_changes.icon = /*icon*/ ctx[0];
            if (dirty & /*connecting*/ 16) walletappbadge_changes.loading = /*connecting*/ ctx[4];
            if (dirty & /*connected*/ 8) walletappbadge_changes.border = /*connected*/ ctx[3] ? "green" : "custom";
            walletappbadge.$set(walletappbadge_changes);
            if (!current || dirty & /*label*/ 2) $6697ff39d54b09bb$export$90a7f3efeed30595(t1, /*label*/ ctx[1]);
            if (/*connected*/ ctx[3]) {
                if (if_block) {
                    if (dirty & /*connected*/ 8) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block, 1);
                } else {
                    if_block = $6697ff39d54b09bb$var$create_if_block$5();
                    if_block.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block, 1);
                    if_block.m(div1, null);
                }
            } else if (if_block) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
            if (!current || dirty & /*disabled*/ 32) button.disabled = /*disabled*/ ctx[5];
            if (!current || dirty & /*connected*/ 8) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(button, "connected", /*connected*/ ctx[3]);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(walletappbadge.$$.fragment, local);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block);
            if (local) {
                if (!button_intro) $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(()=>{
                    button_intro = $6697ff39d54b09bb$export$e7c866399fa523f5(button, $6697ff39d54b09bb$export$78acf4525d8a74c4, {});
                    button_intro.start();
                });
            }
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(walletappbadge.$$.fragment, local);
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div2);
            $6697ff39d54b09bb$export$3466f893ebf79586(walletappbadge);
            if (if_block) if_block.d();
            mounted = false;
            $6697ff39d54b09bb$export$61196ced6d74a310(dispose);
        }
    };
}
function $6697ff39d54b09bb$var$instance$7($$self, $$props, $$invalidate) {
    let { icon: icon } = $$props;
    let { label: label } = $$props;
    let { onClick: onClick } = $$props;
    let { connected: connected } = $$props;
    let { connecting: connecting } = $$props;
    let { disabled: disabled } = $$props;
    let windowWidth;
    function onwindowresize() {
        $$invalidate(6, windowWidth = window.innerWidth);
    }
    $$self.$$set = ($$props)=>{
        if ("icon" in $$props) $$invalidate(0, icon = $$props.icon);
        if ("label" in $$props) $$invalidate(1, label = $$props.label);
        if ("onClick" in $$props) $$invalidate(2, onClick = $$props.onClick);
        if ("connected" in $$props) $$invalidate(3, connected = $$props.connected);
        if ("connecting" in $$props) $$invalidate(4, connecting = $$props.connecting);
        if ("disabled" in $$props) $$invalidate(5, disabled = $$props.disabled);
    };
    return [
        icon,
        label,
        onClick,
        connected,
        connecting,
        disabled,
        windowWidth,
        onwindowresize
    ];
}
class $6697ff39d54b09bb$var$WalletButton extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$7, $6697ff39d54b09bb$var$create_fragment$7, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            icon: 0,
            label: 1,
            onClick: 2,
            connected: 3,
            connecting: 4,
            disabled: 5
        }, $6697ff39d54b09bb$var$add_css$7);
    }
}
/* src/views/connect/SelectingWallet.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$6(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-kpc6js", ".wallets-container.svelte-kpc6js{display:flex;gap:0.5rem;overflow-x:scroll;overflow-y:hidden;padding:0.75rem 0.5rem;border-bottom:1px solid var(--border-color);-ms-overflow-style:none;scrollbar-width:none}.wallets-container.svelte-kpc6js::-webkit-scrollbar{display:none}.warning-container.svelte-kpc6js{margin:1rem 1rem 0}.notice-container.svelte-kpc6js{flex:0 0 100%;margin-top:0.75rem}@media all and (min-width: 768px){.wallets-container.svelte-kpc6js{display:grid;grid-template-columns:repeat(var(--onboard-wallet-columns, 2), 1fr);padding:1rem;border:none}.notice-container.svelte-kpc6js{grid-column:span 2;margin:0}}");
}
function $6697ff39d54b09bb$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[10] = list[i];
    return child_ctx;
}
// (65:2) {#if connectingErrorMessage}
function $6697ff39d54b09bb$var$create_if_block_1$3(ctx) {
    let div;
    let warning;
    let current;
    warning = new $6697ff39d54b09bb$var$Warning({
        props: {
            $$slots: {
                default: [
                    $6697ff39d54b09bb$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(warning.$$.fragment);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "warning-container svelte-kpc6js");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            $6697ff39d54b09bb$export$9bb611d729802a56(warning, div, null);
            current = true;
        },
        p (ctx, dirty) {
            const warning_changes = {};
            if (dirty & /*$$scope, connectingErrorMessage*/ 8200) warning_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            warning.$set(warning_changes);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(warning.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(warning.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            $6697ff39d54b09bb$export$3466f893ebf79586(warning);
        }
    };
}
// (67:6) <Warning>
function $6697ff39d54b09bb$var$create_default_slot_1(ctx) {
    let html_tag;
    let html_anchor;
    return {
        c () {
            html_tag = new $6697ff39d54b09bb$export$ce26c07117d59d6a(false);
            html_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m(/*connectingErrorMessage*/ ctx[3], target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*connectingErrorMessage*/ 8) html_tag.p(/*connectingErrorMessage*/ ctx[3]);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (72:4) {#each wallets as wallet}
function $6697ff39d54b09bb$var$create_each_block(ctx) {
    let walletbutton;
    let current;
    function func() {
        return /*func*/ ctx[9](/*wallet*/ ctx[10]);
    }
    walletbutton = new $6697ff39d54b09bb$var$WalletButton({
        props: {
            connected: /*checkConnected*/ ctx[7](/*wallet*/ ctx[10].label),
            connecting: /*connectingWalletLabel*/ ctx[2] === /*wallet*/ ctx[10].label,
            label: /*wallet*/ ctx[10].label,
            icon: /*wallet*/ ctx[10].icon,
            onClick: func,
            disabled: /*windowWidth*/ ctx[4] <= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH && /*connectingWalletLabel*/ ctx[2] && /*connectingWalletLabel*/ ctx[2] !== /*wallet*/ ctx[10].label
        }
    });
    return {
        c () {
            $6697ff39d54b09bb$export$d66501df72047452(walletbutton.$$.fragment);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$9bb611d729802a56(walletbutton, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const walletbutton_changes = {};
            if (dirty & /*wallets*/ 1) walletbutton_changes.connected = /*checkConnected*/ ctx[7](/*wallet*/ ctx[10].label);
            if (dirty & /*connectingWalletLabel, wallets*/ 5) walletbutton_changes.connecting = /*connectingWalletLabel*/ ctx[2] === /*wallet*/ ctx[10].label;
            if (dirty & /*wallets*/ 1) walletbutton_changes.label = /*wallet*/ ctx[10].label;
            if (dirty & /*wallets*/ 1) walletbutton_changes.icon = /*wallet*/ ctx[10].icon;
            if (dirty & /*selectWallet, wallets*/ 3) walletbutton_changes.onClick = func;
            if (dirty & /*windowWidth, connectingWalletLabel, wallets*/ 21) walletbutton_changes.disabled = /*windowWidth*/ ctx[4] <= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH && /*connectingWalletLabel*/ ctx[2] && /*connectingWalletLabel*/ ctx[2] !== /*wallet*/ ctx[10].label;
            walletbutton.$set(walletbutton_changes);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(walletbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(walletbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $6697ff39d54b09bb$export$3466f893ebf79586(walletbutton, detaching);
        }
    };
}
// (84:4) {#if !connect.removeWhereIsMyWalletWarning}
function $6697ff39d54b09bb$var$create_if_block$4(ctx) {
    let div;
    let warning;
    let current;
    warning = new $6697ff39d54b09bb$var$Warning({
        props: {
            $$slots: {
                default: [
                    $6697ff39d54b09bb$var$create_default_slot$3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(warning.$$.fragment);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "notice-container svelte-kpc6js");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            $6697ff39d54b09bb$export$9bb611d729802a56(warning, div, null);
            current = true;
        },
        p (ctx, dirty) {
            const warning_changes = {};
            if (dirty & /*$$scope, $_*/ 8224) warning_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            warning.$set(warning_changes);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(warning.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(warning.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            $6697ff39d54b09bb$export$3466f893ebf79586(warning);
        }
    };
}
// (86:8) <Warning>
function $6697ff39d54b09bb$var$create_default_slot$3(ctx) {
    let div;
    let t0_value = /*$_*/ ctx[5]("connect.selectingWallet.whyDontISeeMyWallet", {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.selectingWallet.whyDontISeeMyWallet
    }) + "";
    let t0;
    let t1;
    let a;
    let t2_value = /*$_*/ ctx[5]("connect.selectingWallet.learnMore", {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.selectingWallet.learnMore
    }) + "";
    let t2;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t0 = $6697ff39d54b09bb$export$625550452a3fa3ec(t0_value);
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            a = $6697ff39d54b09bb$export$35e795649ee09318("a");
            t2 = $6697ff39d54b09bb$export$625550452a3fa3ec(t2_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "class", "link pointer");
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "href", /*connect*/ ctx[6].wheresMyWalletLink || $6697ff39d54b09bb$var$wheresMyWalletDefault);
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "target", "_blank");
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "rel", "noreferrer noopener");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div, t0);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t1, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, a, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(a, t2);
        },
        p (ctx, dirty) {
            if (dirty & /*$_*/ 32 && t0_value !== (t0_value = /*$_*/ ctx[5]("connect.selectingWallet.whyDontISeeMyWallet", {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.selectingWallet.whyDontISeeMyWallet
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t0, t0_value);
            if (dirty & /*$_*/ 32 && t2_value !== (t2_value = /*$_*/ ctx[5]("connect.selectingWallet.learnMore", {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.selectingWallet.learnMore
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t2, t2_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t1);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(a);
        }
    };
}
function $6697ff39d54b09bb$var$create_fragment$6(ctx) {
    let div1;
    let t0;
    let div0;
    let t1;
    let current;
    let mounted;
    let dispose;
    $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[8]);
    let if_block0 = /*connectingErrorMessage*/ ctx[3] && $6697ff39d54b09bb$var$create_if_block_1$3(ctx);
    let each_value = /*wallets*/ ctx[0];
    let each_blocks = [];
    for(let i = 0; i < each_value.length; i += 1)each_blocks[i] = $6697ff39d54b09bb$var$create_each_block($6697ff39d54b09bb$var$get_each_context(ctx, each_value, i));
    const out = (i)=>$6697ff39d54b09bb$export$ebd11618f299a286(each_blocks[i], 1, 1, ()=>{
            each_blocks[i] = null;
        });
    let if_block1 = !/*connect*/ ctx[6].removeWhereIsMyWalletWarning && $6697ff39d54b09bb$var$create_if_block$4(ctx);
    return {
        c () {
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "wallets-container svelte-kpc6js");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "outer-container");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div1, anchor);
            if (if_block0) if_block0.m(div1, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, div0);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(div0, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div0, t1);
            if (if_block1) if_block1.m(div0, null);
            current = true;
            if (!mounted) {
                dispose = $6697ff39d54b09bb$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[8]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (/*connectingErrorMessage*/ ctx[3]) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*connectingErrorMessage*/ 8) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block0, 1);
                } else {
                    if_block0 = $6697ff39d54b09bb$var$create_if_block_1$3(ctx);
                    if_block0.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block0, 1);
                    if_block0.m(div1, t0);
                }
            } else if (if_block0) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
            if (dirty & /*checkConnected, wallets, connectingWalletLabel, selectWallet, windowWidth, MOBILE_WINDOW_WIDTH*/ 151) {
                each_value = /*wallets*/ ctx[0];
                let i;
                for(i = 0; i < each_value.length; i += 1){
                    const child_ctx = $6697ff39d54b09bb$var$get_each_context(ctx, each_value, i);
                    if (each_blocks[i]) {
                        each_blocks[i].p(child_ctx, dirty);
                        $6697ff39d54b09bb$export$d141bba7fdc215a3(each_blocks[i], 1);
                    } else {
                        each_blocks[i] = $6697ff39d54b09bb$var$create_each_block(child_ctx);
                        each_blocks[i].c();
                        $6697ff39d54b09bb$export$d141bba7fdc215a3(each_blocks[i], 1);
                        each_blocks[i].m(div0, t1);
                    }
                }
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                for(i = each_value.length; i < each_blocks.length; i += 1)out(i);
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
            if (!/*connect*/ ctx[6].removeWhereIsMyWalletWarning) if_block1.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block0);
            for(let i = 0; i < each_value.length; i += 1)$6697ff39d54b09bb$export$d141bba7fdc215a3(each_blocks[i]);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block1);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block0);
            each_blocks = each_blocks.filter(Boolean);
            for(let i = 0; i < each_blocks.length; i += 1)$6697ff39d54b09bb$export$ebd11618f299a286(each_blocks[i]);
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block1);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div1);
            if (if_block0) if_block0.d();
            $6697ff39d54b09bb$export$ef35774e6d314e91(each_blocks, detaching);
            if (if_block1) if_block1.d();
            mounted = false;
            dispose();
        }
    };
}
const $6697ff39d54b09bb$var$wheresMyWalletDefault = "https://www.blocknative.com/blog/metamask-wont-connect-web3-wallet-troubleshooting";
function $6697ff39d54b09bb$var$instance$6($$self, $$props, $$invalidate) {
    let $_;
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, (0, $6y4qQ._), ($$value)=>$$invalidate(5, $_ = $$value));
    let { wallets: wallets } = $$props;
    let { selectWallet: selectWallet } = $$props;
    let { connectingWalletLabel: connectingWalletLabel } = $$props;
    let { connectingErrorMessage: connectingErrorMessage } = $$props;
    let windowWidth;
    const { connect: connect } = $6697ff39d54b09bb$export$6559d589eb85fbb6.get();
    function checkConnected(label) {
        const { wallets: wallets } = $6697ff39d54b09bb$export$6559d589eb85fbb6.get();
        return !!wallets.find((wallet)=>wallet.label === label);
    }
    function onwindowresize() {
        $$invalidate(4, windowWidth = window.innerWidth);
    }
    const func = (wallet)=>selectWallet(wallet);
    $$self.$$set = ($$props)=>{
        if ("wallets" in $$props) $$invalidate(0, wallets = $$props.wallets);
        if ("selectWallet" in $$props) $$invalidate(1, selectWallet = $$props.selectWallet);
        if ("connectingWalletLabel" in $$props) $$invalidate(2, connectingWalletLabel = $$props.connectingWalletLabel);
        if ("connectingErrorMessage" in $$props) $$invalidate(3, connectingErrorMessage = $$props.connectingErrorMessage);
    };
    return [
        wallets,
        selectWallet,
        connectingWalletLabel,
        connectingErrorMessage,
        windowWidth,
        $_,
        connect,
        checkConnected,
        onwindowresize,
        func
    ];
}
class $6697ff39d54b09bb$var$SelectingWallet extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$6, $6697ff39d54b09bb$var$create_fragment$6, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            wallets: 0,
            selectWallet: 1,
            connectingWalletLabel: 2,
            connectingErrorMessage: 3
        }, $6697ff39d54b09bb$var$add_css$6);
    }
}
/* src/views/connect/Sidebar.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$5(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-obaru3", ".sidebar.svelte-obaru3{--background-color:var(\n      --onboard-connect-sidebar-background,\n      var(--w3o-foreground-color, none)\n    );--text-color:var(--onboard-connect-sidebar-color, inherit);--border-color:var(--onboard-connect-sidebar-border-color, inherit);display:flex;flex-flow:column;gap:1rem;padding:1rem;align-items:center}.inner-container.svelte-obaru3{display:flex;flex-flow:column;align-items:center;align-self:stretch;gap:0.5rem;padding:1.5rem;text-align:center;border:1px solid transparent;border-radius:12px;border-color:var(--border-color);background:var(--background-color);color:var(--text-color)}.icon-container.svelte-obaru3{display:flex;height:3.5rem;width:auto;min-width:3.5rem;max-width:100%}.heading.svelte-obaru3{font-size:var(--onboard-font-size-3, var(--font-size-3));margin:0 0 var(--onboard-spacing-5, var(--spacing-5)) 0}.subheading.svelte-obaru3{line-height:1rem}.description.svelte-obaru3{line-height:1.25rem;font-size:var(--onboard-font-size-6, var(--font-size-6))}img.svelte-obaru3{max-width:100%;height:auto}.indicators.svelte-obaru3{margin-top:auto}.indicator.svelte-obaru3{box-sizing:content-box;width:8px;height:8px;border-radius:8px;background:var(\n      --onboard-connect-sidebar-progress-background,\n      var(--onboard-gray-700, var(--gray-700))\n    );transition:background 250ms ease-in-out}.indicator.on.svelte-obaru3{background:var(\n      --onboard-connect-sidebar-progress-color,\n      var(--action-color)\n    );border:2px solid\n      var(\n        --onboard-connect-sidebar-progress-background,\n        var(--onboard-gray-700, var(--gray-700))\n      )}.join.svelte-obaru3{box-sizing:content-box;z-index:1;right:4px;height:2px;background:var(\n      --onboard-connect-sidebar-progress-background,\n      var(--onboard-gray-700, var(--gray-700))\n    );transition:background 250ms ease-in-out}.join.active.svelte-obaru3{background:var(\n      --onboard-connect-sidebar-progress-color,\n      var(--action-color)\n    )}.no-link.svelte-obaru3{display:flex;flex-direction:row;align-items:center;padding:0.25rem 0.5rem 0.25rem 0.75rem;gap:0.25rem;font-size:var(--onboard-font-size-6, var(--font-size-6))}.info-icon.svelte-obaru3{width:1.25rem;display:flex;align-items:center}@media all and (min-width: 768px){.sidebar.svelte-obaru3{max-width:280px;border-right:1px solid;border-color:var(--border-color);background:var(--background-color)}.inner-container.svelte-obaru3{border:none;text-align:initial;flex:1;align-items:flex-start;gap:1rem}.indicators.svelte-obaru3{margin-bottom:0.25rem}}");
}
// (164:4) {#if windowWidth >= MOBILE_WINDOW_WIDTH}
function $6697ff39d54b09bb$var$create_if_block_3$2(ctx) {
    let div;
    let t;
    let show_if = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.header`, {
        default: ""
    });
    let if_block1_anchor;
    function select_block_type(ctx, dirty) {
        if (/*$appMetadata$*/ ctx[2] && /*$appMetadata$*/ (ctx[2].logo || /*$appMetadata$*/ ctx[2].icon)) return $6697ff39d54b09bb$var$create_if_block_5$2;
        return $6697ff39d54b09bb$var$create_else_block_1$1;
    }
    let current_block_type = select_block_type(ctx);
    let if_block0 = current_block_type(ctx);
    let if_block1 = show_if && $6697ff39d54b09bb$var$create_if_block_4$2(ctx);
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if_block0.c();
            t = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            if_block1_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "icon-container svelte-obaru3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            if_block0.m(div, null);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t, anchor);
            if (if_block1) if_block1.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block1_anchor, anchor);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block0) if_block0.p(ctx, dirty);
            else {
                if_block0.d(1);
                if_block0 = current_block_type(ctx);
                if (if_block0) {
                    if_block0.c();
                    if_block0.m(div, null);
                }
            }
            if (dirty & /*$_, step*/ 9) show_if = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.header`, {
                default: ""
            });
            if (show_if) {
                if (if_block1) if_block1.p(ctx, dirty);
                else {
                    if_block1 = $6697ff39d54b09bb$var$create_if_block_4$2(ctx);
                    if_block1.c();
                    if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
                }
            } else if (if_block1) {
                if_block1.d(1);
                if_block1 = null;
            }
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            if_block0.d();
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t);
            if (if_block1) if_block1.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block1_anchor);
        }
    };
}
// (172:8) {:else}
function $6697ff39d54b09bb$var$create_else_block_1$1(ctx) {
    let html_tag;
    let html_anchor;
    return {
        c () {
            html_tag = new $6697ff39d54b09bb$export$ce26c07117d59d6a(false);
            html_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m($6697ff39d54b09bb$var$defaultBnIcon, target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (166:8) {#if $appMetadata$ && ($appMetadata$.logo || $appMetadata$.icon)}
function $6697ff39d54b09bb$var$create_if_block_5$2(ctx) {
    let show_if;
    let if_block_anchor;
    function select_block_type_1(ctx, dirty) {
        if (dirty & /*$appMetadata$*/ 4) show_if = null;
        if (show_if == null) show_if = !!$6697ff39d54b09bb$export$34aec0b863436764(/*$appMetadata$*/ ctx[2].logo || /*$appMetadata$*/ ctx[2].icon);
        if (show_if) return $6697ff39d54b09bb$var$create_if_block_6$2;
        return $6697ff39d54b09bb$var$create_else_block$1;
    }
    let current_block_type = select_block_type_1(ctx, -1);
    let if_block = current_block_type(ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if_block.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            }
        },
        d (detaching) {
            if_block.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (169:10) {:else}
function $6697ff39d54b09bb$var$create_else_block$1(ctx) {
    let img;
    let img_src_value;
    return {
        c () {
            img = $6697ff39d54b09bb$export$35e795649ee09318("img");
            if (!$6697ff39d54b09bb$export$3c2fa207a37baaea(img.src, img_src_value = /*$appMetadata$*/ ctx[2].logo || /*$appMetadata$*/ ctx[2].icon)) $6697ff39d54b09bb$export$342063e11d6c3cad(img, "src", img_src_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(img, "alt", "logo");
            $6697ff39d54b09bb$export$342063e11d6c3cad(img, "class", "svelte-obaru3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, img, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$appMetadata$*/ 4 && !$6697ff39d54b09bb$export$3c2fa207a37baaea(img.src, img_src_value = /*$appMetadata$*/ ctx[2].logo || /*$appMetadata$*/ ctx[2].icon)) $6697ff39d54b09bb$export$342063e11d6c3cad(img, "src", img_src_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(img);
        }
    };
}
// (167:10) {#if isSVG($appMetadata$.logo || $appMetadata$.icon)}
function $6697ff39d54b09bb$var$create_if_block_6$2(ctx) {
    let html_tag;
    let raw_value = /*$appMetadata$*/ (ctx[2].logo || /*$appMetadata$*/ ctx[2].icon) + "";
    let t;
    return {
        c () {
            html_tag = new $6697ff39d54b09bb$export$ce26c07117d59d6a(false);
            t = $6697ff39d54b09bb$export$625550452a3fa3ec("\u200B");
            html_tag.a = t;
        },
        m (target, anchor) {
            html_tag.m(raw_value, target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$appMetadata$*/ 4 && raw_value !== (raw_value = /*$appMetadata$*/ (ctx[2].logo || /*$appMetadata$*/ ctx[2].icon) + "")) html_tag.p(raw_value);
        },
        d (detaching) {
            if (detaching) html_tag.d();
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t);
        }
    };
}
// (176:6) {#if $_(`connect.${step}.sidebar.header`, { default: '' })}
function $6697ff39d54b09bb$var$create_if_block_4$2(ctx) {
    let div;
    let t_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.header`, {
        default: /*heading*/ ctx[7]
    }) + "";
    let t;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t = $6697ff39d54b09bb$export$625550452a3fa3ec(t_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "heading svelte-obaru3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div, t);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, step*/ 9 && t_value !== (t_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.header`, {
                default: /*heading*/ ctx[7]
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
        }
    };
}
// (197:4) {#if !connect.removeIDontHaveAWalletInfoLink}
function $6697ff39d54b09bb$var$create_if_block_2$2(ctx) {
    let a;
    let t0_value = /*$_*/ ctx[3]("connect.selectingWallet.sidebar.IDontHaveAWallet", {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.selectingWallet.sidebar.IDontHaveAWallet
    }) + "";
    let t0;
    let t1;
    let div;
    return {
        c () {
            a = $6697ff39d54b09bb$export$35e795649ee09318("a");
            t0 = $6697ff39d54b09bb$export$625550452a3fa3ec(t0_value);
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "info-icon svelte-obaru3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "href", /*connect*/ ctx[4].iDontHaveAWalletLink || "https://ethereum.org/en/wallets/find-wallet/#main-content");
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "target", "_blank");
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "rel", "noreferrer noopener");
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "class", "no-link svelte-obaru3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, a, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(a, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(a, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(a, div);
            div.innerHTML = $6697ff39d54b09bb$var$infoIcon;
        },
        p (ctx, dirty) {
            if (dirty & /*$_*/ 8 && t0_value !== (t0_value = /*$_*/ ctx[3]("connect.selectingWallet.sidebar.IDontHaveAWallet", {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect.selectingWallet.sidebar.IDontHaveAWallet
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t0, t0_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(a);
        }
    };
}
// (210:4) {#if windowWidth < MOBILE_WINDOW_WIDTH}
function $6697ff39d54b09bb$var$create_if_block_1$2(ctx) {
    let div5;
    let div0;
    let t0;
    let div1;
    let div1_style_value;
    let t1;
    let div2;
    let t2;
    let div3;
    let div3_style_value;
    let t3;
    let div4;
    return {
        c () {
            div5 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div2 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t2 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div3 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t3 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div4 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "indicator relative svelte-obaru3");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div0, "on", true);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "join relative svelte-obaru3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "style", div1_style_value = `${ctx[0] !== "selectingWallet" ? "right: 4px; width: 52px;" : "right: 2px; width: 54px;"}`);
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div1, "active", /*step*/ ctx[0] !== "selectingWallet");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "class", "indicator relative svelte-obaru3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "style", `right: 8px;`);
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div2, "on", /*step*/ ctx[0] !== "selectingWallet");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div3, "class", "join relative svelte-obaru3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div3, "style", div3_style_value = `${ctx[0] === "connectedWallet" ? "right: 12px; width: 52px;" : "right: 10px; width: 54px;"}`);
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div3, "active", /*step*/ ctx[0] === "connectedWallet");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div4, "style", `right: 16px;`);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div4, "class", "indicator relative svelte-obaru3");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div4, "on", /*step*/ ctx[0] === "connectedWallet");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div5, "class", "indicators flex items-center svelte-obaru3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div5, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, div0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, div1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, div2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, t2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, div3);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, t3);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, div4);
        },
        p (ctx, dirty) {
            if (dirty & /*step*/ 1 && div1_style_value !== (div1_style_value = `${ctx[0] !== "selectingWallet" ? "right: 4px; width: 52px;" : "right: 2px; width: 54px;"}`)) $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "style", div1_style_value);
            if (dirty & /*step*/ 1) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div1, "active", /*step*/ ctx[0] !== "selectingWallet");
            if (dirty & /*step*/ 1) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div2, "on", /*step*/ ctx[0] !== "selectingWallet");
            if (dirty & /*step*/ 1 && div3_style_value !== (div3_style_value = `${ctx[0] === "connectedWallet" ? "right: 12px; width: 52px;" : "right: 10px; width: 54px;"}`)) $6697ff39d54b09bb$export$342063e11d6c3cad(div3, "style", div3_style_value);
            if (dirty & /*step*/ 1) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div3, "active", /*step*/ ctx[0] === "connectedWallet");
            if (dirty & /*step*/ 1) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div4, "on", /*step*/ ctx[0] === "connectedWallet");
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div5);
        }
    };
}
// (244:2) {#if windowWidth >= MOBILE_WINDOW_WIDTH}
function $6697ff39d54b09bb$var$create_if_block$3(ctx) {
    let div5;
    let div0;
    let t0;
    let div1;
    let div1_style_value;
    let t1;
    let div2;
    let t2;
    let div3;
    let div3_style_value;
    let t3;
    let div4;
    return {
        c () {
            div5 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div2 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t2 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div3 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t3 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div4 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "indicator relative svelte-obaru3");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div0, "on", true);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "join relative svelte-obaru3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "style", div1_style_value = `right: 2px; ${ctx[0] !== "selectingWallet" ? "width: 78px;" : "width: 82px;"}`);
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div1, "active", /*step*/ ctx[0] !== "selectingWallet");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "class", "indicator relative svelte-obaru3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "style", `right: 4px;`);
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div2, "on", /*step*/ ctx[0] !== "selectingWallet");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div3, "class", "join relative svelte-obaru3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div3, "style", div3_style_value = `right: 6px; ${ctx[0] === "connectedWallet" ? "width: 74px;" : "width: 81px;"}`);
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div3, "active", /*step*/ ctx[0] === "connectedWallet");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div4, "style", `right: 8px;`);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div4, "class", "indicator relative svelte-obaru3");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div4, "on", /*step*/ ctx[0] === "connectedWallet");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div5, "class", "indicators flex items-center svelte-obaru3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div5, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, div0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, div1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, div2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, t2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, div3);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, t3);
            $6697ff39d54b09bb$export$953cecd6e717a553(div5, div4);
        },
        p (ctx, dirty) {
            if (dirty & /*step*/ 1 && div1_style_value !== (div1_style_value = `right: 2px; ${ctx[0] !== "selectingWallet" ? "width: 78px;" : "width: 82px;"}`)) $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "style", div1_style_value);
            if (dirty & /*step*/ 1) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div1, "active", /*step*/ ctx[0] !== "selectingWallet");
            if (dirty & /*step*/ 1) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div2, "on", /*step*/ ctx[0] !== "selectingWallet");
            if (dirty & /*step*/ 1 && div3_style_value !== (div3_style_value = `right: 6px; ${ctx[0] === "connectedWallet" ? "width: 74px;" : "width: 81px;"}`)) $6697ff39d54b09bb$export$342063e11d6c3cad(div3, "style", div3_style_value);
            if (dirty & /*step*/ 1) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div3, "active", /*step*/ ctx[0] === "connectedWallet");
            if (dirty & /*step*/ 1) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div4, "on", /*step*/ ctx[0] === "connectedWallet");
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div5);
        }
    };
}
function $6697ff39d54b09bb$var$create_fragment$5(ctx) {
    let div4;
    let div2;
    let t0;
    let div0;
    let t1_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.subheading`, {
        default: /*subheading*/ ctx[5]
    }) + "";
    let t1;
    let t2;
    let div1;
    let t3_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.paragraph`, {
        values: {
            app: /*$appMetadata$*/ ctx[2] && /*$appMetadata$*/ ctx[2].name || "This App"
        },
        default: /*paragraph*/ ctx[6]
    }) + "";
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let div3;
    let mounted;
    let dispose;
    $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[9]);
    let if_block0 = /*windowWidth*/ ctx[1] >= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH && $6697ff39d54b09bb$var$create_if_block_3$2(ctx);
    let if_block1 = !/*connect*/ ctx[4].removeIDontHaveAWalletInfoLink && $6697ff39d54b09bb$var$create_if_block_2$2(ctx);
    let if_block2 = /*windowWidth*/ ctx[1] < $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH && $6697ff39d54b09bb$var$create_if_block_1$2(ctx);
    let if_block3 = /*windowWidth*/ ctx[1] >= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH && $6697ff39d54b09bb$var$create_if_block$3(ctx);
    return {
        c () {
            div4 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div2 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t1 = $6697ff39d54b09bb$export$625550452a3fa3ec(t1_value);
            t2 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t3 = $6697ff39d54b09bb$export$625550452a3fa3ec(t3_value);
            t4 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            t5 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block2) if_block2.c();
            t6 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block3) if_block3.c();
            t7 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div3 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "subheading svelte-obaru3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "description svelte-obaru3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "class", "inner-container svelte-obaru3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div4, "class", "sidebar svelte-obaru3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div4, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, div2);
            if (if_block0) if_block0.m(div2, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, div0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div0, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, t2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, div1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t3);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, t4);
            if (if_block1) if_block1.m(div2, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, t5);
            if (if_block2) if_block2.m(div2, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, t6);
            if (if_block3) if_block3.m(div4, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, t7);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, div3);
            div3.innerHTML = $6697ff39d54b09bb$export$a93c5207d687da10;
            if (!mounted) {
                dispose = $6697ff39d54b09bb$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[9]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (/*windowWidth*/ ctx[1] >= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH) {
                if (if_block0) if_block0.p(ctx, dirty);
                else {
                    if_block0 = $6697ff39d54b09bb$var$create_if_block_3$2(ctx);
                    if_block0.c();
                    if_block0.m(div2, t0);
                }
            } else if (if_block0) {
                if_block0.d(1);
                if_block0 = null;
            }
            if (dirty & /*$_, step*/ 9 && t1_value !== (t1_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.subheading`, {
                default: /*subheading*/ ctx[5]
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t1, t1_value);
            if (dirty & /*$_, step, $appMetadata$*/ 13 && t3_value !== (t3_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.paragraph`, {
                values: {
                    app: /*$appMetadata$*/ ctx[2] && /*$appMetadata$*/ ctx[2].name || "This App"
                },
                default: /*paragraph*/ ctx[6]
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t3, t3_value);
            if (!/*connect*/ ctx[4].removeIDontHaveAWalletInfoLink) if_block1.p(ctx, dirty);
            if (/*windowWidth*/ ctx[1] < $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH) {
                if (if_block2) if_block2.p(ctx, dirty);
                else {
                    if_block2 = $6697ff39d54b09bb$var$create_if_block_1$2(ctx);
                    if_block2.c();
                    if_block2.m(div2, null);
                }
            } else if (if_block2) {
                if_block2.d(1);
                if_block2 = null;
            }
            if (/*windowWidth*/ ctx[1] >= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH) {
                if (if_block3) if_block3.p(ctx, dirty);
                else {
                    if_block3 = $6697ff39d54b09bb$var$create_if_block$3(ctx);
                    if_block3.c();
                    if_block3.m(div4, t7);
                }
            } else if (if_block3) {
                if_block3.d(1);
                if_block3 = null;
            }
        },
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div4);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            if (if_block2) if_block2.d();
            if (if_block3) if_block3.d();
            mounted = false;
            dispose();
        }
    };
}
function $6697ff39d54b09bb$var$instance$5($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, (0, $6y4qQ._), ($$value)=>$$invalidate(3, $_ = $$value));
    let { step: step } = $$props;
    const { connect: connect } = $6697ff39d54b09bb$export$6559d589eb85fbb6.get();
    const defaultContent = $6697ff39d54b09bb$export$e7094788287c5e9b.connect[step].sidebar;
    const { subheading: subheading, paragraph: paragraph } = defaultContent;
    const { heading: heading } = defaultContent;
    let windowWidth;
    const appMetadata$ = $6697ff39d54b09bb$export$6559d589eb85fbb6.select("appMetadata").pipe((0, $fy9c8.startWith)($6697ff39d54b09bb$export$6559d589eb85fbb6.get().appMetadata), (0, $hDTQV.shareReplay)(1));
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(2, $appMetadata$ = value));
    function onwindowresize() {
        $$invalidate(1, windowWidth = window.innerWidth);
    }
    $$self.$$set = ($$props)=>{
        if ("step" in $$props) $$invalidate(0, step = $$props.step);
    };
    return [
        step,
        windowWidth,
        $appMetadata$,
        $_,
        connect,
        subheading,
        paragraph,
        heading,
        appMetadata$,
        onwindowresize
    ];
}
class $6697ff39d54b09bb$var$Sidebar extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$5, $6697ff39d54b09bb$var$create_fragment$5, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            step: 0
        }, $6697ff39d54b09bb$var$add_css$5);
    }
}
/* src/views/connect/Index.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$4(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-1qwmck3", ".container.svelte-1qwmck3{--background-color:var(\n      --onboard-main-scroll-container-background,\n      var(--w3o-background-color)\n    );--foreground-color:var(--w3o-foreground-color);--text-color:var(--onboard-connect-text-color, var(--w3o-text-color));--border-color:var(--w3o-border-color, var(--gray-200));--action-color:var(--w3o-action-color, var(--primary-500));font-family:var(--onboard-font-family-normal, var(--font-family-normal));font-size:var(--onboard-font-size-5, 1rem);background:var(--background-color);color:var(--text-color);border-color:var(--border-color);line-height:24px;overflow:hidden;position:relative;display:flex;height:min-content;flex-flow:column-reverse}.content.svelte-1qwmck3{width:var(--onboard-connect-content-width, 100%)}.header.svelte-1qwmck3{display:flex;padding:1rem;border-bottom:1px solid transparent;background:var(--onboard-connect-header-background);color:var(--onboard-connect-header-color);border-color:var(--border-color)}.header-heading.svelte-1qwmck3{line-height:1rem}.button-container.svelte-1qwmck3{right:0.5rem;top:0.5rem}.mobile-header.svelte-1qwmck3{display:flex;gap:0.5rem;height:4.5rem;padding:1rem;border-bottom:1px solid;border-color:var(--border-color)}.mobile-subheader.svelte-1qwmck3{opacity:0.6;font-size:0.875rem;font-weight:400;line-height:1rem;margin-top:0.25rem}.icon-container.svelte-1qwmck3{display:flex;flex:0 0 auto;height:2.5rem;width:2.5rem;min-width:2.5rem;justify-content:center;align-items:center}.disabled.svelte-1qwmck3{opacity:0.2;pointer-events:none;overflow:hidden}.icon-container svg{display:block;height:100%;width:auto}.w-full.svelte-1qwmck3{width:100%}.scroll-container.svelte-1qwmck3{overflow-y:auto;transition:opacity 250ms ease-in-out;scrollbar-width:none}.scroll-container.svelte-1qwmck3::-webkit-scrollbar{display:none}@media all and (min-width: 768px){.container.svelte-1qwmck3{margin:0;flex-flow:row;height:var(--onboard-connect-content-height, 440px)}.content.svelte-1qwmck3{width:var(--onboard-connect-content-width, 488px)}.mobile-subheader.svelte-1qwmck3{display:none}.icon-container.svelte-1qwmck3{display:none}}");
}
// (431:0) {#if !autoSelect.disableModals}
function $6697ff39d54b09bb$var$create_if_block$2(ctx) {
    let modal;
    let current;
    modal = new $6697ff39d54b09bb$export$8743009a87fcb00f({
        props: {
            close: !/*connect*/ ctx[16].disableClose && /*close*/ ctx[20],
            $$slots: {
                default: [
                    $6697ff39d54b09bb$var$create_default_slot$2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            $6697ff39d54b09bb$export$d66501df72047452(modal.$$.fragment);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$9bb611d729802a56(modal, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const modal_changes = {};
            if (dirty[0] & /*scrollContainer, selectedWallet, $modalStep$, windowWidth, connectionRejected, previousConnectionRequest, displayConnectingWallet, agreed, wallets, connectingWalletLabel, connectingErrorMessage, availableWallets, $_, $appMetadata$*/ 32766 | dirty[1] & /*$$scope*/ 32) modal_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            modal.$set(modal_changes);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(modal.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(modal.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $6697ff39d54b09bb$export$3466f893ebf79586(modal, detaching);
        }
    };
}
// (434:6) {#if connect.showSidebar}
function $6697ff39d54b09bb$var$create_if_block_9$1(ctx) {
    let sidebar;
    let current;
    sidebar = new $6697ff39d54b09bb$var$Sidebar({
        props: {
            step: /*$modalStep$*/ ctx[5]
        }
    });
    return {
        c () {
            $6697ff39d54b09bb$export$d66501df72047452(sidebar.$$.fragment);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$9bb611d729802a56(sidebar, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const sidebar_changes = {};
            if (dirty[0] & /*$modalStep$*/ 32) sidebar_changes.step = /*$modalStep$*/ ctx[5];
            sidebar.$set(sidebar_changes);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(sidebar.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(sidebar.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $6697ff39d54b09bb$export$3466f893ebf79586(sidebar, detaching);
        }
    };
}
// (477:8) {:else}
function $6697ff39d54b09bb$var$create_else_block_3(ctx) {
    let div1;
    let div0;
    let t0_value = /*$_*/ ctx[14](`connect.${ctx[5]}.header`, {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].header,
        values: {
            connectionRejected: /*connectionRejected*/ ctx[1],
            wallet: /*selectedWallet*/ ctx[3] && /*selectedWallet*/ ctx[3].label
        }
    }) + "";
    let t0;
    let t1;
    let t2_value = /*$modalStep$*/ (ctx[5] === "selectingWallet" ? `(${ctx[12]})` : "") + "";
    let t2;
    return {
        c () {
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t0 = $6697ff39d54b09bb$export$625550452a3fa3ec(t0_value);
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            t2 = $6697ff39d54b09bb$export$625550452a3fa3ec(t2_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "header-heading svelte-1qwmck3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "header relative flex items-center svelte-1qwmck3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div1, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, div0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div0, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div0, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div0, t2);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$_, $modalStep$, connectionRejected, selectedWallet*/ 16426 && t0_value !== (t0_value = /*$_*/ ctx[14](`connect.${ctx[5]}.header`, {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].header,
                values: {
                    connectionRejected: /*connectionRejected*/ ctx[1],
                    wallet: /*selectedWallet*/ ctx[3] && /*selectedWallet*/ ctx[3].label
                }
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t0, t0_value);
            if (dirty[0] & /*$modalStep$, availableWallets*/ 4128 && t2_value !== (t2_value = /*$modalStep$*/ (ctx[5] === "selectingWallet" ? `(${ctx[12]})` : "") + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t2, t2_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div1);
        }
    };
}
// (439:8) {#if windowWidth <= MOBILE_WINDOW_WIDTH}
function $6697ff39d54b09bb$var$create_if_block_6$1(ctx) {
    let div4;
    let div0;
    let t0;
    let div3;
    let div1;
    let t1_value = /*$_*/ ctx[14](/*$modalStep$*/ ctx[5] === "connectingWallet" && /*selectedWallet*/ ctx[3] ? `connect.${ctx[5]}.header` : `connect.${ctx[5]}.sidebar.subheading`, {
        default: /*$modalStep$*/ ctx[5] === "connectingWallet" && /*selectedWallet*/ ctx[3] ? $6697ff39d54b09bb$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].header : $6697ff39d54b09bb$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].sidebar.subheading,
        values: {
            connectionRejected: /*connectionRejected*/ ctx[1],
            wallet: /*selectedWallet*/ ctx[3] && /*selectedWallet*/ ctx[3].label
        }
    }) + "";
    let t1;
    let t2;
    let div2;
    let t3_value = /*$modalStep$*/ (ctx[5] === "selectingWallet" ? `${ctx[12]} available wallets` : "1 account selected") + "";
    let t3;
    function select_block_type_1(ctx, dirty) {
        if (/*$appMetadata$*/ ctx[13] && /*$appMetadata$*/ ctx[13].icon) return $6697ff39d54b09bb$var$create_if_block_7$1;
        return $6697ff39d54b09bb$var$create_else_block_2;
    }
    let current_block_type = select_block_type_1(ctx);
    let if_block = current_block_type(ctx);
    return {
        c () {
            div4 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if_block.c();
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div3 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t1 = $6697ff39d54b09bb$export$625550452a3fa3ec(t1_value);
            t2 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div2 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            t3 = $6697ff39d54b09bb$export$625550452a3fa3ec(t3_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "icon-container svelte-1qwmck3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "header-heading svelte-1qwmck3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "class", "mobile-subheader svelte-1qwmck3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div3, "class", "flex flex-column justify-center w-full svelte-1qwmck3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div4, "class", "mobile-header svelte-1qwmck3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div4, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, div0);
            if_block.m(div0, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div4, div3);
            $6697ff39d54b09bb$export$953cecd6e717a553(div3, div1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div3, t2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div3, div2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, t3);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type_1(ctx)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(div0, null);
                }
            }
            if (dirty[0] & /*$_, $modalStep$, selectedWallet, connectionRejected*/ 16426 && t1_value !== (t1_value = /*$_*/ ctx[14](/*$modalStep$*/ ctx[5] === "connectingWallet" && /*selectedWallet*/ ctx[3] ? `connect.${ctx[5]}.header` : `connect.${ctx[5]}.sidebar.subheading`, {
                default: /*$modalStep$*/ ctx[5] === "connectingWallet" && /*selectedWallet*/ ctx[3] ? $6697ff39d54b09bb$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].header : $6697ff39d54b09bb$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].sidebar.subheading,
                values: {
                    connectionRejected: /*connectionRejected*/ ctx[1],
                    wallet: /*selectedWallet*/ ctx[3] && /*selectedWallet*/ ctx[3].label
                }
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t1, t1_value);
            if (dirty[0] & /*$modalStep$, availableWallets*/ 4128 && t3_value !== (t3_value = /*$modalStep$*/ (ctx[5] === "selectingWallet" ? `${ctx[12]} available wallets` : "1 account selected") + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t3, t3_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div4);
            if_block.d();
        }
    };
}
// (448:14) {:else}
function $6697ff39d54b09bb$var$create_else_block_2(ctx) {
    let html_tag;
    let html_anchor;
    return {
        c () {
            html_tag = new $6697ff39d54b09bb$export$ce26c07117d59d6a(false);
            html_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m($6697ff39d54b09bb$var$defaultBnIcon, target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (442:14) {#if $appMetadata$ && $appMetadata$.icon}
function $6697ff39d54b09bb$var$create_if_block_7$1(ctx) {
    let show_if;
    let if_block_anchor;
    function select_block_type_2(ctx, dirty) {
        if (dirty[0] & /*$appMetadata$*/ 8192) show_if = null;
        if (show_if == null) show_if = !!$6697ff39d54b09bb$export$34aec0b863436764(/*$appMetadata$*/ ctx[13].icon);
        if (show_if) return $6697ff39d54b09bb$var$create_if_block_8$1;
        return $6697ff39d54b09bb$var$create_else_block_1;
    }
    let current_block_type = select_block_type_2(ctx, [
        -1,
        -1
    ]);
    let if_block = current_block_type(ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if_block.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type_2(ctx, dirty)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            }
        },
        d (detaching) {
            if_block.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (445:16) {:else}
function $6697ff39d54b09bb$var$create_else_block_1(ctx) {
    let img;
    let img_src_value;
    return {
        c () {
            img = $6697ff39d54b09bb$export$35e795649ee09318("img");
            if (!$6697ff39d54b09bb$export$3c2fa207a37baaea(img.src, img_src_value = /*$appMetadata$*/ ctx[13].icon)) $6697ff39d54b09bb$export$342063e11d6c3cad(img, "src", img_src_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(img, "alt", "logo");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, img, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$appMetadata$*/ 8192 && !$6697ff39d54b09bb$export$3c2fa207a37baaea(img.src, img_src_value = /*$appMetadata$*/ ctx[13].icon)) $6697ff39d54b09bb$export$342063e11d6c3cad(img, "src", img_src_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(img);
        }
    };
}
// (443:16) {#if isSVG($appMetadata$.icon)}
function $6697ff39d54b09bb$var$create_if_block_8$1(ctx) {
    let html_tag;
    let raw_value = /*$appMetadata$*/ ctx[13].icon + "";
    let html_anchor;
    return {
        c () {
            html_tag = new $6697ff39d54b09bb$export$ce26c07117d59d6a(false);
            html_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m(raw_value, target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$appMetadata$*/ 8192 && raw_value !== (raw_value = /*$appMetadata$*/ ctx[13].icon + "")) html_tag.p(raw_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (491:8) {#if !connect.disableClose}
function $6697ff39d54b09bb$var$create_if_block_5$1(ctx) {
    let div;
    let closebutton;
    let current;
    let mounted;
    let dispose;
    closebutton = new $6697ff39d54b09bb$var$CloseButton({});
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(closebutton.$$.fragment);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "button-container absolute svelte-1qwmck3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            $6697ff39d54b09bb$export$9bb611d729802a56(closebutton, div, null);
            current = true;
            if (!mounted) {
                dispose = $6697ff39d54b09bb$export$ffb5f4729a158638(div, "click", /*close*/ ctx[20]);
                mounted = true;
            }
        },
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(closebutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(closebutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            $6697ff39d54b09bb$export$3466f893ebf79586(closebutton);
            mounted = false;
            dispose();
        }
    };
}
// (498:10) {#if $modalStep$ === 'selectingWallet' || windowWidth <= MOBILE_WINDOW_WIDTH}
function $6697ff39d54b09bb$var$create_if_block_3$1(ctx) {
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    const if_block_creators = [
        $6697ff39d54b09bb$var$create_if_block_4$1,
        $6697ff39d54b09bb$var$create_else_block
    ];
    const if_blocks = [];
    function select_block_type_3(ctx, dirty) {
        if (/*wallets*/ ctx[2].length) return 0;
        return 1;
    }
    current_block_type_index = select_block_type_3(ctx);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if_blocks[current_block_type_index].m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type_3(ctx);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block, 1);
                if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (510:12) {:else}
function $6697ff39d54b09bb$var$create_else_block(ctx) {
    let installwallet;
    let current;
    installwallet = new $6697ff39d54b09bb$var$InstallWallet({});
    return {
        c () {
            $6697ff39d54b09bb$export$d66501df72047452(installwallet.$$.fragment);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$9bb611d729802a56(installwallet, target, anchor);
            current = true;
        },
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(installwallet.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(installwallet.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $6697ff39d54b09bb$export$3466f893ebf79586(installwallet, detaching);
        }
    };
}
// (499:12) {#if wallets.length}
function $6697ff39d54b09bb$var$create_if_block_4$1(ctx) {
    let agreement;
    let updating_agreed;
    let t;
    let div;
    let selectingwallet;
    let current;
    function agreement_agreed_binding(value) {
        /*agreement_agreed_binding*/ ctx[24](value);
    }
    let agreement_props = {};
    if (/*agreed*/ ctx[7] !== void 0) agreement_props.agreed = /*agreed*/ ctx[7];
    agreement = new $6697ff39d54b09bb$var$Agreement({
        props: agreement_props
    });
    $6697ff39d54b09bb$export$39b482c5e57630a8.push(()=>$6697ff39d54b09bb$export$2219238a014317b0(agreement, "agreed", agreement_agreed_binding));
    selectingwallet = new $6697ff39d54b09bb$var$SelectingWallet({
        props: {
            selectWallet: /*selectWallet*/ ctx[18],
            wallets: /*wallets*/ ctx[2],
            connectingWalletLabel: /*connectingWalletLabel*/ ctx[8],
            connectingErrorMessage: /*connectingErrorMessage*/ ctx[9]
        }
    });
    return {
        c () {
            $6697ff39d54b09bb$export$d66501df72047452(agreement.$$.fragment);
            t = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(selectingwallet.$$.fragment);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "svelte-1qwmck3");
            $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "disabled", !/*agreed*/ ctx[7]);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$9bb611d729802a56(agreement, target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            $6697ff39d54b09bb$export$9bb611d729802a56(selectingwallet, div, null);
            current = true;
        },
        p (ctx, dirty) {
            const agreement_changes = {};
            if (!updating_agreed && dirty[0] & /*agreed*/ 128) {
                updating_agreed = true;
                agreement_changes.agreed = /*agreed*/ ctx[7];
                $6697ff39d54b09bb$export$4c3d22f3d993c33f(()=>updating_agreed = false);
            }
            agreement.$set(agreement_changes);
            const selectingwallet_changes = {};
            if (dirty[0] & /*wallets*/ 4) selectingwallet_changes.wallets = /*wallets*/ ctx[2];
            if (dirty[0] & /*connectingWalletLabel*/ 256) selectingwallet_changes.connectingWalletLabel = /*connectingWalletLabel*/ ctx[8];
            if (dirty[0] & /*connectingErrorMessage*/ 512) selectingwallet_changes.connectingErrorMessage = /*connectingErrorMessage*/ ctx[9];
            selectingwallet.$set(selectingwallet_changes);
            if (!current || dirty[0] & /*agreed*/ 128) $6697ff39d54b09bb$export$7f8ddf7c7c20b3cd(div, "disabled", !/*agreed*/ ctx[7]);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(agreement.$$.fragment, local);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(selectingwallet.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(agreement.$$.fragment, local);
            $6697ff39d54b09bb$export$ebd11618f299a286(selectingwallet.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $6697ff39d54b09bb$export$3466f893ebf79586(agreement, detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            $6697ff39d54b09bb$export$3466f893ebf79586(selectingwallet);
        }
    };
}
// (515:10) {#if displayConnectingWallet}
function $6697ff39d54b09bb$var$create_if_block_2$1(ctx) {
    let connectingwallet;
    let current;
    connectingwallet = new $6697ff39d54b09bb$var$ConnectingWallet({
        props: {
            connectWallet: /*connectWallet*/ ctx[21],
            connectionRejected: /*connectionRejected*/ ctx[1],
            previousConnectionRequest: /*previousConnectionRequest*/ ctx[6],
            setStep: /*setStep*/ ctx[22],
            deselectWallet: /*deselectWallet*/ ctx[19],
            selectedWallet: /*selectedWallet*/ ctx[3]
        }
    });
    return {
        c () {
            $6697ff39d54b09bb$export$d66501df72047452(connectingwallet.$$.fragment);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$9bb611d729802a56(connectingwallet, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const connectingwallet_changes = {};
            if (dirty[0] & /*connectionRejected*/ 2) connectingwallet_changes.connectionRejected = /*connectionRejected*/ ctx[1];
            if (dirty[0] & /*previousConnectionRequest*/ 64) connectingwallet_changes.previousConnectionRequest = /*previousConnectionRequest*/ ctx[6];
            if (dirty[0] & /*selectedWallet*/ 8) connectingwallet_changes.selectedWallet = /*selectedWallet*/ ctx[3];
            connectingwallet.$set(connectingwallet_changes);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(connectingwallet.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(connectingwallet.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $6697ff39d54b09bb$export$3466f893ebf79586(connectingwallet, detaching);
        }
    };
}
// (526:10) {#if $modalStep$ === 'connectedWallet' && selectedWallet && windowWidth >= MOBILE_WINDOW_WIDTH}
function $6697ff39d54b09bb$var$create_if_block_1$1(ctx) {
    let connectedwallet;
    let current;
    connectedwallet = new $6697ff39d54b09bb$var$ConnectedWallet({
        props: {
            selectedWallet: /*selectedWallet*/ ctx[3]
        }
    });
    return {
        c () {
            $6697ff39d54b09bb$export$d66501df72047452(connectedwallet.$$.fragment);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$9bb611d729802a56(connectedwallet, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const connectedwallet_changes = {};
            if (dirty[0] & /*selectedWallet*/ 8) connectedwallet_changes.selectedWallet = /*selectedWallet*/ ctx[3];
            connectedwallet.$set(connectedwallet_changes);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(connectedwallet.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(connectedwallet.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $6697ff39d54b09bb$export$3466f893ebf79586(connectedwallet, detaching);
        }
    };
}
// (432:2) <Modal close={!connect.disableClose && close}>
function $6697ff39d54b09bb$var$create_default_slot$2(ctx) {
    let div2;
    let t0;
    let div1;
    let t1;
    let t2;
    let div0;
    let t3;
    let t4;
    let current;
    let if_block0 = /*connect*/ ctx[16].showSidebar && $6697ff39d54b09bb$var$create_if_block_9$1(ctx);
    function select_block_type(ctx, dirty) {
        if (/*windowWidth*/ ctx[4] <= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH) return $6697ff39d54b09bb$var$create_if_block_6$1;
        return $6697ff39d54b09bb$var$create_else_block_3;
    }
    let current_block_type = select_block_type(ctx);
    let if_block1 = current_block_type(ctx);
    let if_block2 = !/*connect*/ ctx[16].disableClose && $6697ff39d54b09bb$var$create_if_block_5$1(ctx);
    let if_block3 = /*$modalStep$*/ (ctx[5] === "selectingWallet" || /*windowWidth*/ ctx[4] <= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH) && $6697ff39d54b09bb$var$create_if_block_3$1(ctx);
    let if_block4 = /*displayConnectingWallet*/ ctx[11] && $6697ff39d54b09bb$var$create_if_block_2$1(ctx);
    let if_block5 = /*$modalStep$*/ ctx[5] === "connectedWallet" && /*selectedWallet*/ ctx[3] && /*windowWidth*/ ctx[4] >= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH && $6697ff39d54b09bb$var$create_if_block_1$1(ctx);
    return {
        c () {
            div2 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if_block1.c();
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block2) if_block2.c();
            t2 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if (if_block3) if_block3.c();
            t3 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block4) if_block4.c();
            t4 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block5) if_block5.c();
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "scroll-container svelte-1qwmck3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "content flex flex-column svelte-1qwmck3");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div2, "class", "container svelte-1qwmck3");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div2, anchor);
            if (if_block0) if_block0.m(div2, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div2, div1);
            if_block1.m(div1, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t1);
            if (if_block2) if_block2.m(div1, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, div0);
            if (if_block3) if_block3.m(div0, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div0, t3);
            if (if_block4) if_block4.m(div0, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div0, t4);
            if (if_block5) if_block5.m(div0, null);
            /*div0_binding*/ ctx[25](div0);
            current = true;
        },
        p (ctx, dirty) {
            if (/*connect*/ ctx[16].showSidebar) if_block0.p(ctx, dirty);
            if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block1) if_block1.p(ctx, dirty);
            else {
                if_block1.d(1);
                if_block1 = current_block_type(ctx);
                if (if_block1) {
                    if_block1.c();
                    if_block1.m(div1, t1);
                }
            }
            if (!/*connect*/ ctx[16].disableClose) if_block2.p(ctx, dirty);
            if (/*$modalStep$*/ ctx[5] === "selectingWallet" || /*windowWidth*/ ctx[4] <= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH) {
                if (if_block3) {
                    if_block3.p(ctx, dirty);
                    if (dirty[0] & /*$modalStep$, windowWidth*/ 48) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block3, 1);
                } else {
                    if_block3 = $6697ff39d54b09bb$var$create_if_block_3$1(ctx);
                    if_block3.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block3, 1);
                    if_block3.m(div0, t3);
                }
            } else if (if_block3) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block3, 1, 1, ()=>{
                    if_block3 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
            if (/*displayConnectingWallet*/ ctx[11]) {
                if (if_block4) {
                    if_block4.p(ctx, dirty);
                    if (dirty[0] & /*displayConnectingWallet*/ 2048) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block4, 1);
                } else {
                    if_block4 = $6697ff39d54b09bb$var$create_if_block_2$1(ctx);
                    if_block4.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block4, 1);
                    if_block4.m(div0, t4);
                }
            } else if (if_block4) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block4, 1, 1, ()=>{
                    if_block4 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
            if (/*$modalStep$*/ ctx[5] === "connectedWallet" && /*selectedWallet*/ ctx[3] && /*windowWidth*/ ctx[4] >= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH) {
                if (if_block5) {
                    if_block5.p(ctx, dirty);
                    if (dirty[0] & /*$modalStep$, selectedWallet, windowWidth*/ 56) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block5, 1);
                } else {
                    if_block5 = $6697ff39d54b09bb$var$create_if_block_1$1(ctx);
                    if_block5.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block5, 1);
                    if_block5.m(div0, null);
                }
            } else if (if_block5) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block5, 1, 1, ()=>{
                    if_block5 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block0);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block2);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block3);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block4);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block5);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block0);
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block2);
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block3);
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block4);
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block5);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div2);
            if (if_block0) if_block0.d();
            if_block1.d();
            if (if_block2) if_block2.d();
            if (if_block3) if_block3.d();
            if (if_block4) if_block4.d();
            if (if_block5) if_block5.d();
            /*div0_binding*/ ctx[25](null);
        }
    };
}
function $6697ff39d54b09bb$var$create_fragment$4(ctx) {
    let if_block_anchor;
    let current;
    let mounted;
    let dispose;
    $6697ff39d54b09bb$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[23]);
    let if_block = !/*autoSelect*/ ctx[0].disableModals && $6697ff39d54b09bb$var$create_if_block$2(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
            if (!mounted) {
                dispose = $6697ff39d54b09bb$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[23]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (!/*autoSelect*/ ctx[0].disableModals) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty[0] & /*autoSelect*/ 1) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block, 1);
                } else {
                    if_block = $6697ff39d54b09bb$var$create_if_block$2(ctx);
                    if_block.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block, 1);
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            } else if (if_block) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block_anchor);
            mounted = false;
            dispose();
        }
    };
}
function $6697ff39d54b09bb$var$instance$4($$self, $$props, $$invalidate) {
    let availableWallets;
    let displayConnectingWallet;
    let $appMetadata$;
    let $modalStep$;
    let $_;
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, (0, $6y4qQ._), ($$value)=>$$invalidate(14, $_ = $$value));
    let { autoSelect: autoSelect } = $$props;
    const appMetadata$ = $6697ff39d54b09bb$export$6559d589eb85fbb6.select("appMetadata").pipe((0, $fy9c8.startWith)($6697ff39d54b09bb$export$6559d589eb85fbb6.get().appMetadata), (0, $hDTQV.shareReplay)(1));
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(13, $appMetadata$ = value));
    const { unstoppableResolution: unstoppableResolution, device: device } = $6697ff39d54b09bb$export$c9170ad7d4cd7e57;
    const { walletModules: walletModules, connect: connect, chains: chains } = $6697ff39d54b09bb$export$6559d589eb85fbb6.get();
    const cancelPreviousConnect$ = new (0, $3TBY8.Subject)();
    let connectionRejected = false;
    let previousConnectionRequest = false;
    let wallets = [];
    let selectedWallet;
    let agreed;
    let connectingWalletLabel;
    let connectingErrorMessage;
    let windowWidth;
    let scrollContainer;
    const modalStep$ = new (0, $axHCK.BehaviorSubject)("selectingWallet");
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, modalStep$, (value)=>$$invalidate(5, $modalStep$ = value));
    // handle the edge case where disableModals was set to true on first call
    // and then set to false on second call and there is still a pending call
    $6697ff39d54b09bb$export$a07804094c3ecf2d.pipe((0, $9AGP8.distinctUntilChanged)((prev, curr)=>prev.autoSelect && curr.autoSelect && prev.autoSelect.disableModals === curr.autoSelect.disableModals), (0, $d6DLj.filter)(({ autoSelect: autoSelect })=>autoSelect && autoSelect.disableModals === false), (0, $jXWpp.takeUntil)($6697ff39d54b09bb$var$onDestroy$)).subscribe(()=>{
        selectedWallet && connectWallet();
    });
    // ==== SELECT WALLET ==== //
    async function selectWallet({ label: label, icon: icon, getInterface: getInterface }) {
        $$invalidate(8, connectingWalletLabel = label);
        try {
            const existingWallet = $6697ff39d54b09bb$export$6559d589eb85fbb6.get().wallets.find((wallet)=>wallet.label === label);
            if (existingWallet) {
                // set as first wallet
                $6697ff39d54b09bb$var$addWallet(existingWallet);
                setTimeout(()=>setStep("connectedWallet"), 1);
                $$invalidate(3, selectedWallet = existingWallet);
                return;
            }
            const { chains: chains } = $6697ff39d54b09bb$export$6559d589eb85fbb6.get();
            const { provider: provider, instance: instance } = await getInterface({
                chains: chains,
                BigNumber: (0, $kVZhy.BigNumber),
                EventEmitter: (/*@__PURE__*/$parcel$interopDefault($3vRz3)),
                appMetadata: $appMetadata$
            });
            const loadedIcon = await icon;
            $$invalidate(3, selectedWallet = {
                label: label,
                icon: loadedIcon,
                provider: provider,
                instance: instance,
                accounts: [],
                chains: [
                    {
                        namespace: "evm",
                        id: "0x1"
                    }
                ]
            });
            $$invalidate(9, connectingErrorMessage = "");
            scrollToTop();
            // change step on next event loop
            setTimeout(()=>setStep("connectingWallet"), 1);
        } catch (error) {
            const { message: message } = error;
            $$invalidate(9, connectingErrorMessage = message);
            $$invalidate(8, connectingWalletLabel = "");
            scrollToTop();
        }
    }
    function deselectWallet() {
        $$invalidate(3, selectedWallet = null);
    }
    function updateSelectedWallet(update) {
        $$invalidate(3, selectedWallet = {
            ...selectedWallet,
            ...update
        });
    }
    async function autoSelectWallet(wallet) {
        const { getIcon: getIcon, getInterface: getInterface, label: label } = wallet;
        const icon = getIcon();
        selectWallet({
            label: label,
            icon: icon,
            getInterface: getInterface
        });
    }
    async function loadWalletsForSelection() {
        $$invalidate(2, wallets = walletModules.map(({ getIcon: getIcon, getInterface: getInterface, label: label })=>{
            return {
                label: label,
                icon: getIcon(),
                getInterface: getInterface
            };
        }));
    }
    function close() {
        $6697ff39d54b09bb$export$a07804094c3ecf2d.next({
            inProgress: false
        });
    }
    // ==== CONNECT WALLET ==== //
    async function connectWallet() {
        $$invalidate(1, connectionRejected = false);
        const { provider: provider, label: label } = selectedWallet;
        cancelPreviousConnect$.next();
        try {
            const [address] = await Promise.race([
                // resolved account
                $6697ff39d54b09bb$var$requestAccounts(provider),
                // or connect wallet is called again whilst waiting for response
                (0, $jKULm.firstValueFrom)(cancelPreviousConnect$.pipe((0, $8Ydqd.mapTo)([])))
            ]);
            // canceled previous request
            if (!address) return;
            // store last connected wallet
            if ($6697ff39d54b09bb$export$6559d589eb85fbb6.get().connect.autoConnectLastWallet || $6697ff39d54b09bb$export$6559d589eb85fbb6.get().connect.autoConnectAllPreviousWallet) {
                let labelsList = $6697ff39d54b09bb$var$getLocalStore($6697ff39d54b09bb$var$STORAGE_KEYS.LAST_CONNECTED_WALLET);
                try {
                    let labelsListParsed = JSON.parse(labelsList);
                    if (labelsListParsed && Array.isArray(labelsListParsed)) {
                        const tempLabels = labelsListParsed;
                        labelsList = [
                            ...new Set([
                                label,
                                ...tempLabels
                            ])
                        ];
                    }
                } catch (err) {
                    if (err instanceof SyntaxError && labelsList && typeof labelsList === "string") {
                        const tempLabel = labelsList;
                        labelsList = [
                            tempLabel
                        ];
                    } else throw new Error(err);
                }
                if (!labelsList) labelsList = [
                    label
                ];
                $6697ff39d54b09bb$var$setLocalStore($6697ff39d54b09bb$var$STORAGE_KEYS.LAST_CONNECTED_WALLET, JSON.stringify(labelsList));
            }
            const chain = await $6697ff39d54b09bb$var$getChainId(provider);
            if ($6697ff39d54b09bb$export$6559d589eb85fbb6.get().notify.enabled) {
                const sdk = await $6697ff39d54b09bb$var$getBNMulitChainSdk();
                if (sdk) try {
                    sdk.subscribe({
                        id: address,
                        chainId: chain,
                        type: "account"
                    });
                } catch (error) {} // unsupported network for transaction events
            }
            const update = {
                accounts: [
                    {
                        address: address,
                        ens: null,
                        uns: null,
                        balance: null
                    }
                ],
                chains: [
                    {
                        namespace: "evm",
                        id: chain
                    }
                ]
            };
            $6697ff39d54b09bb$var$addWallet({
                ...selectedWallet,
                ...update
            });
            $6697ff39d54b09bb$var$trackWallet(provider, label);
            updateSelectedWallet(update);
            setStep("connectedWallet");
            scrollToTop();
        } catch (error) {
            const { code: code } = error;
            scrollToTop();
            // user rejected account access
            if (code === (0, $7oBBe.ProviderRpcErrorCode).ACCOUNT_ACCESS_REJECTED) {
                $$invalidate(1, connectionRejected = true);
                if (autoSelect.disableModals) $6697ff39d54b09bb$export$a07804094c3ecf2d.next({
                    inProgress: false
                });
                else if (autoSelect.label) $$invalidate(0, autoSelect.label = "", autoSelect);
                return;
            }
            // account access has already been requested and is awaiting approval
            if (code === (0, $7oBBe.ProviderRpcErrorCode).ACCOUNT_ACCESS_ALREADY_REQUESTED) {
                $$invalidate(6, previousConnectionRequest = true);
                if (autoSelect.disableModals) {
                    $6697ff39d54b09bb$export$a07804094c3ecf2d.next({
                        inProgress: false
                    });
                    return;
                }
                $6697ff39d54b09bb$var$listenAccountsChanged({
                    provider: selectedWallet.provider,
                    disconnected$: $6697ff39d54b09bb$export$a07804094c3ecf2d.pipe((0, $d6DLj.filter)(({ inProgress: inProgress })=>!inProgress), (0, $8Ydqd.mapTo)(""))
                }).pipe((0, $jGgch.take)(1)).subscribe(([account])=>{
                    account && connectWallet();
                });
                return;
            }
        }
    }
    // ==== CONNECTED WALLET ==== //
    async function updateAccountDetails() {
        const { accounts: accounts, chains: selectedWalletChains } = selectedWallet;
        const appChains = $6697ff39d54b09bb$export$6559d589eb85fbb6.get().chains;
        const [connectedWalletChain] = selectedWalletChains;
        const appChain = appChains.find(({ namespace: namespace, id: id })=>namespace === connectedWalletChain.namespace && id === connectedWalletChain.id);
        const { address: address } = accounts[0];
        let { balance: balance, ens: ens, uns: uns, secondaryTokens: secondaryTokens } = accounts[0];
        if (balance === null) $6697ff39d54b09bb$var$getBalance(address, appChain).then((balance)=>{
            $6697ff39d54b09bb$var$updateAccount(selectedWallet.label, address, {
                balance: balance
            });
        });
        if (appChain && !secondaryTokens && Array.isArray(appChain.secondaryTokens) && appChain.secondaryTokens.length) $6697ff39d54b09bb$var$updateSecondaryTokens(selectedWallet, address, appChain).then((secondaryTokens)=>{
            $6697ff39d54b09bb$var$updateAccount(selectedWallet.label, address, {
                secondaryTokens: secondaryTokens
            });
        });
        if (ens === null && $6697ff39d54b09bb$var$validEnsChain(connectedWalletChain.id)) {
            const ensChain = chains.find(({ id: id })=>id === $6697ff39d54b09bb$var$validEnsChain(connectedWalletChain.id));
            $6697ff39d54b09bb$var$getEns(address, ensChain).then((ens)=>{
                $6697ff39d54b09bb$var$updateAccount(selectedWallet.label, address, {
                    ens: ens
                });
            });
        }
        if (uns === null && unstoppableResolution) $6697ff39d54b09bb$var$getUns(address, appChain).then((uns)=>{
            $6697ff39d54b09bb$var$updateAccount(selectedWallet.label, address, {
                uns: uns
            });
        });
        setTimeout(()=>$6697ff39d54b09bb$export$a07804094c3ecf2d.next({
                inProgress: false
            }), 1500);
    }
    modalStep$.pipe((0, $jXWpp.takeUntil)($6697ff39d54b09bb$var$onDestroy$)).subscribe((step)=>{
        switch(step){
            case "selectingWallet":
                if (autoSelect.label) {
                    const walletToAutoSelect = walletModules.find(({ label: label })=>label.toLowerCase() === autoSelect.label.toLowerCase());
                    if (walletToAutoSelect) autoSelectWallet(walletToAutoSelect);
                    else if (autoSelect.disableModals) $6697ff39d54b09bb$export$a07804094c3ecf2d.next({
                        inProgress: false
                    });
                } else {
                    $$invalidate(8, connectingWalletLabel = "");
                    loadWalletsForSelection();
                }
                break;
            case "connectingWallet":
                connectWallet();
                break;
            case "connectedWallet":
                $$invalidate(8, connectingWalletLabel = "");
                updateAccountDetails();
                break;
        }
    });
    function setStep(update) {
        cancelPreviousConnect$.next();
        modalStep$.next(update);
    }
    function scrollToTop() {
        scrollContainer && scrollContainer.scrollTo(0, 0);
    }
    function onwindowresize() {
        $$invalidate(4, windowWidth = window.innerWidth);
    }
    function agreement_agreed_binding(value) {
        agreed = value;
        $$invalidate(7, agreed);
    }
    function div0_binding($$value) {
        $6697ff39d54b09bb$export$39b482c5e57630a8[$$value ? "unshift" : "push"](()=>{
            scrollContainer = $$value;
            $$invalidate(10, scrollContainer);
        });
    }
    $$self.$$set = ($$props)=>{
        if ("autoSelect" in $$props) $$invalidate(0, autoSelect = $$props.autoSelect);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty[0] & /*wallets*/ 4) $$invalidate(12, availableWallets = wallets.length - $6697ff39d54b09bb$export$6559d589eb85fbb6.get().wallets.length);
        if ($$self.$$.dirty[0] & /*$modalStep$, selectedWallet, windowWidth, connectionRejected*/ 58) $$invalidate(11, displayConnectingWallet = $modalStep$ === "connectingWallet" && selectedWallet && windowWidth >= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH || windowWidth <= $6697ff39d54b09bb$var$MOBILE_WINDOW_WIDTH && connectionRejected && $modalStep$ === "connectingWallet" && selectedWallet);
    };
    return [
        autoSelect,
        connectionRejected,
        wallets,
        selectedWallet,
        windowWidth,
        $modalStep$,
        previousConnectionRequest,
        agreed,
        connectingWalletLabel,
        connectingErrorMessage,
        scrollContainer,
        displayConnectingWallet,
        availableWallets,
        $appMetadata$,
        $_,
        appMetadata$,
        connect,
        modalStep$,
        selectWallet,
        deselectWallet,
        close,
        connectWallet,
        setStep,
        onwindowresize,
        agreement_agreed_binding,
        div0_binding
    ];
}
class $6697ff39d54b09bb$var$Index$1 extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$4, $6697ff39d54b09bb$var$create_fragment$4, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            autoSelect: 0
        }, $6697ff39d54b09bb$var$add_css$4, [
            -1,
            -1
        ]);
    }
}
/* src/views/chain/SwitchChain.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$3(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-12yam41", ".container.svelte-12yam41{padding:var(--onboard-spacing-4, var(--spacing-4));font-family:var(--onboard-font-family-normal, var(--font-family-normal));line-height:16px;font-size:var(--onboard-font-size-5, var(--font-size-5))}.close.svelte-12yam41{top:var(--onboard-spacing-5, var(--spacing-5));right:var(--onboard-spacing-5, var(--spacing-5));padding:0.5rem}h4.svelte-12yam41{font-size:var(--onboard-font-size-3, var(--font-size-3));margin:var(--onboard-spacing-4, var(--spacing-4)) 0}p.svelte-12yam41{margin:0 0 var(--onboard-spacing-4, var(--spacing-4)) 0;max-width:488px}");
}
// (43:0) <Modal {close}>
function $6697ff39d54b09bb$var$create_default_slot$1(ctx) {
    let div1;
    let h4;
    let t0_value = /*$_*/ ctx[0]("modals.switchChain.heading", {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.modals.switchChain.heading
    }) + "";
    let t0;
    let t1;
    let p0;
    let t2_value = /*$_*/ ctx[0]("modals.switchChain.paragraph1", {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.modals.switchChain.paragraph1,
        values: {
            app: /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].name || "This app",
            nextNetworkName: /*nextNetworkName*/ ctx[2]
        }
    }) + "";
    let t2;
    let t3;
    let p1;
    let t4_value = /*$_*/ ctx[0]("modals.switchChain.paragraph2", {
        default: $6697ff39d54b09bb$export$e7094788287c5e9b.modals.switchChain.paragraph2
    }) + "";
    let t4;
    let t5;
    let div0;
    let closebutton;
    let current;
    let mounted;
    let dispose;
    closebutton = new $6697ff39d54b09bb$var$CloseButton({});
    return {
        c () {
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            h4 = $6697ff39d54b09bb$export$35e795649ee09318("h4");
            t0 = $6697ff39d54b09bb$export$625550452a3fa3ec(t0_value);
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            p0 = $6697ff39d54b09bb$export$35e795649ee09318("p");
            t2 = $6697ff39d54b09bb$export$625550452a3fa3ec(t2_value);
            t3 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            p1 = $6697ff39d54b09bb$export$35e795649ee09318("p");
            t4 = $6697ff39d54b09bb$export$625550452a3fa3ec(t4_value);
            t5 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(closebutton.$$.fragment);
            $6697ff39d54b09bb$export$342063e11d6c3cad(h4, "class", "svelte-12yam41");
            $6697ff39d54b09bb$export$342063e11d6c3cad(p0, "class", "svelte-12yam41");
            $6697ff39d54b09bb$export$342063e11d6c3cad(p1, "class", "svelte-12yam41");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "close absolute svelte-12yam41");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "container relative svelte-12yam41");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div1, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, h4);
            $6697ff39d54b09bb$export$953cecd6e717a553(h4, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, p0);
            $6697ff39d54b09bb$export$953cecd6e717a553(p0, t2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t3);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, p1);
            $6697ff39d54b09bb$export$953cecd6e717a553(p1, t4);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t5);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, div0);
            $6697ff39d54b09bb$export$9bb611d729802a56(closebutton, div0, null);
            current = true;
            if (!mounted) {
                dispose = $6697ff39d54b09bb$export$ffb5f4729a158638(div0, "click", /*close*/ ctx[3]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if ((!current || dirty & /*$_*/ 1) && t0_value !== (t0_value = /*$_*/ ctx[0]("modals.switchChain.heading", {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.modals.switchChain.heading
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t0, t0_value);
            if ((!current || dirty & /*$_, $appMetadata$*/ 3) && t2_value !== (t2_value = /*$_*/ ctx[0]("modals.switchChain.paragraph1", {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.modals.switchChain.paragraph1,
                values: {
                    app: /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].name || "This app",
                    nextNetworkName: /*nextNetworkName*/ ctx[2]
                }
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t2, t2_value);
            if ((!current || dirty & /*$_*/ 1) && t4_value !== (t4_value = /*$_*/ ctx[0]("modals.switchChain.paragraph2", {
                default: $6697ff39d54b09bb$export$e7094788287c5e9b.modals.switchChain.paragraph2
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t4, t4_value);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(closebutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(closebutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div1);
            $6697ff39d54b09bb$export$3466f893ebf79586(closebutton);
            mounted = false;
            dispose();
        }
    };
}
function $6697ff39d54b09bb$var$create_fragment$3(ctx) {
    let modal;
    let current;
    modal = new $6697ff39d54b09bb$export$8743009a87fcb00f({
        props: {
            close: /*close*/ ctx[3],
            $$slots: {
                default: [
                    $6697ff39d54b09bb$var$create_default_slot$1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            $6697ff39d54b09bb$export$d66501df72047452(modal.$$.fragment);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$9bb611d729802a56(modal, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const modal_changes = {};
            if (dirty & /*$$scope, $_, $appMetadata$*/ 67) modal_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            modal.$set(modal_changes);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(modal.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(modal.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $6697ff39d54b09bb$export$3466f893ebf79586(modal, detaching);
        }
    };
}
function $6697ff39d54b09bb$var$instance$3($$self, $$props, $$invalidate) {
    let $switchChainModal$;
    let $_;
    let $appMetadata$;
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, $6697ff39d54b09bb$var$switchChainModal$, ($$value)=>$$invalidate(5, $switchChainModal$ = $$value));
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, (0, $6y4qQ._), ($$value)=>$$invalidate(0, $_ = $$value));
    const nextNetworkName = $switchChainModal$.chain.label;
    function close() {
        $6697ff39d54b09bb$var$switchChainModal$.next(null);
    }
    const appMetadata$ = state.select("appMetadata").pipe(startWith(state.get().appMetadata), shareReplay(1));
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(1, $appMetadata$ = value));
    return [
        $_,
        $appMetadata$,
        nextNetworkName,
        close,
        appMetadata$
    ];
}
class $6697ff39d54b09bb$var$SwitchChain extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$3, $6697ff39d54b09bb$var$create_fragment$3, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {}, $6697ff39d54b09bb$var$add_css$3);
    }
}
/* src/views/shared/InfoIcon.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$2(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-z54y2j", ".icon.svelte-z54y2j{border-radius:50px;color:var(--onboard-primary-500, var(--primary-500))}");
}
function $6697ff39d54b09bb$var$create_fragment$2(ctx) {
    let div;
    let div_style_value;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "icon flex svelte-z54y2j");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "style", div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px;`);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            div.innerHTML = $6697ff39d54b09bb$var$infoIcon;
        },
        p (ctx, [dirty]) {
            if (dirty & /*size*/ 1 && div_style_value !== (div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px;`)) $6697ff39d54b09bb$export$342063e11d6c3cad(div, "style", div_style_value);
        },
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
        }
    };
}
function $6697ff39d54b09bb$var$instance$2($$self, $$props, $$invalidate) {
    let { size: size = 20 } = $$props;
    $$self.$$set = ($$props)=>{
        if ("size" in $$props) $$invalidate(0, size = $$props.size);
    };
    return [
        size
    ];
}
class $6697ff39d54b09bb$var$InfoIcon extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$2, $6697ff39d54b09bb$var$create_fragment$2, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            size: 0
        }, $6697ff39d54b09bb$var$add_css$2);
    }
}
/* src/views/connect/ActionRequired.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css$1(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-20hjq1", ".content.svelte-20hjq1{padding:1rem;width:300px;font-family:var(--onboard-font-family-normal, var(--font-family-normal));font-size:var(--onboard-font-size-5, var(--font-size-5));line-height:24px;background:var(\n      --onboard-action-required-modal-background,\n      var(--onboard-white, var(--white))\n    )}.icon-container.svelte-20hjq1{width:3rem;height:3rem;background:var(--onboard-primary-100, var(--primary-100));border-radius:24px}h4.svelte-20hjq1{margin:1.5rem 0 0.5rem 0;font-weight:600}.action-required-heading.svelte-20hjq1,.action-required-info.svelte-20hjq1{color:var(\n      --onboard-action-required-text-color,\n      var(--onboard-black, inherit)\n    )}.action-required-btn.svelte-20hjq1{color:var(\n      --onboard-action-required-btn-text-color,\n      var(--onboard-black, inherit)\n    )}p.svelte-20hjq1{margin:0;font-weight:400}a.svelte-20hjq1{font-weight:600}button.svelte-20hjq1{margin-top:1.5rem;font-weight:600}");
}
// (79:6) {#if wallet === 'MetaMask'}
function $6697ff39d54b09bb$var$create_if_block$1(ctx) {
    let a;
    let t_value = /*$_*/ ctx[1]("modals.actionRequired.linkText", {
        values: {
            wallet: /*wallet*/ ctx[0]
        }
    }) + "";
    let t;
    return {
        c () {
            a = $6697ff39d54b09bb$export$35e795649ee09318("a");
            t = $6697ff39d54b09bb$export$625550452a3fa3ec(t_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "href", "https://metamask.zendesk.com/hc/en-us/articles/360061346311-Switching-accounts-in-MetaMask");
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "target", "_blank");
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "rel", "noreferrer noopener");
            $6697ff39d54b09bb$export$342063e11d6c3cad(a, "class", "svelte-20hjq1");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, a, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(a, t);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, wallet*/ 3 && t_value !== (t_value = /*$_*/ ctx[1]("modals.actionRequired.linkText", {
                values: {
                    wallet: /*wallet*/ ctx[0]
                }
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(a);
        }
    };
}
// (66:0) <Modal {close}>
function $6697ff39d54b09bb$var$create_default_slot(ctx) {
    let div1;
    let div0;
    let infoicon;
    let t0;
    let h4;
    let t1_value = /*$_*/ ctx[1]("modals.actionRequired.heading", {
        values: {
            wallet: /*wallet*/ ctx[0]
        }
    }) + "";
    let t1;
    let t2;
    let p;
    let t3_value = /*$_*/ ctx[1]("modals.actionRequired.paragraph", {
        values: {
            wallet: /*wallet*/ ctx[0]
        }
    }) + "";
    let t3;
    let t4;
    let t5;
    let button;
    let t6_value = /*$_*/ ctx[1]("modals.actionRequired.buttonText") + "";
    let t6;
    let current;
    let mounted;
    let dispose;
    infoicon = new $6697ff39d54b09bb$var$InfoIcon({});
    let if_block = /*wallet*/ ctx[0] === "MetaMask" && $6697ff39d54b09bb$var$create_if_block$1(ctx);
    return {
        c () {
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$d66501df72047452(infoicon.$$.fragment);
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            h4 = $6697ff39d54b09bb$export$35e795649ee09318("h4");
            t1 = $6697ff39d54b09bb$export$625550452a3fa3ec(t1_value);
            t2 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            p = $6697ff39d54b09bb$export$35e795649ee09318("p");
            t3 = $6697ff39d54b09bb$export$625550452a3fa3ec(t3_value);
            t4 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block) if_block.c();
            t5 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            button = $6697ff39d54b09bb$export$35e795649ee09318("button");
            t6 = $6697ff39d54b09bb$export$625550452a3fa3ec(t6_value);
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "class", "icon-container flex justify-center items-center svelte-20hjq1");
            $6697ff39d54b09bb$export$342063e11d6c3cad(h4, "class", "action-required-heading svelte-20hjq1");
            $6697ff39d54b09bb$export$342063e11d6c3cad(p, "class", "action-required-info svelte-20hjq1");
            $6697ff39d54b09bb$export$342063e11d6c3cad(button, "class", "button-neutral-solid rounded action-required-btn svelte-20hjq1");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "content svelte-20hjq1");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div1, anchor);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, div0);
            $6697ff39d54b09bb$export$9bb611d729802a56(infoicon, div0, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, h4);
            $6697ff39d54b09bb$export$953cecd6e717a553(h4, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t2);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, p);
            $6697ff39d54b09bb$export$953cecd6e717a553(p, t3);
            $6697ff39d54b09bb$export$953cecd6e717a553(p, t4);
            if (if_block) if_block.m(p, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t5);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, button);
            $6697ff39d54b09bb$export$953cecd6e717a553(button, t6);
            current = true;
            if (!mounted) {
                dispose = $6697ff39d54b09bb$export$ffb5f4729a158638(button, "click", /*close*/ ctx[2]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if ((!current || dirty & /*$_, wallet*/ 3) && t1_value !== (t1_value = /*$_*/ ctx[1]("modals.actionRequired.heading", {
                values: {
                    wallet: /*wallet*/ ctx[0]
                }
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t1, t1_value);
            if ((!current || dirty & /*$_, wallet*/ 3) && t3_value !== (t3_value = /*$_*/ ctx[1]("modals.actionRequired.paragraph", {
                values: {
                    wallet: /*wallet*/ ctx[0]
                }
            }) + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t3, t3_value);
            if (/*wallet*/ ctx[0] === "MetaMask") {
                if (if_block) if_block.p(ctx, dirty);
                else {
                    if_block = $6697ff39d54b09bb$var$create_if_block$1(ctx);
                    if_block.c();
                    if_block.m(p, null);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
            if ((!current || dirty & /*$_*/ 2) && t6_value !== (t6_value = /*$_*/ ctx[1]("modals.actionRequired.buttonText") + "")) $6697ff39d54b09bb$export$90a7f3efeed30595(t6, t6_value);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(infoicon.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(infoicon.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div1);
            $6697ff39d54b09bb$export$3466f893ebf79586(infoicon);
            if (if_block) if_block.d();
            mounted = false;
            dispose();
        }
    };
}
function $6697ff39d54b09bb$var$create_fragment$1(ctx) {
    let modal;
    let current;
    modal = new $6697ff39d54b09bb$export$8743009a87fcb00f({
        props: {
            close: /*close*/ ctx[2],
            $$slots: {
                default: [
                    $6697ff39d54b09bb$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            $6697ff39d54b09bb$export$d66501df72047452(modal.$$.fragment);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$9bb611d729802a56(modal, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const modal_changes = {};
            if (dirty & /*$$scope, $_, wallet*/ 11) modal_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            modal.$set(modal_changes);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(modal.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(modal.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $6697ff39d54b09bb$export$3466f893ebf79586(modal, detaching);
        }
    };
}
function $6697ff39d54b09bb$var$instance$1($$self, $$props, $$invalidate) {
    let $_;
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, (0, $6y4qQ._), ($$value)=>$$invalidate(1, $_ = $$value));
    let { wallet: wallet } = $$props;
    function close() {
        $6697ff39d54b09bb$export$a07804094c3ecf2d.next({
            inProgress: false,
            actionRequired: ""
        });
    }
    $$self.$$set = ($$props)=>{
        if ("wallet" in $$props) $$invalidate(0, wallet = $$props.wallet);
    };
    return [
        wallet,
        $_,
        close
    ];
}
class $6697ff39d54b09bb$var$ActionRequired extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance$1, $6697ff39d54b09bb$var$create_fragment$1, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {
            wallet: 0
        }, $6697ff39d54b09bb$var$add_css$1);
    }
}
/* src/views/Index.svelte generated by Svelte v3.59.2 */ function $6697ff39d54b09bb$var$add_css(target) {
    $6697ff39d54b09bb$export$407448d2b89b1813(target, "svelte-g9s19b", ".flex{display:flex}.inline-flex{display:inline-flex}.flex-column{flex-direction:column}.items-center{align-items:center}.items-end{align-items:flex-end}.items-start{align-items:flex-start}.justify-center{justify-content:center}.justify-start{justify-content:flex-start}.justify-between{justify-content:space-between}.justify-end{justify-content:flex-end}.justify-around{justify-content:space-around}.relative{position:relative}.absolute{position:absolute}.fixed{position:fixed}.pointer{cursor:pointer}.shadow-1{box-shadow:var(--onboard-shadow-1, var(--shadow-1))}.w-100{width:100%}*{box-sizing:border-box}input{background:var(--onboard-white, var(--white))}input{width:100%;padding:0.5rem 1rem;outline:2px solid var(--onboard-gray-200, var(--gray-200));border:none;border-radius:8px;font-size:1rem;line-height:1.5;color:var(--onboard-gray-600, var(--gray-600));transition:all 200ms ease-in-out}input[type='checkbox']{-webkit-appearance:none;width:auto;background:var(--onboard-white, var(--white));outline:1px solid var(--onboard-gray-300, var(--gray-300));border:none;padding:0.5em;border-radius:3px;display:flex;justify-content:center;align-items:center;position:relative;cursor:pointer}input[type='checkbox']:hover{border-color:var(\n      --onboard-checkbox-background,\n      var(--onboard-primary-500, var(--primary-500))\n    )}input[type='checkbox']:checked{background:var(\n      --onboard-checkbox-background,\n      var(--onboard-primary-500, var(--primary-500))\n    );border-color:var(\n      --onboard-checkbox-background,\n      var(--onboard-primary-500, var(--primary-500))\n    );color:var(--onboard-checkbox-color, var(--onboard-white, var(--white)))}input[type='checkbox']:checked:after{content:url(\"data:image/svg+xml,%3Csvg width='0.885em' height='0.6em' viewBox='0 0 14 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 6L5 11L14 2L12.59 0.58L5 8.17L1.41 4.59L0 6Z' fill='white'/%3E%3C/svg%3E\");font-size:12px;position:absolute;color:var(--onboard-checkbox-color, var(--onboard-white, var(--white)))}input:hover{border-color:var(\n      --onboard-checkbox-color,\n      var(--onboard-white, var(--white))\n    )}input:focus{border-color:var(--onboard-primary-500, var(--primary-500));box-shadow:0 0 1px 1px\n      var(\n        --onboard-checkbox-background,\n        var(--onboard-primary-500, var(--primary-500))\n      );box-shadow:0 0 0 1px -moz-mac-focusring}input:disabled, textarea:disabled, select:disabled{background:var(--gray-100)}input::-moz-focus-inner{outline:0;padding:0;margin-top:-2px;margin-bottom:-2px}a{color:var(\n      --onboard-link-color,\n      var(--onboard-primary-500, var(--primary-500))\n    );text-decoration:none}a:hover{text-decoration:underline}button{display:flex;align-items:center;justify-content:center;padding:calc(var(--onboard-spacing-4, var(--spacing-4)) - 1px);border-radius:24px;cursor:pointer;font:inherit;border:none;transition:background-color 150ms ease-in-out, color 150ms ease-in-out}.onboard-button-primary{background:var(--onboard-white, var(--white));padding:calc(var(--onboard-spacing-5, var(--spacing-5)) - 1px)\n      calc(var(--onboard-spacing-4, var(--spacing-4)) - 1px);color:var(--onboard-gray-500, var(--gray-500));font-size:var(--onboard-font-size-6, var(--font-size-6));line-height:var(--onboard-font-line-height-3, var(--font-line-height-3));border:1px solid var(--onboard-gray-500, var(--gray-500));font-weight:600}.button-neutral-solid{width:100%;border-radius:8px;background:var(--onboard-gray-500, var(--gray-500));color:var(--onboard-white, var(--white));line-height:var(--onboard-font-line-height-3, var(--font-line-height-3))}.button-neutral-solid-b{width:100%;background:var(--onboard-gray-100, var(--gray-100));color:var(--onboard-gray-500, var(--gray-500));line-height:var(--onboard-font-line-height-3, var(--font-line-height-3))}button.rounded{border-radius:24px}.button-neutral-solid:hover{background:var(--onboard-gray-700, var(--gray-700))}.button-neutral-solid-b:hover{background:var(--onboard-gray-200, var(--gray-200))}.button-neutral-solid:active{color:var(--onboard-gray-300, var(--gray-300))}.button-neutral-solid-b:active{color:var(--onboard-gray-600, var(--gray-600));background:var(--onboard-gray-300, var(--gray-300))}.container.svelte-g9s19b{padding:16px;font-family:var(--onboard-font-family-normal, var(--font-family-normal));pointer-events:none;touch-action:none;width:100%}.z-indexed.svelte-g9s19b{z-index:var(--account-center-z-index)}@media all and (min-width: 428px){.container.svelte-g9s19b{max-width:348px}}");
}
// (363:0) {#if $connectWallet$.inProgress}
function $6697ff39d54b09bb$var$create_if_block_20(ctx) {
    let connect;
    let current;
    connect = new $6697ff39d54b09bb$var$Index$1({
        props: {
            autoSelect: /*$connectWallet$*/ ctx[8].autoSelect
        }
    });
    return {
        c () {
            $6697ff39d54b09bb$export$d66501df72047452(connect.$$.fragment);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$9bb611d729802a56(connect, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const connect_changes = {};
            if (dirty & /*$connectWallet$*/ 256) connect_changes.autoSelect = /*$connectWallet$*/ ctx[8].autoSelect;
            connect.$set(connect_changes);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(connect.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(connect.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $6697ff39d54b09bb$export$3466f893ebf79586(connect, detaching);
        }
    };
}
// (367:0) {#if $connectWallet$.actionRequired}
function $6697ff39d54b09bb$var$create_if_block_19(ctx) {
    let actionrequired;
    let current;
    actionrequired = new $6697ff39d54b09bb$var$ActionRequired({
        props: {
            wallet: /*$connectWallet$*/ ctx[8].actionRequired
        }
    });
    return {
        c () {
            $6697ff39d54b09bb$export$d66501df72047452(actionrequired.$$.fragment);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$9bb611d729802a56(actionrequired, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const actionrequired_changes = {};
            if (dirty & /*$connectWallet$*/ 256) actionrequired_changes.wallet = /*$connectWallet$*/ ctx[8].actionRequired;
            actionrequired.$set(actionrequired_changes);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(actionrequired.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(actionrequired.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $6697ff39d54b09bb$export$3466f893ebf79586(actionrequired, detaching);
        }
    };
}
// (371:0) {#if $switchChainModal$}
function $6697ff39d54b09bb$var$create_if_block_18(ctx) {
    let switchchain;
    let current;
    switchchain = new $6697ff39d54b09bb$var$SwitchChain({});
    return {
        c () {
            $6697ff39d54b09bb$export$d66501df72047452(switchchain.$$.fragment);
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$9bb611d729802a56(switchchain, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(switchchain.$$.fragment, local);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(switchchain.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $6697ff39d54b09bb$export$3466f893ebf79586(switchchain, detaching);
        }
    };
}
// (375:0) {#if !$accountCenter$.enabled && !$notify$.enabled}
function $6697ff39d54b09bb$var$create_if_block_17(ctx) {
    let div;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "container flex flex-column fixed z-indexed svelte-g9s19b");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "style", "top: 0; right: 0; " + /*device*/ (ctx[11].type === "mobile" ? "padding-bottom: 0;" : "") + "");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
        },
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
        }
    };
}
// (385:0) {#if displayAccountCenterNotifySameContainer}
function $6697ff39d54b09bb$var$create_if_block_9(ctx) {
    let div1;
    let show_if_3 = /*$notify$*/ ctx[3].position.includes("bottom") && /*$accountCenter$*/ ctx[1].position.includes("bottom") && /*samePositionOrMobile*/ ctx[7];
    let t0;
    let show_if_2 = /*$accountCenter$*/ ctx[1].position.includes("bottom");
    let t1;
    let div0;
    let t2;
    let show_if_1 = /*$accountCenter$*/ ctx[1].position.includes("top");
    let t3;
    let show_if = /*$notify$*/ ctx[3].position.includes("top") && /*$accountCenter$*/ ctx[1].position.includes("top") && /*samePositionOrMobile*/ ctx[7];
    let div1_style_value;
    let current;
    let if_block0 = show_if_3 && $6697ff39d54b09bb$var$create_if_block_15(ctx);
    let if_block1 = show_if_2 && $6697ff39d54b09bb$var$create_if_block_14();
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $6697ff39d54b09bb$var$create_pending_block_3,
        then: $6697ff39d54b09bb$var$create_then_block_3,
        catch: $6697ff39d54b09bb$var$create_catch_block_3,
        value: 23,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $6697ff39d54b09bb$export$71511d61b312f219(/*accountCenterComponent*/ ctx[16], info);
    let if_block2 = show_if_1 && $6697ff39d54b09bb$var$create_if_block_12();
    let if_block3 = show_if && $6697ff39d54b09bb$var$create_if_block_10(ctx);
    return {
        c () {
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            info.block.c();
            t2 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block2) if_block2.c();
            t3 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block3) if_block3.c();
            $6697ff39d54b09bb$export$342063e11d6c3cad(div0, "id", "account-center-with-notify");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "container flex flex-column fixed z-indexed svelte-g9s19b");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "style", div1_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($6697ff39d54b09bb$var$accountCenterPositioning)[/*$accountCenter$*/ ctx[1].position] + "; " + /*device*/ (ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("top") ? "padding-bottom: 0;" : /*device*/ ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("bottom") ? "padding-top:0;" : "") + ""));
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div1, anchor);
            if (if_block0) if_block0.m(div1, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t0);
            if (if_block1) if_block1.m(div1, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t1);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, div0);
            info.block.m(div0, info.anchor = null);
            info.mount = ()=>div0;
            info.anchor = null;
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t2);
            if (if_block2) if_block2.m(div1, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t3);
            if (if_block3) if_block3.m(div1, null);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty & /*$notify$, $accountCenter$, samePositionOrMobile*/ 138) show_if_3 = /*$notify$*/ ctx[3].position.includes("bottom") && /*$accountCenter$*/ ctx[1].position.includes("bottom") && /*samePositionOrMobile*/ ctx[7];
            if (show_if_3) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*$notify$, $accountCenter$, samePositionOrMobile*/ 138) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block0, 1);
                } else {
                    if_block0 = $6697ff39d54b09bb$var$create_if_block_15(ctx);
                    if_block0.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block0, 1);
                    if_block0.m(div1, t0);
                }
            } else if (if_block0) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
            if (dirty & /*$accountCenter$*/ 2) show_if_2 = /*$accountCenter$*/ ctx[1].position.includes("bottom");
            if (show_if_2) {
                if (if_block1) ;
                else {
                    if_block1 = $6697ff39d54b09bb$var$create_if_block_14();
                    if_block1.c();
                    if_block1.m(div1, t1);
                }
            } else if (if_block1) {
                if_block1.d(1);
                if_block1 = null;
            }
            $6697ff39d54b09bb$export$3d8c2f653ac9d0b9(info, ctx, dirty);
            if (dirty & /*$accountCenter$*/ 2) show_if_1 = /*$accountCenter$*/ ctx[1].position.includes("top");
            if (show_if_1) {
                if (if_block2) ;
                else {
                    if_block2 = $6697ff39d54b09bb$var$create_if_block_12();
                    if_block2.c();
                    if_block2.m(div1, t3);
                }
            } else if (if_block2) {
                if_block2.d(1);
                if_block2 = null;
            }
            if (dirty & /*$notify$, $accountCenter$, samePositionOrMobile*/ 138) show_if = /*$notify$*/ ctx[3].position.includes("top") && /*$accountCenter$*/ ctx[1].position.includes("top") && /*samePositionOrMobile*/ ctx[7];
            if (show_if) {
                if (if_block3) {
                    if_block3.p(ctx, dirty);
                    if (dirty & /*$notify$, $accountCenter$, samePositionOrMobile*/ 138) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block3, 1);
                } else {
                    if_block3 = $6697ff39d54b09bb$var$create_if_block_10(ctx);
                    if_block3.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block3, 1);
                    if_block3.m(div1, null);
                }
            } else if (if_block3) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block3, 1, 1, ()=>{
                    if_block3 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
            if (!current || dirty & /*$accountCenter$*/ 2 && div1_style_value !== (div1_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($6697ff39d54b09bb$var$accountCenterPositioning)[/*$accountCenter$*/ ctx[1].position] + "; " + /*device*/ (ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("top") ? "padding-bottom: 0;" : /*device*/ ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("bottom") ? "padding-top:0;" : "") + ""))) $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "style", div1_style_value);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block0);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(info.block);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block3);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block0);
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $6697ff39d54b09bb$export$ebd11618f299a286(block);
            }
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block3);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div1);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            info.block.d();
            info.token = null;
            info = null;
            if (if_block2) if_block2.d();
            if (if_block3) if_block3.d();
        }
    };
}
// (396:4) {#if $notify$.position.includes('bottom') && $accountCenter$.position.includes('bottom') && samePositionOrMobile}
function $6697ff39d54b09bb$var$create_if_block_15(ctx) {
    let await_block_anchor;
    let current;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $6697ff39d54b09bb$var$create_pending_block_4,
        then: $6697ff39d54b09bb$var$create_then_block_4,
        catch: $6697ff39d54b09bb$var$create_catch_block_4,
        value: 22,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $6697ff39d54b09bb$export$71511d61b312f219(/*notifyComponent*/ ctx[17], info);
    return {
        c () {
            await_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
            info.block.c();
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, await_block_anchor, anchor);
            info.block.m(target, info.anchor = anchor);
            info.mount = ()=>await_block_anchor.parentNode;
            info.anchor = await_block_anchor;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            $6697ff39d54b09bb$export$3d8c2f653ac9d0b9(info, ctx, dirty);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $6697ff39d54b09bb$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(await_block_anchor);
            info.block.d(detaching);
            info.token = null;
            info = null;
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $6697ff39d54b09bb$var$create_catch_block_4(ctx) {
    return {
        c: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        m: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5
    };
}
// (397:42)          {#if Notify}
function $6697ff39d54b09bb$var$create_then_block_4(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*Notify*/ ctx[22] && $6697ff39d54b09bb$var$create_if_block_16(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*Notify*/ ctx[22]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (398:8) {#if Notify}
function $6697ff39d54b09bb$var$create_if_block_16(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*Notify*/ ctx[22];
    function switch_props(ctx) {
        return {
            props: {
                notifications: /*$notifications$*/ ctx[10],
                position: /*$notify$*/ ctx[3].position,
                sharedContainer: /*sharedContainer*/ ctx[0]
            }
        };
    }
    if (switch_value) switch_instance = $6697ff39d54b09bb$var$construct_svelte_component(switch_value, switch_props(ctx));
    return {
        c () {
            if (switch_instance) $6697ff39d54b09bb$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $6697ff39d54b09bb$export$9bb611d729802a56(switch_instance, target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const switch_instance_changes = {};
            if (dirty & /*$notifications$*/ 1024) switch_instance_changes.notifications = /*$notifications$*/ ctx[10];
            if (dirty & /*$notify$*/ 8) switch_instance_changes.position = /*$notify$*/ ctx[3].position;
            if (dirty & /*sharedContainer*/ 1) switch_instance_changes.sharedContainer = /*sharedContainer*/ ctx[0];
            if (switch_value !== (switch_value = /*Notify*/ ctx[22])) {
                if (switch_instance) {
                    $6697ff39d54b09bb$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $6697ff39d54b09bb$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $6697ff39d54b09bb$export$3466f893ebf79586(old_component, 1);
                    });
                    $6697ff39d54b09bb$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $6697ff39d54b09bb$var$construct_svelte_component(switch_value, switch_props(ctx));
                    $6697ff39d54b09bb$export$d66501df72047452(switch_instance.$$.fragment);
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $6697ff39d54b09bb$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            } else if (switch_value) switch_instance.$set(switch_instance_changes);
        },
        i (local) {
            if (current) return;
            if (switch_instance) $6697ff39d54b09bb$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $6697ff39d54b09bb$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $6697ff39d54b09bb$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $6697ff39d54b09bb$var$create_pending_block_4(ctx) {
    return {
        c: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        m: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5
    };
}
// (408:4) {#if $accountCenter$.position.includes('bottom')}
function $6697ff39d54b09bb$var$create_if_block_14(ctx) {
    let div;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
            $6697ff39d54b09bb$export$971d5caa766a69d7(div, "margin-bottom", "8px");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $6697ff39d54b09bb$var$create_catch_block_3(ctx) {
    return {
        c: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        m: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5
    };
}
// (412:56)          {#if AccountCenter}
function $6697ff39d54b09bb$var$create_then_block_3(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*AccountCenter*/ ctx[23] && $6697ff39d54b09bb$var$create_if_block_13(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*AccountCenter*/ ctx[23]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (413:8) {#if AccountCenter}
function $6697ff39d54b09bb$var$create_if_block_13(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*AccountCenter*/ ctx[23];
    function switch_props(ctx) {
        return {};
    }
    if (switch_value) switch_instance = $6697ff39d54b09bb$var$construct_svelte_component(switch_value, switch_props());
    return {
        c () {
            if (switch_instance) $6697ff39d54b09bb$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $6697ff39d54b09bb$export$9bb611d729802a56(switch_instance, target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (switch_value !== (switch_value = /*AccountCenter*/ ctx[23])) {
                if (switch_instance) {
                    $6697ff39d54b09bb$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $6697ff39d54b09bb$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $6697ff39d54b09bb$export$3466f893ebf79586(old_component, 1);
                    });
                    $6697ff39d54b09bb$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $6697ff39d54b09bb$var$construct_svelte_component(switch_value, switch_props());
                    $6697ff39d54b09bb$export$d66501df72047452(switch_instance.$$.fragment);
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $6697ff39d54b09bb$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            }
        },
        i (local) {
            if (current) return;
            if (switch_instance) $6697ff39d54b09bb$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $6697ff39d54b09bb$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $6697ff39d54b09bb$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $6697ff39d54b09bb$var$create_pending_block_3(ctx) {
    return {
        c: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        m: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5
    };
}
// (418:4) {#if $accountCenter$.position.includes('top')}
function $6697ff39d54b09bb$var$create_if_block_12(ctx) {
    let div;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
            $6697ff39d54b09bb$export$971d5caa766a69d7(div, "margin-top", "8px");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
        }
    };
}
// (421:4) {#if $notify$.position.includes('top') && $accountCenter$.position.includes('top') && samePositionOrMobile}
function $6697ff39d54b09bb$var$create_if_block_10(ctx) {
    let await_block_anchor;
    let current;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $6697ff39d54b09bb$var$create_pending_block_2,
        then: $6697ff39d54b09bb$var$create_then_block_2,
        catch: $6697ff39d54b09bb$var$create_catch_block_2,
        value: 22,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $6697ff39d54b09bb$export$71511d61b312f219(/*notifyComponent*/ ctx[17], info);
    return {
        c () {
            await_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
            info.block.c();
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, await_block_anchor, anchor);
            info.block.m(target, info.anchor = anchor);
            info.mount = ()=>await_block_anchor.parentNode;
            info.anchor = await_block_anchor;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            $6697ff39d54b09bb$export$3d8c2f653ac9d0b9(info, ctx, dirty);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $6697ff39d54b09bb$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(await_block_anchor);
            info.block.d(detaching);
            info.token = null;
            info = null;
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $6697ff39d54b09bb$var$create_catch_block_2(ctx) {
    return {
        c: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        m: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5
    };
}
// (422:42)          {#if Notify}
function $6697ff39d54b09bb$var$create_then_block_2(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*Notify*/ ctx[22] && $6697ff39d54b09bb$var$create_if_block_11(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*Notify*/ ctx[22]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (423:8) {#if Notify}
function $6697ff39d54b09bb$var$create_if_block_11(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*Notify*/ ctx[22];
    function switch_props(ctx) {
        return {
            props: {
                notifications: /*$notifications$*/ ctx[10],
                position: /*$notify$*/ ctx[3].position,
                sharedContainer: /*sharedContainer*/ ctx[0]
            }
        };
    }
    if (switch_value) switch_instance = $6697ff39d54b09bb$var$construct_svelte_component(switch_value, switch_props(ctx));
    return {
        c () {
            if (switch_instance) $6697ff39d54b09bb$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $6697ff39d54b09bb$export$9bb611d729802a56(switch_instance, target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const switch_instance_changes = {};
            if (dirty & /*$notifications$*/ 1024) switch_instance_changes.notifications = /*$notifications$*/ ctx[10];
            if (dirty & /*$notify$*/ 8) switch_instance_changes.position = /*$notify$*/ ctx[3].position;
            if (dirty & /*sharedContainer*/ 1) switch_instance_changes.sharedContainer = /*sharedContainer*/ ctx[0];
            if (switch_value !== (switch_value = /*Notify*/ ctx[22])) {
                if (switch_instance) {
                    $6697ff39d54b09bb$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $6697ff39d54b09bb$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $6697ff39d54b09bb$export$3466f893ebf79586(old_component, 1);
                    });
                    $6697ff39d54b09bb$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $6697ff39d54b09bb$var$construct_svelte_component(switch_value, switch_props(ctx));
                    $6697ff39d54b09bb$export$d66501df72047452(switch_instance.$$.fragment);
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $6697ff39d54b09bb$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            } else if (switch_value) switch_instance.$set(switch_instance_changes);
        },
        i (local) {
            if (current) return;
            if (switch_instance) $6697ff39d54b09bb$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $6697ff39d54b09bb$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $6697ff39d54b09bb$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $6697ff39d54b09bb$var$create_pending_block_2(ctx) {
    return {
        c: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        m: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5
    };
}
// (435:0) {#if displayAccountCenterSeparate}
function $6697ff39d54b09bb$var$create_if_block_4(ctx) {
    let div1;
    let show_if_1 = /*$accountCenter$*/ ctx[1].position.includes("bottom");
    let t0;
    let div0;
    let t1;
    let show_if = /*$accountCenter$*/ ctx[1].position.includes("top");
    let div1_style_value;
    let current;
    let if_block0 = show_if_1 && $6697ff39d54b09bb$var$create_if_block_8();
    let if_block1 = /*$accountCenter$*/ ctx[1].enabled && /*$wallets$*/ ctx[2].length && $6697ff39d54b09bb$var$create_if_block_6(ctx);
    let if_block2 = show_if && $6697ff39d54b09bb$var$create_if_block_5();
    return {
        c () {
            div1 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            div0 = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if (if_block1) if_block1.c();
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block2) if_block2.c();
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "class", "container flex flex-column fixed z-indexed svelte-g9s19b");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "style", div1_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($6697ff39d54b09bb$var$accountCenterPositioning)[/*$accountCenter$*/ ctx[1].position] + "; " + /*device*/ (ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("top") ? "padding-bottom: 0;" : /*device*/ ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("bottom") ? "padding-top:0;" : "") + ""));
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div1, anchor);
            if (if_block0) if_block0.m(div1, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t0);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, div0);
            if (if_block1) if_block1.m(div0, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div1, t1);
            if (if_block2) if_block2.m(div1, null);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty & /*$accountCenter$*/ 2) show_if_1 = /*$accountCenter$*/ ctx[1].position.includes("bottom");
            if (show_if_1) {
                if (if_block0) ;
                else {
                    if_block0 = $6697ff39d54b09bb$var$create_if_block_8();
                    if_block0.c();
                    if_block0.m(div1, t0);
                }
            } else if (if_block0) {
                if_block0.d(1);
                if_block0 = null;
            }
            if (/*$accountCenter$*/ ctx[1].enabled && /*$wallets$*/ ctx[2].length) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*$accountCenter$, $wallets$*/ 6) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block1, 1);
                } else {
                    if_block1 = $6697ff39d54b09bb$var$create_if_block_6(ctx);
                    if_block1.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block1, 1);
                    if_block1.m(div0, null);
                }
            } else if (if_block1) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
            if (dirty & /*$accountCenter$*/ 2) show_if = /*$accountCenter$*/ ctx[1].position.includes("top");
            if (show_if) {
                if (if_block2) ;
                else {
                    if_block2 = $6697ff39d54b09bb$var$create_if_block_5();
                    if_block2.c();
                    if_block2.m(div1, null);
                }
            } else if (if_block2) {
                if_block2.d(1);
                if_block2 = null;
            }
            if (!current || dirty & /*$accountCenter$*/ 2 && div1_style_value !== (div1_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($6697ff39d54b09bb$var$accountCenterPositioning)[/*$accountCenter$*/ ctx[1].position] + "; " + /*device*/ (ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("top") ? "padding-bottom: 0;" : /*device*/ ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("bottom") ? "padding-top:0;" : "") + ""))) $6697ff39d54b09bb$export$342063e11d6c3cad(div1, "style", div1_style_value);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block1);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block1);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div1);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            if (if_block2) if_block2.d();
        }
    };
}
// (446:4) {#if $accountCenter$.position.includes('bottom')}
function $6697ff39d54b09bb$var$create_if_block_8(ctx) {
    let div;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
            $6697ff39d54b09bb$export$971d5caa766a69d7(div, "margin-bottom", "8px");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
        }
    };
}
// (450:6) {#if $accountCenter$.enabled && $wallets$.length}
function $6697ff39d54b09bb$var$create_if_block_6(ctx) {
    let await_block_anchor;
    let current;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $6697ff39d54b09bb$var$create_pending_block_1,
        then: $6697ff39d54b09bb$var$create_then_block_1,
        catch: $6697ff39d54b09bb$var$create_catch_block_1,
        value: 23,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $6697ff39d54b09bb$export$71511d61b312f219(/*accountCenterComponent*/ ctx[16], info);
    return {
        c () {
            await_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
            info.block.c();
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, await_block_anchor, anchor);
            info.block.m(target, info.anchor = anchor);
            info.mount = ()=>await_block_anchor.parentNode;
            info.anchor = await_block_anchor;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            $6697ff39d54b09bb$export$3d8c2f653ac9d0b9(info, ctx, dirty);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $6697ff39d54b09bb$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(await_block_anchor);
            info.block.d(detaching);
            info.token = null;
            info = null;
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $6697ff39d54b09bb$var$create_catch_block_1(ctx) {
    return {
        c: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        m: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5
    };
}
// (451:58)            {#if AccountCenter}
function $6697ff39d54b09bb$var$create_then_block_1(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*AccountCenter*/ ctx[23] && $6697ff39d54b09bb$var$create_if_block_7(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*AccountCenter*/ ctx[23]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (452:10) {#if AccountCenter}
function $6697ff39d54b09bb$var$create_if_block_7(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*AccountCenter*/ ctx[23];
    function switch_props(ctx) {
        return {};
    }
    if (switch_value) switch_instance = $6697ff39d54b09bb$var$construct_svelte_component(switch_value, switch_props());
    return {
        c () {
            if (switch_instance) $6697ff39d54b09bb$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $6697ff39d54b09bb$export$9bb611d729802a56(switch_instance, target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (switch_value !== (switch_value = /*AccountCenter*/ ctx[23])) {
                if (switch_instance) {
                    $6697ff39d54b09bb$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $6697ff39d54b09bb$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $6697ff39d54b09bb$export$3466f893ebf79586(old_component, 1);
                    });
                    $6697ff39d54b09bb$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $6697ff39d54b09bb$var$construct_svelte_component(switch_value, switch_props());
                    $6697ff39d54b09bb$export$d66501df72047452(switch_instance.$$.fragment);
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $6697ff39d54b09bb$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            }
        },
        i (local) {
            if (current) return;
            if (switch_instance) $6697ff39d54b09bb$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $6697ff39d54b09bb$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $6697ff39d54b09bb$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $6697ff39d54b09bb$var$create_pending_block_1(ctx) {
    return {
        c: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        m: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5
    };
}
// (458:4) {#if $accountCenter$.position.includes('top')}
function $6697ff39d54b09bb$var$create_if_block_5(ctx) {
    let div;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
            $6697ff39d54b09bb$export$971d5caa766a69d7(div, "margin-top", "8px");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
        }
    };
}
// (463:0) {#if displayNotifySeparate}
function $6697ff39d54b09bb$var$create_if_block(ctx) {
    let div;
    let show_if_1 = /*$notify$*/ ctx[3].position.includes("top");
    let t0;
    let t1;
    let show_if = /*$notify$*/ ctx[3].position.includes("bottom");
    let div_style_value;
    let current;
    let if_block0 = show_if_1 && $6697ff39d54b09bb$var$create_if_block_3();
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $6697ff39d54b09bb$var$create_pending_block,
        then: $6697ff39d54b09bb$var$create_then_block,
        catch: $6697ff39d54b09bb$var$create_catch_block,
        value: 22,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $6697ff39d54b09bb$export$71511d61b312f219(/*notifyComponent*/ ctx[17], info);
    let if_block1 = show_if && $6697ff39d54b09bb$var$create_if_block_1();
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            info.block.c();
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "class", "container flex flex-column fixed z-indexed svelte-g9s19b");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "style", div_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($6697ff39d54b09bb$var$notifyPositioning)[/*$notify$*/ ctx[3].position] + "; " + /*device*/ (ctx[11].type === "mobile" && /*$notify$*/ ctx[3].position.includes("top") ? "padding-bottom: 0;" : /*device*/ ctx[11].type === "mobile" && /*$notify$*/ ctx[3].position.includes("bottom") ? "padding-top:0;" : "") + ""));
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
            if (if_block0) if_block0.m(div, null);
            $6697ff39d54b09bb$export$953cecd6e717a553(div, t0);
            info.block.m(div, info.anchor = null);
            info.mount = ()=>div;
            info.anchor = t1;
            $6697ff39d54b09bb$export$953cecd6e717a553(div, t1);
            if (if_block1) if_block1.m(div, null);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty & /*$notify$*/ 8) show_if_1 = /*$notify$*/ ctx[3].position.includes("top");
            if (show_if_1) {
                if (if_block0) ;
                else {
                    if_block0 = $6697ff39d54b09bb$var$create_if_block_3();
                    if_block0.c();
                    if_block0.m(div, t0);
                }
            } else if (if_block0) {
                if_block0.d(1);
                if_block0 = null;
            }
            $6697ff39d54b09bb$export$3d8c2f653ac9d0b9(info, ctx, dirty);
            if (dirty & /*$notify$*/ 8) show_if = /*$notify$*/ ctx[3].position.includes("bottom");
            if (show_if) {
                if (if_block1) ;
                else {
                    if_block1 = $6697ff39d54b09bb$var$create_if_block_1();
                    if_block1.c();
                    if_block1.m(div, null);
                }
            } else if (if_block1) {
                if_block1.d(1);
                if_block1 = null;
            }
            if (!current || dirty & /*$notify$*/ 8 && div_style_value !== (div_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($6697ff39d54b09bb$var$notifyPositioning)[/*$notify$*/ ctx[3].position] + "; " + /*device*/ (ctx[11].type === "mobile" && /*$notify$*/ ctx[3].position.includes("top") ? "padding-bottom: 0;" : /*device*/ ctx[11].type === "mobile" && /*$notify$*/ ctx[3].position.includes("bottom") ? "padding-top:0;" : "") + ""))) $6697ff39d54b09bb$export$342063e11d6c3cad(div, "style", div_style_value);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $6697ff39d54b09bb$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
            if (if_block0) if_block0.d();
            info.block.d();
            info.token = null;
            info = null;
            if (if_block1) if_block1.d();
        }
    };
}
// (474:4) {#if $notify$.position.includes('top')}
function $6697ff39d54b09bb$var$create_if_block_3(ctx) {
    let div;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $6697ff39d54b09bb$var$create_catch_block(ctx) {
    return {
        c: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        m: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5
    };
}
// (477:40)        {#if Notify}
function $6697ff39d54b09bb$var$create_then_block(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*Notify*/ ctx[22] && $6697ff39d54b09bb$var$create_if_block_2(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*Notify*/ ctx[22]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (478:6) {#if Notify}
function $6697ff39d54b09bb$var$create_if_block_2(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*Notify*/ ctx[22];
    function switch_props(ctx) {
        return {
            props: {
                notifications: /*$notifications$*/ ctx[10],
                position: /*$notify$*/ ctx[3].position,
                sharedContainer: /*sharedContainer*/ ctx[0]
            }
        };
    }
    if (switch_value) switch_instance = $6697ff39d54b09bb$var$construct_svelte_component(switch_value, switch_props(ctx));
    return {
        c () {
            if (switch_instance) $6697ff39d54b09bb$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $6697ff39d54b09bb$export$9bb611d729802a56(switch_instance, target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const switch_instance_changes = {};
            if (dirty & /*$notifications$*/ 1024) switch_instance_changes.notifications = /*$notifications$*/ ctx[10];
            if (dirty & /*$notify$*/ 8) switch_instance_changes.position = /*$notify$*/ ctx[3].position;
            if (dirty & /*sharedContainer*/ 1) switch_instance_changes.sharedContainer = /*sharedContainer*/ ctx[0];
            if (switch_value !== (switch_value = /*Notify*/ ctx[22])) {
                if (switch_instance) {
                    $6697ff39d54b09bb$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $6697ff39d54b09bb$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $6697ff39d54b09bb$export$3466f893ebf79586(old_component, 1);
                    });
                    $6697ff39d54b09bb$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $6697ff39d54b09bb$var$construct_svelte_component(switch_value, switch_props(ctx));
                    $6697ff39d54b09bb$export$d66501df72047452(switch_instance.$$.fragment);
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $6697ff39d54b09bb$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            } else if (switch_value) switch_instance.$set(switch_instance_changes);
        },
        i (local) {
            if (current) return;
            if (switch_instance) $6697ff39d54b09bb$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $6697ff39d54b09bb$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $6697ff39d54b09bb$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $6697ff39d54b09bb$var$create_pending_block(ctx) {
    return {
        c: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        m: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        p: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        i: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        o: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5,
        d: $6697ff39d54b09bb$export$7ccc53e8f1e7dfc5
    };
}
// (487:4) {#if $notify$.position.includes('bottom')}
function $6697ff39d54b09bb$var$create_if_block_1(ctx) {
    let div;
    return {
        c () {
            div = $6697ff39d54b09bb$export$35e795649ee09318("div");
            $6697ff39d54b09bb$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
        },
        m (target, anchor) {
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(div);
        }
    };
}
function $6697ff39d54b09bb$var$create_fragment(ctx) {
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let if_block6_anchor;
    let current;
    let if_block0 = /*$connectWallet$*/ ctx[8].inProgress && $6697ff39d54b09bb$var$create_if_block_20(ctx);
    let if_block1 = /*$connectWallet$*/ ctx[8].actionRequired && $6697ff39d54b09bb$var$create_if_block_19(ctx);
    let if_block2 = /*$switchChainModal$*/ ctx[9] && $6697ff39d54b09bb$var$create_if_block_18();
    let if_block3 = !/*$accountCenter$*/ ctx[1].enabled && !/*$notify$*/ ctx[3].enabled && $6697ff39d54b09bb$var$create_if_block_17(ctx);
    let if_block4 = /*displayAccountCenterNotifySameContainer*/ ctx[4] && $6697ff39d54b09bb$var$create_if_block_9(ctx);
    let if_block5 = /*displayAccountCenterSeparate*/ ctx[5] && $6697ff39d54b09bb$var$create_if_block_4(ctx);
    let if_block6 = /*displayNotifySeparate*/ ctx[6] && $6697ff39d54b09bb$var$create_if_block(ctx);
    return {
        c () {
            if (if_block0) if_block0.c();
            t0 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            t1 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block2) if_block2.c();
            t2 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block3) if_block3.c();
            t3 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block4) if_block4.c();
            t4 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block5) if_block5.c();
            t5 = $6697ff39d54b09bb$export$2329c99376c9d0a4();
            if (if_block6) if_block6.c();
            if_block6_anchor = $6697ff39d54b09bb$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block0) if_block0.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t0, anchor);
            if (if_block1) if_block1.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t1, anchor);
            if (if_block2) if_block2.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t2, anchor);
            if (if_block3) if_block3.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t3, anchor);
            if (if_block4) if_block4.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t4, anchor);
            if (if_block5) if_block5.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, t5, anchor);
            if (if_block6) if_block6.m(target, anchor);
            $6697ff39d54b09bb$export$8b22cf2602fb60ce(target, if_block6_anchor, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            if (/*$connectWallet$*/ ctx[8].inProgress) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*$connectWallet$*/ 256) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block0, 1);
                } else {
                    if_block0 = $6697ff39d54b09bb$var$create_if_block_20(ctx);
                    if_block0.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block0, 1);
                    if_block0.m(t0.parentNode, t0);
                }
            } else if (if_block0) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
            if (/*$connectWallet$*/ ctx[8].actionRequired) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*$connectWallet$*/ 256) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block1, 1);
                } else {
                    if_block1 = $6697ff39d54b09bb$var$create_if_block_19(ctx);
                    if_block1.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block1, 1);
                    if_block1.m(t1.parentNode, t1);
                }
            } else if (if_block1) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
            if (/*$switchChainModal$*/ ctx[9]) {
                if (if_block2) {
                    if (dirty & /*$switchChainModal$*/ 512) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block2, 1);
                } else {
                    if_block2 = $6697ff39d54b09bb$var$create_if_block_18();
                    if_block2.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block2, 1);
                    if_block2.m(t2.parentNode, t2);
                }
            } else if (if_block2) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block2, 1, 1, ()=>{
                    if_block2 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
            if (!/*$accountCenter$*/ ctx[1].enabled && !/*$notify$*/ ctx[3].enabled) {
                if (if_block3) if_block3.p(ctx, dirty);
                else {
                    if_block3 = $6697ff39d54b09bb$var$create_if_block_17(ctx);
                    if_block3.c();
                    if_block3.m(t3.parentNode, t3);
                }
            } else if (if_block3) {
                if_block3.d(1);
                if_block3 = null;
            }
            if (/*displayAccountCenterNotifySameContainer*/ ctx[4]) {
                if (if_block4) {
                    if_block4.p(ctx, dirty);
                    if (dirty & /*displayAccountCenterNotifySameContainer*/ 16) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block4, 1);
                } else {
                    if_block4 = $6697ff39d54b09bb$var$create_if_block_9(ctx);
                    if_block4.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block4, 1);
                    if_block4.m(t4.parentNode, t4);
                }
            } else if (if_block4) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block4, 1, 1, ()=>{
                    if_block4 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
            if (/*displayAccountCenterSeparate*/ ctx[5]) {
                if (if_block5) {
                    if_block5.p(ctx, dirty);
                    if (dirty & /*displayAccountCenterSeparate*/ 32) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block5, 1);
                } else {
                    if_block5 = $6697ff39d54b09bb$var$create_if_block_4(ctx);
                    if_block5.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block5, 1);
                    if_block5.m(t5.parentNode, t5);
                }
            } else if (if_block5) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block5, 1, 1, ()=>{
                    if_block5 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
            if (/*displayNotifySeparate*/ ctx[6]) {
                if (if_block6) {
                    if_block6.p(ctx, dirty);
                    if (dirty & /*displayNotifySeparate*/ 64) $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block6, 1);
                } else {
                    if_block6 = $6697ff39d54b09bb$var$create_if_block(ctx);
                    if_block6.c();
                    $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block6, 1);
                    if_block6.m(if_block6_anchor.parentNode, if_block6_anchor);
                }
            } else if (if_block6) {
                $6697ff39d54b09bb$export$4a5767248b18ef41();
                $6697ff39d54b09bb$export$ebd11618f299a286(if_block6, 1, 1, ()=>{
                    if_block6 = null;
                });
                $6697ff39d54b09bb$export$df995fae86a55f06();
            }
        },
        i (local) {
            if (current) return;
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block0);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block1);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block2);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block4);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block5);
            $6697ff39d54b09bb$export$d141bba7fdc215a3(if_block6);
            current = true;
        },
        o (local) {
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block0);
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block1);
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block2);
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block4);
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block5);
            $6697ff39d54b09bb$export$ebd11618f299a286(if_block6);
            current = false;
        },
        d (detaching) {
            if (if_block0) if_block0.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t0);
            if (if_block1) if_block1.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t1);
            if (if_block2) if_block2.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t2);
            if (if_block3) if_block3.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t3);
            if (if_block4) if_block4.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t4);
            if (if_block5) if_block5.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(t5);
            if (if_block6) if_block6.d(detaching);
            if (detaching) $6697ff39d54b09bb$export$4368d992c4eafac0(if_block6_anchor);
        }
    };
}
const $6697ff39d54b09bb$var$accountCenterPositioning = "account-center";
const $6697ff39d54b09bb$var$notifyPositioning = "notify-onboard-container";


function $6697ff39d54b09bb$var$instance($$self, $$props, $$invalidate) {
    let sharedContainer;
    let samePositionOrMobile;
    let sharedMobileContainerCheck;
    let displayNotifySeparate;
    let displayAccountCenterSeparate;
    let displayAccountCenterNotifySameContainer;
    let $accountCenter$;
    let $wallets$;
    let $notify$;
    let $connectWallet$;
    let $switchChainModal$;
    let $notifications$;
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, $6697ff39d54b09bb$export$efccba1c4a2ef57b, ($$value)=>$$invalidate(2, $wallets$ = $$value));
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, $6697ff39d54b09bb$export$a07804094c3ecf2d, ($$value)=>$$invalidate(8, $connectWallet$ = $$value));
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, $6697ff39d54b09bb$var$switchChainModal$, ($$value)=>$$invalidate(9, $switchChainModal$ = $$value));
    const { device: device, containerElements: containerElements } = $6697ff39d54b09bb$export$c9170ad7d4cd7e57;
    const accountCenter$ = $6697ff39d54b09bb$export$6559d589eb85fbb6.select("accountCenter").pipe((0, $fy9c8.startWith)($6697ff39d54b09bb$export$6559d589eb85fbb6.get().accountCenter), (0, $hDTQV.shareReplay)(1));
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, accountCenter$, (value)=>$$invalidate(1, $accountCenter$ = value));
    const notify$ = $6697ff39d54b09bb$export$6559d589eb85fbb6.select("notify").pipe((0, $fy9c8.startWith)($6697ff39d54b09bb$export$6559d589eb85fbb6.get().notify), (0, $hDTQV.shareReplay)(1));
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, notify$, (value)=>$$invalidate(3, $notify$ = value));
    const notifications$ = $6697ff39d54b09bb$export$6559d589eb85fbb6.select("notifications").pipe((0, $fy9c8.startWith)($6697ff39d54b09bb$export$6559d589eb85fbb6.get().notifications));
    $6697ff39d54b09bb$export$db3b6bfb95261072($$self, notifications$, (value)=>$$invalidate(10, $notifications$ = value));
    const setPositioningDefaults = (targetComponentVariable)=>{
        return {
            topLeft: `
        top: var(--${targetComponentVariable}-position-top, 0); 
        left: var(--${targetComponentVariable}-position-left, 0);`,
            topRight: `
        top: var(--${targetComponentVariable}-position-top, 0); 
        right: var(--${targetComponentVariable}-position-right, 0);`,
            bottomRight: `
        bottom: var(--${targetComponentVariable}-position-bottom, 0); 
        right: var(--${targetComponentVariable}-position-right, 0);`,
            bottomLeft: `
        bottom: var(--${targetComponentVariable}-position-bottom, 0); 
        left: var(--${targetComponentVariable}-position-left, 0);`
        };
    };
    const accountCenterComponent = $accountCenter$.enabled ? (parcelRequire("gphoY")).then((mod)=>mod.default) : Promise.resolve(null);
    const notifyComponent = $notify$.enabled ? (parcelRequire("83NaW")).then((mod)=>mod.default) : Promise.resolve(null);
    const accountCenterMountToElement = $accountCenter$.enabled && containerElements && containerElements.accountCenter;
    const attachCompToDom = (domEl, targetEl, component, compSettings)=>{
        const target = domEl.attachShadow({
            mode: "open"
        });
        let getW3OEl = document.querySelector("onboard-v2");
        let w3OStyleSheets = getW3OEl.shadowRoot.styleSheets;
        const copiedStyleSheet = new CSSStyleSheet();
        // Copy Onboard stylesheets over to AccountCenter shadow DOM
        Object.values(w3OStyleSheets).forEach((sheet)=>{
            const styleRules = Object.values(sheet.cssRules);
            styleRules.forEach((rule)=>copiedStyleSheet.insertRule(rule.cssText));
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        target.adoptedStyleSheets = [
            copiedStyleSheet
        ];
        const containerElement = document.querySelector(targetEl);
        containerElement.appendChild(domEl);
        if (!containerElement) throw new Error(`Element with query ${targetEl} does not exist.`);
        const getACComp = async ()=>{
            let newComp = await component;
            if (newComp) new newComp({
                target: target,
                props: {
                    settings: compSettings,
                    mountInContainer: true
                }
            });
        };
        getACComp();
    };
    if (accountCenterMountToElement) {
        const accountCenter = document.createElement("onboard-account-center");
        attachCompToDom(accountCenter, accountCenterMountToElement, accountCenterComponent, $accountCenter$);
    }
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*$accountCenter$, $notify$*/ 10) $$invalidate(0, sharedContainer = !accountCenterMountToElement && $accountCenter$.enabled && $notify$.enabled && $notify$.position === $accountCenter$.position);
        if ($$self.$$.dirty & /*$accountCenter$, $notify$*/ 10) $$invalidate(7, samePositionOrMobile = device.type === "mobile" || $accountCenter$.position === $notify$.position);
        if ($$self.$$.dirty & /*$notify$, $accountCenter$*/ 10) $$invalidate(18, sharedMobileContainerCheck = $notify$.position.includes("bottom") && $accountCenter$.position.includes("bottom") || $notify$.position.includes("top") && $accountCenter$.position.includes("top"));
        if ($$self.$$.dirty & /*$notify$, $accountCenter$, sharedMobileContainerCheck, $wallets$*/ 262158) $$invalidate(6, displayNotifySeparate = $notify$.enabled && (!$accountCenter$.enabled || accountCenterMountToElement || $notify$.position !== $accountCenter$.position && device.type !== "mobile" || device.type === "mobile" && !sharedMobileContainerCheck || !$wallets$.length));
        if ($$self.$$.dirty & /*$accountCenter$, $notify$, sharedMobileContainerCheck, $wallets$*/ 262158) $$invalidate(5, displayAccountCenterSeparate = $accountCenter$.enabled && (!$notify$.enabled || $notify$.position !== $accountCenter$.position && device.type !== "mobile" || device.type === "mobile" && !sharedMobileContainerCheck) && $wallets$.length);
        if ($$self.$$.dirty & /*$notify$, $accountCenter$, sharedContainer, sharedMobileContainerCheck, $wallets$*/ 262159) $$invalidate(4, displayAccountCenterNotifySameContainer = $notify$.enabled && $accountCenter$.enabled && (sharedContainer || device.type === "mobile" && sharedMobileContainerCheck) && $wallets$.length);
    };
    return [
        sharedContainer,
        $accountCenter$,
        $wallets$,
        $notify$,
        displayAccountCenterNotifySameContainer,
        displayAccountCenterSeparate,
        displayNotifySeparate,
        samePositionOrMobile,
        $connectWallet$,
        $switchChainModal$,
        $notifications$,
        device,
        accountCenter$,
        notify$,
        notifications$,
        setPositioningDefaults,
        accountCenterComponent,
        notifyComponent,
        sharedMobileContainerCheck
    ];
}
class $6697ff39d54b09bb$var$Index extends $6697ff39d54b09bb$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $6697ff39d54b09bb$export$23f2a1d2818174ef(this, options, $6697ff39d54b09bb$var$instance, $6697ff39d54b09bb$var$create_fragment, $6697ff39d54b09bb$export$2408f22a0fab9ae5, {}, $6697ff39d54b09bb$var$add_css);
    }
}
let $6697ff39d54b09bb$var$notificationsArr;
$6697ff39d54b09bb$export$6559d589eb85fbb6.select("notifications").subscribe((notifications)=>{
    $6697ff39d54b09bb$var$notificationsArr = notifications;
});
async function $6697ff39d54b09bb$var$preflightNotifications(options) {
    const invalid = $6697ff39d54b09bb$var$validatePreflightNotifications(options);
    if (invalid) throw invalid;
    const { sendTransaction: sendTransaction, estimateGas: estimateGas, gasPrice: gasPrice, balance: balance, txDetails: txDetails, txApproveReminderTimeout: txApproveReminderTimeout } = options;
    // Check for reminder timeout and confirm its greater than 3 seconds
    const reminderTimeout = txApproveReminderTimeout && txApproveReminderTimeout > 3000 ? txApproveReminderTimeout : 15000;
    // if `balance` or `estimateGas` or `gasPrice` is not provided,
    // then sufficient funds check is disabled
    // if `txDetails` is not provided,
    // then duplicate transaction check is disabled
    // if dev doesn't want notify to initiate the transaction
    // and `sendTransaction` is not provided, then transaction
    // rejected notification is disabled
    // to disable hints for `txAwaitingApproval`, `txConfirmReminder`
    // or any other notification, then return false from listener functions
    const [gas, price] = await $6697ff39d54b09bb$var$gasEstimates(estimateGas, gasPrice);
    const id = $6697ff39d54b09bb$var$createId((0, $kBJxW.nanoid)());
    const value = new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(txDetails && txDetails.value || 0);
    // check sufficient balance if required parameters are available
    if (balance && gas && price) {
        const transactionCost = gas.times(price).plus(value);
        // if transaction cost is greater than the current balance
        if (transactionCost.gt(new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(balance))) {
            const eventCode = "nsfFail";
            $6697ff39d54b09bb$var$addNotification($6697ff39d54b09bb$var$buildNotification(eventCode, id));
        }
    }
    // check previous transactions awaiting approval
    const txRequested = $6697ff39d54b09bb$var$notificationsArr.find((tx)=>tx.eventCode === "txRequest");
    if (txRequested) {
        const eventCode = "txAwaitingApproval";
        const newNotification = $6697ff39d54b09bb$var$buildNotification(eventCode, txRequested.id);
        $6697ff39d54b09bb$var$addNotification(newNotification);
    }
    // confirm reminder timeout defaults to 20 seconds
    setTimeout(()=>{
        const awaitingApproval = $6697ff39d54b09bb$var$notificationsArr.find((tx)=>tx.id === id && tx.eventCode === "txRequest");
        if (awaitingApproval) {
            const eventCode = "txConfirmReminder";
            const newNotification = $6697ff39d54b09bb$var$buildNotification(eventCode, awaitingApproval.id);
            $6697ff39d54b09bb$var$addNotification(newNotification);
        }
    }, reminderTimeout);
    const eventCode = "txRequest";
    $6697ff39d54b09bb$var$addNotification($6697ff39d54b09bb$var$buildNotification(eventCode, id));
    // if not provided with sendTransaction function,
    // resolve with transaction hash(or void) so dev can initiate transaction
    if (!sendTransaction) return id;
    // get result and handle errors
    let hash;
    try {
        hash = await sendTransaction();
    } catch (error) {
        const { eventCode: eventCode, errorMsg: errorMsg } = $6697ff39d54b09bb$var$extractMessageFromError(error);
        $6697ff39d54b09bb$var$addNotification($6697ff39d54b09bb$var$buildNotification(eventCode, id));
        console.error(errorMsg);
        return;
    }
    // Remove preflight notification if a resolves to hash
    // and let the SDK take over
    $6697ff39d54b09bb$export$1fbe638ecf81657e(id);
    if (hash) return hash;
    return;
}
const $6697ff39d54b09bb$var$buildNotification = (eventCode, id)=>{
    return {
        eventCode: eventCode,
        type: $6697ff39d54b09bb$var$eventToType(eventCode),
        id: id,
        key: $6697ff39d54b09bb$var$createKey(id, eventCode),
        message: $6697ff39d54b09bb$var$createMessageText(eventCode),
        startTime: Date.now(),
        network: Object.keys($6697ff39d54b09bb$export$2f6ca3d3b1f80bf5).find((key)=>$6697ff39d54b09bb$export$2f6ca3d3b1f80bf5[key] === $6697ff39d54b09bb$export$6559d589eb85fbb6.get().chains[0].id),
        autoDismiss: 0
    };
};
const $6697ff39d54b09bb$var$createKey = (id, eventCode)=>{
    return `${id}-${eventCode}`;
};
const $6697ff39d54b09bb$var$createId = (id)=>{
    return `${id}-preflight`;
};
const $6697ff39d54b09bb$var$createMessageText = (eventCode)=>{
    const notificationDefaultMessages = $6697ff39d54b09bb$export$e7094788287c5e9b.notify;
    notificationDefaultMessages.transaction;
    return notificationDefaultMessages.transaction[eventCode];
};
function $6697ff39d54b09bb$var$extractMessageFromError(error) {
    if (!error.stack || !error.message) return {
        eventCode: "txError",
        errorMsg: "An unknown error occured"
    };
    const message = error.stack || error.message;
    if (message.includes("User denied transaction signature")) return {
        eventCode: "txSendFail",
        errorMsg: "User denied transaction signature"
    };
    if (message.includes("transaction underpriced")) return {
        eventCode: "txUnderpriced",
        errorMsg: "Transaction is under priced"
    };
    return {
        eventCode: "txError",
        errorMsg: message
    };
}
const $6697ff39d54b09bb$var$gasEstimates = async (gasFunc, gasPriceFunc)=>{
    if (!gasFunc || !gasPriceFunc) return Promise.resolve([]);
    const gasProm = gasFunc();
    if (!gasProm.then) throw new Error("The `estimateGas` function must return a Promise");
    const gasPriceProm = gasPriceFunc();
    if (!gasPriceProm.then) throw new Error("The `gasPrice` function must return a Promise");
    return Promise.all([
        gasProm,
        gasPriceProm
    ]).then(([gasResult, gasPriceResult])=>{
        if (typeof gasResult !== "string") throw new Error(`The Promise returned from calling 'estimateGas' must resolve with a value of type 'string'. Received a value of: ${gasResult} with a type: ${typeof gasResult}`);
        if (typeof gasPriceResult !== "string") throw new Error(`The Promise returned from calling 'gasPrice' must resolve with a value of type 'string'. Received a value of: ${gasPriceResult} with a type: ${typeof gasPriceResult}`);
        return [
            new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(gasResult),
            new (0, (/*@__PURE__*/$parcel$interopDefault($5Kq8F)))(gasPriceResult)
        ];
    }).catch((error)=>{
        throw new Error(`There was an error getting gas estimates: ${error}`);
    });
};
const $6697ff39d54b09bb$var$API = {
    connectWallet: $6697ff39d54b09bb$export$3b513254972cfc9c,
    disconnectWallet: $6697ff39d54b09bb$export$56c0d5a1e737357d,
    setChain: $6697ff39d54b09bb$export$2d1720544b23b823,
    state: {
        get: $6697ff39d54b09bb$export$6559d589eb85fbb6.get,
        select: $6697ff39d54b09bb$export$6559d589eb85fbb6.select,
        actions: {
            setWalletModules: $6697ff39d54b09bb$var$setWalletModules,
            setLocale: $6697ff39d54b09bb$var$setLocale,
            updateNotify: $6697ff39d54b09bb$var$updateNotify,
            customNotification: $6697ff39d54b09bb$var$customNotification,
            preflightNotifications: $6697ff39d54b09bb$var$preflightNotifications,
            updateBalances: $6697ff39d54b09bb$var$updateBalances,
            updateAccountCenter: $6697ff39d54b09bb$export$1a82df3d29112e01,
            setPrimaryWallet: $6697ff39d54b09bb$export$c4ce752e73470fba,
            updateTheme: $6697ff39d54b09bb$var$updateTheme,
            updateAppMetadata: $6697ff39d54b09bb$var$updateAppMetadata
        }
    }
};
function $6697ff39d54b09bb$export$9d398bebfec1c039(options) {
    if (typeof window === "undefined") return $6697ff39d54b09bb$var$API;
    if (options) {
        const error = $6697ff39d54b09bb$var$validateInitOptions(options);
        if (error) throw error;
    }
    const { wallets: wallets, chains: chains, appMetadata: appMetadata, i18n: i18n, accountCenter: accountCenter, apiKey: apiKey, notify: notify, gas: gas, connect: connect, containerElements: containerElements, transactionPreview: transactionPreview, theme: theme, disableFontDownload: disableFontDownload, unstoppableResolution: unstoppableResolution } = options;
    if (containerElements) $6697ff39d54b09bb$var$updateConfiguration({
        containerElements: containerElements
    });
    const { device: device, svelteInstance: svelteInstance } = $6697ff39d54b09bb$export$c9170ad7d4cd7e57;
    if (svelteInstance) {
        // if already initialized, need to cleanup old instance
        console.warn("Re-initializing Onboard and resetting back to initial state");
        $6697ff39d54b09bb$var$reset$.next();
    }
    $6697ff39d54b09bb$var$initialize(i18n);
    $6697ff39d54b09bb$var$addChains($6697ff39d54b09bb$var$chainIdToHex(chains));
    $6697ff39d54b09bb$var$updateConnectModal(connect);
    // update accountCenter
    if (typeof accountCenter !== "undefined") {
        let accountCenterUpdate;
        const { hideTransactionProtectionBtn: hideTransactionProtectionBtn, transactionProtectionInfoLink: transactionProtectionInfoLink } = accountCenter;
        if (device.type === "mobile") accountCenterUpdate = {
            ...$6697ff39d54b09bb$var$APP_INITIAL_STATE.accountCenter,
            hideTransactionProtectionBtn: hideTransactionProtectionBtn,
            transactionProtectionInfoLink: transactionProtectionInfoLink,
            ...accountCenter.mobile ? accountCenter.mobile : {}
        };
        else if (accountCenter.desktop) accountCenterUpdate = {
            ...$6697ff39d54b09bb$var$APP_INITIAL_STATE.accountCenter,
            hideTransactionProtectionBtn: hideTransactionProtectionBtn,
            transactionProtectionInfoLink: transactionProtectionInfoLink,
            ...accountCenter.desktop
        };
        $6697ff39d54b09bb$export$1a82df3d29112e01(accountCenterUpdate);
    }
    // update notify
    if (typeof notify !== "undefined") {
        if ("desktop" in notify || "mobile" in notify) {
            const error = $6697ff39d54b09bb$var$validateNotifyOptions(notify);
            if (error) throw error;
            if ((!notify.desktop || notify.desktop && !notify.desktop.position) && accountCenter && accountCenter.desktop && accountCenter.desktop.position) notify.desktop.position = accountCenter.desktop.position;
            if ((!notify.mobile || notify.mobile && !notify.mobile.position) && accountCenter && accountCenter.mobile && accountCenter.mobile.position) notify.mobile.position = accountCenter.mobile.position;
            let notifyUpdate;
            if (device.type === "mobile" && notify.mobile) notifyUpdate = {
                ...$6697ff39d54b09bb$var$APP_INITIAL_STATE.notify,
                ...notify.mobile
            };
            else if (notify.desktop) notifyUpdate = {
                ...$6697ff39d54b09bb$var$APP_INITIAL_STATE.notify,
                ...notify.desktop
            };
            $6697ff39d54b09bb$var$updateNotify(notifyUpdate);
        } else {
            const error = $6697ff39d54b09bb$var$validateNotify(notify);
            if (error) throw error;
            const notifyUpdate = {
                ...$6697ff39d54b09bb$var$APP_INITIAL_STATE.notify,
                ...notify
            };
            $6697ff39d54b09bb$var$updateNotify(notifyUpdate);
        }
    } else {
        const notifyUpdate = $6697ff39d54b09bb$var$APP_INITIAL_STATE.notify;
        $6697ff39d54b09bb$var$updateNotify(notifyUpdate);
    }
    const app = svelteInstance || $6697ff39d54b09bb$var$mountApp(theme, disableFontDownload);
    $6697ff39d54b09bb$var$updateConfiguration({
        svelteInstance: app,
        apiKey: apiKey,
        initialWalletInit: wallets,
        gas: gas,
        transactionPreview: transactionPreview,
        unstoppableResolution: unstoppableResolution
    });
    appMetadata && $6697ff39d54b09bb$var$updateAppMetadata(appMetadata);
    if (apiKey && transactionPreview) {
        const getBnSDK = async ()=>{
            transactionPreview.init({
                containerElement: "#w3o-transaction-preview-container",
                sdk: await $6697ff39d54b09bb$var$getBlocknativeSdk(),
                apiKey: apiKey
            });
            $6697ff39d54b09bb$export$efccba1c4a2ef57b.subscribe((wallets)=>{
                wallets.forEach(({ provider: provider })=>{
                    transactionPreview.patchProvider(provider);
                });
            });
        };
        getBnSDK();
    }
    theme && $6697ff39d54b09bb$var$updateTheme(theme);
    // handle auto connection of last wallet
    if (connect && (connect.autoConnectLastWallet || connect.autoConnectAllPreviousWallet)) {
        const lastConnectedWallets = $6697ff39d54b09bb$var$getLocalStore($6697ff39d54b09bb$var$STORAGE_KEYS.LAST_CONNECTED_WALLET);
        try {
            const lastConnectedWalletsParsed = JSON.parse(lastConnectedWallets);
            if (lastConnectedWalletsParsed && Array.isArray(lastConnectedWalletsParsed) && lastConnectedWalletsParsed.length) $6697ff39d54b09bb$var$connectAllPreviousWallets(lastConnectedWalletsParsed, connect);
        } catch (err) {
            // Handle for legacy single wallet approach
            // Above try will throw syntax error is local storage is not json
            if (err instanceof SyntaxError && lastConnectedWallets) $6697ff39d54b09bb$var$API.connectWallet({
                autoSelect: {
                    label: lastConnectedWallets,
                    disableModals: true
                }
            });
        }
    }
    return $6697ff39d54b09bb$var$API;
}
const $6697ff39d54b09bb$var$fontFamilyExternallyDefined = (theme, disableFontDownload)=>{
    if (disableFontDownload) return true;
    if (document.body && (getComputedStyle(document.body).getPropertyValue("--onboard-font-family-normal") || getComputedStyle(document.body).getPropertyValue("--w3o-font-family"))) return true;
    if (!theme) return false;
    if (typeof theme === "object" && theme["--w3o-font-family"]) return true;
    return false;
};

const $6697ff39d54b09bb$var$importInterFont = async ()=>{
    const { InterVar: InterVar } = await Promise.resolve((parcelRequire("bib7R")));
    // Add Fonts to main page
    const styleEl = document.createElement("style");
    styleEl.innerHTML = `
    ${InterVar}
  `;
    document.body.appendChild(styleEl);
};
const $6697ff39d54b09bb$var$connectAllPreviousWallets = async (lastConnectedWallets, connect)=>{
    const activeWalletsList = [];
    const parsedWalletList = lastConnectedWallets;
    if (!connect.autoConnectAllPreviousWallet) {
        $6697ff39d54b09bb$var$API.connectWallet({
            autoSelect: {
                label: parsedWalletList[0],
                disableModals: true
            }
        });
        activeWalletsList.push(parsedWalletList[0]);
    } else // Loop in reverse to maintain wallet order
    for(let i = parsedWalletList.length; i--;){
        const walletConnectionPromise = await $6697ff39d54b09bb$var$API.connectWallet({
            autoSelect: {
                label: parsedWalletList[i],
                disableModals: true
            }
        });
        // Update localStorage list for available wallets
        if (walletConnectionPromise.some((r)=>r.label === parsedWalletList[i])) activeWalletsList.unshift(parsedWalletList[i]);
    }
    $6697ff39d54b09bb$var$setLocalStore($6697ff39d54b09bb$var$STORAGE_KEYS.LAST_CONNECTED_WALLET, JSON.stringify(activeWalletsList));
};
function $6697ff39d54b09bb$var$mountApp(theme, disableFontDownload) {
    class Onboard extends HTMLElement {
        constructor(){
            super();
        }
    }
    if (!customElements.get("onboard-v2")) customElements.define("onboard-v2", Onboard);
    if (!$6697ff39d54b09bb$var$fontFamilyExternallyDefined(theme, disableFontDownload)) $6697ff39d54b09bb$var$importInterFont();
    // add to DOM
    const onboard = document.createElement("onboard-v2");
    const target = onboard.attachShadow({
        mode: "open"
    });
    onboard.style.all = "initial";
    target.innerHTML = `

  <style>
    :host {
          /* COLORS */
          --white: white;
          --black: black;
          --primary-1: #2F80ED;
          --primary-100: #eff1fc;
          --primary-200: #d0d4f7;
          --primary-300: #b1b8f2;
          --primary-400: #929bed;
          --primary-500: #6370e5;
          --primary-600: #454ea0;
          --primary-700: #323873;
          --gray-100: #ebebed;
          --gray-200: #c2c4c9;
          --gray-300: #999ca5;
          --gray-400: #707481;
          --gray-500: #33394b;
          --gray-600: #242835;
          --gray-700: #1a1d26;
          --success-100: #d1fae3;
          --success-200: #baf7d5;
          --success-300: #a4f4c6;
          --success-400: #8df2b8;
          --success-500: #5aec99;
          --success-600: #18ce66;
          --success-700: #129b4d;
          --danger-100: #ffe5e6;
          --danger-200: #ffcccc;
          --danger-300: #ffb3b3;
          --danger-400: #ff8080;
          --danger-500: #ff4f4f;
          --danger-600: #cc0000;
          --danger-700: #660000;
          --warning-100: #ffefcc;
          --warning-200: #ffe7b3;
          --warning-300: #ffd780;
          --warning-400: #ffc74c;
          --warning-500: #ffaf00;
          --warning-600: #cc8c00;
          --warning-700: #664600;

          /* FONTS */
          --font-family-normal: var(--w3o-font-family, Inter, sans-serif);

          --font-size-1: 3rem;
          --font-size-2: 2.25rem;
          --font-size-3: 1.5rem;
          --font-size-4: 1.25rem;
          --font-size-5: 1rem;
          --font-size-6: .875rem;
          --font-size-7: .75rem;

          --font-line-height-1: 24px;
          --font-line-height-2: 20px;
          --font-line-height-3: 16px;
          --font-line-height-4: 12px;

          /* SPACING */
          --spacing-1: 3rem;
          --spacing-2: 2rem;
          --spacing-3: 1.5rem;
          --spacing-4: 1rem;
          --spacing-5: 0.5rem;
          --spacing-6: 0.25rem;
          --spacing-7: 0.125rem;

          /* BORDER RADIUS */
          --border-radius-1: 24px;
          --border-radius-2: 20px;
          --border-radius-3: 16px;
          --border-radius-4: 12px;
          --border-radius-5: 8px;

          /* SHADOWS */
          --shadow-0: none;
          --shadow-1: 0px 4px 12px rgba(0, 0, 0, 0.1);
          --shadow-2: inset 0px -1px 0px rgba(0, 0, 0, 0.1);
          --shadow-3: 0px 4px 16px rgba(0, 0, 0, 0.2);

          /* MODAL POSITIONING */
          --modal-z-index: 10;
          --modal-top: unset;
          --modal-right: unset;
          --modal-bottom: unset;
          --modal-left: unset;

          /* MODAL STYLES */
          --modal-backdrop: rgba(0, 0, 0, 0.6);

        }
      </style>
    `;
    const connectModalContEl = $6697ff39d54b09bb$export$c9170ad7d4cd7e57.containerElements.connectModal;
    const containerElementQuery = connectModalContEl || $6697ff39d54b09bb$export$6559d589eb85fbb6.get().accountCenter.containerElement || "body";
    const containerElement = document.querySelector(containerElementQuery);
    if (!containerElement) throw new Error(`Element with query ${containerElementQuery} does not exist.`);
    containerElement.appendChild(onboard);
    const app = new $6697ff39d54b09bb$var$Index({
        target: target
    });
    return app;
}

});
parcelRegister("axHCK", function(module, exports) {

$parcel$export(module.exports, "BehaviorSubject", () => $7aced346698c521d$export$cc3d42e6b2b9cf8b);

var $7WQrb = parcelRequire("7WQrb");

var $3TBY8 = parcelRequire("3TBY8");
var $7aced346698c521d$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $7WQrb.__extends)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $3TBY8.Subject));

});
parcelRegister("3TBY8", function(module, exports) {

$parcel$export(module.exports, "Subject", () => $2d63f5ffe6ca8602$export$b6bbab5a9b109038);

var $7WQrb = parcelRequire("7WQrb");

var $6OiYn = parcelRequire("6OiYn");

var $bgI6x = parcelRequire("bgI6x");

var $5Mj7J = parcelRequire("5Mj7J");

var $3JYOM = parcelRequire("3JYOM");

var $cxQqV = parcelRequire("cxQqV");
var $2d63f5ffe6ca8602$export$b6bbab5a9b109038 = function(_super) {
    (0, $7WQrb.__extends)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $2d63f5ffe6ca8602$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $5Mj7J.ObjectUnsubscribedError)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $cxQqV.errorContext)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $7WQrb.__values)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $cxQqV.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $cxQqV.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $bgI6x.EMPTY_SUBSCRIPTION;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $bgI6x.Subscription)(function() {
            _this.currentObservers = null;
            (0, $3JYOM.arrRemove)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $6OiYn.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $2d63f5ffe6ca8602$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $6OiYn.Observable));
var $2d63f5ffe6ca8602$export$155189cde295587d = function(_super) {
    (0, $7WQrb.__extends)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $bgI6x.EMPTY_SUBSCRIPTION);
    };
    return AnonymousSubject;
}($2d63f5ffe6ca8602$export$b6bbab5a9b109038);

});
parcelRegister("6OiYn", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $4f562137a990678a$export$77cea355fa80b5f4);

var $hOMJ7 = parcelRequire("hOMJ7");

var $bgI6x = parcelRequire("bgI6x");

var $kaCww = parcelRequire("kaCww");

var $1itL3 = parcelRequire("1itL3");

var $hmjgn = parcelRequire("hmjgn");

var $gCSeg = parcelRequire("gCSeg");

var $cxQqV = parcelRequire("cxQqV");
var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $hOMJ7.SafeSubscriber)(observerOrNext, error, complete);
        (0, $cxQqV.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $hOMJ7.SafeSubscriber)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $kaCww.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $1itL3.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $hmjgn.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $gCSeg.isFunction)(value.next) && (0, $gCSeg.isFunction)(value.error) && (0, $gCSeg.isFunction)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $hOMJ7.Subscriber) || $4f562137a990678a$var$isObserver(value) && (0, $bgI6x.isSubscription)(value);
}

});
parcelRegister("hOMJ7", function(module, exports) {

$parcel$export(module.exports, "Subscriber", () => $cf8ce74b80455e9f$export$60959659b2c22881);
$parcel$export(module.exports, "SafeSubscriber", () => $cf8ce74b80455e9f$export$94eeb6a328cab6c7);

var $7WQrb = parcelRequire("7WQrb");

var $gCSeg = parcelRequire("gCSeg");

var $bgI6x = parcelRequire("bgI6x");

var $hmjgn = parcelRequire("hmjgn");

var $28DKm = parcelRequire("28DKm");

var $75rFk = parcelRequire("75rFk");

var $ZT8xQ = parcelRequire("ZT8xQ");

var $gwzK1 = parcelRequire("gwzK1");

var $cxQqV = parcelRequire("cxQqV");
var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $7WQrb.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $bgI6x.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $ZT8xQ.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $ZT8xQ.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $ZT8xQ.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $bgI6x.Subscription));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $7WQrb.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $gCSeg.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $hmjgn.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $hmjgn.config).useDeprecatedSynchronousErrorHandling) (0, $cxQqV.captureError)(error);
    else (0, $28DKm.reportUnhandledError)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $hmjgn.config).onStoppedNotification;
    onStoppedNotification && (0, $gwzK1.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $75rFk.noop),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $75rFk.noop)
};

});
parcelRegister("gCSeg", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $c1aa42b0603892d6$export$f6e2535fb5126e54);
function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}

});

parcelRegister("bgI6x", function(module, exports) {

$parcel$export(module.exports, "Subscription", () => $8343668acd7c4a9b$export$f55210826850c514);
$parcel$export(module.exports, "EMPTY_SUBSCRIPTION", () => $8343668acd7c4a9b$export$610f9c3ca1a38dd8);
$parcel$export(module.exports, "isSubscription", () => $8343668acd7c4a9b$export$4f9221cbada3c4fc);

var $7WQrb = parcelRequire("7WQrb");

var $gCSeg = parcelRequire("gCSeg");

var $l4W4q = parcelRequire("l4W4q");

var $3JYOM = parcelRequire("3JYOM");
var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $7WQrb.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $gCSeg.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $l4W4q.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $7WQrb.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $l4W4q.UnsubscriptionError)) errors = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(errors)), (0, $7WQrb.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $l4W4q.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $3JYOM.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $3JYOM.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && "closed" in value && (0, $gCSeg.isFunction)(value.remove) && (0, $gCSeg.isFunction)(value.add) && (0, $gCSeg.isFunction)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $gCSeg.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

});
parcelRegister("l4W4q", function(module, exports) {

$parcel$export(module.exports, "UnsubscriptionError", () => $f587043ffd615a90$export$c9648b76fd580c34);

var $kfFvr = parcelRequire("kfFvr");
var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $kfFvr.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});

});
parcelRegister("kfFvr", function(module, exports) {

$parcel$export(module.exports, "createErrorClass", () => $ebe567a061bc80f6$export$128a15b65d1b6041);
function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

});


parcelRegister("3JYOM", function(module, exports) {

$parcel$export(module.exports, "arrRemove", () => $2b94c03d07e501cc$export$dae3f38077fc36c0);
function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

});


parcelRegister("hmjgn", function(module, exports) {

$parcel$export(module.exports, "config", () => $ca336efb1b4fb564$export$e506a1d27d1eaa20);
var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

});

parcelRegister("28DKm", function(module, exports) {

$parcel$export(module.exports, "reportUnhandledError", () => $18eb28ff53cc4943$export$ebf645db02d3e99f);

var $hmjgn = parcelRequire("hmjgn");

var $gwzK1 = parcelRequire("gwzK1");
function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $gwzK1.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, $hmjgn.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

});
parcelRegister("gwzK1", function(module, exports) {

$parcel$export(module.exports, "timeoutProvider", () => $c07b5bfa3b9d4401$export$365aa6bd3c788e3d);

var $7WQrb = parcelRequire("7WQrb");
var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $7WQrb.__spreadArray)([
            handler,
            timeout
        ], (0, $7WQrb.__read)(args)));
        return setTimeout.apply(void 0, (0, $7WQrb.__spreadArray)([
            handler,
            timeout
        ], (0, $7WQrb.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

});


parcelRegister("75rFk", function(module, exports) {

$parcel$export(module.exports, "noop", () => $528e75db69787807$export$8793edee2d425525);
function $528e75db69787807$export$8793edee2d425525() {}

});

parcelRegister("ZT8xQ", function(module, exports) {

$parcel$export(module.exports, "COMPLETE_NOTIFICATION", () => $0ba077a4cdfd9739$export$b7f97edb34bc1f87);
$parcel$export(module.exports, "errorNotification", () => $0ba077a4cdfd9739$export$dd472c3d8fe5a85a);
$parcel$export(module.exports, "nextNotification", () => $0ba077a4cdfd9739$export$ff9346b0d1d30313);
var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

});

parcelRegister("cxQqV", function(module, exports) {

$parcel$export(module.exports, "errorContext", () => $92213d3dd6a83b5d$export$d974811edc77eafa);
$parcel$export(module.exports, "captureError", () => $92213d3dd6a83b5d$export$3e205fbb5df021e0);

var $hmjgn = parcelRequire("hmjgn");
var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $hmjgn.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $hmjgn.config).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}

});


parcelRegister("kaCww", function(module, exports) {

$parcel$export(module.exports, "observable", () => $eaf29fccbded6ed3$export$5ab46cbf6120b33a);
var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

});

parcelRegister("1itL3", function(module, exports) {

$parcel$export(module.exports, "pipeFromArray", () => $0f1e8e2d1fe93adf$export$71f88a61afaa14d7);

var $a4Ze1 = parcelRequire("a4Ze1");
function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $a4Ze1.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

});
parcelRegister("a4Ze1", function(module, exports) {

$parcel$export(module.exports, "identity", () => $7569c528cdd9d182$export$f0954fd7d5368655);
function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}

});



parcelRegister("5Mj7J", function(module, exports) {

$parcel$export(module.exports, "ObjectUnsubscribedError", () => $43504509ae7aa03d$export$f708eee25634bc80);

var $kfFvr = parcelRequire("kfFvr");
var $43504509ae7aa03d$export$f708eee25634bc80 = (0, $kfFvr.createErrorClass)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});

});



parcelRegister("bfHa8", function(module, exports) {

$parcel$export(module.exports, "defer", () => $8312939aeeb1a4f7$export$260e5c0943f31606);

var $6OiYn = parcelRequire("6OiYn");

var $2ypWW = parcelRequire("2ypWW");
function $8312939aeeb1a4f7$export$260e5c0943f31606(observableFactory) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        (0, $2ypWW.innerFrom)(observableFactory()).subscribe(subscriber);
    });
}

});
parcelRegister("2ypWW", function(module, exports) {

$parcel$export(module.exports, "innerFrom", () => $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910);

var $7WQrb = parcelRequire("7WQrb");

var $bGCU7 = parcelRequire("bGCU7");

var $dy1jD = parcelRequire("dy1jD");

var $6OiYn = parcelRequire("6OiYn");

var $rOw2q = parcelRequire("rOw2q");

var $aGtFl = parcelRequire("aGtFl");

var $iolDb = parcelRequire("iolDb");

var $fQMll = parcelRequire("fQMll");

var $7gZl2 = parcelRequire("7gZl2");

var $gCSeg = parcelRequire("gCSeg");

var $28DKm = parcelRequire("28DKm");

var $kaCww = parcelRequire("kaCww");
function $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $6OiYn.Observable)) return input;
    if (input != null) {
        if ((0, $rOw2q.isInteropObservable)(input)) return $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(input);
        if ((0, $bGCU7.isArrayLike)(input)) return $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(input);
        if ((0, $dy1jD.isPromise)(input)) return $1dc2e2cd8f7c5351$export$60f45028237c39d1(input);
        if ((0, $aGtFl.isAsyncIterable)(input)) return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(input);
        if ((0, $fQMll.isIterable)(input)) return $1dc2e2cd8f7c5351$export$dcccc29c315dd646(input);
        if ((0, $7gZl2.isReadableStreamLike)(input)) return $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $iolDb.createInvalidObservableTypeError)(input);
}
function $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(obj) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var obs = obj[0, $kaCww.observable]();
        if ((0, $gCSeg.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
}
function $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(array) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$60f45028237c39d1(promise) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $28DKm.reportUnhandledError));
    });
}
function $1dc2e2cd8f7c5351$export$dcccc29c315dd646(iterable) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $7WQrb.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(readableStream) {
    return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1((0, $7gZl2.readableStreamLikeToAsyncGenerator)(readableStream));
}
function $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $7WQrb.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $7WQrb.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

});
parcelRegister("bGCU7", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $8821cb8787de9fb5$export$1e2f57719e155213);
var $8821cb8787de9fb5$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

});

parcelRegister("dy1jD", function(module, exports) {

$parcel$export(module.exports, "isPromise", () => $9dcf7896928e75dd$export$4369c812aac99591);

var $gCSeg = parcelRequire("gCSeg");
function $9dcf7896928e75dd$export$4369c812aac99591(value) {
    return (0, $gCSeg.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

});

parcelRegister("rOw2q", function(module, exports) {

$parcel$export(module.exports, "isInteropObservable", () => $0539b51af1903d0a$export$48c0cddbc99c45c2);

var $kaCww = parcelRequire("kaCww");

var $gCSeg = parcelRequire("gCSeg");
function $0539b51af1903d0a$export$48c0cddbc99c45c2(input) {
    return (0, $gCSeg.isFunction)(input[0, $kaCww.observable]);
}

});

parcelRegister("aGtFl", function(module, exports) {

$parcel$export(module.exports, "isAsyncIterable", () => $7c74d6a5e2273447$export$edb10ab8dd75a915);

var $gCSeg = parcelRequire("gCSeg");
function $7c74d6a5e2273447$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $gCSeg.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

});

parcelRegister("iolDb", function(module, exports) {

$parcel$export(module.exports, "createInvalidObservableTypeError", () => $d63b3f5b704e6de4$export$7cbe71b9fa263484);
function $d63b3f5b704e6de4$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

});

parcelRegister("fQMll", function(module, exports) {

$parcel$export(module.exports, "isIterable", () => $b8a13650b96f19ab$export$9652023d9040757);

var $ZpNjd = parcelRequire("ZpNjd");

var $gCSeg = parcelRequire("gCSeg");
function $b8a13650b96f19ab$export$9652023d9040757(input) {
    return (0, $gCSeg.isFunction)(input === null || input === void 0 ? void 0 : input[0, $ZpNjd.iterator]);
}

});
parcelRegister("ZpNjd", function(module, exports) {

$parcel$export(module.exports, "iterator", () => $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d);
function $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d = $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8();

});


parcelRegister("7gZl2", function(module, exports) {

$parcel$export(module.exports, "readableStreamLikeToAsyncGenerator", () => $54b99b9095e84ce4$export$cf4785e597badab3);
$parcel$export(module.exports, "isReadableStreamLike", () => $54b99b9095e84ce4$export$c088ffafdba7405f);

var $7WQrb = parcelRequire("7WQrb");

var $gCSeg = parcelRequire("gCSeg");
function $54b99b9095e84ce4$export$cf4785e597badab3(readableStream) {
    return (0, $7WQrb.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $7WQrb.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $7WQrb.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $7WQrb.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $7WQrb.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $54b99b9095e84ce4$export$c088ffafdba7405f(obj) {
    return (0, $gCSeg.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

});



parcelRegister("9AGP8", function(module, exports) {

$parcel$export(module.exports, "distinctUntilChanged", () => $6fb8b1c12553edae$export$779c5fb865a0172e);

var $a4Ze1 = parcelRequire("a4Ze1");

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $6fb8b1c12553edae$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $a4Ze1.identity);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $6fb8b1c12553edae$var$defaultCompare;
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $6fb8b1c12553edae$var$defaultCompare(a, b) {
    return a === b;
}

});
parcelRegister("d9kQQ", function(module, exports) {

$parcel$export(module.exports, "operate", () => $992c4a42843eb1d0$export$871731df685d7753);

var $gCSeg = parcelRequire("gCSeg");
function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $gCSeg.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}

});

parcelRegister("4QgEI", function(module, exports) {

$parcel$export(module.exports, "createOperatorSubscriber", () => $3868f035248205c1$export$b9e075132cc6937f);

var $7WQrb = parcelRequire("7WQrb");

var $hOMJ7 = parcelRequire("hOMJ7");
function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $7WQrb.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $hOMJ7.Subscriber));

});


parcelRegister("d6DLj", function(module, exports) {

$parcel$export(module.exports, "filter", () => $98aaadcfa91e6727$export$3dea766d36a8935f);

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $98aaadcfa91e6727$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}

});

parcelRegister("jKULm", function(module, exports) {

$parcel$export(module.exports, "firstValueFrom", () => $e61e581d31b1ea5f$export$400f9f949cef996c);

var $9ksbw = parcelRequire("9ksbw");

var $hOMJ7 = parcelRequire("hOMJ7");
function $e61e581d31b1ea5f$export$400f9f949cef996c(source, config) {
    var hasConfig = typeof config === "object";
    return new Promise(function(resolve, reject) {
        var subscriber = new (0, $hOMJ7.SafeSubscriber)({
            next: function(value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function() {
                if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, $9ksbw.EmptyError)());
            }
        });
        source.subscribe(subscriber);
    });
}

});
parcelRegister("9ksbw", function(module, exports) {

$parcel$export(module.exports, "EmptyError", () => $6cabd83f99ce6113$export$78f6d1b1dbcda304);

var $kfFvr = parcelRequire("kfFvr");
var $6cabd83f99ce6113$export$78f6d1b1dbcda304 = (0, $kfFvr.createErrorClass)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = "EmptyError";
        this.message = "no elements in sequence";
    };
});

});


parcelRegister("l9kJq", function(module, exports) {

$parcel$export(module.exports, "fromEvent", () => $f65a851e0b190f66$export$a36e16046ae8f1bb);

var $7WQrb = parcelRequire("7WQrb");

var $2ypWW = parcelRequire("2ypWW");

var $6OiYn = parcelRequire("6OiYn");

var $63Jtj = parcelRequire("63Jtj");

var $bGCU7 = parcelRequire("bGCU7");

var $gCSeg = parcelRequire("gCSeg");

var $jOyqp = parcelRequire("jOyqp");
var $f65a851e0b190f66$var$nodeEventEmitterMethods = [
    "addListener",
    "removeListener"
];
var $f65a851e0b190f66$var$eventTargetMethods = [
    "addEventListener",
    "removeEventListener"
];
var $f65a851e0b190f66$var$jqueryMethods = [
    "on",
    "off"
];
function $f65a851e0b190f66$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $gCSeg.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $f65a851e0b190f66$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $jOyqp.mapOneOrManyArgs)(resultSelector));
    var _a = (0, $7WQrb.__read)($f65a851e0b190f66$var$isEventTarget(target) ? $f65a851e0b190f66$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $f65a851e0b190f66$var$isNodeStyleEventEmitter(target) ? $f65a851e0b190f66$var$nodeEventEmitterMethods.map($f65a851e0b190f66$var$toCommonHandlerRegistry(target, eventName)) : $f65a851e0b190f66$var$isJQueryStyleEventEmitter(target) ? $f65a851e0b190f66$var$jqueryMethods.map($f65a851e0b190f66$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $bGCU7.isArrayLike)(target)) return (0, $63Jtj.mergeMap)(function(subTarget) {
            return $f65a851e0b190f66$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $2ypWW.innerFrom)(target));
    }
    if (!add) throw new TypeError("Invalid event target");
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $f65a851e0b190f66$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $f65a851e0b190f66$var$isNodeStyleEventEmitter(target) {
    return (0, $gCSeg.isFunction)(target.addListener) && (0, $gCSeg.isFunction)(target.removeListener);
}
function $f65a851e0b190f66$var$isJQueryStyleEventEmitter(target) {
    return (0, $gCSeg.isFunction)(target.on) && (0, $gCSeg.isFunction)(target.off);
}
function $f65a851e0b190f66$var$isEventTarget(target) {
    return (0, $gCSeg.isFunction)(target.addEventListener) && (0, $gCSeg.isFunction)(target.removeEventListener);
}

});
parcelRegister("63Jtj", function(module, exports) {

$parcel$export(module.exports, "mergeMap", () => $46964ba1b403cbfc$export$6b9f6c0d32c093f9);

var $d4PzE = parcelRequire("d4PzE");

var $2ypWW = parcelRequire("2ypWW");

var $d9kQQ = parcelRequire("d9kQQ");

var $dshQu = parcelRequire("dshQu");

var $gCSeg = parcelRequire("gCSeg");
function $46964ba1b403cbfc$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $gCSeg.isFunction)(resultSelector)) return $46964ba1b403cbfc$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $d4PzE.map)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $2ypWW.innerFrom)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        return (0, $dshQu.mergeInternals)(source, subscriber, project, concurrent);
    });
}

});
parcelRegister("d4PzE", function(module, exports) {

$parcel$export(module.exports, "map", () => $9853a79d111e4e33$export$871de8747c9eaa88);

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $9853a79d111e4e33$export$871de8747c9eaa88(project, thisArg) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

});

parcelRegister("dshQu", function(module, exports) {

$parcel$export(module.exports, "mergeInternals", () => $9cbbbba4f565a378$export$600918ebaa9e0a1b);

var $2ypWW = parcelRequire("2ypWW");

var $4yU8l = parcelRequire("4yU8l");

var $4QgEI = parcelRequire("4QgEI");
function $9cbbbba4f565a378$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $2ypWW.innerFrom)(project(value, index++)).subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $4yU8l.executeSchedule)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}

});
parcelRegister("4yU8l", function(module, exports) {

$parcel$export(module.exports, "executeSchedule", () => $3525e15e439f8b93$export$a2b7447487315232);
function $3525e15e439f8b93$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

});



parcelRegister("jOyqp", function(module, exports) {

$parcel$export(module.exports, "mapOneOrManyArgs", () => $e6cd63efe08c02de$export$559affaa48f4288d);

var $7WQrb = parcelRequire("7WQrb");

var $d4PzE = parcelRequire("d4PzE");
var $e6cd63efe08c02de$var$isArray = Array.isArray;
function $e6cd63efe08c02de$var$callOrApply(fn, args) {
    return $e6cd63efe08c02de$var$isArray(args) ? fn.apply(void 0, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(args))) : fn(args);
}
function $e6cd63efe08c02de$export$559affaa48f4288d(fn) {
    return (0, $d4PzE.map)(function(args) {
        return $e6cd63efe08c02de$var$callOrApply(fn, args);
    });
}

});


parcelRegister("hU8PB", function(module, exports) {

$parcel$export(module.exports, "fromEventPattern", () => $d08e84546ee8df12$export$af596f9f0ff848f8);

var $6OiYn = parcelRequire("6OiYn");

var $gCSeg = parcelRequire("gCSeg");

var $jOyqp = parcelRequire("jOyqp");
function $d08e84546ee8df12$export$af596f9f0ff848f8(addHandler, removeHandler, resultSelector) {
    if (resultSelector) return $d08e84546ee8df12$export$af596f9f0ff848f8(addHandler, removeHandler).pipe((0, $jOyqp.mapOneOrManyArgs)(resultSelector));
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var handler = function() {
            var e = [];
            for(var _i = 0; _i < arguments.length; _i++)e[_i] = arguments[_i];
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue = addHandler(handler);
        return (0, $gCSeg.isFunction)(removeHandler) ? function() {
            return removeHandler(handler, retValue);
        } : undefined;
    });
}

});

parcelRegister("8Ydqd", function(module, exports) {

$parcel$export(module.exports, "mapTo", () => $687e56a36053246d$export$e0eaf3a86c03b2ad);

var $d4PzE = parcelRequire("d4PzE");
function $687e56a36053246d$export$e0eaf3a86c03b2ad(value) {
    return (0, $d4PzE.map)(function() {
        return value;
    });
}

});

parcelRegister("hDTQV", function(module, exports) {

$parcel$export(module.exports, "shareReplay", () => $cd8167599454f872$export$db61d692014e534e);

var $6mpu5 = parcelRequire("6mpu5");

var $16oXE = parcelRequire("16oXE");
function $cd8167599454f872$export$db61d692014e534e(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === "object") _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    else bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    return (0, $16oXE.share)({
        connector: function() {
            return new (0, $6mpu5.ReplaySubject)(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
    });
}

});
parcelRegister("6mpu5", function(module, exports) {

$parcel$export(module.exports, "ReplaySubject", () => $4a1890c700519557$export$915d2682b0aa0991);

var $7WQrb = parcelRequire("7WQrb");

var $3TBY8 = parcelRequire("3TBY8");

var $cLITg = parcelRequire("cLITg");
var $4a1890c700519557$export$915d2682b0aa0991 = function(_super) {
    (0, $7WQrb.__extends)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, $cLITg.dateTimestampProvider);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, $3TBY8.Subject));

});
parcelRegister("cLITg", function(module, exports) {

$parcel$export(module.exports, "dateTimestampProvider", () => $94bcb2181a19339b$export$c1895ea2d519a677);
var $94bcb2181a19339b$export$c1895ea2d519a677 = {
    now: function() {
        return ($94bcb2181a19339b$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};

});


parcelRegister("16oXE", function(module, exports) {

$parcel$export(module.exports, "share", () => $0cd9b6b86141760f$export$ed80d9de1d9df928);

var $7WQrb = parcelRequire("7WQrb");

var $2ypWW = parcelRequire("2ypWW");

var $3TBY8 = parcelRequire("3TBY8");

var $hOMJ7 = parcelRequire("hOMJ7");

var $d9kQQ = parcelRequire("d9kQQ");
function $0cd9b6b86141760f$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $3TBY8.Subject)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $d9kQQ.operate)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $0cd9b6b86141760f$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $hOMJ7.SafeSubscriber)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $2ypWW.innerFrom)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $0cd9b6b86141760f$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $hOMJ7.SafeSubscriber)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $2ypWW.innerFrom)(on.apply(void 0, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(args)))).subscribe(onSubscriber);
}

});


parcelRegister("fy9c8", function(module, exports) {

$parcel$export(module.exports, "startWith", () => $b52129d9072c7912$export$a4fe86229b0e9bdd);

var $beVzk = parcelRequire("beVzk");

var $54Vhv = parcelRequire("54Vhv");

var $d9kQQ = parcelRequire("d9kQQ");
function $b52129d9072c7912$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $54Vhv.popScheduler)(values);
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        (scheduler ? (0, $beVzk.concat)(values, source, scheduler) : (0, $beVzk.concat)(values, source)).subscribe(subscriber);
    });
}

});
parcelRegister("beVzk", function(module, exports) {

$parcel$export(module.exports, "concat", () => $82eda875fdd470db$export$ee1b3e54f0441b22);

var $50mg2 = parcelRequire("50mg2");

var $54Vhv = parcelRequire("54Vhv");

var $46Tqd = parcelRequire("46Tqd");
function $82eda875fdd470db$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $50mg2.concatAll)()((0, $46Tqd.from)(args, (0, $54Vhv.popScheduler)(args)));
}

});
parcelRegister("50mg2", function(module, exports) {

$parcel$export(module.exports, "concatAll", () => $3a4e37c3b56570cb$export$b314777ae20abca9);

var $665rg = parcelRequire("665rg");
function $3a4e37c3b56570cb$export$b314777ae20abca9() {
    return (0, $665rg.mergeAll)(1);
}

});
parcelRegister("665rg", function(module, exports) {

$parcel$export(module.exports, "mergeAll", () => $4707859e785b3da6$export$18aef43295bbe906);

var $63Jtj = parcelRequire("63Jtj");

var $a4Ze1 = parcelRequire("a4Ze1");
function $4707859e785b3da6$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $63Jtj.mergeMap)((0, $a4Ze1.identity), concurrent);
}

});


parcelRegister("54Vhv", function(module, exports) {

$parcel$export(module.exports, "popResultSelector", () => $3b29c258456d9a89$export$9ae19b645239a61b);
$parcel$export(module.exports, "popScheduler", () => $3b29c258456d9a89$export$29534b2f653ae592);
$parcel$export(module.exports, "popNumber", () => $3b29c258456d9a89$export$3de14b735070dcd5);

var $gCSeg = parcelRequire("gCSeg");

var $hEazg = parcelRequire("hEazg");
function $3b29c258456d9a89$var$last(arr) {
    return arr[arr.length - 1];
}
function $3b29c258456d9a89$export$9ae19b645239a61b(args) {
    return (0, $gCSeg.isFunction)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$29534b2f653ae592(args) {
    return (0, $hEazg.isScheduler)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $3b29c258456d9a89$var$last(args) === "number" ? args.pop() : defaultValue;
}

});
parcelRegister("hEazg", function(module, exports) {

$parcel$export(module.exports, "isScheduler", () => $cd8e5ea142a386bd$export$187e35932e88c15c);

var $gCSeg = parcelRequire("gCSeg");
function $cd8e5ea142a386bd$export$187e35932e88c15c(value) {
    return value && (0, $gCSeg.isFunction)(value.schedule);
}

});


parcelRegister("46Tqd", function(module, exports) {

$parcel$export(module.exports, "from", () => $2fe2b696577919a5$export$6788812c4e6611e6);

var $ci5Ul = parcelRequire("ci5Ul");

var $2ypWW = parcelRequire("2ypWW");
function $2fe2b696577919a5$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $ci5Ul.scheduled)(input, scheduler) : (0, $2ypWW.innerFrom)(input);
}

});
parcelRegister("ci5Ul", function(module, exports) {

$parcel$export(module.exports, "scheduled", () => $8f2bbfa9b5105688$export$49c44dfc2bb21d70);

var $jxGcZ = parcelRequire("jxGcZ");

var $aS4Ip = parcelRequire("aS4Ip");

var $16Erw = parcelRequire("16Erw");

var $4ZsdA = parcelRequire("4ZsdA");

var $i3S70 = parcelRequire("i3S70");

var $rOw2q = parcelRequire("rOw2q");

var $dy1jD = parcelRequire("dy1jD");

var $bGCU7 = parcelRequire("bGCU7");

var $fQMll = parcelRequire("fQMll");

var $aGtFl = parcelRequire("aGtFl");

var $iolDb = parcelRequire("iolDb");

var $7gZl2 = parcelRequire("7gZl2");

var $arhob = parcelRequire("arhob");
function $8f2bbfa9b5105688$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $rOw2q.isInteropObservable)(input)) return (0, $jxGcZ.scheduleObservable)(input, scheduler);
        if ((0, $bGCU7.isArrayLike)(input)) return (0, $16Erw.scheduleArray)(input, scheduler);
        if ((0, $dy1jD.isPromise)(input)) return (0, $aS4Ip.schedulePromise)(input, scheduler);
        if ((0, $aGtFl.isAsyncIterable)(input)) return (0, $i3S70.scheduleAsyncIterable)(input, scheduler);
        if ((0, $fQMll.isIterable)(input)) return (0, $4ZsdA.scheduleIterable)(input, scheduler);
        if ((0, $7gZl2.isReadableStreamLike)(input)) return (0, $arhob.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, $iolDb.createInvalidObservableTypeError)(input);
}

});
parcelRegister("jxGcZ", function(module, exports) {

$parcel$export(module.exports, "scheduleObservable", () => $e3a1d71c442b5de9$export$ed8bd553a12b6a30);

var $2ypWW = parcelRequire("2ypWW");

var $3blUb = parcelRequire("3blUb");

var $iNvbf = parcelRequire("iNvbf");
function $e3a1d71c442b5de9$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $2ypWW.innerFrom)(input).pipe((0, $iNvbf.subscribeOn)(scheduler), (0, $3blUb.observeOn)(scheduler));
}

});
parcelRegister("3blUb", function(module, exports) {

$parcel$export(module.exports, "observeOn", () => $25136415cad576bc$export$9007f49c319d1ac7);

var $4yU8l = parcelRequire("4yU8l");

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $25136415cad576bc$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            return (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

});

parcelRegister("iNvbf", function(module, exports) {

$parcel$export(module.exports, "subscribeOn", () => $daf4fd612cb884aa$export$1eb44d8f5f64733b);

var $d9kQQ = parcelRequire("d9kQQ");
function $daf4fd612cb884aa$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

});


parcelRegister("aS4Ip", function(module, exports) {

$parcel$export(module.exports, "schedulePromise", () => $7ea29ae5d684fb04$export$fc9afd948577f0a8);

var $2ypWW = parcelRequire("2ypWW");

var $3blUb = parcelRequire("3blUb");

var $iNvbf = parcelRequire("iNvbf");
function $7ea29ae5d684fb04$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $2ypWW.innerFrom)(input).pipe((0, $iNvbf.subscribeOn)(scheduler), (0, $3blUb.observeOn)(scheduler));
}

});

parcelRegister("16Erw", function(module, exports) {

$parcel$export(module.exports, "scheduleArray", () => $0ce5b91768be0a6d$export$b34673931371729a);

var $6OiYn = parcelRequire("6OiYn");
function $0ce5b91768be0a6d$export$b34673931371729a(input, scheduler) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

});

parcelRegister("4ZsdA", function(module, exports) {

$parcel$export(module.exports, "scheduleIterable", () => $3a22bf76b9b6de63$export$2b75c58ab9b5b766);

var $6OiYn = parcelRequire("6OiYn");

var $ZpNjd = parcelRequire("ZpNjd");

var $gCSeg = parcelRequire("gCSeg");

var $4yU8l = parcelRequire("4yU8l");
function $3a22bf76b9b6de63$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        var iterator;
        (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, $ZpNjd.iterator]();
            (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $gCSeg.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

});

parcelRegister("i3S70", function(module, exports) {

$parcel$export(module.exports, "scheduleAsyncIterable", () => $d2627b52a3f1ff1b$export$7c7f0979b56a32f3);

var $6OiYn = parcelRequire("6OiYn");

var $4yU8l = parcelRequire("4yU8l");
function $d2627b52a3f1ff1b$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $6OiYn.Observable)(function(subscriber) {
        (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $4yU8l.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

});

parcelRegister("arhob", function(module, exports) {

$parcel$export(module.exports, "scheduleReadableStreamLike", () => $7999ea1c5b71ad25$export$3385251aeecad28a);

var $i3S70 = parcelRequire("i3S70");

var $7gZl2 = parcelRequire("7gZl2");
function $7999ea1c5b71ad25$export$3385251aeecad28a(input, scheduler) {
    return (0, $i3S70.scheduleAsyncIterable)((0, $7gZl2.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

});





parcelRegister("jGgch", function(module, exports) {

$parcel$export(module.exports, "take", () => $e53e80f9042754be$export$b7df5d561049483a);

var $ckPFG = parcelRequire("ckPFG");

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $e53e80f9042754be$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $ckPFG.EMPTY;
    } : (0, $d9kQQ.operate)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}

});
parcelRegister("ckPFG", function(module, exports) {

$parcel$export(module.exports, "EMPTY", () => $8faf6f2806f38bc2$export$ccb33e29d92c9a58);

var $6OiYn = parcelRequire("6OiYn");
var $8faf6f2806f38bc2$export$ccb33e29d92c9a58 = new (0, $6OiYn.Observable)(function(subscriber) {
    return subscriber.complete();
});
function $8faf6f2806f38bc2$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $8faf6f2806f38bc2$var$emptyScheduled(scheduler) : $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
}
function $8faf6f2806f38bc2$var$emptyScheduled(scheduler) {
    return new (0, $6OiYn.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

});


parcelRegister("jXWpp", function(module, exports) {

$parcel$export(module.exports, "takeUntil", () => $e890d5c5b4491f33$export$ac8dfd3a7ad06e80);

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");

var $2ypWW = parcelRequire("2ypWW");

var $75rFk = parcelRequire("75rFk");
function $e890d5c5b4491f33$export$ac8dfd3a7ad06e80(notifier) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        (0, $2ypWW.innerFrom)(notifier).subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function() {
            return subscriber.complete();
        }, (0, $75rFk.noop)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}

});

parcelRegister("7QREK", function(module, exports) {

$parcel$export(module.exports, "distinctUntilKeyChanged", () => $5b7702bd13db251d$export$571da16e28367bde);

var $9AGP8 = parcelRequire("9AGP8");
function $5b7702bd13db251d$export$571da16e28367bde(key, compare) {
    return (0, $9AGP8.distinctUntilChanged)(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}

});

parcelRegister("6vUKV", function(module, exports) {

$parcel$export(module.exports, "pluck", () => $4be1a9d761a9d3e3$export$c44985b87d605eff);

var $d4PzE = parcelRequire("d4PzE");
function $4be1a9d761a9d3e3$export$c44985b87d605eff() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error("list of properties cannot be empty.");
    return (0, $d4PzE.map)(function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
            if (typeof p !== "undefined") currentProp = p;
            else return undefined;
        }
        return currentProp;
    });
}

});

parcelRegister("466t7", function(module, exports) {

$parcel$export(module.exports, "switchMap", () => $2fbcbd7f7704e649$export$9f6ea8e48bc26eab);

var $2ypWW = parcelRequire("2ypWW");

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");
function $2fbcbd7f7704e649$export$9f6ea8e48bc26eab(project, resultSelector) {
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, $2ypWW.innerFrom)(project(value, outerIndex)).subscribe(innerSubscriber = (0, $4QgEI.createOperatorSubscriber)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}

});

parcelRegister("eUlHv", function(module, exports) {

$parcel$export(module.exports, "withLatestFrom", () => $ada720f14bd5f844$export$d449030e5c10edf7);

var $7WQrb = parcelRequire("7WQrb");

var $d9kQQ = parcelRequire("d9kQQ");

var $4QgEI = parcelRequire("4QgEI");

var $2ypWW = parcelRequire("2ypWW");

var $a4Ze1 = parcelRequire("a4Ze1");

var $75rFk = parcelRequire("75rFk");

var $54Vhv = parcelRequire("54Vhv");
function $ada720f14bd5f844$export$d449030e5c10edf7() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = (0, $54Vhv.popResultSelector)(inputs);
    return (0, $d9kQQ.operate)(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            (0, $2ypWW.innerFrom)(inputs[i]).subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every((0, $a4Ze1.identity))) && (hasValue = null);
                }
            }, (0, $75rFk.noop)));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe((0, $4QgEI.createOperatorSubscriber)(subscriber, function(value) {
            if (ready) {
                var values = (0, $7WQrb.__spreadArray)([
                    value
                ], (0, $7WQrb.__read)(otherValues));
                subscriber.next(project ? project.apply(void 0, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(values))) : values);
            }
        }));
    });
}

});

parcelRegister("k3ihT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1Mr4B").then(()=>parcelRequire("1zV8I"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("gphoY", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jLls5").then(()=>parcelRequire("d7yUB"));

});

parcelRegister("83NaW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("61CYG").then(()=>parcelRequire("bTejC"));

});


parcelRegister("2awro", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array ? array.length : 0;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    if (value !== value) return baseFindIndex(array, baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity]
 *  The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function uniqBy(array, iteratee) {
    return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = uniqBy;

});

parcelRegister("77xkm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7RU8N").then(()=>parcelRequire("duk7B"));

});

parcelRegister("kKnxg", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dOEWM").then(()=>parcelRequire("ctRet"));

});

parcelRegister("5xwMc", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3M8Th").then(()=>parcelRequire("9b4YQ"));

});

parcelRegister("bj7eP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hM5jg").then(()=>parcelRequire("dMQDz"));

});

parcelRegister("anred", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("l2YA8").then(()=>parcelRequire("9R0kj"));

});

parcelRegister("2BbQ6", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hSZsE").then(()=>parcelRequire("1IgSe"));

});

parcelRegister("gTJxy", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kUBQp").then(()=>parcelRequire("erKGn"));

});

parcelRegister("g7yAU", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4E6cO").then(()=>parcelRequire("4CNIw"));

});

parcelRegister("eSE7Q", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kPrzs").then(()=>parcelRequire("9DV8H"));

});

parcelRegister("8kAZ4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6cyn7").then(()=>parcelRequire("1IMEn"));

});

parcelRegister("dHpB8", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1vV0A").then(()=>parcelRequire("c7y0K"));

});

parcelRegister("kV0Q8", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("f8wXH").then(()=>parcelRequire("kw2I3"));

});

parcelRegister("pQUpv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8rnp7").then(()=>parcelRequire("bJMgZ"));

});

parcelRegister("lQSGK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("coZkB").then(()=>parcelRequire("bVwUi"));

});

parcelRegister("eIsx2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hofEg").then(()=>parcelRequire("j5vV4"));

});

parcelRegister("4zOC9", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dCigr").then(()=>parcelRequire("lsB0u"));

});

parcelRegister("k0Ct4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("zaPCJ").then(()=>parcelRequire("hokDK"));

});

parcelRegister("9yERD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lCEBY").then(()=>parcelRequire("cN5pk"));

});

parcelRegister("fvG3x", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cZDHO").then(()=>parcelRequire("9DCVW"));

});

parcelRegister("gYtt1", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1Ohg0").then(()=>parcelRequire("hrY7z"));

});

parcelRegister("dGnOC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fyqb4").then(()=>parcelRequire("e4iH8"));

});

parcelRegister("nFYmO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eJhML").then(()=>parcelRequire("dyfOj"));

});

parcelRegister("jqRMv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8dIyi").then(()=>parcelRequire("8holg"));

});

parcelRegister("bLBFP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("itMxT").then(()=>parcelRequire("ei3e3"));

});

parcelRegister("gv6kT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lD49O").then(()=>parcelRequire("3CXWx"));

});

parcelRegister("f282q", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6gvC0").then(()=>parcelRequire("1JJV2"));

});

parcelRegister("8LKEq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hKM2U").then(()=>parcelRequire("idQvq"));

});

parcelRegister("bwEZx", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hm4LN").then(()=>parcelRequire("cc2dV"));

});

parcelRegister("iqiBr", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9njq9").then(()=>parcelRequire("dJXKs"));

});

parcelRegister("gMGpM", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gcwDV").then(()=>parcelRequire("8bhU4"));

});

parcelRegister("7nPtz", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7BRSq").then(()=>parcelRequire("551g3"));

});

parcelRegister("72eqq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("61hP4").then(()=>parcelRequire("bInfu"));

});

parcelRegister("eH9pd", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dETuu").then(()=>parcelRequire("j9pL5"));

});

parcelRegister("gIFYS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5C23A").then(()=>parcelRequire("1cwTd"));

});

parcelRegister("jca0Q", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1GoKa").then(()=>parcelRequire("aKqby"));

});

parcelRegister("3YfNp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3c8No").then(()=>parcelRequire("l0gry"));

});

parcelRegister("eE8CS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kvrX1").then(()=>parcelRequire("2RmDu"));

});

parcelRegister("k6Pln", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ebw82").then(()=>parcelRequire("enel0"));

});

parcelRegister("1uXeX", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("er3V6").then(()=>parcelRequire("e7UXx"));

});

parcelRegister("izG35", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1wJUp").then(()=>parcelRequire("1NH5Q"));

});

parcelRegister("7Y8iK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aQ7qs").then(()=>parcelRequire("cOYqs"));

});

parcelRegister("j62R5", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4USHL").then(()=>parcelRequire("idvuO"));

});

parcelRegister("7TIXn", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jT7YW").then(()=>parcelRequire("c17C4"));

});

parcelRegister("dqL91", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8pjKT").then(()=>parcelRequire("gJ4Zo"));

});

parcelRegister("hUMdH", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gZXE0").then(()=>parcelRequire("4JkLN"));

});

parcelRegister("joZtd", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1dPRA").then(()=>parcelRequire("ll4mB"));

});

parcelRegister("l9F2c", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8B3IS").then(()=>parcelRequire("ebsJf"));

});

parcelRegister("2Ayqw", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3WWP9").then(()=>parcelRequire("4WOfD"));

});

parcelRegister("eifR8", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8TIJD").then(()=>parcelRequire("3LSG5"));

});

parcelRegister("6wQWr", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6Ofxf").then(()=>parcelRequire("gpVP6"));

});

parcelRegister("ceJdF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("f3whp").then(()=>parcelRequire("lelTE"));

});

parcelRegister("4OR8U", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("69iDJ").then(()=>parcelRequire("5eGoU"));

});

parcelRegister("R733B", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9pTu2").then(()=>parcelRequire("5z130"));

});

parcelRegister("6ZQPJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aYuan").then(()=>parcelRequire("eUlAm"));

});

parcelRegister("hx9TJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kZofj").then(()=>parcelRequire("8chCN"));

});

var $6c57cc56acea9c6c$exports = {};

$parcel$export($6c57cc56acea9c6c$exports, "logger", () => $6c57cc56acea9c6c$export$af88d00dbe7f521);
$parcel$export($6c57cc56acea9c6c$exports, "Signer", () => $deb85df20e19ba32$export$fdf54fdde81cc9f0);
$parcel$export($6c57cc56acea9c6c$exports, "Wallet", () => $3ff70163f9f2ebd5$export$bcca3ea514774656);
$parcel$export($6c57cc56acea9c6c$exports, "VoidSigner", () => $deb85df20e19ba32$export$7dbc56d9b9612bad);
$parcel$export($6c57cc56acea9c6c$exports, "getDefaultProvider", () => $859153647bbc688f$export$4f77a1d3c1ac6642);
$parcel$export($6c57cc56acea9c6c$exports, "providers", () => $859153647bbc688f$exports);
$parcel$export($6c57cc56acea9c6c$exports, "BaseContract", () => $b84bae218d85c3ca$export$304faa4fc17528db);
$parcel$export($6c57cc56acea9c6c$exports, "Contract", () => $b84bae218d85c3ca$export$8517d80acf00e19a);
$parcel$export($6c57cc56acea9c6c$exports, "ContractFactory", () => $b84bae218d85c3ca$export$505569a6bf584fd9);
$parcel$export($6c57cc56acea9c6c$exports, "BigNumber", () => $0df4577496dcf693$export$d97aa349ed20696);
$parcel$export($6c57cc56acea9c6c$exports, "FixedNumber", () => $bdc30db990c4b693$export$d4693c66c2213e45);
$parcel$export($6c57cc56acea9c6c$exports, "constants", () => $4c29a01839587aec$exports);
$parcel$export($6c57cc56acea9c6c$exports, "errors", () => $97a8d5981d597bb7$export$d4e71bc0b80dc0fb);
$parcel$export($6c57cc56acea9c6c$exports, "utils", () => $0e788201f8a90b1e$exports);
$parcel$export($6c57cc56acea9c6c$exports, "wordlists", () => $c98b8711de347986$export$e8e1b4711c2d1939);
$parcel$export($6c57cc56acea9c6c$exports, "version", () => $9f7bf65ddafc81a6$export$83d89fbfd8236492);
$parcel$export($6c57cc56acea9c6c$exports, "Wordlist", () => $1aa3df27db978ea8$export$4d9531a8ddb0ebca);
const $4b9cd088fca23de9$export$83d89fbfd8236492 = "logger/5.7.0";


"use strict";
let $97a8d5981d597bb7$var$_permanentCensorErrors = false;
let $97a8d5981d597bb7$var$_censorErrors = false;
const $97a8d5981d597bb7$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $97a8d5981d597bb7$var$_logLevel = $97a8d5981d597bb7$var$LogLevels["default"];
let $97a8d5981d597bb7$var$_globalLogger = null;
function $97a8d5981d597bb7$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $97a8d5981d597bb7$var$_normalizeError = $97a8d5981d597bb7$var$_checkNormalize();
var $97a8d5981d597bb7$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($97a8d5981d597bb7$export$243e62d78d3b544d || ($97a8d5981d597bb7$export$243e62d78d3b544d = {}));
var $97a8d5981d597bb7$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($97a8d5981d597bb7$export$d4e71bc0b80dc0fb || ($97a8d5981d597bb7$export$d4e71bc0b80dc0fb = {}));
const $97a8d5981d597bb7$var$HEX = "0123456789abcdef";
class $97a8d5981d597bb7$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($97a8d5981d597bb7$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($97a8d5981d597bb7$var$_logLevel > $97a8d5981d597bb7$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($97a8d5981d597bb7$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($97a8d5981d597bb7$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $97a8d5981d597bb7$var$HEX[value[i] >> 4];
                        hex += $97a8d5981d597bb7$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $97a8d5981d597bb7$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($97a8d5981d597bb7$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $97a8d5981d597bb7$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $97a8d5981d597bb7$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$97a8d5981d597bb7$var$_globalLogger) $97a8d5981d597bb7$var$_globalLogger = new $97a8d5981d597bb7$export$efa9a398d6368992((0, $4b9cd088fca23de9$export$83d89fbfd8236492));
        return $97a8d5981d597bb7$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($97a8d5981d597bb7$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $97a8d5981d597bb7$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $97a8d5981d597bb7$var$_censorErrors = !!censorship;
        $97a8d5981d597bb7$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $97a8d5981d597bb7$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $97a8d5981d597bb7$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $97a8d5981d597bb7$var$_logLevel = level;
    }
    static from(version) {
        return new $97a8d5981d597bb7$export$efa9a398d6368992(version);
    }
}
$97a8d5981d597bb7$export$efa9a398d6368992.errors = $97a8d5981d597bb7$export$d4e71bc0b80dc0fb;
$97a8d5981d597bb7$export$efa9a398d6368992.levels = $97a8d5981d597bb7$export$243e62d78d3b544d;


const $95fe903f324809f2$export$83d89fbfd8236492 = "bytes/5.7.0";


"use strict";
const $7b88b6e03e4708f2$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $95fe903f324809f2$export$83d89fbfd8236492));
///////////////////////////////
function $7b88b6e03e4708f2$var$isHexable(value) {
    return !!value.toHexString;
}
function $7b88b6e03e4708f2$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $7b88b6e03e4708f2$export$9a14abb1a440cd5e(value) {
    return $7b88b6e03e4708f2$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $7b88b6e03e4708f2$export$c6fabfbfd097fc30(value);
}
function $7b88b6e03e4708f2$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $7b88b6e03e4708f2$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$7b88b6e03e4708f2$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$7b88b6e03e4708f2$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $7b88b6e03e4708f2$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $7b88b6e03e4708f2$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($7b88b6e03e4708f2$var$isHexable(value)) value = value.toHexString();
    if ($7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(result));
    }
    if ($7b88b6e03e4708f2$export$c6fabfbfd097fc30(value)) return $7b88b6e03e4708f2$var$addSlice(new Uint8Array(value));
    return $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $7b88b6e03e4708f2$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$7b88b6e03e4708f2$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $7b88b6e03e4708f2$var$addSlice(result);
}
function $7b88b6e03e4708f2$export$a8f4574d0e56446c(value) {
    let result = $7b88b6e03e4708f2$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d(value, length) {
    value = $7b88b6e03e4708f2$export$3131421a7d01b4fb(value);
    if (value.length > length) $7b88b6e03e4708f2$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $7b88b6e03e4708f2$var$addSlice(result);
}
function $7b88b6e03e4708f2$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $7b88b6e03e4708f2$var$HexCharacters = "0123456789abcdef";
function $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $7b88b6e03e4708f2$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $7b88b6e03e4708f2$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($7b88b6e03e4708f2$var$isHexable(value)) return value.toHexString();
    if ($7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($7b88b6e03e4708f2$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $7b88b6e03e4708f2$var$HexCharacters[(v & 0xf0) >> 4] + $7b88b6e03e4708f2$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $7b88b6e03e4708f2$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(data);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $7b88b6e03e4708f2$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(data);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(data) || data.length % 2) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $7b88b6e03e4708f2$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $7b88b6e03e4708f2$export$6916af760a341dd3(value) {
    const trimmed = $7b88b6e03e4708f2$export$967bc0082a978949($7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $7b88b6e03e4708f2$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value);
    if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $7b88b6e03e4708f2$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(value);
    else if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(value)) $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $7b88b6e03e4708f2$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $7b88b6e03e4708f2$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($7b88b6e03e4708f2$export$9a14abb1a440cd5e(signature)) {
        let bytes = $7b88b6e03e4708f2$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $7b88b6e03e4708f2$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $7b88b6e03e4708f2$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d($7b88b6e03e4708f2$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result.r)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result.s)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result.s, 32);
        const vs = $7b88b6e03e4708f2$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $7b88b6e03e4708f2$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$7b88b6e03e4708f2$export$b02a40aff8e4ad18(result._vs)) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $7b88b6e03e4708f2$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $7b88b6e03e4708f2$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $7b88b6e03e4708f2$export$71bb9d78a59bbe25(signature) {
    signature = $7b88b6e03e4708f2$export$7fb170f1e457988f(signature);
    return $7b88b6e03e4708f2$export$2b0d6b5fbe698c70($7b88b6e03e4708f2$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}



var $dEXSZ = parcelRequire("dEXSZ");


const $a38aef31efdfa85e$export$83d89fbfd8236492 = "bignumber/5.7.0";


"use strict";
var $0df4577496dcf693$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).BN;
const $0df4577496dcf693$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $a38aef31efdfa85e$export$83d89fbfd8236492));
const $0df4577496dcf693$var$_constructorGuard = {};
const $0df4577496dcf693$var$MAX_SAFE = 0x1fffffffffffff;
function $0df4577496dcf693$export$a3d0a7fa9b65683b(value) {
    return value != null && ($0df4577496dcf693$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value) || typeof value === "bigint" || (0, $7b88b6e03e4708f2$export$c6fabfbfd097fc30)(value));
}
// Only warn about passing 10 into radix once
let $0df4577496dcf693$var$_warnedToStringRadix = false;
class $0df4577496dcf693$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $0df4577496dcf693$var$_constructorGuard) $0df4577496dcf693$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $0df4577496dcf693$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).add($0df4577496dcf693$var$toBN(other)));
    }
    sub(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).sub($0df4577496dcf693$var$toBN(other)));
    }
    div(other) {
        const o = $0df4577496dcf693$export$d97aa349ed20696.from(other);
        if (o.isZero()) $0df4577496dcf693$var$throwFault("division-by-zero", "div");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).div($0df4577496dcf693$var$toBN(other)));
    }
    mul(other) {
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).mul($0df4577496dcf693$var$toBN(other)));
    }
    mod(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (value.isNeg()) $0df4577496dcf693$var$throwFault("division-by-zero", "mod");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (value.isNeg()) $0df4577496dcf693$var$throwFault("negative-power", "pow");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("unbound-bitwise-result", "and");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).and(value));
    }
    or(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("unbound-bitwise-result", "or");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $0df4577496dcf693$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $0df4577496dcf693$var$throwFault("unbound-bitwise-result", "xor");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("negative-width", "mask");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("negative-width", "shl");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $0df4577496dcf693$var$throwFault("negative-width", "shr");
        return $0df4577496dcf693$var$toBigNumber($0df4577496dcf693$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $0df4577496dcf693$var$toBN(this).eq($0df4577496dcf693$var$toBN(other));
    }
    lt(other) {
        return $0df4577496dcf693$var$toBN(this).lt($0df4577496dcf693$var$toBN(other));
    }
    lte(other) {
        return $0df4577496dcf693$var$toBN(this).lte($0df4577496dcf693$var$toBN(other));
    }
    gt(other) {
        return $0df4577496dcf693$var$toBN(this).gt($0df4577496dcf693$var$toBN(other));
    }
    gte(other) {
        return $0df4577496dcf693$var$toBN(this).gte($0df4577496dcf693$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $0df4577496dcf693$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $0df4577496dcf693$var$toBN(this).toNumber();
        } catch (error) {
            $0df4577496dcf693$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $0df4577496dcf693$var$logger.throwError("this platform does not support BigInt", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$0df4577496dcf693$var$_warnedToStringRadix) {
                    $0df4577496dcf693$var$_warnedToStringRadix = true;
                    $0df4577496dcf693$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $0df4577496dcf693$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
            else $0df4577496dcf693$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $0df4577496dcf693$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $0df4577496dcf693$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $0df4577496dcf693$export$d97aa349ed20696($0df4577496dcf693$var$_constructorGuard, $0df4577496dcf693$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $0df4577496dcf693$export$d97aa349ed20696($0df4577496dcf693$var$_constructorGuard, $0df4577496dcf693$var$toHex(new $0df4577496dcf693$var$BN(value)));
            return $0df4577496dcf693$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $0df4577496dcf693$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $0df4577496dcf693$var$MAX_SAFE || value <= -$0df4577496dcf693$var$MAX_SAFE) $0df4577496dcf693$var$throwFault("overflow", "BigNumber.from", value);
            return $0df4577496dcf693$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $0df4577496dcf693$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $7b88b6e03e4708f2$export$c6fabfbfd097fc30)(anyValue)) return $0df4577496dcf693$export$d97aa349ed20696.from((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $0df4577496dcf693$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(hex) || hex[0] === "-" && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(hex.substring(1))) return $0df4577496dcf693$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $0df4577496dcf693$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $0df4577496dcf693$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $0df4577496dcf693$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $0df4577496dcf693$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $0df4577496dcf693$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $0df4577496dcf693$var$toBigNumber(value) {
    return $0df4577496dcf693$export$d97aa349ed20696.from($0df4577496dcf693$var$toHex(value));
}
function $0df4577496dcf693$var$toBN(value) {
    const hex = $0df4577496dcf693$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $0df4577496dcf693$var$BN("-" + hex.substring(3), 16);
    return new $0df4577496dcf693$var$BN(hex.substring(2), 16);
}
function $0df4577496dcf693$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $0df4577496dcf693$var$logger.throwError(fault, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
function $0df4577496dcf693$export$51e4a08295f7770f(value) {
    return new $0df4577496dcf693$var$BN(value, 36).toString(16);
}
function $0df4577496dcf693$export$1293db5d29c264ff(value) {
    return new $0df4577496dcf693$var$BN(value, 16).toString(36);
}



const $ec235c03b0398629$export$83d89fbfd8236492 = "properties/5.7.0";


"use strict";
var $a463a6b5f08d6875$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $a463a6b5f08d6875$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $ec235c03b0398629$export$83d89fbfd8236492));
function $a463a6b5f08d6875$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $a463a6b5f08d6875$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $a463a6b5f08d6875$export$d503dd157d963b60(object) {
    return $a463a6b5f08d6875$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $a463a6b5f08d6875$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $a463a6b5f08d6875$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $a463a6b5f08d6875$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $a463a6b5f08d6875$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $a463a6b5f08d6875$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $a463a6b5f08d6875$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $a463a6b5f08d6875$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$a463a6b5f08d6875$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $a463a6b5f08d6875$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $a463a6b5f08d6875$var$_deepCopy(object) {
    if ($a463a6b5f08d6875$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$a463a6b5f08d6875$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $a463a6b5f08d6875$export$104236534534f9be(result, key, $a463a6b5f08d6875$export$6c40052bed430212(value));
        }
        return result;
    }
    return $a463a6b5f08d6875$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $a463a6b5f08d6875$export$6c40052bed430212(object) {
    return $a463a6b5f08d6875$var$_deepCopy(object);
}
class $a463a6b5f08d6875$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $a463a6b5f08d6875$export$6c40052bed430212(info[key]);
    }
}



const $7b99b6039539a6c4$export$83d89fbfd8236492 = "abi/5.7.0";


"use strict";
const $2c0f0ed4c5bed241$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
function $2c0f0ed4c5bed241$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $2c0f0ed4c5bed241$export$2c0c39526f8bad46 {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        $2c0f0ed4c5bed241$var$logger.throwArgumentError(message, this.localName, value);
    }
}
class $2c0f0ed4c5bed241$export$d7a960146e1a269e {
    constructor(wordSize){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $0df4577496dcf693$export$d97aa349ed20696).from(value));
        if (bytes.length > this.wordSize) $2c0f0ed4c5bed241$var$logger.throwError("value out-of-bounds", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class $2c0f0ed4c5bed241$export$2f7a2f0e90c07dc4 {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_data", (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "wordSize", wordSize || 32);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_coerceFunc", coerceFunc);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $2c0f0ed4c5bed241$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $2c0f0ed4c5bed241$var$logger.throwError("data out-of-bounds", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $2c0f0ed4c5bed241$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $0df4577496dcf693$export$d97aa349ed20696).from(this.readBytes(this.wordSize));
    }
}




var $1IGmO = parcelRequire("1IGmO");

"use strict";
function $1dbc6131e27af3ca$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($1IGmO))).keccak_256((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data));
}


var $6ff2d0f6bfa15181$exports = {};

$parcel$export($6ff2d0f6bfa15181$exports, "encode", () => $6ff2d0f6bfa15181$export$c564cdbbe6da493);
$parcel$export($6ff2d0f6bfa15181$exports, "decode", () => $6ff2d0f6bfa15181$export$2f872c0f2117be69);


const $82765913239667f9$export$83d89fbfd8236492 = "rlp/5.7.0";


"use strict";
const $6ff2d0f6bfa15181$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $82765913239667f9$export$83d89fbfd8236492));
function $6ff2d0f6bfa15181$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $6ff2d0f6bfa15181$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($6ff2d0f6bfa15181$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $6ff2d0f6bfa15181$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $7b88b6e03e4708f2$export$9a14abb1a440cd5e)(object)) $6ff2d0f6bfa15181$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $6ff2d0f6bfa15181$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $6ff2d0f6bfa15181$export$c564cdbbe6da493(object) {
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)($6ff2d0f6bfa15181$var$_encode(object));
}
function $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $6ff2d0f6bfa15181$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $6ff2d0f6bfa15181$var$logger.throwError("child data too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $6ff2d0f6bfa15181$var$_decode(data, offset) {
    if (data.length === 0) $6ff2d0f6bfa15181$var$logger.throwError("data too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data short segment too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data long segment too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $6ff2d0f6bfa15181$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $6ff2d0f6bfa15181$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data array too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $6ff2d0f6bfa15181$var$logger.throwError("data too short", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data[offset])
    };
}
function $6ff2d0f6bfa15181$export$2f872c0f2117be69(data) {
    const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
    const decoded = $6ff2d0f6bfa15181$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $6ff2d0f6bfa15181$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}



const $f0caac95ce71359f$export$83d89fbfd8236492 = "address/5.7.0";


"use strict";
const $8aee8aee2d40605d$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $f0caac95ce71359f$export$83d89fbfd8236492));
function $8aee8aee2d40605d$var$getChecksumAddress(address) {
    if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(address, 20)) $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $8aee8aee2d40605d$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $8aee8aee2d40605d$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $8aee8aee2d40605d$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$8aee8aee2d40605d$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$8aee8aee2d40605d$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $8aee8aee2d40605d$var$safeDigits = Math.floor($8aee8aee2d40605d$var$log10($8aee8aee2d40605d$var$MAX_SAFE_INTEGER));
function $8aee8aee2d40605d$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $8aee8aee2d40605d$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $8aee8aee2d40605d$var$safeDigits){
        let block = expanded.substring(0, $8aee8aee2d40605d$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $8aee8aee2d40605d$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $8aee8aee2d40605d$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $8aee8aee2d40605d$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $8aee8aee2d40605d$var$ibanChecksum(address)) $8aee8aee2d40605d$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $0df4577496dcf693$export$51e4a08295f7770f)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $8aee8aee2d40605d$var$getChecksumAddress("0x" + result);
    } else $8aee8aee2d40605d$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $8aee8aee2d40605d$export$977e255126d763d6(address) {
    try {
        $8aee8aee2d40605d$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $8aee8aee2d40605d$export$962c4ddada9f668f(address) {
    let base36 = (0, $0df4577496dcf693$export$1293db5d29c264ff)($8aee8aee2d40605d$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $8aee8aee2d40605d$var$ibanChecksum("XE00" + base36) + base36;
}
function $8aee8aee2d40605d$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $8aee8aee2d40605d$export$88411125f012957a(transaction.from);
    } catch (error) {
        $8aee8aee2d40605d$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction.nonce).toHexString()));
    return $8aee8aee2d40605d$export$88411125f012957a((0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $6ff2d0f6bfa15181$export$c564cdbbe6da493)([
        from,
        nonce
    ])), 12));
}
function $8aee8aee2d40605d$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(salt) !== 32) $8aee8aee2d40605d$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(initCodeHash) !== 32) $8aee8aee2d40605d$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $8aee8aee2d40605d$export$88411125f012957a((0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        "0xff",
        $8aee8aee2d40605d$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}







const $f9bb23bb4b058849$export$83d89fbfd8236492 = "strings/5.7.0";


"use strict";
const $b2a54ce293d87a2e$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $f9bb23bb4b058849$export$83d89fbfd8236492));
var $b2a54ce293d87a2e$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($b2a54ce293d87a2e$export$c6986442964129f5 || ($b2a54ce293d87a2e$export$c6986442964129f5 = {}));
var $b2a54ce293d87a2e$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($b2a54ce293d87a2e$export$c285fa6ac15ff6a6 || ($b2a54ce293d87a2e$export$c285fa6ac15ff6a6 = {}));
function $b2a54ce293d87a2e$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $b2a54ce293d87a2e$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $b2a54ce293d87a2e$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $b2a54ce293d87a2e$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $b2a54ce293d87a2e$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $b2a54ce293d87a2e$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $b2a54ce293d87a2e$var$errorFunc,
    ignore: $b2a54ce293d87a2e$var$ignoreFunc,
    replace: $b2a54ce293d87a2e$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $b2a54ce293d87a2e$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $b2a54ce293d87a2e$export$c6e2180c5bb5bc05.error;
    bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($b2a54ce293d87a2e$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $b2a54ce293d87a2e$export$8feeb310b4b4752f(str, form = $b2a54ce293d87a2e$export$c6986442964129f5.current) {
    if (form != $b2a54ce293d87a2e$export$c6986442964129f5.current) {
        $b2a54ce293d87a2e$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(result);
}
function $b2a54ce293d87a2e$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $b2a54ce293d87a2e$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $b2a54ce293d87a2e$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $b2a54ce293d87a2e$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $b2a54ce293d87a2e$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $b2a54ce293d87a2e$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $b2a54ce293d87a2e$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $b2a54ce293d87a2e$export$7643a1dc2c38d5eb(bytes, onError) {
    return $b2a54ce293d87a2e$export$232e1dab03132235($b2a54ce293d87a2e$var$getUtf8CodePoints(bytes, onError));
}
function $b2a54ce293d87a2e$export$ae470a36a31b28c2(str, form = $b2a54ce293d87a2e$export$c6986442964129f5.current) {
    return $b2a54ce293d87a2e$var$getUtf8CodePoints($b2a54ce293d87a2e$export$8feeb310b4b4752f(str, form));
}


function $7cd0a9996bd6b341$export$d560c7e4a29451c2(text) {
    return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(text));
}












"use strict";
class $22f6893c208a0a4e$export$59dbbded7775bfe7 extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, $8aee8aee2d40605d$export$88411125f012957a)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $8aee8aee2d40605d$export$88411125f012957a)((0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(reader.readValue().toHexString(), 20));
    }
}






"use strict";
class $3a25498c1332da4a$export$87c41d1139a03fa2 extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}


"use strict";
const $a30effb870f18115$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
function $a30effb870f18115$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $a30effb870f18115$var$logger.throwError("cannot encode object for signature with missing names", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $a30effb870f18115$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $a30effb870f18115$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $a30effb870f18115$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $2c0f0ed4c5bed241$export$d7a960146e1a269e)(writer.wordSize);
    let dynamicWriter = new (0, $2c0f0ed4c5bed241$export$d7a960146e1a269e)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $a30effb870f18115$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $a30effb870f18115$export$88bc419d2df11f54 extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $a30effb870f18115$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $a30effb870f18115$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) $a30effb870f18115$var$logger.throwError("insufficient data length", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $3a25498c1332da4a$export$87c41d1139a03fa2)(this.coder));
        return reader.coerce(this.name, $a30effb870f18115$export$417857010dc9287f(reader, coders));
    }
}



"use strict";
class $394fcd7db865fb3c$export$fe9118d6c093150c extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}




"use strict";
class $6e254db4e73082b7$export$db9eadd8df12ad2e extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class $6e254db4e73082b7$export$e5823e9574df18d2 extends $6e254db4e73082b7$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(super.decode(reader)));
    }
}




"use strict";
class $9c7ee045e883fffe$export$7dec9db68e6bcf5a extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(reader.readBytes(this.size)));
    }
}



"use strict";
class $8815781d2f2dcc92$export$70982cadf2d6b4ec extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}




const $c5333cf79421e056$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(-1);
const $c5333cf79421e056$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(0);
const $c5333cf79421e056$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(1);
const $c5333cf79421e056$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from(2);
const $c5333cf79421e056$export$c8db55bd7405209e = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("1000000000000000000");
const $c5333cf79421e056$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $c5333cf79421e056$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $c5333cf79421e056$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $0df4577496dcf693$export$d97aa349ed20696).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");



"use strict";
class $f9cce4408e3f228e$export$b934dc8cfe13938c extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $c5333cf79421e056$export$1b53890de5aabdd0).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $c5333cf79421e056$export$9aa05a5866350bcf)).mul((0, $c5333cf79421e056$export$c83ef0909a6ddeec)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $c5333cf79421e056$export$aaef8a3eae948f03)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}




"use strict";
class $90994e88a8e0b05b$export$2d1b854518731426 extends (0, $6e254db4e73082b7$export$db9eadd8df12ad2e) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(value));
    }
    decode(reader) {
        return (0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)(super.decode(reader));
    }
}




"use strict";
class $c633d82d9fdfc710$export$e9fceba8f110fea6 extends (0, $2c0f0ed4c5bed241$export$2c0c39526f8bad46) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, $a30effb870f18115$export$2a703dbb0cb35339)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $a30effb870f18115$export$417857010dc9287f)(reader, this.coders));
    }
}






"use strict";
const $871a765ee5e657d2$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
const $871a765ee5e657d2$var$_constructorGuard = {};
let $871a765ee5e657d2$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $871a765ee5e657d2$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $871a765ee5e657d2$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($871a765ee5e657d2$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($871a765ee5e657d2$var$ModifiersNest[name]) return true;
    }
    if ($871a765ee5e657d2$var$ModifiersBytes[name] || name === "payable") $871a765ee5e657d2$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $871a765ee5e657d2$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $871a765ee5e657d2$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $871a765ee5e657d2$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($871a765ee5e657d2$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $871a765ee5e657d2$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($871a765ee5e657d2$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $871a765ee5e657d2$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $871a765ee5e657d2$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($871a765ee5e657d2$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $871a765ee5e657d2$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($871a765ee5e657d2$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $871a765ee5e657d2$var$verifyType(parent.type);
    return parent;
}
function $871a765ee5e657d2$var$populate(object, params) {
    for(let key in params)(0, $a463a6b5f08d6875$export$104236534534f9be)(object, key, params[key]);
}
const $871a765ee5e657d2$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $871a765ee5e657d2$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $871a765ee5e657d2$export$426dc07f493a4c47 {
    constructor(constructorGuard, params){
        if (constructorGuard !== $871a765ee5e657d2$var$_constructorGuard) $871a765ee5e657d2$var$logger.throwError("use fromString", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $871a765ee5e657d2$var$populate(this, params);
        let match = this.type.match($871a765ee5e657d2$var$paramTypeArray);
        if (match) $871a765ee5e657d2$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $871a765ee5e657d2$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $871a765ee5e657d2$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $871a765ee5e657d2$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $871a765ee5e657d2$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $871a765ee5e657d2$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $871a765ee5e657d2$export$426dc07f493a4c47($871a765ee5e657d2$var$_constructorGuard, {
            name: value.name || null,
            type: $871a765ee5e657d2$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $871a765ee5e657d2$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($871a765ee5e657d2$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function $871a765ee5e657d2$var$parseParams(value, allowIndex) {
    return $871a765ee5e657d2$var$splitNesting(value).map((param)=>$871a765ee5e657d2$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $871a765ee5e657d2$export$ffb0004e005737fa {
    constructor(constructorGuard, params){
        if (constructorGuard !== $871a765ee5e657d2$var$_constructorGuard) $871a765ee5e657d2$var$logger.throwError("use a static from method", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $871a765ee5e657d2$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if ($871a765ee5e657d2$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $871a765ee5e657d2$export$ffb0004e005737fa.fromString(value);
        return $871a765ee5e657d2$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $871a765ee5e657d2$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $871a765ee5e657d2$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromObject(value);
            case "error":
                return $871a765ee5e657d2$export$2c42c6d543aa9b59.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $871a765ee5e657d2$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $871a765ee5e657d2$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $871a765ee5e657d2$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return $871a765ee5e657d2$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
        return $871a765ee5e657d2$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class $871a765ee5e657d2$export$958548f08bac2833 extends $871a765ee5e657d2$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $871a765ee5e657d2$export$958548f08bac2833.fromString(value);
        return $871a765ee5e657d2$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $871a765ee5e657d2$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $871a765ee5e657d2$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $871a765ee5e657d2$export$958548f08bac2833($871a765ee5e657d2$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($871a765ee5e657d2$var$regexParen);
        if (!match) $871a765ee5e657d2$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $871a765ee5e657d2$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $871a765ee5e657d2$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $871a765ee5e657d2$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $871a765ee5e657d2$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $871a765ee5e657d2$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $871a765ee5e657d2$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $0df4577496dcf693$export$d97aa349ed20696).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $871a765ee5e657d2$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $871a765ee5e657d2$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $871a765ee5e657d2$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $871a765ee5e657d2$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $871a765ee5e657d2$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $871a765ee5e657d2$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $871a765ee5e657d2$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $871a765ee5e657d2$export$3ac5c9504f801ea4 extends $871a765ee5e657d2$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.sighash) $871a765ee5e657d2$var$logger.throwError("cannot format a constructor for sighash", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromString(value);
        return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $871a765ee5e657d2$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $871a765ee5e657d2$var$verifyState(value);
        if (state.constant) $871a765ee5e657d2$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $0df4577496dcf693$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $871a765ee5e657d2$export$3ac5c9504f801ea4($871a765ee5e657d2$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $871a765ee5e657d2$var$parseGas(value, params);
        let parens = value.match($871a765ee5e657d2$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $871a765ee5e657d2$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $871a765ee5e657d2$var$parseParams(parens[2].trim(), false);
        $871a765ee5e657d2$var$parseModifiers(parens[3].trim(), params);
        return $871a765ee5e657d2$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $871a765ee5e657d2$export$8d576c928b93668f extends $871a765ee5e657d2$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $871a765ee5e657d2$export$8d576c928b93668f.fromString(value);
        return $871a765ee5e657d2$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $871a765ee5e657d2$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $871a765ee5e657d2$var$verifyState(value);
        const params = {
            type: value.type,
            name: $871a765ee5e657d2$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $0df4577496dcf693$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $871a765ee5e657d2$export$8d576c928b93668f($871a765ee5e657d2$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $871a765ee5e657d2$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $871a765ee5e657d2$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($871a765ee5e657d2$var$regexParen);
        if (!parens) $871a765ee5e657d2$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $871a765ee5e657d2$var$verifyIdentifier(params.name);
        params.inputs = $871a765ee5e657d2$var$parseParams(parens[2], false);
        $871a765ee5e657d2$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($871a765ee5e657d2$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $871a765ee5e657d2$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $871a765ee5e657d2$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $871a765ee5e657d2$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function $871a765ee5e657d2$var$checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $871a765ee5e657d2$var$logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class $871a765ee5e657d2$export$2c42c6d543aa9b59 extends $871a765ee5e657d2$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $871a765ee5e657d2$export$f010f239efc4d445.sighash;
        if (!$871a765ee5e657d2$export$f010f239efc4d445[format]) $871a765ee5e657d2$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $871a765ee5e657d2$export$f010f239efc4d445.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $871a765ee5e657d2$export$f010f239efc4d445.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $871a765ee5e657d2$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $871a765ee5e657d2$export$2c42c6d543aa9b59.fromString(value);
        return $871a765ee5e657d2$export$2c42c6d543aa9b59.fromObject(value);
    }
    static fromObject(value) {
        if ($871a765ee5e657d2$export$2c42c6d543aa9b59.isErrorFragment(value)) return value;
        if (value.type !== "error") $871a765ee5e657d2$var$logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: $871a765ee5e657d2$var$verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map($871a765ee5e657d2$export$426dc07f493a4c47.fromObject) : []
        };
        return $871a765ee5e657d2$var$checkForbidden(new $871a765ee5e657d2$export$2c42c6d543aa9b59($871a765ee5e657d2$var$_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match($871a765ee5e657d2$var$regexParen);
        if (!parens) $871a765ee5e657d2$var$logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $871a765ee5e657d2$var$verifyIdentifier(params.name);
        params.inputs = $871a765ee5e657d2$var$parseParams(parens[2], false);
        return $871a765ee5e657d2$var$checkForbidden($871a765ee5e657d2$export$2c42c6d543aa9b59.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function $871a765ee5e657d2$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const $871a765ee5e657d2$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $871a765ee5e657d2$var$verifyIdentifier(value) {
    if (!value || !value.match($871a765ee5e657d2$var$regexIdentifier)) $871a765ee5e657d2$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $871a765ee5e657d2$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $871a765ee5e657d2$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $871a765ee5e657d2$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}


"use strict";
const $2f97e4c6f3904f5b$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
const $2f97e4c6f3904f5b$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $2f97e4c6f3904f5b$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $2f97e4c6f3904f5b$export$fe041e1a83d3efc6 {
    constructor(coerceFunc){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $22f6893c208a0a4e$export$59dbbded7775bfe7)(param.name);
            case "bool":
                return new (0, $394fcd7db865fb3c$export$fe9118d6c093150c)(param.name);
            case "string":
                return new (0, $90994e88a8e0b05b$export$2d1b854518731426)(param.name);
            case "bytes":
                return new (0, $6e254db4e73082b7$export$e5823e9574df18d2)(param.name);
            case "array":
                return new (0, $a30effb870f18115$export$88bc419d2df11f54)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $c633d82d9fdfc710$export$e9fceba8f110fea6)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $8815781d2f2dcc92$export$70982cadf2d6b4ec)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($2f97e4c6f3904f5b$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $2f97e4c6f3904f5b$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $f9cce4408e3f228e$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($2f97e4c6f3904f5b$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $2f97e4c6f3904f5b$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $9c7ee045e883fffe$export$7dec9db68e6bcf5a)(size, param.name);
        }
        return $2f97e4c6f3904f5b$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $2c0f0ed4c5bed241$export$2f7a2f0e90c07dc4)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $2c0f0ed4c5bed241$export$d7a960146e1a269e)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, $871a765ee5e657d2$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $c633d82d9fdfc710$export$e9fceba8f110fea6)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) $2f97e4c6f3904f5b$var$logger.throwError("types/values length mismatch", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $871a765ee5e657d2$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $c633d82d9fdfc710$export$e9fceba8f110fea6)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $871a765ee5e657d2$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $c633d82d9fdfc710$export$e9fceba8f110fea6)(coders, "_");
        return coder.decode(this._getReader((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data), loose));
    }
}
const $2f97e4c6f3904f5b$export$51d1cfcdb913adff = new $2f97e4c6f3904f5b$export$fe041e1a83d3efc6();






"use strict";
const $ef97d5c3a9a93354$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b99b6039539a6c4$export$83d89fbfd8236492));
class $ef97d5c3a9a93354$export$c2ab6499be98b3c5 extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
}
class $ef97d5c3a9a93354$export$7a3223b0fadb690b extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
}
class $ef97d5c3a9a93354$export$cfba08fc0e40e2ab extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
}
class $ef97d5c3a9a93354$export$8ef99100a3c56f8c extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const $ef97d5c3a9a93354$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $ef97d5c3a9a93354$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $ef97d5c3a9a93354$export$48cefb51a4e315b2 {
    constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "fragments", abi.map((fragment)=>{
            return (0, $871a765ee5e657d2$export$ffb0004e005737fa).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_abiCoder", (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getAbiCoder")());
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "functions", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "errors", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "events", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $ef97d5c3a9a93354$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $ef97d5c3a9a93354$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "deploy", (0, $871a765ee5e657d2$export$3ac5c9504f801ea4).from({
            payable: false,
            type: "constructor"
        }));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, $871a765ee5e657d2$export$f010f239efc4d445).full;
        if (format === (0, $871a765ee5e657d2$export$f010f239efc4d445).sighash) $ef97d5c3a9a93354$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $871a765ee5e657d2$export$f010f239efc4d445).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $2f97e4c6f3904f5b$export$51d1cfcdb913adff;
    }
    static getAddress(address) {
        return (0, $8aee8aee2d40605d$export$88411125f012957a)(address);
    }
    static getSighash(fragment) {
        return (0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $ef97d5c3a9a93354$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, $871a765ee5e657d2$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $ef97d5c3a9a93354$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, $871a765ee5e657d2$export$958548f08bac2833).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
            const getSighash = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) $ef97d5c3a9a93354$var$logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, $871a765ee5e657d2$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $ef97d5c3a9a93354$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
        if ((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $ef97d5c3a9a93354$var$logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
        if ((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $ef97d5c3a9a93354$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(0, 4));
                    const builtin = $ef97d5c3a9a93354$var$BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                        if (errorName === "Error") message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                        else if (errorName === "Panic") message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {}
                    break;
                }
        }
        return $ef97d5c3a9a93354$var$logger.throwError("call revert exception" + message, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data),
            errorArgs: errorArgs,
            errorName: errorName,
            errorSignature: errorSignature,
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $ef97d5c3a9a93354$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(value);
            else if (param.type === "bytes") return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            if (param.type.match(/^u?int/)) value = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toHexString();
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $ef97d5c3a9a93354$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $ef97d5c3a9a93354$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $ef97d5c3a9a93354$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(value));
                else if (param.type === "bytes") topics.push((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $ef97d5c3a9a93354$var$logger.throwError("fragment/topic mismatch", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $871a765ee5e657d2$export$426dc07f493a4c47).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $ef97d5c3a9a93354$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $ef97d5c3a9a93354$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw $ef97d5c3a9a93354$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw $ef97d5c3a9a93354$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $ef97d5c3a9a93354$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $0df4577496dcf693$export$d97aa349ed20696).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $ef97d5c3a9a93354$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $ef97d5c3a9a93354$export$cfba08fc0e40e2ab({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}






const $794843703201998f$export$83d89fbfd8236492 = "abstract-provider/5.7.0";


"use strict";
var $81658ac0a17fba50$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $81658ac0a17fba50$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $794843703201998f$export$83d89fbfd8236492));
class $81658ac0a17fba50$export$406ece1549ccd00e extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class $81658ac0a17fba50$export$5b2cada8494f9d99 extends $81658ac0a17fba50$export$406ece1549ccd00e {
    constructor(blockHash, expiry){
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(blockHash, 32)) $81658ac0a17fba50$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
}
class $81658ac0a17fba50$export$26bcd61a55716c98 extends $81658ac0a17fba50$export$406ece1549ccd00e {
    constructor(hash, expiry){
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(hash, 32)) $81658ac0a17fba50$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
}
class $81658ac0a17fba50$export$8f8609bfee47c93 extends $81658ac0a17fba50$export$406ece1549ccd00e {
    constructor(beforeHash, afterHash, expiry){
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(beforeHash, 32)) $81658ac0a17fba50$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(afterHash, 32)) $81658ac0a17fba50$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
class $81658ac0a17fba50$export$2881499e37b75b9a {
    constructor(){
        $81658ac0a17fba50$var$logger.checkAbstract(new.target, $81658ac0a17fba50$export$2881499e37b75b9a);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_isProvider", true);
    }
    getFeeData() {
        return $81658ac0a17fba50$var$__awaiter(this, void 0, void 0, function*() {
            const { block: block, gasPrice: gasPrice } = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error)=>{
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let lastBaseFeePerGas = null, maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                lastBaseFeePerGas = block.baseFeePerGas;
                maxPriorityFeePerGas = (0, $0df4577496dcf693$export$d97aa349ed20696).from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return {
                lastBaseFeePerGas: lastBaseFeePerGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                gasPrice: gasPrice
            };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
}




const $1f1ca693564f9708$export$83d89fbfd8236492 = "abstract-signer/5.7.0";


"use strict";
var $deb85df20e19ba32$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $deb85df20e19ba32$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $1f1ca693564f9708$export$83d89fbfd8236492));
const $deb85df20e19ba32$var$allowedTransactionKeys = [
    "accessList",
    "ccipReadEnabled",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
const $deb85df20e19ba32$var$forwardErrors = [
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS,
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NONCE_EXPIRED,
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED
];
class $deb85df20e19ba32$export$fdf54fdde81cc9f0 {
    ///////////////////
    // Sub-classes MUST call super
    constructor(){
        $deb85df20e19ba32$var$logger.checkAbstract(new.target, $deb85df20e19ba32$export$fdf54fdde81cc9f0);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_isSigner", true);
    }
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("estimateGas");
            const tx = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("call");
            const tx = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for(const key in transaction)if ($deb85df20e19ba32$var$allowedTransactionKeys.indexOf(key) === -1) $deb85df20e19ba32$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
        const tx = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(transaction);
        if (tx.from == null) tx.from = this.getAddress();
        else // Make sure any provided address matches this signer
        tx.from = Promise.all([
            Promise.resolve(tx.from),
            this.getAddress()
        ]).then((result)=>{
            if (result[0].toLowerCase() !== result[1].toLowerCase()) $deb85df20e19ba32$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            return result[0];
        });
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return $deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
            const tx = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to)=>$deb85df20e19ba32$var$__awaiter(this, void 0, void 0, function*() {
                        if (to == null) return null;
                        const address = yield this.resolveName(to);
                        if (address == null) $deb85df20e19ba32$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                        return address;
                    }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error)=>{});
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $deb85df20e19ba32$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $deb85df20e19ba32$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            if ((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
            tx.type = 2;
            else if (tx.type === 0 || tx.type === 1) // Explicit Legacy or EIP-2930 transaction
            // Populate missing gasPrice
            {
                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
            } else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        } else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                        }
                    } else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) $deb85df20e19ba32$var$logger.throwError("network does not support EIP-1559", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                            operation: "populateTransaction"
                        });
                        // Populate missing fee data
                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    } else // getFeeData has failed us.
                    $deb85df20e19ba32$var$logger.throwError("failed to get consistent fee data", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: "signer.getFeeData"
                    });
                } else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                }
            }
            if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
            if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch((error)=>{
                if ($deb85df20e19ba32$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                return $deb85df20e19ba32$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
                    error: error,
                    tx: tx
                });
            });
            if (tx.chainId == null) tx.chainId = this.getChainId();
            else tx.chainId = Promise.all([
                Promise.resolve(tx.chainId),
                this.getChainId()
            ]).then((results)=>{
                if (results[1] !== 0 && results[0] !== results[1]) $deb85df20e19ba32$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                return results[0];
            });
            return yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) $deb85df20e19ba32$var$logger.throwError("missing provider", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: operation || "_checkProvider"
        });
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
}
class $deb85df20e19ba32$export$7dbc56d9b9612bad extends $deb85df20e19ba32$export$fdf54fdde81cc9f0 {
    constructor(address, provider){
        super();
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", address);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", provider || null);
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(()=>{
            $deb85df20e19ba32$var$logger.throwError(message, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: operation
            });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new $deb85df20e19ba32$export$7dbc56d9b9612bad(this.address, provider);
    }
}














var $dEXSZ = parcelRequire("dEXSZ");

var $kiSKt = parcelRequire("kiSKt");
var $63aabbf7dfa8a956$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $63aabbf7dfa8a956$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $63aabbf7dfa8a956$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $63aabbf7dfa8a956$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $63aabbf7dfa8a956$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $63aabbf7dfa8a956$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $63aabbf7dfa8a956$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $63aabbf7dfa8a956$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $63aabbf7dfa8a956$var$minimalisticAssert = $63aabbf7dfa8a956$var$assert;
function $63aabbf7dfa8a956$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$63aabbf7dfa8a956$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $63aabbf7dfa8a956$var$utils_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $63aabbf7dfa8a956$var$utils_1$1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $63aabbf7dfa8a956$var$minimalisticAssert;
    utils.toArray = $63aabbf7dfa8a956$var$utils_1.toArray;
    utils.zero2 = $63aabbf7dfa8a956$var$utils_1.zero2;
    utils.toHex = $63aabbf7dfa8a956$var$utils_1.toHex;
    utils.encode = $63aabbf7dfa8a956$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $63aabbf7dfa8a956$var$getNAF = $63aabbf7dfa8a956$var$utils_1$1.getNAF;
var $63aabbf7dfa8a956$var$getJSF = $63aabbf7dfa8a956$var$utils_1$1.getJSF;
var $63aabbf7dfa8a956$var$assert$1 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $63aabbf7dfa8a956$var$base = $63aabbf7dfa8a956$var$BaseCurve;
$63aabbf7dfa8a956$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$63aabbf7dfa8a956$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$63aabbf7dfa8a956$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $63aabbf7dfa8a956$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $63aabbf7dfa8a956$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$63aabbf7dfa8a956$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $63aabbf7dfa8a956$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $63aabbf7dfa8a956$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$63aabbf7dfa8a956$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $63aabbf7dfa8a956$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $63aabbf7dfa8a956$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $63aabbf7dfa8a956$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $63aabbf7dfa8a956$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$63aabbf7dfa8a956$var$BaseCurve.BasePoint = $63aabbf7dfa8a956$var$BasePoint;
$63aabbf7dfa8a956$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$63aabbf7dfa8a956$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$63aabbf7dfa8a956$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $63aabbf7dfa8a956$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $63aabbf7dfa8a956$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $63aabbf7dfa8a956$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$63aabbf7dfa8a956$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$63aabbf7dfa8a956$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$63aabbf7dfa8a956$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $63aabbf7dfa8a956$var$utils_1$1.encode(this._encode(compact), enc);
};
$63aabbf7dfa8a956$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$63aabbf7dfa8a956$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$63aabbf7dfa8a956$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$63aabbf7dfa8a956$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$63aabbf7dfa8a956$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$63aabbf7dfa8a956$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $63aabbf7dfa8a956$var$inherits_browser = $63aabbf7dfa8a956$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $63aabbf7dfa8a956$var$assert$2 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$ShortCurve(conf) {
    $63aabbf7dfa8a956$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$63aabbf7dfa8a956$var$inherits_browser($63aabbf7dfa8a956$var$ShortCurve, $63aabbf7dfa8a956$var$base);
var $63aabbf7dfa8a956$var$short_1 = $63aabbf7dfa8a956$var$ShortCurve;
$63aabbf7dfa8a956$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $63aabbf7dfa8a956$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$63aabbf7dfa8a956$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$63aabbf7dfa8a956$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$63aabbf7dfa8a956$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $63aabbf7dfa8a956$var$Point(curve, x, y, isRed) {
    $63aabbf7dfa8a956$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$63aabbf7dfa8a956$var$inherits_browser($63aabbf7dfa8a956$var$Point, $63aabbf7dfa8a956$var$base.BasePoint);
$63aabbf7dfa8a956$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $63aabbf7dfa8a956$var$Point(this, x, y, isRed);
};
$63aabbf7dfa8a956$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $63aabbf7dfa8a956$var$Point.fromJSON(this, obj, red);
};
$63aabbf7dfa8a956$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$63aabbf7dfa8a956$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$63aabbf7dfa8a956$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$63aabbf7dfa8a956$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$63aabbf7dfa8a956$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$63aabbf7dfa8a956$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$63aabbf7dfa8a956$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$63aabbf7dfa8a956$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$63aabbf7dfa8a956$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$63aabbf7dfa8a956$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$63aabbf7dfa8a956$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$63aabbf7dfa8a956$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$63aabbf7dfa8a956$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$63aabbf7dfa8a956$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$63aabbf7dfa8a956$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $63aabbf7dfa8a956$var$JPoint(curve, x, y, z) {
    $63aabbf7dfa8a956$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$63aabbf7dfa8a956$var$inherits_browser($63aabbf7dfa8a956$var$JPoint, $63aabbf7dfa8a956$var$base.BasePoint);
$63aabbf7dfa8a956$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $63aabbf7dfa8a956$var$JPoint(this, x, y, z);
};
$63aabbf7dfa8a956$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$63aabbf7dfa8a956$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$63aabbf7dfa8a956$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$63aabbf7dfa8a956$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$63aabbf7dfa8a956$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$63aabbf7dfa8a956$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$63aabbf7dfa8a956$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$63aabbf7dfa8a956$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$63aabbf7dfa8a956$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $63aabbf7dfa8a956$var$curve_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $63aabbf7dfa8a956$var$base;
    curve.short = $63aabbf7dfa8a956$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $63aabbf7dfa8a956$var$curves_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $63aabbf7dfa8a956$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $63aabbf7dfa8a956$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $63aabbf7dfa8a956$var$curve_1.edwards(options);
        else this.curve = new $63aabbf7dfa8a956$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $63aabbf7dfa8a956$var$HmacDRBG(options) {
    if (!(this instanceof $63aabbf7dfa8a956$var$HmacDRBG)) return new $63aabbf7dfa8a956$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $63aabbf7dfa8a956$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $63aabbf7dfa8a956$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $63aabbf7dfa8a956$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $63aabbf7dfa8a956$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $63aabbf7dfa8a956$var$hmacDrbg = $63aabbf7dfa8a956$var$HmacDRBG;
$63aabbf7dfa8a956$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).hmac(this.hash, this.K);
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $63aabbf7dfa8a956$var$utils_1.toArray(entropy, entropyEnc);
    add = $63aabbf7dfa8a956$var$utils_1.toArray(add, addEnc);
    $63aabbf7dfa8a956$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$63aabbf7dfa8a956$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $63aabbf7dfa8a956$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $63aabbf7dfa8a956$var$utils_1.encode(res, enc);
};
"use strict";
var $63aabbf7dfa8a956$var$assert$3 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $63aabbf7dfa8a956$var$key = $63aabbf7dfa8a956$var$KeyPair;
$63aabbf7dfa8a956$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $63aabbf7dfa8a956$var$KeyPair) return pub;
    return new $63aabbf7dfa8a956$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$63aabbf7dfa8a956$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $63aabbf7dfa8a956$var$KeyPair) return priv;
    return new $63aabbf7dfa8a956$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$63aabbf7dfa8a956$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$63aabbf7dfa8a956$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$63aabbf7dfa8a956$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$63aabbf7dfa8a956$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$63aabbf7dfa8a956$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $63aabbf7dfa8a956$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $63aabbf7dfa8a956$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$63aabbf7dfa8a956$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $63aabbf7dfa8a956$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$63aabbf7dfa8a956$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$63aabbf7dfa8a956$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$63aabbf7dfa8a956$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $63aabbf7dfa8a956$var$assert$4 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$Signature(options, enc) {
    if (options instanceof $63aabbf7dfa8a956$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $63aabbf7dfa8a956$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $63aabbf7dfa8a956$var$signature = $63aabbf7dfa8a956$var$Signature;
function $63aabbf7dfa8a956$var$Position() {
    this.place = 0;
}
function $63aabbf7dfa8a956$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $63aabbf7dfa8a956$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$63aabbf7dfa8a956$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $63aabbf7dfa8a956$var$utils_1$1.toArray(data, enc);
    var p = new $63aabbf7dfa8a956$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $63aabbf7dfa8a956$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $63aabbf7dfa8a956$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $63aabbf7dfa8a956$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(s);
    this.recoveryParam = null;
    return true;
};
function $63aabbf7dfa8a956$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$63aabbf7dfa8a956$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $63aabbf7dfa8a956$var$rmPadding(r);
    s = $63aabbf7dfa8a956$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $63aabbf7dfa8a956$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $63aabbf7dfa8a956$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $63aabbf7dfa8a956$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $63aabbf7dfa8a956$var$utils_1$1.encode(res, enc);
};
"use strict";
var $63aabbf7dfa8a956$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $63aabbf7dfa8a956$var$assert$5 = $63aabbf7dfa8a956$var$utils_1$1.assert;
function $63aabbf7dfa8a956$var$EC(options) {
    if (!(this instanceof $63aabbf7dfa8a956$var$EC)) return new $63aabbf7dfa8a956$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $63aabbf7dfa8a956$var$assert$5(Object.prototype.hasOwnProperty.call($63aabbf7dfa8a956$var$curves_1, options), "Unknown curve " + options);
        options = $63aabbf7dfa8a956$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $63aabbf7dfa8a956$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $63aabbf7dfa8a956$var$ec = $63aabbf7dfa8a956$var$EC;
$63aabbf7dfa8a956$var$EC.prototype.keyPair = function keyPair(options) {
    return new $63aabbf7dfa8a956$var$key(this, options);
};
$63aabbf7dfa8a956$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $63aabbf7dfa8a956$var$key.fromPrivate(this, priv, enc);
};
$63aabbf7dfa8a956$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $63aabbf7dfa8a956$var$key.fromPublic(this, pub, enc);
};
$63aabbf7dfa8a956$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $63aabbf7dfa8a956$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $63aabbf7dfa8a956$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$63aabbf7dfa8a956$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$63aabbf7dfa8a956$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $63aabbf7dfa8a956$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $63aabbf7dfa8a956$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$63aabbf7dfa8a956$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $63aabbf7dfa8a956$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$63aabbf7dfa8a956$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $63aabbf7dfa8a956$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $63aabbf7dfa8a956$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($dEXSZ)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$63aabbf7dfa8a956$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $63aabbf7dfa8a956$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $63aabbf7dfa8a956$var$elliptic_1 = $63aabbf7dfa8a956$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $63aabbf7dfa8a956$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $63aabbf7dfa8a956$var$curve_1;
    elliptic.curves = $63aabbf7dfa8a956$var$curves_1;
    // Protocols
    elliptic.ec = $63aabbf7dfa8a956$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $63aabbf7dfa8a956$export$129fe12d32abc311 = $63aabbf7dfa8a956$var$elliptic_1.ec;





const $a512adda7ad1dfdc$export$83d89fbfd8236492 = "signing-key/5.7.0";


"use strict";
const $ff9f75f56da7c459$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $a512adda7ad1dfdc$export$83d89fbfd8236492));
let $ff9f75f56da7c459$var$_curve = null;
function $ff9f75f56da7c459$var$getCurve() {
    if (!$ff9f75f56da7c459$var$_curve) $ff9f75f56da7c459$var$_curve = new (0, $63aabbf7dfa8a956$export$129fe12d32abc311)("secp256k1");
    return $ff9f75f56da7c459$var$_curve;
}
class $ff9f75f56da7c459$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "curve", "secp256k1");
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "privateKey", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(privateKey));
        if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(this.privateKey) !== 32) $ff9f75f56da7c459$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = $ff9f75f56da7c459$var$getCurve().keyFromPrivate((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.privateKey));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $ff9f75f56da7c459$var$getCurve().keyFromPublic((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.publicKey));
        const p1 = $ff9f75f56da7c459$var$getCurve().keyFromPublic((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $ff9f75f56da7c459$var$getCurve().keyFromPrivate((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.privateKey));
        const digestBytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(digest);
        if (digestBytes.length !== 32) $ff9f75f56da7c459$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)({
            recoveryParam: signature.recoveryParam,
            r: (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)("0x" + signature.r.toString(16), 32),
            s: (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $ff9f75f56da7c459$var$getCurve().keyFromPrivate((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.privateKey));
        const otherKeyPair = $ff9f75f56da7c459$var$getCurve().keyFromPublic((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)($ff9f75f56da7c459$export$4a89473d39301224(otherKey)));
        return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $ff9f75f56da7c459$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)(signature);
    const rs = {
        r: (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(sig.r),
        s: (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(sig.s)
    };
    return "0x" + $ff9f75f56da7c459$var$getCurve().recoverPubKey((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $ff9f75f56da7c459$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(key);
    if (bytes.length === 32) {
        const signingKey = new $ff9f75f56da7c459$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $ff9f75f56da7c459$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $ff9f75f56da7c459$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $ff9f75f56da7c459$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $ff9f75f56da7c459$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}



const $8ffd0867b0da9487$export$83d89fbfd8236492 = "transactions/5.7.0";


"use strict";
const $0a7021bc70fec74d$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $8ffd0867b0da9487$export$83d89fbfd8236492));
var $0a7021bc70fec74d$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($0a7021bc70fec74d$export$80349e05e0724e11 || ($0a7021bc70fec74d$export$80349e05e0724e11 = {}));
///////////////////////////////
function $0a7021bc70fec74d$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $8aee8aee2d40605d$export$88411125f012957a)(value);
}
function $0a7021bc70fec74d$var$handleNumber(value) {
    if (value === "0x") return 0, $c5333cf79421e056$export$aaef8a3eae948f03;
    return (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
}
// Legacy Transaction Fields
const $0a7021bc70fec74d$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $0a7021bc70fec74d$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $0a7021bc70fec74d$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $ff9f75f56da7c459$export$4a89473d39301224)(key);
    return (0, $8aee8aee2d40605d$export$88411125f012957a)((0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$15da666eba198c18)(publicKey, 1)), 12));
}
function $0a7021bc70fec74d$export$23cc18f96d8510e2(digest, signature) {
    return $0a7021bc70fec74d$export$e67e2732ba9803f9((0, $ff9f75f56da7c459$export$952dd09fbe0232b7)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(digest), signature));
}
function $0a7021bc70fec74d$var$formatNumber(value, name) {
    const result = (0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)((0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toHexString());
    if (result.length > 32) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $0a7021bc70fec74d$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $8aee8aee2d40605d$export$88411125f012957a)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(storageKey) !== 32) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $0a7021bc70fec74d$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $0a7021bc70fec74d$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $0a7021bc70fec74d$var$accessSetify(set[0], set[1]);
        }
        return $0a7021bc70fec74d$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $0a7021bc70fec74d$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $0a7021bc70fec74d$var$formatAccessList(value) {
    return $0a7021bc70fec74d$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $0a7021bc70fec74d$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction.gasPrice);
        const maxFeePerGas = (0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $0a7021bc70fec74d$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $0a7021bc70fec74d$var$formatNumber(transaction.chainId || 0, "chainId"),
        $0a7021bc70fec74d$var$formatNumber(transaction.nonce || 0, "nonce"),
        $0a7021bc70fec74d$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $0a7021bc70fec74d$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $0a7021bc70fec74d$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $8aee8aee2d40605d$export$88411125f012957a)(transaction.to) : "0x",
        $0a7021bc70fec74d$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $0a7021bc70fec74d$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)(signature);
        fields.push($0a7021bc70fec74d$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
        "0x02",
        $6ff2d0f6bfa15181$export$c564cdbbe6da493(fields)
    ]);
}
function $0a7021bc70fec74d$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $0a7021bc70fec74d$var$formatNumber(transaction.chainId || 0, "chainId"),
        $0a7021bc70fec74d$var$formatNumber(transaction.nonce || 0, "nonce"),
        $0a7021bc70fec74d$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $0a7021bc70fec74d$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $8aee8aee2d40605d$export$88411125f012957a)(transaction.to) : "0x",
        $0a7021bc70fec74d$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $0a7021bc70fec74d$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)(signature);
        fields.push($0a7021bc70fec74d$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
        "0x01",
        $6ff2d0f6bfa15181$export$c564cdbbe6da493(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $0a7021bc70fec74d$var$_serialize(transaction, signature) {
    (0, $a463a6b5f08d6875$export$ae5a316ba623b73a)(transaction, $0a7021bc70fec74d$var$allowedTransactionKeys);
    const raw = [];
    $0a7021bc70fec74d$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)(value);
            if (value.length > fieldInfo.maxLength) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $0a7021bc70fec74d$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $7b88b6e03e4708f2$export$9a14abb1a440cd5e)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $6ff2d0f6bfa15181$export$c564cdbbe6da493(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $7b88b6e03e4708f2$export$7fb170f1e457988f)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $0a7021bc70fec74d$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $0a7021bc70fec74d$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(v));
    raw.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(sig.r)));
    raw.push((0, $7b88b6e03e4708f2$export$a8f4574d0e56446c)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(sig.s)));
    return $6ff2d0f6bfa15181$export$c564cdbbe6da493(raw);
}
function $0a7021bc70fec74d$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $0a7021bc70fec74d$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $0a7021bc70fec74d$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $0a7021bc70fec74d$var$_serializeEip2930(transaction, signature);
        case 2:
            return $0a7021bc70fec74d$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $0a7021bc70fec74d$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $0a7021bc70fec74d$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $0a7021bc70fec74d$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $0a7021bc70fec74d$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(fields[1], 32);
    tx.s = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(fields[2], 32);
    try {
        const digest = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(serialize(tx));
        tx.from = $0a7021bc70fec74d$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $0a7021bc70fec74d$var$_parseEip1559(payload) {
    const transaction = $6ff2d0f6bfa15181$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(payload));
    const maxPriorityFeePerGas = $0a7021bc70fec74d$var$handleNumber(transaction[2]);
    const maxFeePerGas = $0a7021bc70fec74d$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $0a7021bc70fec74d$var$handleNumber(transaction[0]).toNumber(),
        nonce: $0a7021bc70fec74d$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $0a7021bc70fec74d$var$handleNumber(transaction[4]),
        to: $0a7021bc70fec74d$var$handleAddress(transaction[5]),
        value: $0a7021bc70fec74d$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $0a7021bc70fec74d$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(payload);
    $0a7021bc70fec74d$var$_parseEipSignature(tx, transaction.slice(9), $0a7021bc70fec74d$var$_serializeEip1559);
    return tx;
}
function $0a7021bc70fec74d$var$_parseEip2930(payload) {
    const transaction = $6ff2d0f6bfa15181$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(payload));
    const tx = {
        type: 1,
        chainId: $0a7021bc70fec74d$var$handleNumber(transaction[0]).toNumber(),
        nonce: $0a7021bc70fec74d$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $0a7021bc70fec74d$var$handleNumber(transaction[2]),
        gasLimit: $0a7021bc70fec74d$var$handleNumber(transaction[3]),
        to: $0a7021bc70fec74d$var$handleAddress(transaction[4]),
        value: $0a7021bc70fec74d$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $0a7021bc70fec74d$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(payload);
    $0a7021bc70fec74d$var$_parseEipSignature(tx, transaction.slice(8), $0a7021bc70fec74d$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $0a7021bc70fec74d$var$_parse(rawTransaction) {
    const transaction = $6ff2d0f6bfa15181$export$2f872c0f2117be69(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $0a7021bc70fec74d$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $0a7021bc70fec74d$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $0a7021bc70fec74d$var$handleNumber(transaction[1]),
        gasLimit: $0a7021bc70fec74d$var$handleNumber(transaction[2]),
        to: $0a7021bc70fec74d$var$handleAddress(transaction[3]),
        value: $0a7021bc70fec74d$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(transaction[7], 32);
    tx.s = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(transaction[8], 32);
    if ((0, $0df4577496dcf693$export$d97aa349ed20696).from(tx.r).isZero() && (0, $0df4577496dcf693$export$d97aa349ed20696).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)($6ff2d0f6bfa15181$export$c564cdbbe6da493(raw));
        try {
            tx.from = $0a7021bc70fec74d$export$23cc18f96d8510e2(digest, {
                r: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(tx.r),
                s: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $0a7021bc70fec74d$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $0a7021bc70fec74d$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $0a7021bc70fec74d$var$_parseEip2930(payload);
        case 2:
            return $0a7021bc70fec74d$var$_parseEip1559(payload);
        default:
            break;
    }
    return $0a7021bc70fec74d$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}



const $e1c2f54bf01974f7$export$83d89fbfd8236492 = "contracts/5.7.0";


"use strict";
var $b84bae218d85c3ca$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $b84bae218d85c3ca$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $e1c2f54bf01974f7$export$83d89fbfd8236492));
///////////////////////////////
const $b84bae218d85c3ca$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function $b84bae218d85c3ca$var$resolveName(resolver, nameOrPromise) {
    return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
        const name = yield nameOrPromise;
        if (typeof name !== "string") $b84bae218d85c3ca$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
        // If it is already an address, just use it (after adding checksum)
        try {
            return (0, $8aee8aee2d40605d$export$88411125f012957a)(name);
        } catch (error) {}
        if (!resolver) $b84bae218d85c3ca$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "resolveName"
        });
        const address = yield resolver.resolveName(name);
        if (address == null) $b84bae218d85c3ca$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $b84bae218d85c3ca$var$resolveAddresses(resolver, value, paramType) {
    return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
        if (Array.isArray(paramType)) return yield Promise.all(paramType.map((paramType, index)=>{
            return $b84bae218d85c3ca$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
        }));
        if (paramType.type === "address") return yield $b84bae218d85c3ca$var$resolveName(resolver, value);
        if (paramType.type === "tuple") return yield $b84bae218d85c3ca$var$resolveAddresses(resolver, value, paramType.components);
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) return Promise.reject($b84bae218d85c3ca$var$logger.makeError("invalid value for array", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "value",
                value: value
            }));
            return yield Promise.all(value.map((v)=>$b84bae218d85c3ca$var$resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function $b84bae218d85c3ca$var$populateTransaction(contract, fragment, args) {
    return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(args.pop());
        // Make sure the parameter count matches
        $b84bae218d85c3ca$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
            // but we allow overriding "from" if it matches the signer
            overrides.from = (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                override: $b84bae218d85c3ca$var$resolveName(contract.signer, overrides.from),
                signer: contract.signer.getAddress()
            }).then((check)=>$b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
                    if ((0, $8aee8aee2d40605d$export$88411125f012957a)(check.signer) !== check.override) $b84bae218d85c3ca$var$logger.throwError("Contract with a Signer cannot override from", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.from"
                    });
                    return check.override;
                }));
            else overrides.from = contract.signer.getAddress();
        } else if (overrides.from) overrides.from = $b84bae218d85c3ca$var$resolveName(contract.provider, overrides.from);
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
            args: $b84bae218d85c3ca$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: (0, $a463a6b5f08d6875$export$d503dd157d963b60)(overrides) || {}
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) tx.nonce = (0, $0df4577496dcf693$export$d97aa349ed20696).from(ro.nonce).toNumber();
        if (ro.gasLimit != null) tx.gasLimit = (0, $0df4577496dcf693$export$d97aa349ed20696).from(ro.gasLimit);
        if (ro.gasPrice != null) tx.gasPrice = (0, $0df4577496dcf693$export$d97aa349ed20696).from(ro.gasPrice);
        if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $0df4577496dcf693$export$d97aa349ed20696).from(ro.maxFeePerGas);
        if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $0df4577496dcf693$export$d97aa349ed20696).from(ro.maxPriorityFeePerGas);
        if (ro.from != null) tx.from = ro.from;
        if (ro.type != null) tx.type = ro.type;
        if (ro.accessList != null) tx.accessList = (0, $0a7021bc70fec74d$export$6c8662b1600dce2)(ro.accessList);
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
            for(let i = 0; i < bytes.length; i++){
                intrinsic += 4;
                if (bytes[i]) intrinsic += 64;
            }
            tx.gasLimit = (0, $0df4577496dcf693$export$d97aa349ed20696).from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = (0, $0df4577496dcf693$export$d97aa349ed20696).from(ro.value);
            if (!roValue.isZero() && !fragment.payable) $b84bae218d85c3ca$var$logger.throwError("non-payable method cannot override value", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: overrides.value
            });
            tx.value = roValue;
        }
        if (ro.customData) tx.customData = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(ro.customData);
        if (ro.ccipReadEnabled) tx.ccipReadEnabled = !!ro.ccipReadEnabled;
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        delete overrides.ccipReadEnabled;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key)=>overrides[key] != null);
        if (leftovers.length) $b84bae218d85c3ca$var$logger.throwError(`cannot override ${leftovers.map((l)=>JSON.stringify(l)).join(",")}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "overrides",
            overrides: leftovers
        });
        return tx;
    });
}
function $b84bae218d85c3ca$var$buildPopulate(contract, fragment) {
    return function(...args) {
        return $b84bae218d85c3ca$var$populateTransaction(contract, fragment, args);
    };
}
function $b84bae218d85c3ca$var$buildEstimate(contract, fragment) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
            if (!signerOrProvider) $b84bae218d85c3ca$var$logger.throwError("estimate require a provider or signer", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
            });
            const tx = yield $b84bae218d85c3ca$var$populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function $b84bae218d85c3ca$var$addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations)=>{
        return wait(confirmations).then((receipt)=>{
            receipt.events = receipt.logs.map((log)=>{
                let event = (0, $a463a6b5f08d6875$export$6c40052bed430212)(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics)=>{
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = ()=>{
                    return contract.provider;
                };
                event.getBlock = ()=>{
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = ()=>{
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = ()=>{
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $b84bae218d85c3ca$var$buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                const overrides = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(args.pop());
                if (overrides.blockTag != null) blockTag = yield overrides.blockTag;
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed(blockTag);
            // Call a node and get the result
            const tx = yield $b84bae218d85c3ca$var$populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                return value;
            } catch (error) {
                if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function $b84bae218d85c3ca$var$buildSend(contract, fragment) {
    return function(...args) {
        return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
            if (!contract.signer) $b84bae218d85c3ca$var$logger.throwError("sending a transaction requires a signer", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
            });
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed();
            const txRequest = yield $b84bae218d85c3ca$var$populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            $b84bae218d85c3ca$var$addContractWait(contract, tx);
            return tx;
        });
    };
}
function $b84bae218d85c3ca$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $b84bae218d85c3ca$var$buildCall(contract, fragment, collapseSimple);
    return $b84bae218d85c3ca$var$buildSend(contract, fragment);
}
function $b84bae218d85c3ca$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic)=>{
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
class $b84bae218d85c3ca$var$RunningEvent {
    constructor(tag, filter){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "tag", tag);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "filter", filter);
        this._listeners = [];
    }
    addListener(listener, once) {
        this._listeners.push({
            listener: listener,
            once: once
        });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item)=>{
            if (done || item.listener !== listener) return true;
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i)=>i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item)=>{
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(()=>{
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !item.once;
        });
        return listenerCount;
    }
    prepareEvent(event) {}
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [
            event
        ];
    }
}
class $b84bae218d85c3ca$var$ErrorRunningEvent extends $b84bae218d85c3ca$var$RunningEvent {
    constructor(){
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class $b84bae218d85c3ca$var$FragmentRunningEvent extends $b84bae218d85c3ca$var$RunningEvent {
    constructor(address, contractInterface, fragment, topics){
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $b84bae218d85c3ca$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        super($b84bae218d85c3ca$var$getEventTag(filter), filter);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", address);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "interface", contractInterface);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "fragment", fragment);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics)=>{
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        } catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = (0, $2c0f0ed4c5bed241$export$5546b9ec21157cc2)(event.args);
        if (errors.length) throw errors[0].error;
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class $b84bae218d85c3ca$var$WildcardRunningEvent extends $b84bae218d85c3ca$var$RunningEvent {
    constructor(address, contractInterface){
        super("*", {
            address: address
        });
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", address);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "interface", contractInterface);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics)=>{
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        } catch (error) {
        // No matching event
        }
    }
}
class $b84bae218d85c3ca$export$304faa4fc17528db {
    constructor(addressOrName, contractInterface, signerOrProvider){
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "interface", (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", null);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "signer", null);
        } else if ((0, $deb85df20e19ba32$export$fdf54fdde81cc9f0).isSigner(signerOrProvider)) {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", signerOrProvider.provider || null);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "signer", signerOrProvider);
        } else if ((0, $81658ac0a17fba50$export$2881499e37b75b9a).isProvider(signerOrProvider)) {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", signerOrProvider);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "signer", null);
        } else $b84bae218d85c3ca$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "callStatic", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "estimateGas", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "functions", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "populateTransaction", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature)=>{
                const event = this.interface.events[eventSignature];
                (0, $a463a6b5f08d6875$export$104236534534f9be)(this.filters, eventSignature, (...args)=>{
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name)=>{
                const filters = uniqueFilters[name];
                if (filters.length === 1) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.filters, name, this.filters[filters[0]]);
                else $b84bae218d85c3ca$var$logger.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
            });
        }
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_runningEvents", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_wrappedEmits", {});
        if (addressOrName == null) $b84bae218d85c3ca$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", addressOrName);
        if (this.provider) (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "resolvedAddress", $b84bae218d85c3ca$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "resolvedAddress", Promise.resolve((0, $8aee8aee2d40605d$export$88411125f012957a)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $b84bae218d85c3ca$var$logger.throwError("provider is required to use ENS name as contract address", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch((e)=>{});
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature)=>{
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $b84bae218d85c3ca$var$logger.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) uniqueNames[`%${name}`] = [];
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this, signature, $b84bae218d85c3ca$var$buildDefault(this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.functions, signature, $b84bae218d85c3ca$var$buildDefault(this, fragment, false));
            if (this.callStatic[signature] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.callStatic, signature, $b84bae218d85c3ca$var$buildCall(this, fragment, true));
            if (this.populateTransaction[signature] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.populateTransaction, signature, $b84bae218d85c3ca$var$buildPopulate(this, fragment));
            if (this.estimateGas[signature] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.estimateGas, signature, $b84bae218d85c3ca$var$buildEstimate(this, fragment));
        });
        Object.keys(uniqueNames).forEach((name)=>{
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this, name, this[signature]);
            } catch (e) {}
            if (this.functions[name] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.functions, name, this.functions[signature]);
            if (this.callStatic[name] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.callStatic, name, this.callStatic[signature]);
            if (this.populateTransaction[name] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.populateTransaction, name, this.populateTransaction[signature]);
            if (this.estimateGas[name] == null) (0, $a463a6b5f08d6875$export$104236534534f9be)(this.estimateGas, name, this.estimateGas[signature]);
        });
    }
    static getContractAddress(transaction) {
        return (0, $8aee8aee2d40605d$export$b7fbffef12272e40)(transaction);
    }
    static getInterface(contractInterface) {
        if ((0, $ef97d5c3a9a93354$export$48cefb51a4e315b2).isInterface(contractInterface)) return contractInterface;
        return new (0, $ef97d5c3a9a93354$export$48cefb51a4e315b2)(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(()=>{
                return this;
            });
            else // @TODO: Once we allow a timeout to be passed in, we will wait
            // up to that many blocks for getCode
            // Otherwise, poll for our code to be deployed
            this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code)=>{
                if (code === "0x") $b84bae218d85c3ca$var$logger.throwError("contract not deployed", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    contractAddress: this.address,
                    operation: "getDeployed"
                });
                return this;
            });
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) $b84bae218d85c3ca$var$logger.throwError("sending a transactions require a signer", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "sendTransaction(fallback)"
        });
        const tx = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(overrides || {});
        [
            "from",
            "to"
        ].forEach(function(key) {
            if (tx[key] == null) return;
            $b84bae218d85c3ca$var$logger.throwError("cannot override " + key, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(()=>{
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof signerOrProvider === "string") signerOrProvider = new (0, $deb85df20e19ba32$export$7dbc56d9b9612bad)(signerOrProvider, this.provider);
        const contract = new this.constructor(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) (0, $a463a6b5f08d6875$export$104236534534f9be)(contract, "deployTransaction", this.deployTransaction);
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return (0, $ef97d5c3a9a93354$export$8ef99100a3c56f8c).isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof eventName === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$ErrorRunningEvent());
            // Listen for any event that is registered
            if (eventName === "event") return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$RunningEvent("event", null));
            // Listen for any event
            if (eventName === "*") return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$WildcardRunningEvent(this.address, this.interface));
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            } catch (error) {}
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$RunningEvent($b84bae218d85c3ca$var$getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new $b84bae218d85c3ca$var$WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = (0, $a463a6b5f08d6875$export$6c40052bed430212)(log);
        event.removeListener = ()=>{
            if (!listener) return;
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = ()=>{
            return this.provider.getBlock(log.blockHash);
        };
        event.getTransaction = ()=>{
            return this.provider.getTransaction(log.transactionHash);
        };
        event.getTransactionReceipt = ()=>{
            return this.provider.getTransactionReceipt(log.transactionHash);
        };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) $b84bae218d85c3ca$var$logger.throwError("events require a provider or a signer with a provider", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "once"
        });
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log)=>{
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) try {
                    const args = runningEvent.getEmit(event);
                    this.emit(runningEvent.filter, ...args);
                } catch (error) {
                    event.decodeError = error.error;
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) this.emit("event", event);
                // Emit "error" if there was an error
                if (event.decodeError != null) this.emit("error", event.decodeError, event);
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(runningEvent.filter);
        if (typeof fromBlockOrBlockhash === "string" && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) $b84bae218d85c3ca$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            filter.blockHash = fromBlockOrBlockhash;
        } else {
            filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
            filter.toBlock = toBlock != null ? toBlock : "latest";
        }
        return this.provider.getLogs(filter).then((logs)=>{
            return logs.map((log)=>this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) return false;
        const runningEvent = this._getRunningEvent(eventName);
        const result = runningEvent.run(args) > 0;
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) return 0;
        if (eventName == null) return Object.keys(this._runningEvents).reduce((accum, key)=>{
            return accum + this._runningEvents[key].listenerCount();
        }, 0);
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) return [];
        if (eventName == null) {
            const result = [];
            for(let tag in this._runningEvents)this._runningEvents[tag].listeners().forEach((listener)=>{
                result.push(listener);
            });
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) return this;
        if (eventName == null) {
            for(const tag in this._runningEvents){
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) return this;
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
}
class $b84bae218d85c3ca$export$8517d80acf00e19a extends $b84bae218d85c3ca$export$304faa4fc17528db {
}
class $b84bae218d85c3ca$export$505569a6bf584fd9 {
    constructor(contractInterface, bytecode, signer){
        let bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $7b88b6e03e4708f2$export$c6fabfbfd097fc30)(bytecode)) bytecodeHex = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(bytecodeHex) || bytecodeHex.length % 2) $b84bae218d85c3ca$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $deb85df20e19ba32$export$fdf54fdde81cc9f0).isSigner(signer)) $b84bae218d85c3ca$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "bytecode", bytecodeHex);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "interface", (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getInterface")(contractInterface));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "signer", signer || null);
    }
    // @TODO: Future; rename to populateTransaction?
    getDeployTransaction(...args) {
        let tx = {};
        // If we have 1 additional argument, we allow transaction overrides
        if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
            tx = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(args.pop());
            for(const key in tx){
                if (!$b84bae218d85c3ca$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
            }
        }
        // Do not allow these to be overridden in a deployment transaction
        [
            "data",
            "from",
            "to"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            $b84bae218d85c3ca$var$logger.throwError("cannot override " + key, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        if (tx.value) {
            const value = (0, $0df4577496dcf693$export$d97aa349ed20696).from(tx.value);
            if (!value.isZero() && !this.interface.deploy.payable) $b84bae218d85c3ca$var$logger.throwError("non-payable constructor cannot override value", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: tx.value
            });
        }
        // Make sure the call matches the constructor signature
        $b84bae218d85c3ca$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
        // Set the data to the bytecode + the encoded constructor arguments
        tx.data = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            this.bytecode,
            this.interface.encodeDeploy(args)
        ]));
        return tx;
    }
    deploy(...args) {
        return $b84bae218d85c3ca$var$__awaiter(this, void 0, void 0, function*() {
            let overrides = {};
            // If 1 extra parameter was passed in, it contains overrides
            if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
            // Make sure the call matches the constructor signature
            $b84bae218d85c3ca$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
            // Resolve ENS names and promises in the arguments
            const params = yield $b84bae218d85c3ca$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            params.push(overrides);
            // Get the deployment transaction (with optional overrides)
            const unsignedTx = this.getDeployTransaction(...params);
            // Send the deployment transaction
            const tx = yield this.signer.sendTransaction(unsignedTx);
            const address = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "getContractAddress")(tx);
            const contract = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "getContract")(address, this.interface, this.signer);
            // Add the modified wait that wraps events
            $b84bae218d85c3ca$var$addContractWait(contract, tx);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(contract, "deployTransaction", tx);
            return contract;
        });
    }
    attach(address) {
        return this.constructor.getContract(address, this.interface, this.signer);
    }
    connect(signer) {
        return new this.constructor(this.interface, this.bytecode, signer);
    }
    static fromSolidity(compilerOutput, signer) {
        if (compilerOutput == null) $b84bae218d85c3ca$var$logger.throwError("missing compiler output", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.MISSING_ARGUMENT, {
            argument: "compilerOutput"
        });
        if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
        const abi = compilerOutput.abi;
        let bytecode = null;
        if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
        else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
        return new this(abi, bytecode, signer);
    }
    static getInterface(contractInterface) {
        return $b84bae218d85c3ca$export$8517d80acf00e19a.getInterface(contractInterface);
    }
    static getContractAddress(tx) {
        return (0, $8aee8aee2d40605d$export$b7fbffef12272e40)(tx);
    }
    static getContract(address, contractInterface, signer) {
        return new $b84bae218d85c3ca$export$8517d80acf00e19a(address, contractInterface, signer);
    }
}






"use strict";
const $bdc30db990c4b693$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $a38aef31efdfa85e$export$83d89fbfd8236492));
const $bdc30db990c4b693$var$_constructorGuard = {};
const $bdc30db990c4b693$var$Zero = (0, $0df4577496dcf693$export$d97aa349ed20696).from(0);
const $bdc30db990c4b693$var$NegativeOne = (0, $0df4577496dcf693$export$d97aa349ed20696).from(-1);
function $bdc30db990c4b693$var$throwFault(message, fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $bdc30db990c4b693$var$logger.throwError(message, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let $bdc30db990c4b693$var$zeros = "0";
while($bdc30db990c4b693$var$zeros.length < 256)$bdc30db990c4b693$var$zeros += $bdc30db990c4b693$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $bdc30db990c4b693$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $0df4577496dcf693$export$d97aa349ed20696).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $bdc30db990c4b693$var$zeros.substring(0, decimals);
    return $bdc30db990c4b693$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $bdc30db990c4b693$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $bdc30db990c4b693$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
    const negative = value.lt($bdc30db990c4b693$var$Zero);
    if (negative) value = value.mul($bdc30db990c4b693$var$NegativeOne);
    let fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $bdc30db990c4b693$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $bdc30db990c4b693$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $bdc30db990c4b693$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    const negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $bdc30db990c4b693$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) $bdc30db990c4b693$var$logger.throwArgumentError("too many decimal points", "value", value);
    let whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $bdc30db990c4b693$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    const wholeValue = (0, $0df4577496dcf693$export$d97aa349ed20696).from(whole);
    const fractionValue = (0, $0df4577496dcf693$export$d97aa349ed20696).from(fraction);
    let wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($bdc30db990c4b693$var$NegativeOne);
    return wei;
}
class $bdc30db990c4b693$export$1f3ec5b8f47ebd4d {
    constructor(constructorGuard, signed, width, decimals){
        if (constructorGuard !== $bdc30db990c4b693$var$_constructorGuard) $bdc30db990c4b693$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $bdc30db990c4b693$var$getMultiplier(decimals);
        Object.freeze(this);
    }
    static from(value) {
        if (value instanceof $bdc30db990c4b693$export$1f3ec5b8f47ebd4d) return value;
        if (typeof value === "number") value = `fixed128x${value}`;
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof value === "string") {
            if (value === "fixed") ;
            else if (value === "ufixed") signed = false;
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) $bdc30db990c4b693$var$logger.throwArgumentError("invalid fixed format", "format", value);
                signed = match[1] !== "u";
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        } else if (value) {
            const check = (key, type, defaultValue)=>{
                if (value[key] == null) return defaultValue;
                if (typeof value[key] !== type) $bdc30db990c4b693$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) $bdc30db990c4b693$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        if (decimals > 80) $bdc30db990c4b693$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        return new $bdc30db990c4b693$export$1f3ec5b8f47ebd4d($bdc30db990c4b693$var$_constructorGuard, signed, width, decimals);
    }
}
class $bdc30db990c4b693$export$d4693c66c2213e45 {
    constructor(constructorGuard, hex, value, format){
        if (constructorGuard !== $bdc30db990c4b693$var$_constructorGuard) $bdc30db990c4b693$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    _checkFormat(other) {
        if (this.format.name !== other.format.name) $bdc30db990c4b693$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = $bdc30db990c4b693$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $bdc30db990c4b693$export$1b039987e86d7269(other._value, other.format.decimals);
        return $bdc30db990c4b693$export$d4693c66c2213e45.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = $bdc30db990c4b693$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $bdc30db990c4b693$export$1b039987e86d7269(other._value, other.format.decimals);
        return $bdc30db990c4b693$export$d4693c66c2213e45.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = $bdc30db990c4b693$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $bdc30db990c4b693$export$1b039987e86d7269(other._value, other.format.decimals);
        return $bdc30db990c4b693$export$d4693c66c2213e45.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = $bdc30db990c4b693$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $bdc30db990c4b693$export$1b039987e86d7269(other._value, other.format.decimals);
        return $bdc30db990c4b693$export$d4693c66c2213e45.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $bdc30db990c4b693$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) result = result.subUnsafe($bdc30db990c4b693$var$ONE.toFormat(result.format));
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $bdc30db990c4b693$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) result = result.addUnsafe($bdc30db990c4b693$var$ONE.toFormat(result.format));
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) decimals = 0;
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        if (decimals < 0 || decimals > 80 || decimals % 1) $bdc30db990c4b693$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        if (comps[1].length <= decimals) return this;
        const factor = $bdc30db990c4b693$export$d4693c66c2213e45.from("1" + $bdc30db990c4b693$var$zeros.substring(0, decimals), this.format);
        const bump = $bdc30db990c4b693$var$BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(width) {
        if (width == null) return this._hex;
        if (width % 8) $bdc30db990c4b693$var$logger.throwArgumentError("invalid byte width", "width", width);
        const hex = (0, $0df4577496dcf693$export$d97aa349ed20696).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(hex, width / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(format) {
        return $bdc30db990c4b693$export$d4693c66c2213e45.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !(0, $0df4577496dcf693$export$a3d0a7fa9b65683b)(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) decimals = 0;
        if (format == null) format = "fixed";
        return $bdc30db990c4b693$export$d4693c66c2213e45.fromString($bdc30db990c4b693$export$cc011b843b5d69f2(value, decimals), $bdc30db990c4b693$export$1f3ec5b8f47ebd4d.from(format));
    }
    static fromString(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $bdc30db990c4b693$export$1f3ec5b8f47ebd4d.from(format);
        const numeric = $bdc30db990c4b693$export$1b039987e86d7269(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt($bdc30db990c4b693$var$Zero)) $bdc30db990c4b693$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
        let hex = null;
        if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
        else {
            hex = numeric.toHexString();
            hex = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(hex, fixedFormat.width / 8);
        }
        const decimal = $bdc30db990c4b693$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $bdc30db990c4b693$export$d4693c66c2213e45($bdc30db990c4b693$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $bdc30db990c4b693$export$1f3ec5b8f47ebd4d.from(format);
        if ((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value).length > fixedFormat.width / 8) throw new Error("overflow");
        let numeric = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
        if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = $bdc30db990c4b693$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $bdc30db990c4b693$export$d4693c66c2213e45($bdc30db990c4b693$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof value === "string") return $bdc30db990c4b693$export$d4693c66c2213e45.fromString(value, format);
        if ((0, $7b88b6e03e4708f2$export$c6fabfbfd097fc30)(value)) return $bdc30db990c4b693$export$d4693c66c2213e45.fromBytes(value, format);
        try {
            return $bdc30db990c4b693$export$d4693c66c2213e45.fromValue(value, 0, format);
        } catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT) throw error;
        }
        return $bdc30db990c4b693$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
}
const $bdc30db990c4b693$var$ONE = $bdc30db990c4b693$export$d4693c66c2213e45.from(1);
const $bdc30db990c4b693$var$BUMP = $bdc30db990c4b693$export$d4693c66c2213e45.from("0.5");










const $d83cea76876f8e45$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $d83cea76876f8e45$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(message);
    return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)($d83cea76876f8e45$export$1ff3fdc4802a2ba6),
        (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(String(message.length)),
        message
    ]));
}







const $389eb7fe008974da$export$83d89fbfd8236492 = "hash/5.7.0";



var $74ec091a01b8d3e1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $74ec091a01b8d3e1$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $389eb7fe008974da$export$83d89fbfd8236492));
const $74ec091a01b8d3e1$var$padding = new Uint8Array(32);
$74ec091a01b8d3e1$var$padding.fill(0);
const $74ec091a01b8d3e1$var$NegativeOne = (0, $0df4577496dcf693$export$d97aa349ed20696).from(-1);
const $74ec091a01b8d3e1$var$Zero = (0, $0df4577496dcf693$export$d97aa349ed20696).from(0);
const $74ec091a01b8d3e1$var$One = (0, $0df4577496dcf693$export$d97aa349ed20696).from(1);
const $74ec091a01b8d3e1$var$MaxUint256 = (0, $0df4577496dcf693$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $74ec091a01b8d3e1$var$hexPadRight(value) {
    const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
        bytes,
        $74ec091a01b8d3e1$var$padding.slice(padOffset)
    ]);
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes);
}
const $74ec091a01b8d3e1$var$hexTrue = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)($74ec091a01b8d3e1$var$One.toHexString(), 32);
const $74ec091a01b8d3e1$var$hexFalse = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)($74ec091a01b8d3e1$var$Zero.toHexString(), 32);
const $74ec091a01b8d3e1$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $74ec091a01b8d3e1$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $74ec091a01b8d3e1$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $74ec091a01b8d3e1$var$domainChecks = {
    name: $74ec091a01b8d3e1$var$checkString("name"),
    version: $74ec091a01b8d3e1$var$checkString("version"),
    chainId: function(value) {
        try {
            return (0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toString();
        } catch (error) {}
        return $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $8aee8aee2d40605d$export$88411125f012957a)(value).toLowerCase();
        } catch (error) {}
        return $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        try {
            const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes);
        } catch (error) {}
        return $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function $74ec091a01b8d3e1$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $74ec091a01b8d3e1$var$logger.throwArgumentError("invalid numeric width", "type", type);
            const boundsUpper = $74ec091a01b8d3e1$var$MaxUint256.mask(signed ? width - 1 : width);
            const boundsLower = signed ? boundsUpper.add($74ec091a01b8d3e1$var$One).mul($74ec091a01b8d3e1$var$NegativeOne) : $74ec091a01b8d3e1$var$Zero;
            return function(value) {
                const v = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $74ec091a01b8d3e1$var$logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) $74ec091a01b8d3e1$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
                if (bytes.length !== width) $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                return $74ec091a01b8d3e1$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)((0, $8aee8aee2d40605d$export$88411125f012957a)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $74ec091a01b8d3e1$var$hexFalse : $74ec091a01b8d3e1$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(value);
            };
        case "string":
            return function(value) {
                return (0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(value);
            };
    }
    return null;
}
function $74ec091a01b8d3e1$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
class $74ec091a01b8d3e1$export$458ab927ae635c3 {
    constructor(types){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "types", Object.freeze((0, $a463a6b5f08d6875$export$6c40052bed430212)(types)));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_encoderCache", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type)=>{
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(const name in types){
            const uniqueNames = {};
            types[name].forEach((field)=>{
                // Check each field has a unique name
                if (uniqueNames[field.name]) $74ec091a01b8d3e1$var$logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $74ec091a01b8d3e1$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                // Is this a base encoding type?
                const encoder = $74ec091a01b8d3e1$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $74ec091a01b8d3e1$var$logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n)=>parents[n].length === 0);
        if (primaryTypes.length === 0) $74ec091a01b8d3e1$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $74ec091a01b8d3e1$var$logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", types);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $74ec091a01b8d3e1$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach((child)=>{
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype)=>{
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(const name in subtypes){
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = $74ec091a01b8d3e1$var$encodeType(name, types[name]) + st.map((t)=>$74ec091a01b8d3e1$var$encodeType(t, types[t])).join("");
        }
    }
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $74ec091a01b8d3e1$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value)=>{
                if (length >= 0 && value.length !== length) $74ec091a01b8d3e1$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                let result = value.map(subEncoder);
                if (this._types[subtype]) result = result.map((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35));
                return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$6d4b99629b38754a)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(this._types[type]);
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)(values);
            };
        }
        return $74ec091a01b8d3e1$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) $74ec091a01b8d3e1$var$logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $74ec091a01b8d3e1$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) $74ec091a01b8d3e1$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            return value.map((v)=>this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        return $74ec091a01b8d3e1$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new $74ec091a01b8d3e1$export$458ab927ae635c3(types);
    }
    static getPrimaryType(types) {
        return $74ec091a01b8d3e1$export$458ab927ae635c3.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return $74ec091a01b8d3e1$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            const type = $74ec091a01b8d3e1$var$domainFieldTypes[name];
            if (!type) $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $74ec091a01b8d3e1$var$domainFieldNames.indexOf(a.name) - $74ec091a01b8d3e1$var$domainFieldNames.indexOf(b.name);
        });
        return $74ec091a01b8d3e1$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    static encode(domain, types, value) {
        return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
            "0x1901",
            $74ec091a01b8d3e1$export$458ab927ae635c3.hashDomain(domain),
            $74ec091a01b8d3e1$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)($74ec091a01b8d3e1$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return $74ec091a01b8d3e1$var$__awaiter(this, void 0, void 0, function*() {
            // Make a copy to isolate it from the object passed in
            domain = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
            // We are going to use the encoder to visit all the base values
            const encoder = $74ec091a01b8d3e1$export$458ab927ae635c3.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value)=>{
                if (type === "address" && !(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value, 20)) ensCache[value] = "0x";
                return value;
            });
            // Lookup each name
            for(const name in ensCache)ensCache[name] = yield resolveName(name);
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value)=>{
                if (type === "address" && ensCache[value]) return ensCache[value];
                return value;
            });
            return {
                domain: domain,
                value: value
            };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        $74ec091a01b8d3e1$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $74ec091a01b8d3e1$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $74ec091a01b8d3e1$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $74ec091a01b8d3e1$var$domainFieldTypes[name]
            });
        });
        const encoder = $74ec091a01b8d3e1$export$458ab927ae635c3.from(types);
        const typesWithDomain = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(types);
        if (typesWithDomain.EIP712Domain) $74ec091a01b8d3e1$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        else typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof value !== "string") $74ec091a01b8d3e1$var$logger.throwArgumentError(`invalid string`, "value", value);
                        return value;
                }
                return $74ec091a01b8d3e1$var$logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
}


/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 

class $3fca3a6183b20b71$export$240043ab8e806ec7 {
    constructor(alphabet){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "alphabet", alphabet);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "base", alphabet.length);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_alphabetMap", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(let i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    encode(value) {
        let source = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        if (source.length === 0) return "";
        let digits = [
            0
        ];
        for(let i = 0; i < source.length; ++i){
            let carry = source[i];
            for(let j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for(let k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(let q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    }
    decode(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        let bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(let i = 0; i < value.length; i++){
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            let carry = byte;
            for(let j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(let k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(new Uint8Array(bytes.reverse()));
    }
}
const $3fca3a6183b20b71$export$cfabb2852920f5ec = new $3fca3a6183b20b71$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
const $3fca3a6183b20b71$export$45a587635c9954b2 = new $3fca3a6183b20b71$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))







var $kiSKt = parcelRequire("kiSKt");

var $da90616c06668669$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($da90616c06668669$export$d2a8849cfb277c || ($da90616c06668669$export$d2a8849cfb277c = {}));



const $7c32f9e80a4a2783$export$83d89fbfd8236492 = "sha2/5.7.0";


"use strict";
const $bb82ee6f1acbd7c8$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7c32f9e80a4a2783$export$83d89fbfd8236492));
function $bb82ee6f1acbd7c8$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).ripemd160().update((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha256().update((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $bb82ee6f1acbd7c8$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).sha512().update((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $bb82ee6f1acbd7c8$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $da90616c06668669$export$d2a8849cfb277c)[algorithm]) $bb82ee6f1acbd7c8$var$logger.throwError("unsupported algorithm " + algorithm, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($kiSKt))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($kiSKt)))[algorithm], (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(key)).update((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data)).digest("hex");
}


"use strict";
function $52d8b575085ace3c$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(password);
    salt = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for(let i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $bb82ee6f1acbd7c8$export$967075d2f3b8e7ff)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(let j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $bb82ee6f1acbd7c8$export$967075d2f3b8e7ff)(hashAlgorithm, password, U));
            for(let k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(T).slice(0, len), destPos);
    }
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(DK);
}









const $7b1f5e4d32c2ee77$export$83d89fbfd8236492 = "wordlists/5.7.0";


"use strict";
// This gets overridden by rollup
const $1aa3df27db978ea8$var$exportWordlist = false;
const $1aa3df27db978ea8$export$af88d00dbe7f521 = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $7b1f5e4d32c2ee77$export$83d89fbfd8236492));
class $1aa3df27db978ea8$export$4d9531a8ddb0ebca {
    constructor(locale){
        $1aa3df27db978ea8$export$af88d00dbe7f521.checkAbstract(new.target, $1aa3df27db978ea8$export$4d9531a8ddb0ebca);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "locale", locale);
    }
    // Subclasses may override this
    split(mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    }
    // Subclasses may override this
    join(words) {
        return words.join(" ");
    }
    static check(wordlist) {
        const words = [];
        for(let i = 0; i < 2048; i++){
            const word = wordlist.getWord(i);
            /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
            words.push(word);
        }
        return (0, $7cd0a9996bd6b341$export$d560c7e4a29451c2)(words.join("\n") + "\n");
    }
    static register(lang, name) {
        if (!name) name = lang.locale;
        /* istanbul ignore if */ if ($1aa3df27db978ea8$var$exportWordlist) try {
            const anyGlobal = window;
            if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                if (!anyGlobal._ethers.wordlists[name]) (0, $a463a6b5f08d6875$export$104236534534f9be)(anyGlobal._ethers.wordlists, name, lang);
            }
        } catch (error) {}
    }
}


"use strict";
const $e1c37ee3c90035e1$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let $e1c37ee3c90035e1$var$wordlist = null;
function $e1c37ee3c90035e1$var$loadWords(lang) {
    if ($e1c37ee3c90035e1$var$wordlist != null) return;
    $e1c37ee3c90035e1$var$wordlist = $e1c37ee3c90035e1$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $1aa3df27db978ea8$export$4d9531a8ddb0ebca).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $e1c37ee3c90035e1$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
class $e1c37ee3c90035e1$var$LangEn extends (0, $1aa3df27db978ea8$export$4d9531a8ddb0ebca) {
    constructor(){
        super("en");
    }
    getWord(index) {
        $e1c37ee3c90035e1$var$loadWords(this);
        return $e1c37ee3c90035e1$var$wordlist[index];
    }
    getWordIndex(word) {
        $e1c37ee3c90035e1$var$loadWords(this);
        return $e1c37ee3c90035e1$var$wordlist.indexOf(word);
    }
}
const $e1c37ee3c90035e1$export$a2c9518710cf1f49 = new $e1c37ee3c90035e1$var$LangEn();
(0, $1aa3df27db978ea8$export$4d9531a8ddb0ebca).register($e1c37ee3c90035e1$export$a2c9518710cf1f49);


"use strict";
const $c98b8711de347986$export$e8e1b4711c2d1939 = {
    en: (0, $e1c37ee3c90035e1$export$a2c9518710cf1f49)
};



const $6054160a15387c6c$export$83d89fbfd8236492 = "hdnode/5.7.0";


"use strict";
const $d830e21df8d45279$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $6054160a15387c6c$export$83d89fbfd8236492));
const $d830e21df8d45279$var$N = (0, $0df4577496dcf693$export$d97aa349ed20696).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
const $d830e21df8d45279$var$MasterSecret = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)("Bitcoin seed");
const $d830e21df8d45279$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $d830e21df8d45279$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $d830e21df8d45279$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $d830e21df8d45279$var$bytes32(value) {
    return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value), 32);
}
function $d830e21df8d45279$var$base58check(data) {
    return (0, $3fca3a6183b20b71$export$45a587635c9954b2).encode((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        data,
        (0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)(data)), 0, 4)
    ]));
}
function $d830e21df8d45279$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $c98b8711de347986$export$e8e1b4711c2d1939)["en"];
    if (typeof wordlist === "string") {
        const words = (0, $c98b8711de347986$export$e8e1b4711c2d1939)[wordlist];
        if (words == null) $d830e21df8d45279$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
const $d830e21df8d45279$var$_constructorGuard = {};
const $d830e21df8d45279$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
class $d830e21df8d45279$export$b68640c53e22b952 {
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */ constructor(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath){
        /* istanbul ignore if */ if (constructorGuard !== $d830e21df8d45279$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            const signingKey = new (0, $ff9f75f56da7c459$export$21643ca94aed3e83)(privateKey);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "privateKey", signingKey.privateKey);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "privateKey", null);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "publicKey", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(publicKey));
        }
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "parentFingerprint", parentFingerprint);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "fingerprint", (0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $bb82ee6f1acbd7c8$export$d1cea0ee4e3f0d3e)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)(this.publicKey)), 0, 4));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", (0, $0a7021bc70fec74d$export$e67e2732ba9803f9)(this.publicKey));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "chainCode", chainCode);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "index", index);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "mnemonic", null);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "mnemonic", null);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "mnemonic", mnemonicOrPath);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "path", mnemonicOrPath.path);
        }
    }
    get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        if (this.depth >= 256) throw new Error("Depth too large!");
        return $d830e21df8d45279$var$base58check((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
            (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(this.depth),
            this.parentFingerprint,
            (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(this.index), 4),
            this.chainCode,
            this.privateKey != null ? (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
                "0x00",
                this.privateKey
            ]) : this.publicKey
        ]));
    }
    neuter() {
        return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
    }
    _derive(index) {
        if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
        // Base path
        let path = this.path;
        if (path) path += "/" + (index & ~$d830e21df8d45279$var$HardenedBit);
        const data = new Uint8Array(37);
        if (index & $d830e21df8d45279$var$HardenedBit) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            // Data = 0x00 || ser_256(k_par)
            data.set((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.privateKey), 1);
            // Hardened path
            if (path) path += "'";
        } else // Data = ser_p(point(k_par))
        data.set((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(this.publicKey));
        // Data += ser_32(i)
        for(let i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
        const I = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $bb82ee6f1acbd7c8$export$967075d2f3b8e7ff)((0, $da90616c06668669$export$d2a8849cfb277c).sha512, this.chainCode, data));
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // The private key
        let ki = null;
        // The public key
        let Ki = null;
        if (this.privateKey) ki = $d830e21df8d45279$var$bytes32((0, $0df4577496dcf693$export$d97aa349ed20696).from(IL).add(this.privateKey).mod($d830e21df8d45279$var$N));
        else {
            const ek = new (0, $ff9f75f56da7c459$export$21643ca94aed3e83)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        let mnemonicOrPath = path;
        const srcMnemonic = this.mnemonic;
        if (srcMnemonic) mnemonicOrPath = Object.freeze({
            phrase: srcMnemonic.phrase,
            path: path,
            locale: srcMnemonic.locale || "en"
        });
        return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, ki, Ki, this.fingerprint, $d830e21df8d45279$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
    }
    derivePath(path) {
        const components = path.split("/");
        if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
        if (components[0] === "m") components.shift();
        let result = this;
        for(let i = 0; i < components.length; i++){
            const component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                const index = parseInt(component.substring(0, component.length - 1));
                if (index >= $d830e21df8d45279$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive($d830e21df8d45279$var$HardenedBit + index);
            } else if (component.match(/^[0-9]+$/)) {
                const index = parseInt(component);
                if (index >= $d830e21df8d45279$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive(index);
            } else throw new Error("invalid path component - " + component);
        }
        return result;
    }
    static _fromSeed(seed, mnemonic) {
        const seedArray = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(seed);
        if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
        const I = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $bb82ee6f1acbd7c8$export$967075d2f3b8e7ff)((0, $da90616c06668669$export$d2a8849cfb277c).sha512, $d830e21df8d45279$var$MasterSecret, seedArray));
        return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, $d830e21df8d45279$var$bytes32(I.slice(0, 32)), null, "0x00000000", $d830e21df8d45279$var$bytes32(I.slice(32)), 0, 0, mnemonic);
    }
    static fromMnemonic(mnemonic, password, wordlist) {
        // If a locale name was passed in, find the associated wordlist
        wordlist = $d830e21df8d45279$var$getWordlist(wordlist);
        // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
        mnemonic = $d830e21df8d45279$export$4becd65eb23312e6($d830e21df8d45279$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
        return $d830e21df8d45279$export$b68640c53e22b952._fromSeed($d830e21df8d45279$export$3dee74f1204ab09f(mnemonic, password), {
            phrase: mnemonic,
            path: "m",
            locale: wordlist.locale
        });
    }
    static fromSeed(seed) {
        return $d830e21df8d45279$export$b68640c53e22b952._fromSeed(seed, null);
    }
    static fromExtendedKey(extendedKey) {
        const bytes = (0, $3fca3a6183b20b71$export$45a587635c9954b2).decode(extendedKey);
        if (bytes.length !== 82 || $d830e21df8d45279$var$base58check(bytes.slice(0, 78)) !== extendedKey) $d830e21df8d45279$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
        const depth = bytes[4];
        const parentFingerprint = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(5, 9));
        const index = parseInt((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes.slice(0, 4))){
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, null, (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(key), parentFingerprint, chainCode, index, depth, null);
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) break;
                return new $d830e21df8d45279$export$b68640c53e22b952($d830e21df8d45279$var$_constructorGuard, (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
        }
        return $d830e21df8d45279$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    }
}
function $d830e21df8d45279$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    const salt = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)("mnemonic" + password, (0, $b2a54ce293d87a2e$export$c6986442964129f5).NFKD);
    return (0, $52d8b575085ace3c$export$448fa22aedc9dbca)((0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(mnemonic, (0, $b2a54ce293d87a2e$export$c6986442964129f5).NFKD), salt, 2048, 64, "sha512");
}
function $d830e21df8d45279$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $d830e21df8d45279$var$getWordlist(wordlist);
    $d830e21df8d45279$var$logger.checkNormalize();
    const words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    const entropy = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    let offset = 0;
    for(let i = 0; i < words.length; i++){
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(let bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = $d830e21df8d45279$var$getUpperMask(checksumBits);
    const checksum = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(entropy.slice(0, entropyBits / 8));
}
function $d830e21df8d45279$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $d830e21df8d45279$var$getWordlist(wordlist);
    entropy = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    const indices = [
        0
    ];
    let remainingBits = 11;
    for(let i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $d830e21df8d45279$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)(entropy))[0] & $d830e21df8d45279$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map((index)=>wordlist.getWord(index)));
}
function $d830e21df8d45279$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $d830e21df8d45279$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $d830e21df8d45279$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $d830e21df8d45279$var$HardenedBit || index % 1) $d830e21df8d45279$var$logger.throwArgumentError("invalid account index", "index", index);
    return `m/44'/60'/${index}'/0/0`;
}






const $d4cbf396701ae91f$export$83d89fbfd8236492 = "random/5.7.0";


"use strict";
const $d0ff10d17aa2d59e$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $d4cbf396701ae91f$export$83d89fbfd8236492));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $d0ff10d17aa2d59e$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $d0ff10d17aa2d59e$var$anyGlobal = $d0ff10d17aa2d59e$var$getGlobal();
let $d0ff10d17aa2d59e$var$crypto = $d0ff10d17aa2d59e$var$anyGlobal.crypto || $d0ff10d17aa2d59e$var$anyGlobal.msCrypto;
if (!$d0ff10d17aa2d59e$var$crypto || !$d0ff10d17aa2d59e$var$crypto.getRandomValues) {
    $d0ff10d17aa2d59e$var$logger.warn("WARNING: Missing strong random number source");
    $d0ff10d17aa2d59e$var$crypto = {
        getRandomValues: function(buffer) {
            return $d0ff10d17aa2d59e$var$logger.throwError("no secure random source avaialble", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $d0ff10d17aa2d59e$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $d0ff10d17aa2d59e$var$logger.throwArgumentError("invalid length", "length", length);
    const result = new Uint8Array(length);
    $d0ff10d17aa2d59e$var$crypto.getRandomValues(result);
    return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(result);
}




var $jcj12 = parcelRequire("jcj12");

var $innAd = parcelRequire("innAd");










"use strict";
function $6180d5962b5fb34a$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(hexString);
}
function $6180d5962b5fb34a$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $6180d5962b5fb34a$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(password, (0, $b2a54ce293d87a2e$export$c6986442964129f5).NFKC);
    return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(password);
}
function $6180d5962b5fb34a$export$5a5c1dbd910e2c32(object, path) {
    let currentChild = object;
    const comps = path.toLowerCase().split("/");
    for(let i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for(const key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $6180d5962b5fb34a$export$ec7b18ebad55a3a9(randomBytes) {
    const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const value = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}



const $2b288706101a2813$export$83d89fbfd8236492 = "json-wallets/5.7.0";


"use strict";
var $1cdfca8f3ea9db41$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $1cdfca8f3ea9db41$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $2b288706101a2813$export$83d89fbfd8236492));
// Exported Types
function $1cdfca8f3ea9db41$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
class $1cdfca8f3ea9db41$export$cf9dc4fd6dde0315 extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
    isKeystoreAccount(value) {
        return !!(value && value._isKeystoreAccount);
    }
}
function $1cdfca8f3ea9db41$var$_decrypt(data, key, ciphertext) {
    const cipher = (0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        const iv = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/cipherparams/iv"));
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).ModeOfOperation.ctr(key, counter);
        return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $1cdfca8f3ea9db41$var$_getAccount(data, key) {
    const ciphertext = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/ciphertext"));
    const computedMAC = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    const privateKey = $1cdfca8f3ea9db41$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $1cdfca8f3ea9db41$var$logger.throwError("unsupported cipher", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    const mnemonicKey = key.slice(32, 64);
    const address = (0, $0a7021bc70fec74d$export$e67e2732ba9803f9)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $8aee8aee2d40605d$export$88411125f012957a)(check) !== address) throw new Error("address mismatch");
    }
    const account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "x-ethers/version") === "0.1") {
        const mnemonicCiphertext = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "x-ethers/mnemonicCiphertext"));
        const mnemonicIv = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "x-ethers/mnemonicCounter"));
        const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).Counter(mnemonicIv);
        const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        const path = (0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "x-ethers/path") || (0, $d830e21df8d45279$export$d48ad89f7e11a603);
        const locale = (0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "x-ethers/locale") || "en";
        const entropy = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            const mnemonic = (0, $d830e21df8d45279$export$4becd65eb23312e6)(entropy, locale);
            const node = (0, $d830e21df8d45279$export$b68640c53e22b952).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $1cdfca8f3ea9db41$export$cf9dc4fd6dde0315(account);
}
function $1cdfca8f3ea9db41$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $52d8b575085ace3c$export$448fa22aedc9dbca)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $1cdfca8f3ea9db41$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($1cdfca8f3ea9db41$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $1cdfca8f3ea9db41$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    const passwordBytes = (0, $6180d5962b5fb34a$export$350bd33120f7413e)(password);
    const kdf = (0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        const throwError = function(name, value) {
            return $1cdfca8f3ea9db41$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/salt"));
            const N = parseInt((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/n"));
            const r = parseInt((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/r"));
            const p = parseInt((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            const dkLen = parseInt((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/salt"));
            let prfFunc = null;
            const prf = (0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            const count = parseInt((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/c"));
            const dkLen = parseInt((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return pbkdf2Func(passwordBytes, salt, count, dkLen, prfFunc);
        }
    }
    return $1cdfca8f3ea9db41$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $1cdfca8f3ea9db41$export$9bd2c37889ee5e36(json, password) {
    const data = JSON.parse(json);
    const key = $1cdfca8f3ea9db41$var$_computeKdfKey(data, password, $1cdfca8f3ea9db41$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($innAd))).syncScrypt);
    return $1cdfca8f3ea9db41$var$_getAccount(data, key);
}
function $1cdfca8f3ea9db41$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $1cdfca8f3ea9db41$var$__awaiter(this, void 0, void 0, function*() {
        const data = JSON.parse(json);
        const key = yield $1cdfca8f3ea9db41$var$_computeKdfKey(data, password, $1cdfca8f3ea9db41$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($innAd))).scrypt, progressCallback);
        return $1cdfca8f3ea9db41$var$_getAccount(data, key);
    });
}
function $1cdfca8f3ea9db41$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $8aee8aee2d40605d$export$88411125f012957a)(account.address) !== (0, $0a7021bc70fec74d$export$e67e2732ba9803f9)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($1cdfca8f3ea9db41$var$hasMnemonic(account)) {
            const mnemonic = account.mnemonic;
            const node = (0, $d830e21df8d45279$export$b68640c53e22b952).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $d830e21df8d45279$export$d48ad89f7e11a603));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    const privateKey = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(account.privateKey);
    const passwordBytes = (0, $6180d5962b5fb34a$export$350bd33120f7413e)(password);
    let entropy = null;
    let path = null;
    let locale = null;
    if ($1cdfca8f3ea9db41$var$hasMnemonic(account)) {
        const srcMnemonic = account.mnemonic;
        entropy = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $d830e21df8d45279$export$135e090d58b310ca)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $d830e21df8d45279$export$d48ad89f7e11a603);
        locale = srcMnemonic.locale || "en";
    }
    let client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    let salt = null;
    if (options.salt) salt = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(options.salt);
    else salt = (0, $d0ff10d17aa2d59e$export$5f828d93ff035aa8)(32);
    // Override initialization vector
    let iv = null;
    if (options.iv) {
        iv = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $d0ff10d17aa2d59e$export$5f828d93ff035aa8)(16);
    // Override the uuid
    let uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $d0ff10d17aa2d59e$export$5f828d93ff035aa8)(16);
    // Override the scrypt password-based key derivation function parameters
    let N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($innAd))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then((key)=>{
        key = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        const derivedKey = key.slice(0, 16);
        const macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        const mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).ModeOfOperation.ctr(derivedKey, counter);
        const ciphertext = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        const mac = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        const data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $6180d5962b5fb34a$export$ec7b18ebad55a3a9)(uuidRandom),
            version: 3,
            crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(iv).substring(2)
                },
                ciphertext: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            const mnemonicIv = (0, $d0ff10d17aa2d59e$export$5f828d93ff035aa8)(16);
            const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).Counter(mnemonicIv);
            const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            const mnemonicCiphertext = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(mnemonicAesCtr.encrypt(entropy));
            const now = new Date();
            const timestamp = now.getUTCFullYear() + "-" + (0, $6180d5962b5fb34a$export$67752b99d3bc61c6)(now.getUTCMonth() + 1, 2) + "-" + (0, $6180d5962b5fb34a$export$67752b99d3bc61c6)(now.getUTCDate(), 2) + "T" + (0, $6180d5962b5fb34a$export$67752b99d3bc61c6)(now.getUTCHours(), 2) + "-" + (0, $6180d5962b5fb34a$export$67752b99d3bc61c6)(now.getUTCMinutes(), 2) + "-" + (0, $6180d5962b5fb34a$export$67752b99d3bc61c6)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}


var $jcj12 = parcelRequire("jcj12");









"use strict";
const $be21d7d825475473$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $2b288706101a2813$export$83d89fbfd8236492));
class $be21d7d825475473$export$93a76d16f88f2b3 extends (0, $a463a6b5f08d6875$export$393edc798c47379d) {
    isCrowdsaleAccount(value) {
        return !!(value && value._isCrowdsaleAccount);
    }
}
function $be21d7d825475473$export$e85a0c9a1067c5d3(json, password) {
    const data = JSON.parse(json);
    password = (0, $6180d5962b5fb34a$export$350bd33120f7413e)(password);
    // Ethereum Address
    const ethaddr = (0, $8aee8aee2d40605d$export$88411125f012957a)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "ethaddr"));
    // Encrypted Seed
    const encseed = (0, $6180d5962b5fb34a$export$2cde08bde0cfd932)((0, $6180d5962b5fb34a$export$5a5c1dbd910e2c32)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $be21d7d825475473$var$logger.throwArgumentError("invalid encseed", "json", json);
    const key = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $52d8b575085ace3c$export$448fa22aedc9dbca)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).ModeOfOperation.cbc(key, iv);
    const seed = (0, (/*@__PURE__*/$parcel$interopDefault($jcj12))).padding.pkcs7.strip((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for(let i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    const seedHexBytes = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(seedHex);
    const privateKey = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(seedHexBytes);
    return new $be21d7d825475473$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}



"use strict";
function $e21ba517a486d299$export$724d6cf6b9fd8578(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $e21ba517a486d299$export$67dc926b8e68b2d8(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $e21ba517a486d299$export$9a68ee9f8f3afd38(json) {
    if ($e21ba517a486d299$export$724d6cf6b9fd8578(json)) try {
        return (0, $8aee8aee2d40605d$export$88411125f012957a)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($e21ba517a486d299$export$67dc926b8e68b2d8(json)) try {
        return (0, $8aee8aee2d40605d$export$88411125f012957a)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}



"use strict";
function $ca5238b7fb30f36a$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $e21ba517a486d299$export$724d6cf6b9fd8578)(json)) {
        if (progressCallback) progressCallback(0);
        const account = (0, $be21d7d825475473$export$e85a0c9a1067c5d3)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $e21ba517a486d299$export$67dc926b8e68b2d8)(json)) return (0, $1cdfca8f3ea9db41$export$e85a0c9a1067c5d3)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $ca5238b7fb30f36a$export$7a81c437a678891a(json, password) {
    if ((0, $e21ba517a486d299$export$724d6cf6b9fd8578)(json)) return (0, $be21d7d825475473$export$e85a0c9a1067c5d3)(json, password);
    if ((0, $e21ba517a486d299$export$67dc926b8e68b2d8)(json)) return (0, $1cdfca8f3ea9db41$export$9bd2c37889ee5e36)(json, password);
    throw new Error("invalid JSON wallet");
}




const $e08684831330b7d7$export$83d89fbfd8236492 = "wallet/5.7.0";


"use strict";
var $3ff70163f9f2ebd5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $3ff70163f9f2ebd5$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $e08684831330b7d7$export$83d89fbfd8236492));
function $3ff70163f9f2ebd5$var$isAccount(value) {
    return value != null && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value.privateKey, 32) && value.address != null;
}
function $3ff70163f9f2ebd5$var$hasMnemonic(value) {
    const mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
class $3ff70163f9f2ebd5$export$bcca3ea514774656 extends (0, $deb85df20e19ba32$export$fdf54fdde81cc9f0) {
    constructor(privateKey, provider){
        super();
        if ($3ff70163f9f2ebd5$var$isAccount(privateKey)) {
            const signingKey = new (0, $ff9f75f56da7c459$export$21643ca94aed3e83)(privateKey.privateKey);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_signingKey", ()=>signingKey);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", (0, $0a7021bc70fec74d$export$e67e2732ba9803f9)(this.publicKey));
            if (this.address !== (0, $8aee8aee2d40605d$export$88411125f012957a)(privateKey.address)) $3ff70163f9f2ebd5$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($3ff70163f9f2ebd5$var$hasMnemonic(privateKey)) {
                const srcMnemonic = privateKey.mnemonic;
                (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_mnemonic", ()=>({
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $d830e21df8d45279$export$d48ad89f7e11a603),
                        locale: srcMnemonic.locale || "en"
                    }));
                const mnemonic = this.mnemonic;
                const node = (0, $d830e21df8d45279$export$b68640c53e22b952).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $0a7021bc70fec74d$export$e67e2732ba9803f9)(node.privateKey) !== this.address) $3ff70163f9f2ebd5$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_mnemonic", ()=>null);
        } else {
            if ((0, $ff9f75f56da7c459$export$21643ca94aed3e83).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $3ff70163f9f2ebd5$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_signingKey", ()=>privateKey);
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                const signingKey = new (0, $ff9f75f56da7c459$export$21643ca94aed3e83)(privateKey);
                (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_signingKey", ()=>signingKey);
            }
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_mnemonic", ()=>null);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", (0, $0a7021bc70fec74d$export$e67e2732ba9803f9)(this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $81658ac0a17fba50$export$2881499e37b75b9a).isProvider(provider)) $3ff70163f9f2ebd5$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", provider || null);
    }
    get mnemonic() {
        return this._mnemonic();
    }
    get privateKey() {
        return this._signingKey().privateKey;
    }
    get publicKey() {
        return this._signingKey().publicKey;
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    connect(provider) {
        return new $3ff70163f9f2ebd5$export$bcca3ea514774656(this, provider);
    }
    signTransaction(transaction) {
        return (0, $a463a6b5f08d6875$export$d503dd157d963b60)(transaction).then((tx)=>{
            if (tx.from != null) {
                if ((0, $8aee8aee2d40605d$export$88411125f012957a)(tx.from) !== this.address) $3ff70163f9f2ebd5$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                delete tx.from;
            }
            const signature = this._signingKey().signDigest((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $0a7021bc70fec74d$export$dfdc1655ccc5b9cb)(tx)));
            return (0, $0a7021bc70fec74d$export$dfdc1655ccc5b9cb)(tx, signature);
        });
    }
    signMessage(message) {
        return $3ff70163f9f2ebd5$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $7b88b6e03e4708f2$export$71bb9d78a59bbe25)(this._signingKey().signDigest((0, $d83cea76876f8e45$export$d4c241cec96564c1)(message)));
        });
    }
    _signTypedData(domain, types, value) {
        return $3ff70163f9f2ebd5$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names
            const populated = yield (0, $74ec091a01b8d3e1$export$458ab927ae635c3).resolveNames(domain, types, value, (name)=>{
                if (this.provider == null) $3ff70163f9f2ebd5$var$logger.throwError("cannot resolve ENS names without a provider", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "resolveName",
                    value: name
                });
                return this.provider.resolveName(name);
            });
            return (0, $7b88b6e03e4708f2$export$71bb9d78a59bbe25)(this._signingKey().signDigest((0, $74ec091a01b8d3e1$export$458ab927ae635c3).hash(populated.domain, types, populated.value)));
        });
    }
    encrypt(password, options, progressCallback) {
        if (typeof options === "function" && !progressCallback) {
            progressCallback = options;
            options = {};
        }
        if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
        if (!options) options = {};
        return (0, $1cdfca8f3ea9db41$export$5b0f6292f11d1d18)(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */ static createRandom(options) {
        let entropy = (0, $d0ff10d17aa2d59e$export$5f828d93ff035aa8)(16);
        if (!options) options = {};
        if (options.extraEntropy) entropy = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
            entropy,
            options.extraEntropy
        ])), 0, 16));
        const mnemonic = (0, $d830e21df8d45279$export$4becd65eb23312e6)(entropy, options.locale);
        return $3ff70163f9f2ebd5$export$bcca3ea514774656.fromMnemonic(mnemonic, options.path, options.locale);
    }
    static fromEncryptedJson(json, password, progressCallback) {
        return (0, $ca5238b7fb30f36a$export$e74fcde37488267a)(json, password, progressCallback).then((account)=>{
            return new $3ff70163f9f2ebd5$export$bcca3ea514774656(account);
        });
    }
    static fromEncryptedJsonSync(json, password) {
        return new $3ff70163f9f2ebd5$export$bcca3ea514774656((0, $ca5238b7fb30f36a$export$7a81c437a678891a)(json, password));
    }
    static fromMnemonic(mnemonic, path, wordlist) {
        if (!path) path = (0, $d830e21df8d45279$export$d48ad89f7e11a603);
        return new $3ff70163f9f2ebd5$export$bcca3ea514774656((0, $d830e21df8d45279$export$b68640c53e22b952).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
}
function $3ff70163f9f2ebd5$export$228d0e772cc158cb(message, signature) {
    return (0, $0a7021bc70fec74d$export$23cc18f96d8510e2)((0, $d83cea76876f8e45$export$d4c241cec96564c1)(message), signature);
}
function $3ff70163f9f2ebd5$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $0a7021bc70fec74d$export$23cc18f96d8510e2)((0, $74ec091a01b8d3e1$export$458ab927ae635c3).hash(domain, types, value), signature);
}


var $4c29a01839587aec$exports = {};

$parcel$export($4c29a01839587aec$exports, "AddressZero", () => $22c6f0407e5356d6$export$badd13187c087617);
$parcel$export($4c29a01839587aec$exports, "NegativeOne", () => $c5333cf79421e056$export$c83ef0909a6ddeec);
$parcel$export($4c29a01839587aec$exports, "Zero", () => $c5333cf79421e056$export$aaef8a3eae948f03);
$parcel$export($4c29a01839587aec$exports, "One", () => $c5333cf79421e056$export$9aa05a5866350bcf);
$parcel$export($4c29a01839587aec$exports, "Two", () => $c5333cf79421e056$export$9276dd97bf62cc8d);
$parcel$export($4c29a01839587aec$exports, "WeiPerEther", () => $c5333cf79421e056$export$c8db55bd7405209e);
$parcel$export($4c29a01839587aec$exports, "MaxUint256", () => $c5333cf79421e056$export$1b53890de5aabdd0);
$parcel$export($4c29a01839587aec$exports, "MinInt256", () => $c5333cf79421e056$export$963c9b9317b80aaf);
$parcel$export($4c29a01839587aec$exports, "MaxInt256", () => $c5333cf79421e056$export$6f8dbb07ebe6d738);
$parcel$export($4c29a01839587aec$exports, "HashZero", () => $9b26373cc461c855$export$71c2e4e213dcb7f2);
$parcel$export($4c29a01839587aec$exports, "EtherSymbol", () => $deb5368d1753dad5$export$c7e79fcb6f8ac048);
const $22c6f0407e5356d6$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";



const $9b26373cc461c855$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";


// NFKC (composed)             // (decomposed)
const $deb5368d1753dad5$export$c7e79fcb6f8ac048 = "\u039E"; // "\uD835\uDF63";


"use strict";


var $859153647bbc688f$exports = {};

$parcel$export($859153647bbc688f$exports, "getDefaultProvider", () => $859153647bbc688f$export$4f77a1d3c1ac6642);
$parcel$export($859153647bbc688f$exports, "Provider", () => $81658ac0a17fba50$export$2881499e37b75b9a);
$parcel$export($859153647bbc688f$exports, "BaseProvider", () => $43e733c7f2a529c1$export$ff3f6dd83125ac45);
$parcel$export($859153647bbc688f$exports, "Resolver", () => $43e733c7f2a529c1$export$8b4c839865b08288);
$parcel$export($859153647bbc688f$exports, "UrlJsonRpcProvider", () => $8044ebfe209f61e4$export$664128d6239ccf96);
$parcel$export($859153647bbc688f$exports, "FallbackProvider", () => $14eaab77c6d2e466$export$cb1d0beacb55feb7);
$parcel$export($859153647bbc688f$exports, "AlchemyProvider", () => $e94c62bb842b5925$export$999cc40da3fbc6f);
$parcel$export($859153647bbc688f$exports, "AlchemyWebSocketProvider", () => $e94c62bb842b5925$export$f6c13301c7b76371);
$parcel$export($859153647bbc688f$exports, "AnkrProvider", () => $efd7dc521b26566c$export$72783b2aefa72a45);
$parcel$export($859153647bbc688f$exports, "CloudflareProvider", () => $cdd214e3d1599302$export$7113381f8f264fc0);
$parcel$export($859153647bbc688f$exports, "EtherscanProvider", () => $d7687248e25a81ef$export$dd1d942a536c7912);
$parcel$export($859153647bbc688f$exports, "InfuraProvider", () => $1be1b51d2ba5e5c5$export$60ff1a559b5c6ebd);
$parcel$export($859153647bbc688f$exports, "InfuraWebSocketProvider", () => $1be1b51d2ba5e5c5$export$dd168a807d60da4f);
$parcel$export($859153647bbc688f$exports, "JsonRpcProvider", () => $e32f9441afb0a406$export$da28308012bf6748);
$parcel$export($859153647bbc688f$exports, "JsonRpcBatchProvider", () => $a926fa2c67f65d9a$export$5a16092bf20edf97);
$parcel$export($859153647bbc688f$exports, "NodesmithProvider", () => $dcb00489ffa41a84$export$8235cbce3ce273bd);
$parcel$export($859153647bbc688f$exports, "PocketProvider", () => $fbe10c5df3b2b203$export$58bb47e42f6b092e);
$parcel$export($859153647bbc688f$exports, "StaticJsonRpcProvider", () => $8044ebfe209f61e4$export$b3d647c1c29df44d);
$parcel$export($859153647bbc688f$exports, "Web3Provider", () => $c7f9e560d629e6df$export$d05096c9fd9d936d);
$parcel$export($859153647bbc688f$exports, "WebSocketProvider", () => $f2ba8b3ea7dcf3ca$export$bfafe629242f30bd);
$parcel$export($859153647bbc688f$exports, "IpcProvider", () => $9b4b4c9da3406148$export$fbe151f90a1ece01);
$parcel$export($859153647bbc688f$exports, "JsonRpcSigner", () => $e32f9441afb0a406$export$5f7b5fca3508545a);
$parcel$export($859153647bbc688f$exports, "getNetwork", () => $17c84d4c9be9446e$export$7de4970ebfd8206d);
$parcel$export($859153647bbc688f$exports, "isCommunityResource", () => $dc6c759982861e14$export$d93d5f61c2498b6);
$parcel$export($859153647bbc688f$exports, "isCommunityResourcable", () => $dc6c759982861e14$export$3091239f5b20b896);
$parcel$export($859153647bbc688f$exports, "showThrottleMessage", () => $dc6c759982861e14$export$4c41bd49e82e82ab);
$parcel$export($859153647bbc688f$exports, "Formatter", () => $dc6c759982861e14$export$a06636add2a09fd8);


const $5f8483051c1cd7c9$export$83d89fbfd8236492 = "networks/5.7.1";


"use strict";
const $17c84d4c9be9446e$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $5f8483051c1cd7c9$export$83d89fbfd8236492));
function $17c84d4c9be9446e$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $17c84d4c9be9446e$var$ethDefaultProvider(network) {
    const func = function(providers, options) {
        if (options == null) options = {};
        const providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider && options.etherscan !== "-") try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider && options.alchemy !== "-") try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = [
                "goerli",
                "ropsten",
                "rinkeby",
                "sepolia"
            ];
            try {
                const provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providers.AnkrProvider && options.ankr !== "-") try {
            const skip = [
                "ropsten"
            ];
            const provider = new providers.AnkrProvider(network, options.ankr);
            if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $17c84d4c9be9446e$var$ethDefaultProvider(network);
    };
    return func;
}
function $17c84d4c9be9446e$var$etcDefaultProvider(url, network) {
    const func = function(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $17c84d4c9be9446e$var$etcDefaultProvider(url, network);
    };
    return func;
}
const $17c84d4c9be9446e$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("homestead")
};
const $17c84d4c9be9446e$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("ropsten")
};
const $17c84d4c9be9446e$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $17c84d4c9be9446e$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const $17c84d4c9be9446e$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $17c84d4c9be9446e$var$homestead,
    mainnet: $17c84d4c9be9446e$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $17c84d4c9be9446e$var$ropsten,
    testnet: $17c84d4c9be9446e$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("goerli")
    },
    kintsugi: {
        chainId: 1337702,
        name: "kintsugi"
    },
    sepolia: {
        chainId: 11155111,
        name: "sepolia",
        _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("sepolia")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $17c84d4c9be9446e$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $17c84d4c9be9446e$var$classicMordor,
    classicTestnet: $17c84d4c9be9446e$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $17c84d4c9be9446e$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("matic")
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: $17c84d4c9be9446e$var$ethDefaultProvider("optimism")
    },
    "optimism-kovan": {
        chainId: 69,
        name: "optimism-kovan"
    },
    "optimism-goerli": {
        chainId: 420,
        name: "optimism-goerli"
    },
    arbitrum: {
        chainId: 42161,
        name: "arbitrum"
    },
    "arbitrum-rinkeby": {
        chainId: 421611,
        name: "arbitrum-rinkeby"
    },
    "arbitrum-goerli": {
        chainId: 421613,
        name: "arbitrum-goerli"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $17c84d4c9be9446e$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(const name in $17c84d4c9be9446e$var$networks){
            const standard = $17c84d4c9be9446e$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        const standard = $17c84d4c9be9446e$var$networks[network];
        if (standard == null) return null;
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: standard._defaultProvider || null
        };
    }
    const standard = $17c84d4c9be9446e$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof network.chainId !== "number") $17c84d4c9be9446e$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) $17c84d4c9be9446e$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if ($17c84d4c9be9446e$var$isRenetworkable(standard._defaultProvider)) defaultProvider = standard._defaultProvider.renetwork(network);
        else defaultProvider = standard._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: network.ensAddress || standard.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}




"use strict";
function $1d2ab8f2156e640e$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    const data = [];
    for(let i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
}
function $1d2ab8f2156e640e$export$c564cdbbe6da493(data) {
    data = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}











/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ // https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
function $a30010648e61cae9$var$flat(array, depth) {
    if (depth == null) depth = 1;
    const result = [];
    const forEach = result.forEach;
    const flatDeep = function(arr, depth) {
        forEach.call(arr, function(val) {
            if (depth > 0 && Array.isArray(val)) flatDeep(val, depth - 1);
            else result.push(val);
        });
    };
    flatDeep(array, depth);
    return result;
}
function $a30010648e61cae9$var$fromEntries(array) {
    const result = {};
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        result[value[0]] = value[1];
    }
    return result;
}
function $a30010648e61cae9$export$956eeed0f8f2ceff(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = Math.pow(2, N);
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
function $a30010648e61cae9$export$2cda812f22276871(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $a30010648e61cae9$export$671d8b4ebc0c42ad(bytes) {
    return $a30010648e61cae9$export$2cda812f22276871($a30010648e61cae9$export$956eeed0f8f2ceff(bytes));
}
function $a30010648e61cae9$export$a785de3a2a8dd1aa(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $a30010648e61cae9$var$read_counts(n, next) {
    let v = Array(n);
    for(let i = 0; i < n; i++)v[i] = 1 + next();
    return v;
}
function $a30010648e61cae9$var$read_ascending(n, next) {
    let v = Array(n);
    for(let i = 0, x = -1; i < n; i++)v[i] = x += 1 + next();
    return v;
}
function $a30010648e61cae9$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $a30010648e61cae9$export$a785de3a2a8dd1aa(next());
    return v;
}
function $a30010648e61cae9$export$9303bf4e1ede4914(next, lookup) {
    let v = $a30010648e61cae9$var$read_ascending(next(), next);
    let n = next();
    let vX = $a30010648e61cae9$var$read_ascending(n, next);
    let vN = $a30010648e61cae9$var$read_counts(n, next);
    for(let i = 0; i < n; i++)for(let j = 0; j < vN[i]; j++)v.push(vX[i] + j);
    return lookup ? v.map((x)=>lookup[x]) : v;
}
function $a30010648e61cae9$export$824d00fb01c38bd9(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($a30010648e61cae9$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($a30010648e61cae9$var$read_replacement_table(w, next));
    }
    return $a30010648e61cae9$var$fromEntries($a30010648e61cae9$var$flat(ret));
}
function $a30010648e61cae9$export$e9011071590ab431(next) {
    let v = [];
    while(true){
        let i = next();
        if (i == 0) break;
        v.push(i);
    }
    return v;
}
function $a30010648e61cae9$var$read_transposed(n, w, next) {
    let m = Array(n).fill(undefined).map(()=>[]);
    for(let i = 0; i < w; i++)$a30010648e61cae9$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
function $a30010648e61cae9$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $a30010648e61cae9$export$e9011071590ab431(next);
    let m = $a30010648e61cae9$var$read_transposed(vN.length, 1 + w, next);
    return $a30010648e61cae9$var$flat(m.map((v, i)=>{
        const x = v[0], ys = v.slice(1);
        //let [x, ...ys] = v;
        //return Array(vN[i]).fill().map((_, j) => {
        return Array(vN[i]).fill(undefined).map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    }));
}
function $a30010648e61cae9$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $a30010648e61cae9$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $a30010648e61cae9$export$d7b24c6ce369e1b7(next) {
    let sorted = $a30010648e61cae9$export$9303bf4e1ede4914(next).sort((a, b)=>a - b);
    return read();
    function read() {
        let branches = [];
        while(true){
            let keys = $a30010648e61cae9$export$9303bf4e1ede4914(next, sorted);
            if (keys.length == 0) break;
            branches.push({
                set: new Set(keys),
                node: read()
            });
        }
        branches.sort((a, b)=>b.set.size - a.set.size); // sort by likelihood
        let temp = next();
        let valid = temp % 3;
        temp = temp / 3 | 0;
        let fe0f = !!(temp & 1);
        temp >>= 1;
        let save = temp == 1;
        let check = temp == 2;
        return {
            branches: branches,
            valid: valid,
            fe0f: fe0f,
            save: save,
            check: check
        };
    }
}


function $15597a7af7fcc2e4$export$7a171f172be0782e() {
    return (0, $a30010648e61cae9$export$671d8b4ebc0c42ad)((0, $1d2ab8f2156e640e$export$2f872c0f2117be69)("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"));
}



const $8676be15da7193bb$var$r = (0, $15597a7af7fcc2e4$export$7a171f172be0782e)();
// @TODO: This should be lazily loaded
const $8676be15da7193bb$var$VALID = new Set((0, $a30010648e61cae9$export$9303bf4e1ede4914)($8676be15da7193bb$var$r));
const $8676be15da7193bb$var$IGNORED = new Set((0, $a30010648e61cae9$export$9303bf4e1ede4914)($8676be15da7193bb$var$r));
const $8676be15da7193bb$var$MAPPED = (0, $a30010648e61cae9$export$824d00fb01c38bd9)($8676be15da7193bb$var$r);
const $8676be15da7193bb$var$EMOJI_ROOT = (0, $a30010648e61cae9$export$d7b24c6ce369e1b7)($8676be15da7193bb$var$r);
//const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
//const STOP = 0x2E;
const $8676be15da7193bb$var$HYPHEN = 0x2D;
const $8676be15da7193bb$var$UNDERSCORE = 0x5F;
function $8676be15da7193bb$var$explode_cp(name) {
    return (0, $b2a54ce293d87a2e$export$ae470a36a31b28c2)(name);
}
function $8676be15da7193bb$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != 0xFE0F);
}
function $8676be15da7193bb$export$5252e54b57fcf4fd(name) {
    for (let label of name.split(".")){
        let cps = $8676be15da7193bb$var$explode_cp(label);
        try {
            for(let i = cps.lastIndexOf($8676be15da7193bb$var$UNDERSCORE) - 1; i >= 0; i--){
                if (cps[i] !== $8676be15da7193bb$var$UNDERSCORE) throw new Error(`underscore only allowed at start`);
            }
            if (cps.length >= 4 && cps.every((cp)=>cp < 0x80) && cps[2] === $8676be15da7193bb$var$HYPHEN && cps[3] === $8676be15da7193bb$var$HYPHEN) throw new Error(`invalid label extension`);
        } catch (err) {
            throw new Error(`Invalid label "${label}": ${err.message}`);
        }
    }
    return name;
}
function $8676be15da7193bb$export$499f715881831a51(name) {
    return $8676be15da7193bb$export$5252e54b57fcf4fd($8676be15da7193bb$var$normalize(name, $8676be15da7193bb$var$filter_fe0f));
}
function $8676be15da7193bb$var$normalize(name, emoji_filter) {
    let input = $8676be15da7193bb$var$explode_cp(name).reverse(); // flip for pop
    let output = [];
    while(input.length){
        let emoji = $8676be15da7193bb$var$consume_emoji_reversed(input);
        if (emoji) {
            output.push(...emoji_filter(emoji));
            continue;
        }
        let cp = input.pop();
        if ($8676be15da7193bb$var$VALID.has(cp)) {
            output.push(cp);
            continue;
        }
        if ($8676be15da7193bb$var$IGNORED.has(cp)) continue;
        let cps = $8676be15da7193bb$var$MAPPED[cp];
        if (cps) {
            output.push(...cps);
            continue;
        }
        throw new Error(`Disallowed codepoint: 0x${cp.toString(16).toUpperCase()}`);
    }
    return $8676be15da7193bb$export$5252e54b57fcf4fd($8676be15da7193bb$var$nfc(String.fromCodePoint(...output)));
}
function $8676be15da7193bb$var$nfc(s) {
    return s.normalize("NFC");
}
function $8676be15da7193bb$var$consume_emoji_reversed(cps, eaten) {
    var _a;
    let node = $8676be15da7193bb$var$EMOJI_ROOT;
    let emoji;
    let saved;
    let stack = [];
    let pos = cps.length;
    if (eaten) eaten.length = 0; // clear input buffer (if needed)
    while(pos){
        let cp = cps[--pos];
        node = (_a = node.branches.find((x)=>x.set.has(cp))) === null || _a === void 0 ? void 0 : _a.node;
        if (!node) break;
        if (node.save) saved = cp;
        else if (node.check) {
            if (cp === saved) break;
        }
        stack.push(cp);
        if (node.fe0f) {
            stack.push(0xFE0F);
            if (pos > 0 && cps[pos - 1] == 0xFE0F) pos--; // consume optional FE0F
        }
        if (node.valid) {
            emoji = stack.slice(); // copy stack
            if (node.valid == 2) emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // copy input (if needed)
            cps.length = pos; // truncate
        }
    }
    return emoji;
}


const $62768931dfa5f58f$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $389eb7fe008974da$export$83d89fbfd8236492));
const $62768931dfa5f58f$var$Zeros = new Uint8Array(32);
$62768931dfa5f58f$var$Zeros.fill(0);
function $62768931dfa5f58f$var$checkComponent(comp) {
    if (comp.length === 0) throw new Error("invalid ENS name; empty component");
    return comp;
}
function $62768931dfa5f58f$var$ensNameSplit(name) {
    const bytes = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)((0, $8676be15da7193bb$export$499f715881831a51)(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($62768931dfa5f58f$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    if (last >= bytes.length) throw new Error("invalid ENS name; empty component");
    comps.push($62768931dfa5f58f$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $62768931dfa5f58f$export$5f232fd2f1a1e8ac(name) {
    return $62768931dfa5f58f$var$ensNameSplit(name).map((comp)=>(0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)(comp)).join(".");
}
function $62768931dfa5f58f$export$cce2300886e7ace6(name) {
    try {
        return $62768931dfa5f58f$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $62768931dfa5f58f$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $62768931dfa5f58f$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    let result = $62768931dfa5f58f$var$Zeros;
    const comps = $62768931dfa5f58f$var$ensNameSplit(name);
    while(comps.length)result = (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        result,
        (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)(comps.pop())
    ]));
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(result);
}
function $62768931dfa5f58f$export$6c0a8cdae51cb512(name) {
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)($62768931dfa5f58f$var$ensNameSplit(name).map((comp)=>{
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}











const $42333c997d417afb$export$83d89fbfd8236492 = "web/5.7.1";



"use strict";
var $6dbd18c809d22593$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $6dbd18c809d22593$export$94df0e59ebebf4a7(href, options) {
    return $6dbd18c809d22593$var$__awaiter(this, void 0, void 0, function*() {
        if (options == null) options = {};
        const request = {
            method: options.method || "GET",
            headers: options.headers || {},
            body: options.body || undefined
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        if (options.fetchOptions != null) {
            const opts = options.fetchOptions;
            if (opts.mode) request.mode = opts.mode;
            if (opts.cache) request.cache = opts.cache;
            if (opts.credentials) request.credentials = opts.credentials;
            if (opts.redirect) request.redirect = opts.redirect;
            if (opts.referrer) request.referrer = opts.referrer;
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) response.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        else response.headers.keys().forEach((key)=>{
            headers[key.toLowerCase()] = response.headers.get(key);
        });
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(new Uint8Array(body))
        };
    });
}


"use strict";
var $4d026a5befa5b358$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $4d026a5befa5b358$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $42333c997d417afb$export$83d89fbfd8236492));
function $4d026a5befa5b358$var$staller(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $4d026a5befa5b358$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $7b88b6e03e4708f2$export$9a14abb1a440cd5e)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)(value);
        } catch (error) {}
        return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value);
    }
    return value;
}
function $4d026a5befa5b358$var$unpercent(value) {
    return (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $4d026a5befa5b358$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $4d026a5befa5b358$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    const throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $4d026a5befa5b358$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET"
    };
    let allow304 = false;
    let timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $4d026a5befa5b358$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(const key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $4d026a5befa5b358$var$logger.throwError("basic authentication requires a secure https url", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $1d2ab8f2156e640e$export$c564cdbbe6da493)((0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) options.skipFetchSetup = !!connection.skipFetchSetup;
        if (connection.fetchOptions != null) options.fetchOptions = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(connection.fetchOptions);
    }
    const reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
    const dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        const response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1] || "text/plain"
            },
            body: dataMatch[2] ? (0, $1d2ab8f2156e640e$export$2f872c0f2117be69)(dataMatch[3]) : $4d026a5befa5b358$var$unpercent(dataMatch[3])
        };
        let result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $4d026a5befa5b358$var$logger.throwError("processing response error", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
            body: $4d026a5befa5b358$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key)=>{
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = function() {
        let timer = null;
        const promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                reject($4d026a5befa5b358$var$logger.makeError("timeout", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.TIMEOUT, {
                    requestBody: $4d026a5befa5b358$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        const cancel = function() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    const runningFetch = function() {
        return $4d026a5befa5b358$var$__awaiter(this, void 0, void 0, function*() {
            for(let attempt = 0; attempt < attemptLimit; attempt++){
                let response = null;
                try {
                    response = yield (0, $6dbd18c809d22593$export$94df0e59ebebf4a7)(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        } else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                                else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling 429");
                                yield $4d026a5befa5b358$var$staller(stall);
                                continue;
                            }
                        }
                    }
                } catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        $4d026a5befa5b358$var$logger.throwError("missing response", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                            requestBody: $4d026a5befa5b358$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) body = null;
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    $4d026a5befa5b358$var$logger.throwError("bad response", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: $4d026a5befa5b358$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        requestBody: $4d026a5befa5b358$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) try {
                    const result = yield processFunc(body, response);
                    runningTimeout.cancel();
                    return result;
                } catch (error) {
                    // Allow the processFunc to trigger a throttle
                    if (error.throttleRetry && attempt < attemptLimit) {
                        let tryAgain = true;
                        if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                        if (tryAgain) {
                            const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                            //console.log("Stalling callback");
                            yield $4d026a5befa5b358$var$staller(timeout);
                            continue;
                        }
                    }
                    runningTimeout.cancel();
                    $4d026a5befa5b358$var$logger.throwError("processing response error", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                        body: $4d026a5befa5b358$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        error: error,
                        requestBody: $4d026a5befa5b358$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return $4d026a5befa5b358$var$logger.throwError("failed response", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                requestBody: $4d026a5befa5b358$var$bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $4d026a5befa5b358$export$6d71b655afe1638d(connection, json, processFunc) {
    let processJsonFunc = (value, response)=>{
        let result = null;
        if (value != null) try {
            result = JSON.parse((0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)(value));
        } catch (error) {
            $4d026a5befa5b358$var$logger.throwError("invalid JSON", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(json);
        // Create a connection with the content-type set for JSON
        const updated = typeof connection === "string" ? {
            url: connection
        } : (0, $a463a6b5f08d6875$export$9c13236873b118a5)(connection);
        if (updated.headers) {
            const hasContentType = Object.keys(updated.headers).filter((k)=>k.toLowerCase() === "content-type").length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $4d026a5befa5b358$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $4d026a5befa5b358$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = ()=>{
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(()=>{
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}



var $7CtKW = parcelRequire("7CtKW");

const $fd8f67b80e142427$export$83d89fbfd8236492 = "providers/5.7.2";










"use strict";
const $dc6c759982861e14$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
class $dc6c759982861e14$export$a06636add2a09fd8 {
    constructor(){
        this.formats = this.getDefaultFormats();
    }
    getDefaultFormats() {
        const formats = {};
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v)=>{
            return this.data(v, true);
        };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null),
            blockHash: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hash, null),
            blockNumber: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number, null),
            transactionIndex: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number, null),
            confirmations: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.uint256),
            s: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.uint256),
            v: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            creates: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address, null),
            raw: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(data)
        };
        formats.transactionRequest = {
            from: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address),
            nonce: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            gasLimit: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            gasPrice: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            to: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address),
            value: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            data: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(strictData),
            type: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            accessList: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null)
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: $dc6c759982861e14$export$a06636add2a09fd8.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash
        };
        formats.receipt = {
            to: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.address, null),
            from: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.address, null),
            contractAddress: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: $dc6c759982861e14$export$a06636add2a09fd8.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber),
            status: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            type: type
        };
        formats.block = {
            hash: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hash),
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address),
            extraData: data,
            transactions: $dc6c759982861e14$export$a06636add2a09fd8.allowNull($dc6c759982861e14$export$a06636add2a09fd8.arrayOf(hash)),
            baseFeePerGas: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(bigNumber)
        };
        formats.blockWithTransactions = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(formats.block);
        formats.blockWithTransactions.transactions = $dc6c759982861e14$export$a06636add2a09fd8.allowNull($dc6c759982861e14$export$a06636add2a09fd8.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            toBlock: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            blockHash: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hash, undefined),
            address: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(address, undefined),
            topics: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.topics.bind(this), undefined)
        };
        formats.filterLog = {
            blockNumber: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(number),
            blockHash: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(hash),
            transactionIndex: number,
            removed: $dc6c759982861e14$export$a06636add2a09fd8.allowNull(this.boolean.bind(this)),
            address: address,
            data: $dc6c759982861e14$export$a06636add2a09fd8.allowFalsish(data, "0x"),
            topics: $dc6c759982861e14$export$a06636add2a09fd8.arrayOf(hash),
            transactionHash: hash,
            logIndex: number
        };
        return formats;
    }
    accessList(accessList) {
        return (0, $0a7021bc70fec74d$export$6c8662b1600dce2)(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") return 0;
        return (0, $0df4577496dcf693$export$d97aa349ed20696).from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) return 0;
        return (0, $0df4577496dcf693$export$d97aa349ed20696).from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") {
            value = value.toLowerCase();
            if (value === "true") return true;
            if (value === "false") return false;
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof value === "string") {
            if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
            if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value)) return value.toLowerCase();
        }
        return $dc6c759982861e14$var$logger.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return (0, $8aee8aee2d40605d$export$88411125f012957a)(value);
    }
    callAddress(value) {
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value, 32)) return null;
        const address = (0, $8aee8aee2d40605d$export$88411125f012957a)((0, $7b88b6e03e4708f2$export$15da666eba198c18)(value, 12));
        return address === (0, $22c6f0407e5356d6$export$badd13187c087617) ? null : address;
    }
    contractAddress(value) {
        return (0, $8aee8aee2d40605d$export$b7fbffef12272e40)(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) return "latest";
        if (blockTag === "earliest") return "0x0";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "latest":
            case "pending":
            case "safe":
            case "finalized":
                return blockTag;
        }
        if (typeof blockTag === "number" || (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(blockTag)) return (0, $7b88b6e03e4708f2$export$6916af760a341dd3)(blockTag);
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(result) !== 32) return $dc6c759982861e14$var$logger.throwArgumentError("invalid hash", "value", value);
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) return null;
        const v = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value);
        try {
            return v.toNumber();
        } catch (error) {}
        return null;
    }
    uint256(value) {
        if (!(0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value)) throw new Error("invalid uint256");
        return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) value.miner = value.author;
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
        const result = $dc6c759982861e14$export$a06636add2a09fd8.check(format, value);
        result._difficulty = difficulty == null ? null : (0, $0df4577496dcf693$export$d97aa349ed20696).from(difficulty);
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && (0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
        // Rename input to data
        if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
        const result = $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(chainId)) chainId = (0, $0df4577496dcf693$export$d97aa349ed20696).from(chainId).toNumber();
            result.chainId = chainId;
        } else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) chainId = transaction.chainId;
            if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(chainId)) chainId = (0, $0df4577496dcf693$export$d97aa349ed20696).from(chainId).toNumber();
            if (typeof chainId !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) chainId = 0;
                chainId = parseInt(chainId);
            }
            if (typeof chainId !== "number") chainId = 0;
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
        return result;
    }
    transaction(value) {
        return (0, $0a7021bc70fec74d$export$98e6a39c04603d36)(value);
    }
    receiptLog(value) {
        return $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = (0, $0df4577496dcf693$export$d97aa349ed20696).from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && result.status !== value) $dc6c759982861e14$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                        root: result.root,
                        status: result.status
                    });
                    result.status = value;
                    delete result.root;
                } else $dc6c759982861e14$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
            } else if (result.root.length !== 66) // Must be a valid bytes32
            $dc6c759982861e14$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
        }
        if (result.status != null) result.byzantium = true;
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) return value.map((v)=>this.topics(v));
        else if (value != null) return this.hash(value, true);
        return null;
    }
    filter(value) {
        return $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.filter, value);
    }
    filterLog(value) {
        return $dc6c759982861e14$export$a06636add2a09fd8.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for(const key in format)try {
            const value = format[key](object[key]);
            if (value !== undefined) result[key] = value;
        } catch (error) {
            error.checkKey = key;
            error.checkValue = object[key];
            throw error;
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return function(value) {
            if (value == null) return nullValue;
            return format(value);
        };
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return function(value) {
            if (!value) return replaceValue;
            return format(value);
        };
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return function(array) {
            if (!Array.isArray(array)) throw new Error("not an array");
            const result = [];
            array.forEach(function(value) {
                result.push(format(value));
            });
            return result;
        };
    }
}
function $dc6c759982861e14$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $dc6c759982861e14$export$d93d5f61c2498b6(value) {
    return $dc6c759982861e14$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
let $dc6c759982861e14$var$throttleMessage = false;
function $dc6c759982861e14$export$4c41bd49e82e82ab() {
    if ($dc6c759982861e14$var$throttleMessage) return;
    $dc6c759982861e14$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}


"use strict";
var $43e733c7f2a529c1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $43e733c7f2a529c1$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
const $43e733c7f2a529c1$var$MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function $43e733c7f2a529c1$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(topic) !== 32) $43e733c7f2a529c1$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $43e733c7f2a529c1$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map((topic)=>{
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic)=>{
                unique[$43e733c7f2a529c1$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $43e733c7f2a529c1$var$checkTopic(topic);
    }).join("&");
}
function $43e733c7f2a529c1$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map((topic)=>{
        if (topic === "") return [];
        const comps = topic.split("|").map((topic)=>{
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $43e733c7f2a529c1$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $7b88b6e03e4708f2$export$13882f896d3c0683)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $43e733c7f2a529c1$var$serializeTopics(eventName);
    else if ((0, $81658ac0a17fba50$export$406ece1549ccd00e).isForkEvent(eventName)) {
        $43e733c7f2a529c1$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $43e733c7f2a529c1$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $43e733c7f2a529c1$var$getTime() {
    return new Date().getTime();
}
function $43e733c7f2a529c1$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ const $43e733c7f2a529c1$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
class $43e733c7f2a529c1$export$d61e24a684f9e51 {
    constructor(tag, listener, once){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "tag", tag);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "listener", listener);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    get event() {
        switch(this.type){
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") return null;
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") return null;
        const address = comps[1];
        const topics = $43e733c7f2a529c1$var$deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) filter.topics = topics;
        if (address && address !== "*") filter.address = address;
        return filter;
    }
    pollable() {
        return this.tag.indexOf(":") >= 0 || $43e733c7f2a529c1$var$PollableEvents.indexOf(this.tag) >= 0;
    }
}
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const $43e733c7f2a529c1$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $43e733c7f2a529c1$var$bytes32ify(value) {
    return (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)((0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $43e733c7f2a529c1$var$base58Encode(data) {
    return (0, $3fca3a6183b20b71$export$45a587635c9954b2).encode((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        data,
        (0, $7b88b6e03e4708f2$export$15da666eba198c18)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)((0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)(data)), 0, 4)
    ]));
}
const $43e733c7f2a529c1$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $43e733c7f2a529c1$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $43e733c7f2a529c1$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $43e733c7f2a529c1$var$_parseString(result, start) {
    try {
        return (0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)($43e733c7f2a529c1$var$_parseBytes(result, start));
    } catch (error) {}
    return null;
}
function $43e733c7f2a529c1$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    const offset = (0, $0df4577496dcf693$export$d97aa349ed20696).from((0, $7b88b6e03e4708f2$export$15da666eba198c18)(result, start, start + 32)).toNumber();
    const length = (0, $0df4577496dcf693$export$d97aa349ed20696).from((0, $7b88b6e03e4708f2$export$15da666eba198c18)(result, offset, offset + 32)).toNumber();
    return (0, $7b88b6e03e4708f2$export$15da666eba198c18)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function $43e733c7f2a529c1$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else $43e733c7f2a529c1$var$logger.throwArgumentError("unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
function $43e733c7f2a529c1$var$numPad(value) {
    const result = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $43e733c7f2a529c1$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function $43e733c7f2a529c1$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push(null);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(datas[i]);
        // Update the bytes offset
        result[i] = $43e733c7f2a529c1$var$numPad(byteCount);
        // The length and padded value of data
        result.push($43e733c7f2a529c1$var$numPad(data.length));
        result.push($43e733c7f2a529c1$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)(result);
}
class $43e733c7f2a529c1$export$8b4c839865b08288 {
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress){
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", provider);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "name", name);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "address", provider.formatter.address(address));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_resolvedAddress", resolvedAddress);
    }
    supportsWildcard() {
        if (!this._supportsEip2544) // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
        this._supportsEip2544 = this.provider.call({
            to: this.address,
            data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
        }).then((result)=>{
            return (0, $0df4577496dcf693$export$d97aa349ed20696).from(result).eq(1);
        }).catch((error)=>{
            if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION) return false;
            // Rethrow the error: link is down, etc. Let future attempts retry.
            this._supportsEip2544 = null;
            throw error;
        });
        return this._supportsEip2544;
    }
    _fetch(selector, parameters) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                ccipReadEnabled: true,
                data: (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
                    selector,
                    (0, $62768931dfa5f58f$export$91d651ee363e1209)(this.name),
                    parameters || "0x"
                ])
            };
            // Wildcard support; use EIP-2544 to resolve the request
            let parseBytes = false;
            if (yield this.supportsWildcard()) {
                parseBytes = true;
                // selector("resolve(bytes,bytes)")
                tx.data = (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
                    "0x9061b923",
                    $43e733c7f2a529c1$var$encodeBytes([
                        (0, $62768931dfa5f58f$export$6c0a8cdae51cb512)(this.name),
                        tx.data
                    ])
                ]);
            }
            try {
                let result = yield this.provider.call(tx);
                if ((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(result).length % 32 === 4) $43e733c7f2a529c1$var$logger.throwError("resolver threw error", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    transaction: tx,
                    data: result
                });
                if (parseBytes) result = $43e733c7f2a529c1$var$_parseBytes(result, 0);
                return result;
            } catch (error) {
                if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION) return null;
                throw error;
            }
        });
    }
    _fetchBytes(selector, parameters) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._fetch(selector, parameters);
            if (result != null) return $43e733c7f2a529c1$var$_parseBytes(result, 0);
            return null;
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = $43e733c7f2a529c1$var$coinInfos[String(coinType)];
        if (coinInfo == null) $43e733c7f2a529c1$var$logger.throwError(`unsupported coin type: ${coinType}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: `getAddress(${coinType})`
        });
        if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
        const bytes = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $43e733c7f2a529c1$var$base58Encode((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
                    [
                        coinInfo.p2pkh
                    ],
                    "0x" + p2pkh[2]
                ]));
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) return $43e733c7f2a529c1$var$base58Encode((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
                    [
                        coinInfo.p2sh
                    ],
                    "0x" + p2sh[2]
                ]));
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) version = -1;
            } else version = -1;
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = (0, (/*@__PURE__*/$parcel$interopDefault($7CtKW))).toWords(bytes.slice(2));
                words.unshift(version);
                return (0, (/*@__PURE__*/$parcel$interopDefault($7CtKW))).encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (coinType == null) coinType = 60;
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) try {
                // keccak256("addr(bytes32)")
                const result = yield this._fetch("0x3b3b57de");
                // No address
                if (result === "0x" || result === (0, $9b26373cc461c855$export$71c2e4e213dcb7f2)) return null;
                return this.provider.formatter.callAddress(result);
            } catch (error) {
                if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION) return null;
                throw error;
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", $43e733c7f2a529c1$var$bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") return null;
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) $43e733c7f2a529c1$var$logger.throwError(`invalid or unsupported coin data`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`,
                coinType: coinType,
                data: hexBytes
            });
            return address;
        });
    }
    getAvatar() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const linkage = [
                {
                    type: "name",
                    content: this.name
                }
            ];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) return null;
                for(let i = 0; i < $43e733c7f2a529c1$var$matchers.length; i++){
                    const match = avatar.match($43e733c7f2a529c1$var$matchers[i]);
                    if (match == null) continue;
                    const scheme = match[1].toLowerCase();
                    switch(scheme){
                        case "https":
                            linkage.push({
                                type: "url",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "data":
                            linkage.push({
                                type: "data",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "ipfs":
                            linkage.push({
                                type: "ipfs",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: $43e733c7f2a529c1$var$getIpfsLink(avatar)
                            };
                        case "erc721":
                        case "erc1155":
                            {
                                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                                const selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: scheme,
                                    content: avatar
                                });
                                // The owner of this name
                                const owner = this._resolvedAddress || (yield this.getAddress());
                                const comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return null;
                                const addr = yield this.provider.formatter.address(comps[0]);
                                const tokenId = (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)((0, $0df4577496dcf693$export$d97aa349ed20696).from(comps[1]).toHexString(), 32);
                                // Check that this account owns the token
                                if (scheme === "erc721") {
                                    // ownerOf(uint256 tokenId)
                                    const tokenOwner = this.provider.formatter.callAddress((yield this.provider.call({
                                        to: addr,
                                        data: (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })));
                                    if (owner !== tokenOwner) return null;
                                    linkage.push({
                                        type: "owner",
                                        content: tokenOwner
                                    });
                                } else if (scheme === "erc1155") {
                                    // balanceOf(address owner, uint256 tokenId)
                                    const balance = (0, $0df4577496dcf693$export$d97aa349ed20696).from((yield this.provider.call({
                                        to: addr,
                                        data: (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
                                            "0x00fdd58e",
                                            (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(owner, 32),
                                            tokenId
                                        ])
                                    })));
                                    if (balance.isZero()) return null;
                                    linkage.push({
                                        type: "balance",
                                        content: balance.toString()
                                    });
                                }
                                // Call the token contract for the metadata URL
                                const tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                let metadataUrl = $43e733c7f2a529c1$var$_parseString((yield this.provider.call(tx)), 0);
                                if (metadataUrl == null) return null;
                                linkage.push({
                                    type: "metadata-url-base",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (scheme === "erc1155") {
                                    metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                    linkage.push({
                                        type: "metadata-url-expanded",
                                        content: metadataUrl
                                    });
                                }
                                // Transform IPFS metadata links
                                if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $43e733c7f2a529c1$var$getIpfsLink(metadataUrl);
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                // Get the token metadata
                                const metadata = yield (0, $4d026a5befa5b358$export$6d71b655afe1638d)(metadataUrl);
                                if (!metadata) return null;
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                // Pull the image URL out
                                let imageUrl = metadata.image;
                                if (typeof imageUrl !== "string") return null;
                                if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                                else {
                                    // Transform IPFS link to gateway
                                    const ipfs = imageUrl.match($43e733c7f2a529c1$var$matcherIpfs);
                                    if (ipfs == null) return null;
                                    linkage.push({
                                        type: "url-ipfs",
                                        content: imageUrl
                                    });
                                    imageUrl = $43e733c7f2a529c1$var$getIpfsLink(imageUrl);
                                }
                                linkage.push({
                                    type: "url",
                                    content: imageUrl
                                });
                                return {
                                    linkage: linkage,
                                    url: imageUrl
                                };
                            }
                    }
                }
            } catch (error) {}
            return null;
        });
    }
    getContentHash() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") return null;
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) return "ipfs://" + (0, $3fca3a6183b20b71$export$45a587635c9954b2).encode("0x" + ipfs[1]);
            }
            // IPNS (CID: 1, Type: libp2p-key)
            const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipns) {
                const length = parseInt(ipns[3], 16);
                if (ipns[4].length === length * 2) return "ipns://" + (0, $3fca3a6183b20b71$export$45a587635c9954b2).encode("0x" + ipns[1]);
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === 64) return "bzz://" + swarm[1];
            }
            const skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
            if (skynet) {
                if (skynet[1].length === 68) {
                    // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
                    const urlSafe = {
                        "=": "",
                        "+": "-",
                        "/": "_"
                    };
                    const hash = (0, $1d2ab8f2156e640e$export$c564cdbbe6da493)("0x" + skynet[1]).replace(/[=+\/]/g, (a)=>urlSafe[a]);
                    return "sia://" + hash;
                }
            }
            return $43e733c7f2a529c1$var$logger.throwError(`invalid or unsupported content hash data`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            // The key encoded as parameter to fetchBytes
            let keyBytes = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
                $43e733c7f2a529c1$var$bytes32ify(64),
                $43e733c7f2a529c1$var$bytes32ify(keyBytes.length),
                keyBytes
            ]);
            // Pad to word-size (32 bytes)
            if (keyBytes.length % 32 !== 0) keyBytes = (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
                keyBytes,
                (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)("0x", 32 - key.length % 32)
            ]);
            const hexBytes = yield this._fetchBytes("0x59d1d43c", (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(keyBytes));
            if (hexBytes == null || hexBytes === "0x") return null;
            return (0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)(hexBytes);
        });
    }
}
let $43e733c7f2a529c1$var$defaultFormatter = null;
let $43e733c7f2a529c1$var$nextPollId = 1;
class $43e733c7f2a529c1$export$ff3f6dd83125ac45 extends (0, $81658ac0a17fba50$export$2881499e37b75b9a) {
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */ constructor(network){
        super();
        // Events being listened to
        this._events = [];
        this._emitted = {
            block: -2
        };
        this.disableCcipRead = false;
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "anyNetwork", network === "any");
        if (this.anyNetwork) network = this.detectNetwork();
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error)=>{});
            // Trigger initial network setting (async)
            this._ready().catch((error)=>{});
        } else {
            const knownNetwork = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getNetwork")(network);
            if (knownNetwork) {
                (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            } else $43e733c7f2a529c1$var$logger.throwArgumentError("invalid network", "network", network);
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._maxFilterBlockRange = 10;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
    _ready() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) try {
                    network = yield this._networkPromise;
                } catch (error) {}
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) network = yield this.detectNetwork();
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) $43e733c7f2a529c1$var$logger.throwError("no network detected", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {});
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) this._network = network;
                    else (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return (0, $4d026a5befa5b358$export$e0c10349b2c5e1d4)(()=>{
            return this._ready().then((network)=>{
                return network;
            }, (error)=>{
                // If the network isn't running yet, we will wait
                if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if ($43e733c7f2a529c1$var$defaultFormatter == null) $43e733c7f2a529c1$var$defaultFormatter = new (0, $dc6c759982861e14$export$a06636add2a09fd8)();
        return $43e733c7f2a529c1$var$defaultFormatter;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return (0, $17c84d4c9be9446e$export$7de4970ebfd8206d)(network == null ? "homestead" : network);
    }
    ccipReadFetch(tx, calldata, urls) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (this.disableCcipRead || urls.length === 0) return null;
            const sender = tx.to.toLowerCase();
            const data = calldata.toLowerCase();
            const errorMessages = [];
            for(let i = 0; i < urls.length; i++){
                const url = urls[i];
                // URL expansion
                const href = url.replace("{sender}", sender).replace("{data}", data);
                // If no {data} is present, use POST; otherwise GET
                const json = url.indexOf("{data}") >= 0 ? null : JSON.stringify({
                    data: data,
                    sender: sender
                });
                const result = yield (0, $4d026a5befa5b358$export$6d71b655afe1638d)({
                    url: href,
                    errorPassThrough: true
                }, json, (value, response)=>{
                    value.status = response.statusCode;
                    return value;
                });
                if (result.data) return result.data;
                const errorMessage = result.message || "unknown error";
                // 4xx indicates the result is not present; stop
                if (result.status >= 400 && result.status < 500) return $43e733c7f2a529c1$var$logger.throwError(`response not found during CCIP fetch: ${errorMessage}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    url: url,
                    errorMessage: errorMessage
                });
                // 5xx indicates server issue; try the next url
                errorMessages.push(errorMessage);
            }
            return $43e733c7f2a529c1$var$logger.throwError(`error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                urls: urls,
                errorMessages: errorMessages
            });
        });
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) // While there are pending internal block requests...
            while(this._internalBlockNumber){
                // ..."remember" which fetch we started with
                const internalBlockNumber = this._internalBlockNumber;
                try {
                    // Check the result is not too stale
                    const result = yield internalBlockNumber;
                    if ($43e733c7f2a529c1$var$getTime() - result.respTime <= maxAge) return result.blockNumber;
                    break;
                } catch (error) {
                    // The fetch rejected; if we are the first to get the
                    // rejection, drop through so we replace it with a new
                    // fetch; all others blocked will then get that fetch
                    // which won't match the one they "remembered" and loop
                    if (this._internalBlockNumber === internalBlockNumber) break;
                }
            }
            const reqTime = $43e733c7f2a529c1$var$getTime();
            const checkInternalBlockNumber = (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network)=>null, (error)=>error)
            }).then(({ blockNumber: blockNumber, networkError: networkError })=>{
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
                    throw networkError;
                }
                const respTime = $43e733c7f2a529c1$var$getTime();
                blockNumber = (0, $0df4577496dcf693$export$d97aa349ed20696).from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) blockNumber = this._maxInternalBlockNumber;
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return {
                    blockNumber: blockNumber,
                    reqTime: reqTime,
                    respTime: respTime
                };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error)=>{
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const pollId = $43e733c7f2a529c1$var$nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            } catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
            if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                $43e733c7f2a529c1$var$logger.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", $43e733c7f2a529c1$var$logger.makeError("network block skew detected", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            } else // Notify all listener for each block that has passed
            for(let i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key)=>{
                    // The block event does not expire
                    if (key === "block") return;
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") return;
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) delete this._emitted[key];
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
            // Find all transaction hashes we are waiting on
            this._events.forEach((event)=>{
                switch(event.type){
                    case "tx":
                        {
                            const hash = event.hash;
                            let runner = this.getTransactionReceipt(hash).then((receipt)=>{
                                if (!receipt || receipt.blockNumber == null) return null;
                                this._emitted["t:" + hash] = receipt.blockNumber;
                                this.emit(hash, receipt);
                                return null;
                            }).catch((error)=>{
                                this.emit("error", error);
                            });
                            runners.push(runner);
                            break;
                        }
                    case "filter":
                        // We only allow a single getLogs to be in-flight at a time
                        if (!event._inflight) {
                            event._inflight = true;
                            // This is the first filter for this event, so we want to
                            // restrict events to events that happened no earlier than now
                            if (event._lastBlockNumber === -2) event._lastBlockNumber = blockNumber - 1;
                            // Filter from the last *known* event; due to load-balancing
                            // and some nodes returning updated block numbers before
                            // indexing events, a logs result with 0 entries cannot be
                            // trusted and we must retry a range which includes it again
                            const filter = event.filter;
                            filter.fromBlock = event._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            // Prevent fitler ranges from growing too wild, since it is quite
                            // likely there just haven't been any events to move the lastBlockNumber.
                            const minFromBlock = filter.toBlock - this._maxFilterBlockRange;
                            if (minFromBlock > filter.fromBlock) filter.fromBlock = minFromBlock;
                            if (filter.fromBlock < 0) filter.fromBlock = 0;
                            const runner = this.getLogs(filter).then((logs)=>{
                                // Allow the next getLogs
                                event._inflight = false;
                                if (logs.length === 0) return;
                                logs.forEach((log)=>{
                                    // Only when we get an event for a given block number
                                    // can we trust the events are indexed
                                    if (log.blockNumber > event._lastBlockNumber) event._lastBlockNumber = log.blockNumber;
                                    // Make sure we stall requests to fetch blocks and txs
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error)=>{
                                this.emit("error", error);
                                // Allow another getLogs (the range was not updated)
                                event._inflight = false;
                            });
                            runners.push(runner);
                        }
                        break;
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(()=>{
                this.emit("didPoll", pollId);
            }).catch((error)=>{
                this.emit("error", error);
            });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) this.poll();
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            return $43e733c7f2a529c1$var$logger.throwError("provider does not support network detection", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield $43e733c7f2a529c1$var$stall(0);
                    return this._network;
                }
                const error = $43e733c7f2a529c1$var$logger.makeError("underlying network changed", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber)=>{
            this._setFastBlockNumber(blockNumber);
        }, (error)=>{});
        return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
    }
    get polling() {
        return this._poller != null;
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(()=>{
                this.poll();
            }, this.pollingInterval);
            if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(()=>{
                this.poll();
                // We block additional polls until the polling interval
                // is done, to prevent overwhelming the poll function
                this._bootstrapPoll = setTimeout(()=>{
                    // If polling was disabled, something may require a poke
                    // since starting the bootstrap poll and it was disabled
                    if (!this._poller) this.poll();
                    // Clear out the bootstrap so we can do another
                    this._bootstrapPoll = null;
                }, this.pollingInterval);
            }, 0);
        } else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(()=>{
                this.poll();
            }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = $43e733c7f2a529c1$var$getTime();
        // Stale block number, request a newer value
        if (now - this._fastQueryDate > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber)=>{
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) this._fastBlockNumber = blockNumber;
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
        // Update the time we updated the blocknumber
        this._fastQueryDate = $43e733c7f2a529c1$var$getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            return this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) return receipt;
            // Poll until the receipt is good...
            return new Promise((resolve, reject)=>{
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function() {
                    if (done) return true;
                    done = true;
                    cancelFuncs.forEach((func)=>{
                        func();
                    });
                    return false;
                };
                const minedHandler = (receipt)=>{
                    if (receipt.confirmations < confirmations) return;
                    if (alreadyDone()) return;
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(()=>{
                    this.removeListener(transactionHash, minedHandler);
                });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber)=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                            if (done) return;
                            // Wait 1 second; this is only used in the case of a fault, so
                            // we will trade off a little bit of latency for more consistent
                            // results and fewer JSON-RPC calls
                            yield $43e733c7f2a529c1$var$stall(1000);
                            this.getTransactionCount(replaceable.from).then((nonce)=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                                    if (done) return;
                                    if (nonce <= replaceable.nonce) lastBlockNumber = blockNumber;
                                    else {
                                        // First check if the transaction was mined
                                        {
                                            const mined = yield this.getTransaction(transactionHash);
                                            if (mined && mined.blockNumber != null) return;
                                        }
                                        // First time scanning. We start a little earlier for some
                                        // wiggle room here to handle the eventually consistent nature
                                        // of blockchain (e.g. the getTransactionCount was for a
                                        // different block)
                                        if (scannedBlock == null) {
                                            scannedBlock = lastBlockNumber - 3;
                                            if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                        }
                                        while(scannedBlock <= blockNumber){
                                            if (done) return;
                                            const block = yield this.getBlockWithTransactions(scannedBlock);
                                            for(let ti = 0; ti < block.transactions.length; ti++){
                                                const tx = block.transactions[ti];
                                                // Successfully mined!
                                                if (tx.hash === transactionHash) return;
                                                // Matches our transaction from and nonce; its a replacement
                                                if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                                    if (done) return;
                                                    // Get the receipt of the replacement
                                                    const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                                    // Already resolved or rejected (prolly a timeout)
                                                    if (alreadyDone()) return;
                                                    // The reason we were replaced
                                                    let reason = "replaced";
                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                    // Explain why we were replaced
                                                    reject($43e733c7f2a529c1$var$logger.makeError("transaction was replaced", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.TRANSACTION_REPLACED, {
                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                        reason: reason,
                                                        replacement: this._wrapTransaction(tx),
                                                        hash: transactionHash,
                                                        receipt: receipt
                                                    }));
                                                    return;
                                                }
                                            }
                                            scannedBlock++;
                                        }
                                    }
                                    if (done) return;
                                    this.once("block", replaceHandler);
                                }), (error)=>{
                                if (done) return;
                                this.once("block", replaceHandler);
                            });
                        });
                    if (done) return;
                    this.once("block", replaceHandler);
                    cancelFuncs.push(()=>{
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof timeout === "number" && timeout > 0) {
                    const timer = setTimeout(()=>{
                        if (alreadyDone()) return;
                        reject($43e733c7f2a529c1$var$logger.makeError("timeout exceeded", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.TIMEOUT, {
                            timeout: timeout
                        }));
                    }, timeout);
                    if (timer.unref) timer.unref();
                    cancelFuncs.push(()=>{
                        clearTimeout(timer);
                    });
                }
            });
        });
    }
    getBlockNumber() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return (0, $0df4577496dcf693$export$d97aa349ed20696).from(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result: result,
                    error: error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return (0, $0df4577496dcf693$export$d97aa349ed20696).from(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getBalance",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return (0, $0df4577496dcf693$export$d97aa349ed20696).from(result).toNumber();
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getCode",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p)=>(0, $7b88b6e03e4708f2$export$6916af760a341dd3)(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && (0, $7b88b6e03e4708f2$export$13882f896d3c0683)(hash) !== 32) throw new Error("invalid response - sendTransaction");
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) $43e733c7f2a529c1$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {
            expectedHash: tx.hash,
            returnedHash: hash
        });
        result.wait = (confirms, timeout)=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                if (confirms == null) confirms = 1;
                if (timeout == null) timeout = 0;
                // Get the details to detect replacement
                let replacement = undefined;
                if (confirms !== 0 && startBlock != null) replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock: startBlock
                };
                const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
                if (receipt == null && confirms === 0) return null;
                // No longer pending, allow the polling loop to garbage collect this
                this._emitted["t:" + tx.hash] = receipt.blockNumber;
                if (receipt.status === 0) $43e733c7f2a529c1$var$logger.throwError("transaction failed", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
                return receipt;
            });
        return result;
    }
    sendTransaction(signedTransaction) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then((t)=>(0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) tx.confirmations = 0;
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", {
                    signedTransaction: hexTx
                });
                return this._wrapTransaction(tx, hash, blockNumber);
            } catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            const values = yield transaction;
            const tx = {};
            [
                "from",
                "to"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? this._getAddress(v) : null);
            });
            [
                "gasLimit",
                "gasPrice",
                "maxFeePerGas",
                "maxPriorityFeePerGas",
                "value"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $0df4577496dcf693$export$d97aa349ed20696).from(v) : null);
            });
            [
                "type"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v != null ? v : null);
            });
            if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
            [
                "data"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(v) : null);
            });
            return this.formatter.transactionRequest((yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)(tx)));
        });
    }
    _getFilter(filter) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            filter = yield filter;
            const result = {};
            if (filter.address != null) result.address = this._getAddress(filter.address);
            [
                "blockHash",
                "topics"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = filter[key];
            });
            [
                "fromBlock",
                "toBlock"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter((yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)(result)));
        });
    }
    _call(transaction, blockTag, attempt) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (attempt >= $43e733c7f2a529c1$var$MAX_CCIP_REDIRECTS) $43e733c7f2a529c1$var$logger.throwError("CCIP read exceeded maximum redirections", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                redirects: attempt,
                transaction: transaction
            });
            const txSender = transaction.to;
            const result = yield this.perform("call", {
                transaction: transaction,
                blockTag: blockTag
            });
            // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)
            if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (0, $7b88b6e03e4708f2$export$13882f896d3c0683)(result) % 32 === 4) try {
                const data = (0, $7b88b6e03e4708f2$export$15da666eba198c18)(result, 4);
                // Check the sender of the OffchainLookup matches the transaction
                const sender = (0, $7b88b6e03e4708f2$export$15da666eba198c18)(data, 0, 32);
                if (!(0, $0df4577496dcf693$export$d97aa349ed20696).from(sender).eq(txSender)) $43e733c7f2a529c1$var$logger.throwError("CCIP Read sender did not match", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                // Read the URLs from the response
                const urls = [];
                const urlsOffset = (0, $0df4577496dcf693$export$d97aa349ed20696).from((0, $7b88b6e03e4708f2$export$15da666eba198c18)(data, 32, 64)).toNumber();
                const urlsLength = (0, $0df4577496dcf693$export$d97aa349ed20696).from((0, $7b88b6e03e4708f2$export$15da666eba198c18)(data, urlsOffset, urlsOffset + 32)).toNumber();
                const urlsData = (0, $7b88b6e03e4708f2$export$15da666eba198c18)(data, urlsOffset + 32);
                for(let u = 0; u < urlsLength; u++){
                    const url = $43e733c7f2a529c1$var$_parseString(urlsData, u * 32);
                    if (url == null) $43e733c7f2a529c1$var$logger.throwError("CCIP Read contained corrupt URL string", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                        name: "OffchainLookup",
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        transaction: transaction,
                        data: result
                    });
                    urls.push(url);
                }
                // Get the CCIP calldata to forward
                const calldata = $43e733c7f2a529c1$var$_parseBytes(data, 64);
                // Get the callbackSelector (bytes4)
                if (!(0, $0df4577496dcf693$export$d97aa349ed20696).from((0, $7b88b6e03e4708f2$export$15da666eba198c18)(data, 100, 128)).isZero()) $43e733c7f2a529c1$var$logger.throwError("CCIP Read callback selector included junk", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const callbackSelector = (0, $7b88b6e03e4708f2$export$15da666eba198c18)(data, 96, 100);
                // Get the extra data to send back to the contract as context
                const extraData = $43e733c7f2a529c1$var$_parseBytes(data, 128);
                const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);
                if (ccipResult == null) $43e733c7f2a529c1$var$logger.throwError("CCIP Read disabled or provided no URLs", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const tx = {
                    to: txSender,
                    data: (0, $7b88b6e03e4708f2$export$6d4b99629b38754a)([
                        callbackSelector,
                        $43e733c7f2a529c1$var$encodeBytes([
                            ccipResult,
                            extraData
                        ])
                    ])
                };
                return this._call(tx, blockTag, attempt + 1);
            } catch (error) {
                if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR) throw error;
            }
            try {
                return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "call",
                    params: {
                        transaction: transaction,
                        blockTag: blockTag
                    },
                    result: result,
                    error: error
                });
            }
        });
    }
    call(transaction, blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const resolved = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag),
                ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
            });
            return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
        });
    }
    estimateGas(transaction) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return (0, $0df4577496dcf693$export$d97aa349ed20696).from(result);
            } catch (error) {
                return $43e733c7f2a529c1$var$logger.throwError("bad result from backend", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            addressOrName = yield addressOrName;
            if (typeof addressOrName !== "string") $43e733c7f2a529c1$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            const address = yield this.resolveName(addressOrName);
            if (address == null) $43e733c7f2a529c1$var$logger.throwError("ENS name not configured", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: `resolveName(${JSON.stringify(addressOrName)})`
            });
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(blockHashOrBlockTag, 32)) params.blockHash = blockHashOrBlockTag;
            else try {
                params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
            } catch (error) {
                $43e733c7f2a529c1$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
            }
            return (0, $4d026a5befa5b358$export$e0c10349b2c5e1d4)(()=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                    const block = yield this.perform("getBlock", params);
                    // Block was not found
                    if (block == null) {
                        // For blockhashes, if we didn't say it existed, that blockhash may
                        // not exist. If we did see it though, perhaps from a log, we know
                        // it exists, and this node is just not caught up yet.
                        if (params.blockHash != null) {
                            if (this._emitted["b:" + params.blockHash] == null) return null;
                        }
                        // For block tags, if we are asking for a future block, we return null
                        if (params.blockTag != null) {
                            if (blockNumber > this._emitted.block) return null;
                        }
                        // Retry on the next block
                        return undefined;
                    }
                    // Add transactions
                    if (includeTransactions) {
                        let blockNumber = null;
                        for(let i = 0; i < block.transactions.length; i++){
                            const tx = block.transactions[i];
                            if (tx.blockNumber == null) tx.confirmations = 0;
                            else if (tx.confirmations == null) {
                                if (blockNumber == null) blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                                // Add the confirmations using the fast block number (pessimistic)
                                let confirmations = blockNumber - tx.blockNumber + 1;
                                if (confirmations <= 0) confirmations = 1;
                                tx.confirmations = confirmations;
                            }
                        }
                        const blockWithTxs = this.formatter.blockWithTransactions(block);
                        blockWithTxs.transactions = blockWithTxs.transactions.map((tx)=>this._wrapTransaction(tx));
                        return blockWithTxs;
                    }
                    return this.formatter.block(block);
                }), {
                oncePoll: this
            });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, false);
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, true);
    }
    getTransaction(transactionHash) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $4d026a5befa5b358$export$e0c10349b2c5e1d4)(()=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransaction", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    const tx = this.formatter.transactionResponse(result);
                    if (tx.blockNumber == null) tx.confirmations = 0;
                    else if (tx.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - tx.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        tx.confirmations = confirmations;
                    }
                    return this._wrapTransaction(tx);
                }), {
                oncePoll: this
            });
        });
    }
    getTransactionReceipt(transactionHash) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $4d026a5befa5b358$export$e0c10349b2c5e1d4)(()=>$43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransactionReceipt", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    // "geth-etc" returns receipts before they are ready
                    if (result.blockHash == null) return undefined;
                    const receipt = this.formatter.receipt(result);
                    if (receipt.blockNumber == null) receipt.confirmations = 0;
                    else if (receipt.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - receipt.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        receipt.confirmations = confirmations;
                    }
                    return receipt;
                }), {
                oncePoll: this
            });
        });
    }
    getLogs(filter) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
                filter: this._getFilter(filter)
            });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log)=>{
                if (log.removed == null) log.removed = false;
            });
            return (0, $dc6c759982861e14$export$a06636add2a09fd8).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            blockTag = yield blockTag;
            if (typeof blockTag === "number" && blockTag < 0) {
                if (blockTag % 1) $43e733c7f2a529c1$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) blockNumber = 0;
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            let currentName = name;
            while(true){
                if (currentName === "" || currentName === ".") return null;
                // Optimization since the eth node cannot change and does
                // not have a wildcard resolver
                if (name !== "eth" && currentName === "eth") return null;
                // Check the current node for a resolver
                const addr = yield this._getResolver(currentName, "getResolver");
                // Found a resolver!
                if (addr != null) {
                    const resolver = new $43e733c7f2a529c1$export$8b4c839865b08288(this, addr, name);
                    // Legacy resolver found, using EIP-2544 so it isn't safe to use
                    if (currentName !== name && !(yield resolver.supportsWildcard())) return null;
                    return resolver;
                }
                // Get the parent node
                currentName = currentName.split(".").slice(1).join(".");
            }
        });
    }
    _getResolver(name, operation) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            if (operation == null) operation = "ENS";
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) $43e733c7f2a529c1$var$logger.throwError("network does not support ENS", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: operation,
                network: network.name
            });
            try {
                // keccak256("resolver(bytes32)")
                const addrData = yield this.call({
                    to: network.ensAddress,
                    data: "0x0178b8bf" + (0, $62768931dfa5f58f$export$91d651ee363e1209)(name).substring(2)
                });
                return this.formatter.callAddress(addrData);
            } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32)
            }
            return null;
        });
    }
    resolveName(name) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            } catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(name)) throw error;
            }
            if (typeof name !== "string") $43e733c7f2a529c1$var$logger.throwArgumentError("invalid ENS name", "name", name);
            // Get the addr from the resolver
            const resolver = yield this.getResolver(name);
            if (!resolver) return null;
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            address = yield address;
            address = this.formatter.address(address);
            const node = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddr = yield this._getResolver(node, "lookupAddress");
            if (resolverAddr == null) return null;
            // keccak("name(bytes32)")
            const name = $43e733c7f2a529c1$var$_parseString((yield this.call({
                to: resolverAddr,
                data: "0x691f3431" + (0, $62768931dfa5f58f$export$91d651ee363e1209)(node).substring(2)
            })), 0);
            const addr = yield this.resolveName(name);
            if (addr != address) return null;
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return $43e733c7f2a529c1$var$__awaiter(this, void 0, void 0, function*() {
            let resolver = null;
            if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const node = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(node, "getAvatar");
                if (!resolverAddress) return null;
                // Try resolving the avatar against the addr.reverse resolver
                resolver = new $43e733c7f2a529c1$export$8b4c839865b08288(this, resolverAddress, node);
                try {
                    const avatar = yield resolver.getAvatar();
                    if (avatar) return avatar.url;
                } catch (error) {
                    if (error.code !== (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION) throw error;
                }
                // Try getting the name and performing forward lookup; allowing wildcards
                try {
                    // keccak("name(bytes32)")
                    const name = $43e733c7f2a529c1$var$_parseString((yield this.call({
                        to: resolverAddress,
                        data: "0x691f3431" + (0, $62768931dfa5f58f$export$91d651ee363e1209)(node).substring(2)
                    })), 0);
                    resolver = yield this.getResolver(name);
                } catch (error) {
                    if (error.code !== (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION) throw error;
                    return null;
                }
            } else {
                // ENS name; forward lookup with wildcard
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) return null;
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) return null;
            return avatar.url;
        });
    }
    perform(method, params) {
        return $43e733c7f2a529c1$var$logger.throwError(method + " not implemented", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
            operation: method
        });
    }
    _startEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _stopEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _addEventListener(eventName, listener, once) {
        const event = new $43e733c7f2a529c1$export$d61e24a684f9e51($43e733c7f2a529c1$var$getEventTag(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag) return true;
            setTimeout(()=>{
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) return this._events.length;
        let eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
        return this._events.filter((event)=>{
            return event.tag === eventTag;
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) return this._events.map((event)=>event.listener);
        let eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
        return this._events.filter((event)=>event.tag === eventTag).map((event)=>event.listener);
    }
    off(eventName, listener) {
        if (listener == null) return this.removeAllListeners(eventName);
        const stopped = [];
        let found = false;
        let eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag || event.listener != listener) return true;
            if (found) return true;
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        } else {
            const eventTag = $43e733c7f2a529c1$var$getEventTag(eventName);
            this._events = this._events.filter((event)=>{
                if (event.tag !== eventTag) return true;
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
}

















"use strict";
var $e32f9441afb0a406$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $e32f9441afb0a406$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
const $e32f9441afb0a406$var$errorGas = [
    "call",
    "estimateGas"
];
function $e32f9441afb0a406$var$spelunk(value, requireData) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match("reverted")) {
        const data = (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(value.data) ? value.data : null;
        if (!requireData || data) return {
            message: value.message,
            data: data
        };
    }
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $e32f9441afb0a406$var$spelunk(value[key], requireData);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $e32f9441afb0a406$var$spelunk(JSON.parse(value), requireData);
    } catch (error) {}
    return null;
}
function $e32f9441afb0a406$var$checkError(method, error, params) {
    const transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        const result = $e32f9441afb0a406$var$spelunk(error, true);
        if (result) return result.data;
        // Nothing descriptive..
        $e32f9441afb0a406$var$logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
            data: "0x",
            transaction: transaction,
            error: error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        let result = $e32f9441afb0a406$var$spelunk(error.body, false);
        if (result == null) result = $e32f9441afb0a406$var$spelunk(error, false);
        // Found "reverted", this is a CALL_EXCEPTION
        if (result) $e32f9441afb0a406$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
            reason: result.message,
            method: method,
            transaction: transaction,
            error: error
        });
    }
    // @TODO: Should we spelunk for message too?
    let message = error.message;
    if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i)) $e32f9441afb0a406$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) $e32f9441afb0a406$var$logger.throwError("nonce has already been used", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) $e32f9441afb0a406$var$logger.throwError("replacement fee too low", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) $e32f9441afb0a406$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($e32f9441afb0a406$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/)) $e32f9441afb0a406$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $e32f9441afb0a406$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $e32f9441afb0a406$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $e32f9441afb0a406$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
const $e32f9441afb0a406$var$_constructorGuard = {};
class $e32f9441afb0a406$export$5f7b5fca3508545a extends (0, $deb85df20e19ba32$export$fdf54fdde81cc9f0) {
    constructor(constructorGuard, provider, addressOrIndex){
        super();
        if (constructorGuard !== $e32f9441afb0a406$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_address", this.provider.formatter.address(addressOrIndex));
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_index", addressOrIndex);
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_address", null);
        } else $e32f9441afb0a406$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
    }
    connect(provider) {
        return $e32f9441afb0a406$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new $e32f9441afb0a406$var$UncheckedJsonRpcSigner($e32f9441afb0a406$var$_constructorGuard, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) return Promise.resolve(this._address);
        return this.provider.send("eth_accounts", []).then((accounts)=>{
            if (accounts.length <= this._index) $e32f9441afb0a406$var$logger.throwError("unknown account #" + this._index, (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "getAddress"
            });
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(transaction);
        const fromAddress = this.getAddress().then((address)=>{
            if (address) address = address.toLowerCase();
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then((to)=>$e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
                if (to == null) return null;
                const address = yield this.provider.resolveName(to);
                if (address == null) $e32f9441afb0a406$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                return address;
            }));
        return (0, $a463a6b5f08d6875$export$d503dd157d963b60)({
            tx: (0, $a463a6b5f08d6875$export$d503dd157d963b60)(transaction),
            sender: fromAddress
        }).then(({ tx: tx, sender: sender })=>{
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) $e32f9441afb0a406$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            } else tx.from = sender;
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, {
                from: true
            });
            return this.provider.send("eth_sendTransaction", [
                hexTx
            ]).then((hash)=>{
                return hash;
            }, (error)=>{
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $e32f9441afb0a406$var$logger.throwError("user rejected transaction", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "sendTransaction",
                    transaction: tx
                });
                return $e32f9441afb0a406$var$checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return $e32f9441afb0a406$var$logger.throwError("signing transactions is unsupported", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield (0, $4d026a5befa5b358$export$e0c10349b2c5e1d4)(()=>$e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
                        const tx = yield this.provider.getTransaction(hash);
                        if (tx === null) return undefined;
                        return this.provider._wrapTransaction(tx, hash, blockNumber);
                    }), {
                    oncePoll: this.provider
                });
            } catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(message) : message;
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("personal_sign", [
                    (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data),
                    address.toLowerCase()
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $e32f9441afb0a406$var$logger.throwError("user rejected signing", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "signMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _legacySignMessage(message) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(message) : message;
            const address = yield this.getAddress();
            try {
                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                return yield this.provider.send("eth_sign", [
                    address.toLowerCase(),
                    (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(data)
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $e32f9441afb0a406$var$logger.throwError("user rejected signing", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "_legacySignMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _signTypedData(domain, types, value) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names (in-place)
            const populated = yield (0, $74ec091a01b8d3e1$export$458ab927ae635c3).resolveNames(domain, types, value, (name)=>{
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("eth_signTypedData_v4", [
                    address.toLowerCase(),
                    JSON.stringify((0, $74ec091a01b8d3e1$export$458ab927ae635c3).getPayload(populated.domain, types, populated.value))
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $e32f9441afb0a406$var$logger.throwError("user rejected signing", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "_signTypedData",
                    from: address,
                    messageData: {
                        domain: populated.domain,
                        types: types,
                        value: populated.value
                    }
                });
                throw error;
            }
        });
    }
    unlock(password) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [
                address.toLowerCase(),
                password,
                null
            ]);
        });
    }
}
class $e32f9441afb0a406$var$UncheckedJsonRpcSigner extends $e32f9441afb0a406$export$5f7b5fca3508545a {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash)=>{
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations)=>{
                    return this.provider.waitForTransaction(hash, confirmations);
                }
            };
        });
    }
}
const $e32f9441afb0a406$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
class $e32f9441afb0a406$export$da28308012bf6748 extends (0, $43e733c7f2a529c1$export$ff3f6dd83125ac45) {
    constructor(url, network){
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then((network)=>{
                    resolve(network);
                }, (error)=>{
                    reject(error);
                });
            }, 0);
        });
        super(networkOrReady);
        // Default URL
        if (!url) url = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "connection", Object.freeze({
            url: url
        }));
        else (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "connection", Object.freeze((0, $a463a6b5f08d6875$export$9c13236873b118a5)(url)));
        this._nextId = 42;
    }
    get _cache() {
        if (this._eventLoopCache == null) this._eventLoopCache = {};
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http://localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(()=>{
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            yield $e32f9441afb0a406$var$timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            } catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                } catch (error) {}
            }
            if (chainId != null) {
                const getNetwork = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "getNetwork");
                try {
                    return getNetwork((0, $0df4577496dcf693$export$d97aa349ed20696).from(chainId).toNumber());
                } catch (error) {
                    return $e32f9441afb0a406$var$logger.throwError("could not detect network", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return $e32f9441afb0a406$var$logger.throwError("could not detect network", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new $e32f9441afb0a406$export$5f7b5fca3508545a($e32f9441afb0a406$var$_constructorGuard, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts)=>{
            return accounts.map((a)=>this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: (0, $a463a6b5f08d6875$export$6c40052bed430212)(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = [
            "eth_chainId",
            "eth_blockNumber"
        ].indexOf(method) >= 0;
        if (cache && this._cache[method]) return this._cache[method];
        const result = (0, $4d026a5befa5b358$export$6d71b655afe1638d)(this.connection, JSON.stringify(request), $e32f9441afb0a406$var$getResult).then((result)=>{
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(()=>{
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch(method){
            case "getBlockNumber":
                return [
                    "eth_blockNumber",
                    []
                ];
            case "getGasPrice":
                return [
                    "eth_gasPrice",
                    []
                ];
            case "getBalance":
                return [
                    "eth_getBalance",
                    [
                        $e32f9441afb0a406$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getTransactionCount":
                return [
                    "eth_getTransactionCount",
                    [
                        $e32f9441afb0a406$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getCode":
                return [
                    "eth_getCode",
                    [
                        $e32f9441afb0a406$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getStorageAt":
                return [
                    "eth_getStorageAt",
                    [
                        $e32f9441afb0a406$var$getLowerCase(params.address),
                        (0, $7b88b6e03e4708f2$export$e9c46a54370b47e8)(params.position, 32),
                        params.blockTag
                    ]
                ];
            case "sendTransaction":
                return [
                    "eth_sendRawTransaction",
                    [
                        params.signedTransaction
                    ]
                ];
            case "getBlock":
                if (params.blockTag) return [
                    "eth_getBlockByNumber",
                    [
                        params.blockTag,
                        !!params.includeTransactions
                    ]
                ];
                else if (params.blockHash) return [
                    "eth_getBlockByHash",
                    [
                        params.blockHash,
                        !!params.includeTransactions
                    ]
                ];
                return null;
            case "getTransaction":
                return [
                    "eth_getTransactionByHash",
                    [
                        params.transactionHash
                    ]
                ];
            case "getTransactionReceipt":
                return [
                    "eth_getTransactionReceipt",
                    [
                        params.transactionHash
                    ]
                ];
            case "call":
                {
                    const hexlifyTransaction = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_call",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            }),
                            params.blockTag
                        ]
                    ];
                }
            case "estimateGas":
                {
                    const hexlifyTransaction = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_estimateGas",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            })
                        ]
                    ];
                }
            case "getLogs":
                if (params.filter && params.filter.address != null) params.filter.address = $e32f9441afb0a406$var$getLowerCase(params.filter.address);
                return [
                    "eth_getLogs",
                    [
                        params.filter
                    ]
                ];
            default:
                break;
        }
        return null;
    }
    perform(method, params) {
        return $e32f9441afb0a406$var$__awaiter(this, void 0, void 0, function*() {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && (0, $0df4577496dcf693$export$d97aa349ed20696).from(tx.type).isZero()) // If there are no EIP-1559 properties, it might be non-EIP-1559
                {
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(params);
                            params.transaction = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) $e32f9441afb0a406$var$logger.throwError(method + " not implemented", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
                operation: method
            });
            try {
                return yield this.send(args[0], args[1]);
            } catch (error) {
                return $e32f9441afb0a406$var$checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") this._startPending();
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) return;
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function(filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [
                    filterId
                ]).then(function(hashes) {
                    if (self._pendingFilter != pendingFilter) return null;
                    let seq = Promise.resolve();
                    hashes.forEach(function(hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function() {
                            return self.getTransaction(hash).then(function(tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function() {
                        return $e32f9441afb0a406$var$timer(1000);
                    });
                }).then(function() {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [
                            filterId
                        ]);
                        return;
                    }
                    setTimeout(function() {
                        poll();
                    }, 0);
                    return null;
                }).catch((error)=>{});
            }
            poll();
            return filterId;
        }).catch((error)=>{});
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = (0, $a463a6b5f08d6875$export$9c13236873b118a5)($e32f9441afb0a406$var$allowedTransactionKeys);
        if (allowExtra) {
            for(const key in allowExtra)if (allowExtra[key]) allowed[key] = true;
        }
        (0, $a463a6b5f08d6875$export$ae5a316ba623b73a)(transaction, allowed);
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            const value = (0, $7b88b6e03e4708f2$export$6916af760a341dd3)((0, $0df4577496dcf693$export$d97aa349ed20696).from(transaction[key]));
            if (key === "gasLimit") key = "gas";
            result[key] = value;
        });
        [
            "from",
            "to",
            "data"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            result[key] = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(transaction[key]);
        });
        if (transaction.accessList) result["accessList"] = (0, $0a7021bc70fec74d$export$6c8662b1600dce2)(transaction.accessList);
        return result;
    }
}




"use strict";
let $c20588e763a5ccc3$export$3909fb301d3dc8c9 = null;
try {
    $c20588e763a5ccc3$export$3909fb301d3dc8c9 = WebSocket;
    if ($c20588e763a5ccc3$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    const logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
    $c20588e763a5ccc3$export$3909fb301d3dc8c9 = function() {
        logger.throwError("WebSockets not supported in this environment", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}




"use strict";
var $f2ba8b3ea7dcf3ca$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $f2ba8b3ea7dcf3ca$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ let $f2ba8b3ea7dcf3ca$var$NextId = 1;
class $f2ba8b3ea7dcf3ca$export$bfafe629242f30bd extends (0, $e32f9441afb0a406$export$da28308012bf6748) {
    constructor(url, network){
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $f2ba8b3ea7dcf3ca$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        if (typeof url === "string") super(url, network);
        else super("_websocket", network);
        this._pollingInterval = -1;
        this._wsReady = false;
        if (typeof url === "string") (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_websocket", new (0, $c20588e763a5ccc3$export$3909fb301d3dc8c9)(this.connection.url));
        else (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_websocket", url);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_requests", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_subs", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_subIds", {});
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_detectNetwork", super.detectNetwork());
        // Stall sending requests until the socket is open...
        this.websocket.onopen = ()=>{
            this._wsReady = true;
            Object.keys(this._requests).forEach((id)=>{
                this.websocket.send(this._requests[id].payload);
            });
        };
        this.websocket.onmessage = (messageEvent)=>{
            const data = messageEvent.data;
            const result = JSON.parse(data);
            if (result.id != null) {
                const id = String(result.id);
                const request = this._requests[id];
                delete this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: this
                    });
                } else {
                    let error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $a463a6b5f08d6875$export$104236534534f9be)(error, "code", result.error.code || null);
                        (0, $a463a6b5f08d6875$export$104236534534f9be)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: this
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                const sub = this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        const fauxPoll = setInterval(()=>{
            this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
    }
    // Cannot narrow the type of _websocket, as that is not backwards compatible
    // so we add a getter and let the WebSocket be a public API.
    get websocket() {
        return this._websocket;
    }
    detectNetwork() {
        return this._detectNetwork;
    }
    get pollingInterval() {
        return 0;
    }
    resetEventsBlock(blockNumber) {
        $f2ba8b3ea7dcf3ca$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "resetEventBlock"
        });
    }
    set pollingInterval(value) {
        $f2ba8b3ea7dcf3ca$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "setPollingInterval"
        });
    }
    poll() {
        return $f2ba8b3ea7dcf3ca$var$__awaiter(this, void 0, void 0, function*() {
            return null;
        });
    }
    set polling(value) {
        if (!value) return;
        $f2ba8b3ea7dcf3ca$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "setPolling"
        });
    }
    send(method, params) {
        const rid = $f2ba8b3ea7dcf3ca$var$NextId++;
        return new Promise((resolve, reject)=>{
            function callback(error, result) {
                if (error) return reject(error);
                return resolve(result);
            }
            const payload = JSON.stringify({
                method: method,
                params: params,
                id: rid,
                jsonrpc: "2.0"
            });
            this.emit("debug", {
                action: "request",
                request: JSON.parse(payload),
                provider: this
            });
            this._requests[String(rid)] = {
                callback: callback,
                payload: payload
            };
            if (this._wsReady) this.websocket.send(payload);
        });
    }
    static defaultUrl() {
        return "ws://localhost:8546";
    }
    _subscribe(tag, param, processFunc) {
        return $f2ba8b3ea7dcf3ca$var$__awaiter(this, void 0, void 0, function*() {
            let subIdPromise = this._subIds[tag];
            if (subIdPromise == null) {
                subIdPromise = Promise.all(param).then((param)=>{
                    return this.send("eth_subscribe", param);
                });
                this._subIds[tag] = subIdPromise;
            }
            const subId = yield subIdPromise;
            this._subs[subId] = {
                tag: tag,
                processFunc: processFunc
            };
        });
    }
    _startEvent(event) {
        switch(event.type){
            case "block":
                this._subscribe("block", [
                    "newHeads"
                ], (result)=>{
                    const blockNumber = (0, $0df4577496dcf693$export$d97aa349ed20696).from(result.number).toNumber();
                    this._emitted.block = blockNumber;
                    this.emit("block", blockNumber);
                });
                break;
            case "pending":
                this._subscribe("pending", [
                    "newPendingTransactions"
                ], (result)=>{
                    this.emit("pending", result);
                });
                break;
            case "filter":
                this._subscribe(event.tag, [
                    "logs",
                    this._getFilter(event.filter)
                ], (result)=>{
                    if (result.removed == null) result.removed = false;
                    this.emit(event.filter, this.formatter.filterLog(result));
                });
                break;
            case "tx":
                {
                    const emitReceipt = (event)=>{
                        const hash = event.hash;
                        this.getTransactionReceipt(hash).then((receipt)=>{
                            if (!receipt) return;
                            this.emit(hash, receipt);
                        });
                    };
                    // In case it is already mined
                    emitReceipt(event);
                    // To keep things simple, we start up a single newHeads subscription
                    // to keep an eye out for transactions we are watching for.
                    // Starting a subscription for an event (i.e. "tx") that is already
                    // running is (basically) a nop.
                    this._subscribe("tx", [
                        "newHeads"
                    ], (result)=>{
                        this._events.filter((e)=>e.type === "tx").forEach(emitReceipt);
                    });
                    break;
                }
            // Nothing is needed
            case "debug":
            case "poll":
            case "willPoll":
            case "didPoll":
            case "error":
                break;
            default:
                console.log("unhandled:", event);
                break;
        }
    }
    _stopEvent(event) {
        let tag = event.tag;
        if (event.type === "tx") {
            // There are remaining transaction event listeners
            if (this._events.filter((e)=>e.type === "tx").length) return;
            tag = "tx";
        } else if (this.listenerCount(event.event)) // There are remaining event listeners
        return;
        const subId = this._subIds[tag];
        if (!subId) return;
        delete this._subIds[tag];
        subId.then((subId)=>{
            if (!this._subs[subId]) return;
            delete this._subs[subId];
            this.send("eth_unsubscribe", [
                subId
            ]);
        });
    }
    destroy() {
        return $f2ba8b3ea7dcf3ca$var$__awaiter(this, void 0, void 0, function*() {
            // Wait until we have connected before trying to disconnect
            if (this.websocket.readyState === (0, $c20588e763a5ccc3$export$3909fb301d3dc8c9).CONNECTING) yield new Promise((resolve)=>{
                this.websocket.onopen = function() {
                    resolve(true);
                };
                this.websocket.onerror = function() {
                    resolve(false);
                };
            });
            // Hangup
            // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
            this.websocket.close(1000);
        });
    }
}








"use strict";
var $8044ebfe209f61e4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8044ebfe209f61e4$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
class $8044ebfe209f61e4$export$b3d647c1c29df44d extends (0, $e32f9441afb0a406$export$da28308012bf6748) {
    detectNetwork() {
        const _super = Object.create(null, {
            detectNetwork: {
                get: ()=>super.detectNetwork
            }
        });
        return $8044ebfe209f61e4$var$__awaiter(this, void 0, void 0, function*() {
            let network = this.network;
            if (network == null) {
                network = yield _super.detectNetwork.call(this);
                if (!network) $8044ebfe209f61e4$var$logger.throwError("no network detected", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {});
                // If still not set, set it
                if (this._network == null) {
                    // A static network does not support "any"
                    (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return network;
        });
    }
}
class $8044ebfe209f61e4$export$664128d6239ccf96 extends $8044ebfe209f61e4$export$b3d647c1c29df44d {
    constructor(network, apiKey){
        $8044ebfe209f61e4$var$logger.checkAbstract(new.target, $8044ebfe209f61e4$export$664128d6239ccf96);
        // Normalize the Network and API Key
        network = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getNetwork")(network);
        apiKey = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getApiKey")(apiKey);
        const connection = (0, $a463a6b5f08d6875$export$f695fbbf3cdaaf47)(new.target, "getUrl")(network, apiKey);
        super(connection, network);
        if (typeof apiKey === "string") (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach((key)=>{
            (0, $a463a6b5f08d6875$export$104236534534f9be)(this, key, apiKey[key]);
        });
    }
    _startPending() {
        $8044ebfe209f61e4$var$logger.warn("WARNING: API provider does not support pending filters");
    }
    isCommunityResource() {
        return false;
    }
    getSigner(address) {
        return $8044ebfe209f61e4$var$logger.throwError("API provider does not support signing", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "getSigner"
        });
    }
    listAccounts() {
        return Promise.resolve([]);
    }
    // Return a defaultApiKey if null, otherwise validate the API key
    static getApiKey(apiKey) {
        return apiKey;
    }
    // Returns the url or connection for the given network and API key. The
    // API key will have been sanitized by the getApiKey first, so any validation
    // or transformations can be done there.
    static getUrl(network, apiKey) {
        return $8044ebfe209f61e4$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
            operation: "getUrl"
        });
    }
}


"use strict";
const $e94c62bb842b5925$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
const $e94c62bb842b5925$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class $e94c62bb842b5925$export$f6c13301c7b76371 extends (0, $f2ba8b3ea7dcf3ca$export$bfafe629242f30bd) {
    constructor(network, apiKey){
        const provider = new $e94c62bb842b5925$export$999cc40da3fbc6f(network, apiKey);
        const url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        super(url, provider.network);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "apiKey", provider.apiKey);
    }
    isCommunityResource() {
        return this.apiKey === $e94c62bb842b5925$var$defaultApiKey;
    }
}
class $e94c62bb842b5925$export$999cc40da3fbc6f extends (0, $8044ebfe209f61e4$export$664128d6239ccf96) {
    static getWebSocketProvider(network, apiKey) {
        return new $e94c62bb842b5925$export$f6c13301c7b76371(network, apiKey);
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $e94c62bb842b5925$var$defaultApiKey;
        if (apiKey && typeof apiKey !== "string") $e94c62bb842b5925$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "eth-mainnet.alchemyapi.io/v2/";
                break;
            case "goerli":
                host = "eth-goerli.g.alchemy.com/v2/";
                break;
            case "matic":
                host = "polygon-mainnet.g.alchemy.com/v2/";
                break;
            case "maticmum":
                host = "polygon-mumbai.g.alchemy.com/v2/";
                break;
            case "arbitrum":
                host = "arb-mainnet.g.alchemy.com/v2/";
                break;
            case "arbitrum-goerli":
                host = "arb-goerli.g.alchemy.com/v2/";
                break;
            case "optimism":
                host = "opt-mainnet.g.alchemy.com/v2/";
                break;
            case "optimism-goerli":
                host = "opt-goerli.g.alchemy.com/v2/";
                break;
            default:
                $e94c62bb842b5925$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return {
            allowGzip: true,
            url: "https://" + host + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey === $e94c62bb842b5925$var$defaultApiKey) (0, $dc6c759982861e14$export$4c41bd49e82e82ab)();
                return Promise.resolve(true);
            }
        };
    }
    isCommunityResource() {
        return this.apiKey === $e94c62bb842b5925$var$defaultApiKey;
    }
}






const $efd7dc521b26566c$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
const $efd7dc521b26566c$var$defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function $efd7dc521b26566c$var$getHost(name) {
    switch(name){
        case "homestead":
            return "rpc.ankr.com/eth/";
        case "ropsten":
            return "rpc.ankr.com/eth_ropsten/";
        case "rinkeby":
            return "rpc.ankr.com/eth_rinkeby/";
        case "goerli":
            return "rpc.ankr.com/eth_goerli/";
        case "matic":
            return "rpc.ankr.com/polygon/";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum/";
    }
    return $efd7dc521b26566c$var$logger.throwArgumentError("unsupported network", "name", name);
}
class $efd7dc521b26566c$export$72783b2aefa72a45 extends (0, $8044ebfe209f61e4$export$664128d6239ccf96) {
    isCommunityResource() {
        return this.apiKey === $efd7dc521b26566c$var$defaultApiKey;
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $efd7dc521b26566c$var$defaultApiKey;
        return apiKey;
    }
    static getUrl(network, apiKey) {
        if (apiKey == null) apiKey = $efd7dc521b26566c$var$defaultApiKey;
        const connection = {
            allowGzip: true,
            url: "https://" + $efd7dc521b26566c$var$getHost(network.name) + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey.apiKey === $efd7dc521b26566c$var$defaultApiKey) (0, $dc6c759982861e14$export$4c41bd49e82e82ab)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
}





"use strict";
var $cdd214e3d1599302$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $cdd214e3d1599302$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
class $cdd214e3d1599302$export$7113381f8f264fc0 extends (0, $8044ebfe209f61e4$export$664128d6239ccf96) {
    static getApiKey(apiKey) {
        if (apiKey != null) $cdd214e3d1599302$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
        return null;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://cloudflare-eth.com/";
                break;
            default:
                $cdd214e3d1599302$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host;
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $cdd214e3d1599302$var$__awaiter(this, void 0, void 0, function*() {
            // The Cloudflare provider does not support eth_blockNumber,
            // so we get the latest block and pull it from that
            if (method === "getBlockNumber") {
                const block = yield _super.perform.call(this, "getBlock", {
                    blockTag: "latest"
                });
                return block.number;
            }
            return _super.perform.call(this, method, params);
        });
    }
}










"use strict";
var $d7687248e25a81ef$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d7687248e25a81ef$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
// The transaction has already been sanitized by the calls in Provider
function $d7687248e25a81ef$var$getTransactionPostData(transaction) {
    const result = {};
    for(let key in transaction){
        if (transaction[key] == null) continue;
        let value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $7b88b6e03e4708f2$export$6916af760a341dd3)((0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value));
        else if (key === "accessList") value = "[" + (0, $0a7021bc70fec74d$export$6c8662b1600dce2)(value).map((set)=>{
            return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
        }).join(",") + "]";
        else value = (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)(value);
        result[key] = value;
    }
    return result;
}
function $d7687248e25a81ef$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || typeof result.message !== "string" || !result.message.match(/^OK/)) {
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $d7687248e25a81ef$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        const error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        throw error;
    }
    if (result.error) {
        // @TODO: not any
        const error = new Error(result.error.message || "unknown error");
        if (result.error.code) error.code = result.error.code;
        if (result.error.data) error.data = result.error.data;
        throw error;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $d7687248e25a81ef$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
function $d7687248e25a81ef$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR) {
        const e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            let data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(data)) return data;
            $d7687248e25a81ef$var$logger.throwError("missing revert data in call exception", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    let message = error.message;
    if (error.code === (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $d7687248e25a81ef$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $d7687248e25a81ef$var$logger.throwError("nonce has already been used", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $d7687248e25a81ef$var$logger.throwError("replacement fee too low", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $d7687248e25a81ef$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
class $d7687248e25a81ef$export$dd1d942a536c7912 extends (0, $43e733c7f2a529c1$export$ff3f6dd83125ac45) {
    constructor(network, apiKey){
        super(network);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "baseUrl", this.getBaseUrl());
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "apiKey", apiKey || null);
    }
    getBaseUrl() {
        switch(this.network ? this.network.name : "invalid"){
            case "homestead":
                return "https://api.etherscan.io";
            case "goerli":
                return "https://api-goerli.etherscan.io";
            case "sepolia":
                return "https://api-sepolia.etherscan.io";
            case "matic":
                return "https://api.polygonscan.com";
            case "maticmum":
                return "https://api-testnet.polygonscan.com";
            case "arbitrum":
                return "https://api.arbiscan.io";
            case "arbitrum-goerli":
                return "https://api-goerli.arbiscan.io";
            case "optimism":
                return "https://api-optimistic.etherscan.io";
            case "optimism-goerli":
                return "https://api-goerli-optimistic.etherscan.io";
            default:
        }
        return $d7687248e25a81ef$var$logger.throwArgumentError("unsupported network", "network", this.network.name);
    }
    getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key)=>{
            const value = params[key];
            if (value != null) accum += `&${key}=${value}`;
            return accum;
        }, "");
        const apiKey = this.apiKey ? `&apikey=${this.apiKey}` : "";
        return `${this.baseUrl}/api?module=${module}${query}${apiKey}`;
    }
    getPostUrl() {
        return `${this.baseUrl}/api`;
    }
    getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    fetch(module, params, post) {
        return $d7687248e25a81ef$var$__awaiter(this, void 0, void 0, function*() {
            const url = post ? this.getPostUrl() : this.getUrl(module, params);
            const payload = post ? this.getPostData(module, params) : null;
            const procFunc = module === "proxy" ? $d7687248e25a81ef$var$getJsonResult : $d7687248e25a81ef$var$getResult;
            this.emit("debug", {
                action: "request",
                request: url,
                provider: this
            });
            const connection = {
                url: url,
                throttleSlotInterval: 1000,
                throttleCallback: (attempt, url)=>{
                    if (this.isCommunityResource()) (0, $dc6c759982861e14$export$4c41bd49e82e82ab)();
                    return Promise.resolve(true);
                }
            };
            let payloadStr = null;
            if (payload) {
                connection.headers = {
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                };
                payloadStr = Object.keys(payload).map((key)=>{
                    return `${key}=${payload[key]}`;
                }).join("&");
            }
            const result = yield (0, $4d026a5befa5b358$export$6d71b655afe1638d)(connection, payloadStr, procFunc || $d7687248e25a81ef$var$getJsonResult);
            this.emit("debug", {
                action: "response",
                request: url,
                response: (0, $a463a6b5f08d6875$export$6c40052bed430212)(result),
                provider: this
            });
            return result;
        });
    }
    detectNetwork() {
        return $d7687248e25a81ef$var$__awaiter(this, void 0, void 0, function*() {
            return this.network;
        });
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $d7687248e25a81ef$var$__awaiter(this, void 0, void 0, function*() {
            switch(method){
                case "getBlockNumber":
                    return this.fetch("proxy", {
                        action: "eth_blockNumber"
                    });
                case "getGasPrice":
                    return this.fetch("proxy", {
                        action: "eth_gasPrice"
                    });
                case "getBalance":
                    // Returns base-10 result
                    return this.fetch("account", {
                        action: "balance",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getTransactionCount":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionCount",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getCode":
                    return this.fetch("proxy", {
                        action: "eth_getCode",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getStorageAt":
                    return this.fetch("proxy", {
                        action: "eth_getStorageAt",
                        address: params.address,
                        position: params.position,
                        tag: params.blockTag
                    });
                case "sendTransaction":
                    return this.fetch("proxy", {
                        action: "eth_sendRawTransaction",
                        hex: params.signedTransaction
                    }, true).catch((error)=>{
                        return $d7687248e25a81ef$var$checkError("sendTransaction", error, params.signedTransaction);
                    });
                case "getBlock":
                    if (params.blockTag) return this.fetch("proxy", {
                        action: "eth_getBlockByNumber",
                        tag: params.blockTag,
                        boolean: params.includeTransactions ? "true" : "false"
                    });
                    throw new Error("getBlock by blockHash not implemented");
                case "getTransaction":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionByHash",
                        txhash: params.transactionHash
                    });
                case "getTransactionReceipt":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionReceipt",
                        txhash: params.transactionHash
                    });
                case "call":
                    {
                        if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                        const postData = $d7687248e25a81ef$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_call";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $d7687248e25a81ef$var$checkError("call", error, params.transaction);
                        }
                    }
                case "estimateGas":
                    {
                        const postData = $d7687248e25a81ef$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_estimateGas";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $d7687248e25a81ef$var$checkError("estimateGas", error, params.transaction);
                        }
                    }
                case "getLogs":
                    {
                        const args = {
                            action: "getLogs"
                        };
                        if (params.filter.fromBlock) args.fromBlock = $d7687248e25a81ef$var$checkLogTag(params.filter.fromBlock);
                        if (params.filter.toBlock) args.toBlock = $d7687248e25a81ef$var$checkLogTag(params.filter.toBlock);
                        if (params.filter.address) args.address = params.filter.address;
                        // @TODO: We can handle slightly more complicated logs using the logs API
                        if (params.filter.topics && params.filter.topics.length > 0) {
                            if (params.filter.topics.length > 1) $d7687248e25a81ef$var$logger.throwError("unsupported topic count", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                topics: params.filter.topics
                            });
                            if (params.filter.topics.length === 1) {
                                const topic0 = params.filter.topics[0];
                                if (typeof topic0 !== "string" || topic0.length !== 66) $d7687248e25a81ef$var$logger.throwError("unsupported topic format", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                    topic0: topic0
                                });
                                args.topic0 = topic0;
                            }
                        }
                        const logs = yield this.fetch("logs", args);
                        // Cache txHash => blockHash
                        let blocks = {};
                        // Add any missing blockHash to the logs
                        for(let i = 0; i < logs.length; i++){
                            const log = logs[i];
                            if (log.blockHash != null) continue;
                            if (blocks[log.blockNumber] == null) {
                                const block = yield this.getBlock(log.blockNumber);
                                if (block) blocks[log.blockNumber] = block.hash;
                            }
                            log.blockHash = blocks[log.blockNumber];
                        }
                        return logs;
                    }
                case "getEtherPrice":
                    if (this.network.name !== "homestead") return 0.0;
                    return parseFloat((yield this.fetch("stats", {
                        action: "ethprice"
                    })).ethusd);
                default:
                    break;
            }
            return _super.perform.call(this, method, params);
        });
    }
    // Note: The `page` page parameter only allows pagination within the
    //       10,000 window available without a page and offset parameter
    //       Error: Result window is too large, PageNo x Offset size must
    //              be less than or equal to 10000
    getHistory(addressOrName, startBlock, endBlock) {
        return $d7687248e25a81ef$var$__awaiter(this, void 0, void 0, function*() {
            const params = {
                action: "txlist",
                address: yield this.resolveName(addressOrName),
                startblock: startBlock == null ? 0 : startBlock,
                endblock: endBlock == null ? 99999999 : endBlock,
                sort: "asc"
            };
            const result = yield this.fetch("account", params);
            return result.map((tx)=>{
                [
                    "contractAddress",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == "") delete tx[key];
                });
                if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                const item = this.formatter.transactionResponse(tx);
                if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                return item;
            });
        });
    }
    isCommunityResource() {
        return this.apiKey == null;
    }
}






"use strict";
function $dc90334677e5edd7$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}







"use strict";
var $14eaab77c6d2e466$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $14eaab77c6d2e466$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
function $14eaab77c6d2e466$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $14eaab77c6d2e466$var$checkNetworks(networks) {
    let result = null;
    for(let i = 0; i < networks.length; i++){
        const network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $14eaab77c6d2e466$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $14eaab77c6d2e466$var$median(values, maxDelta) {
    values = values.slice().sort();
    const middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    const a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $14eaab77c6d2e466$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $0df4577496dcf693$export$d97aa349ed20696).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map((i)=>$14eaab77c6d2e466$var$serialize(i)));
    else if (typeof value === "object") {
        const keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map((key)=>{
            let v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $14eaab77c6d2e466$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + typeof value);
}
// Next request ID to use for emitting debug info
let $14eaab77c6d2e466$var$nextRid = 1;
function $14eaab77c6d2e466$var$stall(duration) {
    let cancel = null;
    let timer = null;
    let promise = new Promise((resolve)=>{
        cancel = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    const wait = (func)=>{
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
const $14eaab77c6d2e466$var$ForwardErrors = [
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.CALL_EXCEPTION,
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS,
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NONCE_EXPIRED,
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED,
    (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT
];
const $14eaab77c6d2e466$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $14eaab77c6d2e466$var$exposeDebugConfig(config, now) {
    const result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: ()=>config.provider
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $14eaab77c6d2e466$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        const tally = {};
        configs.forEach((c)=>{
            const value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        const keys = Object.keys(tally);
        for(let i = 0; i < keys.length; i++){
            const check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $14eaab77c6d2e466$var$getProcessFunc(provider, method, params) {
    let normalize = $14eaab77c6d2e466$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                // Get the median block number
                let blockNumber = $14eaab77c6d2e466$var$median(configs.map((c)=>c.result), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $14eaab77c6d2e466$var$median(configs.map((c)=>c.result));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function(tx) {
                if (tx == null) return null;
                tx = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(tx);
                tx.confirmations = -1;
                return $14eaab77c6d2e466$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function(block) {
                if (block == null) return null;
                block = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(block);
                block.transactions = block.transactions.map((tx)=>{
                    tx = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $14eaab77c6d2e466$var$serialize(block);
            };
            else normalize = function(block) {
                if (block == null) return null;
                return $14eaab77c6d2e466$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $14eaab77c6d2e466$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $14eaab77c6d2e466$var$waitForSync(config, blockNumber) {
    return $14eaab77c6d2e466$var$__awaiter(this, void 0, void 0, function*() {
        const provider = config.provider;
        if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return provider;
        return (0, $4d026a5befa5b358$export$e0c10349b2c5e1d4)(()=>{
            return new Promise((resolve, reject)=>{
                setTimeout(function() {
                    // We are synced
                    if (provider.blockNumber >= blockNumber) return resolve(provider);
                    // We're done; just quit
                    if (config.cancelled) return resolve(null);
                    // Try again, next block
                    return resolve(undefined);
                }, 0);
            });
        }, {
            oncePoll: provider
        });
    });
}
function $14eaab77c6d2e466$var$getRunner(config, currentBlockNumber, method, params) {
    return $14eaab77c6d2e466$var$__awaiter(this, void 0, void 0, function*() {
        let provider = config.provider;
        switch(method){
            case "getBlockNumber":
            case "getGasPrice":
                return provider[method]();
            case "getEtherPrice":
                if (provider.getEtherPrice) return provider.getEtherPrice();
                break;
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
                if (params.blockTag && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                return provider[method](params.address, params.blockTag || "latest");
            case "getStorageAt":
                if (params.blockTag && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                return provider.getStorageAt(params.address, params.position, params.blockTag || "latest");
            case "getBlock":
                if (params.blockTag && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                return provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash);
            case "call":
            case "estimateGas":
                if (params.blockTag && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                if (method === "call" && params.blockTag) return provider[method](params.transaction, params.blockTag);
                return provider[method](params.transaction);
            case "getTransaction":
            case "getTransactionReceipt":
                return provider[method](params.transactionHash);
            case "getLogs":
                {
                    let filter = params.filter;
                    if (filter.fromBlock && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(filter.fromBlock) || filter.toBlock && (0, $7b88b6e03e4708f2$export$b02a40aff8e4ad18)(filter.toBlock)) provider = yield $14eaab77c6d2e466$var$waitForSync(config, currentBlockNumber);
                    return provider.getLogs(filter);
                }
        }
        return $14eaab77c6d2e466$var$logger.throwError("unknown method error", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {
            method: method,
            params: params
        });
    });
}
class $14eaab77c6d2e466$export$cb1d0beacb55feb7 extends (0, $43e733c7f2a529c1$export$ff3f6dd83125ac45) {
    constructor(providers, quorum){
        if (providers.length === 0) $14eaab77c6d2e466$var$logger.throwArgumentError("missing providers", "providers", providers);
        const providerConfigs = providers.map((configOrProvider, index)=>{
            if ((0, $81658ac0a17fba50$export$2881499e37b75b9a).isProvider(configOrProvider)) {
                const stallTimeout = (0, $dc6c759982861e14$export$d93d5f61c2498b6)(configOrProvider) ? 2000 : 750;
                const priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            const config = (0, $a463a6b5f08d6875$export$9c13236873b118a5)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $dc6c759982861e14$export$d93d5f61c2498b6)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            const weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $14eaab77c6d2e466$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${index}].weight`, weight);
            return Object.freeze(config);
        });
        const total = providerConfigs.reduce((accum, c)=>accum + c.weight, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $14eaab77c6d2e466$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        let networkOrReady = $14eaab77c6d2e466$var$checkNetworks(providerConfigs.map((c)=>c.provider.network));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        super(networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "providerConfigs", Object.freeze(providerConfigs));
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "quorum", quorum);
        this._highestBlockNumber = -1;
    }
    detectNetwork() {
        return $14eaab77c6d2e466$var$__awaiter(this, void 0, void 0, function*() {
            const networks = yield Promise.all(this.providerConfigs.map((c)=>c.provider.getNetwork()));
            return $14eaab77c6d2e466$var$checkNetworks(networks);
        });
    }
    perform(method, params) {
        return $14eaab77c6d2e466$var$__awaiter(this, void 0, void 0, function*() {
            // Sending transactions is special; always broadcast it to all backends
            if (method === "sendTransaction") {
                const results = yield Promise.all(this.providerConfigs.map((c)=>{
                    return c.provider.sendTransaction(params.signedTransaction).then((result)=>{
                        return result.hash;
                    }, (error)=>{
                        return error;
                    });
                }));
                // Any success is good enough (other errors are likely "already seen" errors
                for(let i = 0; i < results.length; i++){
                    const result = results[i];
                    if (typeof result === "string") return result;
                }
                // They were all an error; pick the first error
                throw results[0];
            }
            // We need to make sure we are in sync with our backends, so we need
            // to know this before we can make a lot of calls
            if (this._highestBlockNumber === -1 && method !== "getBlockNumber") yield this.getBlockNumber();
            const processFunc = $14eaab77c6d2e466$var$getProcessFunc(this, method, params);
            // Shuffle the providers and then sort them by their priority; we
            // shallowCopy them since we will store the result in them too
            const configs = (0, $dc90334677e5edd7$export$e6c7296801b9b341)(this.providerConfigs.map((0, $a463a6b5f08d6875$export$9c13236873b118a5)));
            configs.sort((a, b)=>a.priority - b.priority);
            const currentBlockNumber = this._highestBlockNumber;
            let i = 0;
            let first = true;
            while(true){
                const t0 = $14eaab77c6d2e466$var$now();
                // Compute the inflight weight (exclude anything past)
                let inflightWeight = configs.filter((c)=>c.runner && t0 - c.start < c.stallTimeout).reduce((accum, c)=>accum + c.weight, 0);
                // Start running enough to meet quorum
                while(inflightWeight < this.quorum && i < configs.length){
                    const config = configs[i++];
                    const rid = $14eaab77c6d2e466$var$nextRid++;
                    config.start = $14eaab77c6d2e466$var$now();
                    config.staller = $14eaab77c6d2e466$var$stall(config.stallTimeout);
                    config.staller.wait(()=>{
                        config.staller = null;
                    });
                    config.runner = $14eaab77c6d2e466$var$getRunner(config, currentBlockNumber, method, params).then((result)=>{
                        config.done = true;
                        config.result = result;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $14eaab77c6d2e466$var$exposeDebugConfig(config, $14eaab77c6d2e466$var$now()),
                            request: {
                                method: method,
                                params: (0, $a463a6b5f08d6875$export$6c40052bed430212)(params)
                            },
                            provider: this
                        });
                    }, (error)=>{
                        config.done = true;
                        config.error = error;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $14eaab77c6d2e466$var$exposeDebugConfig(config, $14eaab77c6d2e466$var$now()),
                            request: {
                                method: method,
                                params: (0, $a463a6b5f08d6875$export$6c40052bed430212)(params)
                            },
                            provider: this
                        });
                    });
                    if (this.listenerCount("debug")) this.emit("debug", {
                        action: "request",
                        rid: rid,
                        backend: $14eaab77c6d2e466$var$exposeDebugConfig(config, null),
                        request: {
                            method: method,
                            params: (0, $a463a6b5f08d6875$export$6c40052bed430212)(params)
                        },
                        provider: this
                    });
                    inflightWeight += config.weight;
                }
                // Wait for anything meaningful to finish or stall out
                const waiting = [];
                configs.forEach((c)=>{
                    if (c.done || !c.runner) return;
                    waiting.push(c.runner);
                    if (c.staller) waiting.push(c.staller.getPromise());
                });
                if (waiting.length) yield Promise.race(waiting);
                // Check the quorum and process the results; the process function
                // may additionally decide the quorum is not met
                const results = configs.filter((c)=>c.done && c.error == null);
                if (results.length >= this.quorum) {
                    const result = processFunc(results);
                    if (result !== undefined) {
                        // Shut down any stallers
                        configs.forEach((c)=>{
                            if (c.staller) c.staller.cancel();
                            c.cancelled = true;
                        });
                        return result;
                    }
                    if (!first) yield $14eaab77c6d2e466$var$stall(100).getPromise();
                    first = false;
                }
                // No result, check for errors that should be forwarded
                const errors = configs.reduce((accum, c)=>{
                    if (!c.done || c.error == null) return accum;
                    const code = c.error.code;
                    if ($14eaab77c6d2e466$var$ForwardErrors.indexOf(code) >= 0) {
                        if (!accum[code]) accum[code] = {
                            error: c.error,
                            weight: 0
                        };
                        accum[code].weight += c.weight;
                    }
                    return accum;
                }, {});
                Object.keys(errors).forEach((errorCode)=>{
                    const tally = errors[errorCode];
                    if (tally.weight < this.quorum) return;
                    // Shut down any stallers
                    configs.forEach((c)=>{
                        if (c.staller) c.staller.cancel();
                        c.cancelled = true;
                    });
                    const e = tally.error;
                    const props = {};
                    $14eaab77c6d2e466$var$ForwardProperties.forEach((name)=>{
                        if (e[name] == null) return;
                        props[name] = e[name];
                    });
                    $14eaab77c6d2e466$var$logger.throwError(e.reason || e.message, errorCode, props);
                });
                // All configs have run to completion; we will never get more data
                if (configs.filter((c)=>!c.done).length === 0) break;
            }
            // Shut down any stallers; shouldn't be any
            configs.forEach((c)=>{
                if (c.staller) c.staller.cancel();
                c.cancelled = true;
            });
            return $14eaab77c6d2e466$var$logger.throwError("failed to meet quorum", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.SERVER_ERROR, {
                method: method,
                params: params,
                //results: configs.map((c) => c.result),
                //errors: configs.map((c) => c.error),
                results: configs.map((c)=>$14eaab77c6d2e466$var$exposeDebugConfig(c)),
                provider: this
            });
        });
    }
}


"use strict";
const $9b4b4c9da3406148$export$fbe151f90a1ece01 = null;








"use strict";
const $1be1b51d2ba5e5c5$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
const $1be1b51d2ba5e5c5$var$defaultProjectId = "84842078b09946638c03157f83405213";
class $1be1b51d2ba5e5c5$export$dd168a807d60da4f extends (0, $f2ba8b3ea7dcf3ca$export$bfafe629242f30bd) {
    constructor(network, apiKey){
        const provider = new $1be1b51d2ba5e5c5$export$60ff1a559b5c6ebd(network, apiKey);
        const connection = provider.connection;
        if (connection.password) $1be1b51d2ba5e5c5$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        const url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, network);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "apiKey", provider.projectId);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "projectId", provider.projectId);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "projectSecret", provider.projectSecret);
    }
    isCommunityResource() {
        return this.projectId === $1be1b51d2ba5e5c5$var$defaultProjectId;
    }
}
class $1be1b51d2ba5e5c5$export$60ff1a559b5c6ebd extends (0, $8044ebfe209f61e4$export$664128d6239ccf96) {
    static getWebSocketProvider(network, apiKey) {
        return new $1be1b51d2ba5e5c5$export$dd168a807d60da4f(network, apiKey);
    }
    static getApiKey(apiKey) {
        const apiKeyObj = {
            apiKey: $1be1b51d2ba5e5c5$var$defaultProjectId,
            projectId: $1be1b51d2ba5e5c5$var$defaultProjectId,
            projectSecret: null
        };
        if (apiKey == null) return apiKeyObj;
        if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
        else if (apiKey.projectSecret != null) {
            $1be1b51d2ba5e5c5$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
            $1be1b51d2ba5e5c5$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
            apiKeyObj.projectId = apiKey.projectId;
            apiKeyObj.projectSecret = apiKey.projectSecret;
        } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
        apiKeyObj.apiKey = apiKeyObj.projectId;
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "homestead":
                host = "mainnet.infura.io";
                break;
            case "goerli":
                host = "goerli.infura.io";
                break;
            case "sepolia":
                host = "sepolia.infura.io";
                break;
            case "matic":
                host = "polygon-mainnet.infura.io";
                break;
            case "maticmum":
                host = "polygon-mumbai.infura.io";
                break;
            case "optimism":
                host = "optimism-mainnet.infura.io";
                break;
            case "optimism-goerli":
                host = "optimism-goerli.infura.io";
                break;
            case "arbitrum":
                host = "arbitrum-mainnet.infura.io";
                break;
            case "arbitrum-goerli":
                host = "arbitrum-goerli.infura.io";
                break;
            default:
                $1be1b51d2ba5e5c5$var$logger.throwError("unsupported network", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const connection = {
            allowGzip: true,
            url: "https://" + host + "/v3/" + apiKey.projectId,
            throttleCallback: (attempt, url)=>{
                if (apiKey.projectId === $1be1b51d2ba5e5c5$var$defaultProjectId) (0, $dc6c759982861e14$export$4c41bd49e82e82ab)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
    isCommunityResource() {
        return this.projectId === $1be1b51d2ba5e5c5$var$defaultProjectId;
    }
}






class $a926fa2c67f65d9a$export$5a16092bf20edf97 extends (0, $e32f9441afb0a406$export$da28308012bf6748) {
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        if (this._pendingBatch == null) this._pendingBatch = [];
        const inflightRequest = {
            request: request,
            resolve: null,
            reject: null
        };
        const promise = new Promise((resolve, reject)=>{
            inflightRequest.resolve = resolve;
            inflightRequest.reject = reject;
        });
        this._pendingBatch.push(inflightRequest);
        if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
        this._pendingBatchAggregator = setTimeout(()=>{
            // Get teh current batch and clear it, so new requests
            // go into the next batch
            const batch = this._pendingBatch;
            this._pendingBatch = null;
            this._pendingBatchAggregator = null;
            // Get the request as an array of requests
            const request = batch.map((inflight)=>inflight.request);
            this.emit("debug", {
                action: "requestBatch",
                request: (0, $a463a6b5f08d6875$export$6c40052bed430212)(request),
                provider: this
            });
            return (0, $4d026a5befa5b358$export$6d71b655afe1638d)(this.connection, JSON.stringify(request)).then((result)=>{
                this.emit("debug", {
                    action: "response",
                    request: request,
                    response: result,
                    provider: this
                });
                // For each result, feed it to the correct Promise, depending
                // on whether it was a success or error
                batch.forEach((inflightRequest, index)=>{
                    const payload = result[index];
                    if (payload.error) {
                        const error = new Error(payload.error.message);
                        error.code = payload.error.code;
                        error.data = payload.error.data;
                        inflightRequest.reject(error);
                    } else inflightRequest.resolve(payload.result);
                });
            }, (error)=>{
                this.emit("debug", {
                    action: "response",
                    error: error,
                    request: request,
                    provider: this
                });
                batch.forEach((inflightRequest)=>{
                    inflightRequest.reject(error);
                });
            });
        }, 10);
        return promise;
    }
}


/* istanbul ignore file */ 


"use strict";
const $dcb00489ffa41a84$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
// Special API key provided by Nodesmith for ethers.js
const $dcb00489ffa41a84$var$defaultApiKey = "ETHERS_JS_SHARED";
class $dcb00489ffa41a84$export$8235cbce3ce273bd extends (0, $8044ebfe209f61e4$export$664128d6239ccf96) {
    static getApiKey(apiKey) {
        if (apiKey && typeof apiKey !== "string") $dcb00489ffa41a84$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey || $dcb00489ffa41a84$var$defaultApiKey;
    }
    static getUrl(network, apiKey) {
        $dcb00489ffa41a84$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                break;
            case "ropsten":
                host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                break;
            case "rinkeby":
                host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                break;
            case "goerli":
                host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                break;
            case "kovan":
                host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                break;
            default:
                $dcb00489ffa41a84$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host + "?apiKey=" + apiKey;
    }
}





"use strict";
const $fbe10c5df3b2b203$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
const $fbe10c5df3b2b203$var$defaultApplicationId = "62e1ad51b37b8e00394bda3b";
class $fbe10c5df3b2b203$export$58bb47e42f6b092e extends (0, $8044ebfe209f61e4$export$664128d6239ccf96) {
    static getApiKey(apiKey) {
        const apiKeyObj = {
            applicationId: null,
            loadBalancer: true,
            applicationSecretKey: null
        };
        // Parse applicationId and applicationSecretKey
        if (apiKey == null) apiKeyObj.applicationId = $fbe10c5df3b2b203$var$defaultApplicationId;
        else if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
        else if (apiKey.applicationSecretKey != null) {
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
        } else if (apiKey.applicationId) apiKeyObj.applicationId = apiKey.applicationId;
        else $fbe10c5df3b2b203$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "goerli":
                host = "eth-goerli.gateway.pokt.network";
                break;
            case "homestead":
                host = "eth-mainnet.gateway.pokt.network";
                break;
            case "kovan":
                host = "poa-kovan.gateway.pokt.network";
                break;
            case "matic":
                host = "poly-mainnet.gateway.pokt.network";
                break;
            case "maticmum":
                host = "polygon-mumbai-rpc.gateway.pokt.network";
                break;
            case "rinkeby":
                host = "eth-rinkeby.gateway.pokt.network";
                break;
            case "ropsten":
                host = "eth-ropsten.gateway.pokt.network";
                break;
            default:
                $fbe10c5df3b2b203$var$logger.throwError("unsupported network", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const url = `https:/\/${host}/v1/lb/${apiKey.applicationId}`;
        const connection = {
            headers: {},
            url: url
        };
        if (apiKey.applicationSecretKey != null) {
            connection.user = "";
            connection.password = apiKey.applicationSecretKey;
        }
        return connection;
    }
    isCommunityResource() {
        return this.applicationId === $fbe10c5df3b2b203$var$defaultApplicationId;
    }
}







"use strict";
const $c7f9e560d629e6df$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
let $c7f9e560d629e6df$var$_nextId = 1;
function $c7f9e560d629e6df$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    const fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        const request = {
            method: method,
            params: params,
            id: $c7f9e560d629e6df$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise((resolve, reject)=>{
            this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $a463a6b5f08d6875$export$6c40052bed430212)(request),
                provider: this
            });
            sendFunc(request, (error, response)=>{
                if (error) {
                    this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: this
                    });
                    return reject(error);
                }
                this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: this
                });
                if (response.error) {
                    const error = new Error(response.error.message);
                    error.code = response.error.code;
                    error.data = response.error.data;
                    return reject(error);
                }
                resolve(response.result);
            });
        });
    };
}
function $c7f9e560d629e6df$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        if (params == null) params = [];
        const request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $a463a6b5f08d6875$export$6c40052bed430212)(request),
            provider: this
        });
        return provider.request(request).then((response)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: this
            });
            return response;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: this
            });
            throw error;
        });
    };
}
class $c7f9e560d629e6df$export$d05096c9fd9d936d extends (0, $e32f9441afb0a406$export$da28308012bf6748) {
    constructor(provider, network){
        if (provider == null) $c7f9e560d629e6df$var$logger.throwArgumentError("missing provider", "provider", provider);
        let path = null;
        let jsonRpcFetchFunc = null;
        let subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $c7f9e560d629e6df$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $c7f9e560d629e6df$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $c7f9e560d629e6df$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $c7f9e560d629e6df$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        super(path, network);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $a463a6b5f08d6875$export$104236534534f9be)(this, "provider", subprovider);
    }
    send(method, params) {
        return this.jsonRpcFetchFunc(method, params);
    }
}






"use strict";
const $859153647bbc688f$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $fd8f67b80e142427$export$83d89fbfd8236492));
////////////////////////
// Helper Functions
function $859153647bbc688f$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        const match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1].toLowerCase()){
            case "http":
            case "https":
                return new (0, $e32f9441afb0a406$export$da28308012bf6748)(network);
            case "ws":
            case "wss":
                return new (0, $f2ba8b3ea7dcf3ca$export$bfafe629242f30bd)(network);
            default:
                $859153647bbc688f$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    const n = (0, $17c84d4c9be9446e$export$7de4970ebfd8206d)(network);
    if (!n || !n._defaultProvider) $859153647bbc688f$var$logger.throwError("unsupported getDefaultProvider network", (0, $97a8d5981d597bb7$export$efa9a398d6368992).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: $14eaab77c6d2e466$export$cb1d0beacb55feb7,
        AlchemyProvider: $e94c62bb842b5925$export$999cc40da3fbc6f,
        AnkrProvider: $efd7dc521b26566c$export$72783b2aefa72a45,
        CloudflareProvider: $cdd214e3d1599302$export$7113381f8f264fc0,
        EtherscanProvider: $d7687248e25a81ef$export$dd1d942a536c7912,
        InfuraProvider: $1be1b51d2ba5e5c5$export$60ff1a559b5c6ebd,
        JsonRpcProvider: $e32f9441afb0a406$export$da28308012bf6748,
        NodesmithProvider: $dcb00489ffa41a84$export$8235cbce3ce273bd,
        PocketProvider: $fbe10c5df3b2b203$export$58bb47e42f6b092e,
        Web3Provider: $c7f9e560d629e6df$export$d05096c9fd9d936d,
        IpcProvider: $9b4b4c9da3406148$export$fbe151f90a1ece01
    }, options);
}



var $0e788201f8a90b1e$exports = {};

$parcel$export($0e788201f8a90b1e$exports, "AbiCoder", () => $2f97e4c6f3904f5b$export$fe041e1a83d3efc6);
$parcel$export($0e788201f8a90b1e$exports, "defaultAbiCoder", () => $2f97e4c6f3904f5b$export$51d1cfcdb913adff);
$parcel$export($0e788201f8a90b1e$exports, "Fragment", () => $871a765ee5e657d2$export$ffb0004e005737fa);
$parcel$export($0e788201f8a90b1e$exports, "ConstructorFragment", () => $871a765ee5e657d2$export$3ac5c9504f801ea4);
$parcel$export($0e788201f8a90b1e$exports, "ErrorFragment", () => $871a765ee5e657d2$export$2c42c6d543aa9b59);
$parcel$export($0e788201f8a90b1e$exports, "EventFragment", () => $871a765ee5e657d2$export$958548f08bac2833);
$parcel$export($0e788201f8a90b1e$exports, "FunctionFragment", () => $871a765ee5e657d2$export$8d576c928b93668f);
$parcel$export($0e788201f8a90b1e$exports, "ParamType", () => $871a765ee5e657d2$export$426dc07f493a4c47);
$parcel$export($0e788201f8a90b1e$exports, "FormatTypes", () => $871a765ee5e657d2$export$f010f239efc4d445);
$parcel$export($0e788201f8a90b1e$exports, "checkResultErrors", () => $2c0f0ed4c5bed241$export$5546b9ec21157cc2);
$parcel$export($0e788201f8a90b1e$exports, "Logger", () => $97a8d5981d597bb7$export$efa9a398d6368992);
$parcel$export($0e788201f8a90b1e$exports, "RLP", () => $6ff2d0f6bfa15181$exports);
$parcel$export($0e788201f8a90b1e$exports, "_fetchData", () => $4d026a5befa5b358$export$e37fa27017c6c012);
$parcel$export($0e788201f8a90b1e$exports, "fetchJson", () => $4d026a5befa5b358$export$6d71b655afe1638d);
$parcel$export($0e788201f8a90b1e$exports, "poll", () => $4d026a5befa5b358$export$e0c10349b2c5e1d4);
$parcel$export($0e788201f8a90b1e$exports, "checkProperties", () => $a463a6b5f08d6875$export$ae5a316ba623b73a);
$parcel$export($0e788201f8a90b1e$exports, "deepCopy", () => $a463a6b5f08d6875$export$6c40052bed430212);
$parcel$export($0e788201f8a90b1e$exports, "defineReadOnly", () => $a463a6b5f08d6875$export$104236534534f9be);
$parcel$export($0e788201f8a90b1e$exports, "getStatic", () => $a463a6b5f08d6875$export$f695fbbf3cdaaf47);
$parcel$export($0e788201f8a90b1e$exports, "resolveProperties", () => $a463a6b5f08d6875$export$d503dd157d963b60);
$parcel$export($0e788201f8a90b1e$exports, "shallowCopy", () => $a463a6b5f08d6875$export$9c13236873b118a5);
$parcel$export($0e788201f8a90b1e$exports, "arrayify", () => $7b88b6e03e4708f2$export$3131421a7d01b4fb);
$parcel$export($0e788201f8a90b1e$exports, "concat", () => $7b88b6e03e4708f2$export$ee1b3e54f0441b22);
$parcel$export($0e788201f8a90b1e$exports, "stripZeros", () => $7b88b6e03e4708f2$export$a8f4574d0e56446c);
$parcel$export($0e788201f8a90b1e$exports, "zeroPad", () => $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d);
$parcel$export($0e788201f8a90b1e$exports, "isBytes", () => $7b88b6e03e4708f2$export$c6fabfbfd097fc30);
$parcel$export($0e788201f8a90b1e$exports, "isBytesLike", () => $7b88b6e03e4708f2$export$9a14abb1a440cd5e);
$parcel$export($0e788201f8a90b1e$exports, "defaultPath", () => $d830e21df8d45279$export$d48ad89f7e11a603);
$parcel$export($0e788201f8a90b1e$exports, "HDNode", () => $d830e21df8d45279$export$b68640c53e22b952);
$parcel$export($0e788201f8a90b1e$exports, "SigningKey", () => $ff9f75f56da7c459$export$21643ca94aed3e83);
$parcel$export($0e788201f8a90b1e$exports, "Interface", () => $ef97d5c3a9a93354$export$48cefb51a4e315b2);
$parcel$export($0e788201f8a90b1e$exports, "LogDescription", () => $ef97d5c3a9a93354$export$c2ab6499be98b3c5);
$parcel$export($0e788201f8a90b1e$exports, "TransactionDescription", () => $ef97d5c3a9a93354$export$7a3223b0fadb690b);
$parcel$export($0e788201f8a90b1e$exports, "base58", () => $3fca3a6183b20b71$export$45a587635c9954b2);
$parcel$export($0e788201f8a90b1e$exports, "base64", () => $aafe94bc1874bf9c$exports);
$parcel$export($0e788201f8a90b1e$exports, "hexlify", () => $7b88b6e03e4708f2$export$2b0d6b5fbe698c70);
$parcel$export($0e788201f8a90b1e$exports, "isHexString", () => $7b88b6e03e4708f2$export$b02a40aff8e4ad18);
$parcel$export($0e788201f8a90b1e$exports, "hexConcat", () => $7b88b6e03e4708f2$export$6d4b99629b38754a);
$parcel$export($0e788201f8a90b1e$exports, "hexStripZeros", () => $7b88b6e03e4708f2$export$967bc0082a978949);
$parcel$export($0e788201f8a90b1e$exports, "hexValue", () => $7b88b6e03e4708f2$export$6916af760a341dd3);
$parcel$export($0e788201f8a90b1e$exports, "hexZeroPad", () => $7b88b6e03e4708f2$export$e9c46a54370b47e8);
$parcel$export($0e788201f8a90b1e$exports, "hexDataLength", () => $7b88b6e03e4708f2$export$13882f896d3c0683);
$parcel$export($0e788201f8a90b1e$exports, "hexDataSlice", () => $7b88b6e03e4708f2$export$15da666eba198c18);
$parcel$export($0e788201f8a90b1e$exports, "nameprep", () => $9d6cc79a6dc289e5$export$94f0b6f93c619bc);
$parcel$export($0e788201f8a90b1e$exports, "_toEscapedUtf8String", () => $b2a54ce293d87a2e$export$a7a0ec15960b9055);
$parcel$export($0e788201f8a90b1e$exports, "toUtf8Bytes", () => $b2a54ce293d87a2e$export$8feeb310b4b4752f);
$parcel$export($0e788201f8a90b1e$exports, "toUtf8CodePoints", () => $b2a54ce293d87a2e$export$ae470a36a31b28c2);
$parcel$export($0e788201f8a90b1e$exports, "toUtf8String", () => $b2a54ce293d87a2e$export$7643a1dc2c38d5eb);
$parcel$export($0e788201f8a90b1e$exports, "Utf8ErrorFuncs", () => $b2a54ce293d87a2e$export$c6e2180c5bb5bc05);
$parcel$export($0e788201f8a90b1e$exports, "formatBytes32String", () => $df4edb3ed5b824a0$export$b97e949c0076e971);
$parcel$export($0e788201f8a90b1e$exports, "parseBytes32String", () => $df4edb3ed5b824a0$export$49340cb8f3954db8);
$parcel$export($0e788201f8a90b1e$exports, "dnsEncode", () => $62768931dfa5f58f$export$6c0a8cdae51cb512);
$parcel$export($0e788201f8a90b1e$exports, "hashMessage", () => $d83cea76876f8e45$export$d4c241cec96564c1);
$parcel$export($0e788201f8a90b1e$exports, "namehash", () => $62768931dfa5f58f$export$91d651ee363e1209);
$parcel$export($0e788201f8a90b1e$exports, "isValidName", () => $62768931dfa5f58f$export$cce2300886e7ace6);
$parcel$export($0e788201f8a90b1e$exports, "id", () => $7cd0a9996bd6b341$export$d560c7e4a29451c2);
$parcel$export($0e788201f8a90b1e$exports, "_TypedDataEncoder", () => $74ec091a01b8d3e1$export$458ab927ae635c3);
$parcel$export($0e788201f8a90b1e$exports, "getAddress", () => $8aee8aee2d40605d$export$88411125f012957a);
$parcel$export($0e788201f8a90b1e$exports, "getIcapAddress", () => $8aee8aee2d40605d$export$962c4ddada9f668f);
$parcel$export($0e788201f8a90b1e$exports, "getContractAddress", () => $8aee8aee2d40605d$export$b7fbffef12272e40);
$parcel$export($0e788201f8a90b1e$exports, "getCreate2Address", () => $8aee8aee2d40605d$export$e0b22d96621f73a2);
$parcel$export($0e788201f8a90b1e$exports, "isAddress", () => $8aee8aee2d40605d$export$977e255126d763d6);
$parcel$export($0e788201f8a90b1e$exports, "formatEther", () => $c043804acab33a9c$export$11bc63b4c03ea518);
$parcel$export($0e788201f8a90b1e$exports, "parseEther", () => $c043804acab33a9c$export$642c4e67bbdc0bc7);
$parcel$export($0e788201f8a90b1e$exports, "formatUnits", () => $c043804acab33a9c$export$bd39b96f71da1885);
$parcel$export($0e788201f8a90b1e$exports, "parseUnits", () => $c043804acab33a9c$export$203ae30b4f6490b3);
$parcel$export($0e788201f8a90b1e$exports, "commify", () => $c043804acab33a9c$export$de1294767e6ef661);
$parcel$export($0e788201f8a90b1e$exports, "computeHmac", () => $bb82ee6f1acbd7c8$export$967075d2f3b8e7ff);
$parcel$export($0e788201f8a90b1e$exports, "keccak256", () => $1dbc6131e27af3ca$export$f8151fce47ad1c35);
$parcel$export($0e788201f8a90b1e$exports, "ripemd160", () => $bb82ee6f1acbd7c8$export$d1cea0ee4e3f0d3e);
$parcel$export($0e788201f8a90b1e$exports, "sha256", () => $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9);
$parcel$export($0e788201f8a90b1e$exports, "sha512", () => $bb82ee6f1acbd7c8$export$a888d2532e6dc7bb);
$parcel$export($0e788201f8a90b1e$exports, "randomBytes", () => $d0ff10d17aa2d59e$export$5f828d93ff035aa8);
$parcel$export($0e788201f8a90b1e$exports, "shuffled", () => $dc90334677e5edd7$export$e6c7296801b9b341);
$parcel$export($0e788201f8a90b1e$exports, "solidityPack", () => $dd0a1119d94e1d6f$export$2a703dbb0cb35339);
$parcel$export($0e788201f8a90b1e$exports, "solidityKeccak256", () => $dd0a1119d94e1d6f$export$f8151fce47ad1c35);
$parcel$export($0e788201f8a90b1e$exports, "soliditySha256", () => $dd0a1119d94e1d6f$export$bced8d2aada2d1c9);
$parcel$export($0e788201f8a90b1e$exports, "splitSignature", () => $7b88b6e03e4708f2$export$7fb170f1e457988f);
$parcel$export($0e788201f8a90b1e$exports, "joinSignature", () => $7b88b6e03e4708f2$export$71bb9d78a59bbe25);
$parcel$export($0e788201f8a90b1e$exports, "accessListify", () => $0a7021bc70fec74d$export$6c8662b1600dce2);
$parcel$export($0e788201f8a90b1e$exports, "parseTransaction", () => $0a7021bc70fec74d$export$98e6a39c04603d36);
$parcel$export($0e788201f8a90b1e$exports, "serializeTransaction", () => $0a7021bc70fec74d$export$dfdc1655ccc5b9cb);
$parcel$export($0e788201f8a90b1e$exports, "TransactionTypes", () => $0a7021bc70fec74d$export$80349e05e0724e11);
$parcel$export($0e788201f8a90b1e$exports, "getJsonWalletAddress", () => $e21ba517a486d299$export$9a68ee9f8f3afd38);
$parcel$export($0e788201f8a90b1e$exports, "computeAddress", () => $0a7021bc70fec74d$export$e67e2732ba9803f9);
$parcel$export($0e788201f8a90b1e$exports, "recoverAddress", () => $0a7021bc70fec74d$export$23cc18f96d8510e2);
$parcel$export($0e788201f8a90b1e$exports, "computePublicKey", () => $ff9f75f56da7c459$export$4a89473d39301224);
$parcel$export($0e788201f8a90b1e$exports, "recoverPublicKey", () => $ff9f75f56da7c459$export$952dd09fbe0232b7);
$parcel$export($0e788201f8a90b1e$exports, "verifyMessage", () => $3ff70163f9f2ebd5$export$228d0e772cc158cb);
$parcel$export($0e788201f8a90b1e$exports, "verifyTypedData", () => $3ff70163f9f2ebd5$export$3603b1c1bcd76798);
$parcel$export($0e788201f8a90b1e$exports, "getAccountPath", () => $d830e21df8d45279$export$22b80e4f9eff636d);
$parcel$export($0e788201f8a90b1e$exports, "mnemonicToEntropy", () => $d830e21df8d45279$export$135e090d58b310ca);
$parcel$export($0e788201f8a90b1e$exports, "entropyToMnemonic", () => $d830e21df8d45279$export$4becd65eb23312e6);
$parcel$export($0e788201f8a90b1e$exports, "isValidMnemonic", () => $d830e21df8d45279$export$5eea3393c6119c80);
$parcel$export($0e788201f8a90b1e$exports, "mnemonicToSeed", () => $d830e21df8d45279$export$3dee74f1204ab09f);
$parcel$export($0e788201f8a90b1e$exports, "SupportedAlgorithm", () => $da90616c06668669$export$d2a8849cfb277c);
$parcel$export($0e788201f8a90b1e$exports, "UnicodeNormalizationForm", () => $b2a54ce293d87a2e$export$c6986442964129f5);
$parcel$export($0e788201f8a90b1e$exports, "Utf8ErrorReason", () => $b2a54ce293d87a2e$export$c285fa6ac15ff6a6);
$parcel$export($0e788201f8a90b1e$exports, "Indexed", () => $ef97d5c3a9a93354$export$8ef99100a3c56f8c);


var $aafe94bc1874bf9c$exports = {};

$parcel$export($aafe94bc1874bf9c$exports, "decode", () => $1d2ab8f2156e640e$export$2f872c0f2117be69);
$parcel$export($aafe94bc1874bf9c$exports, "encode", () => $1d2ab8f2156e640e$export$c564cdbbe6da493);

"use strict";
















const $4fb643241867151c$export$83d89fbfd8236492 = "solidity/5.7.0";


"use strict";
const $dd0a1119d94e1d6f$var$regexBytes = new RegExp("^bytes([0-9]+)$");
const $dd0a1119d94e1d6f$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
const $dd0a1119d94e1d6f$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const $dd0a1119d94e1d6f$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
const $dd0a1119d94e1d6f$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $4fb643241867151c$export$83d89fbfd8236492));
function $dd0a1119d94e1d6f$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d)(value, 32);
            return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        case "string":
            return (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(value);
        case "bytes":
            return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d)(value, 32);
            return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value);
    }
    let match = type.match($dd0a1119d94e1d6f$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $dd0a1119d94e1d6f$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $0df4577496dcf693$export$d97aa349ed20696).from(value).toTwos(size);
        return (0, $7b88b6e03e4708f2$export$3cdc770bf8b2ed3d)(value, size / 8);
    }
    match = type.match($dd0a1119d94e1d6f$var$regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) $dd0a1119d94e1d6f$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(value).byteLength !== size) $dd0a1119d94e1d6f$var$logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        if (isArray) return (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)((value + $dd0a1119d94e1d6f$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($dd0a1119d94e1d6f$var$regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) $dd0a1119d94e1d6f$var$logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        const result = [];
        value.forEach(function(value) {
            result.push($dd0a1119d94e1d6f$var$_pack(baseType, value, true));
        });
        return (0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)(result);
    }
    return $dd0a1119d94e1d6f$var$logger.throwArgumentError("invalid type", "type", type);
}
function $dd0a1119d94e1d6f$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $dd0a1119d94e1d6f$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    const tight = [];
    types.forEach(function(type, index) {
        tight.push($dd0a1119d94e1d6f$var$_pack(type, values[index]));
    });
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)(tight));
}
function $dd0a1119d94e1d6f$export$f8151fce47ad1c35(types, values) {
    return (0, $1dbc6131e27af3ca$export$f8151fce47ad1c35)($dd0a1119d94e1d6f$export$2a703dbb0cb35339(types, values));
}
function $dd0a1119d94e1d6f$export$bced8d2aada2d1c9(types, values) {
    return (0, $bb82ee6f1acbd7c8$export$bced8d2aada2d1c9)($dd0a1119d94e1d6f$export$2a703dbb0cb35339(types, values));
}







"use strict";
function $9d6cc79a6dc289e5$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    let result = [];
    for(let i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $9d6cc79a6dc289e5$var$createTable(data, func) {
    if (!func) func = function(value) {
        return [
            parseInt(value, 16)
        ];
    };
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair)=>{
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $9d6cc79a6dc289e5$var$createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v)=>{
        let comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $9d6cc79a6dc289e5$var$matchMap(value, ranges) {
    let lo = 0;
    for(let i = 0; i < ranges.length; i++){
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
const $9d6cc79a6dc289e5$var$Table_A_1_ranges = $9d6cc79a6dc289e5$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const $9d6cc79a6dc289e5$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v)=>parseInt(v, 16));
const $9d6cc79a6dc289e5$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
const $9d6cc79a6dc289e5$var$Table_B_2_lut_abs = $9d6cc79a6dc289e5$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const $9d6cc79a6dc289e5$var$Table_B_2_lut_rel = $9d6cc79a6dc289e5$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const $9d6cc79a6dc289e5$var$Table_B_2_complex = $9d6cc79a6dc289e5$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $9d6cc79a6dc289e5$var$bytes2);
const $9d6cc79a6dc289e5$var$Table_C_ranges = $9d6cc79a6dc289e5$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $9d6cc79a6dc289e5$var$flatten(values) {
    return values.reduce((accum, value)=>{
        value.forEach((value)=>{
            accum.push(value);
        });
        return accum;
    }, []);
}
function $9d6cc79a6dc289e5$export$d1ae0d802533bef0(codepoint) {
    return !!$9d6cc79a6dc289e5$var$matchMap(codepoint, $9d6cc79a6dc289e5$var$Table_A_1_ranges);
}
function $9d6cc79a6dc289e5$export$9630a1f26a43b76c(codepoint) {
    let range = $9d6cc79a6dc289e5$var$matchMap(codepoint, $9d6cc79a6dc289e5$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    let codes = $9d6cc79a6dc289e5$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    let shift = $9d6cc79a6dc289e5$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    let complex = $9d6cc79a6dc289e5$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $9d6cc79a6dc289e5$export$e07a548cae6d1553(codepoint) {
    return !!$9d6cc79a6dc289e5$var$matchMap(codepoint, $9d6cc79a6dc289e5$var$Table_C_ranges);
}
function $9d6cc79a6dc289e5$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    let codes = (0, $b2a54ce293d87a2e$export$ae470a36a31b28c2)(value);
    codes = $9d6cc79a6dc289e5$var$flatten(codes.map((code)=>{
        // Substitute Table B.1 (Maps to Nothing)
        if ($9d6cc79a6dc289e5$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = $9d6cc79a6dc289e5$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $b2a54ce293d87a2e$export$ae470a36a31b28c2)((0, $b2a54ce293d87a2e$export$232e1dab03132235)(codes), (0, $b2a54ce293d87a2e$export$c6986442964129f5).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code)=>{
        if ($9d6cc79a6dc289e5$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code)=>{
        if ($9d6cc79a6dc289e5$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    let name = (0, $b2a54ce293d87a2e$export$232e1dab03132235)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    return name;
}




"use strict";
function $df4edb3ed5b824a0$export$b97e949c0076e971(text) {
    // Get the bytes
    const bytes = (0, $b2a54ce293d87a2e$export$8feeb310b4b4752f)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $7b88b6e03e4708f2$export$2b0d6b5fbe698c70)((0, $7b88b6e03e4708f2$export$ee1b3e54f0441b22)([
        bytes,
        (0, $9b26373cc461c855$export$71c2e4e213dcb7f2)
    ]).slice(0, 32));
}
function $df4edb3ed5b824a0$export$49340cb8f3954db8(bytes) {
    const data = (0, $7b88b6e03e4708f2$export$3131421a7d01b4fb)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    let length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $b2a54ce293d87a2e$export$7643a1dc2c38d5eb)(data.slice(0, length));
}





const $18e24cde8c8cacf4$export$83d89fbfd8236492 = "units/5.7.0";


"use strict";
const $c043804acab33a9c$var$logger = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $18e24cde8c8cacf4$export$83d89fbfd8236492));
const $c043804acab33a9c$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $c043804acab33a9c$export$de1294767e6ef661(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $c043804acab33a9c$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    let suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    const formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        const index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $c043804acab33a9c$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        const index = $c043804acab33a9c$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $bdc30db990c4b693$export$cc011b843b5d69f2)(value, unitName != null ? unitName : 18);
}
function $c043804acab33a9c$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $c043804acab33a9c$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        const index = $c043804acab33a9c$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $bdc30db990c4b693$export$1b039987e86d7269)(value, unitName != null ? unitName : 18);
}
function $c043804acab33a9c$export$11bc63b4c03ea518(wei) {
    return $c043804acab33a9c$export$bd39b96f71da1885(wei, 18);
}
function $c043804acab33a9c$export$642c4e67bbdc0bc7(ether) {
    return $c043804acab33a9c$export$203ae30b4f6490b3(ether, 18);
}




"use strict";



const $9f7bf65ddafc81a6$export$83d89fbfd8236492 = "ethers/5.7.2";


"use strict";
const $6c57cc56acea9c6c$export$af88d00dbe7f521 = new (0, $97a8d5981d597bb7$export$efa9a398d6368992)((0, $9f7bf65ddafc81a6$export$83d89fbfd8236492));


"use strict";
try {
    const anyGlobal = window;
    if (anyGlobal._ethers == null) anyGlobal._ethers = $6c57cc56acea9c6c$exports;
} catch (error) {}



var $8O6s0 = parcelRequire("8O6s0");


parcelRequire("kyrHl");
parcelRequire("6y4qQ");

parcelRequire("kmsNQ");
parcelRequire("bib7R");
parcelRequire("5Kq8F");
parcelRequire("hLpYp");
parcelRequire("4yR7b");

parcelRequire("bgFCw");
parcelRequire("3vRz3");


var $8O6s0 = parcelRequire("8O6s0");

var $2awro = parcelRequire("2awro");
parcelRequire("bib7R");
var $kMjQs = parcelRequire("kMjQs");
/**
 * The `ProviderIdentityFlag` is a property on an injected provider
 * that uniquely identifies that provider
 */ var $b89b21830de830ce$export$ed1aacaf3c5fdac4;
(function(ProviderIdentityFlag) {
    ProviderIdentityFlag["AlphaWallet"] = "isAlphaWallet";
    ProviderIdentityFlag["ApexWallet"] = "isApexWallet";
    ProviderIdentityFlag["AToken"] = "isAToken";
    ProviderIdentityFlag["BifrostWallet"] = "isBifrost";
    ProviderIdentityFlag["Binance"] = "bbcSignTx";
    ProviderIdentityFlag["Bitpie"] = "isBitpie";
    ProviderIdentityFlag["BlockWallet"] = "isBlockWallet";
    ProviderIdentityFlag["Coinbase"] = "isToshi";
    ProviderIdentityFlag["CoinbaseExtension"] = "isCoinbaseWallet";
    ProviderIdentityFlag["Detected"] = "request";
    ProviderIdentityFlag["Dcent"] = "isDcentWallet";
    ProviderIdentityFlag["Exodus"] = "isExodus";
    ProviderIdentityFlag["Frontier"] = "isFrontier";
    ProviderIdentityFlag["Frame"] = "isFrame";
    ProviderIdentityFlag["HuobiWallet"] = "isHbWallet";
    ProviderIdentityFlag["HyperPay"] = "isHyperPay";
    ProviderIdentityFlag["ImToken"] = "isImToken";
    ProviderIdentityFlag["InfinityWallet"] = "isInfinityWallet";
    ProviderIdentityFlag["Liquality"] = "isLiquality";
    ProviderIdentityFlag["MeetOne"] = "wallet";
    ProviderIdentityFlag["MetaMask"] = "isMetaMask";
    ProviderIdentityFlag["MyKey"] = "isMYKEY";
    ProviderIdentityFlag["OwnBit"] = "isOwnbit";
    ProviderIdentityFlag["Status"] = "isStatus";
    ProviderIdentityFlag["Trust"] = "isTrust";
    ProviderIdentityFlag["TokenPocket"] = "isTokenPocket";
    ProviderIdentityFlag["TP"] = "isTp";
    ProviderIdentityFlag["WalletIo"] = "isWalletIO";
    ProviderIdentityFlag["XDEFI"] = "isXDEFI";
    ProviderIdentityFlag["OneInch"] = "isOneInchIOSWallet";
    ProviderIdentityFlag["Tokenary"] = "isTokenary";
    ProviderIdentityFlag["Tally"] = "isTally";
    ProviderIdentityFlag["BraveWallet"] = "isBraveWallet";
    ProviderIdentityFlag["Rabby"] = "isRabby";
    ProviderIdentityFlag["MathWallet"] = "isMathWallet";
    ProviderIdentityFlag["Bitget"] = "isBitKeep";
    ProviderIdentityFlag["Sequence"] = "isSequence";
    ProviderIdentityFlag["Core"] = "isAvalanche";
    ProviderIdentityFlag["Opera"] = "isOpera";
    ProviderIdentityFlag["Bitski"] = "isBitski";
    ProviderIdentityFlag["Enkrypt"] = "isEnkrypt";
    ProviderIdentityFlag["Phantom"] = "isPhantom";
    ProviderIdentityFlag["OKXWallet"] = "isOkxWallet";
    ProviderIdentityFlag["Zeal"] = "isZeal";
    ProviderIdentityFlag["Zerion"] = "isZerion";
    ProviderIdentityFlag["Rainbow"] = "isRainbow";
    ProviderIdentityFlag["SafePal"] = "isSafePal";
    ProviderIdentityFlag["DeFiWallet"] = "isDeficonnectProvider";
    ProviderIdentityFlag["Safeheron"] = "isSafeheron";
    ProviderIdentityFlag["Talisman"] = "isTalisman";
    ProviderIdentityFlag["OneKey"] = "isOneKey";
    ProviderIdentityFlag["Fordefi"] = "isFordefi";
    ProviderIdentityFlag["Coin98Wallet"] = "isCoin98";
    ProviderIdentityFlag["SubWallet"] = "isSubWallet";
    ProviderIdentityFlag["Kayros"] = "isKayros";
    ProviderIdentityFlag["FoxWallet"] = "isFoxWallet";
    ProviderIdentityFlag["Lif3Wallet"] = "isLif3Wallet";
})($b89b21830de830ce$export$ed1aacaf3c5fdac4 || ($b89b21830de830ce$export$ed1aacaf3c5fdac4 = {}));
var $b89b21830de830ce$export$a9253ba86c8edfd5;
(function(ProviderExternalUrl) {
    ProviderExternalUrl["Binance"] = "https://www.bnbchain.org/ru/blog/binance-extension-wallet/";
    ProviderExternalUrl["Bitget"] = "https://web3.bitget.com/en/wallet-download";
    ProviderExternalUrl["Coinbase"] = "https://www.coinbase.com/wallet/downloads";
    ProviderExternalUrl["MetaMask"] = "https://metamask.io/download/";
    ProviderExternalUrl["OKXWallet"] = "https://okx.com/download";
    ProviderExternalUrl["Phantom"] = "https://phantom.app/ul/v1/connect";
    ProviderExternalUrl["Talisman"] = "https://www.talisman.xyz/";
    ProviderExternalUrl["Trust"] = "https://link.trustwallet.com";
    ProviderExternalUrl["OneKey"] = "https://onekey.so/download/";
    ProviderExternalUrl["RoninWallet"] = "https://wallet.skymavis.com/";
    ProviderExternalUrl["Coin98Wallet"] = "https://coin98.com/wallet/";
    ProviderExternalUrl["SubWallet"] = "https://www.subwallet.app/";
    ProviderExternalUrl["Kayros"] = "https://www.kayros.games/wallet/";
    ProviderExternalUrl["XDEFI"] = "https://xdefi.io/";
    ProviderExternalUrl["FoxWallet"] = "https://foxwallet.com/download";
    ProviderExternalUrl["Lif3Wallet"] = "https://lif3.com";
    ProviderExternalUrl["Rabby"] = "https://rabby.io";
})($b89b21830de830ce$export$a9253ba86c8edfd5 || ($b89b21830de830ce$export$a9253ba86c8edfd5 = {}));
var $b89b21830de830ce$export$f0b712b78e0e0d3a;
(function(ProviderLabel) {
    ProviderLabel["AlphaWallet"] = "AlphaWallet";
    ProviderLabel["ApexWallet"] = "Apex Wallet";
    ProviderLabel["AToken"] = "AToken";
    ProviderLabel["BifrostWallet"] = "Bifrost Wallet";
    ProviderLabel["Binance"] = "Binance Smart Wallet";
    ProviderLabel["Bitpie"] = "Bitpie";
    ProviderLabel["Bitski"] = "Bitski";
    ProviderLabel["BlockWallet"] = "BlockWallet";
    ProviderLabel["Brave"] = "Brave Wallet";
    ProviderLabel["Coinbase"] = "Coinbase Wallet";
    ProviderLabel["Dcent"] = "D'CENT";
    ProviderLabel["Detected"] = "Detected Wallet";
    ProviderLabel["Exodus"] = "Exodus";
    ProviderLabel["Frame"] = "Frame";
    ProviderLabel["Frontier"] = "Frontier";
    ProviderLabel["HuobiWallet"] = "Huobi Wallet";
    ProviderLabel["HyperPay"] = "HyperPay";
    ProviderLabel["ImToken"] = "imToken";
    ProviderLabel["InfinityWallet"] = "Infinity Wallet";
    ProviderLabel["Liquality"] = "Liquality";
    ProviderLabel["MeetOne"] = "MeetOne";
    ProviderLabel["MetaMask"] = "MetaMask";
    ProviderLabel["MyKey"] = "MyKey";
    ProviderLabel["Opera"] = "Opera Wallet";
    ProviderLabel["OwnBit"] = "OwnBit";
    ProviderLabel["Status"] = "Status Wallet";
    ProviderLabel["Trust"] = "Trust Wallet";
    ProviderLabel["TokenPocket"] = "TokenPocket";
    ProviderLabel["TP"] = "TP Wallet";
    ProviderLabel["WalletIo"] = "Wallet.io";
    ProviderLabel["XDEFI"] = "XDEFI Wallet";
    ProviderLabel["OneInch"] = "1inch Wallet";
    ProviderLabel["Tokenary"] = "Tokenary Wallet";
    ProviderLabel["Tally"] = "Taho";
    ProviderLabel["Rabby"] = "Rabby Wallet";
    ProviderLabel["MathWallet"] = "MathWallet";
    ProviderLabel["Bitget"] = "Bitget Wallet";
    ProviderLabel["Sequence"] = "Sequence";
    ProviderLabel["Core"] = "Core";
    ProviderLabel["Enkrypt"] = "Enkrypt";
    ProviderLabel["Zeal"] = "Zeal";
    ProviderLabel["Phantom"] = "Phantom";
    ProviderLabel["OKXWallet"] = "OKX Wallet";
    ProviderLabel["Zerion"] = "Zerion";
    ProviderLabel["Rainbow"] = "Rainbow";
    ProviderLabel["SafePal"] = "SafePal";
    ProviderLabel["DeFiWallet"] = "DeFi Wallet";
    ProviderLabel["Safeheron"] = "Safeheron";
    ProviderLabel["Talisman"] = "Talisman";
    ProviderLabel["OneKey"] = "OneKey";
    ProviderLabel["Fordefi"] = "Fordefi";
    ProviderLabel["RoninWallet"] = "Ronin Wallet";
    ProviderLabel["Coin98Wallet"] = "Coin98 Wallet";
    ProviderLabel["SubWallet"] = "SubWallet";
    ProviderLabel["Kayros"] = "Kayros";
    ProviderLabel["FoxWallet"] = "FoxWallet";
    ProviderLabel["Lif3Wallet"] = "Lif3 Wallet";
})($b89b21830de830ce$export$f0b712b78e0e0d3a || ($b89b21830de830ce$export$f0b712b78e0e0d3a = {}));
var $b89b21830de830ce$export$c1baa9dfa9de24b2;
(function(InjectedNameSpace) {
    InjectedNameSpace["Ethereum"] = "ethereum";
    InjectedNameSpace["Binance"] = "BinanceChain";
    InjectedNameSpace["Tally"] = "tally";
    InjectedNameSpace["Web3"] = "web3";
    InjectedNameSpace["Arbitrum"] = "arbitrum";
    InjectedNameSpace["XFI"] = "xfi";
    InjectedNameSpace["Bitget"] = "bitkeep";
    InjectedNameSpace["Avalanche"] = "avalanche";
    InjectedNameSpace["Bitski"] = "Bitski";
    InjectedNameSpace["Enkrypt"] = "enkrypt";
    InjectedNameSpace["Zeal"] = "zeal";
    InjectedNameSpace["Phantom"] = "phantom";
    InjectedNameSpace["OKXWallet"] = "okxwallet";
    InjectedNameSpace["Trust"] = "trustwallet";
    InjectedNameSpace["Frontier"] = "frontier";
    InjectedNameSpace["DeFiConnectProvider"] = "deficonnectProvider";
    InjectedNameSpace["Safeheron"] = "safeheron";
    InjectedNameSpace["Talisman"] = "talismanEth";
    InjectedNameSpace["OneKey"] = "$onekey";
    InjectedNameSpace["RoninWallet"] = "ronin";
    InjectedNameSpace["Coin98Wallet"] = "coin98";
    InjectedNameSpace["SubWallet"] = "SubWallet";
    InjectedNameSpace["Kayros"] = "kayros";
    InjectedNameSpace["FoxWallet"] = "foxwallet";
})($b89b21830de830ce$export$c1baa9dfa9de24b2 || ($b89b21830de830ce$export$c1baa9dfa9de24b2 = {}));
class $b89b21830de830ce$export$9c8150830466b77e extends Event {
    constructor(){
        super("eip6963:requestProvider");
    }
}


parcelRequire("bib7R");
var $kMjQs = parcelRequire("kMjQs");

const $53af229ac85d9a59$var$UNSUPPORTED_METHOD = null;
function $53af229ac85d9a59$var$getInjectedInterface(identity, checkOtherProviderFlags) {
    return async ()=>({
            provider: window.ethereum.providers && Array.isArray(window.ethereum.providers) ? $53af229ac85d9a59$var$getInterfaceFromProvidersArray(identity, checkOtherProviderFlags) : window.ethereum
        });
}
function $53af229ac85d9a59$var$getInterfaceFromProvidersArray(identity, checkOtherProviderFlags) {
    return window.ethereum.providers.find((provider)=>{
        return checkOtherProviderFlags ? !!provider[identity] && !$53af229ac85d9a59$var$otherProviderFlagsExist(identity, provider) : !!provider[identity];
    });
}
function $53af229ac85d9a59$var$otherProviderFlagsExist(identity, provider) {
    const otherProviderFlags = Object.values((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4)).filter((id)=>id !== identity && id !== (0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Detected);
    return otherProviderFlags.some((id)=>!!provider[id]);
}

const $53af229ac85d9a59$var$metamask = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).MetaMask,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).MetaMask] && !$53af229ac85d9a59$var$otherProviderFlagsExist((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).MetaMask, provider),
    getIcon: async ()=>(await (parcelRequire("77xkm"))).default,
    getInterface: $53af229ac85d9a59$var$getInjectedInterface((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).MetaMask, true),
    platforms: [
        "all"
    ],
    externalUrl: (0, $b89b21830de830ce$export$a9253ba86c8edfd5).MetaMask
};

const $53af229ac85d9a59$var$infinitywallet = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).InfinityWallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).InfinityWallet],
    getIcon: async ()=>(await (parcelRequire("kKnxg"))).default,
    getInterface: $53af229ac85d9a59$var$getInjectedInterface((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).InfinityWallet),
    platforms: [
        "desktop"
    ]
};

const $53af229ac85d9a59$var$exodus = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Exodus,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Exodus],
    getIcon: async ()=>(await (parcelRequire("5xwMc"))).default,
    getInterface: $53af229ac85d9a59$var$getInjectedInterface((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Exodus),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$frontier = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Frontier,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Frontier,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider["ethereum"] && !!provider["ethereum"][(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Frontier],
    getIcon: async ()=>(await (parcelRequire("bj7eP"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.frontier.ethereum)
        }),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$brave = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Brave,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).BraveWallet],
    getIcon: async ()=>(await (parcelRequire("anred"))).default,
    getInterface: $53af229ac85d9a59$var$getInjectedInterface((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).BraveWallet),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$binance = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Binance,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Binance,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Binance],
    getIcon: async ()=>(await (parcelRequire("2BbQ6"))).default,
    getInterface: async ()=>{
        // Replace the provider as the BNB provider is readonly
        let tempBNBProvider = {
            ...window.BinanceChain
        };
        window.BinanceChain = tempBNBProvider;
        const addListener = window.BinanceChain.on.bind(window.BinanceChain);
        window.BinanceChain.on = (event, func)=>{
            // intercept chainChanged event and format string
            if (event === "chainChanged") addListener(event, (chainId)=>{
                const cb = func;
                cb(`0x${parseInt(chainId).toString(16)}`);
            });
            else addListener(event, func);
        };
        const provider = (0, $kMjQs.createEIP1193Provider)(window.BinanceChain, {
            eth_chainId: ({ baseRequest: baseRequest })=>baseRequest({
                    method: "eth_chainId"
                }).then((id)=>`0x${parseInt(id).toString(16)}`),
            // Unsupported method -- will throw error
            eth_selectAccounts: $53af229ac85d9a59$var$UNSUPPORTED_METHOD,
            wallet_switchEthereumChain: $53af229ac85d9a59$var$UNSUPPORTED_METHOD
        });
        provider.removeListener = (event, func)=>{};
        return {
            provider: provider
        };
    },
    platforms: [
        "desktop"
    ],
    externalUrl: (0, $b89b21830de830ce$export$a9253ba86c8edfd5).Binance
};

const $53af229ac85d9a59$var$coinbase = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Coinbase,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Coinbase] || !!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).CoinbaseExtension],
    getIcon: async ()=>(await (parcelRequire("gTJxy"))).default,
    getInterface: async ()=>{
        const { provider: provider } = await $53af229ac85d9a59$var$getInjectedInterface((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).CoinbaseExtension)();
        const addListener = provider.on.bind(provider);
        provider.on = (event, func)=>{
            // intercept chainChanged event and format string
            if (event === "chainChanged") addListener(event, (chainId)=>{
                const cb = func;
                cb(`0x${parseInt(chainId).toString(16)}`);
            });
            else addListener(event, func);
        };
        return {
            provider: provider
        };
    },
    platforms: [
        "all"
    ],
    externalUrl: (0, $b89b21830de830ce$export$a9253ba86c8edfd5).Coinbase
};

const $53af229ac85d9a59$var$detected = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Detected,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Detected],
    getIcon: async ()=>(await (parcelRequire("g7yAU"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$trust = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Trust,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Trust,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Trust],
    getIcon: async ()=>(await (parcelRequire("eSE7Q"))).default,
    getInterface: async ()=>{
        const ethereumInjectionExists = window.hasOwnProperty((0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum);
        let provider;
        // check if trust is injected into window.ethereum
        if (ethereumInjectionExists && window[(0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum].isTrust) provider = window[(0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum];
        else // directly use the window.trustwallet injection
        provider = window[(0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Trust];
        return {
            provider: provider
        };
    },
    platforms: [
        "all"
    ],
    externalUrl: (0, $b89b21830de830ce$export$a9253ba86c8edfd5).Trust
};

const $53af229ac85d9a59$var$opera = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Opera,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Opera],
    getIcon: async ()=>(await (parcelRequire("8kAZ4"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ethereum, {
                eth_requestAccounts: async ({ baseRequest: baseRequest })=>baseRequest({
                        method: "eth_accounts"
                    }),
                eth_selectAccounts: $53af229ac85d9a59$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$status = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Status,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Status],
    getIcon: async ()=>(await (parcelRequire("dHpB8"))).default,
    getInterface: async ()=>{
        const provider = window.ethereum;
        return {
            provider: provider
        };
    },
    platforms: [
        "mobile"
    ]
};

const $53af229ac85d9a59$var$alphawallet = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).AlphaWallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).AlphaWallet],
    getIcon: async ()=>(await (parcelRequire("kV0Q8"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $53af229ac85d9a59$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $53af229ac85d9a59$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};

const $53af229ac85d9a59$var$apexwallet = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).ApexWallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).ApexWallet],
    getIcon: async ()=>(await (parcelRequire("pQUpv"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        "desktop",
        "Chrome",
        "Chromium",
        "Microsoft Edge"
    ]
};

const $53af229ac85d9a59$var$atoken = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).AToken,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).AToken],
    getIcon: async ()=>(await (parcelRequire("lQSGK"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        "mobile"
    ]
};

const $53af229ac85d9a59$var$bifrostwallet = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).BifrostWallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).BifrostWallet],
    getIcon: async ()=>(await (parcelRequire("eIsx2"))).default,
    getInterface: $53af229ac85d9a59$var$getInjectedInterface((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).BifrostWallet),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$bitpie = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Bitpie,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ()=>!!window.Bitpie,
    getIcon: async ()=>(await (parcelRequire("4zOC9"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $53af229ac85d9a59$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $53af229ac85d9a59$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};

const $53af229ac85d9a59$var$blockwallet = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).BlockWallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).BlockWallet],
    getIcon: async ()=>(await (parcelRequire("k0Ct4"))).default,
    getInterface: $53af229ac85d9a59$var$getInjectedInterface((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).BlockWallet),
    platforms: [
        "desktop"
    ]
};

const $53af229ac85d9a59$var$frame = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Frame,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Frame],
    getIcon: async ()=>(await (parcelRequire("9yERD"))).default,
    getInterface: async ()=>{
        const provider = window.ethereum;
        if (!provider || !provider.connected) throw new Error("Frame App must be open with a hot wallet connected. If not installed first download the Frame App.");
        return {
            provider: provider
        };
    },
    platforms: [
        "desktop"
    ]
};

const $53af229ac85d9a59$var$huobiwallet = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).HuobiWallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).HuobiWallet],
    getIcon: async ()=>(await (parcelRequire("fvG3x"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $53af229ac85d9a59$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $53af229ac85d9a59$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};

const $53af229ac85d9a59$var$hyperpay = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).HyperPay,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    // Note: The property `hiWallet` is as of now the only known way of identifying hyperpay
    // wallet as it is a direct clone of metamask. `checkProviderIdentity` implementation is subject to
    // future changes
    checkProviderIdentity: ()=>!!window.hiWallet,
    getIcon: async ()=>(await (parcelRequire("gYtt1"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $53af229ac85d9a59$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $53af229ac85d9a59$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};

const $53af229ac85d9a59$var$imtoken = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).ImToken,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).ImToken],
    getIcon: async ()=>(await (parcelRequire("dGnOC"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ethereum, {
                eth_selectAccounts: $53af229ac85d9a59$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};

const $53af229ac85d9a59$var$liquality = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Liquality,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Liquality],
    getIcon: async ()=>(await (parcelRequire("nFYmO"))).default,
    getInterface: async ()=>{
        const provider = (0, $kMjQs.createEIP1193Provider)(window.ethereum, {
            wallet_switchEthereumChain: $53af229ac85d9a59$var$UNSUPPORTED_METHOD,
            eth_selectAccounts: $53af229ac85d9a59$var$UNSUPPORTED_METHOD
        });
        provider.removeListener = (event, func)=>{};
        return {
            provider: provider
        };
    },
    platforms: [
        "desktop"
    ]
};

const $53af229ac85d9a59$var$meetone = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).MeetOne,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).MeetOne] === "MEETONE",
    getIcon: async ()=>(await (parcelRequire("jqRMv"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        "mobile"
    ]
};

const $53af229ac85d9a59$var$mykey = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).MyKey,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).MyKey],
    getIcon: async ()=>(await (parcelRequire("bLBFP"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        "mobile"
    ]
};

const $53af229ac85d9a59$var$ownbit = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).OwnBit,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).OwnBit],
    getIcon: async ()=>(await (parcelRequire("gv6kT"))).default,
    getInterface: async ()=>{
        const provider = (0, $kMjQs.createEIP1193Provider)(window.ethereum, {
            eth_chainId: ({ baseRequest: baseRequest })=>baseRequest({
                    method: "eth_chainId"
                }).then((id)=>`0x${parseInt(id).toString(16)}`),
            wallet_switchEthereumChain: $53af229ac85d9a59$var$UNSUPPORTED_METHOD,
            eth_selectAccounts: $53af229ac85d9a59$var$UNSUPPORTED_METHOD
        });
        provider.removeListener = (event, listener)=>{};
        provider.on = (event, listener)=>{};
        return {
            provider: provider
        };
    },
    platforms: [
        "mobile"
    ]
};

const $53af229ac85d9a59$var$tokenpocket = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).TokenPocket,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).TokenPocket] && !provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).TP],
    getIcon: async ()=>(await (parcelRequire("f282q"))).default,
    getInterface: $53af229ac85d9a59$var$getInjectedInterface((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).TokenPocket),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$tp = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).TP,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).TP],
    getIcon: async ()=>(await (parcelRequire("8LKEq"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $53af229ac85d9a59$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $53af229ac85d9a59$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};

const $53af229ac85d9a59$var$xdefi = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).XDEFI,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).XFI,
    checkProviderIdentity: ({ provider: provider })=>provider && provider.ethereum && provider.ethereum[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).XDEFI],
    getIcon: async ()=>(await (parcelRequire("bwEZx"))).default,
    getInterface: async ()=>({
            provider: window.xfi && window.xfi.ethereum
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $b89b21830de830ce$export$a9253ba86c8edfd5).XDEFI
};

const $53af229ac85d9a59$var$oneInch = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).OneInch,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).OneInch],
    getIcon: async ()=>(await (parcelRequire("iqiBr"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        "mobile"
    ]
};

const $53af229ac85d9a59$var$tokenary = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Tokenary,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Tokenary],
    getIcon: async ()=>(await (parcelRequire("gMGpM"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$tally = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Tally,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Tally,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Tally],
    getIcon: async ()=>(await (parcelRequire("7nPtz"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.tally)
        }),
    platforms: [
        "desktop"
    ]
};

const $53af229ac85d9a59$var$zeal = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Zeal,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Zeal,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Zeal],
    getIcon: async ()=>(await (parcelRequire("72eqq"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.zeal)
        }),
    platforms: [
        "desktop"
    ]
};

const $53af229ac85d9a59$var$rabby = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Rabby,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Rabby],
    getIcon: async ()=>(await (parcelRequire("eH9pd"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        "desktop",
        "mobile"
    ]
};

const $53af229ac85d9a59$var$mathwallet = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).MathWallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).MathWallet],
    getIcon: async ()=>(await (parcelRequire("gIFYS"))).default,
    getInterface: $53af229ac85d9a59$var$getInjectedInterface((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).MathWallet),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$bitget = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Bitget,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Bitget,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider["ethereum"][(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Bitget],
    getIcon: async ()=>(await (parcelRequire("jca0Q"))).default,
    getInterface: async ()=>({
            provider: window.bitkeep && window.bitkeep.ethereum
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $b89b21830de830ce$export$a9253ba86c8edfd5).Bitget
};

const $53af229ac85d9a59$var$sequence = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Sequence,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Sequence],
    getIcon: async ()=>(await (parcelRequire("3YfNp"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$core = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Core,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Avalanche,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Core],
    getIcon: async ()=>(await (parcelRequire("eE8CS"))).default,
    getInterface: $53af229ac85d9a59$var$getInjectedInterface((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Core),
    // Core wallet is only tested in chrome or chromium browser
    platforms: [
        "desktop",
        "Chrome",
        "Chromium",
        "Microsoft Edge"
    ]
};

const $53af229ac85d9a59$var$bitski = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Bitski,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Bitski,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider.getProvider && !!provider.getProvider().isBitski,
    getIcon: async ()=>(await (parcelRequire("k6Pln"))).default,
    getInterface: async ()=>({
            provider: window.Bitski && window.Bitski.getProvider && window.Bitski.getProvider()
        }),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$zerion = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Zerion,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Zerion],
    getIcon: async ()=>(await (parcelRequire("1uXeX"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$enkrypt = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Enkrypt,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Enkrypt,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider.providers && !!provider.providers.ethereum,
    getIcon: async ()=>(await (parcelRequire("izG35"))).default,
    getInterface: async ()=>{
        const addListener = window.enkrypt.providers.ethereum.on.bind(window.enkrypt.providers.ethereum);
        window.enkrypt.providers.ethereum.on = (event, func)=>{
            // intercept chainChanged event and format string
            if (event === "chainChanged") addListener(event, (chainId)=>{
                const cb = func;
                cb(`0x${parseInt(chainId).toString(16)}`);
            });
            else addListener(event, func);
        };
        const provider = (0, $kMjQs.createEIP1193Provider)(window.enkrypt.providers.ethereum, {
            eth_chainId: ({ baseRequest: baseRequest })=>baseRequest({
                    method: "eth_chainId"
                }).then((id)=>`0x${parseInt(id).toString(16)}`)
        });
        provider.removeListener = (event, func)=>{};
        return {
            provider: provider
        };
    },
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$phantom = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Phantom,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Phantom,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider["ethereum"] && !!provider["ethereum"][(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Phantom],
    getIcon: async ()=>(await (parcelRequire("7Y8iK"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.phantom.ethereum)
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $b89b21830de830ce$export$a9253ba86c8edfd5).Phantom
};

const $53af229ac85d9a59$var$safepal = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).SafePal,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).SafePal],
    getIcon: async ()=>(await (parcelRequire("j62R5"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$rainbow = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Rainbow,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Rainbow],
    getIcon: async ()=>(await (parcelRequire("7TIXn"))).default,
    getInterface: $53af229ac85d9a59$var$getInjectedInterface((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Rainbow),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$okxwallet = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).OKXWallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).OKXWallet,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).OKXWallet],
    getIcon: async ()=>(await (parcelRequire("dqL91"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.okxwallet)
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $b89b21830de830ce$export$a9253ba86c8edfd5).OKXWallet
};

const $53af229ac85d9a59$var$defiwallet = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).DeFiWallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).DeFiConnectProvider,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).DeFiWallet],
    getIcon: async ()=>(await (parcelRequire("hUMdH"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.deficonnectProvider)
        }),
    platforms: [
        "all"
    ]
};

const $53af229ac85d9a59$var$safeheron = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Safeheron,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Safeheron,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Safeheron],
    getIcon: async ()=>(await (parcelRequire("joZtd"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.safeheron)
        }),
    platforms: [
        "desktop",
        "Chrome",
        "Chromium",
        "Microsoft Edge"
    ]
};

const $53af229ac85d9a59$var$talisman = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Talisman,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Talisman,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Talisman],
    getIcon: async ()=>(await (parcelRequire("l9F2c"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.talismanEth)
        }),
    platforms: [
        "desktop"
    ],
    externalUrl: (0, $b89b21830de830ce$export$a9253ba86c8edfd5).Talisman
};

const $53af229ac85d9a59$var$ronin = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).RoninWallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).RoninWallet,
    checkProviderIdentity: ({ provider: provider })=>!!provider,
    getIcon: async ()=>(await (parcelRequire("2Ayqw"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ronin.provider)
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $b89b21830de830ce$export$a9253ba86c8edfd5).RoninWallet
};

const $53af229ac85d9a59$var$onekey = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).OneKey,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).OneKey,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider.ethereum && !!provider.ethereum[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).OneKey],
    getIcon: async ()=>(await (parcelRequire("eifR8"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.$onekey.ethereum)
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $b89b21830de830ce$export$a9253ba86c8edfd5).OneKey
};

const $53af229ac85d9a59$var$fordefi = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Fordefi,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Fordefi],
    getIcon: async ()=>(await (parcelRequire("6wQWr"))).default,
    getInterface: $53af229ac85d9a59$var$getInjectedInterface((0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Fordefi, true),
    platforms: [
        "desktop"
    ]
};

const $53af229ac85d9a59$var$coin98wallet = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Coin98Wallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Coin98Wallet],
    getIcon: async ()=>(await (parcelRequire("ceJdF"))).default,
    getInterface: async ()=>{
        const ethereumInjectionExists = window.hasOwnProperty((0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum);
        let provider;
        // check if coin98 is injected into window.ethereum
        if (ethereumInjectionExists && window[(0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum].isCoin98) provider = window[(0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum];
        else // directly use the window.coin98 injection
        provider = window[(0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Coin98Wallet].provider;
        return {
            provider: provider
        };
    },
    platforms: [
        "all"
    ],
    externalUrl: (0, $b89b21830de830ce$export$a9253ba86c8edfd5).Coin98Wallet
};

const $53af229ac85d9a59$var$subwallet = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).SubWallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).SubWallet,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).SubWallet],
    getIcon: async ()=>(await (parcelRequire("4OR8U"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.SubWallet)
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $b89b21830de830ce$export$a9253ba86c8edfd5).SubWallet
};

const $53af229ac85d9a59$var$kayros = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Kayros,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Kayros,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Kayros],
    getIcon: async ()=>(await (parcelRequire("R733B"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.kayros)
        }),
    platforms: [
        "desktop"
    ]
};

const $53af229ac85d9a59$var$foxwallet = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).FoxWallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).FoxWallet,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).FoxWallet],
    getIcon: async ()=>(await (parcelRequire("6ZQPJ"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.foxwallet)
        }),
    platforms: [
        "mobile"
    ]
};

const $53af229ac85d9a59$var$Lif3Wallet = {
    label: (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Lif3Wallet,
    injectedNamespace: (0, $b89b21830de830ce$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $b89b21830de830ce$export$ed1aacaf3c5fdac4).Lif3Wallet],
    getIcon: async ()=>(await (parcelRequire("hx9TJ"))).default,
    getInterface: async ()=>({
            provider: (0, $kMjQs.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $53af229ac85d9a59$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $53af229ac85d9a59$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};
const $53af229ac85d9a59$var$wallets = [
    $53af229ac85d9a59$var$zeal,
    $53af229ac85d9a59$var$exodus,
    $53af229ac85d9a59$var$frontier,
    $53af229ac85d9a59$var$metamask,
    $53af229ac85d9a59$var$bifrostwallet,
    $53af229ac85d9a59$var$binance,
    $53af229ac85d9a59$var$coinbase,
    $53af229ac85d9a59$var$detected,
    $53af229ac85d9a59$var$trust,
    $53af229ac85d9a59$var$opera,
    $53af229ac85d9a59$var$status,
    $53af229ac85d9a59$var$alphawallet,
    $53af229ac85d9a59$var$apexwallet,
    $53af229ac85d9a59$var$atoken,
    $53af229ac85d9a59$var$bitget,
    $53af229ac85d9a59$var$bitpie,
    $53af229ac85d9a59$var$blockwallet,
    $53af229ac85d9a59$var$brave,
    $53af229ac85d9a59$var$frame,
    $53af229ac85d9a59$var$huobiwallet,
    $53af229ac85d9a59$var$hyperpay,
    $53af229ac85d9a59$var$imtoken,
    $53af229ac85d9a59$var$liquality,
    $53af229ac85d9a59$var$meetone,
    $53af229ac85d9a59$var$mykey,
    $53af229ac85d9a59$var$ownbit,
    $53af229ac85d9a59$var$tokenpocket,
    $53af229ac85d9a59$var$tp,
    $53af229ac85d9a59$var$xdefi,
    $53af229ac85d9a59$var$oneInch,
    $53af229ac85d9a59$var$tokenary,
    $53af229ac85d9a59$var$tally,
    $53af229ac85d9a59$var$rabby,
    $53af229ac85d9a59$var$mathwallet,
    $53af229ac85d9a59$var$sequence,
    $53af229ac85d9a59$var$core,
    $53af229ac85d9a59$var$bitski,
    $53af229ac85d9a59$var$enkrypt,
    $53af229ac85d9a59$var$phantom,
    $53af229ac85d9a59$var$okxwallet,
    $53af229ac85d9a59$var$zerion,
    $53af229ac85d9a59$var$rainbow,
    $53af229ac85d9a59$var$safepal,
    $53af229ac85d9a59$var$defiwallet,
    $53af229ac85d9a59$var$infinitywallet,
    $53af229ac85d9a59$var$safeheron,
    $53af229ac85d9a59$var$talisman,
    $53af229ac85d9a59$var$onekey,
    $53af229ac85d9a59$var$fordefi,
    $53af229ac85d9a59$var$ronin,
    $53af229ac85d9a59$var$coin98wallet,
    $53af229ac85d9a59$var$subwallet,
    $53af229ac85d9a59$var$kayros,
    $53af229ac85d9a59$var$foxwallet,
    $53af229ac85d9a59$var$Lif3Wallet
];
var $53af229ac85d9a59$export$2e2bcd8739ae039 = $53af229ac85d9a59$var$wallets;



var $kmsNQ = parcelRequire("kmsNQ");
parcelRequire("bib7R");
var $fsqu3 = parcelRequire("fsqu3");
const $2bab71bfcf6c70ed$var$walletModule = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    label: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    getIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function().arity(0).required(),
    getInterface: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function().maxArity(1).required(),
    injectedNamespace: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    checkProviderIdentity: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function().arity(1).required(),
    platforms: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string()),
    externalUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string()
});
const $2bab71bfcf6c70ed$var$wallets = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).array().items($2bab71bfcf6c70ed$var$walletModule);
const $2bab71bfcf6c70ed$var$filter = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object().pattern(/\w+/, (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(), (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string())));
const $2bab71bfcf6c70ed$var$walletOptions = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    custom: $2bab71bfcf6c70ed$var$wallets,
    filter: $2bab71bfcf6c70ed$var$filter,
    displayUnavailable: [
        (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean(),
        (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string())
    ],
    walletUnavailableMessage: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function(),
    sort: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).function(),
    externalUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string(),
    disable6963Support: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).boolean()
});
const $2bab71bfcf6c70ed$export$579090a152b2b16 = (data)=>(0, $fsqu3.validate)($2bab71bfcf6c70ed$var$walletOptions, data);
const $2bab71bfcf6c70ed$var$eip6963ProviderInfo = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    uuid: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    name: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required(),
    rdns: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).string().required()
});
const $2bab71bfcf6c70ed$var$eip6963ProviderDetail = (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object({
    info: $2bab71bfcf6c70ed$var$eip6963ProviderInfo.required(),
    provider: (0, (/*@__PURE__*/$parcel$interopDefault($kmsNQ))).object().required()
});
const $2bab71bfcf6c70ed$export$9f850aef0c7d58e5 = (data)=>(0, $fsqu3.validate)($2bab71bfcf6c70ed$var$eip6963ProviderDetail, data);


class $e917f50e09e15c26$export$417589b978208a8f extends Error {
    constructor(error){
        super(error.message);
        this.message = error.message;
        this.code = error.code;
        this.data = error.data;
    }
}
const $e917f50e09e15c26$export$edcd15c5afc9c733 = ({ label: label, externalUrl: externalUrl })=>externalUrl ? `Please <a href="${externalUrl}" target="_blank">install or switch to</a> ${label} to continue` : `Please install or enable ${label} to continue`;
const $e917f50e09e15c26$export$4e06f978fc4aa878 = (provider, checkProviderIdentity, device)=>{
    var _a;
    // No injected providers exist.
    if (!provider) return false;
    // Many injected providers add their own object into window.
    if (checkProviderIdentity({
        provider: provider,
        device: device
    })) return true;
    // For multiple injected providers, check providers array
    // example coinbase inj wallet pushes over-ridden wallets
    // into a providers array at window.ethereum
    return !!((_a = provider.providers) === null || _a === void 0 ? void 0 : _a.some((provider)=>checkProviderIdentity({
            provider: provider,
            device: device
        })));
};
function $e917f50e09e15c26$export$303e63c37a8e91ee(svgString) {
    if (!svgString) return false;
    // Regular expression to match <script> tags
    const scriptTagRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    // Regular expression to match event handler attributes (e.g., onclick, onload)
    const eventHandlerRegex = /\bon[a-z]+\s*=\s*["']?(?:javascript:)?/gi;
    // Regular expression to match href or xlink:href attributes containing "javascript:"
    const hrefJavaScriptRegex = /\b(href|xlink:href)\s*=\s*["']?javascript:/gi;
    // Check for <script> tags
    if (scriptTagRegex.test(svgString)) return true;
    // Check for event handlers
    if (eventHandlerRegex.test(svgString)) return true;
    // Check for "javascript:" in href or xlink:href
    if (hrefJavaScriptRegex.test(svgString)) return true;
    // No executable JavaScript found
    return false;
}


const $810f8d7b4e0c21ef$var$providers6963 = [];
function $810f8d7b4e0c21ef$var$checkFor6963Providers() {
    // Add event listener for 'eip6963:announceProvider' event
    window.addEventListener("eip6963:announceProvider", (event)=>{
        const eipEvent = event;
        const { detail: detail } = eipEvent;
        if (!detail) return;
        if (eipEvent) {
            const result = (0, $2bab71bfcf6c70ed$export$9f850aef0c7d58e5)(detail);
            if (result && result.error) throw result.error;
        }
        const { info: info, provider: provider } = detail;
        const { name: name, icon: icon } = info;
        if ((0, $e917f50e09e15c26$export$303e63c37a8e91ee)(icon)) {
            console.error(`The icon for injected wallet: ${name} contains executable JavaScript and has been blocked.`);
            return;
        }
        // Push the provider information to the providers6963 array
        $810f8d7b4e0c21ef$var$providers6963.push({
            label: name,
            getIcon: async ()=>icon,
            getInterface: async ()=>({
                    provider: (0, $kMjQs.createEIP1193Provider)(provider)
                }),
            platforms: [
                "all"
            ],
            eip6963Provider: (0, $kMjQs.createEIP1193Provider)(provider),
            checkProviderIdentity: ({ provider: provider })=>!!provider
        });
    });
    // Dispatch a custom event to request the provider information
    window.dispatchEvent(new CustomEvent("eip6963:requestProvider"));
}
function $810f8d7b4e0c21ef$var$injected(options) {
    if (typeof window === "undefined") return ()=>null;
    if (options) {
        const result = (0, $2bab71bfcf6c70ed$export$579090a152b2b16)(options);
        if (result && result.error) throw result.error;
    }
    !(options === null || options === void 0 ? void 0 : options.disable6963Support) && $810f8d7b4e0c21ef$var$checkFor6963Providers();
    return (helpers)=>{
        const { device: device } = helpers;
        const { custom: custom = [], filter: filter = {}, displayUnavailable: displayUnavailable, sort: sort, walletUnavailableMessage: walletUnavailableMessage } = options || {};
        // combine custom with standard wallets and dedupe
        const allWallets = (0, (/*@__PURE__*/$parcel$interopDefault($2awro)))([
            ...custom,
            ...$810f8d7b4e0c21ef$var$providers6963,
            ...(0, $53af229ac85d9a59$export$2e2bcd8739ae039)
        ], ({ label: label })=>label);
        const wallets = allWallets.reduce((acc, wallet)=>{
            const { label: label, platforms: platforms, injectedNamespace: injectedNamespace, checkProviderIdentity: checkProviderIdentity, eip6963Provider: eip6963Provider } = wallet;
            const walletFilters = filter[label];
            const filteredWallet = walletFilters === false;
            const provider = eip6963Provider || window[injectedNamespace];
            const walletAvailable = (0, $e917f50e09e15c26$export$4e06f978fc4aa878)(provider, checkProviderIdentity, device);
            let excludedDevice = false;
            // dev specified platform filters
            if (Array.isArray(walletFilters) && (walletFilters.includes(device.type) || walletFilters.includes(device.os.name))) excludedDevice = true;
            // unavailable filter
            if (walletFilters === "unavailable" && !walletAvailable) excludedDevice = true;
            // wallet specified platform filters
            const invalidPlatform = !platforms.includes("all") && !platforms.includes(device.type) && !platforms.includes(device.os.name);
            const supportedWallet = !filteredWallet && !excludedDevice && !invalidPlatform && (walletAvailable || displayUnavailable === true || Array.isArray(displayUnavailable) && displayUnavailable.length && displayUnavailable.includes(wallet.label));
            if (supportedWallet) acc.push(// modify wallet to display error if unavailable but displayUnavailable is set
            (displayUnavailable === true || Array.isArray(displayUnavailable) && displayUnavailable.length && displayUnavailable.includes(wallet.label)) && !walletAvailable ? {
                ...wallet,
                getInterface: async ()=>{
                    throw new Error(walletUnavailableMessage ? walletUnavailableMessage(wallet) : (0, $e917f50e09e15c26$export$edcd15c5afc9c733)(wallet));
                }
            } : wallet);
            return acc;
        }, []);
        if (wallets.length) {
            const moreThanOneWallet = wallets.length > 1;
            // if more than one wallet, then remove detected wallet
            const formattedWallets = wallets.filter((wallet)=>{
                const { label: label } = wallet;
                return !(label === (0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Detected && moreThanOneWallet);
            })// then map to the WalletModule interface
            .map(({ label: label, getIcon: getIcon, getInterface: getInterface })=>({
                    label: label,
                    getIcon: getIcon,
                    getInterface: getInterface
                }))// default sort by alphabetical
            .sort((a, b)=>a.label < b.label ? -1 : a.label > b.label ? 1 : 0);
            return sort ? sort(formattedWallets) : formattedWallets;
        }
        return [];
    };
}
var $810f8d7b4e0c21ef$export$2e2bcd8739ae039 = $810f8d7b4e0c21ef$var$injected;


var $0a3e105b1857cf4f$exports = {};
$0a3e105b1857cf4f$exports = JSON.parse('{"inf":"wss://sepolia.infura.io/ws/v3/b6a189799a344811bc698268f0c5a9d8","ptAddress":"0xe6BEF4f92000b0F52877b9438808A869299259f7","jfAddress":"0x5ae14318a8a64B8e4eBA1bB73F0c67D85Cfc1f5a"}');


var $c23d6e973c69e07b$exports = {};
$c23d6e973c69e07b$exports = JSON.parse('[{"inputs":[{"internalType":"address","name":"gmdtContractAddress","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint128","name":"value","type":"uint128"}],"name":"onDeposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint128","name":"value","type":"uint128"}],"name":"onInterestPaid","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint64","name":"round","type":"uint64"}],"name":"onNewRound","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"onRewardAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint128","name":"value","type":"uint128"}],"name":"onRewardPaid","type":"event"},{"stateMutability":"payable","type":"fallback"},{"inputs":[],"name":"ANNUITY","outputs":[{"internalType":"uint64","name":"","type":"uint64"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"INTEREST","outputs":[{"internalType":"uint64","name":"","type":"uint64"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"INTEREST_PERIOD","outputs":[{"internalType":"uint64","name":"","type":"uint64"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MIN_AMOUNT","outputs":[{"internalType":"uint128","name":"","type":"uint128"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"NUM_GROUPS","outputs":[{"internalType":"uint64","name":"","type":"uint64"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"WAITING_PERIOD","outputs":[{"internalType":"uint64","name":"","type":"uint64"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"addReward","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"getPoolInfo","outputs":[{"internalType":"uint64","name":"round","type":"uint64"},{"internalType":"uint64","name":"time","type":"uint64"},{"internalType":"uint128","name":"reward","type":"uint128"},{"internalType":"uint128","name":"groupsROI","type":"uint128"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getUserInfo","outputs":[{"internalType":"bool","name":"isCurrentRound","type":"bool"},{"internalType":"uint128","name":"balance","type":"uint128"},{"internalType":"uint128","name":"withdrawable","type":"uint128"},{"internalType":"uint128","name":"reward","type":"uint128"},{"internalType":"bool","name":"isLeadingGroup","type":"bool"},{"internalType":"bool","name":"isLeader","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pool","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"stateMutability":"payable","type":"receive"}]');


const $77ac944da51b7354$var$CONTRACT_ADDRESS = $0a3e105b1857cf4f$exports.jfAddress;
const $77ac944da51b7354$var$RPC_URL = $0a3e105b1857cf4f$exports.inf;
let $77ac944da51b7354$var$provider;
let $77ac944da51b7354$var$signer;
let $77ac944da51b7354$var$contract;
let $77ac944da51b7354$var$onboard;
let $77ac944da51b7354$var$connected = false;
let $77ac944da51b7354$var$timerInterval;
let $77ac944da51b7354$var$currentPrice = 0;
let $77ac944da51b7354$var$remainingSeconds;
const $77ac944da51b7354$var$injected = (0, $810f8d7b4e0c21ef$export$2e2bcd8739ae039)({
    filter: {
        [(0, $b89b21830de830ce$export$f0b712b78e0e0d3a).Detected]: true
    }
});
const $77ac944da51b7354$var$ThemingMap = {
    "--w3o-background-color": "#2064bc",
    "--w3o-foreground-color": "#fffffe",
    "--w3o-text-color": "#fffffe",
    "--w3o-border-color": "#85878b",
    "--w3o-action-color": "#fffa00",
    "--w3o-border-radius": "0px"
};
const $77ac944da51b7354$var$initializeOnboard = ()=>{
    $77ac944da51b7354$var$onboard = (0, $8O6s0.aB)({
        wallets: [
            $77ac944da51b7354$var$injected
        ],
        chains: [
            {
                id: "0xaa36a7",
                token: "ETH",
                label: "Ethereum Sepolia",
                rpcUrl: $77ac944da51b7354$var$RPC_URL
            }
        ],
        containerElements: {
            accountCenter: "#web3-onboard-modal"
        },
        connect: {
            autoConnectLastWallet: true,
            autoConnectAllPreviousWallet: true,
            disableClose: false
        },
        theme: $77ac944da51b7354$var$ThemingMap,
        accountCenter: {
            desktop: {
                enabled: true,
                minimal: false,
                position: "topRight"
            },
            mobile: {
                enabled: true,
                minimal: false,
                position: "topRight"
            }
        }
    });
};
const $77ac944da51b7354$var$getPrice = ()=>{
    return fetch("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD").then((response)=>response.json()).then((price)=>{
        console.log(price);
        return price.USD;
    });
};
const $77ac944da51b7354$var$updateContractData = ()=>{
    const fetchContractData = (contractToUse)=>{
        contractToUse.getPoolInfo().then((poolInfo)=>{
            const round = poolInfo[0].toString();
            const time = poolInfo[1].toString();
            const reward = parseFloat((0, $6c57cc56acea9c6c$exports).utils.formatEther(poolInfo[2]));
            const groupsROI = poolInfo[3].toString();
            if (time == 0) {
                document.querySelector(".round").textContent = `Rounds #${round}. Previous round has ended, add balance to be the first to get the reward.`;
                document.getElementById("time-text").style.display = "none";
                clearInterval($77ac944da51b7354$var$timerInterval);
            } else {
                document.querySelector(".round").textContent = `Rounds #${round}`;
                document.getElementById("time-text").style.display = "block";
                // Update timer
                $77ac944da51b7354$var$remainingSeconds = time;
                $77ac944da51b7354$var$updateTimerDisplay();
                clearInterval($77ac944da51b7354$var$timerInterval);
                $77ac944da51b7354$var$timerInterval = setInterval($77ac944da51b7354$var$updateTimer, 1000);
            }
            document.querySelector(".eth_reward").textContent = `${reward.toFixed(4)} ETH`;
            document.querySelector(".usd_reward").textContent = `$${(reward * $77ac944da51b7354$var$currentPrice).toFixed(2)}`;
            document.querySelector(".group_roi").textContent = `${groupsROI}% ROI`;
            if ($77ac944da51b7354$var$signer) contractToUse.getUserInfo().then((userInfo)=>{
                const isCurrentRound = userInfo[0];
                const balance = (0, $6c57cc56acea9c6c$exports).utils.formatEther(userInfo[1]);
                const withdrawable = (0, $6c57cc56acea9c6c$exports).utils.formatEther(userInfo[2]);
                const userReward = (0, $6c57cc56acea9c6c$exports).utils.formatEther(userInfo[3]);
                const isLeadingGroup = userInfo[4];
                const isLeader = userInfo[5];
                document.querySelector(".balance_eth").textContent = balance;
                document.querySelector(".group_win").textContent = isLeadingGroup ? "winning" : "loosing";
                if (isLeadingGroup) document.querySelector(".group_win").style.color = "green";
                else document.querySelector(".group_win").style.color = "red";
                document.querySelector(".reward_last").textContent = isLeader ? "winning" : "loosing";
                if (isLeader) document.querySelector(".reward_last").style.color = "green";
                else document.querySelector(".reward_last").style.color = "red";
                document.querySelector(".withdraw_eth").textContent = withdrawable;
                document.querySelector(".withdraw_block_eth").textContent = `${withdrawable} ETH`;
                document.querySelector(".withdraw_block_usd").textContent = `$${(parseFloat(withdrawable) * $77ac944da51b7354$var$currentPrice).toFixed(2)}`;
                document.querySelector(".withdraw_eth_prev").textContent = `${userReward} ETH`;
                document.querySelector(".withdraw_usd_prev").textContent = `$${(parseFloat(userReward) * $77ac944da51b7354$var$currentPrice).toFixed(2)}`;
                if (isCurrentRound) {
                    document.getElementById("currentWallet1").style.display = "block";
                    document.getElementById("currentWallet2").style.display = "none";
                    if (withdrawable == 0) {
                        document.getElementById("withdraw-button").disabled = true;
                        document.getElementById("withdraw-button").classList.add("btn-disabled");
                    } else {
                        document.getElementById("withdraw-button").disabled = false;
                        document.getElementById("withdraw-button").classList.remove("btn-disabled");
                    }
                    document.getElementById("withdraw-prev-button").disabled = true;
                    document.getElementById("withdraw-prev-button").classList.add("btn-disabled");
                } else {
                    document.getElementById("currentWallet1").style.display = "none";
                    document.getElementById("currentWallet2").style.display = "block";
                    document.getElementById("withdraw-button").disabled = true;
                    document.getElementById("withdraw-button").classList.add("btn-disabled");
                    document.getElementById("withdraw-prev-button").disabled = true;
                    document.getElementById("withdraw-prev-button").classList.add("btn-disabled");
                    document.getElementById("withdraw-prev-button").title = "To withdraw reward add any budget to the pool";
                    if (userReward > 0) document.querySelector(".withdraw_eth_prev").textContent = `To withdraw reward add any budget to the pool`;
                }
            }).catch((error)=>{
                console.error("Error updating user info:", error);
                $77ac944da51b7354$var$resetUIData();
            });
            else {
                // Reset values if user is not connected or on a different network
                document.querySelector(".balance_eth").textContent = "-";
                document.querySelector(".group_win").textContent = "-";
                document.querySelector(".withdraw_eth").textContent = "-";
                document.querySelector(".reward_last").textContent = "-";
                document.querySelector(".withdraw_block_eth").textContent = `0.00 ETH`;
                document.querySelector(".withdraw_block_usd").textContent = `0.00 USD`;
                document.querySelector(".withdraw_eth_prev").textContent = `0.00 ETH`;
                document.querySelector(".withdraw_usd_prev").textContent = `0.00 USD`;
            }
        }).catch((error)=>{
            console.error("Error updating contract data:", error);
            $77ac944da51b7354$var$resetUIData();
        });
    };
    if ($77ac944da51b7354$var$connected) $77ac944da51b7354$var$provider.getNetwork().then((network)=>{
        if (network.chainId !== 11155111) {
            document.getElementById("purchase-button").disabled = true;
            document.getElementById("purchase-button").classList.add("btn-disabled");
        } else {
            document.getElementById("purchase-button").disabled = false;
            document.getElementById("purchase-button").classList.remove("btn-disabled");
        }
        fetchContractData($77ac944da51b7354$var$contract);
    });
    else {
        // Initialize a contract with the Infura provider if no wallet is connected
        if (!$77ac944da51b7354$var$provider) // Use a non-websocket provider when there's no web3 wallet
        $77ac944da51b7354$var$provider = new (0, $6c57cc56acea9c6c$exports).providers.JsonRpcProvider($77ac944da51b7354$var$RPC_URL.replace("wss://", "https://"));
        $77ac944da51b7354$var$provider.getNetwork().then(()=>{
            $77ac944da51b7354$var$contract = new (0, $6c57cc56acea9c6c$exports).Contract($77ac944da51b7354$var$CONTRACT_ADDRESS, $c23d6e973c69e07b$exports, $77ac944da51b7354$var$provider);
            fetchContractData($77ac944da51b7354$var$contract);
        }).catch((error)=>{
            console.error("Error getting network:", error);
            $77ac944da51b7354$var$resetUIData();
        });
    }
};
function $77ac944da51b7354$var$updateTimerDisplay() {
    if ($77ac944da51b7354$var$remainingSeconds < 0) $77ac944da51b7354$var$remainingSeconds = 0;
    let hours = Math.floor($77ac944da51b7354$var$remainingSeconds / 3600);
    let minutes = Math.floor($77ac944da51b7354$var$remainingSeconds % 3600 / 60);
    let seconds = $77ac944da51b7354$var$remainingSeconds % 60;
    document.querySelector(".time__item.hours:nth-child(1)").textContent = Math.floor(hours / 10);
    document.querySelector(".time__item.hours:nth-child(2)").textContent = hours % 10;
    document.querySelector(".time__item.mins:nth-child(1)").textContent = Math.floor(minutes / 10);
    document.querySelector(".time__item.mins:nth-child(2)").textContent = minutes % 10;
    document.querySelector(".time__item.seconds:nth-child(1)").textContent = Math.floor(seconds / 10);
    document.querySelector(".time__item.seconds:nth-child(2)").textContent = seconds % 10;
}
function $77ac944da51b7354$var$updateTimer() {
    if ($77ac944da51b7354$var$remainingSeconds > 0) {
        $77ac944da51b7354$var$remainingSeconds--;
        $77ac944da51b7354$var$updateTimerDisplay();
    } else clearInterval($77ac944da51b7354$var$timerInterval);
}
function $77ac944da51b7354$var$resetUIData() {
    // Reset contract data
    document.querySelector(".round").textContent = "Rounds #-";
    clearInterval($77ac944da51b7354$var$timerInterval);
    document.querySelector(".time__item.hours:nth-child(1)").textContent = "0";
    document.querySelector(".time__item.hours:nth-child(2)").textContent = "0";
    document.querySelector(".time__item.mins:nth-child(1)").textContent = "0";
    document.querySelector(".time__item.mins:nth-child(2)").textContent = "0";
    document.querySelector(".time__item.seconds:nth-child(1)").textContent = "0";
    document.querySelector(".time__item.seconds:nth-child(2)").textContent = "0";
    document.querySelector(".eth_reward").textContent = `-`;
    document.querySelector(".usd_reward").textContent = `-`;
    document.querySelector(".group_roi").textContent = `-`;
    // Reset user-specific data
    document.querySelector(".balance_eth").textContent = "-";
    document.querySelector(".group_win").textContent = "-";
    document.querySelector(".withdraw_eth").textContent = "-";
    document.querySelector(".reward_last").textContent = "-";
    document.querySelector(".withdraw_block_eth").textContent = `0.00 ETH`;
    document.querySelector(".withdraw_block_usd").textContent = `0.00 USD`;
    document.querySelector(".withdraw_eth_prev").textContent = `0.00 ETH`;
    document.querySelector(".withdraw_usd_prev").textContent = `0.00 USD`;
    // Reset input fields and calculated values
    document.querySelector(".bottom-stocks__input").value = "0.01";
    document.querySelector(".stocks-calc__header.eth").textContent = `-`;
    document.querySelector(".stocks-calc__bottom.usd").textContent = `-`;
    // Hide the "In your wallet" section
    document.getElementById("currentWallet1").style.display = "none";
    document.getElementById("currentWallet2").style.display = "none";
}
const $77ac944da51b7354$var$subscribeToEvents = ()=>{
    $77ac944da51b7354$var$contract.on("onNewRound", (round)=>{
        console.log("New round started:", round.toString());
        $77ac944da51b7354$var$updateContractData();
    });
    $77ac944da51b7354$var$contract.on("onDeposit", (value)=>{
        console.log("Deposit made:", (0, $6c57cc56acea9c6c$exports).utils.formatEther(value));
        $77ac944da51b7354$var$updateContractData();
    });
    $77ac944da51b7354$var$contract.on("onInterestPaid", (value)=>{
        console.log("Interest paid:", (0, $6c57cc56acea9c6c$exports).utils.formatEther(value));
        $77ac944da51b7354$var$updateContractData();
    });
    $77ac944da51b7354$var$contract.on("onRewardPaid", (value)=>{
        console.log("Reward paid:", (0, $6c57cc56acea9c6c$exports).utils.formatEther(value));
        $77ac944da51b7354$var$updateContractData();
    });
    $77ac944da51b7354$var$contract.on("onRewardAdded", (value)=>{
        console.log("Reward added:", (0, $6c57cc56acea9c6c$exports).utils.formatEther(value));
        $77ac944da51b7354$var$updateContractData();
    });
};
const $77ac944da51b7354$var$handleConnectWallet = ()=>{
    $77ac944da51b7354$var$onboard.connectWallet().then((wallets)=>{
        if (wallets.length > 0) {
            $77ac944da51b7354$var$connected = true;
            $77ac944da51b7354$var$provider = new (0, $6c57cc56acea9c6c$exports).providers.Web3Provider(wallets[0].provider, "any");
            $77ac944da51b7354$var$signer = $77ac944da51b7354$var$provider.getSigner();
            $77ac944da51b7354$var$contract = new (0, $6c57cc56acea9c6c$exports).Contract($77ac944da51b7354$var$CONTRACT_ADDRESS, $c23d6e973c69e07b$exports, $77ac944da51b7354$var$signer);
            $77ac944da51b7354$var$provider.getNetwork().then((network)=>{
                if (network.chainId !== 11155111) {
                    alert("Please switch to the Ethereum Sepolia network.");
                    document.getElementById("btn-connect").disabled = false;
                    document.getElementById("purchase-button").disabled = true;
                    document.getElementById("purchase-button").classList.add("btn-disabled");
                    document.getElementById("withdraw-button").disabled = true;
                    document.getElementById("withdraw-prev-button").disabled = true;
                    return;
                }
                document.getElementById("purchase-button").disabled = false;
                document.getElementById("purchase-button").classList.remove("btn-disabled");
                document.getElementById("withdraw-button").disabled = false;
                document.getElementById("withdraw-prev-button").disabled = false;
                $77ac944da51b7354$var$subscribeToEvents();
                $77ac944da51b7354$var$updateContractData();
            });
        }
    }).catch((error)=>{
        console.error("Error connecting wallet:", error);
    });
};
const $77ac944da51b7354$var$handlePurchase = ()=>{
    if (!$77ac944da51b7354$var$connected) {
        alert("Please connect your wallet first.");
        return;
    }
    const amountInEth = document.querySelector(".input_for_radio").value;
    const amountInWei = (0, $6c57cc56acea9c6c$exports).utils.parseUnits(amountInEth, "ether");
    $77ac944da51b7354$var$contract.pool({
        value: amountInWei
    }).then((tx)=>{
        return tx.wait();
    }).then(()=>{
        console.log("Purchase successful");
        $77ac944da51b7354$var$updateContractData();
    }).catch((error)=>{
        console.error("Error during purchase:", error);
    });
};
const $77ac944da51b7354$var$handleWithdraw = ()=>{
    if (!$77ac944da51b7354$var$connected) {
        alert("Please connect your wallet first.");
        return;
    }
    $77ac944da51b7354$var$contract.withdraw().then((tx)=>{
        return tx.wait();
    }).then(()=>{
        console.log("Withdrawal successful:");
        $77ac944da51b7354$var$updateContractData();
    }).catch((error)=>{
        console.error("Error during withdrawal:", error);
    });
};
document.getElementById("btn-connect").addEventListener("click", $77ac944da51b7354$var$handleConnectWallet);
document.getElementById("purchase-button").addEventListener("click", $77ac944da51b7354$var$handlePurchase);
document.getElementById("withdraw-button").addEventListener("click", $77ac944da51b7354$var$handleWithdraw);
document.getElementById("withdraw-prev-button").addEventListener("click", $77ac944da51b7354$var$handleWithdraw);
const $77ac944da51b7354$var$initialize = ()=>{
    $77ac944da51b7354$var$initializeOnboard();
    $77ac944da51b7354$var$getPrice().then((price)=>{
        $77ac944da51b7354$var$currentPrice = price;
        // Initialize a contract with the Infura provider if no wallet is connected
        if (!$77ac944da51b7354$var$provider) // Use a non-websocket provider when there's no web3 wallet
        $77ac944da51b7354$var$provider = new (0, $6c57cc56acea9c6c$exports).providers.JsonRpcProvider($77ac944da51b7354$var$RPC_URL.replace("wss://", "https://"));
        $77ac944da51b7354$var$provider.getNetwork().then(()=>{
            $77ac944da51b7354$var$contract = new (0, $6c57cc56acea9c6c$exports).Contract($77ac944da51b7354$var$CONTRACT_ADDRESS, $c23d6e973c69e07b$exports, $77ac944da51b7354$var$provider);
            if (typeof window.ethereum !== "undefined") window.ethereum.request({
                method: "eth_accounts"
            }).then((accounts)=>{
                $77ac944da51b7354$var$connected = accounts.length > 0;
                if ($77ac944da51b7354$var$connected) {
                    $77ac944da51b7354$var$signer = $77ac944da51b7354$var$provider.getSigner();
                    $77ac944da51b7354$var$contract = new (0, $6c57cc56acea9c6c$exports).Contract($77ac944da51b7354$var$CONTRACT_ADDRESS, $c23d6e973c69e07b$exports, $77ac944da51b7354$var$signer);
                    $77ac944da51b7354$var$provider.getNetwork().then((network)=>{
                        if (network.chainId !== 11155111) {
                            document.getElementById("purchase-button").disabled = true;
                            document.getElementById("purchase-button").classList.add("btn-disabled");
                        }
                        $77ac944da51b7354$var$subscribeToEvents();
                    });
                }
                window.ethereum.on("accountsChanged", (accounts)=>{
                    if (accounts.length > 0) {
                        $77ac944da51b7354$var$connected = true;
                        $77ac944da51b7354$var$signer = $77ac944da51b7354$var$provider.getSigner();
                        $77ac944da51b7354$var$contract = new (0, $6c57cc56acea9c6c$exports).Contract($77ac944da51b7354$var$CONTRACT_ADDRESS, $c23d6e973c69e07b$exports, $77ac944da51b7354$var$signer);
                        $77ac944da51b7354$var$provider.getNetwork().then((network)=>{
                            if (network.chainId !== 11155111) {
                                document.getElementById("purchase-button").disabled = true;
                                document.getElementById("purchase-button").classList.add("btn-disabled");
                            } else {
                                document.getElementById("purchase-button").disabled = false;
                                document.getElementById("purchase-button").classList.remove("btn-disabled");
                            }
                            $77ac944da51b7354$var$subscribeToEvents();
                        });
                        $77ac944da51b7354$var$updateContractData();
                    } else {
                        $77ac944da51b7354$var$connected = false;
                        $77ac944da51b7354$var$updateContractData();
                    }
                });
                window.ethereum.on("chainChanged", (chainId)=>{
                    $77ac944da51b7354$var$provider.getNetwork().then((network)=>{
                        if (network.chainId !== 11155111) {
                            document.getElementById("purchase-button").disabled = true;
                            document.getElementById("purchase-button").classList.add("btn-disabled");
                        } else {
                            document.getElementById("purchase-button").disabled = false;
                            document.getElementById("purchase-button").classList.remove("btn-disabled");
                        }
                        $77ac944da51b7354$var$updateContractData();
                    });
                });
            }).catch((error)=>{
                console.error("Error during initial wallet connection:", error);
            });
            $77ac944da51b7354$var$updateContractData();
        }).catch((error)=>{
            console.error("Error getting network:", error);
            $77ac944da51b7354$var$resetUIData();
        });
    });
};
$77ac944da51b7354$var$initialize();
const $77ac944da51b7354$var$currentWalletSection = document.getElementById("currentWallet1");
const $77ac944da51b7354$var$previousWalletSection = document.getElementById("currentWallet2");
$77ac944da51b7354$var$currentWalletSection.style.display = "none";
$77ac944da51b7354$var$previousWalletSection.style.display = "none";
// Handle clicks on the radio buttons for amount selection
document.querySelectorAll(".stocks__header input[type='radio']").forEach((radio)=>{
    radio.addEventListener("change", ()=>{
        const selectedAmount = radio.value;
        document.querySelector(".bottom-stocks__input").value = selectedAmount;
        $77ac944da51b7354$var$updateEthAndUsdDisplay(selectedAmount);
    });
});
// Handle direct input in the "cents" input field
document.querySelector(".bottom-stocks__input").addEventListener("input", ()=>{
    const amountInEth = document.querySelector(".bottom-stocks__input").value;
    // Update the radio button selection based on the input value
    const matchingRadio = document.querySelector(`.stocks__header input[type='radio'][value='${amountInEth}']`);
    if (matchingRadio) matchingRadio.checked = true;
    else // If the input value does not match any radio button value, uncheck all radio buttons
    document.querySelectorAll(".stocks__header input[type='radio']").forEach((radio)=>{
        radio.checked = false;
    });
    $77ac944da51b7354$var$updateEthAndUsdDisplay(amountInEth);
});
// Function to update ETH and USD display based on selected amount
function $77ac944da51b7354$var$updateEthAndUsdDisplay(amountInEth) {
    const ethValue = parseFloat(amountInEth).toFixed(4);
    const usdValue = ethValue * $77ac944da51b7354$var$currentPrice;
    document.querySelector(".stocks-calc__header.eth").textContent = `${ethValue} ETH`;
    document.querySelector(".stocks-calc__bottom.usd").textContent = `$${usdValue.toFixed(2)}`;
}
// Set the initial value of the input field to 0.01 when the page loads
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelector(".bottom-stocks__input").value = "0.01";
    $77ac944da51b7354$var$updateEthAndUsdDisplay("0.01"); // Also update the ETH/USD display initially
});
// Periodically update contract data (e.g., every 30 seconds)
setInterval($77ac944da51b7354$var$updateContractData, 30000);


//# sourceMappingURL=game.4cb45e20.js.map
